import { SelfOnboardingStepKey } from 'graphql/types/enums';
import { DocumentKey } from 'graphql/types/enums';
import { OnboardingStepSkipReason } from 'graphql/types/enums';
import { OnboardingStepName } from 'graphql/types/enums';
import { OnboardingStepKey } from 'graphql/types/enums';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Represents a date object with or without time */
  Date: { input: Date | string; output: string };
  /** A date string in YYYY-MM-DD format */
  DateOnly: { input: string; output: string };
  /** An ISO-8601 date and time used by GraphQL inputs */
  DateTime: { input: Date | string; output: string };
  /**
   * A Duration object represents a period of time, like '2 months' or '1 day, 1 hour'.
   * Represented in ISO 8601 duration format
   * https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm
   */
  Duration: { input: string; output: string };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Upload: { input: Blob | File; output: Blob | File };
};

export type AclGrant = {
  __typename?: 'ACLGrant';
  action: Action;
  attributes: Array<Scalars['String']['output']>;
  possession: Possession;
};

export type AclObject = {
  __typename?: 'ACLObject';
  grants: Array<AclGrant>;
  objectName: ObjectName;
};

export type AclRole = {
  __typename?: 'ACLRole';
  objects: Array<AclObject>;
  role: UserRole;
};

/** An access controller device's assignment to a site. */
export type AccessController = {
  __typename?: 'AccessController';
  /** Unset until the access controller device is created or adopted. */
  accessControllerDevice?: Maybe<AccessControllerDevice>;
  id: Scalars['ID']['output'];
  provisioningError?: Maybe<Scalars['String']['output']>;
  provisioningStatus: AccessControllerProvisioningStatus;
};

/** One physical access controller, with the ports the provider reports. */
export type AccessControllerDevice = {
  __typename?: 'AccessControllerDevice';
  device: Device;
  id: Scalars['ID']['output'];
  /** In provider order. */
  ports: Array<AccessControllerPort>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type AccessControllerPort = {
  __typename?: 'AccessControllerPort';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  portType: AccessControllerPortType;
  position: Scalars['Int']['output'];
  /** The reader device on the port, if Odin knows of one. */
  readerDevice?: Maybe<ReaderDevice>;
};

export enum AccessControllerPortType {
  Input = 'INPUT',
  Other = 'OTHER',
  Reader = 'READER',
  Relay = 'RELAY',
  Wiegand = 'WIEGAND',
}

export enum AccessControllerProvisioningStatus {
  AwaitingProvisioning = 'AWAITING_PROVISIONING',
  Creating = 'CREATING',
  Failed = 'FAILED',
  Registered = 'REGISTERED',
}

export type AccessEventCrossing = {
  __typename?: 'AccessEventCrossing';
  entryId?: Maybe<Scalars['ID']['output']>;
  entrySideId?: Maybe<Scalars['ID']['output']>;
  from?: Maybe<AccessEventEndpoint>;
  kind: AccessEventCrossingKind;
  reason?: Maybe<Scalars['String']['output']>;
  revisionId?: Maybe<Scalars['ID']['output']>;
  to?: Maybe<AccessEventEndpoint>;
};

export enum AccessEventCrossingKind {
  Internal = 'INTERNAL',
  PerimeterIn = 'PERIMETER_IN',
  PerimeterOut = 'PERIMETER_OUT',
  Unresolved = 'UNRESOLVED',
}

export type AccessEventEndpoint = {
  __typename?: 'AccessEventEndpoint';
  kind: AccessEventEndpointKind;
  name?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export enum AccessEventEndpointKind {
  Outside = 'OUTSIDE',
  Zone = 'ZONE',
}

export type AccessGroup = {
  __typename?: 'AccessGroup';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  archivedBy?: Maybe<User>;
  avigilon: AccessGroupAvigilonSync;
  /** Newest first, a page at a time (first defaults to 50, at most 200). */
  history: Array<AccessGroupHistoryEntry>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  memberCount: Scalars['Int']['output'];
  /** Active members in grant order, a page at a time (first defaults to 50, at most 200). after takes the last loaded member's cursor. */
  members: Array<AccessGroupMembership>;
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
  zones: Array<AccessGroupZoneGrant>;
};

export type AccessGroupHistoryArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessGroupMembersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type AccessGroupAvigilonSync = {
  __typename?: 'AccessGroupAvigilonSync';
  error?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<ConnectionOrigin>;
  state: AccessGroupSyncState;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum AccessGroupGrantSource {
  Cutover = 'CUTOVER',
  Enrollment = 'ENROLLMENT',
  Manual = 'MANUAL',
  Restore = 'RESTORE',
}

export type AccessGroupHistoryEntry = {
  __typename?: 'AccessGroupHistoryEntry';
  actor: User;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['DateTime']['output'];
  payload: Scalars['JSONObject']['output'];
  type: AccessGroupHistoryType;
};

export enum AccessGroupHistoryType {
  Adopted = 'ADOPTED',
  Archived = 'ARCHIVED',
  Created = 'CREATED',
  DefaultReplaced = 'DEFAULT_REPLACED',
  Renamed = 'RENAMED',
  SetAsDefault = 'SET_AS_DEFAULT',
  ZoneAdded = 'ZONE_ADDED',
  ZoneRemoved = 'ZONE_REMOVED',
}

export type AccessGroupInput = {
  accessGroupId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type AccessGroupMembership = {
  __typename?: 'AccessGroupMembership';
  /** Opaque grant-order position for AccessGroup.members(after:). */
  cursor: Scalars['ID']['output'];
  grantSource: AccessGroupGrantSource;
  grantedAt: Scalars['DateTime']['output'];
  grantedBy: User;
  group: AccessGroup;
  id: Scalars['ID']['output'];
  revokeSource?: Maybe<AccessGroupRevokeSource>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<User>;
  /** Null when the viewer may not read this worker. */
  worker?: Maybe<Worker>;
};

export type AccessGroupMembershipInput = {
  accessGroupId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

export type AccessGroupMembershipSite = {
  __typename?: 'AccessGroupMembershipSite';
  name: Scalars['String']['output'];
  siteId: Scalars['ID']['output'];
};

export enum AccessGroupRevokeSource {
  ContractorChange = 'CONTRACTOR_CHANGE',
  GroupArchived = 'GROUP_ARCHIVED',
  Manual = 'MANUAL',
  Offboard = 'OFFBOARD',
  PermanentBan = 'PERMANENT_BAN',
  SiteChange = 'SITE_CHANGE',
  TemporarySuspension = 'TEMPORARY_SUSPENSION',
}

export enum AccessGroupSyncState {
  Failed = 'FAILED',
  Off = 'OFF',
  Pending = 'PENDING',
  Synced = 'SYNCED',
}

export type AccessGroupZoneGrant = {
  __typename?: 'AccessGroupZoneGrant';
  grantedAt: Scalars['DateTime']['output'];
  grantedBy: User;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: GrantedZoneState;
  zone: Zone;
};

export type AccessGroupZoneInput = {
  accessGroupId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

export type AccessResult = {
  __typename?: 'AccessResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum AcknowledgmentStatus {
  Confirmed = 'confirmed',
  InProgress = 'inProgress',
  NotStarted = 'notStarted',
}

export enum Action {
  Create = 'create',
  Delete = 'delete',
  Read = 'read',
  Update = 'update',
}

export type AddSiteControllerInput = {
  /** The site's Avigilon Access connector; the site's own when unset. */
  connectorId?: InputMaybe<Scalars['ID']['input']>;
  /** The serial number of a controller that already exists in Avigilon. */
  serialNumber: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type AddSiteControllerPayload = {
  __typename?: 'AddSiteControllerPayload';
  /** The controller's assignment to the site, when applied. */
  assignmentId?: Maybe<Scalars['ID']['output']>;
  /** The controller unit, when applied. */
  deviceId?: Maybe<Scalars['ID']['output']>;
  failure?: Maybe<SiteDeviceFailure>;
  kind: SiteDeviceResultKind;
  /** The site's readers that came with it, when applied. */
  readerIds?: Maybe<Array<Scalars['ID']['output']>>;
  refusal?: Maybe<SiteDeviceRefusal>;
  /** An opaque reference to the connector run that recorded the technical outcome, for Support. */
  runId?: Maybe<Scalars['ID']['output']>;
};

export type AdditionalFieldInput = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: DocumentAdditionalFieldType;
};

export type AdditionalFieldValue = {
  __typename?: 'AdditionalFieldValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AdditionalFieldValueInput = {
  key: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalWorkerProfileData = {
  __typename?: 'AdditionalWorkerProfileData';
  cloudStorageBucket?: Maybe<Scalars['String']['output']>;
  cloudStorageUri?: Maybe<Scalars['String']['output']>;
  croppedCloudStorageBucket?: Maybe<Scalars['String']['output']>;
  croppedCloudStorageUri?: Maybe<Scalars['String']['output']>;
  croppedDownloadKey?: Maybe<Scalars['String']['output']>;
  downloadKey?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  orientationDate?: Maybe<Scalars['Date']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  quickCode?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  stickerNumber?: Maybe<Scalars['String']['output']>;
  userAccountId?: Maybe<Scalars['String']['output']>;
  workerId?: Maybe<Scalars['String']['output']>;
};

export type AdoptInventoryItemInput = {
  /** A provider reader or access control unit from the site's connector inventory. */
  itemId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type AdoptInventoryItemPayload = {
  __typename?: 'AdoptInventoryItemPayload';
  /**
   * For a reader, whether the provider reads it as an exit: the direction to
   * suggest with the entry sides. Unset for an access controller.
   */
  isExit?: Maybe<Scalars['Boolean']['output']>;
  /** The adopted item, now connected to the device. */
  item: ConnectorInventoryItem;
  /**
   * For a reader, the entry sides in the site's effective layout connected to
   * the entries the provider reader serves: a suggestion for where to assign
   * it, never an assignment. Empty for an access controller.
   */
  suggestedEntrySideIds: Array<Scalars['ID']['output']>;
};

export enum AnnouncementStatus {
  Archived = 'Archived',
  Draft = 'Draft',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Sent = 'Sent',
}

export enum AnnouncementType {
  Email = 'Email',
  Sms = 'Sms',
}

export type AnonymousJobsiteContractor = {
  __typename?: 'AnonymousJobsiteContractor';
  contractorId: Scalars['ID']['output'];
};

/**
 * Minimal, pre-auth view of a jobsite invitation. Deliberately flat so it cannot
 * be traversed into the full jobsite onboarding configuration; the authenticated
 * flow uses 'getJobsiteInvitation' for that. Carries only what the pre-account
 * flow needs to bootstrap: the jobsite id (for jobsite-scoped feature flags and
 * the pre-auth session query) and the invited contractor id.
 */
export type AnonymousJobsiteInvitation = {
  __typename?: 'AnonymousJobsiteInvitation';
  /** The contractor the invitation is tied to. */
  contractor: AnonymousJobsiteContractor;
  jobsiteId: Scalars['ID']['output'];
};

export enum AppErrorCode {
  ArchivedEntity = 'ARCHIVED_ENTITY',
  BadInput = 'BAD_INPUT',
  FacialRecognitionImageRejected = 'FACIAL_RECOGNITION_IMAGE_REJECTED',
  FacialRecognitionProfileAlreadyAssociated = 'FACIAL_RECOGNITION_PROFILE_ALREADY_ASSOCIATED',
  FacialRecognitionProfileConflict = 'FACIAL_RECOGNITION_PROFILE_CONFLICT',
  FacialRecognitionVendorSyncError = 'FACIAL_RECOGNITION_VENDOR_SYNC_ERROR',
  GatewayAddAfterSiteLayoutPublished = 'GATEWAY_ADD_AFTER_SITE_LAYOUT_PUBLISHED',
  GatewayNotOnSite = 'GATEWAY_NOT_ON_SITE',
  HealthSurveyAlreadySubmitted = 'HEALTH_SURVEY_ALREADY_SUBMITTED',
  IncompleteRequiredDocuments = 'INCOMPLETE_REQUIRED_DOCUMENTS',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  JobsiteAlreadyExists = 'JOBSITE_ALREADY_EXISTS',
  JobsiteAreaHasSwipes = 'JOBSITE_AREA_HAS_SWIPES',
  JobsiteContractorAlreadyExists = 'JOBSITE_CONTRACTOR_ALREADY_EXISTS',
  JobsiteMemberAlreadyExists = 'JOBSITE_MEMBER_ALREADY_EXISTS',
  JobsiteWorkerAlreadyHasSwipes = 'JOBSITE_WORKER_ALREADY_HAS_SWIPES',
  MultipleResourcesFound = 'MULTIPLE_RESOURCES_FOUND',
  NoPhoneMatch = 'NO_PHONE_MATCH',
  OrganizationAlreadyExists = 'ORGANIZATION_ALREADY_EXISTS',
  RateLimitExceeded = 'RATE_LIMIT_EXCEEDED',
  ResourceAlreadyExists = 'RESOURCE_ALREADY_EXISTS',
  ResourceExpiredError = 'RESOURCE_EXPIRED_ERROR',
  ResourceNotFound = 'RESOURCE_NOT_FOUND',
  SsnAlreadyExists = 'SSN_ALREADY_EXISTS',
  StartPasswordlessLogin = 'START_PASSWORDLESS_LOGIN',
  StartPhoneNumberVerification = 'START_PHONE_NUMBER_VERIFICATION',
  UnassignedTempBadge = 'UNASSIGNED_TEMP_BADGE',
  UnlockWorkerProfileDataNoMatch = 'UNLOCK_WORKER_PROFILE_DATA_NO_MATCH',
  UserAlreadyAuthenticatedWithEmail = 'USER_ALREADY_AUTHENTICATED_WITH_EMAIL',
  UserAlreadyAuthenticatedWithPhone = 'USER_ALREADY_AUTHENTICATED_WITH_PHONE',
  WorkerAlreadyExists = 'WORKER_ALREADY_EXISTS',
  WorkerCardAlreadyExists = 'WORKER_CARD_ALREADY_EXISTS',
  WorkerCardFormatCardNumberInvalid = 'WORKER_CARD_FORMAT_CARD_NUMBER_INVALID',
  WorkerCardFormatDefaultNotFound = 'WORKER_CARD_FORMAT_DEFAULT_NOT_FOUND',
  WorkerCardFormatInvalidForJobsite = 'WORKER_CARD_FORMAT_INVALID_FOR_JOBSITE',
  WorkerNotAllowedOnSite = 'WORKER_NOT_ALLOWED_ON_SITE',
  WorkerNotAssignedToSite = 'WORKER_NOT_ASSIGNED_TO_SITE',
  WorkerNotOnSite = 'WORKER_NOT_ON_SITE',
}

export type ArchiveJobsiteWorkerAccessEventInput = {
  accessEventId: Scalars['ID']['input'];
  jobsiteWorkerCheckInId?: InputMaybe<Scalars['ID']['input']>;
};

export type ArchiveJobsiteWorkerAccessEventResponse = {
  __typename?: 'ArchiveJobsiteWorkerAccessEventResponse';
  accessEventId: Scalars['ID']['output'];
  success: Success;
};

export type AssignContractorWorkerToJobsiteInput = {
  /** ID of the contractor to assign the worker to */
  contractorId: Scalars['ID']['input'];
  /**
   * If this flag is 'true' and the worker is already assigned to the specified jobsite and contractor,
   * then the assignment will not be performed and the returned payload will contain isAlreadyAssigned flag as 'true'
   * and the existing jobsite.
   */
  ignoreIfAlreadyAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates that the worker is self-onboarding. When true, if the worker's selfOnboardingCurrentStep is 'Closed',
   * the server will reset it to 'Profile' to reopen the self-onboarding flow.
   */
  isSelfOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the jobsite to assign the worker to */
  jobsiteId: Scalars['ID']['input'];
  /** Input data for the worker */
  jobsiteWorkerInput: JobsiteWorkerInput;
  /** ID of the worker that should be assigned to the jobsite and contractor */
  workerId: Scalars['ID']['input'];
};

export type AssignContractorWorkerToJobsiteResponse = {
  __typename?: 'AssignContractorWorkerToJobsiteResponse';
  isAlreadyAssigned?: Maybe<Scalars['Boolean']['output']>;
  jobsiteWorker: JobsiteWorker;
};

export type AssignDeviceToSiteInput = {
  /** The reader device's or access controller device's id. */
  deviceId: Scalars['ID']['input'];
  /** An active layout site. */
  siteId: Scalars['ID']['input'];
  type: DeviceType;
};

export type AssignDeviceToSitePayload = {
  __typename?: 'AssignDeviceToSitePayload';
  /** The device, now on the site. */
  device: DiscoveredDevice;
  /** For an access controller device, the reader devices on its ports registered on the site with it. */
  readerDevicesAssigned: Array<DiscoveredDevice>;
};

export type AssignTempBadgeInput = {
  cardIssueReason?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * When this is 'true', temp badges assigned,
   * corresponding to 'workerCardIdsToDeactivate' will be deactivated.
   *
   * When 'false' or not provided, if the tempBadge is already assigned
   * to a worker, the mutation will fail, providing existing worker cards info.
   */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  workerCardIdsToDeactivate?: InputMaybe<Array<Scalars['ID']['input']>>;
  workerId: Scalars['ID']['input'];
};

/** Object that holds the current session and user based on the provided session token and/or credentials */
export type Auth = {
  __typename?: 'Auth';
  aclRoles: Array<AclRole>;
  /**
   * Indicates whether the user is an admin.
   * This is derived from the user's roles - if the user holds an 'admin' or 'super' role
   * (the same set used by the server's ACL evaluation), they are considered an admin.
   */
  isAdmin: Scalars['Boolean']['output'];
  /**
   * The calling device's last committed station, resolved on any operation that
   * selects it from a device caller (PIN sign-in and 'getCurrentSession'), and
   * only when it still fully resolves for the signing-in operator: the operator
   * holds the check-in-create capability for the jobsite, the jobsite is configured
   * for app check-in, and the committed gateway is null or still present. Null in
   * every other case (no device header, no record, or the station no longer
   * resolves). Named for its source ('last station'); the conditional return is
   * what makes it a 'remembered' station. See ADR 0010.
   */
  lastStation?: Maybe<Station>;
  /**
   * The user's effective permissions, grouped by scope and merged across all of the user's roles.
   * Mirrors the server's ACL evaluation: 'any' grants land in the global scope (null scopeName/scopeId)
   * and apply everywhere, while 'own' grants land in the scope (Jobsite/Contractor/Worker) they are
   * bound to. Intended as the single source of truth for client-side authorization decisions.
   */
  permissions: Array<ScopedPermissions>;
  /**
   * The full set of current, effective, non-retired policy documents, each
   * annotated with the current user's consent history for its `key`. The
   * re-capture gate renders every entry (accepted ones for context) and clears
   * once none remain outstanding (every `lastAcceptedVersion` equals its
   * `document.version`).
   */
  policyConsentStatuses: Array<UserPolicyConsentStatus>;
  /** The current session based on provided session token and/or credentials */
  session: UserSession;
  /** The current user based on provided session token and/or credentials */
  user: User;
};

/**
 * Indicates whether the authentication is provded via a cookie or bearer token. Only cookie is supported at this time,
 * but bearer may be added when we support native apps.
 */
export enum AuthType {
  Bearer = 'BEARER',
  Cookie = 'COOKIE',
}

export type AuthenticateLimitedTokenDetailsInput = {
  birthDate: Scalars['String']['input'];
  workerId: Scalars['ID']['input'];
};

export type AuthenticateLimitedTokenDetailsResponse = {
  __typename?: 'AuthenticateLimitedTokenDetailsResponse';
  token?: Maybe<Scalars['String']['output']>;
};

export type AvailableSiteController = {
  __typename?: 'AvailableSiteController';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
};

export type AvailableSiteControllerConnection = {
  __typename?: 'AvailableSiteControllerConnection';
  nodes: Array<AvailableSiteController>;
  pageInfo: AvailableSiteControllerPageInfo;
};

export type AvailableSiteControllerPageInfo = {
  __typename?: 'AvailableSiteControllerPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type AvigilonAccessConnector = Connector & {
  __typename?: 'AvigilonAccessConnector';
  avigilonSite?: Maybe<AvigilonAccessSite>;
  connectedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: ConnectorActor;
  definition: AvigilonAccessConnectorDefinition;
  id: Scalars['ID']['output'];
  runs: ConnectorRunPage;
  siteId: Scalars['ID']['output'];
  status: ConnectorStatus;
  type: ConnectorType;
  updatedAt: Scalars['Date']['output'];
  updatedBy: ConnectorActor;
};

export type AvigilonAccessConnectorRunsArgs = {
  filter?: InputMaybe<ConnectorRunFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type AvigilonAccessConnectorDefinition = ConnectorDefinition & {
  __typename?: 'AvigilonAccessConnectorDefinition';
  available: Scalars['Boolean']['output'];
  connectedDescription: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  settingsLabel: Scalars['String']['output'];
  setupDescription: Scalars['String']['output'];
  type: ConnectorType;
};

export type AvigilonAccessSite = {
  __typename?: 'AvigilonAccessSite';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AvigilonVideoConnector = Connector & {
  __typename?: 'AvigilonVideoConnector';
  connectedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: ConnectorActor;
  definition: AvigilonVideoConnectorDefinition;
  id: Scalars['ID']['output'];
  runs: ConnectorRunPage;
  siteId: Scalars['ID']['output'];
  status: ConnectorStatus;
  type: ConnectorType;
  updatedAt: Scalars['Date']['output'];
  updatedBy: ConnectorActor;
};

export type AvigilonVideoConnectorRunsArgs = {
  filter?: InputMaybe<ConnectorRunFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type AvigilonVideoConnectorDefinition = ConnectorDefinition & {
  __typename?: 'AvigilonVideoConnectorDefinition';
  available: Scalars['Boolean']['output'];
  connectedDescription: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  settingsLabel: Scalars['String']['output'];
  setupDescription: Scalars['String']['output'];
  type: ConnectorType;
};

export type BadgeTemplate = {
  __typename?: 'BadgeTemplate';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isForTempBadge: Scalars['Boolean']['output'];
  templateName: Scalars['String']['output'];
};

export type BreakdownStat = {
  __typename?: 'BreakdownStat';
  compliantCount?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type BulkAssignJobsiteWorkerInput = {
  contractorId: Scalars['ID']['input'];
  /** Update values */
  jobsiteWorkerInput: JobsiteWorkerInput;
  /** ID of the worker to update */
  workerId: Scalars['ID']['input'];
};

export type BulkJobsiteWorkerInput = {
  /** ID of the worker to update */
  jobsiteWorkerId: Scalars['ID']['input'];
  /** Update values */
  jobsiteWorkerInput: JobsiteWorkerInput;
};

export type BulkSyncResult = {
  __typename?: 'BulkSyncResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  totalQueued: Scalars['Int']['output'];
};

export type CCureClearance = {
  __typename?: 'CCureClearance';
  cCureClearanceId: Scalars['ID']['output'];
  cCureClearanceObjectId: Scalars['Int']['output'];
  cCureEnvironment: CCureEnvironment;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isSelectable?: Maybe<Scalars['Boolean']['output']>;
  jobsite: Jobsite;
  name?: Maybe<Scalars['String']['output']>;
  objectHistory: ObjectHistory;
};

export type CCureEntityMapping = {
  __typename?: 'CCureEntityMapping';
  cCureEnvironment: CCureEnvironment;
  entityType: CCureEntityType;
  name?: Maybe<Scalars['String']['output']>;
  objectId: Scalars['Int']['output'];
};

export enum CCureEntityType {
  Clearance = 'Clearance',
  Controller = 'Controller',
  Door = 'Door',
  InArea = 'InArea',
  OutArea = 'OutArea',
}

export type CCureEnvironment = {
  __typename?: 'CCureEnvironment';
  cCureEnvironmentId: Scalars['ID']['output'];
  instanceSlug: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  partitionId: Scalars['Int']['output'];
};

export enum CCurePersonnelStatus {
  Active = 'Active',
  Disabled = 'Disabled',
}

export type CardPrintJob = {
  __typename?: 'CardPrintJob';
  cardPrintJobId: Scalars['ID']['output'];
  completion?: Maybe<CardPrintJobCompletion>;
  error?: Maybe<CardPrintJobError>;
  hidPrintJobId: Scalars['ID']['output'];
  jobsite: Jobsite;
  startedAt: Scalars['Date']['output'];
  status: CardPrintJobStatus;
  statusMessage: Scalars['String']['output'];
  worker: Worker;
  workerCard?: Maybe<WorkerCard>;
};

export type CardPrintJobCompletion = {
  __typename?: 'CardPrintJobCompletion';
  cardNumber?: Maybe<Scalars['String']['output']>;
  completedAt: Scalars['Date']['output'];
  facilityCode?: Maybe<Scalars['String']['output']>;
};

export type CardPrintJobError = {
  __typename?: 'CardPrintJobError';
  code: Scalars['Int']['output'];
  erroredAt: Scalars['Date']['output'];
  message: Scalars['String']['output'];
};

export type CardPrintJobInput = {
  cardTemplateName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobsitePrinterId: Scalars['ID']['input'];
  trade?: InputMaybe<Scalars['String']['input']>;
};

export enum CardPrintJobStatus {
  Deleted = 'Deleted',
  Failed = 'Failed',
  Printed = 'Printed',
  Submitted = 'Submitted',
}

export enum CardStatus {
  Active = 'Active',
  Failed = 'Failed',
  Inactive = 'Inactive',
  SentToWorker = 'SentToWorker',
}

export type ChangeContractorForJobsiteWorkersError = {
  __typename?: 'ChangeContractorForJobsiteWorkersError';
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type ChangeContractorForJobsiteWorkersInput = {
  /** IDs of the jobsite workers to update */
  jobsiteWorkerIds: Array<Scalars['ID']['input']>;
  /** Contractor ID to switch these jobsite workers to */
  newContractorId: Scalars['ID']['input'];
  /** Start Date for this these jobsite workers being updated */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ChangeContractorForJobsiteWorkersResponse = {
  __typename?: 'ChangeContractorForJobsiteWorkersResponse';
  changeContractorForJobsiteWorkersError: Array<
    Maybe<ChangeContractorForJobsiteWorkersError>
  >;
  changeContractorForJobsiteWorkersSuccess: Array<
    Maybe<ChangeContractorForJobsiteWorkersSuccess>
  >;
};

export type ChangeContractorForJobsiteWorkersSuccess = {
  __typename?: 'ChangeContractorForJobsiteWorkersSuccess';
  jobsiteWorker: JobsiteWorker;
};

export type ChangeJobsiteWorkersJobsiteAssignmentInput = {
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  jobsiteId: Scalars['ID']['input'];
  jobsiteWorkerIds: Array<Scalars['ID']['input']>;
};

export type ChangeJobsiteWorkersJobsiteAssignmentResponse = {
  __typename?: 'ChangeJobsiteWorkersJobsiteAssignmentResponse';
  edges: Array<JobsiteWorker>;
  totalCount: Scalars['Int']['output'];
};

export type ChangeScheduleStatusInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  status: ScheduleStatus;
};

export type ChangeScheduleStatusPayload = {
  __typename?: 'ChangeScheduleStatusPayload';
  schedule: Schedule;
};

export enum ChangeType {
  Created = 'created',
  Removed = 'removed',
  Updated = 'updated',
}

export type ChangeZonesModeInput = {
  fromMode: ZonesMode;
  /** The newest zones mode change the requester saw; null when the site had none. */
  latestChangeId?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
  toMode: ZonesMode;
};

export type ChangeZonesModePayload = {
  __typename?: 'ChangeZonesModePayload';
  id: Scalars['ID']['output'];
};

export type CheckInJobsiteWorkersInput = {
  checkInAreaId: Scalars['ID']['input'];
  checkInDateTime?: InputMaybe<Scalars['Date']['input']>;
  checkInDirection: JobsiteWorkerCheckInDirection;
  checkInReason?: InputMaybe<Scalars['String']['input']>;
  checkInType: JobsiteWorkerCheckInType;
  jobsiteId: Scalars['ID']['input'];
  jobsiteWorkerIds: Array<Scalars['ID']['input']>;
  location?: InputMaybe<GpsCoordinateInput>;
};

export type CheckWorkerPhoneAvailabilityInput = {
  /** Worker ID to exclude from the check (useful when updating a worker's phone number) */
  excludingWorkerId?: InputMaybe<Scalars['ID']['input']>;
  /** Phone number to check */
  phoneNumber: Scalars['String']['input'];
};

export type CheckWorkerPhoneAvailabilityPayload = {
  __typename?: 'CheckWorkerPhoneAvailabilityPayload';
  /** Indicates whether the phone number is available */
  isAvailable: Scalars['Boolean']['output'];
};

export type CloudFile = {
  __typename?: 'CloudFile';
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileType: FileType;
};

export type CompleteAnonymousPhoneVerificationInput = {
  /**
   * The invitation being onboarded to. Optional, but supplied by the
   * authenticated flow so the server can scope 'selfOnboardingCurrentStep' to
   * this jobsite: a worker resumes only when bound to *this* jobsite, never on a
   * step carried over from onboarding elsewhere.
   */
  jobsiteInvitationId?: InputMaybe<Scalars['ID']['input']>;
  verificationCode: Scalars['String']['input'];
};

export type CompleteAnonymousPhoneVerificationResponse = {
  __typename?: 'CompleteAnonymousPhoneVerificationResponse';
  /**
   * Authenticated session, set only when the verified phone already has an Odin
   * account — the worker is signed in. Sign-in only: jobsite assignment is
   * handled separately by 'selfOnboardingAssignToJobsite' so new and existing
   * workers converge at contractor selection.
   */
  auth?: Maybe<Auth>;
  /**
   * The signed-in worker's persisted self-onboarding step for the jobsite named
   * by 'jobsiteInvitationId', set only alongside 'auth' (existing account). The
   * authenticated flow reads this to resume a returning worker at the step they
   * left off on instead of routing them back through contractor selection. Null
   * when the worker is not yet bound to this jobsite (no jobsiteWorker) — even if
   * they carry a step from onboarding at a different jobsite — in which case the
   * flow sends them to contractor selection to bind.
   */
  selfOnboardingCurrentStep?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /**
   * FusionAuth token proving phone ownership, presented on the account-creation
   * step. Set only for a brand-new phone with no Odin account yet.
   */
  token?: Maybe<Scalars['String']['output']>;
};

export type CompletePasswordlessLoginInput = {
  loginCode: Scalars['String']['input'];
  loginId: Scalars['String']['input'];
};

export type CompletePhoneNumberVerificationAndSignInInput = {
  contractorId: Scalars['ID']['input'];
  jobsiteId: Scalars['ID']['input'];
  verificationCode: Scalars['String']['input'];
};

export type CompletePhoneNumberVerificationAndSignInResponse = {
  __typename?: 'CompletePhoneNumberVerificationAndSignInResponse';
  auth: Auth;
  jobsiteWorker?: Maybe<JobsiteWorker>;
  selfOnboardingInfo: SelfOnboardingWorkerInfo;
  success: Scalars['Boolean']['output'];
};

export type CompletePhoneNumberVerificationInput = {
  verificationCode: Scalars['String']['input'];
  workerId: Scalars['ID']['input'];
};

export type CompletePhoneNumberVerificationResponse = {
  __typename?: 'CompletePhoneNumberVerificationResponse';
  success: Scalars['Boolean']['output'];
  worker?: Maybe<Worker>;
};

export type ConfigurationZone = {
  __typename?: 'ConfigurationZone';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: GrantedZoneState;
};

export type Connection = {
  __typename?: 'Connection';
  entity: ConnectionEntity;
  externalEntity: ExternalEntity;
  id: Scalars['ID']['output'];
};

export type ConnectionEntity = {
  __typename?: 'ConnectionEntity';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export enum ConnectionOrigin {
  Adopted = 'ADOPTED',
  Created = 'CREATED',
}

export type ConnectionTestResult = {
  __typename?: 'ConnectionTestResult';
  apiVersion?: Maybe<Scalars['String']['output']>;
  latency?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Connector = {
  connectedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: ConnectorActor;
  definition: ConnectorDefinition;
  id: Scalars['ID']['output'];
  runs: ConnectorRunPage;
  siteId: Scalars['ID']['output'];
  status: ConnectorStatus;
  type: ConnectorType;
  updatedAt: Scalars['Date']['output'];
  updatedBy: ConnectorActor;
};

export type ConnectorRunsArgs = {
  filter?: InputMaybe<ConnectorRunFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type ConnectorActor = {
  __typename?: 'ConnectorActor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ConnectorCatalog = {
  __typename?: 'ConnectorCatalog';
  definition: ConnectorDefinition;
  items: Array<ConnectorCatalogItem>;
};

export type ConnectorCatalogDefinitionArgs = {
  type: ConnectorType;
};

export type ConnectorCatalogInstance = {
  __typename?: 'ConnectorCatalogInstance';
  connectorId: Scalars['ID']['output'];
  status: ConnectorStatus;
};

export type ConnectorCatalogItem = {
  __typename?: 'ConnectorCatalogItem';
  available: Scalars['Boolean']['output'];
  connectedDescription: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  instance?: Maybe<ConnectorCatalogInstance>;
  settingsLabel: Scalars['String']['output'];
  setupDescription: Scalars['String']['output'];
  type: ConnectorType;
};

/**
 * Environment-level configuration for a connector type. Distinct from an
 * installed connector instance.
 */
export type ConnectorDefinition = {
  /**
   * Whether this connector type can be set up in the current deployment.
   * An unavailable definition remains visible, but setup is disabled. This
   * does not indicate connector-instance state or provider health.
   */
  available: Scalars['Boolean']['output'];
  connectedDescription: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  settingsLabel: Scalars['String']['output'];
  setupDescription: Scalars['String']['output'];
  type: ConnectorType;
};

/** A provider resource a site's connector lists, against Odin. */
export type ConnectorInventoryItem = {
  __typename?: 'ConnectorInventoryItem';
  /**
   * Whether the site may adopt it: a provider reader or access control unit
   * of an enabled connector, seen in the last inventory refresh, serving
   * entries on this provider site alone, and named, with a model id when it
   * has a model. It is connected to nothing, or to a device that may still
   * go on this site: one on no site, such as a device discovery records,
   * that no other site holds through an access controller device's ports
   * (the access controller device a reader device is on, or a reader device
   * on the same ports). A device a discovery found missing is adoptable only
   * when the inventory refresh that last listed it was taken after that
   * discovery.
   */
  adoptable: Scalars['Boolean']['output'];
  connectorId: Scalars['ID']['output'];
  /** The Odin entity of this site connected to it or staged for it; unset unless adopted, staged, or missing. */
  entity?: Maybe<ConnectionEntity>;
  /** The provider resource, named as the last inventory refresh saw it. */
  externalEntity: ExternalEntity;
  id: Scalars['ID']['output'];
  /**
   * For a zone or entry side connected or staged, whether the site's effective
   * layout has it; unset for anything else.
   */
  inEffectiveLayout?: Maybe<Scalars['Boolean']['output']>;
  /** The item the provider lists it under, such as an entry's zone. */
  parent?: Maybe<ConnectorInventoryItem>;
  state: ConnectorInventoryItemState;
};

export enum ConnectorInventoryItemState {
  /** An Odin entity of this site is connected to it. */
  Adopted = 'ADOPTED',
  /**
   * An Odin entity that is not this site's own, such as another site's zone,
   * entry side, reader device or access controller device, is connected to it
   * or staged for it. This site cannot adopt it.
   */
  AdoptedElsewhere = 'ADOPTED_ELSEWHERE',
  /**
   * An Odin entity of this site is connected to it or staged for it, but the
   * last inventory refresh did not see it. Its connection or staged binding is
   * kept.
   */
  Missing = 'MISSING',
  /**
   * A draft's pending choice names it for a zone or entry side, to be bound
   * when the draft is published.
   */
  Staged = 'STAGED',
  /** The provider has it and no Odin entity is connected to it or staged for it. */
  Unadopted = 'UNADOPTED',
}

/** How a connector's inventory refreshes have gone. */
export type ConnectorInventoryRefresh = {
  __typename?: 'ConnectorInventoryRefresh';
  connectorId: Scalars['ID']['output'];
  /** When a refresh last completed; unset if none has. */
  lastCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** When the latest failed refresh that still held its lease failed; unset if none has. Later than the last completion, the inventory is stale. */
  lastFailedAt?: Maybe<Scalars['Date']['output']>;
  /** Why the latest failed refresh that still held its lease failed. */
  lastFailure?: Maybe<Scalars['String']['output']>;
};

export type ConnectorRun = {
  __typename?: 'ConnectorRun';
  connectorId: Scalars['ID']['output'];
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  startedAt: Scalars['Date']['output'];
  status: ConnectorRunStatus;
};

export type ConnectorRunFilterInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<ConnectorRunStatus>>;
};

export type ConnectorRunPage = {
  __typename?: 'ConnectorRunPage';
  runs: Array<ConnectorRun>;
  total: Scalars['Int']['output'];
};

export enum ConnectorRunStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
}

export enum ConnectorStatus {
  Connected = 'CONNECTED',
  Connecting = 'CONNECTING',
  ConnectionFailed = 'CONNECTION_FAILED',
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Enabled = 'ENABLED',
  EnablementFailed = 'ENABLEMENT_FAILED',
  Enabling = 'ENABLING',
}

export enum ConnectorType {
  AvigilonAccess = 'AVIGILON_ACCESS',
  AvigilonVideo = 'AVIGILON_VIDEO',
}

export type ContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Contractor = {
  __typename?: 'Contractor';
  billingContact?: Maybe<ContactPerson>;
  /** Unique identifier for the contractor */
  contractorId: Scalars['ID']['output'];
  contractorMembers: ContractorContractorMembersConnection;
  contractorWorkers: ContractorContractorWorkersConnection;
  description?: Maybe<Scalars['String']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isDefaultContractor?: Maybe<Scalars['Boolean']['output']>;
  jobsiteContractors: ContractorJobsiteContractorsConnection;
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Full organization object */
  organization: Organization;
  stripeMappingDetails?: Maybe<StripeMappingData>;
  stripePaymentMethods?: Maybe<Array<StripePaymentMethod>>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ContractorContractorMembersArgs = {
  input?: InputMaybe<ContractorContractorMembersInput>;
};

export type ContractorContractorWorkersArgs = {
  input?: InputMaybe<ContractorContractorWorkersInput>;
};

export type ContractorJobsiteContractorsArgs = {
  input?: InputMaybe<ContractorJobsiteContractorsInput>;
};

export type ContractorAddJobsitesInput = {
  contractorId: Scalars['ID']['input'];
  jobsiteContractorInput: JobsiteContractorInput;
  jobsiteIds: Array<Scalars['ID']['input']>;
};

export type ContractorAddJobsitesPayload = {
  __typename?: 'ContractorAddJobsitesPayload';
  jobsiteContractors: Array<JobsiteContractor>;
};

export type ContractorArchiveInput = {
  contractorId: Scalars['ID']['input'];
};

export type ContractorArchivePayload = {
  __typename?: 'ContractorArchivePayload';
  success: Success;
};

export type ContractorContractorMembersConnection = {
  __typename?: 'ContractorContractorMembersConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContractorContractorMembersEdge>;
};

export type ContractorContractorMembersEdge = {
  __typename?: 'ContractorContractorMembersEdge';
  node: ContractorMember;
};

export type ContractorContractorMembersInput = {
  orderBy?: InputMaybe<Array<InputMaybe<GetUsersOrderBy>>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ContractorContractorWorkersConnection = {
  __typename?: 'ContractorContractorWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContractorContractorWorkersEdge>;
};

export type ContractorContractorWorkersEdge = {
  __typename?: 'ContractorContractorWorkersEdge';
  node: ContractorWorker;
};

export type ContractorContractorWorkersInput = {
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ContractorCreateInput = {
  billingContact?: InputMaybe<ContactInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Must provide either organizationId or organizationCreateInput but not both */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationInput?: InputMaybe<OrganizationInput>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ContractorCreatePayload = {
  __typename?: 'ContractorCreatePayload';
  contractor: Contractor;
};

/** Input for Contractor Mutations */
export type ContractorInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationInput?: InputMaybe<OrganizationInput>;
};

export type ContractorJobsiteContractorsConnection = {
  __typename?: 'ContractorJobsiteContractorsConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContractorJobsiteContractorsEdge>;
};

export type ContractorJobsiteContractorsEdge = {
  __typename?: 'ContractorJobsiteContractorsEdge';
  node: JobsiteContractor;
};

export type ContractorJobsiteContractorsInput = {
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * ContractorMember return type. A member is any non-worker who is employed by the contractor, such as an owner,
 * manager, or back office employee.
 */
export type ContractorMember = {
  __typename?: 'ContractorMember';
  /** The full contractor object that the member is at */
  contractor: Contractor;
  id: Scalars['ID']['output'];
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Title of the member at the contractor. */
  title?: Maybe<Scalars['String']['output']>;
  /** The full user object of the member */
  user: User;
};

export type ContractorRemoveWorkerInput = {
  contractorWorkerId: Scalars['ID']['input'];
};

export type ContractorRemoveWorkerPayload = {
  __typename?: 'ContractorRemoveWorkerPayload';
  success: Success;
};

export type ContractorUpdateInput = {
  billingContact?: InputMaybe<ContactInput>;
  contractorId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  organizationInput: OrganizationInput;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ContractorUpdatePayload = {
  __typename?: 'ContractorUpdatePayload';
  contractor: Contractor;
};

/**
 * ContractorWorker return type. A worker is any non-worker who is employed by the contractor, such as an owner,
 * manager, or back office employee.
 */
export type ContractorWorker = {
  __typename?: 'ContractorWorker';
  /** The full contractor object that the worker is at */
  contractor: Contractor;
  /** Date the worker ended at the contractor */
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  jobsiteWorkers: ContractorWorkerJobsiteWorkersConnection;
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Payroll ID of the worker at the contractor */
  payrollId?: Maybe<Scalars['ID']['output']>;
  /** Date the worker started at the contractor */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** The full worker object */
  worker: Worker;
};

/**
 * ContractorWorker return type. A worker is any non-worker who is employed by the contractor, such as an owner,
 * manager, or back office employee.
 */
export type ContractorWorkerJobsiteWorkersArgs = {
  input?: InputMaybe<ContractorWorkerJobsiteWorkersInput>;
};

export type ContractorWorkerConnection = {
  __typename?: 'ContractorWorkerConnection';
  contractorWorkerConnectionId?: Maybe<Scalars['String']['output']>;
  edges: Array<ContractorWorker>;
  facets?: Maybe<ContractorWorkerConnectionFacets>;
  totalCount: Scalars['Int']['output'];
};

export type ContractorWorkerConnectionFacets = {
  __typename?: 'ContractorWorkerConnectionFacets';
  jobTitles?: Maybe<Array<Maybe<FacetCount>>>;
  trades?: Maybe<Array<Maybe<FacetCount>>>;
};

export type ContractorWorkerInput = {
  /** Worker end date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Worker's payroll ID */
  payrollId?: InputMaybe<Scalars['ID']['input']>;
  /** Worker start date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ContractorWorkerJobsiteWorkersConnection = {
  __typename?: 'ContractorWorkerJobsiteWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<ContractorWorkerJobsiteWorkersEdge>;
};

export type ContractorWorkerJobsiteWorkersEdge = {
  __typename?: 'ContractorWorkerJobsiteWorkersEdge';
  node: JobsiteWorker;
};

export type ContractorWorkerJobsiteWorkersInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type CreateAccessGroupInput = {
  makeDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateCardPrintJobInput = {
  cardTemplateName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobsiteId: Scalars['ID']['input'];
  jobsitePrinterId: Scalars['ID']['input'];
  trade?: InputMaybe<Scalars['String']['input']>;
  workerId: Scalars['ID']['input'];
};

/** Input for creating a new contractor */
export type CreateContractorInput = {
  createUserInput?: InputMaybe<CreateUserInput>;
  organizationInput: OrganizationInput;
};

export type CreateContractorStripeInvoiceInput = {
  contractorId: Scalars['ID']['input'];
  jobsiteContractorId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateContractorStripeInvoicePayload = {
  __typename?: 'CreateContractorStripeInvoicePayload';
  customerId: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CreateContractorWorkerInput = {
  /** Birthdate of worker */
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  /** Contractor ID to assign worker to */
  contractorId: Scalars['ID']['input'];
  contractorWorkerInput?: InputMaybe<ContractorWorkerInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of worker */
  firstName: Scalars['String']['input'];
  /** Force creation of new worker if none is found */
  forceCreate: Scalars['Boolean']['input'];
  /** Last name of worker */
  lastName: Scalars['String']['input'];
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Last four digits of worker's SSN */
  ssnLastFour?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** Optional User Account ID to use when creating a worker. Required when forceCreate is true */
  userAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional worker public ID to use when assigning worker to contractor */
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateDeveloperJobsiteAccessGrantInput = {
  /** Reference to the written agreement authorizing the share (required) */
  agreementReference: Scalars['String']['input'];
  /** The client (developer) receiving access */
  granteeDeveloperId: Scalars['ID']['input'];
  /** The jobsite whose data is being shared */
  jobsiteId: Scalars['ID']['input'];
};

/** Input for creating a new worker that does not already have an account */
export type CreateJobsiteWorkerInput = {
  /** Input fields for creating a new user account */
  createUserInput: CreateUserInput;
  /** Input fields for creating a new jobsite worker */
  jobsiteWorkerInput: JobsiteWorkerInput;
};

/**
 * Do not remove for now. Even though it's not used by a query or mutation,
 * it is used by 'queryLookerForJobsiteWorkerReports' helper function.
 */
export type CreateLookerJobsiteWorkerReportsResponse = {
  __typename?: 'CreateLookerJobsiteWorkerReportsResponse';
  activeBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  compliantBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  contractorBreakdowns: Array<ElasticFacetEntry>;
  dailyBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  jobTitleBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  jobsiteBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  jobsites: Array<Jobsite>;
  overviewBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  results: Array<ILookerWorkerSessionData>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  tradeBreakdowns: Array<ElasticFacetEntry>;
};

export type CreatePayrollDocumentInput = {
  contractorId: Scalars['ID']['input'];
  jobsiteId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  payrollDocumentTypeId: Scalars['ID']['input'];
  payrollEndDate?: InputMaybe<Scalars['Date']['input']>;
  payrollStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CreatePayrollDocumentVersionInput = {
  fileId: Scalars['ID']['input'];
  submittedAt: Scalars['Date']['input'];
};

export type CreateScheduleShiftInput = {
  duration: Scalars['Int']['input'];
  scheduleId: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
};

export type CreateScheduleShiftPayload = {
  __typename?: 'CreateScheduleShiftPayload';
  scheduleShift: ScheduleShift;
};

export type CreateScheduleWorkerInput = {
  activity?: InputMaybe<Scalars['String']['input']>;
  jobsiteContractorId: Scalars['ID']['input'];
  jobsiteWorkerId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  shiftId: Scalars['ID']['input'];
  trade?: InputMaybe<Scalars['String']['input']>;
  type: ScheduleWorkerType;
};

export type CreateScheduleWorkerPayload = {
  __typename?: 'CreateScheduleWorkerPayload';
  scheduleWorker: ScheduleWorker;
};

export type CreateScheduleWorkerSessionInput = {
  scheduleWorkerId: Scalars['ID']['input'];
};

export type CreateScheduleWorkerSessionPayload = {
  __typename?: 'CreateScheduleWorkerSessionPayload';
  scheduleWorkerSession: ScheduleWorkerSession;
};

export type CreateSiteLayoutDraftInput = {
  /** A published revision of the site to start from; the effective layout when omitted. */
  basedOnRevisionId?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
};

export type CreateTempBadgeInput = {
  badgeName: Scalars['String']['input'];
  badgeTemplateId: Scalars['ID']['input'];
  fileInput?: InputMaybe<FileInput>;
  jobsiteId: Scalars['ID']['input'];
  jobsitePrinterId: Scalars['ID']['input'];
};

/** Input type for creating a new user account for another user */
export type CreateUserInput = {
  /** Email of the new user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the new user */
  firstName: Scalars['String']['input'];
  /** Last name of the new user */
  lastName: Scalars['String']['input'];
  /** Phone number of the new user */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkerCardInput = {
  cardPrintJobInput: CardPrintJobInput;
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteId: Scalars['ID']['input'];
  workerCardInput: WorkerCardInput;
  workerId: Scalars['ID']['input'];
};

/** Input for creating a worker that does not already have a user account */
export type CreateWorkerInput = {
  /** Input fields for creating a new user account */
  createUserInput: CreateUserInput;
  /** Input fields for creating a new worker */
  workerInput: WorkerInput;
};

/** Travel across an entry, from one side to the other. */
export type Crossing = {
  __typename?: 'Crossing';
  from: LayoutSide;
  to: LayoutSide;
};

export type DashboardJobsiteWorkerSession = {
  __typename?: 'DashboardJobsiteWorkerSession';
  contractorOrganizationName?: Maybe<Scalars['String']['output']>;
  croppedDownloadKey?: Maybe<Scalars['String']['output']>;
  jobsiteName: Scalars['String']['output'];
  jobsiteWorkerJobsiteWorkerId: Scalars['String']['output'];
  jobsiteWorkerStatus?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  swipeSessionsCompliant?: Maybe<Scalars['String']['output']>;
  swipeSessionsDisplayValueSpanHours?: Maybe<Scalars['String']['output']>;
  swipeSessionsFirstInboundSwipeTimeOfDay?: Maybe<Scalars['String']['output']>;
  swipeSessionsJobsiteWorkerId: Scalars['String']['output'];
  swipeSessionsLastOutboundSwipeTimeOfDay?: Maybe<Scalars['String']['output']>;
  swipeSessionsNetTotalSpanHours?: Maybe<Scalars['String']['output']>;
  swipeSessionsOvernightSession?: Maybe<Scalars['String']['output']>;
  swipeSessionsReads?: Maybe<Scalars['String']['output']>;
  swipeSessionsReadsInbound?: Maybe<Scalars['String']['output']>;
  swipeSessionsReadsOutbound?: Maybe<Scalars['String']['output']>;
  swipeSessionsSessionDate: Scalars['String']['output'];
  swipeSessionsSessionId: Scalars['String']['output'];
  userIdentityUserFullname: Scalars['String']['output'];
  workerJobTitle?: Maybe<Scalars['String']['output']>;
  workerProfilePicturesViewCroppedCloudStorageBucket?: Maybe<
    Scalars['String']['output']
  >;
  workerProfilePicturesViewCroppedCloudStorageUri?: Maybe<
    Scalars['String']['output']
  >;
  workerProfilePicturesViewCroppedDownloadKey?: Maybe<
    Scalars['String']['output']
  >;
  workerQuickCode?: Maybe<Scalars['String']['output']>;
  workerTrade?: Maybe<Scalars['String']['output']>;
  workerUnionAffiliation?: Maybe<Scalars['String']['output']>;
  workerWorkerId: Scalars['String']['output'];
};

export type DataExtractionInput = {
  extractionType: ExtractionProcessorType;
  fileId: Scalars['ID']['input'];
};

export type DeleteScheduleShiftPayload = {
  __typename?: 'DeleteScheduleShiftPayload';
  success: Success;
};

export type DeleteScheduleWorkerPayload = {
  __typename?: 'DeleteScheduleWorkerPayload';
  success: Success;
};

/**
 * Developer return type. A developer represents a real estate development company, as opposed to an individual working
 * either for or at the developer.
 */
export type Developer = {
  __typename?: 'Developer';
  /** Unique identifier for the developer */
  developerId: Scalars['ID']['output'];
  developerMembers: DeveloperDeveloperMembersConnection;
  jobsites: DeveloperJobsitesConnection;
  name: Scalars['String']['output'];
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Full organization object */
  organization: Organization;
  stripeMappingDetails?: Maybe<StripeMappingData>;
  stripePaymentMethods?: Maybe<Array<StripePaymentMethod>>;
};

/**
 * Developer return type. A developer represents a real estate development company, as opposed to an individual working
 * either for or at the developer.
 */
export type DeveloperDeveloperMembersArgs = {
  input?: InputMaybe<DeveloperDeveloperMembersInput>;
};

/**
 * Developer return type. A developer represents a real estate development company, as opposed to an individual working
 * either for or at the developer.
 */
export type DeveloperJobsitesArgs = {
  input?: InputMaybe<DeveloperJobsitesInput>;
};

export type DeveloperCreateInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationInput?: InputMaybe<OrganizationInput>;
};

export type DeveloperCreatePayload = {
  __typename?: 'DeveloperCreatePayload';
  developer: Developer;
};

export type DeveloperDeveloperMembersConnection = {
  __typename?: 'DeveloperDeveloperMembersConnection';
  count: Scalars['Int']['output'];
  edges: Array<DeveloperDeveloperMembersEdge>;
};

export type DeveloperDeveloperMembersEdge = {
  __typename?: 'DeveloperDeveloperMembersEdge';
  node: DeveloperMember;
};

export type DeveloperDeveloperMembersInput = {
  orderBy?: InputMaybe<Array<InputMaybe<GetUsersOrderBy>>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A per-site, per-counterparty read grant: lets a grantee client see one
 * jobsite's data via the Client API without exposing the owning client's wider
 * portfolio (sc-17264).
 */
export type DeveloperJobsiteAccessGrant = {
  __typename?: 'DeveloperJobsiteAccessGrant';
  /** Reference to the written data-sharing agreement */
  agreementReference: Scalars['String']['output'];
  /** Access verb; 'read' today */
  capability: Scalars['String']['output'];
  /** The client organization receiving access */
  granteeDeveloper: Developer;
  granteeDeveloperId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  jobsiteId: Scalars['ID']['output'];
  objectHistory: ObjectHistory;
  /** 'active' or 'archived' */
  status: Scalars['String']['output'];
};

export type DeveloperJobsiteAccessGrantPayload = {
  __typename?: 'DeveloperJobsiteAccessGrantPayload';
  grant: DeveloperJobsiteAccessGrant;
};

export type DeveloperJobsitesConnection = {
  __typename?: 'DeveloperJobsitesConnection';
  count: Scalars['Int']['output'];
  edges: Array<DeveloperJobsitesEdge>;
};

export type DeveloperJobsitesEdge = {
  __typename?: 'DeveloperJobsitesEdge';
  node: Jobsite;
};

export type DeveloperJobsitesInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

/**
 * DeveloperMember return type. A member is any non-worker who is employed by the developer, such as an owner,
 * manager, or back office employee.
 */
export type DeveloperMember = {
  __typename?: 'DeveloperMember';
  /** The full developer object that the member is at */
  developer: Developer;
  id: Scalars['ID']['output'];
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Title of the member at the developer. */
  title?: Maybe<Scalars['String']['output']>;
  /** The full user object of the member */
  user: User;
};

export type DeveloperUpdateInput = {
  developerId: Scalars['ID']['input'];
  organizationInput?: InputMaybe<OrganizationInput>;
};

export type DeveloperUpdatePayload = {
  __typename?: 'DeveloperUpdatePayload';
  developer: Developer;
};

/** One physical piece of hardware and its name. A device belongs to no site. */
export type Device = {
  __typename?: 'Device';
  id: Scalars['ID']['output'];
  /** The provider's model of an access controller; never set for a reader. */
  modelKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Where a device may be assigned, as assignDeviceToSite decides it. */
export type DeviceAssignability = {
  __typename?: 'DeviceAssignability';
  /**
   * Why it cannot be assigned to any site now, lockedSite included: the
   * refusal of every site. Unset when it can be. The device's own block
   * comes ahead of its locked site's refusal: a device both blocked itself
   * and held to a site that refuses it answers its own block, never
   * ZONES_NOT_ENABLED or SITE_NOT_ACTIVE.
   */
  blockedReason?: Maybe<DeviceAssignmentRefusal>;
  /**
   * When it cannot be assigned because the reader devices on an access
   * controller device's ports are on several sites, those sites, by name.
   * Empty otherwise.
   */
  blockedSites: Array<Site>;
  /** Why it is held to lockedSite: the refusal of any other site. */
  lockedReason?: Maybe<DeviceAssignmentRefusal>;
  /**
   * The one site it may be assigned to, when it is held to one: a reader
   * device's access controller device's site or, while that is on none, the
   * site of the other reader devices on the same access controller device;
   * an access controller device's reader devices' site.
   */
  lockedSite?: Maybe<Site>;
  /**
   * For an access controller device, the reader devices on its ports that are
   * assigned with it: those on no site and not missing. Empty for a reader
   * device, and while it cannot be assigned.
   */
  readerDevicesGoingAlong: Array<DiscoveredDevice>;
};

/** Why assignDeviceToSite refuses to assign a device to a site. */
export enum DeviceAssignmentRefusal {
  /** The access controller device is already on a site; there is no move. */
  AccessControllerDeviceAlreadyAssigned = 'ACCESS_CONTROLLER_DEVICE_ALREADY_ASSIGNED',
  /** The reader device's access controller device is on another site. */
  AccessControllerOnAnotherSite = 'ACCESS_CONTROLLER_ON_ANOTHER_SITE',
  /** The provider no longer reports the device. */
  DeviceMissing = 'DEVICE_MISSING',
  /** The reader device is already on a site; there is no move. */
  ReaderDeviceAlreadyAssigned = 'READER_DEVICE_ALREADY_ASSIGNED',
  /** A reader device on one of the access controller device's ports is on another site. */
  ReaderDeviceOnAnotherSite = 'READER_DEVICE_ON_ANOTHER_SITE',
  /** Another reader device on the same access controller device is on another site. */
  ReaderDeviceOnSameControllerOnAnotherSite = 'READER_DEVICE_ON_SAME_CONTROLLER_ON_ANOTHER_SITE',
  /** The site is archived or inactive. */
  SiteNotActive = 'SITE_NOT_ACTIVE',
  /** The site's site layout is off, so zones are not enabled for it. */
  ZonesNotEnabled = 'ZONES_NOT_ENABLED',
}

/** How device discoveries have gone. */
export type DeviceDiscovery = {
  __typename?: 'DeviceDiscovery';
  /** When a discovery last completed; unset if none has. */
  lastCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** When a discovery last failed; unset if none has. Later than the last completion, the recorded devices may be stale. */
  lastFailedAt?: Maybe<Scalars['Date']['output']>;
  /** Why the latest failed discovery failed. */
  lastFailure?: Maybe<Scalars['String']['output']>;
};

/** What the latest sync read of a controller unit. */
export enum DeviceHealth {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Unknown = 'UNKNOWN',
}

export enum DevicePlatform {
  Android = 'android',
  Ios = 'ios',
}

export enum DeviceType {
  AccessController = 'ACCESS_CONTROLLER',
  Reader = 'READER',
}

export type DiscardSiteLayoutDraftInput = {
  /** The draft token the client read; a draft written since is refused as STALE_DRAFT. */
  expectedDraftToken: Scalars['Int']['input'];
  /** The draft the client read; another draft is refused as REVISION_MISMATCH. */
  revisionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type DiscoverDevicesPayload = {
  __typename?: 'DiscoverDevicesPayload';
  /**
   * Whether this discovery listed every device and recorded each one; false
   * when a listing or a recording failed, and when no discovery ran.
   */
  complete: Scalars['Boolean']['output'];
  /** Every recorded device, after the discovery, by name. */
  devices: Array<DiscoveredDevice>;
  /** Whether a discovery ran; false when one was already running. */
  discovered: Scalars['Boolean']['output'];
  /** How discoveries have gone, after this one. */
  discovery: DeviceDiscovery;
  /** What the discovery recorded and could not, or why it did not run. */
  message: Scalars['String']['output'];
};

/**
 * A reader device or access controller device a device discovery or an
 * adoption recorded, whatever site it is on.
 */
export type DiscoveredDevice = {
  __typename?: 'DiscoveredDevice';
  /** For a reader device on a port, the access controller device the port belongs to. */
  accessControllerDevice?: Maybe<DiscoveredDevice>;
  /**
   * For a reader device, the access controller port it is on, with the
   * reader device on it; unset when it is on none, and for an access
   * controller device.
   */
  accessControllerPort?: Maybe<AccessControllerPort>;
  /** Where it may be assigned now, as assignDeviceToSite decides it. */
  assignability: DeviceAssignability;
  device: Device;
  /**
   * The Avigilon reader or access control unit the device is connected to;
   * null while it has none.
   */
  externalEntity?: Maybe<ExternalEntity>;
  /** The reader device's or access controller device's id. */
  id: Scalars['ID']['output'];
  /**
   * When a complete discovery first no longer found it at the provider; unset
   * until a discovery or adoption records a listing of it. Only Odin's own
   * device discovery sets it; a site's connector inventory refresh does not.
   * assignDeviceToSite refuses a missing device.
   */
  missingSince?: Maybe<Scalars['Date']['output']>;
  /** For an access controller device, how many reader devices are on its ports; unset for a reader device. */
  readerDeviceCount?: Maybe<Scalars['Int']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The site it is on now: an access controller device's assignment, a
   * reader device's registration. Unset while it is on none.
   */
  site?: Maybe<Site>;
  type: DeviceType;
};

export enum DocumentAdditionalFieldType {
  Bool = 'bool',
  Date = 'date',
  DateTime = 'dateTime',
  Float = 'float',
  Int = 'int',
  String = 'string',
}

export { DocumentKey };

export type EditableFields = {
  __typename?: 'EditableFields';
  email: Scalars['Boolean']['output'];
  phone: Scalars['Boolean']['output'];
};

export type ElasticFacetEntry = {
  __typename?: 'ElasticFacetEntry';
  compliantCount?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
};

/**
 * How crossings that admit into a side are treated. ENFORCED means the
 * crossing is an access decision; IDENTIFY_ONLY means it is recorded and never
 * denied; NOT_TRACKED (None) means it is neither, and no reader admits into
 * the side.
 */
export enum Enforcement {
  Enforced = 'ENFORCED',
  IdentifyOnly = 'IDENTIFY_ONLY',
  NotTracked = 'NOT_TRACKED',
}

/** Input for creating a worker if it doesn't exist and starting passwordless login */
export type EnsureWorkerAndStartPasswordlessLoginInput = {
  ensureWorkerInput?: InputMaybe<EnsureWorkerInput>;
  startPasswordlessLoginInput: StartPasswordlessLoginInput;
};

export type EnsureWorkerAndStartPasswordlessLoginResponse = {
  __typename?: 'EnsureWorkerAndStartPasswordlessLoginResponse';
  success: Scalars['Boolean']['output'];
  worker?: Maybe<WorkerAccount>;
};

/** Input for creating a worker if it doesn't exist. Either 'workerId' or 'createWorkerInput' should be specified */
export type EnsureWorkerInput = {
  /** Input fields for creating a new worker and user account. If 'workerId' is truthy no worker will be created */
  createWorkerInput?: InputMaybe<CreateWorkerInput>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type EntityChange = {
  __typename?: 'EntityChange';
  apiDbHandler: Scalars['String']['output'];
  entityDbId?: Maybe<Scalars['Int']['output']>;
  entityId: Scalars['ID']['output'];
  entityUpdatedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  objectHistory: ObjectHistory;
  tableName: Scalars['String']['output'];
  values?: Maybe<Scalars['JSONObject']['output']>;
};

export type EntityChangesEdge = {
  __typename?: 'EntityChangesEdge';
  node: EntityChange;
};

/** A named seam between two sides, as one revision has it. */
export type Entry = {
  __typename?: 'Entry';
  assignments: Array<ReaderAssignment>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sideA: EntrySide;
  sideB: EntrySide;
};

/** One side of an entry, as one revision configures it. */
export type EntrySide = {
  __typename?: 'EntrySide';
  /**
   * The entry side's connection to its Avigilon entry; null while it has
   * none; layout delivery creates or binds it.
   */
  connection?: Maybe<Connection>;
  enforcement: Enforcement;
  id: Scalars['ID']['output'];
  kind: LayoutSideKind;
  position: EntrySidePosition;
  /** The zone the side faces; null when it faces the outside. */
  zone?: Maybe<Zone>;
};

/** One side of an entry as a composite save writes it. */
export type EntrySideInput = {
  /** The site's readers whose crossing admits into this side; empty for none. */
  admittingReaderIds: Array<Scalars['ID']['input']>;
  /** How crossings admitting into this side are treated. */
  enforcement: Enforcement;
  faces: LayoutSideInput;
};

/** Which of an entry's two sides. Direction exists only on a crossing. */
export enum EntrySidePosition {
  A = 'A',
  B = 'B',
}

export type ExternalEntity = {
  __typename?: 'ExternalEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  typeDisplayName: Scalars['String']['output'];
};

export enum ExternalIntegrationType {
  Avigilon = 'Avigilon',
  Procore = 'Procore',
  Stripe = 'Stripe',
}

export enum ExtractionProcessorType {
  IdCard = 'IDCard',
  OshaCard = 'OSHACard',
  SstCard = 'SSTCard',
}

export type FacetCount = {
  __typename?: 'FacetCount';
  count: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

/** File return type. A file represents an actual file stored in the server along with its metadata. */
export type File = {
  __typename?: 'File';
  /** The url to actually download the image */
  downloadUrl: Scalars['String']['output'];
  /** Auto generated ID */
  fileId: Scalars['ID']['output'];
  /** Type of file -- image, video, etc. */
  fileType?: Maybe<FileType>;
  /** Specify if File can be downloaded as an attachment */
  isAttachment?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** Original name of the file */
  originalFileName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the file was uploaded */
  uploadedAt: Scalars['Date']['output'];
};

export type FileChangeInput = {
  changeType: ChangeType;
  fileId?: InputMaybe<Scalars['ID']['input']>;
  fileInput?: InputMaybe<FileInput>;
};

/**
 * Because the downloadUrl in the File object requires authentication, the file server must make a request to the API
 * to check the user's ACL. If the ACL passes, this object is returned with a downloadUrl that the client should be
 * redirected to.
 */
export type FileDownloadRedirect = {
  __typename?: 'FileDownloadRedirect';
  downloadRedirectUrl: Scalars['String']['output'];
  file: File;
};

export type FileInput = {
  isPublic: Scalars['Boolean']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  saveOriginalFileName?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uploadData?: InputMaybe<Scalars['Upload']['input']>;
};

export enum FileType {
  Csv = 'CSV',
  Html = 'HTML',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Video = 'VIDEO',
  Xlxs = 'XLXS',
}

export type FilterInput = {
  entityIds: Array<Scalars['ID']['input']>;
  tableName: Scalars['String']['input'];
};

export type FilterOption = {
  __typename?: 'FilterOption';
  count?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  value: Scalars['ID']['output'];
};

export type Form = {
  __typename?: 'Form';
  allowAdd: Scalars['Boolean']['output'];
  allowAutoCreateOnCheckout: Scalars['Boolean']['output'];
  allowDelete: Scalars['Boolean']['output'];
  allowEdit: Scalars['Boolean']['output'];
  allowPrintView: Scalars['Boolean']['output'];
  allowSessionAssignment: Scalars['Boolean']['output'];
  /** Whether the form should close automatically after a successful save */
  closeOnSave: Scalars['Boolean']['output'];
  /** Whether workers must double-confirm before submitting this form */
  confirmationRequired: Scalars['Boolean']['output'];
  /** Json in a tree shape containing the form definition */
  content: Scalars['JSONObject']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the form */
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Whether to send push notifications to assigned workers when a submission is created */
  sendNotificationOnCreate: Scalars['Boolean']['output'];
};

export type FormArchiveInput = {
  id: Scalars['ID']['input'];
};

export type FormArchivePayload = {
  __typename?: 'FormArchivePayload';
  success: Success;
};

export type FormCreateInput = {
  content: Scalars['JSONObject']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type FormCreatePayload = {
  __typename?: 'FormCreatePayload';
  form: Form;
};

export type FormSubmissionJobsiteWorkerInput = {
  formSubmissionId: Scalars['ID']['input'];
};

export type FormSubmissionsReportInput = {
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['Date']['input'];
  formId: Scalars['ID']['input'];
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<Array<GetJobsiteFormSubmissionsOrderBy>>;
  responses?: InputMaybe<Array<WorkerResponseFilter>>;
  startDate: Scalars['Date']['input'];
  /** Values of extra_data.training to match, for logs that record a training. */
  trainings?: InputMaybe<Array<Scalars['String']['input']>>;
  workerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FormUpdateInput = {
  content?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FormUpdatePayload = {
  __typename?: 'FormUpdatePayload';
  form: Form;
};

export type GpsCoordinate = {
  __typename?: 'GPSCoordinate';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type GpsCoordinateInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

/** The zone a gateway's entry leads into from the outside. */
export type GatewayDestinationInput = {
  gatewayId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

export enum GeofencingEnforcementType {
  Hard = 'hard',
  None = 'none',
}

/** Response object for getAllContractors */
export type GetAllContractorsResponse = {
  __typename?: 'GetAllContractorsResponse';
  count: Scalars['Int']['output'];
  results: Array<Contractor>;
};

export type GetAllOrganizationsConnection = {
  __typename?: 'GetAllOrganizationsConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetAllOrganizationsEdge>;
};

export type GetAllOrganizationsEdge = {
  __typename?: 'GetAllOrganizationsEdge';
  node?: Maybe<Organization>;
};

export type GetAllOrganizationsInput = {
  paginationInput: LimitOffsetPaginationInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetContractorMemberByMemberAndContractorInput = {
  contractorId: Scalars['ID']['input'];
  memberUserAccountId: Scalars['ID']['input'];
};

export type GetContractorMemberInput = {
  contractorMemberId?: InputMaybe<Scalars['ID']['input']>;
  memberAndContractor?: InputMaybe<GetContractorMemberByMemberAndContractorInput>;
};

export type GetDeveloperMemberByMemberAndDeveloperInput = {
  developerId: Scalars['ID']['input'];
  memberUserAccountId: Scalars['ID']['input'];
};

export type GetDeveloperMemberInput = {
  developerMemberId?: InputMaybe<Scalars['ID']['input']>;
  memberAndDeveloper?: InputMaybe<GetDeveloperMemberByMemberAndDeveloperInput>;
};

export type GetEntityChangesInput = {
  filters: Array<FilterInput>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type GetEntityChangesResult = {
  __typename?: 'GetEntityChangesResult';
  count: Scalars['Int']['output'];
  edges: Array<EntityChangesEdge>;
};

export type GetJobsiteAnnouncementsInput = {
  announcementType?: InputMaybe<AnnouncementType>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AnnouncementStatus>;
};

export type GetJobsiteContractorsResponse = {
  __typename?: 'GetJobsiteContractorsResponse';
  count: Scalars['Int']['output'];
  results: Array<JobsiteContractor>;
};

export type GetJobsiteEquipmentDataResponse = {
  __typename?: 'GetJobsiteEquipmentDataResponse';
  count: Scalars['Int']['output'];
  results: Array<JobsiteEquipmentData>;
};

export type GetJobsiteEquipmentHistoryResponse = {
  __typename?: 'GetJobsiteEquipmentHistoryResponse';
  count: Scalars['Int']['output'];
  results: Array<JobsiteEquipmentEvent>;
};

export type GetJobsiteFormSubmissionsOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<GetJobsiteFormSubmissionsOrderByField>;
};

export enum GetJobsiteFormSubmissionsOrderByField {
  AssignedTo = 'assigned_to',
  Building = 'building',
  CreatedBy = 'created_by',
  Date = 'date',
  EndTime = 'end_time',
  ExtinguisherNo = 'extinguisher_no',
  Incident = 'incident',
  InspectedBy = 'inspected_by',
  InspectionType = 'inspection_type',
  Level = 'level',
  Manpower = 'manpower',
  Name = 'name',
  ObservationType = 'observation_type',
  ReportedBy = 'reported_by',
  RespondedAt = 'responded_at',
  Response = 'response',
  StartTime = 'start_time',
  TempBadge = 'temp_badge',
  TempBadgeExpiration = 'temp_badge_expiration',
  Visitor = 'visitor',
  WorkersCount = 'workers_count',
}

export type GetJobsitePacsGatewaysResponse = {
  __typename?: 'GetJobsitePacsGatewaysResponse';
  count: Scalars['Int']['output'];
  results?: Maybe<Array<Maybe<JobsitePacsGateway>>>;
};

export type GetJobsiteWorkerDashboardResponse = {
  __typename?: 'GetJobsiteWorkerDashboardResponse';
  activeBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  ageBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  bannedBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  compliantBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  contractorBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  /**
   * The full set of contractor organization names available as filter options,
   * independent of the current contractor selection (so the multi-select dropdown
   * always offers every contractor, not just the selected ones).
   */
  contractorOptions?: Maybe<Array<Scalars['String']['output']>>;
  dailyBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  genderBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  jobTitleBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  jobsiteBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  jobsites: Array<Jobsite>;
  languageBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  onboardedBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  overviewBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  raceBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  results: Array<DashboardJobsiteWorkerSession>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  tradeBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
  zipcodeBreakdowns?: Maybe<Array<ElasticFacetEntry>>;
};

export enum GetJobsiteWorkerReportsTimeBreakdown {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
}

export type GetJobsiteWorkersOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<GetJobsiteWorkersOrderByField>;
};

export enum GetJobsiteWorkersOrderByField {
  BirthDate = 'BIRTH_DATE',
  CompletedBadgingAt = 'COMPLETED_BADGING_AT',
  CompletedSiteSpecificTrainingAt = 'COMPLETED_SITE_SPECIFIC_TRAINING_AT',
  Contractor = 'CONTRACTOR',
  JobsiteName = 'JOBSITE_NAME',
  JobTitle = 'JOB_TITLE',
  Name = 'NAME',
  OrientationDate = 'ORIENTATION_DATE',
  OrientationStatus = 'ORIENTATION_STATUS',
  SiteSpecificStatus = 'SITE_SPECIFIC_STATUS',
  StartDate = 'START_DATE',
  Trade = 'TRADE',
}

export type GetJobsitesOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: GetJobsitesOrderByField;
};

export enum GetJobsitesOrderByField {
  /**
   * Sort by great-circle distance from the supplied location (closest first, nulls last).
   * Omitted from the sort when no location is provided.
   */
  Distance = 'distance',
  Name = 'name',
  StartDate = 'start_date',
}

export type GetMemberJobsitesResponse = {
  __typename?: 'GetMemberJobsitesResponse';
  count: Scalars['Int']['output'];
  jobsiteMembers: Array<JobsiteMember>;
  selectedJobsiteMember?: Maybe<JobsiteMember>;
  user: User;
};

export type GetOrganizationsOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<GetOrganizationsOrderByField>;
};

export enum GetOrganizationsOrderByField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Slug = 'SLUG',
}

export type GetPayrollDocumentsInput = {
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payrollDocumentTypeId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetSchedulesOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<GetSchedulesOrderByField>;
};

export enum GetSchedulesOrderByField {
  Date = 'date',
  Jobsite = 'jobsite',
  Scheduler = 'scheduler',
  Status = 'status',
}

export type GetTempBadgesOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<GetTempBadgesOrderByField>;
};

export enum GetTempBadgesOrderByField {
  CardNumber = 'cardNumber',
  Name = 'name',
}

export type GetUserRolesOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<GetUserRolesOrderByField>;
};

export enum GetUserRolesOrderByField {
  CreatedAt = 'created_at',
  Jobsite = 'jobsite',
  Title = 'title',
  UpdatedAt = 'updated_at',
}

export type GetUsersOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<GetUsersOrderByField>;
};

export enum GetUsersOrderByField {
  AppVersion = 'app_version',
  Email = 'email',
  LastActiveAt = 'last_active_at',
  Name = 'name',
  PhoneNumber = 'phone_number',
}

export type GetWorkerDocumentsResponse = {
  __typename?: 'GetWorkerDocumentsResponse';
  workerDocuments: Array<JobsiteWorkerDocument>;
};

export enum GrantedZoneState {
  NotInCurrentLayout = 'NOT_IN_CURRENT_LAYOUT',
  NotYetPublished = 'NOT_YET_PUBLISHED',
  Published = 'PUBLISHED',
}

export type HidEntityOption = {
  __typename?: 'HidEntityOption';
  entityType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  proxyInstance: HidProxyInstance;
};

export enum HidProxyInstance {
  Odin = 'odin',
  Related = 'related',
}

/**
 * Note:Not to be removed
 * Used by generateLookerJobsiteWorkerReports
 */
export type ILookerWorkerSessionData = {
  __typename?: 'ILookerWorkerSessionData';
  contractorOrganizationName?: Maybe<Scalars['String']['output']>;
  croppedDownloadKey?: Maybe<Scalars['String']['output']>;
  jobsiteName: Scalars['String']['output'];
  jobsiteWorkerJobTitle?: Maybe<Scalars['String']['output']>;
  jobsiteWorkerJobsiteWorkerId: Scalars['String']['output'];
  jobsiteWorkerStatus?: Maybe<Scalars['String']['output']>;
  jobsiteWorkerTrade?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<Scalars['String']['output']>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  swipeSessionsCompliant?: Maybe<Scalars['String']['output']>;
  swipeSessionsDisplayValueSpanHours?: Maybe<Scalars['String']['output']>;
  swipeSessionsFirstInboundSwipeTimeOfDay?: Maybe<Scalars['String']['output']>;
  swipeSessionsJobsiteWorkerId: Scalars['String']['output'];
  swipeSessionsLastOutboundSwipeTimeOfDay?: Maybe<Scalars['String']['output']>;
  swipeSessionsNetTotalSpanHours?: Maybe<Scalars['String']['output']>;
  swipeSessionsOvernightSession?: Maybe<Scalars['String']['output']>;
  swipeSessionsReads?: Maybe<Scalars['String']['output']>;
  swipeSessionsReadsInbound?: Maybe<Scalars['String']['output']>;
  swipeSessionsReadsOutbound?: Maybe<Scalars['String']['output']>;
  swipeSessionsSessionDate: Scalars['String']['output'];
  swipeSessionsSessionId: Scalars['String']['output'];
  userIdentityUserFullname: Scalars['String']['output'];
  workerJobTitle?: Maybe<Scalars['String']['output']>;
  workerProfilePicturesViewCroppedCloudStorageBucket?: Maybe<
    Scalars['String']['output']
  >;
  workerProfilePicturesViewCroppedCloudStorageUri?: Maybe<
    Scalars['String']['output']
  >;
  workerProfilePicturesViewCroppedDownloadKey?: Maybe<
    Scalars['String']['output']
  >;
  workerQuickCode?: Maybe<Scalars['String']['output']>;
  workerTrade?: Maybe<Scalars['String']['output']>;
  workerUnionAffiliation?: Maybe<Scalars['String']['output']>;
  workerWorkerId: Scalars['String']['output'];
};

export type IdCardData = {
  __typename?: 'IdCardData';
  address?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  idType?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type IdCardDataExtractionResult = {
  __typename?: 'IdCardDataExtractionResult';
  extractedData?: Maybe<IdCardData>;
  file?: Maybe<File>;
};

export type ImportScheduleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sourceId: Scalars['ID']['input'];
};

export type ImportSchedulePayload = {
  __typename?: 'ImportSchedulePayload';
  schedule: Schedule;
};

export type InitiateStripePaymentSetupSessionInput = {
  contractorId: Scalars['ID']['input'];
};

export type InitiateStripePaymentSetupSessionPayload = {
  __typename?: 'InitiateStripePaymentSetupSessionPayload';
  clientSecret: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type IntegrationDetails = {
  __typename?: 'IntegrationDetails';
  integrationType: ExternalIntegrationType;
  url: Scalars['String']['output'];
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type Jobsite = {
  __typename?: 'Jobsite';
  accessChangeEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The access controllers on this site now, with their ports and the reader
   * devices on them, by access controller device name. Read only.
   */
  accessControllers: Array<AccessController>;
  accessGroups: Array<AccessGroup>;
  activityCodeOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** City of the jobsite */
  addressCity?: Maybe<Scalars['String']['output']>;
  /** Address of the jobsite */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Address of the jobsite */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** State of the jobsite */
  addressState?: Maybe<StateAbbreviation>;
  /** Zip code of the jobsite */
  addressZipCode?: Maybe<Scalars['String']['output']>;
  allowOvernightSessions?: Maybe<Scalars['Boolean']['output']>;
  allowsMobileCheckIn?: Maybe<Scalars['Boolean']['output']>;
  appCheckInModule?: Maybe<JobsiteAppCheckInModule>;
  assignmentChangeEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  avigilonCameraEnabled?: Maybe<Scalars['Boolean']['output']>;
  avigilonEnabled?: Maybe<Scalars['Boolean']['output']>;
  cCureClearances: JobsiteCCureClearancesConnection;
  cCureEntityMappings: JobsiteCCureEntityMappingsConnection;
  classificationGroupOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  clearanceAssignmentEnabled?: Maybe<Scalars['Boolean']['output']>;
  connections: Array<Connection>;
  /**
   * What the site's connectors list from their providers. A provider resource
   * the last refresh did not see is listed only while an Odin entity of this
   * site is connected to it or staged for it.
   */
  connectorInventory: Array<ConnectorInventoryItem>;
  /** How each of the site's connectors' inventory refreshes have gone, for those that have refreshed. */
  connectorInventoryRefreshes: Array<ConnectorInventoryRefresh>;
  connectors: Array<Connector>;
  dailyAccessReportEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  defaultAccessGroup?: Maybe<AccessGroup>;
  defaultJobsiteContractor?: Maybe<JobsiteContractor>;
  /** Printer ID for jobsite */
  defaultJobsitePrinterId?: Maybe<Scalars['ID']['output']>;
  /** Description of the jobsite */
  description?: Maybe<Scalars['String']['output']>;
  /** The full developer object */
  developer?: Maybe<Developer>;
  deviceStatusChangeEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  documentTypes: JobsiteWorkerDocumentTypesConnection;
  /** End date of the jobsite */
  endDate?: Maybe<Scalars['Date']['output']>;
  escortChangeEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  featuresModule?: Maybe<JobsiteFeaturesModule>;
  /**
   * Whether adding a gateway is closed at the site: site-layout-ui-enabled is
   * on for it, or can't be read, and a person has published a site layout
   * draft there (the initial layout every site was seeded with does not
   * count). Only a flag that reads off reopens adds there. From then on
   * the site's entries own its gateways, and jobsiteUpdate refuses to add one
   * (GATEWAY_ADD_AFTER_SITE_LAYOUT_PUBLISHED).
   */
  gatewayAddsClosed: Scalars['Boolean']['output'];
  hidCardMappingNonUnion?: Maybe<Scalars['String']['output']>;
  hidCardMappingTest?: Maybe<Scalars['String']['output']>;
  hidCardMappingUnion?: Maybe<Scalars['String']['output']>;
  isTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** Jobsite access events for the jobsite */
  jobsiteAccessEvents?: Maybe<JobsiteAccessEventsConnection>;
  /** Jobsite access sessions for the jobsite */
  jobsiteAccessSessions?: Maybe<JobsiteAccessSessionsConnection>;
  jobsiteBadgeTemplates: JobsiteBadgeTemplatesConnection;
  jobsiteCardFormats: JobsiteCardFormatsConnection;
  jobsiteContractors: JobsiteJobsiteContractorsConnection;
  jobsiteCustomWorkerDataFields: JobsiteCustomWorkerDataFieldsConnection;
  jobsiteFormSubmissions: JobsiteFormSubmissionsConnection;
  jobsiteForms: JobsiteFormsConnection;
  jobsiteGateways: JobsiteGatewaysConnection;
  /** Unique indetifier for the jobsite */
  jobsiteId: Scalars['ID']['output'];
  jobsiteMembers: JobsiteJobsiteMembersConnection;
  jobsiteNumber?: Maybe<Scalars['String']['output']>;
  jobsitePrinters: JobsitePrintersConnection;
  jobsiteStats?: Maybe<JobsiteStats>;
  jobsiteWorkers: JobsiteJobsiteWorkersConnection;
  latestZonesModeChange?: Maybe<ZonesModeChange>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maximumSessionLength?: Maybe<Scalars['Duration']['output']>;
  modules?: Maybe<Array<ValidModule>>;
  /** Name of the jobsite */
  name: Scalars['String']['output'];
  /** History of the object */
  objectHistory: ObjectHistory;
  onboardingGracePeriod?: Maybe<Scalars['Duration']['output']>;
  onboardingModule?: Maybe<JobsiteOnboardingModule>;
  parentId?: Maybe<Scalars['ID']['output']>;
  procoreCompanyId?: Maybe<Scalars['String']['output']>;
  procoreProjectId?: Maybe<Scalars['String']['output']>;
  procoreProjectVendors?: Maybe<ProcoreProjectVendorConnection>;
  /** Jobsite profile picture */
  profilePicture?: Maybe<File>;
  pulseVideoFiles: Array<PulseVideoFile>;
  pulseVideos?: Maybe<PulseVideos>;
  /**
   * The reader devices on this site now (those with an open reader here),
   * whether on an access controller port or on none, by name. Read only.
   */
  readerDevices: Array<SiteReaderDevice>;
  rejectedSwipeEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reportingTimeSlot?: Maybe<Scalars['String']['output']>;
  safetyObservationLogEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  schedulerAccount?: Maybe<User>;
  schedules: SchedulesConnection;
  sessionDisplayColumn?: Maybe<SessionDisplayColumns>;
  /**
   * The effective layout: the open published revision. Null until the site's
   * first layout is published.
   */
  siteLayout?: Maybe<SiteLayout>;
  /** The draft layout, while the site has one. */
  siteLayoutDraft?: Maybe<SiteLayout>;
  /** The site's revisions numbered, with the effective revision and the draft, in one read. */
  siteLayoutOverview: SiteLayoutOverview;
  /**
   * The delivery of the site's effective layout to each connector it was
   * requested for. Empty while the site has no published layout; null when
   * it could not be read.
   */
  siteLayoutPublications?: Maybe<Array<SiteLayoutPublication>>;
  /** One of the site's revisions, draft or published, as the history lists it; null for a revision that is not the site's. */
  siteLayoutRevision?: Maybe<SiteLayoutRevision>;
  /** The site's revisions: the draft first, while it has one, then published revisions newest first. */
  siteLayoutRevisions: Array<SiteLayoutRevision>;
  /** The current user's effective permissions at this site; the API checks the same catalog on every request. */
  sitePermissions: Array<SitePermission>;
  siteSafetyLogEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Start date of the jobsite */
  startDate?: Maybe<Scalars['Date']['output']>;
  swipeInactivityThreshold?: Maybe<Scalars['Duration']['output']>;
  tempBadges: TempBadgesConnection;
  templateId?: Maybe<Scalars['ID']['output']>;
  timeSeries: JobsiteTimeSeries;
  timeZone?: Maybe<Scalars['String']['output']>;
  titleOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tradeOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  unionAffiliationOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weather: JobsiteWeatherConnection;
  weeklyAccessReportEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workerAccessEnabled?: Maybe<Scalars['Boolean']['output']>;
  zones: Array<Zone>;
  zonesMode: ZonesMode;
  zonesReadiness: ZonesReadiness;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteAccessGroupsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteCCureClearancesArgs = {
  input?: InputMaybe<JobsiteCCureClearancesInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteCCureEntityMappingsArgs = {
  input?: InputMaybe<JobsiteCCureEntityMappingsInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteDocumentTypesArgs = {
  input?: InputMaybe<JobsiteWorkerDocumentTypesInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteAccessEventsArgs = {
  input?: InputMaybe<JobsiteAccessEventsInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteAccessSessionsArgs = {
  input?: InputMaybe<JobsiteAccessSessionsInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteBadgeTemplatesArgs = {
  input?: InputMaybe<JobsiteBadgeTemplatesInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteCardFormatsArgs = {
  input?: InputMaybe<JobsiteCardFormatsInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteContractorsArgs = {
  input?: InputMaybe<JobsiteJobsiteContractorsInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteCustomWorkerDataFieldsArgs = {
  input?: InputMaybe<JobsiteCustomWorkerDataFieldsInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteFormSubmissionsArgs = {
  input: JobsiteFormSubmissionsInput;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteFormsArgs = {
  input?: InputMaybe<JobsiteFormsInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteGatewaysArgs = {
  input?: InputMaybe<JobsiteGatewaysInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteMembersArgs = {
  input?: InputMaybe<JobsiteJobsiteMembersInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsitePrintersArgs = {
  input?: InputMaybe<JobsitePrintersInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteJobsiteWorkersArgs = {
  input?: InputMaybe<JobsiteJobsiteWorkersInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsitePulseVideosArgs = {
  endTime?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteSchedulesArgs = {
  input?: InputMaybe<SchedulesInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteSiteLayoutRevisionArgs = {
  id: Scalars['ID']['input'];
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteTempBadgesArgs = {
  input?: InputMaybe<TempBadgesInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteTimeSeriesArgs = {
  input?: InputMaybe<JobsiteTimeSeriesInput>;
};

/**
 * Jobsite return type. A jobsite is an individual project within a developmentProject. Smaller sites will have one
 * project per developmentProject, but larger sites may have many projects in a single developmentProject.
 */
export type JobsiteWeatherArgs = {
  input?: InputMaybe<JobsiteWeatherInput>;
};

export type JobsiteAccessEvent = {
  __typename?: 'JobsiteAccessEvent';
  credentialId?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  eventOccurredAt: Scalars['String']['output'];
  eventType?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobsite?: Maybe<Jobsite>;
  jobsiteFormSubmissions: JobsiteFormSubmissionsConnection;
  jobsiteWorker?: Maybe<JobsiteWorker>;
  localizedDate?: Maybe<Scalars['String']['output']>;
  localizedTime?: Maybe<Scalars['String']['output']>;
  locationStatus?: Maybe<JobsiteWorkerCheckInLocationStatus>;
  message: Scalars['String']['output'];
  overnightSession?: Maybe<Scalars['Boolean']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  sessionDate: Scalars['String']['output'];
  status: JobsiteAccessEventStatus;
  timeStamp: Scalars['Date']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  type: JobsiteAccessEventMessageType;
  worker?: Maybe<Worker>;
  zoneCrossing?: Maybe<AccessEventCrossing>;
};

export enum JobsiteAccessEventDirection {
  Inbound = 'inbound',
  Outbound = 'outbound',
}

export enum JobsiteAccessEventMessageType {
  CardAdmitted = 'CardAdmitted',
  CardRejected = 'CardRejected',
}

export enum JobsiteAccessEventRejectionReason {
  AdministrativeAction = 'AdministrativeAction',
  Admit = 'Admit',
  Clearance = 'Clearance',
  Disabled = 'Disabled',
  Expired = 'Expired',
  FacilityCode = 'FacilityCode',
  GapbPassbackCommFailure = 'GAPBPassbackCommFailure',
  IllegalRejectCode = 'IllegalRejectCode',
  JobsiteDoesNotAllowKioskAccessEvents = 'JobsiteDoesNotAllowKioskAccessEvents',
  JobsiteDoesNotAllowMobileAdminCheckIn = 'JobsiteDoesNotAllowMobileAdminCheckIn',
  JobsiteDoesNotAllowMobileBadgeScanning = 'JobsiteDoesNotAllowMobileBadgeScanning',
  JobsiteDoesNotAllowMobileSelfCheckIn = 'JobsiteDoesNotAllowMobileSelfCheckIn',
  Misread = 'Misread',
  NotActivated = 'NotActivated',
  Passback = 'Passback',
  SiteCode = 'SiteCode',
  TimedAntipassback = 'TimedAntipassback',
  UnassignedTempBadge = 'UnassignedTempBadge',
  UnknownCard = 'UnknownCard',
  WorkerNotAllowedOnSite = 'WorkerNotAllowedOnSite',
  WorkerNotAssignedToSite = 'WorkerNotAssignedToSite',
  WorkerNotOnSite = 'WorkerNotOnSite',
}

export enum JobsiteAccessEventStatus {
  Admit = 'Admit',
  Reject = 'Reject',
  Archived = 'archived',
}

export type JobsiteAccessEventsConnection = {
  __typename?: 'JobsiteAccessEventsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteAccessEventsEdge>;
  filtersOptions?: Maybe<JobsiteAccessEventsFilters>;
};

export type JobsiteAccessEventsEdge = {
  __typename?: 'JobsiteAccessEventsEdge';
  node: JobsiteAccessEvent;
};

export type JobsiteAccessEventsFilters = {
  __typename?: 'JobsiteAccessEventsFilters';
  contractors: Array<FilterOption>;
  gateways: Array<FilterOption>;
  jobsites: Array<FilterOption>;
  locationStatuses: Array<Maybe<FilterOption>>;
  rejectionReasons: Array<Maybe<FilterOption>>;
  zones: Array<FilterOption>;
};

export type JobsiteAccessEventsInput = {
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters to access events whose matching check-in was created by
   * one of these user accounts. Events without a matching check-in
   * (e.g. PACS swipes) are excluded when this filter is set.
   */
  createdByIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  direction?: InputMaybe<JobsiteAccessEventDirection>;
  endDateTime: Scalars['Date']['input'];
  gatewayIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The value passed from the client will be ignored when
   * the input is used for jobsite.jobsiteAccessEvents.
   */
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationStatuses?: InputMaybe<Array<JobsiteWorkerCheckInLocationStatus>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  rejectionReasons?: InputMaybe<Array<JobsiteAccessEventRejectionReason>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sessionDate?: InputMaybe<Scalars['String']['input']>;
  startDateTime: Scalars['Date']['input'];
  status?: InputMaybe<JobsiteAccessEventStatus>;
  zoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type JobsiteAccessSession = {
  __typename?: 'JobsiteAccessSession';
  active?: Maybe<Scalars['Boolean']['output']>;
  balanced?: Maybe<Scalars['Boolean']['output']>;
  balancedGrossSpan?: Maybe<Scalars['Int']['output']>;
  compliant?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Date']['output'];
  displayValueSpan?: Maybe<Scalars['Int']['output']>;
  firstDirection?: Maybe<Scalars['String']['output']>;
  firstInboundSwipe?: Maybe<Scalars['Date']['output']>;
  firstOutboundSwipe?: Maybe<Scalars['Date']['output']>;
  firstSwipe?: Maybe<Scalars['Date']['output']>;
  /**
   * Whether the worker has not badged out yet and the session still counts as
   * on site: until the end of its day, or at a site that allows overnight
   * sessions until the maximum session length after the last badge-in before
   * midnight.
   */
  inProgress?: Maybe<Scalars['Boolean']['output']>;
  /** Jobsite access events for the session */
  jobsiteAccessEvents?: Maybe<JobsiteAccessEventsConnection>;
  jobsiteWorker: JobsiteWorker;
  jobsiteWorkerId?: Maybe<Scalars['String']['output']>;
  lastDirection?: Maybe<Scalars['String']['output']>;
  lastInboundSwipe?: Maybe<Scalars['Date']['output']>;
  lastOutboundSwipe?: Maybe<Scalars['Date']['output']>;
  lastSwipe?: Maybe<Scalars['Date']['output']>;
  naiveGrossSpan?: Maybe<Scalars['Int']['output']>;
  netOffsiteSpan?: Maybe<Scalars['Int']['output']>;
  netOnsiteSpan?: Maybe<Scalars['Int']['output']>;
  netTotalSpan?: Maybe<Scalars['Int']['output']>;
  overnightSession?: Maybe<Scalars['Boolean']['output']>;
  proximitySession: ProximitySessionResult;
  reads?: Maybe<Scalars['Int']['output']>;
  readsInbound?: Maybe<Scalars['Int']['output']>;
  readsOutbound?: Maybe<Scalars['Int']['output']>;
  sessionDate?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type JobsiteAccessSessionBreakdown = {
  __typename?: 'JobsiteAccessSessionBreakdown';
  stats?: Maybe<Array<Maybe<BreakdownStat>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<JobsiteAccessSessionBreakdownType>;
};

export enum JobsiteAccessSessionBreakdownType {
  Active = 'Active',
  Age = 'Age',
  Banned = 'Banned',
  Compliant = 'Compliant',
  Contractor = 'Contractor',
  Daily = 'Daily',
  Gender = 'Gender',
  JobTitle = 'JobTitle',
  Jobsite = 'Jobsite',
  Language = 'Language',
  Onboarded = 'Onboarded',
  Overview = 'Overview',
  Race = 'Race',
  Trade = 'Trade',
  Zipcode = 'Zipcode',
}

export type JobsiteAccessSessionEdge = {
  __typename?: 'JobsiteAccessSessionEdge';
  node?: Maybe<JobsiteAccessSession>;
};

export type JobsiteAccessSessionsConnection = {
  __typename?: 'JobsiteAccessSessionsConnection';
  breakdowns?: Maybe<Array<Maybe<JobsiteAccessSessionBreakdown>>>;
  count: Scalars['Int']['output'];
  edges: Array<Maybe<JobsiteAccessSessionEdge>>;
  filtersOptions?: Maybe<JobsiteAccessSessionsFilters>;
};

export type JobsiteAccessSessionsFilters = {
  __typename?: 'JobsiteAccessSessionsFilters';
  contractors: Array<FilterOption>;
  jobsites: Array<FilterOption>;
};

export type JobsiteAccessSessionsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  breakdowns?: InputMaybe<Array<JobsiteAccessSessionBreakdownType>>;
  compliant?: InputMaybe<Scalars['Boolean']['input']>;
  contractor?: InputMaybe<Scalars['String']['input']>;
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['Date']['input'];
  /**
   * true keeps only the sessions in progress (JobsiteAccessSession.inProgress),
   * false leaves them out.
   */
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /**
   * The value passed from the client will be ignored when
   * the input is used for jobsite.jobsiteAccessSessions.
   */
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  startDate: Scalars['Date']['input'];
  trade?: InputMaybe<Scalars['String']['input']>;
  /**
   * The value passed from the client will be ignored when
   * the input is used for worker.jobsiteAccessSessions.
   */
  workerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum JobsiteAccessStatusType {
  AccessAllowed = 'AccessAllowed',
  CurrentlyOnsite = 'CurrentlyOnsite',
  RecentlyOnsite = 'RecentlyOnsite',
}

export type JobsiteAddContractorsInput = {
  contractorIds: Array<Scalars['ID']['input']>;
  jobsiteContractorInput: JobsiteContractorInput;
  jobsiteId: Scalars['ID']['input'];
};

export type JobsiteAddContractorsPayload = {
  __typename?: 'JobsiteAddContractorsPayload';
  jobsiteContractors: Array<JobsiteContractor>;
};

export type JobsiteAddFormInput = {
  formId: Scalars['ID']['input'];
  jobsiteId: Scalars['ID']['input'];
};

export type JobsiteAddFormPayload = {
  __typename?: 'JobsiteAddFormPayload';
  jobsiteForm: JobsiteForm;
};

/** JobsiteAnnouncement return type. */
export type JobsiteAnnouncement = {
  __typename?: 'JobsiteAnnouncement';
  /** Number of days within which worker has been 'active' that the announcement is sent to */
  accessWithinDayRange?: Maybe<Scalars['Int']['output']>;
  /** Type of announcement */
  announcementType: AnnouncementType;
  /**
   * CandidateRecipientsEdge objects that the announcement might be sent to
   * (Not currently implemented: Spec'd for future use with draft announcements)
   */
  candidateRecipientsEdge?: Maybe<JobsiteAnnouncementCandidateRecipientsConnection>;
  /** Contractors used as a filter for where the announcement is sent to */
  contractors: JobsiteAnnouncementContractorsConnection;
  /** Who created the announcement */
  createdBy?: Maybe<User>;
  deliveredCount: Scalars['Int']['output'];
  endAt?: Maybe<Scalars['Date']['output']>;
  /** Attached files for this announcement */
  files: Array<File>;
  isRepeatable?: Maybe<Scalars['Boolean']['output']>;
  /** Jobsite access status that the announcement is sent to */
  jobsiteAccessStatus?: Maybe<JobsiteAccessStatusType>;
  /** Unique identifier for the announcement */
  jobsiteAnnouncementId: Scalars['ID']['output'];
  /** Jobsites used as a filter for where the announcement will be sent to */
  jobsites: JobsiteAnnouncementJobsitesConnection;
  /** Languages used to filter the announcement recipients */
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Message of the announcement */
  message?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<JobsiteAnnouncementMessage>>;
  publishedCount: Scalars['Int']['output'];
  recipients: JobsiteAnnouncementRecipientsConnection;
  repeatableSchedule?: Maybe<Scalars['String']['output']>;
  /** When the announcement was sent */
  sentAt?: Maybe<Scalars['Date']['output']>;
  /** Who sent the announcement */
  sentBy?: Maybe<User>;
  startAt?: Maybe<Scalars['Date']['output']>;
  /** Status of the announcement */
  status?: Maybe<AnnouncementStatus>;
  /** Subject of the announcement */
  subject?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  /** Title identifiers that the announcement is sent to */
  titles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Trade identifiers that the announcement is sent to */
  trades?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** JobsiteAnnouncement return type. */
export type JobsiteAnnouncementContractorsArgs = {
  input?: InputMaybe<JobsiteAnnouncementContractorsInput>;
};

/** JobsiteAnnouncement return type. */
export type JobsiteAnnouncementJobsitesArgs = {
  input?: InputMaybe<JobsiteAnnouncementJobsitesInput>;
};

/** JobsiteAnnouncement return type. */
export type JobsiteAnnouncementRecipientsArgs = {
  input?: InputMaybe<JobsiteAnnouncementRecipientsInput>;
};

export type JobsiteAnnouncementCandidateRecipientEdge = {
  __typename?: 'JobsiteAnnouncementCandidateRecipientEdge';
  node: Worker;
};

export type JobsiteAnnouncementCandidateRecipientsConnection = {
  __typename?: 'JobsiteAnnouncementCandidateRecipientsConnection';
  edges: Array<JobsiteAnnouncementCandidateRecipientEdge>;
  totalCount: Scalars['Int']['output'];
  totalReachableCount: Scalars['Int']['output'];
};

export type JobsiteAnnouncementConnection = {
  __typename?: 'JobsiteAnnouncementConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteAnnouncementEdge>;
};

export type JobsiteAnnouncementContractorsConnection = {
  __typename?: 'JobsiteAnnouncementContractorsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteAnnouncementContractorsEdge>;
};

export type JobsiteAnnouncementContractorsEdge = {
  __typename?: 'JobsiteAnnouncementContractorsEdge';
  node: Contractor;
};

export type JobsiteAnnouncementContractorsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteAnnouncementEdge = {
  __typename?: 'JobsiteAnnouncementEdge';
  node: JobsiteAnnouncement;
};

/** Input for CandidateRecipientsEdge Query */
export type JobsiteAnnouncementFilterSpecification = {
  /** Type of announcement */
  announcementType: AnnouncementType;
  /** Number of days within which worker has been active to send announcement to */
  filterAccessWithinDayRange?: InputMaybe<Scalars['Int']['input']>;
  /** contractorIds to send announcement to */
  filterContractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Jobsite access status to send announcement to */
  filterJobsiteAccessStatus?: InputMaybe<JobsiteAccessStatusType>;
  /** jobsiteIds to send announcement to */
  filterJobsiteIds: Array<Scalars['ID']['input']>;
  /** Language identifiers to filter by */
  filterLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** title identifiers to send announcement to */
  filterTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** trade identifiers to send announcement to */
  filterTrades?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

/** Input for JobsiteAnnouncement Mutations */
export type JobsiteAnnouncementInput = {
  /** Attachments for the announcement */
  files?: InputMaybe<Array<FileChangeInput>>;
  filterSpecification: JobsiteAnnouncementFilterSpecification;
  /** Message of the announcement */
  message?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  /** Status of the announcement */
  status: AnnouncementStatus;
  /** Subject of the announcement */
  subject?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteAnnouncementJobsitesConnection = {
  __typename?: 'JobsiteAnnouncementJobsitesConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteAnnouncementJobsitesEdge>;
};

export type JobsiteAnnouncementJobsitesEdge = {
  __typename?: 'JobsiteAnnouncementJobsitesEdge';
  node: Jobsite;
};

export type JobsiteAnnouncementJobsitesInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteAnnouncementMessage = {
  __typename?: 'JobsiteAnnouncementMessage';
  encoding?: Maybe<Scalars['String']['output']>;
  isSourceLanguage: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  messagePrefix?: Maybe<Scalars['String']['output']>;
  messageType: JobsiteAnnouncementMessageType;
  segments?: Maybe<Scalars['Int']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['Int']['output']>;
  unitsPerSegment?: Maybe<Scalars['Int']['output']>;
};

export enum JobsiteAnnouncementMessageType {
  Email = 'Email',
  Mms = 'Mms',
  Sms = 'Sms',
}

export type JobsiteAnnouncementRecipient = {
  __typename?: 'JobsiteAnnouncementRecipient';
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  languageCode: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  worker: Worker;
};

export type JobsiteAnnouncementRecipientsConnection = {
  __typename?: 'JobsiteAnnouncementRecipientsConnection';
  count: Scalars['Int']['output'];
  deliveredCount: Scalars['Int']['output'];
  edges: Array<JobsiteAnnouncementRecipientsEdge>;
  publishedCount: Scalars['Int']['output'];
};

export type JobsiteAnnouncementRecipientsEdge = {
  __typename?: 'JobsiteAnnouncementRecipientsEdge';
  node: JobsiteAnnouncementRecipient;
};

export type JobsiteAnnouncementRecipientsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteAnnouncementResultSectionData = {
  __typename?: 'JobsiteAnnouncementResultSectionData';
  at?: Maybe<Scalars['String']['output']>;
  workerIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type JobsiteAppCheckInModule = JobsiteModule & {
  __typename?: 'JobsiteAppCheckInModule';
  areas: Array<JobsiteAppCheckInModuleArea>;
  crewGeofencingEnforcementType?: Maybe<GeofencingEnforcementType>;
  geofencingEnforcementType?: Maybe<GeofencingEnforcementType>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type JobsiteAppCheckInModuleArea = JobsiteWorkerCheckInArea & {
  __typename?: 'JobsiteAppCheckInModuleArea';
  checkInCoordinate: GpsCoordinate;
  checkInRadius: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  isInboundEnabled: Scalars['Boolean']['output'];
  isOutboundEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type JobsiteAppCheckInModuleAreaInput = {
  changeType: ChangeType;
  checkInCoordinate: GpsCoordinateInput;
  checkInRadius: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  isInboundEnabled: Scalars['Boolean']['input'];
  isOutboundEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type JobsiteAppCheckInModuleInput = {
  areas?: InputMaybe<Array<JobsiteAppCheckInModuleAreaInput>>;
  crewGeofencingEnforcementType?: InputMaybe<GeofencingEnforcementType>;
  geofencingEnforcementType?: InputMaybe<GeofencingEnforcementType>;
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type JobsiteArchiveFormSubmissionInput = {
  id: Scalars['ID']['input'];
};

export type JobsiteArchiveFormSubmissionPayload = {
  __typename?: 'JobsiteArchiveFormSubmissionPayload';
  success: Success;
};

export type JobsiteArchiveInvitationInput = {
  jobsiteInvitationId: Scalars['ID']['input'];
};

export type JobsiteArchiveInvitationPayload = {
  __typename?: 'JobsiteArchiveInvitationPayload';
  success: Success;
};

export type JobsiteBadgeTemplate = {
  __typename?: 'JobsiteBadgeTemplate';
  badgeTemplate: BadgeTemplate;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  jobsiteId: Scalars['ID']['output'];
};

export type JobsiteBadgeTemplateInput = {
  badgeTemplateId: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type JobsiteBadgeTemplatesConnection = {
  __typename?: 'JobsiteBadgeTemplatesConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteBadgeTemplatesEdge>;
};

export type JobsiteBadgeTemplatesEdge = {
  __typename?: 'JobsiteBadgeTemplatesEdge';
  node: JobsiteBadgeTemplate;
};

export type JobsiteBadgeTemplatesInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteCCureClearanceInput = {
  cCureClearanceId?: InputMaybe<Scalars['ID']['input']>;
  cCureClearanceObjectId: Scalars['Int']['input'];
  cCureEnvironmentId: Scalars['ID']['input'];
  changeType: ChangeType;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isSelectable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type JobsiteCCureClearancesConnection = {
  __typename?: 'JobsiteCCureClearancesConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteCCureClearancesEdge>;
};

export type JobsiteCCureClearancesEdge = {
  __typename?: 'JobsiteCCureClearancesEdge';
  node: CCureClearance;
};

export type JobsiteCCureClearancesInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteCCureEntityMappingInput = {
  entityType: CCureEntityType;
  environmentId: Scalars['ID']['input'];
  objectId: Scalars['Int']['input'];
};

export type JobsiteCCureEntityMappingsConnection = {
  __typename?: 'JobsiteCCureEntityMappingsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteCCureEntityMappingsEdge>;
};

export type JobsiteCCureEntityMappingsEdge = {
  __typename?: 'JobsiteCCureEntityMappingsEdge';
  node: CCureEntityMapping;
};

export type JobsiteCCureEntityMappingsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteCardFormat = {
  __typename?: 'JobsiteCardFormat';
  isDefaultForCardType?: Maybe<WorkerCardType>;
  jobsite: Jobsite;
  jobsiteCardFormatId: Scalars['ID']['output'];
  workerCardFormat: WorkerCardFormat;
};

export type JobsiteCardFormatsConnection = {
  __typename?: 'JobsiteCardFormatsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteCardFormatsEdge>;
};

export type JobsiteCardFormatsEdge = {
  __typename?: 'JobsiteCardFormatsEdge';
  node: JobsiteCardFormat;
};

export type JobsiteCardFormatsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export enum JobsiteClearanceType {
  CCure = 'CCure',
}

export type JobsiteCloseOutInput = {
  endDate: Scalars['Date']['input'];
  jobsiteId: Scalars['ID']['input'];
};

export type JobsiteCloseOutPayload = {
  __typename?: 'JobsiteCloseOutPayload';
  jobsite: Jobsite;
};

export type JobsiteContractor = {
  __typename?: 'JobsiteContractor';
  contact?: Maybe<ContactPerson>;
  /** The full contractor object */
  contractor: Contractor;
  /** End date of contractor at this jobsite/project */
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** The full jobsite object */
  jobsite: Jobsite;
  jobsiteInvitation?: Maybe<JobsiteInvitation>;
  jobsiteWorkers: JobsiteContractorJobsiteWorkersConnection;
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Parent contractor if this is a subContractor */
  parentJobsiteContractor?: Maybe<JobsiteContractor>;
  procoreProjectVendorId?: Maybe<Scalars['String']['output']>;
  /** Roster statistics for a site-local day (today by default). */
  roster: JobsiteContractorRoster;
  /** Start date of contractor at this jobsite/project */
  startDate: Scalars['Date']['output'];
  /** Current workforce and attendance statistics for this contractor on this jobsite. */
  stats: JobsiteContractorStats;
  stripePaymentMethodId?: Maybe<Scalars['ID']['output']>;
  subcontractedJobsiteContractors: SubcontractedJobsiteContractorsConnection;
};

export type JobsiteContractorJobsiteWorkersArgs = {
  input?: InputMaybe<JobsiteContractorJobsiteWorkersInput>;
};

export type JobsiteContractorRosterArgs = {
  onSiteDate?: InputMaybe<Scalars['Date']['input']>;
};

export type JobsiteContractorStatsArgs = {
  input: JobsiteContractorStatsInput;
};

export type JobsiteContractorSubcontractedJobsiteContractorsArgs = {
  input?: InputMaybe<SubcontractedJobsiteContractorsInput>;
};

/** Input for assigning a jobsite to a contractor or updating their info at the contractor */
export type JobsiteContractorInput = {
  contactInput?: InputMaybe<ContactInput>;
  /** End date of contractor at this jobsite/project */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  parentContractorId?: InputMaybe<Scalars['ID']['input']>;
  procoreProjectVendorId?: InputMaybe<Scalars['String']['input']>;
  /** Start date of contractor at this jobsite/project */
  startDate: Scalars['Date']['input'];
};

export type JobsiteContractorJobsiteWorkersConnection = {
  __typename?: 'JobsiteContractorJobsiteWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteContractorJobsiteWorkersEdge>;
};

export type JobsiteContractorJobsiteWorkersEdge = {
  __typename?: 'JobsiteContractorJobsiteWorkersEdge';
  node: JobsiteWorker;
};

export type JobsiteContractorJobsiteWorkersInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteContractorRoster = {
  __typename?: 'JobsiteContractorRoster';
  onSiteDate: Scalars['DateOnly']['output'];
  /** Distinct workers with a session on this day, or still on site now when this day is today; re-entry sessions count once. */
  onSiteWorkerCount: Scalars['Int']['output'];
  /** Attendance takes precedence. Otherwise offboarded means a nonempty crew whose assignments have all ended before this day; empty crews are off site. */
  status: JobsiteContractorRosterStatus;
};

export enum JobsiteContractorRosterOrder {
  NameAsc = 'NAME_ASC',
  OnSiteWorkerCountDesc = 'ON_SITE_WORKER_COUNT_DESC',
}

export enum JobsiteContractorRosterStatus {
  Offboarded = 'OFFBOARDED',
  OffSite = 'OFF_SITE',
  OnSite = 'ON_SITE',
}

export type JobsiteContractorRosterStatusCounts = {
  __typename?: 'JobsiteContractorRosterStatusCounts';
  offSite: Scalars['Int']['output'];
  offboarded: Scalars['Int']['output'];
  onSite: Scalars['Int']['output'];
};

export type JobsiteContractorStats = {
  __typename?: 'JobsiteContractorStats';
  /** Distinct workers whose sessions overlap each hour, including zero buckets. Open sessions end at local midnight or now, whichever is earlier; daylight-saving days have 23 or 25 buckets. */
  hourlyWorkers: Array<TimeSeries>;
  /** Sum of recorded naive gross session seconds divided by 3600, matching dashboard total hours. Includes sessions whose session date is in the inclusive range; missing spans contribute zero. */
  sessionHours: Scalars['Float']['output'];
  /** Current active assignments, independent of the attendance date range. Counts are distinct workers, with missing access records treated as not allowed. */
  workforce: JobsiteContractorWorkforce;
};

export type JobsiteContractorStatsInput = {
  /** Inclusive jobsite-local last date. */
  endDate: Scalars['DateOnly']['input'];
  /** Inclusive jobsite-local first date. The range may contain at most 366 days. */
  startDate: Scalars['DateOnly']['input'];
};

export type JobsiteContractorUpdateStripePaymentMethodInput = {
  jobsiteContractorId: Scalars['ID']['input'];
  stripePaymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};

export type JobsiteContractorUpdateStripePaymentMethodPayload = {
  __typename?: 'JobsiteContractorUpdateStripePaymentMethodPayload';
  success: Success;
};

export type JobsiteContractorWorkforce = {
  __typename?: 'JobsiteContractorWorkforce';
  allowed: Scalars['Int']['output'];
  jobTitles: Array<JobsiteContractorWorkforceFacet>;
  total: Scalars['Int']['output'];
  trades: Array<JobsiteContractorWorkforceFacet>;
};

export type JobsiteContractorWorkforceFacet = {
  __typename?: 'JobsiteContractorWorkforceFacet';
  allowed: Scalars['Int']['output'];
  /** Trimmed trade or job title, or Unspecified for missing values. Workers with multiple assignments can appear in more than one facet. */
  name: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

/** Input for submitting a jobsite form */
export type JobsiteCreateFormSubmissionInput = {
  checkInId?: InputMaybe<Scalars['ID']['input']>;
  documents?: InputMaybe<Array<JobsiteFormSubmissionDocumentInput>>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  extraData?: InputMaybe<Scalars['JSONObject']['input']>;
  /** When provided, this id will be used for the creation of the form submission */
  id?: InputMaybe<Scalars['ID']['input']>;
  jobsiteContractors?: InputMaybe<Array<JobsiteFormSubmissionContractorInput>>;
  jobsiteFormId: Scalars['ID']['input'];
  jobsiteWorkers?: InputMaybe<Array<JobsiteFormSubmissionWorkerInput>>;
  startAt: Scalars['Date']['input'];
};

export type JobsiteCreateFormSubmissionPayload = {
  __typename?: 'JobsiteCreateFormSubmissionPayload';
  jobsiteFormSubmission: JobsiteFormSubmission;
};

/** Input for Jobsite Mutations */
export type JobsiteCreateInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<StateAbbreviation>;
  addressZipCode?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developerId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteNumber?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteCreateInvitationInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  jobsiteContractorId: Scalars['ID']['input'];
};

export type JobsiteCreateInvitationPayload = {
  __typename?: 'JobsiteCreateInvitationPayload';
  jobsiteInvitation: JobsiteInvitation;
};

export type JobsiteCreatePayload = {
  __typename?: 'JobsiteCreatePayload';
  jobsite: Jobsite;
};

export type JobsiteCustomWorkerDataField = {
  __typename?: 'JobsiteCustomWorkerDataField';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fieldDataType: Scalars['String']['output'];
  fieldLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validationMessage?: Maybe<Scalars['String']['output']>;
  validationRegex?: Maybe<Scalars['String']['output']>;
};

export type JobsiteCustomWorkerDataFieldInput = {
  changeType: ChangeType;
  fieldDataType: Scalars['String']['input'];
  fieldLabel: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  validationMessage?: InputMaybe<Scalars['String']['input']>;
  validationRegex?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteCustomWorkerDataFieldsConnection = {
  __typename?: 'JobsiteCustomWorkerDataFieldsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteCustomWorkerDataFieldsEdge>;
};

export type JobsiteCustomWorkerDataFieldsEdge = {
  __typename?: 'JobsiteCustomWorkerDataFieldsEdge';
  node: JobsiteCustomWorkerDataField;
};

export type JobsiteCustomWorkerDataFieldsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteEquipmentData = {
  __typename?: 'JobsiteEquipmentData';
  description: Scalars['String']['output'];
  guid: Scalars['ID']['output'];
  instanceSlug: Scalars['String']['output'];
  jobsite: Jobsite;
  lastOfflineDate?: Maybe<Scalars['Date']['output']>;
  lastOnlineDate?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  status: JobsiteEquipmentStatusType;
  type: Scalars['String']['output'];
};

export type JobsiteEquipmentEvent = {
  __typename?: 'JobsiteEquipmentEvent';
  deviceDescription: Scalars['String']['output'];
  deviceGuid: Scalars['ID']['output'];
  deviceName: Scalars['String']['output'];
  deviceStatus: JobsiteEquipmentStatusType;
  deviceType: Scalars['String']['output'];
  eventDate: Scalars['Date']['output'];
  instanceSlug: Scalars['String']['output'];
  jobsiteId: Scalars['ID']['output'];
};

export enum JobsiteEquipmentStatusType {
  Offline = 'Offline',
  Online = 'Online',
}

export type JobsiteFeaturesModule = JobsiteModule & {
  __typename?: 'JobsiteFeaturesModule';
  addWorkersToDailyLog?: Maybe<Scalars['Boolean']['output']>;
  announcementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  archivingAccessEventsEnabled?: Maybe<Scalars['Boolean']['output']>;
  doNotAllowToSkipSelfOnboardingSteps?: Maybe<Scalars['Boolean']['output']>;
  enforceValidContractorInSelfOnboarding?: Maybe<Scalars['Boolean']['output']>;
  formsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  schedulingEnabled?: Maybe<Scalars['Boolean']['output']>;
  selfOnboardingAutoCompleteEnabled?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  workerAppAdminCheckInEnabled?: Maybe<Scalars['Boolean']['output']>;
  workerAppBadgeScanningEnabled?: Maybe<Scalars['Boolean']['output']>;
  workerAppEnabled?: Maybe<Scalars['Boolean']['output']>;
  workerAppKioskCheckInEnabled?: Maybe<Scalars['Boolean']['output']>;
  workerAppKioskFrontCameraEnabled?: Maybe<Scalars['Boolean']['output']>;
  workerAppSelfCheckInEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type JobsiteFeaturesModuleInput = {
  addWorkersToDailyLog?: InputMaybe<Scalars['Boolean']['input']>;
  announcementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  archivingAccessEventsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  doNotAllowToSkipSelfOnboardingSteps?: InputMaybe<Scalars['Boolean']['input']>;
  enforceValidContractorInSelfOnboarding?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  formsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedulingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  selfOnboardingAutoCompleteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  workerAppAdminCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workerAppBadgeScanningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workerAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workerAppKioskCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workerAppKioskFrontCameraEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workerAppSelfCheckInEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobsiteForm = {
  __typename?: 'JobsiteForm';
  /**
   * Deprecated back-compat flag for the mobile app: true when the form is auto-assigned via any
   * auto-create trigger (derived from autoCreateTrigger, not stored). New clients should read
   * autoCreateTrigger instead.
   * @deprecated Use autoCreateTrigger instead. Retained only for older mobile-app builds that still read this field; will be removed once the mobile app no longer depends on it.
   */
  autoCreateOnCheckout: Scalars['Boolean']['output'];
  autoCreateTrigger?: Maybe<JobsiteFormAutoCreateTrigger>;
  form: Form;
  id: Scalars['ID']['output'];
  jobsite: Jobsite;
  /** History of the object */
  objectHistory: ObjectHistory;
  sessionAssignment?: Maybe<JobsiteFormSessionAssignment>;
};

/**
 * When an auto-assigned jobsite form is delivered to a worker.
 * following_exit: reactive, created when the worker's access session closes (on exit).
 * morning_after_any_activity: scheduled, created the morning after the worker had any jobsite activity the prior day.
 * Null means the form is not auto-assigned. The two values are mutually exclusive per
 * jobsite form. See ADR 0011.
 */
export enum JobsiteFormAutoCreateTrigger {
  FollowingExit = 'following_exit',
  MorningAfterAnyActivity = 'morning_after_any_activity',
}

export type JobsiteFormInput = {
  autoCreateTrigger?: InputMaybe<JobsiteFormAutoCreateTrigger>;
  changeType: ChangeType;
  formId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  sessionAssignment?: InputMaybe<JobsiteFormSessionAssignment>;
};

export enum JobsiteFormSessionAssignment {
  Optional = 'optional',
  Required = 'required',
}

export enum JobsiteFormSessionAssignmentFilter {
  All = 'all',
  Optional = 'optional',
  Required = 'required',
}

export type JobsiteFormSubmission = {
  __typename?: 'JobsiteFormSubmission';
  availableWorkers: JobsiteFormSubmissionAvailableWorkersConnection;
  checkInId?: Maybe<Scalars['ID']['output']>;
  checkOutId?: Maybe<Scalars['ID']['output']>;
  documents: JobsiteFormSubmissionDocumentsConnection;
  endAt?: Maybe<Scalars['Date']['output']>;
  extraData?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  isStartTimeSpecified: Scalars['Boolean']['output'];
  jobsiteContractors: JobsiteFormSubmissionContractorsConnection;
  jobsiteForm: JobsiteForm;
  jobsiteWorkers: JobsiteFormSubmissionWorkersConnection;
  notifiedAt?: Maybe<Scalars['Date']['output']>;
  /** History of the object */
  objectHistory: ObjectHistory;
  onClockRequirementStatus?: Maybe<OnClockRequirementStatus>;
  startAt?: Maybe<Scalars['Date']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  weatherConditions?: Maybe<Array<WeatherConditions>>;
};

export type JobsiteFormSubmissionAvailableWorkersArgs = {
  input?: InputMaybe<JobsiteFormSubmissionAvailableWorkersInput>;
};

export type JobsiteFormSubmissionDocumentsArgs = {
  input?: InputMaybe<JobsiteFormSubmissionDocumentsInput>;
};

export type JobsiteFormSubmissionJobsiteContractorsArgs = {
  input?: InputMaybe<JobsiteFormSubmissionContractorsInput>;
};

export type JobsiteFormSubmissionJobsiteWorkersArgs = {
  input?: InputMaybe<JobsiteFormSubmissionWorkersInput>;
};

export type JobsiteFormSubmissionAvailableWorkerEdge = {
  __typename?: 'JobsiteFormSubmissionAvailableWorkerEdge';
  node: Worker;
};

export type JobsiteFormSubmissionAvailableWorkersConnection = {
  __typename?: 'JobsiteFormSubmissionAvailableWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteFormSubmissionAvailableWorkerEdge>;
};

export type JobsiteFormSubmissionAvailableWorkersInput = {
  /** Worker.workerId values left out of the results and the count */
  excludedWorkerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeSiblingJobsites?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteFormSubmissionContractor = {
  __typename?: 'JobsiteFormSubmissionContractor';
  associationType: Scalars['String']['output'];
  extraData?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  jobsiteContractor: JobsiteContractor;
};

export type JobsiteFormSubmissionContractorInput = {
  associationType: Scalars['String']['input'];
  changeType: ChangeType;
  extraData?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobsiteContractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type JobsiteFormSubmissionContractorsConnection = {
  __typename?: 'JobsiteFormSubmissionContractorsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteFormSubmissionContractorsEdge>;
};

export type JobsiteFormSubmissionContractorsEdge = {
  __typename?: 'JobsiteFormSubmissionContractorsEdge';
  node: JobsiteFormSubmissionContractor;
};

export type JobsiteFormSubmissionContractorsInput = {
  associationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteFormSubmissionDocument = {
  __typename?: 'JobsiteFormSubmissionDocument';
  associationType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  id: Scalars['ID']['output'];
  jobsiteFormSubmission: JobsiteFormSubmission;
  objectHistory: ObjectHistory;
};

export type JobsiteFormSubmissionDocumentInput = {
  associationType?: InputMaybe<Scalars['String']['input']>;
  changeType: ChangeType;
  description?: InputMaybe<Scalars['String']['input']>;
  extraData?: InputMaybe<Scalars['JSONObject']['input']>;
  files?: InputMaybe<Array<FileChangeInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type JobsiteFormSubmissionDocumentsConnection = {
  __typename?: 'JobsiteFormSubmissionDocumentsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteFormSubmissionDocumentsEdge>;
};

export type JobsiteFormSubmissionDocumentsEdge = {
  __typename?: 'JobsiteFormSubmissionDocumentsEdge';
  node: JobsiteFormSubmissionDocument;
};

export type JobsiteFormSubmissionDocumentsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteFormSubmissionWorker = {
  __typename?: 'JobsiteFormSubmissionWorker';
  associationType: Scalars['String']['output'];
  extraData?: Maybe<Scalars['JSONObject']['output']>;
  historicalData: JobsiteFormSubmissionWorkerHistoricalData;
  id: Scalars['ID']['output'];
  jobsiteWorker: JobsiteWorker;
  objectHistory: ObjectHistory;
};

export type JobsiteFormSubmissionWorkerHistoricalData = {
  __typename?: 'JobsiteFormSubmissionWorkerHistoricalData';
  jobsiteWorkerAccess?: Maybe<JobsiteWorkerAccess>;
};

export type JobsiteFormSubmissionWorkerInput = {
  associationType: Scalars['String']['input'];
  changeType: ChangeType;
  extraData?: InputMaybe<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobsiteWorkerId?: InputMaybe<Scalars['ID']['input']>;
};

export type JobsiteFormSubmissionWorkersConnection = {
  __typename?: 'JobsiteFormSubmissionWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteFormSubmissionWorkersEdge>;
};

export type JobsiteFormSubmissionWorkersEdge = {
  __typename?: 'JobsiteFormSubmissionWorkersEdge';
  node: JobsiteFormSubmissionWorker;
};

export type JobsiteFormSubmissionWorkersInput = {
  associationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  reverseChronological?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobsiteFormSubmissionsConnection = {
  __typename?: 'JobsiteFormSubmissionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteFormSubmissionsEdge>;
  filtersOptions?: Maybe<JobsiteFormSubmissionsFilters>;
};

export type JobsiteFormSubmissionsEdge = {
  __typename?: 'JobsiteFormSubmissionsEdge';
  node: JobsiteFormSubmission;
};

export type JobsiteFormSubmissionsFilters = {
  __typename?: 'JobsiteFormSubmissionsFilters';
  contractors: Array<FilterOption>;
  createdByUsers: Array<FilterOption>;
  forms: Array<FilterOption>;
  workers: Array<FilterOption>;
};

export type JobsiteFormSubmissionsInput = {
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  endDate: Scalars['Date']['input'];
  formIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  formKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAttachments?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The value passed from the client will be ignored when
   * the input is used for jobsite.jobsiteFormSubmissions.
   */
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<Array<GetJobsiteFormSubmissionsOrderBy>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  responses?: InputMaybe<Array<WorkerResponseFilter>>;
  startDate: Scalars['Date']['input'];
  /** Values of extra_data.training to match, for logs that record a training. */
  trainings?: InputMaybe<Array<Scalars['String']['input']>>;
  workerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type JobsiteFormsConnection = {
  __typename?: 'JobsiteFormsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteFormsEdge>;
};

export type JobsiteFormsEdge = {
  __typename?: 'JobsiteFormsEdge';
  node: JobsiteForm;
};

export type JobsiteFormsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  withSessionAssignment?: InputMaybe<JobsiteFormSessionAssignmentFilter>;
};

export type JobsiteGateway = {
  __typename?: 'JobsiteGateway';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type JobsiteGatewayInput = {
  changeType: ChangeType;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type JobsiteGatewaysConnection = {
  __typename?: 'JobsiteGatewaysConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteGatewaysEdge>;
};

export type JobsiteGatewaysEdge = {
  __typename?: 'JobsiteGatewaysEdge';
  node: JobsiteGateway;
};

export type JobsiteGatewaysInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteInvitation = {
  __typename?: 'JobsiteInvitation';
  createdBy: User;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  /** Whether the expiration date has begun in the site's timezone; false when no expiration is set. Independent of archive status. */
  isExpired: Scalars['Boolean']['output'];
  jobsiteContractor: JobsiteContractor;
  jobsiteInvitationId: Scalars['ID']['output'];
  /** Server-configured self-onboarding URL; null for archived or expired invitations. */
  url?: Maybe<Scalars['String']['output']>;
};

export type JobsiteJobsiteContractorsConnection = {
  __typename?: 'JobsiteJobsiteContractorsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteJobsiteContractorsEdge>;
  /** Counts for input.onSiteDate (today at the site by default), ignoring rosterStatus and pagination but honoring the other filters. */
  rosterStatusCounts: JobsiteContractorRosterStatusCounts;
};

export type JobsiteJobsiteContractorsEdge = {
  __typename?: 'JobsiteJobsiteContractorsEdge';
  node: JobsiteContractor;
  /** Roster statistics for the connection's onSiteDate. */
  roster: JobsiteContractorRoster;
};

export type JobsiteJobsiteContractorsInput = {
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  onSiteDate?: InputMaybe<Scalars['Date']['input']>;
  /** Roster queries default to descending on-site worker count, then name and id. */
  orderBy?: InputMaybe<JobsiteContractorRosterOrder>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  procoreLinked?: InputMaybe<Scalars['Boolean']['input']>;
  rosterStatus?: InputMaybe<JobsiteContractorRosterStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteJobsiteMembersConnection = {
  __typename?: 'JobsiteJobsiteMembersConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteJobsiteMembersEdge>;
};

export type JobsiteJobsiteMembersEdge = {
  __typename?: 'JobsiteJobsiteMembersEdge';
  node: JobsiteMember;
};

export type JobsiteJobsiteMembersInput = {
  orderBy?: InputMaybe<Array<InputMaybe<GetUsersOrderBy>>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteJobsiteWorkersConnection = {
  __typename?: 'JobsiteJobsiteWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteJobsiteWorkersEdge>;
  /** Assignment counts per access status and presence for the same site, search, contractor, trade and title scope. Access counts honor onSiteNow and presence counts honor accessStatuses, so each facet ignores only its own filter. Ignores pagination. Null on the roster path, taken when rosterStatus is set or rosterStatusCounts is selected. */
  facetCounts?: Maybe<JobsiteWorkerFacetCounts>;
  /** Distinct worker counts for onSiteDate (today at the jobsite by default). Ignores rosterStatus and pagination; honors search, contractors, trades and job titles. On-site attendance can overlap current onboarding or not-allowed status. For today, on site means an active session now; a past day counts any session that day. */
  rosterStatusCounts: JobsiteWorkerRosterStatusCounts;
};

export type JobsiteJobsiteWorkersEdge = {
  __typename?: 'JobsiteJobsiteWorkersEdge';
  node: JobsiteWorker;
};

export type JobsiteJobsiteWorkersInput = {
  /** Keeps assignments whose access status is one of these. Ignored on the roster path, taken when rosterStatus is set or rosterStatusCounts is selected. */
  accessStatuses?: InputMaybe<Array<JobsiteWorkerAccessStatus>>;
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  onSite?: InputMaybe<Scalars['Boolean']['input']>;
  onSiteDate?: InputMaybe<Scalars['Date']['input']>;
  /** true keeps assignments whose worker has an active session at the site now, false keeps the rest. Ignored on the roster path, taken when rosterStatus is set or rosterStatusCounts is selected. */
  onSiteNow?: InputMaybe<Scalars['Boolean']['input']>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  /** Filters distinct workers before pagination. Takes precedence over onSite. Attendance is evaluated for onSiteDate: an active session now when that is today, any session that day otherwise; access and onboarding reflect current state. */
  rosterStatus?: InputMaybe<JobsiteWorkerRosterStatus>;
  search?: InputMaybe<Scalars['String']['input']>;
  trades?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * JobsiteMember return type. A member is any non-worker who is employed by the jobsite, such as an owner,
 * manager, or back office employee.
 */
export type JobsiteMember = {
  __typename?: 'JobsiteMember';
  id: Scalars['ID']['output'];
  /** The full jobsite object that the member is at */
  jobsite: Jobsite;
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Title of the member at the jobsite. */
  title?: Maybe<Scalars['String']['output']>;
  /** The full user object of the member */
  user: User;
};

export type JobsiteModule = {
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum JobsiteModuleType {
  JobsiteAppCheckInModule = 'JobsiteAppCheckInModule',
  JobsiteFeaturesModule = 'JobsiteFeaturesModule',
  JobsiteOnboardingModule = 'JobsiteOnboardingModule',
  JobsitePreOnboardingModule = 'JobsitePreOnboardingModule',
}

export type JobsiteOffboardContractorInput = {
  jobsiteContractorId: Scalars['ID']['input'];
};

export type JobsiteOffboardContractorPayload = {
  __typename?: 'JobsiteOffboardContractorPayload';
  success: Success;
};

export type JobsiteOnboardingDocument = {
  __typename?: 'JobsiteOnboardingDocument';
  expiration?: Maybe<Scalars['Duration']['output']>;
  fields?: Maybe<Array<JobsiteOnboardingField>>;
  gracePeriod?: Maybe<Scalars['Duration']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  /** It corresponds to the JobsiteWorkerDocumentType key */
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The worker document type key associated with this onboarding document.
   * It is specified only for multi-instance document types;
   * for single-instance document types it is the same as key.
   */
  workerDocTypeKey?: Maybe<Scalars['String']['output']>;
};

export type JobsiteOnboardingDocumentFileInput = {
  docTypeKey: Scalars['String']['input'];
  files: Array<FileChangeInput>;
};

export type JobsiteOnboardingDocumentInput = {
  changeType?: InputMaybe<ChangeType>;
  expiration?: InputMaybe<Scalars['Duration']['input']>;
  fields?: InputMaybe<Array<JobsiteOnboardingFieldInput>>;
  gracePeriod?: InputMaybe<Scalars['Duration']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  workerDocTypeKey?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteOnboardingField = {
  __typename?: 'JobsiteOnboardingField';
  index?: Maybe<Scalars['Int']['output']>;
  isEnforced?: Maybe<Scalars['Boolean']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type JobsiteOnboardingFieldInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  isEnforced?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type JobsiteOnboardingModule = JobsiteModule & {
  __typename?: 'JobsiteOnboardingModule';
  badgeAssignmentAllowed?: Maybe<Scalars['Boolean']['output']>;
  badgePrintingAllowed?: Maybe<Scalars['Boolean']['output']>;
  documents?: Maybe<Array<JobsiteOnboardingDocument>>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  steps?: Maybe<Array<JobsiteOnboardingStep>>;
};

export type JobsiteOnboardingModuleInput = {
  badgeAssignmentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  badgePrintingAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  documents?: InputMaybe<Array<JobsiteOnboardingDocumentInput>>;
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  steps?: InputMaybe<Array<JobsiteOnboardingStepInput>>;
};

export type JobsiteOnboardingStep = {
  __typename?: 'JobsiteOnboardingStep';
  fields?: Maybe<Array<JobsiteOnboardingField>>;
  index?: Maybe<Scalars['Int']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type JobsiteOnboardingStepInput = {
  fields?: InputMaybe<Array<JobsiteOnboardingFieldInput>>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type JobsitePacsGateway = {
  __typename?: 'JobsitePacsGateway';
  id: Scalars['ID']['output'];
  jobsite: Jobsite;
  name: Scalars['String']['output'];
};

export type JobsitePreOnboardingField = {
  __typename?: 'JobsitePreOnboardingField';
  index?: Maybe<Scalars['Int']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type JobsitePreOnboardingFieldInput = {
  index?: InputMaybe<Scalars['Int']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type JobsitePreOnboardingModule = JobsiteModule & {
  __typename?: 'JobsitePreOnboardingModule';
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  steps?: Maybe<Array<JobsitePreOnboardingStep>>;
};

export type JobsitePreOnboardingModuleInput = {
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  steps?: InputMaybe<Array<JobsitePreOnboardingStepInput>>;
};

export type JobsitePreOnboardingStep = {
  __typename?: 'JobsitePreOnboardingStep';
  fields?: Maybe<Array<JobsitePreOnboardingField>>;
  index?: Maybe<Scalars['Int']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type JobsitePreOnboardingStepInput = {
  fields?: InputMaybe<Array<JobsitePreOnboardingFieldInput>>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type JobsitePrinter = {
  __typename?: 'JobsitePrinter';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fargoLocationId?: Maybe<Scalars['String']['output']>;
  fargoOrganizationId?: Maybe<Scalars['String']['output']>;
  hidPrinterId?: Maybe<Scalars['String']['output']>;
  hidProxyInstance?: Maybe<HidProxyInstance>;
  id: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type JobsitePrinterInput = {
  changeType: ChangeType;
  fargoLocationId?: InputMaybe<Scalars['String']['input']>;
  fargoOrganizationId?: InputMaybe<Scalars['String']['input']>;
  hidPrinterId?: InputMaybe<Scalars['String']['input']>;
  hidProxyInstance?: InputMaybe<HidProxyInstance>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type JobsitePrintersConnection = {
  __typename?: 'JobsitePrintersConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsitePrintersEdge>;
};

export type JobsitePrintersEdge = {
  __typename?: 'JobsitePrintersEdge';
  node: JobsitePrinter;
};

export type JobsitePrintersInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteReinstateContractorInput = {
  jobsiteContractorId: Scalars['ID']['input'];
};

export type JobsiteReinstateContractorPayload = {
  __typename?: 'JobsiteReinstateContractorPayload';
  success: Success;
};

export type JobsiteRemoveContractorInput = {
  jobsiteContractorId: Scalars['ID']['input'];
};

export type JobsiteRemoveContractorPayload = {
  __typename?: 'JobsiteRemoveContractorPayload';
  success: Success;
};

export type JobsiteRemoveFormInput = {
  jobsiteFormId: Scalars['ID']['input'];
};

export type JobsiteRemoveFormPayload = {
  __typename?: 'JobsiteRemoveFormPayload';
  success: Success;
};

export type JobsiteStats = {
  __typename?: 'JobsiteStats';
  jobsite?: Maybe<Jobsite>;
  numberOfActiveContractors?: Maybe<Scalars['Int']['output']>;
  numberOfActiveWorkers?: Maybe<Scalars['Int']['output']>;
  numberOfOnSiteContractors?: Maybe<Scalars['Int']['output']>;
  numberOfOnSiteWorkers?: Maybe<Scalars['Int']['output']>;
  numberOfOrientationWorkersCompleted?: Maybe<Scalars['Int']['output']>;
  numberOfOrientationWorkersInProgress?: Maybe<Scalars['Int']['output']>;
  numberOfOrientationWorkersNeedingBadging?: Maybe<Scalars['Int']['output']>;
  numberOfOrientationWorkersNeedingMedical?: Maybe<Scalars['Int']['output']>;
  numberOfOrientationWorkersSelfOnboarding?: Maybe<Scalars['Int']['output']>;
  numberOfOrientationWorkersTotal?: Maybe<Scalars['Int']['output']>;
  numberOfWorkers?: Maybe<Scalars['Int']['output']>;
};

export type JobsiteTimeSeries = {
  __typename?: 'JobsiteTimeSeries';
  contractorSessions?: Maybe<Array<TimeSeries>>;
  inboundAccessEvents?: Maybe<Array<TimeSeries>>;
  /** Contractor equivalent of nowBoundedSessions. */
  nowBoundedContractorSessions?: Maybe<Array<TimeSeries>>;
  /**
   * Worker session buckets bounded to the present moment (open sessions never
   * extend into the future) and aligned to the bucket's start hour in the
   * jobsite time zone. Powers the Jobsite Overview dashboard. Distinct from
   * `sessions`, which other consumers still rely on.
   */
  nowBoundedSessions?: Maybe<Array<TimeSeries>>;
  outboundAccessEvents?: Maybe<Array<TimeSeries>>;
  sessions?: Maybe<Array<TimeSeries>>;
};

export type JobsiteTimeSeriesInput = {
  endDateTime: Scalars['Date']['input'];
  interval?: InputMaybe<TimeSeriesInputInterval>;
  startDateTime: Scalars['Date']['input'];
};

export type JobsiteUpdateContractorInput = {
  jobsiteContractorId: Scalars['ID']['input'];
  jobsiteContractorInput: JobsiteContractorInput;
};

export type JobsiteUpdateContractorPayload = {
  __typename?: 'JobsiteUpdateContractorPayload';
  jobsiteContractor: JobsiteContractor;
};

/** Input for updating a jobsite form submission */
export type JobsiteUpdateFormSubmissionInput = {
  documents?: InputMaybe<Array<JobsiteFormSubmissionDocumentInput>>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  extraData?: InputMaybe<Scalars['JSONObject']['input']>;
  id: Scalars['ID']['input'];
  jobsiteContractors?: InputMaybe<Array<JobsiteFormSubmissionContractorInput>>;
  jobsiteWorkers?: InputMaybe<Array<JobsiteFormSubmissionWorkerInput>>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};

export type JobsiteUpdateFormSubmissionPayload = {
  __typename?: 'JobsiteUpdateFormSubmissionPayload';
  jobsiteFormSubmission: JobsiteFormSubmission;
};

/** Input to update a jobsite */
export type JobsiteUpdateInput = {
  accessChangeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  activityCodeOptions?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<StateAbbreviation>;
  addressZipCode?: InputMaybe<Scalars['String']['input']>;
  allowOvernightSessions?: InputMaybe<Scalars['Boolean']['input']>;
  appCheckInModule?: InputMaybe<JobsiteAppCheckInModuleInput>;
  assignmentChangeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  avigilonCameraEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  avigilonEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  cCureClearances?: InputMaybe<Array<JobsiteCCureClearanceInput>>;
  cCureEntityMappings?: InputMaybe<Array<JobsiteCCureEntityMappingInput>>;
  classificationGroupOptions?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  dailyAccessReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  defaultJobsitePrinterId?: InputMaybe<Scalars['String']['input']>;
  defaultProximityCardId?: InputMaybe<Scalars['ID']['input']>;
  defaultQrCodeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developerId?: InputMaybe<Scalars['ID']['input']>;
  deviceStatusChangeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  escortChangeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  featuresModule?: InputMaybe<JobsiteFeaturesModuleInput>;
  hidCardMappingTest?: InputMaybe<Scalars['String']['input']>;
  hidCardMappingUnion?: InputMaybe<Scalars['String']['input']>;
  hideFromContractorUsers?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteBadgeTemplateInputs?: InputMaybe<Array<JobsiteBadgeTemplateInput>>;
  jobsiteCustomWorkerDataFields?: InputMaybe<
    Array<JobsiteCustomWorkerDataFieldInput>
  >;
  jobsiteForms?: InputMaybe<Array<JobsiteFormInput>>;
  jobsiteGateways?: InputMaybe<Array<JobsiteGatewayInput>>;
  jobsiteId: Scalars['ID']['input'];
  jobsiteNumber?: InputMaybe<Scalars['String']['input']>;
  jobsitePrinters?: InputMaybe<Array<JobsitePrinterInput>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maximumSessionLength?: InputMaybe<Scalars['Duration']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingDocumentFiles?: InputMaybe<
    Array<JobsiteOnboardingDocumentFileInput>
  >;
  onboardingGracePeriod?: InputMaybe<Scalars['Duration']['input']>;
  onboardingModule?: InputMaybe<JobsiteOnboardingModuleInput>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  preOnboardingModule?: InputMaybe<JobsitePreOnboardingModuleInput>;
  procoreCompanyId?: InputMaybe<Scalars['String']['input']>;
  procoreProjectId?: InputMaybe<Scalars['String']['input']>;
  profilePictureFileInput?: InputMaybe<FileInput>;
  rejectedSwipeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  reportingTimeSlot?: InputMaybe<Scalars['String']['input']>;
  safetyObservationLogEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  schedulerAccountId?: InputMaybe<Scalars['ID']['input']>;
  sessionDisplayColumn?: InputMaybe<SessionDisplayColumns>;
  siteSafetyLogEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  supportedCardFormatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  swipeInactivityThreshold?: InputMaybe<Scalars['Duration']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  titleOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tradeOptions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unionAffiliationOptions?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>>
  >;
  weeklyAccessReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type JobsiteUpdatePayload = {
  __typename?: 'JobsiteUpdatePayload';
  jobsite: Jobsite;
};

export type JobsiteWeatherConnection = {
  __typename?: 'JobsiteWeatherConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteWeatherEntryEdge>;
};

export type JobsiteWeatherEntry = {
  __typename?: 'JobsiteWeatherEntry';
  createdAt: Scalars['Date']['output'];
  date: Scalars['DateOnly']['output'];
  id: Scalars['ID']['output'];
  weatherConditions?: Maybe<Array<WeatherConditions>>;
};

export type JobsiteWeatherEntryEdge = {
  __typename?: 'JobsiteWeatherEntryEdge';
  node: JobsiteWeatherEntry;
};

export type JobsiteWeatherInput = {
  /**
   * This flag is used to determine whether to create a weather entry if one doesn't exist for the provided date.
   * It is only applicable when a single date is provided in the 'dates' field.
   */
  createIfNotExists?: InputMaybe<Scalars['Boolean']['input']>;
  dates?: InputMaybe<Array<Scalars['DateOnly']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

/**
 * JobsiteWorker return type. A worker is any non-worker who is employed by the jobsite, such as an owner,
 * manager, or back office employee.
 */
export type JobsiteWorker = {
  __typename?: 'JobsiteWorker';
  accessGroupMemberships: Array<AccessGroupMembership>;
  activeTempWorkerCard?: Maybe<WorkerCard>;
  /** Completion of badging */
  badgingCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** Reason for skipping badging */
  badgingSkipReason?: Maybe<Scalars['String']['output']>;
  /** The reason the worker is banned from the jobsite */
  banCategory?: Maybe<Scalars['String']['output']>;
  /** When the temp ban is set to expire */
  banExpiresAt?: Maybe<Scalars['Date']['output']>;
  banRemovedReason?: Maybe<Scalars['String']['output']>;
  /** When the worker was banned from the jobsite */
  bannedAt?: Maybe<Scalars['Date']['output']>;
  /** Notes regarding why the worker is banned from the jobsite */
  bannedReason?: Maybe<Scalars['String']['output']>;
  breathTestConditionalPassExpiresAt?: Maybe<Scalars['Date']['output']>;
  breathTestLastTakenAt?: Maybe<Scalars['Date']['output']>;
  breathTestStatus?: Maybe<JobsiteWorkerTestStatus>;
  /** Classification group of the worker */
  classificationGroup?: Maybe<Scalars['String']['output']>;
  clearanceAssignments?: Maybe<JobsiteWorkerClearanceAssignmentsConnection>;
  contractorWorker: ContractorWorker;
  currentAccess: JobsiteWorkerCurrentAccess;
  /** Custom worker data collected for this jobsite */
  customWorkerData?: Maybe<Scalars['JSONObject']['output']>;
  documentExemptionReason?: Maybe<Scalars['String']['output']>;
  documents: JobsiteWorkerDocumentsConnection;
  /** DateTime jobsite worker documents signed/uploaded */
  documentsCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** Date that reason for skipping documents expires */
  documentsCompletedSkipExpiresAt?: Maybe<Scalars['Date']['output']>;
  /** Reason for skipping documents signing */
  documentsCompletedSkipReason?: Maybe<Scalars['String']['output']>;
  /** When the worker stops working at the site */
  endDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Whether escort privileges are enabled for this jobsite assignment.
   * Uses the same stored value as isAntipassbackExempt; null means no value is recorded.
   */
  hasEscortPrivileges?: Maybe<Scalars['Boolean']['output']>;
  isAntipassbackExempt?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate whether the worker is banned from the jobsite */
  isBanned?: Maybe<Scalars['Boolean']['output']>;
  isExemptFromSiteSpecificRefresher?: Maybe<Scalars['Boolean']['output']>;
  isExemptFromSwipeInactivity?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this assignment's end date has passed, evaluated server-side so clients never
   * compare endDate to their own clock. The same rule writes the "offboarded on" reason into
   * currentAccess.notAllowedReason.
   */
  isOffboarded?: Maybe<Scalars['Boolean']['output']>;
  isOnSite?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the worker has an active access session at this site right now (same rule as the
   * roster's ON_SITE for today). Unlike isOnSite it is resolved on every query and never reflects
   * a form submission's onSiteDate.
   */
  isOnSiteNow: Scalars['Boolean']['output'];
  /** Completion of Jobite Specific Training */
  isSiteSpecificTrainingExpired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicate whether the worker is currently suspended from the jobsite, i.e. temporarily
   * banned with a suspension that has not expired yet. Since banExpiresAt is a date, this is
   * calculated server-side to keep clients from resolving the expiration in their own time zone.
   */
  isSuspended?: Maybe<Scalars['Boolean']['output']>;
  /** Job title of the worker */
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobsiteAccessSessions?: Maybe<JobsiteAccessSessionsConnection>;
  jobsiteContractor: JobsiteContractor;
  jobsiteWorkerId: Scalars['ID']['output'];
  latestAccessEvent?: Maybe<JobsiteAccessEvent>;
  /** Date that reason for skipping medical exam expires */
  medicalExamSkipExpiresAt?: Maybe<Scalars['Date']['output']>;
  /** Reason for skipping medical exam */
  medicalExamSkipReason?: Maybe<Scalars['String']['output']>;
  medicalNotes?: Maybe<Scalars['String']['output']>;
  nycSstExemptionReason?: Maybe<Scalars['String']['output']>;
  /** History of the object */
  objectHistory: ObjectHistory;
  /** DateTime jobsite worker onboarding signed */
  onboardingSignedAt?: Maybe<Scalars['Date']['output']>;
  /** Date that reason for skipping onboarding expires */
  onboardingSkipExpiresAt?: Maybe<Scalars['Date']['output']>;
  /** Reason for skip signing of onboarding documents */
  onboardingSkipReason?: Maybe<Scalars['String']['output']>;
  /** Date of the worker's orientation */
  orientationDate?: Maybe<Scalars['Date']['output']>;
  /** Status of the worker's orientation */
  orientationStatus?: Maybe<JobsiteWorkerOrientationStatus>;
  oshaCardExpiresAt?: Maybe<Scalars['Date']['output']>;
  oshaCardType?: Maybe<Scalars['String']['output']>;
  /** DateTime jobsite worker passsing medical examination */
  passedMedicalExamAt?: Maybe<Scalars['Date']['output']>;
  /** Payroll ID of the worker at the contractor */
  payrollId?: Maybe<Scalars['String']['output']>;
  /** Reason for skipping the completion of profile */
  profileCompleteSkipReason?: Maybe<Scalars['String']['output']>;
  /** DateTime jobsite worker onboarding profile is done */
  profileCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** Completion of Signature */
  signatureCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** Reason for skipping signature */
  signatureSkipReason?: Maybe<Scalars['String']['output']>;
  /** Name of person who approved site access change */
  siteAccessChangeApprovedBy?: Maybe<Scalars['String']['output']>;
  /** Completion of Jobite Specific Training */
  siteSpecificTrainingCompletedAt?: Maybe<Scalars['Date']['output']>;
  /** Date that reason for skipping site specific training expires */
  siteSpecificTrainingSkipExpiresAt?: Maybe<Scalars['Date']['output']>;
  /** Reason for skipping site specific training */
  siteSpecificTrainingSkipReason?: Maybe<Scalars['String']['output']>;
  sstExpiresAt?: Maybe<Scalars['Date']['output']>;
  sstType?: Maybe<Scalars['String']['output']>;
  /** When the worker started at the site */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** Number on the worker's jobsite hardhat sticker */
  stickerNumber?: Maybe<Scalars['String']['output']>;
  /** Trade of the worker */
  trade?: Maybe<Scalars['String']['output']>;
  /** Trade experience of the worker */
  tradeExperience?: Maybe<Scalars['String']['output']>;
  /** Union affiliation of the worker */
  unionAffiliation?: Maybe<Scalars['String']['output']>;
  urineTestConditionalPassExpiresAt?: Maybe<Scalars['Date']['output']>;
  urineTestLastTakenAt?: Maybe<Scalars['Date']['output']>;
  urineTestStatus?: Maybe<JobsiteWorkerTestStatus>;
};

/**
 * JobsiteWorker return type. A worker is any non-worker who is employed by the jobsite, such as an owner,
 * manager, or back office employee.
 */
export type JobsiteWorkerAccessGroupMembershipsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * JobsiteWorker return type. A worker is any non-worker who is employed by the jobsite, such as an owner,
 * manager, or back office employee.
 */
export type JobsiteWorkerDocumentsArgs = {
  input?: InputMaybe<JobsiteWorkerDocumentsInput>;
};

/**
 * JobsiteWorker return type. A worker is any non-worker who is employed by the jobsite, such as an owner,
 * manager, or back office employee.
 */
export type JobsiteWorkerJobsiteAccessSessionsArgs = {
  input?: InputMaybe<JobsiteAccessSessionsInput>;
};

export type JobsiteWorkerAccess = {
  __typename?: 'JobsiteWorkerAccess';
  /** The last date the worker is allowed on site */
  endDate: Scalars['Date']['output'];
  isAllowedNow: Scalars['Boolean']['output'];
  isAntipassbackExempt?: Maybe<Scalars['Boolean']['output']>;
  /** When the worker is allowed back to this site. If null, worker is disabled indefinitely */
  jobsiteAccessReadmissionDate?: Maybe<Scalars['Date']['output']>;
  /** When the worker's access was disabled to this site. */
  jobsiteDisabledAccessDate?: Maybe<Scalars['Date']['output']>;
  /** Reason worker is not allowed on this site */
  jobsiteDisabledAccessReason?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the worker has access disabled to this site. */
  jobsiteIsDisabledAccess?: Maybe<Scalars['Boolean']['output']>;
  jobsiteWorker: JobsiteWorker;
  notAllowedReason?: Maybe<Scalars['String']['output']>;
  nycSstCardType?: Maybe<Scalars['String']['output']>;
  nycSstExemptionReason?: Maybe<Scalars['String']['output']>;
  objectHistory?: Maybe<ObjectHistory>;
  orientationMedicalCompletedAt?: Maybe<Scalars['Date']['output']>;
  orientationMedicalExpiredAt?: Maybe<Scalars['Date']['output']>;
  orientationMedicalSkipReason?: Maybe<Scalars['String']['output']>;
  orientationSafetyTrainingCompletedAt?: Maybe<Scalars['Date']['output']>;
  orientationSafetyTrainingExpiredAt?: Maybe<Scalars['Date']['output']>;
  orientationSafetyTrainingSkipReason?: Maybe<Scalars['String']['output']>;
  safetyDocumentStatus?: Maybe<SafetyDocumentStatus>;
  safetyDocumentsCompletedAt?: Maybe<Scalars['Date']['output']>;
  safetyDocumentsExpiredAt?: Maybe<Scalars['Date']['output']>;
  safetyDocumentsSkipReason?: Maybe<Scalars['String']['output']>;
  siteSpecificTrainingCompletedAt?: Maybe<Scalars['Date']['output']>;
  siteSpecificTrainingExpiredAt?: Maybe<Scalars['Date']['output']>;
  siteSpecificTrainingSkipReason?: Maybe<Scalars['String']['output']>;
  /** The first date the worker is allowed on site */
  startDate: Scalars['Date']['output'];
  /** When the worker is allowed back to all sites. If null, worker is disabled indefinitely */
  workerAccessReadmissionDate?: Maybe<Scalars['Date']['output']>;
  /** When the worker's access was disabled to all sites. */
  workerDisabledAccessDate?: Maybe<Scalars['Date']['output']>;
  /** Reason worker is not allowed on any site */
  workerDisabledAccessReason?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the worker has access disabled to all sites. */
  workerIsDisabledAccess?: Maybe<Scalars['Boolean']['output']>;
};

/** Site access as the Portal labels it, worst first. Archived is on Worker.isArchived. */
export enum JobsiteWorkerAccessStatus {
  Allowed = 'ALLOWED',
  Banned = 'BANNED',
  NotAllowed = 'NOT_ALLOWED',
  Offboarded = 'OFFBOARDED',
  Suspended = 'SUSPENDED',
}

export type JobsiteWorkerCheckIn = {
  __typename?: 'JobsiteWorkerCheckIn';
  area: JobsiteAppCheckInModuleArea;
  checkInDateTime: Scalars['Date']['output'];
  checkInStatus?: Maybe<JobsiteWorkerCheckInStatus>;
  checkInStatusNotes?: Maybe<JobsiteAccessEventRejectionReason>;
  direction?: Maybe<JobsiteWorkerCheckInDirection>;
  flags?: Maybe<Array<JobsiteWorkerCheckInFlag>>;
  id: Scalars['ID']['output'];
  jobsite: Jobsite;
  jobsiteFormSubmissions: JobsiteFormSubmissionsConnection;
  jobsiteWorker?: Maybe<JobsiteWorker>;
  location?: Maybe<GpsCoordinate>;
  locationStatus?: Maybe<JobsiteWorkerCheckInLocationStatus>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<JobsiteWorkerCheckInSource>;
  type: JobsiteWorkerCheckInType;
  worker?: Maybe<Worker>;
};

export type JobsiteWorkerCheckInAppFarFromAreaFlag =
  JobsiteWorkerCheckInFlag & {
    __typename?: 'JobsiteWorkerCheckInAppFarFromAreaFlag';
    accuracy: Scalars['Float']['output'];
    coordinate: GpsCoordinate;
    message: Scalars['String']['output'];
  };

export type JobsiteWorkerCheckInArea = {
  id: Scalars['ID']['output'];
  isInboundEnabled: Scalars['Boolean']['output'];
  isOutboundEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type JobsiteWorkerCheckInConnection = {
  __typename?: 'JobsiteWorkerCheckInConnection';
  edges: Array<JobsiteWorkerCheckIn>;
  totalCount: Scalars['Int']['output'];
};

export enum JobsiteWorkerCheckInDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
}

export type JobsiteWorkerCheckInFlag = {
  message: Scalars['String']['output'];
};

export enum JobsiteWorkerCheckInLocationStatus {
  LocationNotAvailable = 'LocationNotAvailable',
  Nearby = 'Nearby',
  Offsite = 'Offsite',
  Onsite = 'Onsite',
}

export type JobsiteWorkerCheckInManualOverrideFlag =
  JobsiteWorkerCheckInFlag & {
    __typename?: 'JobsiteWorkerCheckInManualOverrideFlag';
    message: Scalars['String']['output'];
    overrideReason?: Maybe<Scalars['String']['output']>;
    overrideUser: User;
  };

export enum JobsiteWorkerCheckInSource {
  /** Check-in was done using admin-check-in feature */
  AdminCheckIn = 'AdminCheckIn',
  /** Check-in was done using ambassador-mode */
  AmbassadorMode = 'AmbassadorMode',
  /** Check-in was done using badge-scanning feature */
  BadgeScanning = 'BadgeScanning',
  /** Check-in was done using kiosk-mode */
  KioskMode = 'KioskMode',
  /** Check-in was done using self-check-in feature */
  SelfCheckIn = 'SelfCheckIn',
}

export enum JobsiteWorkerCheckInStatus {
  Admit = 'Admit',
  Reject = 'Reject',
}

export type JobsiteWorkerCheckInSuggestion = {
  __typename?: 'JobsiteWorkerCheckInSuggestion';
  direction: JobsiteWorkerCheckInDirection;
  id: Scalars['ID']['output'];
  jobsiteWorker: JobsiteWorker;
};

export type JobsiteWorkerCheckInSuggestionConnection = {
  __typename?: 'JobsiteWorkerCheckInSuggestionConnection';
  edges: Array<JobsiteWorkerCheckInSuggestion>;
  totalCount: Scalars['Int']['output'];
};

export enum JobsiteWorkerCheckInType {
  BluetoothPing = 'BluetoothPing',
  CardSwipe = 'CardSwipe',
  MobileAppCheckIn = 'MobileAppCheckIn',
  WebAppCheckIn = 'WebAppCheckIn',
}

export type JobsiteWorkerClearanceAssignment = {
  __typename?: 'JobsiteWorkerClearanceAssignment';
  clearance: CCureClearance;
  clearanceType?: Maybe<JobsiteClearanceType>;
  id?: Maybe<Scalars['String']['output']>;
  jobsiteWorker: JobsiteWorker;
  objectHistory: ObjectHistory;
};

export type JobsiteWorkerClearanceAssignmentEdge = {
  __typename?: 'JobsiteWorkerClearanceAssignmentEdge';
  node?: Maybe<JobsiteWorkerClearanceAssignment>;
};

export type JobsiteWorkerClearanceAssignmentInput = {
  clearanceId: Scalars['ID']['input'];
  clearanceType?: InputMaybe<JobsiteClearanceType>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobsiteWorkerId: Scalars['ID']['input'];
};

export type JobsiteWorkerClearanceAssignmentsConnection = {
  __typename?: 'JobsiteWorkerClearanceAssignmentsConnection';
  count: Scalars['Int']['output'];
  edges: Array<Maybe<JobsiteWorkerClearanceAssignmentEdge>>;
};

/**
 * JobsiteWorkerCompact is a lightweight version of the JobsiteWorker data, with only the relevant fields
 * This is a reflection of the worker object stored/enriched in elastic
 */
export type JobsiteWorkerCompact = {
  __typename?: 'JobsiteWorkerCompact';
  contractorId?: Maybe<Scalars['String']['output']>;
  contractorName?: Maybe<Scalars['String']['output']>;
  croppedDownloadKey?: Maybe<Scalars['String']['output']>;
  downloadKey?: Maybe<Scalars['String']['output']>;
  fitoutTenant?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobsiteId?: Maybe<Scalars['String']['output']>;
  jobsiteName?: Maybe<Scalars['String']['output']>;
  jobsiteWorkerId?: Maybe<Scalars['String']['output']>;
  profile?: Maybe<AdditionalWorkerProfileData>;
  status?: Maybe<Scalars['String']['output']>;
  trade?: Maybe<Scalars['String']['output']>;
  tradeSubclass?: Maybe<Scalars['String']['output']>;
  unionAffiliation?: Maybe<Scalars['String']['output']>;
  workType?: Maybe<Scalars['String']['output']>;
  workerCardId?: Maybe<Scalars['String']['output']>;
  workerId?: Maybe<Scalars['String']['output']>;
  workerStatus?: Maybe<Scalars['String']['output']>;
};

export type JobsiteWorkerConnection = {
  __typename?: 'JobsiteWorkerConnection';
  edges: Array<JobsiteWorkerAccess>;
  jobsiteStats?: Maybe<JobsiteStats>;
  totalCount: Scalars['Int']['output'];
};

export type JobsiteWorkerCurrentAccess = {
  __typename?: 'JobsiteWorkerCurrentAccess';
  endDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isAllowed: Scalars['Boolean']['output'];
  notAllowedReason?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
};

/** JobsiteWorkerDocument return type. */
export type JobsiteWorkerDocument = {
  __typename?: 'JobsiteWorkerDocument';
  /** Optional JobsiteWorker Associated with Document */
  jobsiteWorker?: Maybe<JobsiteWorker>;
  /** ID of the jobsite worker document */
  jobsiteWorkerDocumentId: Scalars['ID']['output'];
  /** Document Type */
  jobsiteWorkerDocumentType: JobsiteWorkerDocumentType;
  /** Available versions of the specific document */
  jobsiteWorkerDocumentVersions: Array<JobsiteWorkerDocumentVersion>;
  /** Unique human readable ID of document */
  key: Scalars['String']['output'];
  latestVersion: JobsiteWorkerDocumentVersion;
  objectHistory: ObjectHistory;
  /** Worker Associated with Document */
  worker: Worker;
};

export type JobsiteWorkerDocumentInput = {
  /**
   * If 'forceCreate' is true, it will create a new document along with a new document version,
   * even if one already exists for the given 'worker' and 'workerDocumentKey'.
   */
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteWorkerDocumentTypeId: Scalars['ID']['input'];
  jobsiteWorkerId: Scalars['ID']['input'];
  /** Unique human readable id for given document */
  key: Scalars['String']['input'];
};

/** JobsiteWorkerDocumentType return type. */
export type JobsiteWorkerDocumentType = {
  __typename?: 'JobsiteWorkerDocumentType';
  additionalFields: Array<WorkerDocumentAdditionalField>;
  expiration?: Maybe<Scalars['Duration']['output']>;
  files: Array<File>;
  /** ID of the jobsite worker document */
  id: Scalars['ID']['output'];
  /** The full jobsite object */
  jobsite: Jobsite;
  /**
   * The key of the jobsite worker document type.
   * This is used to uniquely identify the document type that can be assigned
   * to a jobsite multiple times (i.e. jobsite-safety-video).
   */
  key?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the jobsite worker document type.
   * This is used as user-friendly name for a document type that can be assigned
   * to a jobsite multiple times (i.e. for jobsite-safety-video document type).
   */
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  workerDocumentType: WorkerDocumentType;
};

export type JobsiteWorkerDocumentTypesConnection = {
  __typename?: 'JobsiteWorkerDocumentTypesConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteWorkerDocumentTypesEdge>;
};

export type JobsiteWorkerDocumentTypesEdge = {
  __typename?: 'JobsiteWorkerDocumentTypesEdge';
  node: JobsiteWorkerDocumentType;
};

export type JobsiteWorkerDocumentTypesInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteWorkerDocumentUpsertInput = {
  additionalFieldValues?: InputMaybe<Array<AdditionalFieldValueInput>>;
  files?: InputMaybe<Array<FileChangeInput>>;
  jobsiteWorkerDocumentTypeId: Scalars['ID']['input'];
  jobsiteWorkerDocumentVersionId?: InputMaybe<Scalars['ID']['input']>;
  jobsiteWorkerId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
};

export type JobsiteWorkerDocumentVersion = {
  __typename?: 'JobsiteWorkerDocumentVersion';
  /** The user who acknowledged the document on behalf of the worker */
  acknowledgedBy?: Maybe<User>;
  /** Optional additional field values */
  additionalFieldValues?: Maybe<Array<AdditionalFieldValue>>;
  /** Optional expiration date of the document */
  expirationDate: Scalars['Date']['output'];
  /** The files associated with the document. */
  files: Array<File>;
  /** ID of the jobsite worker document */
  jobsiteWorkerDocumentVersionId: Scalars['ID']['output'];
  objectHistory: ObjectHistory;
};

export type JobsiteWorkerDocumentVersionInput = {
  additionalFieldValues?: InputMaybe<Array<AdditionalFieldValueInput>>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  fileIds: Array<Scalars['ID']['input']>;
};

export type JobsiteWorkerDocumentsConnection = {
  __typename?: 'JobsiteWorkerDocumentsConnection';
  count: Scalars['Int']['output'];
  edges: Array<JobsiteWorkerDocumentsEdge>;
};

export type JobsiteWorkerDocumentsEdge = {
  __typename?: 'JobsiteWorkerDocumentsEdge';
  node: JobsiteWorkerDocument;
};

export type JobsiteWorkerDocumentsInput = {
  includePhi?: InputMaybe<Scalars['Boolean']['input']>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type JobsiteWorkerFacetCounts = {
  __typename?: 'JobsiteWorkerFacetCounts';
  allowed: Scalars['Int']['output'];
  banned: Scalars['Int']['output'];
  notAllowed: Scalars['Int']['output'];
  offSite: Scalars['Int']['output'];
  offboarded: Scalars['Int']['output'];
  onSite: Scalars['Int']['output'];
  suspended: Scalars['Int']['output'];
};

export type JobsiteWorkerInfo = {
  __typename?: 'JobsiteWorkerInfo';
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobsiteWorkerId: Scalars['ID']['output'];
  trade?: Maybe<Scalars['String']['output']>;
  unionAffiliation?: Maybe<Scalars['String']['output']>;
};

/** Input for saving jobsite specific information for a worker as part of onboarding */
export type JobsiteWorkerInformationInput = {
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  /** When the worker stops working at the site */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  jobsiteWorkerId: Scalars['ID']['input'];
  /** Payroll ID of the worker at the contractor */
  payrollId?: InputMaybe<Scalars['String']['input']>;
  /** When the worker started at the site */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Number on the worker's jobsite hardhat sticker */
  stickerNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Input for assigning a worker to a jobsite or updating their info at the jobsite */
export type JobsiteWorkerInput = {
  /** Completion of badging */
  badgingCompletedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Reason for skipping badging */
  badgingSkipReason?: InputMaybe<Scalars['String']['input']>;
  /** The reason the worker is banned from the jobsite */
  banCategory?: InputMaybe<Scalars['String']['input']>;
  /** When the temp ban is set to expire */
  banExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  banRemovedReason?: InputMaybe<Scalars['String']['input']>;
  /** When the worker was banned from the jobsite */
  bannedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Notes regarding why the worker is banned from the jobsite */
  bannedReason?: InputMaybe<Scalars['String']['input']>;
  /** Classification group of the worker */
  classificationGroup?: InputMaybe<Scalars['String']['input']>;
  clearanceAssignments?: InputMaybe<
    Array<JobsiteWorkerClearanceAssignmentInput>
  >;
  customWorkerData?: InputMaybe<Scalars['JSONObject']['input']>;
  /** Date that document exemption expires */
  documentExemptionReason?: InputMaybe<Scalars['String']['input']>;
  /** DateTime jobsite worker documents signed/uploaded */
  documentsCompletedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Date that reason for skipping documents expires */
  documentsCompletedSkipExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  /** Reason for skipping documents signing */
  documentsCompletedSkipReason?: InputMaybe<Scalars['String']['input']>;
  /** When the worker stops working at the site */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  fitoutTenant?: InputMaybe<Scalars['String']['input']>;
  isAntipassbackExempt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicate whether the worker is banned from the jobsite */
  isBanned?: InputMaybe<Scalars['Boolean']['input']>;
  isExemptFromSiteSpecificRefresher?: InputMaybe<Scalars['Boolean']['input']>;
  isExemptFromSwipeInactivity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Job title of the worker */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** Date that reason for skipping medical exam expires */
  medicalExamSkipExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  /** Reason for skipping medical exam */
  medicalExamSkipReason?: InputMaybe<Scalars['String']['input']>;
  medicalNotes?: InputMaybe<Scalars['String']['input']>;
  nycSstExemptionReason?: InputMaybe<Scalars['String']['input']>;
  /** DateTime jobsite worker onboarding signed */
  onboardingSignedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Date that reason for skipping onboarding expires */
  onboardingSkipExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  /** Reason for skip signing of onboarding documents */
  onboardingSkipReason?: InputMaybe<Scalars['String']['input']>;
  /** Date of the worker's orientation */
  orientationDate?: InputMaybe<Scalars['Date']['input']>;
  /** Status of the worker's orientation */
  orientationStatus?: InputMaybe<JobsiteWorkerOrientationStatus>;
  /** DateTime jobsite worker passsing medical examination */
  passedMedicalExamAt?: InputMaybe<Scalars['Date']['input']>;
  /** Payroll ID of the worker at the contractor */
  payrollId?: InputMaybe<Scalars['String']['input']>;
  /** Reason for skipping the completion of profile */
  profileCompleteSkipReason?: InputMaybe<Scalars['String']['input']>;
  /** DateTime jobsite worker onboarding profile is done */
  profileCompletedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Completion of Signature */
  signatureCompletedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Reason for skipping signature */
  signatureSkipReason?: InputMaybe<Scalars['String']['input']>;
  /** Name of person who approved site access change */
  siteAccessChangeApprovedBy?: InputMaybe<Scalars['String']['input']>;
  /** Completion of Jobite Specific Training */
  siteSpecificTrainingCompletedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Date that reason for skipping site specific training expires */
  siteSpecificTrainingSkipExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  /** Reason for skipping site specific training */
  siteSpecificTrainingSkipReason?: InputMaybe<Scalars['String']['input']>;
  /** When the worker started at the site */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /**
   * The step which will be marked as complete. Used for validation purposes.
   *
   * It is defined as 'String' because OnboardingStepKey custom enum
   * is not correctly parsed by GraphQL.
   */
  stepToComplete?: InputMaybe<Scalars['String']['input']>;
  /** Number on the worker's jobsite hardhat sticker */
  stickerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Title of the worker at the jobsite. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Trade of the worker */
  trade?: InputMaybe<Scalars['String']['input']>;
  /** Trade experience of the worker */
  tradeExperience?: InputMaybe<Scalars['String']['input']>;
  /** Union affiliation of the worker */
  unionAffiliation?: InputMaybe<Scalars['String']['input']>;
  urineTestConditionalPassExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  workType?: InputMaybe<Scalars['String']['input']>;
};

export enum JobsiteWorkerOrientationStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  SelfOnboarding = 'SELF_ONBOARDING',
}

export enum JobsiteWorkerOrientationStatusFilter {
  AtBadging = 'AT_BADGING',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NeedsMedical = 'NEEDS_MEDICAL',
  NotStarted = 'NOT_STARTED',
  SelfOnboarding = 'SELF_ONBOARDING',
}

export type JobsiteWorkerReportContractorBreakdown = {
  __typename?: 'JobsiteWorkerReportContractorBreakdown';
  contractor: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type JobsiteWorkerReportResult = {
  __typename?: 'JobsiteWorkerReportResult';
  jobsiteWorker: JobsiteWorker;
};

export type JobsiteWorkerReportTradeBreakdown = {
  __typename?: 'JobsiteWorkerReportTradeBreakdown';
  count: Scalars['Int']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  trade: Scalars['String']['output'];
};

export enum JobsiteWorkerRosterStatus {
  NotAllowed = 'NOT_ALLOWED',
  OffSite = 'OFF_SITE',
  Onboarding = 'ONBOARDING',
  OnSite = 'ON_SITE',
}

export type JobsiteWorkerRosterStatusCounts = {
  __typename?: 'JobsiteWorkerRosterStatusCounts';
  notAllowed: Scalars['Int']['output'];
  offSite: Scalars['Int']['output'];
  onSite: Scalars['Int']['output'];
  onboarding: Scalars['Int']['output'];
};

export enum JobsiteWorkerTestStatus {
  ConditionalPass = 'ConditionalPass',
  Fail = 'Fail',
  Pass = 'Pass',
}

export enum JobsiteWorkerWorkType {
  Construction = 'CONSTRUCTION',
  FitOut = 'FIT_OUT',
}

export type JobsitesStats = {
  __typename?: 'JobsitesStats';
  jobsites?: Maybe<Array<Jobsite>>;
  numberOfActiveWorkers: Scalars['Int']['output'];
  numberOfOrientationWorkersCompleted: Scalars['Int']['output'];
  numberOfOrientationWorkersInProgress: Scalars['Int']['output'];
  numberOfOrientationWorkersNeedingBadging: Scalars['Int']['output'];
  numberOfOrientationWorkersNeedingMedical: Scalars['Int']['output'];
  numberOfOrientationWorkersSelfOnboarding: Scalars['Int']['output'];
  numberOfOrientationWorkersTotal: Scalars['Int']['output'];
  numberOfWorkers: Scalars['Int']['output'];
};

export enum Language {
  EnUs = 'EN_US',
  Es = 'ES',
  Hu = 'HU',
  Pl = 'PL',
  Ru = 'RU',
  ZhCn = 'ZH_CN',
}

/** One reason a composite layout command wrote nothing. Only the fields of its code are set. */
export type LayoutRefusal = {
  __typename?: 'LayoutRefusal';
  code: LayoutRefusalCode;
  /** STALE_DRAFT: the draft's token now. */
  currentToken?: Maybe<Scalars['Int']['output']>;
  /** ZONE_IN_USE: the entries still facing the zone. */
  entryIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** FIELD: the input it is about. from is side A and to is side B. */
  field?: Maybe<Scalars['String']['output']>;
  /** SEED_NEEDS_DESTINATION: the gateways with no destination zone. FIELD, from a seed: the gateways whose entries the rule refuses, so one can be renamed in the gateway list. */
  gatewayIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** FIELD: the rule, in Odin's words. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Why a composite layout command wrote nothing, or, as SEED_REQUIRED, the code a refused publish's error carries. */
export enum LayoutRefusalCode {
  /** An input breaks a rule; field names it (name, from, to, readers, zoneId or entryId) and message says why. */
  Field = 'FIELD',
  /** The site has no draft. */
  NoDraft = 'NO_DRAFT',
  /** The revision named is not the site's draft: it was discarded or published since it was read. */
  RevisionMismatch = 'REVISION_MISMATCH',
  /** A seed into a draft with several zones needs a destination zone for each gateway gatewayIds names; a draft with no zone needs a zone added first. */
  SeedNeedsDestination = 'SEED_NEEDS_DESTINATION',
  /** A publish refused while the site has live gateways no entry is linked to: the error's extensions carry this code and gatewayIds, the gateways to seed first. */
  SeedRequired = 'SEED_REQUIRED',
  /** The draft has been written since the client read it; currentToken is its token now. */
  StaleDraft = 'STALE_DRAFT',
  /** Entries still face the zone; entryIds names them. */
  ZoneInUse = 'ZONE_IN_USE',
}

/** How a composite layout command ended. */
export enum LayoutResultKind {
  /** The command applied; draftToken is the draft's token after it. */
  Applied = 'APPLIED',
  /** The command wrote nothing; refusals say why. */
  Refused = 'REFUSED',
}

/** What a crossing leaves or enters: a zone of the layout, or the outside. */
export type LayoutSide = {
  __typename?: 'LayoutSide';
  kind: LayoutSideKind;
  /** The zone; null for the outside. */
  zone?: Maybe<Zone>;
};

export type LayoutSideInput = {
  kind: LayoutSideKind;
  /** The zone the side faces. Required for ZONE; absent for OUTSIDE. */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

/** What one side of an entry faces: a zone of the layout, or the outside world. */
export enum LayoutSideKind {
  Outside = 'OUTSIDE',
  Zone = 'ZONE',
}

export type LimitOffsetPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type LogVisitorInput = {
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Input fields for creating a new user account.
   * If workerId is not provided it will be required; otherwise, it will be ignored.
   */
  createUserInput?: InputMaybe<CreateUserInput>;
  /**
   * If true, creates a new worker account for the visitor even if a matching worker is found.
   * It is ignored if workerId is provided.
   */
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * VisitorLog ID is used only for updating an existing VisitorLog.
   * It is ignored when creating a new entry.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The jobsite where the visitor is being logged.
   * It is required when creating a new entry.
   */
  jobsiteId?: InputMaybe<Scalars['ID']['input']>;
  tempBadgeExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  /** If provided, assign the visitor the specified temp badge */
  tempBadgeId?: InputMaybe<Scalars['ID']['input']>;
  vehicleInput?: InputMaybe<VehicleInput>;
  /** If provided, associates the visitor with an existing worker */
  workerId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Input fields for creating a new user account.
   * If workerId is not provided it will be required; otherwise, it will be ignored.
   */
  workerInput?: InputMaybe<VisitorWorkerCreateInput>;
};

/**
 * Returned when a PIN login attempt is rejected. The shape
 * intentionally collapses every rejection reason (wrong PIN, unknown
 * worker, missing credential, credential locked, etc.) into one
 * opaque response, so a brute-forcer cannot probe to
 * learn which workers exist or when they have triggered a lockout.
 * The real reason is logged server-side with a stable tag for
 * telemetry.
 */
export type LoginInvalid = {
  __typename?: 'LoginInvalid';
  /**
   * Always the literal 'INVALID_CREDENTIALS'. Held as a field so the type has a valid
   * GraphQL shape with room to add fields later if needed.
   */
  code: Scalars['String']['output'];
};

/**
 * Returned when the worker must wait before another PIN login attempt
 * will be accepted. Covers two server-side states with identical
 * caller semantics: the Redis-backed rate-limit window (the primary
 * defense against PIN brute force on a shared kiosk) and the
 * credential's own persistent lockout after repeated failed attempts.
 * Callers do not need to distinguish the two. Either way, wait
 * retryAfterSeconds and try again. Attempts made before the window
 * elapses will be rejected.
 */
export type LoginRateLimited = {
  __typename?: 'LoginRateLimited';
  /** Seconds until the server will accept another attempt from this worker. Always at least 1. */
  retryAfterSeconds: Scalars['Int']['output'];
};

export type LoginWithPinInput = {
  pin: Scalars['String']['input'];
  workerId: Scalars['ID']['input'];
};

/** The three outcomes of a loginWithPin mutation. */
export type LoginWithPinResult = Auth | LoginInvalid | LoginRateLimited;

export type ManageContractorStripePaymentMethodInput = {
  contractorId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
};

export type MatchWorkersInput = {
  /** Input fields for creating a new user account */
  createUserInput: CreateUserInput;
  /** Base info for the worker */
  workerBaseInfoInput: WorkerBaseInfoInput;
};

export type MatchWorkersPayload = {
  __typename?: 'MatchWorkersPayload';
  matchedWorkers: Array<WorkerErrorInfo>;
};

export type MobileCompleteAnonymousPhoneVerificationInput = {
  /**
   * The phone number the OTP was sent to (from 'startAnonymousPhoneVerification').
   * Used to (a) authenticate the fixed App-review test user by password rather
   * than a real SMS code, and (b) attribute a failed verification to a phone in
   * the logs. The verification code itself carries no phone, so it must be
   * supplied by the client.
   */
  phoneNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type MobileCompleteAnonymousPhoneVerificationResponse = {
  __typename?: 'MobileCompleteAnonymousPhoneVerificationResponse';
  /**
   * Full authenticated session (access + refresh), set only when the verified
   * phone already has an Odin account — the worker is signed in.
   */
  auth?: Maybe<Auth>;
  /**
   * FusionAuth refresh token from the same passwordless grant, presented
   * alongside 'token' on the account-creation step so the new worker's session
   * is a full session. Set only for a brand-new phone.
   */
  refreshToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /**
   * FusionAuth access token proving phone ownership, presented on the
   * account-creation step ('mobileOnboardingCreateAccount'). Set only for a
   * brand-new phone with no Odin account yet.
   */
  token?: Maybe<Scalars['String']['output']>;
};

export type MobileDashboardForWorkerResponse = {
  __typename?: 'MobileDashboardForWorkerResponse';
  jobsiteWorkerCheckInSuggestions: Array<JobsiteWorkerCheckInSuggestion>;
  mobileDashboardMessages: Array<MobileDashboardMessage>;
};

export type MobileDashboardMessage = {
  __typename?: 'MobileDashboardMessage';
  messageType: MobileDashboardMessageType;
};

export enum MobileDashboardMessageType {
  BeforeYouArriveOnsite = 'BeforeYouArriveOnsite',
  WelcomeToOdin = 'WelcomeToOdin',
}

export type MobileDeviceInfo = {
  __typename?: 'MobileDeviceInfo';
  binaryVersion?: Maybe<Scalars['String']['output']>;
  bundleVersion?: Maybe<Scalars['String']['output']>;
  deviceModelName?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for creating the Odin account of a mobile self-registering worker.
 * Carries no jobsite invitation or contractor — the account is a standalone
 * orphan (no jobsiteWorker), created purely from the OTP-verified phone token.
 */
export type MobileOnboardingCreateAccountInput = {
  /**
   * Name (first/last) and contact for the new user account. Mobile does not
   * send an email, so 'email' stays null and is collected later via
   * 'updateWorker'.
   */
  createUserInput: CreateUserInput;
  /**
   * FusionAuth access token from 'mobileCompleteAnonymousPhoneVerification',
   * proving the caller owns 'createUserInput.phoneNumber'. Required — the new
   * account is linked to that OTP-verified FusionAuth user rather than creating a
   * new one.
   */
  phoneVerificationToken: Scalars['String']['input'];
  /**
   * Ids of the platform policy documents the worker affirmed at account
   * creation (the aggregate consent checkbox, fanned out to the displayed
   * 'getCurrentPolicyDocuments'). One 'policy_consent' row is written per id.
   * Empty when the consent step is inactive (flag off or no policies seeded).
   */
  policyDocumentIds: Array<Scalars['ID']['input']>;
  /** Preferred language of the worker (optional). */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  /**
   * FusionAuth refresh token from the same passwordless grant
   * ('mobileCompleteAnonymousPhoneVerification'), so the new worker is signed in
   * with a full session (access + refresh) rather than an access-only one.
   */
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the worker checked the mandatory SMS opt-in box. Sent explicitly
   * (rather than assumed from the UI gating) so the 'smsConsentReceivedAt'
   * audit stamp reflects genuine consent even for direct API callers: the
   * timestamp is recorded only when this is true.
   */
  smsOptInAcknowledged: Scalars['Boolean']['input'];
};

export type MobileOnboardingCreateAccountPayload = {
  __typename?: 'MobileOnboardingCreateAccountPayload';
  auth: Auth;
  worker: Worker;
};

/** A reader an entry save took off another entry of the draft. */
export type MovedReader = {
  __typename?: 'MovedReader';
  fromEntryId: Scalars['ID']['output'];
  readerId: Scalars['ID']['output'];
};

/** The root mutation object for all mutations */
export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  addAndIssueFacialRecognitionBadge?: Maybe<WorkerCard>;
  addAndIssueMobileBadge: WorkerCard;
  addCardToWorker: WorkerCard;
  /**
   * Adds a controller that already exists in Avigilon to the site by its
   * serial number, with its ports and readers, together or not at all.
   * Requires Manage site devices at the site, and the site's layout to be
   * enabled. Writes nothing to Avigilon.
   */
  addSiteController: AddSiteControllerPayload;
  addZoneToAccessGroup: AccessGroup;
  /**
   * Adopts a provider reader as a reader device registered on the site, or a
   * provider access control unit as an access controller device assigned to
   * the site, recording the device first if no discovery has. Adopting an
   * access control unit also registers on the site the reader devices on its
   * ports that are on no site and not missing, and is refused when one of
   * them is on another site. A reader the provider reports on another site's
   * access controller is adopted without a port, unless Odin already has its
   * reader device on that port, which is refused. A device already on a site
   * is refused.
   * Nothing is written to the provider, and nothing is assigned in the site
   * layout.
   * Other items' states may change too, so refetch the site's inventory.
   */
  adoptInventoryItem: AdoptInventoryItemPayload;
  archiveAccessGroup: AccessGroup;
  /** Delete a jobsite. Returns an error if jobsiteId is not found. */
  archiveJobsite: Success;
  archiveJobsiteWorkerAccessEvent?: Maybe<ArchiveJobsiteWorkerAccessEventResponse>;
  /** Archive's a worker and all nested objects such as jobsiteWorker, contractorWorker, and all documents */
  archiveWorker: Worker;
  /**
   * Assign worker to jobsite. If worker is already associated, it returns error if 'ignoreIfAlreadyAssigned' is falsy
   * or existing jobsite worker if the flag is truthy.
   * This operation should be used either by a contractor or jobsite member to assign a worker to the jobsite.
   */
  assignContractorWorkerToJobsite: AssignContractorWorkerToJobsiteResponse;
  /**
   * Assigns a device to an active layout site: an access controller device,
   * with the reader devices on its ports that are on no site and not
   * missing; or a reader device. Refuses a missing device, one already on a
   * site (there is no move), and one that would be on another site than its
   * access controller device or the reader devices on its ports. A reader
   * device whose access controller device is on no site is refused on
   * another site than a reader device on the same access controller device.
   * Nothing is written to Avigilon. Odin admins only.
   */
  assignDeviceToSite: AssignDeviceToSitePayload;
  assignTempBadge: TempBadgePayload;
  assignWorkerToContractor: ContractorWorker;
  authenticateLimitedTokenDetails: AuthenticateLimitedTokenDetailsResponse;
  /** Update multiple jobsite workers objects. Returns error if any worker not found at jobsite. */
  bulkUpdateJobsiteWorkers: Array<Maybe<JobsiteWorker>>;
  changeContractorForJobsiteWorkers: ChangeContractorForJobsiteWorkersResponse;
  changeJobsiteWorkersJobsiteAssignment: ChangeJobsiteWorkersJobsiteAssignmentResponse;
  changeScheduleStatus: ChangeScheduleStatusPayload;
  changeZonesMode: ChangeZonesModePayload;
  checkInJobsiteWorkers: JobsiteWorkerCheckInConnection;
  checkInWorkers?: Maybe<WorkersCheckInConnection>;
  /**
   * Completes an anonymous phone verification, proving ownership of the phone.
   * Returns a FusionAuth token to be presented on a subsequent
   * account-creation/linking step; it does not create or require an Odin account.
   */
  completeAnonymousPhoneVerification: CompleteAnonymousPhoneVerificationResponse;
  /** Completes a passwordless login based on the given code */
  completePasswordlessLogin: Auth;
  /** Completes a phone number verification request */
  completePhoneNumberVerification: CompletePhoneNumberVerificationResponse;
  completePhoneNumberVerificationAndSignIn: CompletePhoneNumberVerificationAndSignInResponse;
  completeSelfOnBoarding: JobsiteWorker;
  contractorAddJobsites: ContractorAddJobsitesPayload;
  contractorArchive: ContractorArchivePayload;
  contractorCreate: ContractorCreatePayload;
  contractorRemoveWorker: ContractorRemoveWorkerPayload;
  contractorUpdate: ContractorUpdatePayload;
  createAccessGroup: AccessGroup;
  createAndPrintTempBadge: TempBadgePayload;
  /**
   * This is used for now to create and print ID cards only,
   * but we intend to expand this in the future to be the main way
   * to create worker cards, so it includes the same options as addCardToWorker
   */
  createAndPrintWorkerCard: WorkerCardPayload;
  createCardPrintJob: CardPrintJob;
  createContractorStripeInvoice: CreateContractorStripeInvoicePayload;
  createContractorWorker?: Maybe<ContractorWorker>;
  /**
   * Grants a client (the grantee developer) read access to a single jobsite's
   * data via the Client API, under a written data-sharing agreement. Admin/super
   * only. Requires a reference to the written approval.
   */
  createDeveloperJobsiteAccessGrant: DeveloperJobsiteAccessGrantPayload;
  /** Create a jobsite announcement. */
  createJobsiteAnnouncement: JobsiteAnnouncement;
  /**
   * It looks for an existing JobsiteWorkerDocument for the given 'worker' and 'workerDocumentKey'.
   * If one exists, it will add a new JobsiteWorkerDocumentVersion to it.
   * If 'forceCreate' is true, it will create a new document along with a new document version,
   * even if one already exists for the given 'worker' and 'workerDocumentKey'.
   */
  createJobsiteWorkerDocument: JobsiteWorkerDocument;
  createJobsiteWorkerDocumentVersion: JobsiteWorkerDocumentVersion;
  /** Creates a new PayrollDocument with it's initial version. */
  createPayrollDocument: PayrollDocument;
  createPayrollDocumentVersion: PayrollDocumentVersion;
  createScheduleShift: CreateScheduleShiftPayload;
  createScheduleWorker: CreateScheduleWorkerPayload;
  createScheduleWorkerSession: CreateScheduleWorkerSessionPayload;
  /**
   * Opens the site's draft layout, starting from the published revision
   * basedOnRevisionId names, or from the effective layout when it names none.
   * Returns the draft.
   */
  createSiteLayoutDraft: SiteLayout;
  createVisitorLog: VisitorLogPayload;
  /**
   * Create a worker. This will send a welcome email with an invite link.
   * Returns an error if worker with same email already exists.
   */
  createWorker: Worker;
  /** Create a new worker comment */
  createWorkerComment: WorkerComment;
  deactivateTempBadge: TempBadgePayload;
  /** Delete the FusionAuth user for the current session */
  deleteFusionAuthUser: Success;
  /** Delete a single jobsite announcement by ID. Returns error if announcement doesn't exist */
  deleteJobsiteAnnouncement: Success;
  deleteJobsiteWorkerDocument: Success;
  deletePayrollDocument?: Maybe<Success>;
  deleteScheduleShift: DeleteScheduleShiftPayload;
  deleteScheduleWorker: DeleteScheduleWorkerPayload;
  /**
   * Mutation to create a new developer. Takes in either a name or an organizationId
   * If the organization exists already then use than for the new developer
   * If the organization does not exist then use the inputted name to make a new organization
   */
  developerCreate: DeveloperCreatePayload;
  developerUpdate: DeveloperUpdatePayload;
  /** Deletes the site's draft layout and everything only it introduced. Returns the effective layout. */
  discardSiteLayoutDraft?: Maybe<SiteLayout>;
  /**
   * Revokes the current user's Procore refresh token at Procore and removes
   * the FA IdP link. Idempotent — succeeds even if the user wasn't connected.
   */
  disconnectProcore: Success;
  /**
   * Records the environment's Avigilon readers and access control units, with
   * their ports, as devices on no site until assigned; a device already
   * recorded takes what Avigilon reports now. A device Avigilon no longer
   * reports is marked missing once its type is listed completely. Nothing is
   * written to Avigilon. Odin admins only.
   */
  discoverDevices: DiscoverDevicesPayload;
  enableJobsiteWorkerSelfOnboarding: JobsiteWorker;
  /** Creates a worker if it doesn't exist and initiates a passwordless login using phone number */
  ensureWorkerAndStartPasswordlessLogin: EnsureWorkerAndStartPasswordlessLoginResponse;
  extractIdDataFromFile: IdCardDataExtractionResult;
  forceResyncJobsite: SyncResult;
  forceResyncWorker: SyncResult;
  formArchive: FormArchivePayload;
  formCreate: FormCreatePayload;
  formUpdate: FormUpdatePayload;
  generateFormSubmissionsReport: File;
  /**
   * Not to be removed. This is used by the jobsite worker report to get the
   * downloadable file and by the automatically mailed report task
   */
  generateLookerJobsiteWorkerReport: File;
  grantAccessGroupMembership: AccessGroup;
  grantJobsiteAccessToWorker: AccessResult;
  importSchedule: ImportSchedulePayload;
  initiateStripePaymentSetupSession: InitiateStripePaymentSetupSessionPayload;
  jobsiteAddContractors: JobsiteAddContractorsPayload;
  jobsiteAddForm: JobsiteAddFormPayload;
  jobsiteArchiveFormSubmission: JobsiteArchiveFormSubmissionPayload;
  jobsiteArchiveInvitation: JobsiteArchiveInvitationPayload;
  jobsiteCloseOut: JobsiteCloseOutPayload;
  jobsiteContractorUpdateStripePaymentMethod: JobsiteContractorUpdateStripePaymentMethodPayload;
  /** Create a jobsite. Returns an error if developer, development project or CM does not exist. */
  jobsiteCreate: JobsiteCreatePayload;
  jobsiteCreateFormSubmission: JobsiteCreateFormSubmissionPayload;
  jobsiteCreateInvitation: JobsiteCreateInvitationPayload;
  jobsiteOffboardContractor: JobsiteOffboardContractorPayload;
  jobsiteReinstateContractor: JobsiteReinstateContractorPayload;
  jobsiteRemoveContractor: JobsiteRemoveContractorPayload;
  jobsiteRemoveForm: JobsiteRemoveFormPayload;
  jobsiteUpdate: JobsiteUpdatePayload;
  jobsiteUpdateContractor: JobsiteUpdateContractorPayload;
  jobsiteUpdateFormSubmission: JobsiteUpdateFormSubmissionPayload;
  /**
   * Authenticate at a shared field device using a worker badge and PIN.
   * On success the issued token carries authenticationType=PIN so the
   * ACL layer downgrades it to a small operation allowlist (a stolen
   * kiosk token must not be usable for admin endpoints). See
   * LoginInvalid and LoginRateLimited for the failure shapes.
   */
  loginWithPin: LoginWithPinResult;
  /**
   * Sign the calling user out of FusionAuth by revoking their refresh tokens,
   * so the session cannot be renewed once the client has discarded its own
   * copy of the credentials.
   *
   * Pass 'refreshToken' to revoke exactly that token, which signs out only the
   * calling device. Omit it and every refresh token the user holds for the
   * application that issued their access token is revoked, which signs them out
   * of that application everywhere. Scoping to the issuing application is what
   * keeps a mobile sign-out from also ending the caller's web portal session.
   *
   * Clients must clear their stored credentials regardless of what this returns.
   * A 'false' result means the refresh tokens are still live on FusionAuth, not
   * that the user should be left signed in.
   */
  logoutCurrentUser: Success;
  manuallyEnterCardNumberForPrintJob: WorkerCard;
  /**
   * Mobile counterpart of 'completeAnonymousPhoneVerification'. Completes the
   * accountless OTP for the mobile app: an existing account is signed in with a
   * full session (access + refresh), and a brand-new phone hands back a token for
   * the account-creation step. Carries no jobsite context.
   */
  mobileCompleteAnonymousPhoneVerification: MobileCompleteAnonymousPhoneVerificationResponse;
  /**
   * Creates the Odin account for a mobile self-registering worker (name only)
   * and links it to the FusionAuth user proven by the OTP step, signing the
   * worker in. The mobile app has no jobsite-invitation context, so — unlike
   * 'selfOnboardingCreateAccount' — there is no jobsite, contractor, or
   * jobsiteWorker: the worker is created as a standalone "orphan" account.
   * Email/birthDate/SSN are collected later via 'updateWorker'. Mobile
   * auth-first self-registration flow only.
   */
  mobileOnboardingCreateAccount: MobileOnboardingCreateAccountPayload;
  organizationDelete: OrganizationDeletePayload;
  /**
   * Completes the per-user Procore OAuth flow. The app frontend invokes this
   * after Procore redirects the browser back to /auth/procore/exchange with
   * a code and state. The API validates state, exchanges code for tokens,
   * captures the Procore user id, and writes the FA IdP link.
   */
  procoreOAuthExchange: ProcoreOAuthExchangeResponse;
  /**
   * Initiates the per-user Procore OAuth flow. The API generates a CSRF state
   * token, stashes a Redis marker keyed by state with a short TTL, and returns
   * the Procore authorize URL for the app frontend to navigate the browser to.
   */
  procoreOAuthStart: ProcoreOAuthStartResponse;
  /** Makes the site's draft its effective layout from now, closing the one it replaces. Returns the published revision. Refused, as SEED_REQUIRED, while the site has live gateways no entry is linked to. */
  publishSiteLayoutDraft: SiteLayout;
  reactivateTempBadge: TempBadgePayload;
  reactivateWorkerCard: Success;
  /**
   * Requests delivery of the site's effective layout to each of the site's
   * enabled connectors again, so the provider gets what it lacks. Delivery
   * runs in the background, and writes nothing to a provider while the site's
   * zones mode is Off; siteLayoutPublications reports how it went. Refused
   * while the site has no published layout.
   */
  reconcileSiteLayout: ReconcileSiteLayoutPayload;
  /**
   * Record the current user's consent to the given policy documents. Writes one
   * immutable consent row per document, capturing the client IP and user-agent
   * server-side. Idempotent — already-consented policies are skipped. Used by
   * the re-capture gate; account creation records consent via the same domain
   * logic inline.
   */
  recordPolicyConsent: Success;
  /**
   * Lists an enabled connector's provider resources again. Only the
   * connector's inventory and its run history change; no Odin entity,
   * connection, or provider resource does. Refuses a connector that is not
   * enabled or keeps no inventory, and answers a failed refresh with its
   * reason; types listed before the failure keep their new listing.
   */
  refreshConnectorInventory: RefreshConnectorInventoryPayload;
  /** Refresh a FusionAuth provided session */
  refreshFusionAuthSession: Auth;
  /**
   * Register or update an Expo push notification token for the current user's device.
   * Upserts by (userAccountDbId, deviceId) — re-registration on app launch updates the
   * token if it rotated. userAccountDbId is derived from the JWT, not client input.
   */
  registerDevicePushToken: Success;
  registerTempBadge: TempBadgePayload;
  registerWorkerForFacialRecognitionBadge: WorkerCard;
  reissueMobileBadge: WorkerCard;
  removeCardFromWorker: Success;
  /** Takes one entry out of the site's draft with its placements, in one transaction. */
  removeDraftEntry: RemoveDraftEntryPayload;
  /** Takes one zone out of the site's draft in one transaction; refused while an entry faces it. */
  removeDraftZone: RemoveDraftZonePayload;
  /**
   * Removes a controller from the site with the readers that belong to it,
   * keeping the hardware recorded. Refuses while one of those readers is
   * placed in the published layout, or a reader of the site has unresolved
   * ownership. Requires Manage site devices at the site, and the site's
   * layout to be enabled. Writes nothing to Avigilon.
   */
  removeSiteController: RemoveSiteControllerPayload;
  removeSiteReaderAttachment: SiteReaderAttachments;
  removeStripePaymentMethod?: Maybe<Array<StripePaymentMethod>>;
  /**
   * Remove a worker from a jobsite. Returns an error if there will be no more workers of the jobsite or if
   * the workerId is not a worker of the jobsite.
   */
  removeWorkerFromJobsite: RemoveWorkerFromJobsiteResponse;
  removeZoneFromAccessGroup: AccessGroup;
  renameAccessGroup: AccessGroup;
  reprintTempBadge: TempBadgePayload;
  reprintWorkerCard: WorkerCardPayload;
  /** Record a Support ownership correction as the authenticated Odin administrator. */
  resolveReaderOwnership: ResolveReaderOwnershipPayload;
  retryAccessGroupPush: AccessGroup;
  returnTempBadge: TempBadgePayload;
  revokeAccessGroupMembership: AccessGroup;
  /**
   * Revokes a data-sharing grant by archiving it (the record is preserved, not
   * deleted). Admin/super only.
   */
  revokeDeveloperJobsiteAccessGrant: DeveloperJobsiteAccessGrantPayload;
  revokeJobsiteAccessFromWorker: AccessResult;
  /**
   * Writes one entry of the site's draft whole in one transaction: its name,
   * both sides and the readers admitting into each. A reader placed on another
   * entry moves and is reported. A refusal writes nothing.
   */
  saveDraftEntry: SaveDraftEntryPayload;
  /**
   * Adds or renames one zone of the site's draft in one transaction, against
   * the draft and token the client read. A refusal writes nothing.
   */
  saveDraftZone: SaveDraftZonePayload;
  saveJobsiteWorkerInformation: JobsiteWorker;
  savePersonalInformation: Worker;
  saveUserSearchQuery: Success;
  /**
   * Turns the site's gateways no entry is linked to into entries of its draft,
   * opening the draft when there is none, and links each gateway to its entry.
   * Each new entry has side A outside and side B in the gateway's destination
   * zone, both None. Rerunning seeds only gateways still unlinked. A refusal
   * writes nothing.
   */
  seedEntriesFromGateways: SeedEntriesFromGatewaysPayload;
  /**
   * Binds an authenticated self-onboarding worker to a jobsite for the selected
   * contractor (assignment + access sync + default clearances + opt-out SMS),
   * resolving any resume/abort conflict via 'selfOnboardingInfo'. Fired at
   * contractor selection, after the account already exists. Authenticated
   * self-onboarding flow only.
   */
  selfOnboardingAssignToJobsite: SelfOnboardingAssignToJobsitePayload;
  /**
   * Creates the authenticated Odin account for a self-onboarding worker (name
   * only) and links it to the FusionAuth user proven by the OTP step, signing
   * the worker in. Email is collected later, on the jobsite-data step. No
   * contractor and no jobsiteWorker are involved here — the worker is bound to a
   * jobsite afterwards by 'selfOnboardingAssignToJobsite'. Authenticated
   * self-onboarding flow only.
   */
  selfOnboardingCreateAccount: SelfOnboardingCreateAccountPayload;
  selfOnboardingWorkerCreate: SelfOnboardingWorkerCreatePayload;
  selfOnboardingWorkerUpdate: SelfOnboardingWorkerUpdatePayload;
  /** Send password reset email */
  sendPasswordResetEmail?: Maybe<Scalars['String']['output']>;
  sendScheduleNotifications: SendScheduleNotificationsPayload;
  setConnectorEnabled: Connector;
  setDefaultAccessGroup: AccessGroup;
  setDefaultStripePaymentMethod?: Maybe<Array<StripePaymentMethod>>;
  /**
   * Persist the calling device's last committed station (jobsite + optional
   * gateway), keyed by the appInstanceId request header — one record per device,
   * last-writer-wins regardless of operator. Fired by the scanner on every
   * station commit. Guarded by the check-in-create capability so a device cannot
   * persist a station its operator could not scan at. See ADR 0010.
   */
  setDeviceLastStation: Success;
  /**
   * Set or rotate the current user's PIN. Also clears any active
   * credential lockout and rate-limit counters for the underlying
   * worker, so a user who locked themselves out can recover by
   * setting a new PIN from an authenticated web session. Blocked on
   * PIN-marked sessions by the ACL allowlist.
   */
  setMyPin: Success;
  setupAvigilonAccessConnector: Connector;
  setupAvigilonAccessWebhooks: WebhookSetupResult;
  setupAvigilonVideoConnector: Connector;
  /**
   * Begins an OTP for a phone number that has no associated account. Unlike
   * 'startPhoneNumberVerification' this requires no existing Odin worker or
   * account: when no FusionAuth user exists for the phone yet, a minimal one is
   * created from the phone alone, purely to mint and send the code.
   */
  startAnonymousPhoneVerification: StartAnonymousPhoneVerificationResponse;
  /** Initiates a passwordless login using phone number */
  startPasswordlessLogin: StartPasswordlessLoginResponse;
  /** Initiates a phone number verification request */
  startPhoneNumberVerification: StartPhoneNumberVerificationResponse;
  syncAllAvigilonAccessEnabledJobsites: BulkSyncResult;
  syncCCureObjects: Success;
  syncJobsiteToAvigilonAccess: SyncResult;
  /**
   * Refreshes one controller assigned to the site from Avigilon: the unit,
   * its ports and the readers on them or formerly associated with it, and
   * nothing else of the organization. Keeps the last successful information
   * on failure. Requires Manage site devices at the site, and the site's
   * layout to be enabled. Writes nothing to Avigilon.
   */
  syncSiteController: SyncSiteControllerPayload;
  syncWorkerToAvigilonAccess: SyncResult;
  testAvigilonAccessConnection: ConnectionTestResult;
  /** Track handing off the user to one of the integrations */
  trackIntegrationHandoff: IntegrationDetails;
  /** Track the current session. */
  trackSession: Success;
  /** Reverses 'archiveWorker': restores a worker and all nested objects such as jobsiteWorker, contractorWorker, and all documents */
  unarchiveWorker: Worker;
  /**
   * Remove the push notification token for the current user's device.
   * Called on explicit logout. userAccountDbId is derived from the JWT.
   */
  unregisterDevicePushToken: Success;
  updateContractorWorker: ContractorWorker;
  updateJobsiteAnnouncement: JobsiteAnnouncement;
  /** Update jobsite worker object using domain objects. Returns error if no worker found at jobsite. */
  updateJobsiteWorker: JobsiteWorker;
  updateJobsiteWorkerDocumentVersion: JobsiteWorkerDocumentVersion;
  updatePayrollDocumentVersionStatus: PayrollDocumentVersion;
  updateScheduleShift: UpdateScheduleShiftPayload;
  updateScheduleWorker: UpdateScheduleWorkerPayload;
  /** Update the app version stored in the user's session. */
  updateSessionAppVersion: Auth;
  updateVisitorLog: VisitorLogPayload;
  /** Update a worker. Returns an error if workerId is not found or if input is invalid. */
  updateWorker: Worker;
  updateWorkerCard: WorkerCard;
  uploadSingleFile: File;
  /**
   * Upload an image file that needs to be cropped/resized as well as uploaded.
   * Returns the original and cropped file ID's
   */
  uploadSingleImage: Array<File>;
  upsertJobsiteWorkerDocument: JobsiteWorkerDocumentVersion;
  /** Upsert a PayrollDocument - create or make new version. */
  upsertPayrollDocument: PayrollDocument;
  /** Assign a user to either jobsites or contractors */
  userAssign: UserPayload;
  userCancelPendingChange: Success;
  userConfirmPendingChange: UserPayload;
  /** Create a user and assign them to either jobsites or contractors. */
  userCreate: UserPayload;
  /** Update jobsite or contractor user assignment */
  userRemoveAssignment: UserPayload;
  /** Update jobsite or contractor user assignment */
  userUpdateAssignment: UserPayload;
  userUpdateIdentity: UserPayload;
  verifyAvigilonAccessWebhooks: WebhookVerifyResult;
  workerUnlockProfile: WorkerUnlockProfilePayload;
};

/** The root mutation object for all mutations */
export type MutationAddAndIssueFacialRecognitionBadgeArgs = {
  jobsiteId: Scalars['ID']['input'];
  newEmail?: InputMaybe<Scalars['String']['input']>;
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  workerCardInput: WorkerCardInput;
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationAddAndIssueMobileBadgeArgs = {
  jobsiteId: Scalars['ID']['input'];
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  workerCardInput: WorkerCardInput;
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationAddCardToWorkerArgs = {
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteId: Scalars['ID']['input'];
  workerCardInput: WorkerCardInput;
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationAddSiteControllerArgs = {
  input: AddSiteControllerInput;
};

/** The root mutation object for all mutations */
export type MutationAddZoneToAccessGroupArgs = {
  input: AccessGroupZoneInput;
};

/** The root mutation object for all mutations */
export type MutationAdoptInventoryItemArgs = {
  input: AdoptInventoryItemInput;
};

/** The root mutation object for all mutations */
export type MutationArchiveAccessGroupArgs = {
  input: AccessGroupInput;
};

/** The root mutation object for all mutations */
export type MutationArchiveJobsiteArgs = {
  jobsiteId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationArchiveJobsiteWorkerAccessEventArgs = {
  input?: InputMaybe<ArchiveJobsiteWorkerAccessEventInput>;
};

/** The root mutation object for all mutations */
export type MutationArchiveWorkerArgs = {
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationAssignContractorWorkerToJobsiteArgs = {
  input: AssignContractorWorkerToJobsiteInput;
};

/** The root mutation object for all mutations */
export type MutationAssignDeviceToSiteArgs = {
  input: AssignDeviceToSiteInput;
};

/** The root mutation object for all mutations */
export type MutationAssignTempBadgeArgs = {
  input: AssignTempBadgeInput;
};

/** The root mutation object for all mutations */
export type MutationAssignWorkerToContractorArgs = {
  contractorId: Scalars['ID']['input'];
  contractorWorkerInput: ContractorWorkerInput;
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationAuthenticateLimitedTokenDetailsArgs = {
  input?: InputMaybe<AuthenticateLimitedTokenDetailsInput>;
};

/** The root mutation object for all mutations */
export type MutationBulkUpdateJobsiteWorkersArgs = {
  jobsiteWorkerInputs: Array<BulkJobsiteWorkerInput>;
};

/** The root mutation object for all mutations */
export type MutationChangeContractorForJobsiteWorkersArgs = {
  input?: InputMaybe<ChangeContractorForJobsiteWorkersInput>;
};

/** The root mutation object for all mutations */
export type MutationChangeJobsiteWorkersJobsiteAssignmentArgs = {
  input: ChangeJobsiteWorkersJobsiteAssignmentInput;
};

/** The root mutation object for all mutations */
export type MutationChangeScheduleStatusArgs = {
  input: ChangeScheduleStatusInput;
};

/** The root mutation object for all mutations */
export type MutationChangeZonesModeArgs = {
  input: ChangeZonesModeInput;
};

/** The root mutation object for all mutations */
export type MutationCheckInJobsiteWorkersArgs = {
  input: CheckInJobsiteWorkersInput;
};

/** The root mutation object for all mutations */
export type MutationCheckInWorkersArgs = {
  input?: InputMaybe<WorkersCheckInInput>;
};

/** The root mutation object for all mutations */
export type MutationCompleteAnonymousPhoneVerificationArgs = {
  input: CompleteAnonymousPhoneVerificationInput;
};

/** The root mutation object for all mutations */
export type MutationCompletePasswordlessLoginArgs = {
  input: CompletePasswordlessLoginInput;
};

/** The root mutation object for all mutations */
export type MutationCompletePhoneNumberVerificationArgs = {
  input?: InputMaybe<CompletePhoneNumberVerificationInput>;
};

/** The root mutation object for all mutations */
export type MutationCompletePhoneNumberVerificationAndSignInArgs = {
  input?: InputMaybe<CompletePhoneNumberVerificationAndSignInInput>;
};

/** The root mutation object for all mutations */
export type MutationCompleteSelfOnBoardingArgs = {
  jobsiteWorkerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationContractorAddJobsitesArgs = {
  input: ContractorAddJobsitesInput;
};

/** The root mutation object for all mutations */
export type MutationContractorArchiveArgs = {
  input: ContractorArchiveInput;
};

/** The root mutation object for all mutations */
export type MutationContractorCreateArgs = {
  input: ContractorCreateInput;
};

/** The root mutation object for all mutations */
export type MutationContractorRemoveWorkerArgs = {
  input: ContractorRemoveWorkerInput;
};

/** The root mutation object for all mutations */
export type MutationContractorUpdateArgs = {
  input: ContractorUpdateInput;
};

/** The root mutation object for all mutations */
export type MutationCreateAccessGroupArgs = {
  input: CreateAccessGroupInput;
};

/** The root mutation object for all mutations */
export type MutationCreateAndPrintTempBadgeArgs = {
  input: CreateTempBadgeInput;
};

/** The root mutation object for all mutations */
export type MutationCreateAndPrintWorkerCardArgs = {
  input: CreateWorkerCardInput;
};

/** The root mutation object for all mutations */
export type MutationCreateCardPrintJobArgs = {
  input: CreateCardPrintJobInput;
};

/** The root mutation object for all mutations */
export type MutationCreateContractorStripeInvoiceArgs = {
  input: CreateContractorStripeInvoiceInput;
};

/** The root mutation object for all mutations */
export type MutationCreateContractorWorkerArgs = {
  createContractorWorkerInput?: InputMaybe<CreateContractorWorkerInput>;
};

/** The root mutation object for all mutations */
export type MutationCreateDeveloperJobsiteAccessGrantArgs = {
  input: CreateDeveloperJobsiteAccessGrantInput;
};

/** The root mutation object for all mutations */
export type MutationCreateJobsiteAnnouncementArgs = {
  jobsiteAnnouncementInput: JobsiteAnnouncementInput;
};

/** The root mutation object for all mutations */
export type MutationCreateJobsiteWorkerDocumentArgs = {
  jobsiteWorkerDocumentInput: JobsiteWorkerDocumentInput;
  jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput;
};

/** The root mutation object for all mutations */
export type MutationCreateJobsiteWorkerDocumentVersionArgs = {
  jobsiteWorkerDocumentId: Scalars['ID']['input'];
  jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput;
};

/** The root mutation object for all mutations */
export type MutationCreatePayrollDocumentArgs = {
  createPayrollDocumentInput?: InputMaybe<CreatePayrollDocumentInput>;
  createPayrollDocumentVersionInput?: InputMaybe<CreatePayrollDocumentVersionInput>;
};

/** The root mutation object for all mutations */
export type MutationCreatePayrollDocumentVersionArgs = {
  createPayrollDocumentVersionInput: CreatePayrollDocumentVersionInput;
  payrollDocumentId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationCreateScheduleShiftArgs = {
  input: CreateScheduleShiftInput;
};

/** The root mutation object for all mutations */
export type MutationCreateScheduleWorkerArgs = {
  input: CreateScheduleWorkerInput;
};

/** The root mutation object for all mutations */
export type MutationCreateScheduleWorkerSessionArgs = {
  input: CreateScheduleWorkerSessionInput;
};

/** The root mutation object for all mutations */
export type MutationCreateSiteLayoutDraftArgs = {
  input: CreateSiteLayoutDraftInput;
};

/** The root mutation object for all mutations */
export type MutationCreateVisitorLogArgs = {
  input: LogVisitorInput;
};

/** The root mutation object for all mutations */
export type MutationCreateWorkerArgs = {
  input: CreateWorkerInput;
};

/** The root mutation object for all mutations */
export type MutationCreateWorkerCommentArgs = {
  workerCommentInput: WorkerCommentInput;
};

/** The root mutation object for all mutations */
export type MutationDeactivateTempBadgeArgs = {
  id: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationDeleteJobsiteAnnouncementArgs = {
  jobsiteAnnouncementId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationDeleteJobsiteWorkerDocumentArgs = {
  jobsiteWorkerDocumentId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationDeletePayrollDocumentArgs = {
  contractorId: Scalars['ID']['input'];
  payrollDocumentId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationDeleteScheduleShiftArgs = {
  id: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationDeleteScheduleWorkerArgs = {
  id: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationDeveloperCreateArgs = {
  input: DeveloperCreateInput;
};

/** The root mutation object for all mutations */
export type MutationDeveloperUpdateArgs = {
  input: DeveloperUpdateInput;
};

/** The root mutation object for all mutations */
export type MutationDiscardSiteLayoutDraftArgs = {
  input: DiscardSiteLayoutDraftInput;
};

/** The root mutation object for all mutations */
export type MutationEnableJobsiteWorkerSelfOnboardingArgs = {
  jobsiteWorkerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationEnsureWorkerAndStartPasswordlessLoginArgs = {
  input: EnsureWorkerAndStartPasswordlessLoginInput;
};

/** The root mutation object for all mutations */
export type MutationExtractIdDataFromFileArgs = {
  extractionInput: DataExtractionInput;
};

/** The root mutation object for all mutations */
export type MutationForceResyncJobsiteArgs = {
  jobsiteId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationForceResyncWorkerArgs = {
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationFormArchiveArgs = {
  input: FormArchiveInput;
};

/** The root mutation object for all mutations */
export type MutationFormCreateArgs = {
  input: FormCreateInput;
};

/** The root mutation object for all mutations */
export type MutationFormUpdateArgs = {
  input: FormUpdateInput;
};

/** The root mutation object for all mutations */
export type MutationGenerateFormSubmissionsReportArgs = {
  input?: InputMaybe<FormSubmissionsReportInput>;
};

/** The root mutation object for all mutations */
export type MutationGenerateLookerJobsiteWorkerReportArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  compliant?: InputMaybe<Scalars['Boolean']['input']>;
  contractor?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['Date']['input'];
  export?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  overnight?: InputMaybe<Scalars['Boolean']['input']>;
  realtime?: InputMaybe<Scalars['Boolean']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  trade?: InputMaybe<Scalars['String']['input']>;
};

/** The root mutation object for all mutations */
export type MutationGrantAccessGroupMembershipArgs = {
  input: AccessGroupMembershipInput;
};

/** The root mutation object for all mutations */
export type MutationGrantJobsiteAccessToWorkerArgs = {
  jobsiteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationImportScheduleArgs = {
  input: ImportScheduleInput;
};

/** The root mutation object for all mutations */
export type MutationInitiateStripePaymentSetupSessionArgs = {
  input: InitiateStripePaymentSetupSessionInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteAddContractorsArgs = {
  input: JobsiteAddContractorsInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteAddFormArgs = {
  input: JobsiteAddFormInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteArchiveFormSubmissionArgs = {
  input: JobsiteArchiveFormSubmissionInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteArchiveInvitationArgs = {
  input: JobsiteArchiveInvitationInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteCloseOutArgs = {
  input: JobsiteCloseOutInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteContractorUpdateStripePaymentMethodArgs = {
  input: JobsiteContractorUpdateStripePaymentMethodInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteCreateArgs = {
  input: JobsiteCreateInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteCreateFormSubmissionArgs = {
  input: JobsiteCreateFormSubmissionInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteCreateInvitationArgs = {
  input: JobsiteCreateInvitationInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteOffboardContractorArgs = {
  input: JobsiteOffboardContractorInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteReinstateContractorArgs = {
  input: JobsiteReinstateContractorInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteRemoveContractorArgs = {
  input: JobsiteRemoveContractorInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteRemoveFormArgs = {
  input: JobsiteRemoveFormInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteUpdateArgs = {
  input: JobsiteUpdateInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteUpdateContractorArgs = {
  input: JobsiteUpdateContractorInput;
};

/** The root mutation object for all mutations */
export type MutationJobsiteUpdateFormSubmissionArgs = {
  input: JobsiteUpdateFormSubmissionInput;
};

/** The root mutation object for all mutations */
export type MutationLoginWithPinArgs = {
  input: LoginWithPinInput;
};

/** The root mutation object for all mutations */
export type MutationLogoutCurrentUserArgs = {
  refreshToken?: InputMaybe<Scalars['String']['input']>;
};

/** The root mutation object for all mutations */
export type MutationManuallyEnterCardNumberForPrintJobArgs = {
  cardNumber: Scalars['String']['input'];
  cardPrintJobId: Scalars['ID']['input'];
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
  workerCardFormatId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationMobileCompleteAnonymousPhoneVerificationArgs = {
  input: MobileCompleteAnonymousPhoneVerificationInput;
};

/** The root mutation object for all mutations */
export type MutationMobileOnboardingCreateAccountArgs = {
  input: MobileOnboardingCreateAccountInput;
};

/** The root mutation object for all mutations */
export type MutationOrganizationDeleteArgs = {
  organizationId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationProcoreOAuthExchangeArgs = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

/** The root mutation object for all mutations */
export type MutationPublishSiteLayoutDraftArgs = {
  input: PublishSiteLayoutDraftInput;
};

/** The root mutation object for all mutations */
export type MutationReactivateTempBadgeArgs = {
  id: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationReactivateWorkerCardArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationReconcileSiteLayoutArgs = {
  input: ReconcileSiteLayoutInput;
};

/** The root mutation object for all mutations */
export type MutationRecordPolicyConsentArgs = {
  input: RecordPolicyConsentInput;
};

/** The root mutation object for all mutations */
export type MutationRefreshConnectorInventoryArgs = {
  input: RefreshConnectorInventoryInput;
};

/** The root mutation object for all mutations */
export type MutationRefreshFusionAuthSessionArgs = {
  refreshToken: Scalars['String']['input'];
};

/** The root mutation object for all mutations */
export type MutationRegisterDevicePushTokenArgs = {
  input: RegisterDevicePushTokenInput;
};

/** The root mutation object for all mutations */
export type MutationRegisterTempBadgeArgs = {
  input: RegisterTempBadgeInput;
};

/** The root mutation object for all mutations */
export type MutationRegisterWorkerForFacialRecognitionBadgeArgs = {
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  workerCardId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationReissueMobileBadgeArgs = {
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  workerCardId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationRemoveCardFromWorkerArgs = {
  deactivateCardReason?: InputMaybe<Scalars['String']['input']>;
  workerCardIds: Array<Scalars['String']['input']>;
};

/** The root mutation object for all mutations */
export type MutationRemoveDraftEntryArgs = {
  input: RemoveDraftEntryInput;
};

/** The root mutation object for all mutations */
export type MutationRemoveDraftZoneArgs = {
  input: RemoveDraftZoneInput;
};

/** The root mutation object for all mutations */
export type MutationRemoveSiteControllerArgs = {
  input: RemoveSiteControllerInput;
};

/** The root mutation object for all mutations */
export type MutationRemoveSiteReaderAttachmentArgs = {
  input: RemoveSiteReaderAttachmentInput;
};

/** The root mutation object for all mutations */
export type MutationRemoveStripePaymentMethodArgs = {
  input: ManageContractorStripePaymentMethodInput;
};

/** The root mutation object for all mutations */
export type MutationRemoveWorkerFromJobsiteArgs = {
  input: RemoveWorkerFromJobsiteInput;
};

/** The root mutation object for all mutations */
export type MutationRemoveZoneFromAccessGroupArgs = {
  input: AccessGroupZoneInput;
};

/** The root mutation object for all mutations */
export type MutationRenameAccessGroupArgs = {
  input: RenameAccessGroupInput;
};

/** The root mutation object for all mutations */
export type MutationReprintTempBadgeArgs = {
  input: ReprintTempBadgeInput;
};

/** The root mutation object for all mutations */
export type MutationReprintWorkerCardArgs = {
  input: PrintWorkerCardInput;
};

/** The root mutation object for all mutations */
export type MutationResolveReaderOwnershipArgs = {
  input: ResolveReaderOwnershipInput;
};

/** The root mutation object for all mutations */
export type MutationRetryAccessGroupPushArgs = {
  input: AccessGroupInput;
};

/** The root mutation object for all mutations */
export type MutationReturnTempBadgeArgs = {
  id: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationRevokeAccessGroupMembershipArgs = {
  input: RevokeAccessGroupMembershipInput;
};

/** The root mutation object for all mutations */
export type MutationRevokeDeveloperJobsiteAccessGrantArgs = {
  input: RevokeDeveloperJobsiteAccessGrantInput;
};

/** The root mutation object for all mutations */
export type MutationRevokeJobsiteAccessFromWorkerArgs = {
  jobsiteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationSaveDraftEntryArgs = {
  input: SaveDraftEntryInput;
};

/** The root mutation object for all mutations */
export type MutationSaveDraftZoneArgs = {
  input: SaveDraftZoneInput;
};

/** The root mutation object for all mutations */
export type MutationSaveJobsiteWorkerInformationArgs = {
  jobsiteWorkerInformationInput: JobsiteWorkerInformationInput;
};

/** The root mutation object for all mutations */
export type MutationSavePersonalInformationArgs = {
  personalInformationInput: PersonalInformationInput;
};

/** The root mutation object for all mutations */
export type MutationSaveUserSearchQueryArgs = {
  input: UserSearchQueryInput;
};

/** The root mutation object for all mutations */
export type MutationSeedEntriesFromGatewaysArgs = {
  input: SeedEntriesFromGatewaysInput;
};

/** The root mutation object for all mutations */
export type MutationSelfOnboardingAssignToJobsiteArgs = {
  input: SelfOnboardingAssignToJobsiteInput;
};

/** The root mutation object for all mutations */
export type MutationSelfOnboardingCreateAccountArgs = {
  input: SelfOnboardingCreateAccountInput;
};

/** The root mutation object for all mutations */
export type MutationSelfOnboardingWorkerCreateArgs = {
  input: SelfOnboardingWorkerAccountCreateInput;
};

/** The root mutation object for all mutations */
export type MutationSelfOnboardingWorkerUpdateArgs = {
  input: SelfOnboardingWorkerAccountUpdateInput;
};

/** The root mutation object for all mutations */
export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String']['input'];
  sendForgotPasswordEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The root mutation object for all mutations */
export type MutationSendScheduleNotificationsArgs = {
  input: SendScheduleNotificationsInput;
};

/** The root mutation object for all mutations */
export type MutationSetConnectorEnabledArgs = {
  connectorId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
};

/** The root mutation object for all mutations */
export type MutationSetDefaultAccessGroupArgs = {
  input: AccessGroupInput;
};

/** The root mutation object for all mutations */
export type MutationSetDefaultStripePaymentMethodArgs = {
  input: ManageContractorStripePaymentMethodInput;
};

/** The root mutation object for all mutations */
export type MutationSetDeviceLastStationArgs = {
  input: SetDeviceLastStationInput;
};

/** The root mutation object for all mutations */
export type MutationSetMyPinArgs = {
  input: SetMyPinInput;
};

/** The root mutation object for all mutations */
export type MutationSetupAvigilonAccessConnectorArgs = {
  input: SetupAvigilonAccessConnectorInput;
};

/** The root mutation object for all mutations */
export type MutationSetupAvigilonVideoConnectorArgs = {
  input: SetupAvigilonVideoConnectorInput;
};

/** The root mutation object for all mutations */
export type MutationStartAnonymousPhoneVerificationArgs = {
  input: StartAnonymousPhoneVerificationInput;
};

/** The root mutation object for all mutations */
export type MutationStartPasswordlessLoginArgs = {
  input: StartPasswordlessLoginInput;
};

/** The root mutation object for all mutations */
export type MutationStartPhoneNumberVerificationArgs = {
  input?: InputMaybe<StartPhoneNumberVerificationInput>;
};

/** The root mutation object for all mutations */
export type MutationSyncCCureObjectsArgs = {
  backfillPersonnelGuids?: InputMaybe<Scalars['Boolean']['input']>;
  fullSync?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The root mutation object for all mutations */
export type MutationSyncJobsiteToAvigilonAccessArgs = {
  jobsiteId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationSyncSiteControllerArgs = {
  input: SyncSiteControllerInput;
};

/** The root mutation object for all mutations */
export type MutationSyncWorkerToAvigilonAccessArgs = {
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationTrackIntegrationHandoffArgs = {
  integrationType: ExternalIntegrationType;
};

/** The root mutation object for all mutations */
export type MutationTrackSessionArgs = {
  sessionType: SessionType;
};

/** The root mutation object for all mutations */
export type MutationUnarchiveWorkerArgs = {
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationUnregisterDevicePushTokenArgs = {
  input: UnregisterDevicePushTokenInput;
};

/** The root mutation object for all mutations */
export type MutationUpdateContractorWorkerArgs = {
  contractorId: Scalars['ID']['input'];
  contractorWorkerInput: ContractorWorkerInput;
  workerId: Scalars['ID']['input'];
};

/** The root mutation object for all mutations */
export type MutationUpdateJobsiteAnnouncementArgs = {
  jobsiteAnnouncementId: Scalars['ID']['input'];
  jobsiteAnnouncementInput: JobsiteAnnouncementInput;
};

/** The root mutation object for all mutations */
export type MutationUpdateJobsiteWorkerArgs = {
  jobsiteWorkerId: Scalars['ID']['input'];
  jobsiteWorkerInput: JobsiteWorkerInput;
  skipACSSync?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The root mutation object for all mutations */
export type MutationUpdateJobsiteWorkerDocumentVersionArgs = {
  jobsiteWorkerDocumentVersionId: Scalars['ID']['input'];
  jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput;
};

/** The root mutation object for all mutations */
export type MutationUpdatePayrollDocumentVersionStatusArgs = {
  payrollDocumentVersionId: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status: PayrollStatus;
};

/** The root mutation object for all mutations */
export type MutationUpdateScheduleShiftArgs = {
  input: UpdateScheduleShiftInput;
};

/** The root mutation object for all mutations */
export type MutationUpdateScheduleWorkerArgs = {
  input: UpdateScheduleWorkerInput;
};

/** The root mutation object for all mutations */
export type MutationUpdateSessionAppVersionArgs = {
  appVersion: Scalars['String']['input'];
};

/** The root mutation object for all mutations */
export type MutationUpdateVisitorLogArgs = {
  input: LogVisitorInput;
};

/** The root mutation object for all mutations */
export type MutationUpdateWorkerArgs = {
  workerId: Scalars['ID']['input'];
  workerInput: WorkerInput;
};

/** The root mutation object for all mutations */
export type MutationUpdateWorkerCardArgs = {
  workerCardId: Scalars['ID']['input'];
  workerCardInput: WorkerCardInput;
};

/** The root mutation object for all mutations */
export type MutationUploadSingleFileArgs = {
  fileInput: FileInput;
};

/** The root mutation object for all mutations */
export type MutationUploadSingleImageArgs = {
  fileInput: FileInput;
  sizeInput?: InputMaybe<SizeInput>;
};

/** The root mutation object for all mutations */
export type MutationUpsertJobsiteWorkerDocumentArgs = {
  input: JobsiteWorkerDocumentUpsertInput;
};

/** The root mutation object for all mutations */
export type MutationUpsertPayrollDocumentArgs = {
  createPayrollDocumentInput?: InputMaybe<CreatePayrollDocumentInput>;
  createPayrollDocumentVersionInput?: InputMaybe<CreatePayrollDocumentVersionInput>;
};

/** The root mutation object for all mutations */
export type MutationUserAssignArgs = {
  input: UserAssignInput;
};

/** The root mutation object for all mutations */
export type MutationUserCancelPendingChangeArgs = {
  input: UserCancelPendingChangeInput;
};

/** The root mutation object for all mutations */
export type MutationUserConfirmPendingChangeArgs = {
  input: UserConfirmPendingChangeInput;
};

/** The root mutation object for all mutations */
export type MutationUserCreateArgs = {
  input: UserCreateInput;
};

/** The root mutation object for all mutations */
export type MutationUserRemoveAssignmentArgs = {
  input: UserRemoveAssignmentInput;
};

/** The root mutation object for all mutations */
export type MutationUserUpdateAssignmentArgs = {
  input: UserUpdateAssignmentInput;
};

/** The root mutation object for all mutations */
export type MutationUserUpdateIdentityArgs = {
  input: UserUpdateIdentityInput;
};

/** The root mutation object for all mutations */
export type MutationWorkerUnlockProfileArgs = {
  input: WorkerUnlockProfileInput;
};

export type ObjectHistory = {
  __typename?: 'ObjectHistory';
  /** Created date */
  createdAt: Scalars['Date']['output'];
  /** Created by user */
  createdBy?: Maybe<User>;
  /** Deleted date */
  deletedAt?: Maybe<Scalars['Date']['output']>;
  /** Deleted by user */
  deletedBy?: Maybe<User>;
  /** Last updated date */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Updated by user */
  updatedBy?: Maybe<User>;
};

export enum ObjectName {
  AclGrant = 'ACLGrant',
  AclObject = 'ACLObject',
  AclRole = 'ACLRole',
  AdditionalFieldValue = 'AdditionalFieldValue',
  AdditionalWorkerProfileData = 'AdditionalWorkerProfileData',
  AppUserConnection = 'AppUserConnection',
  ArchiveJobsiteWorkerAccessEventResponse = 'ArchiveJobsiteWorkerAccessEventResponse',
  Auth = 'Auth',
  BadgeTemplate = 'BadgeTemplate',
  CCureObjectSync = 'CCureObjectSync',
  CardPrintJob = 'CardPrintJob',
  CardPrintJobCompletion = 'CardPrintJobCompletion',
  CardPrintJobError = 'CardPrintJobError',
  ChangeContractorForJobsiteWorkersError = 'ChangeContractorForJobsiteWorkersError',
  ChangeContractorForJobsiteWorkersResponse = 'ChangeContractorForJobsiteWorkersResponse',
  ChangeContractorForJobsiteWorkersSuccess = 'ChangeContractorForJobsiteWorkersSuccess',
  ChangeJobsiteWorkersJobsiteAssignmentResponse = 'ChangeJobsiteWorkersJobsiteAssignmentResponse',
  Contractor = 'Contractor',
  ContractorMember = 'ContractorMember',
  ContractorWorker = 'ContractorWorker',
  ContractorWorkerConnection = 'ContractorWorkerConnection',
  ContractorWorkerConnectionFacets = 'ContractorWorkerConnectionFacets',
  CreateJobsiteInvitationResponse = 'CreateJobsiteInvitationResponse',
  CreateLookerJobsiteWorkerReportsResponse = 'CreateLookerJobsiteWorkerReportsResponse',
  DashboardJobsiteWorkerSession = 'DashboardJobsiteWorkerSession',
  Developer = 'Developer',
  DeveloperJobsiteAccessGrant = 'DeveloperJobsiteAccessGrant',
  DeveloperMember = 'DeveloperMember',
  DevicePushToken = 'DevicePushToken',
  ElasticFacetEntry = 'ElasticFacetEntry',
  ExternalIntegrationMapping = 'ExternalIntegrationMapping',
  FacetCount = 'FacetCount',
  File = 'File',
  FileDownloadRedirect = 'FileDownloadRedirect',
  Form = 'Form',
  GpsCoordinate = 'GPSCoordinate',
  GetAllContractorsResponse = 'GetAllContractorsResponse',
  GetJobsiteContractorsResponse = 'GetJobsiteContractorsResponse',
  GetJobsiteEquipmentDataResponse = 'GetJobsiteEquipmentDataResponse',
  GetJobsiteEquipmentHistoryResponse = 'GetJobsiteEquipmentHistoryResponse',
  GetJobsiteInvitationsDataResponse = 'GetJobsiteInvitationsDataResponse',
  GetJobsitePacsGatewaysResponse = 'GetJobsitePacsGatewaysResponse',
  GetJobsiteWorkerReportsResponse = 'GetJobsiteWorkerReportsResponse',
  GetMemberJobsitesResponse = 'GetMemberJobsitesResponse',
  GetWorkerAccessEventsResponse = 'GetWorkerAccessEventsResponse',
  GetWorkerDocumentsResponse = 'GetWorkerDocumentsResponse',
  HistoricalJobsiteWorker = 'HistoricalJobsiteWorker',
  ILookerWorkerSessionData = 'ILookerWorkerSessionData',
  Jobsite = 'Jobsite',
  JobsiteAccessEvent = 'JobsiteAccessEvent',
  JobsiteAccessEventsConnection = 'JobsiteAccessEventsConnection',
  JobsiteAccessSession = 'JobsiteAccessSession',
  JobsiteAnnouncement = 'JobsiteAnnouncement',
  JobsiteAppCheckInModule = 'JobsiteAppCheckInModule',
  JobsiteAppCheckInModuleArea = 'JobsiteAppCheckInModuleArea',
  JobsiteBadgeTemplate = 'JobsiteBadgeTemplate',
  JobsiteCardFormat = 'JobsiteCardFormat',
  JobsiteContractor = 'JobsiteContractor',
  JobsiteEquipmentData = 'JobsiteEquipmentData',
  JobsiteEquipmentEvent = 'JobsiteEquipmentEvent',
  JobsiteFeaturesModule = 'JobsiteFeaturesModule',
  JobsiteForm = 'JobsiteForm',
  JobsiteFormSubmission = 'JobsiteFormSubmission',
  JobsiteFormSubmissionContractor = 'JobsiteFormSubmissionContractor',
  JobsiteFormSubmissionDocument = 'JobsiteFormSubmissionDocument',
  JobsiteFormSubmissionWorker = 'JobsiteFormSubmissionWorker',
  JobsiteInvitation = 'JobsiteInvitation',
  JobsiteMember = 'JobsiteMember',
  JobsiteOnboardingDocument = 'JobsiteOnboardingDocument',
  JobsiteOnboardingField = 'JobsiteOnboardingField',
  JobsiteOnboardingModule = 'JobsiteOnboardingModule',
  JobsiteOnboardingStep = 'JobsiteOnboardingStep',
  JobsitePacsGateway = 'JobsitePacsGateway',
  JobsitePreOnboardingField = 'JobsitePreOnboardingField',
  JobsitePreOnboardingModule = 'JobsitePreOnboardingModule',
  JobsitePreOnboardingStep = 'JobsitePreOnboardingStep',
  JobsitePrinter = 'JobsitePrinter',
  JobsiteStats = 'JobsiteStats',
  JobsiteWorker = 'JobsiteWorker',
  JobsiteWorkerAccess = 'JobsiteWorkerAccess',
  JobsiteWorkerCheckIn = 'JobsiteWorkerCheckIn',
  JobsiteWorkerCheckInConnection = 'JobsiteWorkerCheckInConnection',
  JobsiteWorkerCheckInSuggestion = 'JobsiteWorkerCheckInSuggestion',
  JobsiteWorkerCheckInSuggestionConnection = 'JobsiteWorkerCheckInSuggestionConnection',
  JobsiteWorkerCompact = 'JobsiteWorkerCompact',
  JobsiteWorkerConnection = 'JobsiteWorkerConnection',
  JobsiteWorkerDocument = 'JobsiteWorkerDocument',
  JobsiteWorkerDocumentType = 'JobsiteWorkerDocumentType',
  JobsiteWorkerDocumentVersion = 'JobsiteWorkerDocumentVersion',
  JobsiteWorkerReportContractorBreakdown = 'JobsiteWorkerReportContractorBreakdown',
  JobsiteWorkerReportResult = 'JobsiteWorkerReportResult',
  JobsiteWorkerReportTradeBreakdown = 'JobsiteWorkerReportTradeBreakdown',
  JobsitesStats = 'JobsitesStats',
  MobileDashboardForWorkerResponse = 'MobileDashboardForWorkerResponse',
  MobileDashboardMessage = 'MobileDashboardMessage',
  ObjectFile = 'ObjectFile',
  ObjectHistory = 'ObjectHistory',
  Organization = 'Organization',
  OrganizationMember = 'OrganizationMember',
  PayrollDocument = 'PayrollDocument',
  PayrollDocumentType = 'PayrollDocumentType',
  PayrollDocumentVersion = 'PayrollDocumentVersion',
  PreExistingWorkerResponse = 'PreExistingWorkerResponse',
  ProximitySessionLocaleData = 'ProximitySessionLocaleData',
  ProximitySessionLocaleTimeData = 'ProximitySessionLocaleTimeData',
  ProximitySessionReadsCountData = 'ProximitySessionReadsCountData',
  ProximitySessionReadsData = 'ProximitySessionReadsData',
  ProximitySessionReadsDirectionData = 'ProximitySessionReadsDirectionData',
  ProximitySessionResult = 'ProximitySessionResult',
  ProximitySessionSpanData = 'ProximitySessionSpanData',
  RemoveWorkerFromJobsiteResponse = 'RemoveWorkerFromJobsiteResponse',
  Role = 'Role',
  Schedule = 'Schedule',
  ScheduleNotificationPreview = 'ScheduleNotificationPreview',
  ScheduleShift = 'ScheduleShift',
  ScheduleWorker = 'ScheduleWorker',
  ScheduleWorkerSession = 'ScheduleWorkerSession',
  Success = 'Success',
  TempBadge = 'TempBadge',
  User = 'User',
  UserAccount = 'UserAccount',
  UserIdentity = 'UserIdentity',
  UserPin = 'UserPin',
  UserRole = 'UserRole',
  UserRoleObject = 'UserRoleObject',
  UserSearchQuery = 'UserSearchQuery',
  UserSearchQueryResponse = 'UserSearchQueryResponse',
  UserSession = 'UserSession',
  VisitorLog = 'VisitorLog',
  WeatherConditions = 'WeatherConditions',
  Worker = 'Worker',
  WorkerAccessEvent = 'WorkerAccessEvent',
  WorkerAccessHistory = 'WorkerAccessHistory',
  WorkerAuth = 'WorkerAuth',
  WorkerCCureData = 'WorkerCCureData',
  WorkerCard = 'WorkerCard',
  WorkerCardFormat = 'WorkerCardFormat',
  WorkerComment = 'WorkerComment',
  WorkerCommentConnection = 'WorkerCommentConnection',
  WorkerDocumentType = 'WorkerDocumentType',
  WorkerJobsiteBan = 'WorkerJobsiteBan',
  WorkerPhi = 'WorkerPHI',
  WorkerSearchResponse = 'WorkerSearchResponse',
  WorkerSearchResult = 'WorkerSearchResult',
}

export enum OnClockRequirementStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  NotStarted = 'not_started',
}

export enum OnboardingDocumentIncompleteStatus {
  Expired = 'Expired',
  Incomplete = 'Incomplete',
}

export enum OnboardingStepCompleteErrorCode {
  IncompleteRequiredVideos = 'INCOMPLETE_REQUIRED_VIDEOS',
}

export { OnboardingStepKey };

export { OnboardingStepName };

export { OnboardingStepSkipReason };

export enum OrderByDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}

/** Organization return type. */
export type Organization = {
  __typename?: 'Organization';
  /** City of the organization */
  addressCity?: Maybe<Scalars['String']['output']>;
  /** Address of the organization */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Address of the organization */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** State of the organization */
  addressState?: Maybe<StateAbbreviation>;
  /** Zip code of the organization */
  addressZipCode?: Maybe<Scalars['String']['output']>;
  contractors?: Maybe<OrganizationContractorsConnection>;
  developers?: Maybe<OrganizationDevelopersConnection>;
  /** Email for primary point of contact at organization */
  email?: Maybe<Scalars['String']['output']>;
  /** Legal name of the organization */
  legalName?: Maybe<Scalars['String']['output']>;
  /** Name of the organization */
  name: Scalars['String']['output'];
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Unique indetifier for the organization */
  organizationId: Scalars['ID']['output'];
  /** Phone number for primary point of contact at organization */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Slug of the organization. Short, unique, human-readable identifier.
   * Can only contain numbers, letters, and hyphens.
   */
  slug: Scalars['String']['output'];
};

/** Organization return type. */
export type OrganizationContractorsArgs = {
  input?: InputMaybe<OrganizationContractorsInput>;
};

/** Organization return type. */
export type OrganizationDevelopersArgs = {
  input?: InputMaybe<OrganizationDevelopersInput>;
};

export type OrganizationContractorsConnection = {
  __typename?: 'OrganizationContractorsConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationContractorsEdge>;
};

export type OrganizationContractorsEdge = {
  __typename?: 'OrganizationContractorsEdge';
  node: Contractor;
};

export type OrganizationContractorsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type OrganizationDeletePayload = {
  __typename?: 'OrganizationDeletePayload';
  success: Success;
};

export type OrganizationDevelopersConnection = {
  __typename?: 'OrganizationDevelopersConnection';
  count: Scalars['Int']['output'];
  edges: Array<OrganizationDevelopersEdge>;
};

export type OrganizationDevelopersEdge = {
  __typename?: 'OrganizationDevelopersEdge';
  node: Developer;
};

export type OrganizationDevelopersInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type OrganizationInput = {
  /** City of the organization */
  addressCity?: InputMaybe<Scalars['String']['input']>;
  /** Address of the organization */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address of the organization */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** State of the organization */
  addressState?: InputMaybe<StateAbbreviation>;
  /** Zip code of the organization */
  addressZipCode?: InputMaybe<Scalars['String']['input']>;
  /** Email for primary point of contact at organization */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Legal Name */
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number for primary point of contact at organization */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Slug of the organization. Short, unique, human-readable identifier.
   * Can only contain numbers, letters, and hyphens.
   */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUpdatePayload = {
  __typename?: 'OrganizationUpdatePayload';
  organization?: Maybe<OrganizationUpdatePayload>;
};

/** PayrollDocument return type. */
export type PayrollDocument = {
  __typename?: 'PayrollDocument';
  contractor: Contractor;
  id: Scalars['ID']['output'];
  jobsite: Jobsite;
  name: Scalars['String']['output'];
  /** Type of payroll document */
  payrollDocumentType?: Maybe<PayrollDocumentType>;
  /** List of document versions sorted by most recent version first */
  payrollDocumentVersions: Array<PayrollDocumentVersion>;
  /** End date for payroll pay period */
  payrollEndDate?: Maybe<Scalars['Date']['output']>;
  payrollStartDate?: Maybe<Scalars['Date']['output']>;
};

export enum PayrollDocumentDateInputType {
  DateRange = 'DateRange',
  SingleDate = 'SingleDate',
}

/** PayrollDocumentType return type. */
export type PayrollDocumentType = {
  __typename?: 'PayrollDocumentType';
  dateInputType?: Maybe<PayrollDocumentDateInputType>;
  hasApprovalFlow?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supportedFileTypes: Array<Scalars['String']['output']>;
};

/** PayrollDocumentVersion return type. */
export type PayrollDocumentVersion = {
  __typename?: 'PayrollDocumentVersion';
  file: File;
  id: Scalars['ID']['output'];
  objectHistory?: Maybe<ObjectHistory>;
  payrollRejectedReason?: Maybe<Scalars['String']['output']>;
  payrollStatus: PayrollStatus;
  submittedAt: Scalars['Date']['output'];
};

/** Possible status for a given payroll document */
export enum PayrollStatus {
  Accepted = 'Accepted',
  InReview = 'InReview',
  Rejected = 'Rejected',
}

/** A single permission: an action at a possession on the enclosing resource, with the attributes (fields) it covers. */
export type PermissionGrant = {
  __typename?: 'PermissionGrant';
  action: Action;
  attributes: Array<Scalars['String']['output']>;
  possession: Possession;
};

export type PersonalInformationInput = {
  /** City of the worker */
  addressCity?: InputMaybe<Scalars['String']['input']>;
  /** Address of the worker */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address of the worker */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** State of the worker */
  addressState?: InputMaybe<StateAbbreviation>;
  /** Zip code of the worker */
  addressZipCode?: InputMaybe<Scalars['String']['input']>;
  /** Birth date for worker */
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  /** Email of worker's emergency contact */
  emergencyContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name of worker's emergency contact */
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  /** Optional Note regarding worker's emergency contact */
  emergencyContactNote?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of worker's emergency contact */
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Relation of emergency contact to worker */
  emergencyContactRelationship?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the worker */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Whether the worker is a skilled worker */
  isSkilled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the worker is a supervisor */
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the worker is a veteran */
  isVeteran?: InputMaybe<Scalars['Boolean']['input']>;
  /** Middle Initial of the worker */
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  /** Primary language of the worker */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Race of the worker */
  race?: InputMaybe<Scalars['String']['input']>;
  /** last four of SSN for worker */
  ssnLastFour?: InputMaybe<Scalars['String']['input']>;
  /** Suffix of the worker */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A versioned platform policy document requiring user consent (e.g. terms of
 * service, privacy policy). The document content itself is externally hosted —
 * its PDF path is derived from `key` + `version` + the user's language, and
 * its human-readable label comes from app localization keyed by `key`.
 */
export type PolicyDocument = {
  __typename?: 'PolicyDocument';
  /** When this version became (or becomes) live; shown as the effective date. */
  effectiveAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Stable identifier for the logical policy, constant across versions. */
  key: Scalars['String']['output'];
  /** Monotonically increasing version for this policy key. */
  version: Scalars['Int']['output'];
};

export enum Possession {
  Any = 'any',
  Own = 'own',
}

export type PreExistingWorker = {
  __typename?: 'PreExistingWorker';
  firstName: Scalars['String']['output'];
  /** Tells whether this worker has completed onboarding at any jobsite */
  hasCompletedOnboarding: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export type PreExistingWorkerResponse = {
  __typename?: 'PreExistingWorkerResponse';
  preExistingWorker?: Maybe<PreExistingWorker>;
};

export type PreOnboardWorkerMatchInput = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** TODO: Make this required after mobile app v2026.2 gets deployed */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PrintWorkerCardInput = {
  cardPrintJobInput: CardPrintJobInput;
  id: Scalars['ID']['input'];
};

export type ProcoreConnectionStatus = {
  __typename?: 'ProcoreConnectionStatus';
  connected: Scalars['Boolean']['output'];
  procoreUserId?: Maybe<Scalars['Int']['output']>;
};

export type ProcoreOAuthExchangeResponse = {
  __typename?: 'ProcoreOAuthExchangeResponse';
  connected: Scalars['Boolean']['output'];
  procoreUserId: Scalars['Int']['output'];
};

export type ProcoreOAuthStartResponse = {
  __typename?: 'ProcoreOAuthStartResponse';
  authorizeUrl: Scalars['String']['output'];
};

export type ProcoreProjectVendor = {
  __typename?: 'ProcoreProjectVendor';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ProcoreProjectVendorConnection = {
  __typename?: 'ProcoreProjectVendorConnection';
  count: Scalars['Int']['output'];
  edges: Array<ProcoreProjectVendorEdge>;
};

export type ProcoreProjectVendorEdge = {
  __typename?: 'ProcoreProjectVendorEdge';
  node: ProcoreProjectVendor;
};

export type ProximitySessionLocaleData = {
  __typename?: 'ProximitySessionLocaleData';
  day?: Maybe<Scalars['String']['output']>;
  time?: Maybe<ProximitySessionLocaleTimeData>;
};

export type ProximitySessionLocaleTimeData = {
  __typename?: 'ProximitySessionLocaleTimeData';
  beginning?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  finish?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type ProximitySessionReadsCountData = {
  __typename?: 'ProximitySessionReadsCountData';
  inbound?: Maybe<Scalars['Int']['output']>;
  outbound?: Maybe<Scalars['Int']['output']>;
};

export type ProximitySessionReadsData = {
  __typename?: 'ProximitySessionReadsData';
  count?: Maybe<Scalars['Int']['output']>;
  counts?: Maybe<ProximitySessionReadsCountData>;
  direction?: Maybe<ProximitySessionReadsDirectionData>;
  first?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
};

export type ProximitySessionReadsDirectionData = {
  __typename?: 'ProximitySessionReadsDirectionData';
  first?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['String']['output']>;
};

export type ProximitySessionResult = {
  __typename?: 'ProximitySessionResult';
  active: Scalars['Boolean']['output'];
  closed: Scalars['Boolean']['output'];
  compliant: Scalars['Boolean']['output'];
  day: Scalars['String']['output'];
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  locale?: Maybe<ProximitySessionLocaleData>;
  reads?: Maybe<ProximitySessionReadsData>;
  span?: Maybe<ProximitySessionSpanData>;
  start?: Maybe<Scalars['Date']['output']>;
};

export type ProximitySessionSpanData = {
  __typename?: 'ProximitySessionSpanData';
  beginning?: Maybe<Scalars['Int']['output']>;
  finish?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['Float']['output']>;
  milliseconds?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Float']['output']>;
};

export type PublishSiteLayoutDraftInput = {
  /** The draft token the client read; a draft written since is refused as STALE_DRAFT. */
  expectedDraftToken: Scalars['Int']['input'];
  /** The client's id for this publish, recorded on the published revision. */
  requestId: Scalars['ID']['input'];
  /** The draft the client read; another draft is refused as REVISION_MISMATCH. */
  revisionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type PulseVideoCamera = {
  __typename?: 'PulseVideoCamera';
  deviceId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  oldestRecording?: Maybe<Scalars['Date']['output']>;
  playbackSegments?: Maybe<Array<PulseVideoPlaybackSegment>>;
  setupStatus?: Maybe<PulseVideoCameraSetupStatus>;
  sources: Array<Scalars['String']['output']>;
};

export enum PulseVideoCameraSetupStatus {
  Complete = 'COMPLETE',
  FailedInitial = 'FAILED_INITIAL',
  FailedSubsequent = 'FAILED_SUBSEQUENT',
  Pending = 'PENDING',
}

export type PulseVideoFile = {
  __typename?: 'PulseVideoFile';
  thumbnailFiles?: Maybe<Array<CloudFile>>;
  videoFile: File;
};

export enum PulseVideoPlaybackLocation {
  Backup = 'backup',
  Direct = 'direct',
  None = 'none',
}

export type PulseVideoPlaybackSegment = {
  __typename?: 'PulseVideoPlaybackSegment';
  endTime?: Maybe<Scalars['Date']['output']>;
  location: PulseVideoPlaybackLocation;
  time: Scalars['Date']['output'];
};

export type PulseVideos = {
  __typename?: 'PulseVideos';
  avigilonUrl: Scalars['String']['output'];
  cameras: Array<PulseVideoCamera>;
  hlsBasicAuth: Scalars['String']['output'];
  sessionToken: Scalars['String']['output'];
};

export enum PushNotificationEvent {
  FormSubmissionAssigned = 'form_submission_assigned',
  UserAclUpdated = 'user_acl_updated',
}

/** The root query object for all queries */
export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  accessGroup?: Maybe<AccessGroup>;
  /**
   * Bounded, read-only Alta controller choices for an Odin admin configuration
   * session. Excludes active assignments to other sites. Requires Manage site
   * devices, an enabled layout and connected Avigilon Access connector.
   * Adding by serial remains authoritative if assignments change afterward.
   */
  availableSiteControllers: AvailableSiteControllerConnection;
  avigilonAccessConnector?: Maybe<AvigilonAccessConnector>;
  avigilonVideoConnector?: Maybe<AvigilonVideoConnector>;
  /** Returns false if a user with the provided email already exists */
  checkEmail: Success;
  checkWorkerPhoneAvailability: CheckWorkerPhoneAvailabilityPayload;
  connector?: Maybe<Connector>;
  connectorCatalog: ConnectorCatalog;
  /** How the discoveries of the environment's Avigilon devices have gone. Odin admins only. */
  deviceDiscovery: DeviceDiscovery;
  /**
   * One recorded reader device or access controller device, by its own id;
   * unset when none has it. Odin admins only.
   */
  discoveredDevice?: Maybe<DiscoveredDevice>;
  /** Every recorded reader device and access controller device, by name. Odin admins only. */
  discoveredDevices: Array<DiscoveredDevice>;
  getAllJobsiteWorkerDocumentTypes: Array<JobsiteWorkerDocumentType>;
  /** Get all jobsites in the system */
  getAllJobsites: Array<Jobsite>;
  /**
   * Gets all workers for a given contractor ID. Returns an error if the contractor is not found
   * and returns an empty array if no workers assigned to contractor.
   */
  getAllWorkersForContractor: ContractorWorkerConnection;
  /**
   * Pre-auth (whitelisted) counterpart of 'getJobsiteInvitation' exposing only
   * the minimal jobsite + contractor data an unauthenticated worker needs to get
   * through the OTP challenge and contractor selection before account creation.
   * Intentionally a flat type that cannot be traversed into the full jobsite
   * onboarding configuration; the authenticated flow uses 'getJobsiteInvitation'.
   */
  getAnonymousJobsiteInvitation: AnonymousJobsiteInvitation;
  /** Get the available badge templates */
  getBadgeTemplates: Array<BadgeTemplate>;
  getCardPrintJob: CardPrintJob;
  getCardPrintJobs: Array<CardPrintJob>;
  /** Get all jobsites for a construction manager */
  getConstructionManagerJobsites: Array<Jobsite>;
  /** Get a single contractor by ID. Returns error if contractor doesn't exist */
  getContractor: Contractor;
  getContractorMember: ContractorMember;
  /**
   * Get a contractor worker by contractor id and worker id.
   * Returns an error if neither worker or contractor is found,
   * or if given worker is not assigned to the contractor.
   */
  getContractorWorker: ContractorWorker;
  getCurrentCardPrintJob?: Maybe<CardPrintJob>;
  /**
   * The current, effective, non-retired policy documents every user must
   * consent to. Whitelisted pre-auth: the self-onboarding account-creation step
   * reads it before a session exists, and a brand-new account's outstanding set
   * is simply all current policies.
   */
  getCurrentPolicyDocuments: Array<PolicyDocument>;
  /**
   * Get the current session and user based on the provided session token
   * When 'includeComputedRoles' is 'true', the 'user.roles' field, besides the currently assigned roles,
   * it will also contain some computed roles. The computed roles are jobsite roles which are projected
   * on the contractors assigned to the jobsites where the current user has a role.
   * i.e. if the user has an 'Editor' role on 'Jobsite A' and 'Jobsite A' is assigned to 'Contractor A',
   * then computed 'user.roles' will contain 'Editor' role for 'Contractor A' as well
   */
  getCurrentSession?: Maybe<Auth>;
  /** Get the current worker and session */
  getCurrentWorkerAuth: WorkerAuth;
  /**
   * The contractor organization names available as dashboard filter options for
   * the caller, without running the sessions query. A contractor session gets
   * its own companies plus, unless includeSubcontractors is false, the
   * contractors subcontracted to them on the given jobsites.
   */
  getDashboardContractorOptions: Array<Scalars['String']['output']>;
  getDeveloper: Developer;
  getDeveloperMember: DeveloperMember;
  /** Get all jobsites in a developmentProject */
  getDevelopmentProjectJobsites: Array<Jobsite>;
  getEntityChanges: GetEntityChangesResult;
  getFileDownloadRedirect: FileDownloadRedirect;
  getForm: Form;
  /** Get a single jobsite by ID. Returns error if jobsite doesn't exist */
  getJobsite: Jobsite;
  /** Get a single jobsite announcement by ID. Returns error if announcement doesn't exist */
  getJobsiteAnnouncement: JobsiteAnnouncement;
  /** Get Jobsite Announcement Candidate Recipients */
  getJobsiteAnnouncementCandidateRecipients: JobsiteAnnouncementCandidateRecipientsConnection;
  /** Get all announcements on jobsite. */
  getJobsiteAnnouncements: JobsiteAnnouncementConnection;
  /** Get the badge templates associated with a Jobsite */
  getJobsiteBadgeTemplates: Array<JobsiteBadgeTemplate>;
  /** Get the worker card formats associated with a Jobsite */
  getJobsiteCardFormat?: Maybe<JobsiteCardFormat>;
  getJobsiteContractor: JobsiteContractor;
  /**
   * Get all contractors of a jobsite. One of jobsiteIds or contractorId is required.
   * @deprecated Use jobsite.contractors instead
   */
  getJobsiteContractors: GetJobsiteContractorsResponse;
  /**
   * Get CCure controller status information, filterable by list of jobsite IDs or status value.
   * If no filters specified, return info for all jobsites and statuses.
   */
  getJobsiteEquipmentData: GetJobsiteEquipmentDataResponse;
  /**
   * Get an optionally filtered list of historical status change events for CCure controllers, sorted by date.
   * By default, list of events will be sorted by descending date and limited to 100 results.
   */
  getJobsiteEquipmentHistory: GetJobsiteEquipmentHistoryResponse;
  getJobsiteFormSubmission: JobsiteFormSubmission;
  getJobsiteInvitation: JobsiteInvitation;
  /** Get a member of a jobsite. Returns error if association is not found. */
  getJobsiteMember: JobsiteMember;
  getJobsitePacsGateways: GetJobsitePacsGatewaysResponse;
  /** Get the stats for a jobsite. Returns error if jobsite doesn't exist */
  getJobsiteStats: JobsiteStats;
  /**
   * "
   * Get a single JobsiteWorker object. Returns an error if worker or jobsite is not found. Returns null if
   * worker is not on jobsite.
   */
  getJobsiteWorker?: Maybe<JobsiteWorker>;
  getJobsiteWorkerCheckInSuggestions: JobsiteWorkerCheckInSuggestionConnection;
  getJobsiteWorkerCheckIns: JobsiteWorkerCheckInConnection;
  getJobsiteWorkerDashboard?: Maybe<GetJobsiteWorkerDashboardResponse>;
  getJobsiteWorkerDocument: JobsiteWorkerDocument;
  getJobsiteWorkerDocumentType: JobsiteWorkerDocumentType;
  getJobsiteWorkerDocumentVersion: JobsiteWorkerDocumentVersion;
  /** Get all workers of a jobsite. Returns an error if jobsiteId is not found. */
  getJobsiteWorkers: JobsiteWorkerConnection;
  getJobsiteWorkersByDocumentCompliance: JobsiteWorkerConnection;
  /** Get jobsites by city */
  getJobsitesByCity: Array<Jobsite>;
  getJobsitesStats: JobsitesStats;
  /**
   * Get all jobsites for member. Returns an error if memberUserAccountId is not found. If memberUserAccountId is not
   * provided, then the requesting user account ID is assumed.
   */
  getMemberJobsites: GetMemberJobsitesResponse;
  getMobileDashboardForWorker: MobileDashboardForWorkerResponse;
  getOrganization: Organization;
  getPayrollDocument: PayrollDocument;
  /** Get all available payroll document types. */
  getPayrollDocumentTypes: Array<PayrollDocumentType>;
  getPayrollDocuments: Array<PayrollDocument>;
  getPreExistingWorker: PreExistingWorkerResponse;
  /**
   * Returns whether the current user has connected their Procore account via
   * the per-user OAuth flow, and (if so) the Procore user id captured at
   * connect time.
   */
  getProcoreConnectionStatus: ProcoreConnectionStatus;
  /**
   * Get 'count' most recent, unique search queries executed by the current user.  Defaults to returning the 5 most
   * recent results, if 'count' not specified.
   */
  getRecentUserSearchQueries: UserSearchQueryResponse;
  getRoles: Array<Role>;
  getSchedule?: Maybe<Schedule>;
  getScheduleNotificationPreview: Array<ScheduleNotificationPreview>;
  getScheduleShift: ScheduleShift;
  getScheduleWorker: ScheduleWorker;
  getScheduleWorkerSession: ScheduleWorkerSession;
  getTempBadge: TempBadge;
  getUserPendingChange: UserPendingChangePayload;
  getVisitorLog: VisitorLog;
  /** Get a single worker by ID. Returns error if worker doesn't exist */
  getWorker: Worker;
  /**
   * Get a single worker by userAccountId. Returns error if worker doesn't exist. If userAccountId is not
   * provided, then the requesting user account ID is assumed.
   */
  getWorkerByUserAccountId: Worker;
  getWorkerCCureData: WorkerCCureData;
  /** Must provide either [workerCardId], [tempBadgeId] or [cardNumber and cardType] */
  getWorkerCard: WorkerCard;
  getWorkerCheckInInfo?: Maybe<WorkerCheckInInfo>;
  /** Gets a worker comment */
  getWorkerComment: WorkerComment;
  /** Get all comments for worker */
  getWorkerComments?: Maybe<WorkerCommentConnection>;
  getWorkerDocuments: GetWorkerDocumentsResponse;
  isWorkerCardAssigned: Success;
  /**
   * Active data-sharing grants for a jobsite: the client organizations this
   * site's data is shared with under a written agreement. Admin/super only.
   */
  jobsiteDataSharingGrants: Array<DeveloperJobsiteAccessGrant>;
  /**
   * The active layout sites (sites with the site layout enabled), by name:
   * the sites a device may be assigned to. Odin admins only.
   */
  layoutSites: Array<Site>;
  matchWorkers: MatchWorkersPayload;
  /**
   * Search workers accross name, quick code, and email
   * Returns an empty list if none are found.
   */
  searchWorkers: WorkerSearchResponse;
  siteConfigurationZones: Array<ConfigurationZone>;
  /** One controller by its assignment, while it is open on this site. Requires View site devices at the site. */
  siteDevice?: Maybe<SiteController>;
  /**
   * The controllers assigned to the site now, by name, with their readers.
   * Requires View site devices at the site. A page is 50 unless first
   * says otherwise, at most 100, and starts after the assignment after
   * names. An empty page means the end, or that the assignment after names
   * is no longer open: reload the list in that case.
   */
  siteDevices: Array<SiteController>;
  /** The site's independent readers, with placements. Requires View site devices at the site. */
  siteIndependentReaders: Array<SiteIndependentReader>;
  siteReaderAttachments: SiteReaderAttachments;
  /** The site's readers with no recorded controller, by name, plugged in or not. Requires View site devices at the site. */
  siteUnresolvedReaders: Array<SiteUnresolvedReader>;
  workerAccessGroupMemberships: Array<AccessGroupMembership>;
  workerAccessGroupSites: Array<AccessGroupMembershipSite>;
  workerAccessRestorePreview: WorkerAccessRestorePreview;
  zone?: Maybe<Zone>;
};

/** The root query object for all queries */
export type QueryAccessGroupArgs = {
  id: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryAvailableSiteControllersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryAvigilonAccessConnectorArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryAvigilonVideoConnectorArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryCheckEmailArgs = {
  email: Scalars['String']['input'];
};

/** The root query object for all queries */
export type QueryCheckWorkerPhoneAvailabilityArgs = {
  input: CheckWorkerPhoneAvailabilityInput;
};

/** The root query object for all queries */
export type QueryConnectorArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryConnectorCatalogArgs = {
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryDiscoveredDeviceArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetAllJobsiteWorkerDocumentTypesArgs = {
  jobsiteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetAllWorkersForContractorArgs = {
  contractorId: Scalars['ID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  trade?: InputMaybe<Scalars['String']['input']>;
};

/** The root query object for all queries */
export type QueryGetAnonymousJobsiteInvitationArgs = {
  jobsiteInvitationId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetCardPrintJobArgs = {
  cardPrintJobId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetCardPrintJobsArgs = {
  jobsiteId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<CardPrintJobStatus>>>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

/** The root query object for all queries */
export type QueryGetConstructionManagerJobsitesArgs = {
  constructionManagerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetContractorArgs = {
  contractorId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The root query object for all queries */
export type QueryGetContractorMemberArgs = {
  input: GetContractorMemberInput;
};

/** The root query object for all queries */
export type QueryGetContractorWorkerArgs = {
  contractorId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetCurrentCardPrintJobArgs = {
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetCurrentSessionArgs = {
  includeComputedRoles?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The root query object for all queries */
export type QueryGetDashboardContractorOptionsArgs = {
  includeSubcontractors?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The root query object for all queries */
export type QueryGetDeveloperArgs = {
  developerId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The root query object for all queries */
export type QueryGetDeveloperMemberArgs = {
  input: GetDeveloperMemberInput;
};

/** The root query object for all queries */
export type QueryGetDevelopmentProjectJobsitesArgs = {
  developmentProjectId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetEntityChangesArgs = {
  input?: InputMaybe<GetEntityChangesInput>;
};

/** The root query object for all queries */
export type QueryGetFileDownloadRedirectArgs = {
  downloadUrl: Scalars['String']['input'];
};

/** The root query object for all queries */
export type QueryGetFormArgs = {
  formId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsiteArgs = {
  jobsiteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteAnnouncementArgs = {
  jobsiteAnnouncementId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteAnnouncementCandidateRecipientsArgs = {
  input: JobsiteAnnouncementFilterSpecification;
};

/** The root query object for all queries */
export type QueryGetJobsiteAnnouncementsArgs = {
  input?: InputMaybe<GetJobsiteAnnouncementsInput>;
};

/** The root query object for all queries */
export type QueryGetJobsiteBadgeTemplatesArgs = {
  jobsiteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteCardFormatArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteContractorArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteContractorsArgs = {
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  jobsiteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsiteEquipmentDataArgs = {
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<JobsiteEquipmentStatusType>;
};

/** The root query object for all queries */
export type QueryGetJobsiteEquipmentHistoryArgs = {
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDir?: InputMaybe<OrderByDirection>;
  status?: InputMaybe<JobsiteEquipmentStatusType>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsiteFormSubmissionArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteInvitationArgs = {
  jobsiteInvitationId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteMemberArgs = {
  jobsiteId: Scalars['ID']['input'];
  memberUserAccountId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsitePacsGatewaysArgs = {
  jobsiteIds: Array<Scalars['ID']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsiteStatsArgs = {
  jobsiteId: Scalars['ID']['input'];
  submissionDate?: InputMaybe<Scalars['Date']['input']>;
  submissionEndDate?: InputMaybe<Scalars['Date']['input']>;
  submissionStartDate?: InputMaybe<Scalars['Date']['input']>;
  timezoneName?: InputMaybe<Scalars['String']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkerArgs = {
  jobsiteWorkerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkerCheckInSuggestionsArgs = {
  hideNotAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkerCheckInsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobsiteWorkerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  workerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkerDashboardArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  compliant?: InputMaybe<Scalars['Boolean']['input']>;
  contractor?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['Date']['input'];
  export?: InputMaybe<Scalars['Boolean']['input']>;
  fitoutTenant?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  overnight?: InputMaybe<Scalars['Boolean']['input']>;
  realtime?: InputMaybe<Scalars['Boolean']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  timeBreakdown?: InputMaybe<GetJobsiteWorkerReportsTimeBreakdown>;
  trade?: InputMaybe<Scalars['String']['input']>;
  workerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkerDocumentArgs = {
  jobsiteWorkerDocumentId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkerDocumentTypeArgs = {
  jobsiteWorkerDocumentTypeId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkerDocumentVersionArgs = {
  jobsiteWorkerDocumentId: Scalars['ID']['input'];
  jobsiteWorkerDocumentVersionId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkersArgs = {
  activeAsOf?: InputMaybe<Scalars['Date']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  completedSiteSpecificTraining?: InputMaybe<Scalars['Boolean']['input']>;
  completedSiteSpecificTrainingDate?: InputMaybe<Scalars['Date']['input']>;
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hideBanned?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteId?: InputMaybe<Scalars['ID']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  needsMedical?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<GetJobsiteWorkersOrderBy>>>;
  orientationDate?: InputMaybe<Scalars['Date']['input']>;
  orientationEndDate?: InputMaybe<Scalars['Date']['input']>;
  orientationStartDate?: InputMaybe<Scalars['Date']['input']>;
  orientationStatuses?: InputMaybe<Array<JobsiteWorkerOrientationStatusFilter>>;
  showDuplicateWorkersPerJobsite?: InputMaybe<Scalars['Boolean']['input']>;
  siteSpecificOrientationStatus?: InputMaybe<SiteSpecificOrientationStatus>;
  withContractorOnly?: InputMaybe<Scalars['Boolean']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsiteWorkersByDocumentComplianceArgs = {
  jobsiteId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  safetyDocumentStatus?: InputMaybe<Scalars['String']['input']>;
  safetyDocumentType?: InputMaybe<Scalars['String']['input']>;
};

/** The root query object for all queries */
export type QueryGetJobsitesByCityArgs = {
  city: Scalars['String']['input'];
  state: StateAbbreviation;
};

/** The root query object for all queries */
export type QueryGetJobsitesStatsArgs = {
  jobsiteIds: Array<Scalars['ID']['input']>;
  submissionDate?: InputMaybe<Scalars['Date']['input']>;
  submissionEndDate?: InputMaybe<Scalars['Date']['input']>;
  submissionStartDate?: InputMaybe<Scalars['Date']['input']>;
  timezoneName?: InputMaybe<Scalars['String']['input']>;
};

/** The root query object for all queries */
export type QueryGetMemberJobsitesArgs = {
  memberUserAccountId?: InputMaybe<Scalars['ID']['input']>;
};

/** The root query object for all queries */
export type QueryGetOrganizationArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetPayrollDocumentArgs = {
  payrollDocumentId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetPayrollDocumentsArgs = {
  getPayrollDocumentsInput: GetPayrollDocumentsInput;
};

/** The root query object for all queries */
export type QueryGetPreExistingWorkerArgs = {
  input: PreOnboardWorkerMatchInput;
};

/** The root query object for all queries */
export type QueryGetRecentUserSearchQueriesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  searchQueryType?: InputMaybe<SearchQueryType>;
};

/** The root query object for all queries */
export type QueryGetScheduleArgs = {
  input: ScheduleInput;
};

/** The root query object for all queries */
export type QueryGetScheduleNotificationPreviewArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetScheduleShiftArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetScheduleWorkerArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetScheduleWorkerSessionArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetTempBadgeArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetUserPendingChangeArgs = {
  changeType: UserPendingChangeType;
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetVisitorLogArgs = {
  id: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetWorkerArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetWorkerByUserAccountIdArgs = {
  userAccountId?: InputMaybe<Scalars['ID']['input']>;
};

/** The root query object for all queries */
export type QueryGetWorkerCCureDataArgs = {
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetWorkerCardArgs = {
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<WorkerCardType>;
  tempBadgeId?: InputMaybe<Scalars['ID']['input']>;
  workerCardId?: InputMaybe<Scalars['ID']['input']>;
};

/** The root query object for all queries */
export type QueryGetWorkerCheckInInfoArgs = {
  input?: InputMaybe<WorkerCheckInInfoInput>;
};

/** The root query object for all queries */
export type QueryGetWorkerCommentArgs = {
  workerCommentId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryGetWorkerCommentsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

/** The root query object for all queries */
export type QueryGetWorkerDocumentsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includePhi?: InputMaybe<Scalars['Boolean']['input']>;
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryIsWorkerCardAssignedArgs = {
  cardNumber: Scalars['String']['input'];
  cardType: WorkerCardType;
};

/** The root query object for all queries */
export type QueryJobsiteDataSharingGrantsArgs = {
  jobsiteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryMatchWorkersArgs = {
  input: MatchWorkersInput;
};

/** The root query object for all queries */
export type QuerySearchWorkersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchString: Scalars['String']['input'];
};

/** The root query object for all queries */
export type QuerySiteConfigurationZonesArgs = {
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QuerySiteDeviceArgs = {
  assignmentId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QuerySiteDevicesArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QuerySiteIndependentReadersArgs = {
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QuerySiteReaderAttachmentsArgs = {
  input: SiteReaderAttachmentsInput;
};

/** The root query object for all queries */
export type QuerySiteUnresolvedReadersArgs = {
  siteId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryWorkerAccessGroupMembershipsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  siteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryWorkerAccessGroupSitesArgs = {
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryWorkerAccessRestorePreviewArgs = {
  siteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

/** The root query object for all queries */
export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};

/** A reader device registered on the site. Its name is the device's. */
export type Reader = {
  __typename?: 'Reader';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  readerDeviceId: Scalars['ID']['output'];
};

/**
 * A reader's assignment to an entry in one revision: the side it admits into
 * and the crossing it therefore serves. The id belongs to that revision alone.
 */
export type ReaderAssignment = {
  __typename?: 'ReaderAssignment';
  admitsInto: EntrySide;
  crossing: Crossing;
  id: Scalars['ID']['output'];
  reader: Reader;
};

/** One physical reader. The site layout's Reader is its presence on a site. */
export type ReaderDevice = {
  __typename?: 'ReaderDevice';
  device: Device;
  id: Scalars['ID']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export enum ReaderOwnershipResolutionKind {
  Controller = 'CONTROLLER',
  Independent = 'INDEPENDENT',
}

export enum ReaderOwnershipResolutionRefusal {
  AssignmentChanged = 'ASSIGNMENT_CHANGED',
  ReaderConflict = 'READER_CONFLICT',
  RelationshipChanged = 'RELATIONSHIP_CHANGED',
}

export enum ReaderOwnershipResolutionStatus {
  Applied = 'APPLIED',
  Refused = 'REFUSED',
}

export type ReconcileSiteLayoutInput = {
  siteId: Scalars['ID']['input'];
};

export type ReconcileSiteLayoutPayload = {
  __typename?: 'ReconcileSiteLayoutPayload';
  /** The enabled connectors delivery was requested from; zero when the site has none. */
  connectorCount: Scalars['Int']['output'];
  /** The site's effective layout revision, which delivery was requested for. */
  siteLayoutRevisionId: Scalars['ID']['output'];
};

export type RecordPolicyConsentInput = {
  /** The policy documents the user is consenting to. */
  policyDocumentIds: Array<Scalars['ID']['input']>;
  /**
   * When true, also stamp the current user's SMS opt-in consent timestamp — a
   * separate identity attribute from policy consent, captured opportunistically
   * from the gate's optional SMS checkbox. Idempotent server-side (the first
   * affirmation's instant is preserved), so a re-affirmation records nothing.
   * Omitted/false records no SMS consent; the policy documents are still
   * recorded either way.
   */
  smsOptInAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefreshConnectorInventoryInput = {
  connectorId: Scalars['ID']['input'];
};

export type RefreshConnectorInventoryPayload = {
  __typename?: 'RefreshConnectorInventoryPayload';
  /** The site's inventory after the refresh. */
  items: Array<ConnectorInventoryItem>;
  /** What the refresh read, or why it did not run. */
  message: Scalars['String']['output'];
  /**
   * Whether the inventory was read again; false when a refresh of the
   * connector was already running.
   */
  refreshed: Scalars['Boolean']['output'];
};

export type RegisterDevicePushTokenInput = {
  /** AppInstanceId from the mobile app SecureStore */
  deviceId: Scalars['String']['input'];
  /** Device platform: ios or android */
  platform: DevicePlatform;
  /** Expo push token (e.g. ExponentPushToken[xxx]) */
  token: Scalars['String']['input'];
};

export type RegisterTempBadgeInput = {
  cardNumber: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  jobsiteCardFormatId: Scalars['ID']['input'];
};

export type RemoveDraftEntryInput = {
  entryId: Scalars['ID']['input'];
  /** The draft token the client read. */
  expectedDraftToken: Scalars['Int']['input'];
  /** The client's id for this write, recorded on the draft once it commits. */
  requestId: Scalars['ID']['input'];
  /** The draft the client read. */
  revisionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type RemoveDraftEntryPayload = {
  __typename?: 'RemoveDraftEntryPayload';
  /** The draft's token after the removal, when applied. */
  draftToken?: Maybe<Scalars['Int']['output']>;
  kind: LayoutResultKind;
  /** Empty when applied. */
  refusals: Array<LayoutRefusal>;
  /** The placements the entry took with it, when applied; their readers stay registered on the site. */
  removedPlacementIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type RemoveDraftZoneInput = {
  /** The draft token the client read. */
  expectedDraftToken: Scalars['Int']['input'];
  /** The client's id for this write, recorded on the draft once it commits. */
  requestId: Scalars['ID']['input'];
  /** The draft the client read. */
  revisionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

export type RemoveDraftZonePayload = {
  __typename?: 'RemoveDraftZonePayload';
  /** The draft's token after the removal, when applied. */
  draftToken?: Maybe<Scalars['Int']['output']>;
  kind: LayoutResultKind;
  /** Empty when applied. */
  refusals: Array<LayoutRefusal>;
};

export type RemoveSiteControllerInput = {
  /** The controller's assignment to the site, so an old screen cannot act on a later assignment of the same unit. */
  assignmentId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type RemoveSiteControllerPayload = {
  __typename?: 'RemoveSiteControllerPayload';
  /** The site's readers that left with the controller, when applied. */
  closedReaderIds?: Maybe<Array<Scalars['ID']['output']>>;
  failure?: Maybe<SiteDeviceFailure>;
  kind: SiteDeviceResultKind;
  refusal?: Maybe<SiteDeviceRefusal>;
  /** The draft placements removed so the draft publishes without them, when applied. */
  removedDraftPlacementIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Unset: a removal is local and records no connector run. */
  runId?: Maybe<Scalars['ID']['output']>;
};

export type RemoveSiteReaderAttachmentInput = {
  assignmentId: Scalars['ID']['input'];
  entryId: Scalars['ID']['input'];
  expectedFingerprint: Scalars['String']['input'];
  readerDeviceId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type RemoveWorkerFromJobsiteInput = {
  jobsiteWorkerId: Scalars['ID']['input'];
};

export type RemoveWorkerFromJobsiteResponse = {
  __typename?: 'RemoveWorkerFromJobsiteResponse';
  success: Success;
};

export type RenameAccessGroupInput = {
  accessGroupId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type ReprintTempBadgeInput = {
  id: Scalars['ID']['input'];
  jobsitePrinterId: Scalars['ID']['input'];
};

export type ResolveReaderOwnershipInput = {
  assignmentId?: InputMaybe<Scalars['ID']['input']>;
  expectedRelationshipId?: InputMaybe<Scalars['ID']['input']>;
  readerId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  resolutionKind: ReaderOwnershipResolutionKind;
  siteId: Scalars['ID']['input'];
};

export type ResolveReaderOwnershipPayload = {
  __typename?: 'ResolveReaderOwnershipPayload';
  code?: Maybe<ReaderOwnershipResolutionRefusal>;
  kind: ReaderOwnershipResolutionStatus;
  relationshipId?: Maybe<Scalars['ID']['output']>;
};

/** The grants a user holds on a single resource within a scope. */
export type ResourcePermissions = {
  __typename?: 'ResourcePermissions';
  grants: Array<PermissionGrant>;
  resource: ObjectName;
};

export type RevokeAccessGroupMembershipInput = {
  accessGroupId: Scalars['ID']['input'];
  /** Explicitly exclude this group from pending restoration instead of revoking an active interval. */
  excludeFromRestore?: InputMaybe<Scalars['Boolean']['input']>;
  /** The interval shown in the revoke confirmation. Required unless excluding a pending restore. */
  expectedMembershipId?: InputMaybe<Scalars['ID']['input']>;
  siteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
};

export type RevokeDeveloperJobsiteAccessGrantInput = {
  /** The grant id to revoke */
  id: Scalars['ID']['input'];
};

/** A role without a user association */
export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['Date']['output'];
  /** Display name of the role */
  displayName: Scalars['String']['output'];
  /** Indicates whether the role is a super-user role */
  isSuper: Scalars['Boolean']['output'];
  /** Human-readable, all lower-case, snake-case identifier for this role. This is unique to this role. */
  key: UserRoleKey;
  /** When the role itself was updated */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SafetyDocumentStatus {
  Exempt = 'Exempt',
  NotOnFile = 'NotOnFile',
  NycSstExpired = 'NycSstExpired',
  NycSstNotOnFile = 'NycSstNotOnFile',
  NycSstOnFile = 'NycSstOnFile',
  OshaOnFile = 'OshaOnFile',
  TwicCardExpired = 'TwicCardExpired',
  TwicCardNotOnFile = 'TwicCardNotOnFile',
  TwicCardOnFile = 'TwicCardOnFile',
}

export type SaveDraftEntryInput = {
  /** The entry to rewrite; null creates one. */
  entryId?: InputMaybe<Scalars['ID']['input']>;
  /** The draft token the client read. */
  expectedDraftToken: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  /** The client's id for this write, recorded on the draft once it commits. */
  requestId: Scalars['ID']['input'];
  /** The draft the client read. */
  revisionId: Scalars['ID']['input'];
  /** Shown as From. */
  sideA: EntrySideInput;
  /** Shown as To. */
  sideB: EntrySideInput;
  siteId: Scalars['ID']['input'];
};

export type SaveDraftEntryPayload = {
  __typename?: 'SaveDraftEntryPayload';
  /** The draft's token after the save, when applied. */
  draftToken?: Maybe<Scalars['Int']['output']>;
  /** The entry saved, when applied. */
  entryId?: Maybe<Scalars['ID']['output']>;
  kind: LayoutResultKind;
  /** The readers the save took off other entries, when applied. */
  movedReaders?: Maybe<Array<MovedReader>>;
  /** Empty when applied. */
  refusals: Array<LayoutRefusal>;
};

export type SaveDraftZoneInput = {
  /** The draft token the client read. */
  expectedDraftToken: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  /** The client's id for this write, recorded on the draft once it commits. */
  requestId: Scalars['ID']['input'];
  /** The draft the client read. */
  revisionId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
  /** The zone to rename; null creates one. */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveDraftZonePayload = {
  __typename?: 'SaveDraftZonePayload';
  /** The draft's token after the save, when applied. */
  draftToken?: Maybe<Scalars['Int']['output']>;
  kind: LayoutResultKind;
  /** Empty when applied. */
  refusals: Array<LayoutRefusal>;
  /** The zone saved, when applied. */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

export type Schedule = {
  __typename?: 'Schedule';
  date: Scalars['DateOnly']['output'];
  id: Scalars['ID']['output'];
  jobsite: Jobsite;
  notifiedAt?: Maybe<Scalars['Date']['output']>;
  objectHistory: ObjectHistory;
  scheduler: User;
  shifts: Array<ScheduleShift>;
  status: ScheduleStatus;
};

export type ScheduleAttendanceConnection = {
  __typename?: 'ScheduleAttendanceConnection';
  count: Scalars['Int']['output'];
  edges: Array<ScheduleAttendanceEntryEdge>;
};

export type ScheduleAttendanceEntry = {
  __typename?: 'ScheduleAttendanceEntry';
  id: Scalars['ID']['output'];
  jobsiteContractor: JobsiteContractor;
  jobsiteWorker?: Maybe<JobsiteWorker>;
  scheduleWorker?: Maybe<ScheduleWorker>;
  scheduleWorkerSession?: Maybe<ScheduleWorkerSession>;
  session?: Maybe<JobsiteAccessSession>;
  status: ScheduleAttendanceStatus;
};

export type ScheduleAttendanceEntryEdge = {
  __typename?: 'ScheduleAttendanceEntryEdge';
  node?: Maybe<ScheduleAttendanceEntry>;
};

export type ScheduleAttendanceFilterInput = {
  statuses?: InputMaybe<Array<ScheduleAttendanceStatus>>;
};

export enum ScheduleAttendanceStatus {
  Absent = 'absent',
  Present = 'present',
  Scheduled = 'scheduled',
  Unscheduled = 'unscheduled',
}

export type ScheduleEdge = {
  __typename?: 'ScheduleEdge';
  node?: Maybe<Schedule>;
};

export enum ScheduleErrorCode {
  CannotAddShiftToCompleted = 'CANNOT_ADD_SHIFT_TO_COMPLETED',
  CannotClearScheduleWorkerSessions = 'CANNOT_CLEAR_SCHEDULE_WORKER_SESSIONS',
  CannotCreateScheduleWorkerSessions = 'CANNOT_CREATE_SCHEDULE_WORKER_SESSIONS',
  CannotImportSchedule = 'CANNOT_IMPORT_SCHEDULE',
  CannotMatchScheduleWorkerSessions = 'CANNOT_MATCH_SCHEDULE_WORKER_SESSIONS',
  CannotSendNotifications = 'CANNOT_SEND_NOTIFICATIONS',
  InvalidDate = 'INVALID_DATE',
  InvalidId = 'INVALID_ID',
  InvalidStateTransition = 'INVALID_STATE_TRANSITION',
  InvalidStatus = 'INVALID_STATUS',
}

export type ScheduleInput = {
  date: Scalars['DateOnly']['input'];
  jobsiteId: Scalars['ID']['input'];
};

export type ScheduleNotificationPreview = {
  __typename?: 'ScheduleNotificationPreview';
  body?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to: Array<Scalars['String']['output']>;
};

export type ScheduleShift = {
  __typename?: 'ScheduleShift';
  attendance: ScheduleAttendanceConnection;
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  objectHistory: ObjectHistory;
  schedule: Schedule;
  sessions: ScheduleWorkerSessionsConnection;
  startTime: Scalars['String']['output'];
  workers: ScheduleWorkersConnection;
};

export type ScheduleShiftAttendanceArgs = {
  input?: InputMaybe<ScheduleAttendanceFilterInput>;
};

export enum ScheduleStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  NotStarted = 'not_started',
}

export type ScheduleWorker = {
  __typename?: 'ScheduleWorker';
  activity?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobsiteContractor: JobsiteContractor;
  jobsiteWorker?: Maybe<JobsiteWorker>;
  notes?: Maybe<Scalars['String']['output']>;
  objectHistory: ObjectHistory;
  quantity: Scalars['Int']['output'];
  sessions: Array<ScheduleWorkerSession>;
  shift: ScheduleShift;
  trade?: Maybe<Scalars['String']['output']>;
  type: ScheduleWorkerType;
};

export type ScheduleWorkerEdge = {
  __typename?: 'ScheduleWorkerEdge';
  node?: Maybe<ScheduleWorker>;
};

export type ScheduleWorkerSession = {
  __typename?: 'ScheduleWorkerSession';
  id: Scalars['ID']['output'];
  scheduleWorker?: Maybe<ScheduleWorker>;
  session?: Maybe<JobsiteAccessSession>;
};

export type ScheduleWorkerSessionEdge = {
  __typename?: 'ScheduleWorkerSessionEdge';
  node?: Maybe<ScheduleWorkerSession>;
};

export type ScheduleWorkerSessionsConnection = {
  __typename?: 'ScheduleWorkerSessionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<ScheduleWorkerSessionEdge>;
};

export enum ScheduleWorkerType {
  Assigned = 'assigned',
  Scheduled = 'scheduled',
}

export type ScheduleWorkersConnection = {
  __typename?: 'ScheduleWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<ScheduleWorkerEdge>;
};

export type SchedulesConnection = {
  __typename?: 'SchedulesConnection';
  count: Scalars['Int']['output'];
  edges: Array<ScheduleEdge>;
  filtersOptions?: Maybe<SchedulesFilters>;
};

export type SchedulesFilters = {
  __typename?: 'SchedulesFilters';
  schedulerAccountIds: Array<FilterOption>;
};

export type SchedulesInput = {
  endDate: Scalars['DateOnly']['input'];
  /**
   * Used to filter schedules by jobsite IDs.
   * The value passed from the client will be ignored when
   * the input is used for jobsite.schedules.
   */
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  notificationsSent?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<GetSchedulesOrderBy>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  schedulerAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate: Scalars['DateOnly']['input'];
  statuses?: InputMaybe<Array<ScheduleStatus>>;
};

/**
 * The permissions a user holds within a single scope, grouped by resource. A null scopeName/scopeId
 * pair is the global scope, which holds the user's scope-independent ('any') grants.
 */
export type ScopedPermissions = {
  __typename?: 'ScopedPermissions';
  resources: Array<ResourcePermissions>;
  /** The id of the scope (e.g. the jobsiteId/contractorId/workerId). Null for the global scope. */
  scopeId?: Maybe<Scalars['ID']['output']>;
  /** The type of scope this permission set is bound to (e.g. Jobsite, Contractor, Worker). Null for the global scope. */
  scopeName?: Maybe<Scalars['String']['output']>;
};

export enum SearchQueryType {
  Worker = 'Worker',
}

export type SeedEntriesFromGatewaysInput = {
  /**
   * The zone each gateway's entry faces. Needed for every gateway seeded when
   * the draft has more than one zone; otherwise the single zone is used for a
   * gateway not listed. A draft with no zone needs a zone added first. Gateways
   * already linked are ignored.
   */
  destinations?: InputMaybe<Array<GatewayDestinationInput>>;
  siteId: Scalars['ID']['input'];
};

export type SeedEntriesFromGatewaysPayload = {
  __typename?: 'SeedEntriesFromGatewaysPayload';
  /** The draft's token after the seed, when applied. */
  draftToken?: Maybe<Scalars['Int']['output']>;
  kind: LayoutResultKind;
  /** Empty when applied. */
  refusals: Array<LayoutRefusal>;
  /** The entries the seed linked to a gateway, new or already in the draft, when applied; empty when every gateway was already linked. */
  seededEntryIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export enum SelfOnboardingAbortReason {
  JobsiteWorkerOrientationIsNotSelfOnboarding = 'JobsiteWorkerOrientationIsNotSelfOnboarding',
  JobsiteWorkerWithDifferentContractor = 'JobsiteWorkerWithDifferentContractor',
}

/** Input for binding an authenticated self-onboarding worker to a jobsite. */
export type SelfOnboardingAssignToJobsiteInput = {
  /** Selected contractor; the jobsite's default is assigned when omitted. */
  contractorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Invitation from the onboarding URL; resolves the jobsite server-side for
   * feature-flag targeting and for the assignment.
   */
  jobsiteInvitationId: Scalars['ID']['input'];
};

export type SelfOnboardingAssignToJobsitePayload = {
  __typename?: 'SelfOnboardingAssignToJobsitePayload';
  /**
   * The bound jobsiteWorker. Absent when the resolved action aborts without an
   * existing jobsiteWorker (e.g. a jobsiteWorker under a different contractor).
   */
  jobsiteWorker?: Maybe<JobsiteWorker>;
  /** Resume/abort/start decision, for the frontend to drive conflict handling. */
  selfOnboardingInfo: SelfOnboardingWorkerInfo;
};

/**
 * Input for creating the authenticated Odin account of a self-onboarding worker.
 * Carries no contractor: the account is created independently of any jobsite
 * assignment (see 'selfOnboardingAssignToJobsite').
 */
export type SelfOnboardingCreateAccountInput = {
  /** Name (first/last) and contact (email, phone) for the new user account. */
  createUserInput: CreateUserInput;
  /**
   * FusionAuth token from 'completeAnonymousPhoneVerification', proving the
   * caller owns 'createUserInput.phoneNumber'. Required — the new account is
   * linked to that OTP-verified FusionAuth user rather than creating a new one.
   */
  phoneVerificationToken: Scalars['String']['input'];
  /**
   * Ids of the platform policy documents the worker affirmed at account
   * creation (the aggregate consent checkbox, fanned out to the displayed
   * 'getCurrentPolicyDocuments'). One 'policy_consent' row is written per id.
   * Empty when the consent step is inactive (flag off or no policies seeded).
   */
  policyDocumentIds: Array<Scalars['ID']['input']>;
  /**
   * Whether the worker checked the mandatory SMS opt-in box. Sent explicitly
   * (rather than assumed from the UI gating) so the 'smsConsentReceivedAt'
   * audit stamp reflects genuine consent even for direct API callers: the
   * timestamp is recorded only when this is true.
   */
  smsOptInAcknowledged: Scalars['Boolean']['input'];
  /**
   * Worker attributes plus 'jobsiteInvitationId', which resolves the jobsite
   * server-side for feature-flag targeting and is stamped onto the worker.
   */
  workerInput: SelfOnboardingWorkerCreateInput;
};

export type SelfOnboardingCreateAccountPayload = {
  __typename?: 'SelfOnboardingCreateAccountPayload';
  auth: Auth;
  worker: Worker;
};

export { SelfOnboardingStepKey };

/** Input for creating a worker that does not already have a user account */
export type SelfOnboardingWorkerAccountCreateInput = {
  contractorId: Scalars['ID']['input'];
  /** Input fields for creating a new user account */
  createUserInput: CreateUserInput;
  jobsiteId: Scalars['ID']['input'];
  /**
   * FusionAuth token from 'completeAnonymousPhoneVerification', proving the
   * caller owns 'createUserInput.phoneNumber'. Required and validated when
   * authenticated self-onboarding is enabled for the jobsite (the new account is
   * linked to the FusionAuth user from the OTP step); ignored otherwise.
   */
  phoneVerificationToken?: InputMaybe<Scalars['String']['input']>;
  /** Input fields for creating a new worker */
  workerInput: SelfOnboardingWorkerCreateInput;
};

export type SelfOnboardingWorkerAccountUpdateInput = {
  userInput: UpdateUserInput;
  workerId: Scalars['ID']['input'];
  workerInput: SelfOnboardingWorkerUpdateInput;
};

export enum SelfOnboardingWorkerAction {
  AbortOnboarding = 'AbortOnboarding',
  ResumeOnboarding = 'ResumeOnboarding',
  StartNewOnboarding = 'StartNewOnboarding',
}

export type SelfOnboardingWorkerCreateInput = {
  jobsiteInvitationId: Scalars['ID']['input'];
  /** Middle Initial of the worker */
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  /** Primary language of the worker */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  selfOnboardingCurrentStep?: InputMaybe<Scalars['String']['input']>;
  /** Suffix of the worker */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** Base info for the worker */
  workerBaseInfoInput?: InputMaybe<WorkerBaseInfoInput>;
};

export type SelfOnboardingWorkerCreatePayload = {
  __typename?: 'SelfOnboardingWorkerCreatePayload';
  auth: Auth;
  jobsiteWorker: JobsiteWorker;
};

export type SelfOnboardingWorkerInfo = {
  __typename?: 'SelfOnboardingWorkerInfo';
  abortReason?: Maybe<SelfOnboardingAbortReason>;
  continueAction: SelfOnboardingWorkerAction;
  jobsiteWorkerId?: Maybe<Scalars['ID']['output']>;
};

/** Input for SelfOnboardingWorkerUpdate Mutation */
export type SelfOnboardingWorkerUpdateInput = {
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  selfOnboardingCurrentStep?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  workerBaseInfoInput?: InputMaybe<WorkerBaseInfoInput>;
};

export type SelfOnboardingWorkerUpdatePayload = {
  __typename?: 'SelfOnboardingWorkerUpdatePayload';
  worker: Worker;
};

export type SendScheduleNotificationsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SendScheduleNotificationsPayload = {
  __typename?: 'SendScheduleNotificationsPayload';
  schedule: Schedule;
};

export enum SessionDisplayColumns {
  BalancedGross = 'balanced_gross',
  NaiveGross = 'naive_gross',
  NetOffsite = 'net_offsite',
  NetOnsite = 'net_onsite',
  NetTotal = 'net_total',
  SmartBalancedGross = 'smart_balanced_gross',
}

/** This is deprecated. */
export enum SessionType {
  Admin = 'ADMIN',
  Contractor = 'CONTRACTOR',
  Fusionauth = 'FUSIONAUTH',
  LimitedWorkerToken = 'LIMITED_WORKER_TOKEN',
  Organization = 'ORGANIZATION',
  Password = 'PASSWORD',
  Passwordless = 'PASSWORDLESS',
  Pin = 'PIN',
  RefreshToken = 'REFRESH_TOKEN',
  WalletToken = 'WALLET_TOKEN',
  Worker = 'WORKER',
}

export type SetDeviceLastStationInput = {
  jobsiteGatewayId?: InputMaybe<Scalars['ID']['input']>;
  jobsiteId: Scalars['ID']['input'];
};

export type SetMyPinInput = {
  pin: Scalars['String']['input'];
};

export type SetupAvigilonAccessConnectorInput = {
  siteId: Scalars['ID']['input'];
};

export type SetupAvigilonVideoConnectorInput = {
  siteId: Scalars['ID']['input'];
};

/** A site, by id and name. */
export type Site = {
  __typename?: 'Site';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** A controller assigned to the site, as Site Settings > Devices shows it. Every id belongs to the site. */
export type SiteController = {
  __typename?: 'SiteController';
  /** When the controller was assigned to the site; unset for an assignment recorded before Odin kept it. */
  assignedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The name of who assigned it; unset when unknown. */
  assignedBy?: Maybe<Scalars['String']['output']>;
  /** The controller's assignment to the site; what sync and remove act on. */
  assignmentId: Scalars['ID']['output'];
  connection?: Maybe<SiteDeviceConnection>;
  createdAt: Scalars['DateTime']['output'];
  /** The controller unit. */
  deviceId: Scalars['ID']['output'];
  health: DeviceHealth;
  healthObservedAt?: Maybe<Scalars['DateTime']['output']>;
  lastFailureCode?: Maybe<SiteControllerFailureCode>;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessfulSyncAt?: Maybe<Scalars['DateTime']['output']>;
  modelKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** In provider order. */
  ports: Array<SiteControllerPort>;
  provisioningStatus: AccessControllerProvisioningStatus;
  /** By name. */
  readers: Array<SiteControllerReader>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** Why the latest sync of a controller failed; anything else recorded is Support's. */
export enum SiteControllerFailureCode {
  ControllerMissing = 'CONTROLLER_MISSING',
  IncompleteSnapshot = 'INCOMPLETE_SNAPSHOT',
  ProviderUnavailable = 'PROVIDER_UNAVAILABLE',
}

export type SiteControllerPort = {
  __typename?: 'SiteControllerPort';
  externalPortId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  portType: AccessControllerPortType;
  position: Scalars['Int']['output'];
  /** The site's reader on the port, if one is. */
  readerId?: Maybe<Scalars['ID']['output']>;
};

/** A reader the site records under a controller, or finds on its ports. */
export type SiteControllerReader = {
  __typename?: 'SiteControllerReader';
  connection?: Maybe<SiteDeviceConnection>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<SiteReaderEntry>;
  health: SiteReaderHealth;
  kind: SiteReaderKind;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the provider no longer reports it. */
  missing: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ownership: SiteReaderOwnership;
  placement: SiteReaderPlacements;
  /** The controller's port it is on; unset when it is unplugged or on another controller's port. */
  port?: Maybe<SiteControllerReaderPort>;
  readerDeviceId: Scalars['ID']['output'];
  readerId: Scalars['ID']['output'];
  /** When the reader was registered on the site. */
  registeredAt: Scalars['DateTime']['output'];
  /** The name of who registered it; unset when unknown. */
  registeredBy?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

export type SiteControllerReaderPort = {
  __typename?: 'SiteControllerReaderPort';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

/** What a sync found in Avigilon. */
export enum SiteControllerSyncStatus {
  /** Avigilon reports something different; it is applied. */
  Changed = 'CHANGED',
  /** Avigilon no longer has the controller; it is shown offline and every recorded fact stays. */
  Missing = 'MISSING',
  /** Inventory facts are unchanged; observation time, health and sync diagnostics may refresh. */
  Unchanged = 'UNCHANGED',
}

/** The provider resource a device is connected to. */
export type SiteDeviceConnection = {
  __typename?: 'SiteDeviceConnection';
  externalId: Scalars['ID']['output'];
  externalName: Scalars['String']['output'];
};

export enum SiteDeviceFailure {
  IncompleteSnapshot = 'INCOMPLETE_SNAPSHOT',
  ProviderUnavailable = 'PROVIDER_UNAVAILABLE',
  SerialLookupUnsupported = 'SERIAL_LOOKUP_UNSUPPORTED',
}

/** A reader's place on an entry in one revision of the site's layout. */
export type SiteDevicePlacement = {
  __typename?: 'SiteDevicePlacement';
  entryId: Scalars['ID']['output'];
  entryName: Scalars['String']['output'];
  placementId: Scalars['ID']['output'];
};

export enum SiteDeviceRefusal {
  /** Check Avigilon to determine its current assignment; Odin names no other site. */
  AlreadyAssigned = 'ALREADY_ASSIGNED',
  AmbiguousSerial = 'AMBIGUOUS_SERIAL',
  AssignmentChanged = 'ASSIGNMENT_CHANGED',
  AssociationUnresolved = 'ASSOCIATION_UNRESOLVED',
  ConnectorDisabled = 'CONNECTOR_DISABLED',
  NotFound = 'NOT_FOUND',
  PublishedPlacement = 'PUBLISHED_PLACEMENT',
  ReaderConflict = 'READER_CONFLICT',
  SerialRequired = 'SERIAL_REQUIRED',
}

/** How a site device command ended. */
export enum SiteDeviceResultKind {
  /** The command applied; the fields it answers are set. */
  Applied = 'APPLIED',
  /** The provider could not be read; the run has the cause. */
  Failed = 'FAILED',
  /** The command applied nothing; the refusal says why, in Odin's words, naming no other site. */
  Refused = 'REFUSED',
  /** Another write to the controller landed meanwhile; nothing applied. Reload and try again. */
  Superseded = 'SUPERSEDED',
}

/** A site reader explicitly resolved as independent of a controller. */
export type SiteIndependentReader = {
  __typename?: 'SiteIndependentReader';
  connection?: Maybe<SiteDeviceConnection>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<SiteReaderEntry>;
  health: SiteReaderHealth;
  kind: SiteReaderKind;
  lastSeenAt?: Maybe<Scalars['DateTime']['output']>;
  missing: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  placement: SiteReaderPlacements;
  readerDeviceId: Scalars['ID']['output'];
  readerId: Scalars['ID']['output'];
  registeredAt: Scalars['DateTime']['output'];
  registeredBy?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * One revision of a site's layout, read whole. Zone, entry, entry side, and
 * reader ids are stable across revisions; the revision and its reader
 * assignments have ids of their own.
 */
export type SiteLayout = {
  __typename?: 'SiteLayout';
  /**
   * The draft token to send with the draft's next write, read in the same
   * snapshot as this layout: the token to save against. Draft only.
   */
  draftToken?: Maybe<Scalars['Int']['output']>;
  /** Null while the revision is a draft. */
  effectiveFrom?: Maybe<Scalars['Date']['output']>;
  /** Null while the revision is the effective layout, or a draft. */
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  entries: Array<Entry>;
  /**
   * The client request id of the last committed write to the draft that sent
   * one; a write without one leaves it as it was. After a lost response, the
   * request id still here confirms that write committed; another client's
   * later write replaces it. Draft only; null until a client write sends one.
   */
  lastRequestId?: Maybe<Scalars['ID']['output']>;
  /** Null while the revision is a draft. */
  publishedAt?: Maybe<Scalars['Date']['output']>;
  /** The readers assigned somewhere in this revision. */
  readers: Array<Reader>;
  revisionId: Scalars['ID']['output'];
  zones: Array<Zone>;
};

/** Who created, last wrote or published a revision. */
export type SiteLayoutActor = {
  __typename?: 'SiteLayoutActor';
  id: Scalars['ID']['output'];
  /** The user's name; Unknown user for an account with none. */
  name: Scalars['String']['output'];
};

/**
 * A site's revisions in one read. Delivery to providers is not part of it:
 * read siteLayoutPublications.
 */
export type SiteLayoutOverview = {
  __typename?: 'SiteLayoutOverview';
  /** The draft, while the site has one. */
  draft?: Maybe<SiteLayoutRevisionSummary>;
  /** The effective revision; null until the site's first layout is published. */
  effective?: Maybe<SiteLayoutRevisionSummary>;
  /** Every revision of the site: the draft first, then newest window first. */
  history: Array<SiteLayoutRevisionSummary>;
};

/**
 * The delivery of a published layout revision to one of the site's
 * connectors. Publishing a revision requests it for each enabled connector;
 * reconcileSiteLayout requests it again.
 */
export type SiteLayoutPublication = {
  __typename?: 'SiteLayoutPublication';
  /** Attempts since delivery last succeeded, counted up to 30. */
  attempts: Scalars['Int']['output'];
  connectorId: Scalars['ID']['output'];
  /** The connector's status now; delivery writes nothing to a connector that is not enabled. */
  connectorStatus: ConnectorStatus;
  connectorType: ConnectorType;
  id: Scalars['ID']['output'];
  /** When the next attempt is due; null when no requested delivery is outstanding. */
  nextAttemptAt?: Maybe<Scalars['Date']['output']>;
  /** When delivery was last requested. */
  requestedAt: Scalars['Date']['output'];
  revisionId: Scalars['ID']['output'];
  /**
   * The connector run of the latest attempt, with its outcome and message;
   * null until delivery first runs. A delivery that writes nothing (zones
   * mode Off, the connector disabled or not supporting layouts, the revision
   * superseded) finishes SUCCEEDED with a message saying why: read it with
   * the site's zones mode and nextAttemptAt.
   */
  run?: Maybe<ConnectorRun>;
};

/**
 * One revision of a site's layout as the site's history lists it. The draft
 * has no published or effective instants; the effective revision has no end.
 */
export type SiteLayoutRevision = {
  __typename?: 'SiteLayoutRevision';
  createdAt: Scalars['Date']['output'];
  effectiveFrom?: Maybe<Scalars['Date']['output']>;
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The revision read whole. Null for a draft discarded since it was listed;
   * published revisions are never removed.
   */
  layout?: Maybe<SiteLayout>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
};

/** Where a revision stands in the site's history. */
export enum SiteLayoutRevisionStatus {
  /** The site's one draft. */
  Draft = 'DRAFT',
  /** The open published revision: the site's effective layout. */
  Effective = 'EFFECTIVE',
  /** A published revision a later publication has closed. */
  Superseded = 'SUPERSEDED',
}

/**
 * One revision as the site's versions list shows it. number counts the site's
 * published revisions from 1 in effectiveFrom order; the draft takes the
 * number after the last of them.
 */
export type SiteLayoutRevisionSummary = {
  __typename?: 'SiteLayoutRevisionSummary';
  createdAt: Scalars['Date']['output'];
  createdBy: SiteLayoutActor;
  /**
   * The draft's token now. Draft only. This read and the draft layout are
   * separate snapshots, so save against the draftToken of the draft layout
   * read (siteLayoutDraft, or siteLayoutRevision's layout): it comes with the
   * layout it goes with. A token read here beside the layout may be newer than
   * it, and would let a write overwrite changes the client never saw.
   */
  draftToken?: Maybe<Scalars['Int']['output']>;
  /** Null while the revision is a draft. */
  effectiveFrom?: Maybe<Scalars['Date']['output']>;
  /** Null while the revision is the effective layout, or a draft. */
  effectiveTo?: Maybe<Scalars['Date']['output']>;
  /**
   * The client request id of the last committed write to the draft that sent
   * one; a write without one leaves it as it was. After a lost response, the
   * request id still here confirms that write committed; another client's
   * later write replaces it. Draft only; null until a client write sends one.
   */
  lastRequestId?: Maybe<Scalars['ID']['output']>;
  number: Scalars['Int']['output'];
  /** Null while the revision is a draft. */
  publishedAt?: Maybe<Scalars['Date']['output']>;
  /** Who published the revision. Null for the draft, and where it is not known: show Unknown. */
  publishedBy?: Maybe<SiteLayoutActor>;
  revisionId: Scalars['ID']['output'];
  status: SiteLayoutRevisionStatus;
  updatedAt: Scalars['Date']['output'];
  updatedBy: SiteLayoutActor;
};

/**
 * What the current user may do on the zones surfaces of one site. Manage
 * includes View. Admin and Super Admin hold every permission at every site;
 * Odin Ambassador Admin holds the site devices permissions only at sites
 * that role is assigned to, until site layout and site groups authorize by
 * this catalog.
 */
export enum SitePermission {
  ManageSiteDevices = 'MANAGE_SITE_DEVICES',
  ManageSiteGroups = 'MANAGE_SITE_GROUPS',
  ManageSiteLayout = 'MANAGE_SITE_LAYOUT',
  ViewSiteDevices = 'VIEW_SITE_DEVICES',
  ViewSiteGroups = 'VIEW_SITE_GROUPS',
  ViewSiteLayout = 'VIEW_SITE_LAYOUT',
}

export type SiteReaderAttachment = {
  __typename?: 'SiteReaderAttachment';
  currentSite: Scalars['Boolean']['output'];
  entryId: Scalars['ID']['output'];
  entryName: Scalars['String']['output'];
  removable: Scalars['Boolean']['output'];
  removalBlockedReason?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['ID']['output'];
  siteName: Scalars['String']['output'];
  zoneId: Scalars['ID']['output'];
  zoneName: Scalars['String']['output'];
};

export type SiteReaderAttachments = {
  __typename?: 'SiteReaderAttachments';
  attachments: Array<SiteReaderAttachment>;
  fingerprint: Scalars['String']['output'];
  readerName: Scalars['String']['output'];
};

export type SiteReaderAttachmentsInput = {
  assignmentId: Scalars['ID']['input'];
  readerDeviceId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

/** A reader device on a site: one the site layout has an open reader for there. */
export type SiteReaderDevice = {
  __typename?: 'SiteReaderDevice';
  /**
   * For a reader device on a port, the device of the access controller device
   * the port belongs to; unset when it is on none.
   */
  accessControllerDevice?: Maybe<Device>;
  /**
   * The access controller port it is on, with it on the port; unset when it
   * is on none.
   */
  accessControllerPort?: Maybe<AccessControllerPort>;
  device: Device;
  /** The Avigilon reader the reader device is connected to; null while it has none. */
  externalEntity?: Maybe<ExternalEntity>;
  /** The reader device's id. */
  id: Scalars['ID']['output'];
  /**
   * When it was first no longer listed for this site: the earlier of when a
   * complete discovery first no longer found it at the provider and when the
   * site's connector inventory first no longer listed the provider reader
   * connected to it. The discovery's mark is dropped once the inventory has
   * listed that provider reader since a discovery last found it missing. The
   * inventory lists a reader only while its access control unit serves
   * entries of the connector's Alta site, so it can be missing here while
   * the provider still has it. Unset when neither mark holds.
   */
  missingSince?: Maybe<Scalars['Date']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** The Alta entry served by the reader; an entry may serve both kinds. */
export type SiteReaderEntry = {
  __typename?: 'SiteReaderEntry';
  externalEntryId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Kind-specific health; read times belong to the entry, not an individual reader. */
export type SiteReaderHealth = {
  __typename?: 'SiteReaderHealth';
  /** Set for Wiegand readers only. */
  bound?: Maybe<Scalars['Boolean']['output']>;
  /** Set for Alta readers only. */
  isMissing?: Maybe<Scalars['Boolean']['output']>;
  kind: SiteReaderKind;
  /** The latest Alta access event ingested for the entry on this site. */
  lastReadAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum SiteReaderKind {
  Alta = 'ALTA',
  Wiegand = 'WIEGAND',
}

/** Which controller the site records a reader under. */
export enum SiteReaderOwnership {
  /** This controller. */
  Assigned = 'ASSIGNED',
  /** Another controller, or recorded independent by Support, while its device sits on this controller's port. */
  NotThisController = 'NOT_THIS_CONTROLLER',
  /** None yet; Support resolves it, and the controller cannot be removed until then. */
  Unresolved = 'UNRESOLVED',
}

export type SiteReaderPlacements = {
  __typename?: 'SiteReaderPlacements';
  /** In the site's draft, when it has one. */
  draft?: Maybe<SiteDevicePlacement>;
  /** In the layout in force now. */
  published?: Maybe<SiteDevicePlacement>;
};

export enum SiteSpecificOrientationStatus {
  All = 'ALL',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  NotComplete = 'NOT_COMPLETE',
}

/** A reader of the site with no recorded controller. No controller of the site can be removed until Support resolves it. */
export type SiteUnresolvedReader = {
  __typename?: 'SiteUnresolvedReader';
  connection?: Maybe<SiteDeviceConnection>;
  /** Unset when it is on no port of the site's controllers. */
  controller?: Maybe<SiteUnresolvedReaderController>;
  entry?: Maybe<SiteReaderEntry>;
  health: SiteReaderHealth;
  kind: SiteReaderKind;
  /** Whether the provider no longer reports it. */
  missing: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  readerDeviceId: Scalars['ID']['output'];
  readerId: Scalars['ID']['output'];
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** The site's controller whose port an unresolved reader is on. */
export type SiteUnresolvedReaderController = {
  __typename?: 'SiteUnresolvedReaderController';
  assignmentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  portLabel: Scalars['String']['output'];
};

export type SizeInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width: Scalars['Int']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SortInput = {
  __typename?: 'SortInput';
  direction?: Maybe<SortDirection>;
  field?: Maybe<Scalars['String']['output']>;
};

export type StartAnonymousPhoneVerificationInput = {
  phoneNumber: Scalars['String']['input'];
};

export type StartAnonymousPhoneVerificationResponse = {
  __typename?: 'StartAnonymousPhoneVerificationResponse';
  success: Scalars['Boolean']['output'];
};

export type StartPasswordlessLoginInput = {
  loginId: Scalars['String']['input'];
};

export type StartPasswordlessLoginResponse = {
  __typename?: 'StartPasswordlessLoginResponse';
  success: Scalars['Boolean']['output'];
};

export type StartPhoneNumberVerificationInput = {
  isLogin?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  workerId?: InputMaybe<Scalars['ID']['input']>;
};

export type StartPhoneNumberVerificationResponse = {
  __typename?: 'StartPhoneNumberVerificationResponse';
  success: Scalars['Boolean']['output'];
};

/** Represents all valid state abbreviations */
export enum StateAbbreviation {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
}

/**
 * A scanning post: a jobsite plus an optional committed gateway — the unit a
 * scanner operator selects before scanning workers in/out.
 */
export type Station = {
  __typename?: 'Station';
  deviceId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** The committed jobsite, always present. */
  jobsite: Jobsite;
  /** The committed gateway, or null if the station was committed without one. */
  jobsiteGateway?: Maybe<JobsiteGateway>;
};

export type StripeMappingData = {
  __typename?: 'StripeMappingData';
  clientSecret?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
};

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod';
  brand?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type SubcontractedJobsiteContractorEdge = {
  __typename?: 'SubcontractedJobsiteContractorEdge';
  node: JobsiteContractor;
};

export type SubcontractedJobsiteContractorsConnection = {
  __typename?: 'SubcontractedJobsiteContractorsConnection';
  count: Scalars['Int']['output'];
  edges: Array<SubcontractedJobsiteContractorEdge>;
};

export type SubcontractedJobsiteContractorsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type Success = {
  __typename?: 'Success';
  success: Scalars['Boolean']['output'];
};

export type SyncResult = {
  __typename?: 'SyncResult';
  avigilonResourceId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['Date']['output']>;
};

export type SyncSiteControllerInput = {
  /** The controller's assignment to the site, so an old screen cannot act on a later assignment of the same unit. */
  assignmentId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type SyncSiteControllerPayload = {
  __typename?: 'SyncSiteControllerPayload';
  failure?: Maybe<SiteDeviceFailure>;
  kind: SiteDeviceResultKind;
  /** When Avigilon was read, when applied. */
  observedAt?: Maybe<Scalars['DateTime']['output']>;
  refusal?: Maybe<SiteDeviceRefusal>;
  /** An opaque reference to the connector run that recorded the technical outcome, for Support. */
  runId?: Maybe<Scalars['ID']['output']>;
  /** What the sync found, when applied. */
  status?: Maybe<SiteControllerSyncStatus>;
};

export type TempBadge = {
  __typename?: 'TempBadge';
  activeWorkerCard?: Maybe<WorkerCard>;
  badgeTemplate: BadgeTemplate;
  cardNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobsite: Jobsite;
  jobsiteCardFormat?: Maybe<JobsiteCardFormat>;
  lastPrintJob?: Maybe<CardPrintJob>;
  name: Scalars['String']['output'];
  objectHistory: ObjectHistory;
  status?: Maybe<TempBadgeStatus>;
};

export type TempBadgeAssignmentError = {
  __typename?: 'TempBadgeAssignmentError';
  code?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<TempBadgeStatus>;
  message: Scalars['String']['output'];
};

export type TempBadgeEdge = {
  __typename?: 'TempBadgeEdge';
  node?: Maybe<TempBadge>;
};

export enum TempBadgeErrorCode {
  InvalidStateTransition = 'INVALID_STATE_TRANSITION',
  TempBadgeAlreadyExists = 'TEMP_BADGE_ALREADY_EXISTS',
}

export type TempBadgePayload = {
  __typename?: 'TempBadgePayload';
  tempBadge: TempBadge;
};

export enum TempBadgeStatus {
  Assigned = 'assigned',
  Created = 'created',
  Deactivated = 'deactivated',
  PrintFailed = 'printFailed',
  Printed = 'printed',
  Printing = 'printing',
  Registered = 'registered',
}

export type TempBadgesConnection = {
  __typename?: 'TempBadgesConnection';
  count: Scalars['Int']['output'];
  edges: Array<TempBadgeEdge>;
};

export type TempBadgesFilters = {
  __typename?: 'TempBadgesFilters';
  cardNumbers: Array<FilterOption>;
};

export type TempBadgesInput = {
  cardNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Used to filter temp badges by jobsite IDs.
   * The value passed from the client will be ignored when
   * the input is used for jobsite.tempBadges.
   */
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<Array<GetTempBadgesOrderBy>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeactivatedBadges?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<TempBadgeStatus>>;
  syncPrintJob?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeSeries = {
  __typename?: 'TimeSeries';
  dateTime: Scalars['Date']['output'];
  timeZone: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export enum TimeSeriesInputInterval {
  Every_1Hour = 'every_1_hour',
  Every_15Minutes = 'every_15_minutes',
  Every_30Minutes = 'every_30_minutes',
}

export type UnregisterDevicePushTokenInput = {
  /** AppInstanceId — identifies which device token to remove */
  deviceId: Scalars['String']['input'];
};

export type UpdateScheduleShiftInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduleShiftPayload = {
  __typename?: 'UpdateScheduleShiftPayload';
  scheduleShift: ScheduleShift;
};

export type UpdateScheduleWorkerInput = {
  activity?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jobsiteContractorId?: InputMaybe<Scalars['ID']['input']>;
  jobsiteWorkerId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  trade?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ScheduleWorkerType>;
};

export type UpdateScheduleWorkerPayload = {
  __typename?: 'UpdateScheduleWorkerPayload';
  scheduleWorker: ScheduleWorker;
};

export type UpdateUserInput = {
  /** Email of the new user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the new user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the new user */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the new user */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkerCardFormatInput = {
  cardType: WorkerCardType;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityCode?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type User = {
  __typename?: 'User';
  /** Available jobsites or contractors to assign roles on */
  availableRoleObjects: UserAvailableRoleObjectsConnection;
  badgeTemplates: UserBadgeTemplatesConnection;
  cCureEntityMappingOptions: UserCCureEntityMappingOptionsConnection;
  cCureEnvironments: UserCCureEnvironmentsConnection;
  contractorMembers: UserContractorMembersConnection;
  /** All of the contractors that the user has access to, either directly or via subcontracting */
  contractors: UserContractorsConnection;
  /** When the user was created */
  createdAt: Scalars['Date']['output'];
  developers: UserDevelopersConnection;
  forms: UserFormsConnection;
  hasAnnouncementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the user has an authentication method, such as email/password */
  hasAuth: Scalars['Boolean']['output'];
  hasCamerasEnabled?: Maybe<Scalars['Boolean']['output']>;
  hasFormsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if a user has paid or free access. */
  hasPaidAccess?: Maybe<Scalars['Boolean']['output']>;
  hasSchedulingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the user has a urlLockCode set */
  hasUrlLockCode: Scalars['Boolean']['output'];
  hidEntityOptions: UserHidEntityOptionsConnection;
  /** The optional identity of the user. If this is null, the user is anonymous */
  identity?: Maybe<UserIdentity>;
  /** Used for determining whether this user has used the mobile log in flow */
  isMobileUser?: Maybe<Scalars['Boolean']['output']>;
  jobsiteAccessEvents?: Maybe<JobsiteAccessEventsConnection>;
  jobsiteAccessSessions?: Maybe<JobsiteAccessSessionsConnection>;
  jobsiteFormSubmissions: JobsiteFormSubmissionsConnection;
  jobsiteForms: UserJobsiteFormsConnection;
  jobsiteMembers: UserJobsiteMembersConnection;
  /** All of the jobsites that the user has access to */
  jobsites: UserJobsitesConnection;
  /** Most recent user session */
  lastSession?: Maybe<UserSession>;
  mobileDeviceInfo?: Maybe<MobileDeviceInfo>;
  organizations: UserOrganizationsConnection;
  /** Metadata about the user's PIN credential, if set. Null when no PIN exists. */
  pin?: Maybe<UserPin>;
  /** User profile picture */
  profilePicture?: Maybe<File>;
  /** User cropped profile picture */
  profilePictureCropped?: Maybe<File>;
  /** Indicates which roles the user is a member of */
  roles: Array<UserRole>;
  schedules: SchedulesConnection;
  /** Unique ID of the user */
  userAccountId: Scalars['ID']['output'];
  users: UserUsersConnection;
  worker?: Maybe<Worker>;
  workerCardFormats: UserWorkerCardFormatsConnection;
  workerDocumentTypes: UserWorkerDocumentTypesConnection;
  /** All workers that the user has access to, whether via a contractor or jobsite */
  workers: UserWorkersConnection;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserAvailableRoleObjectsArgs = {
  input?: InputMaybe<UserAvailableRoleObjectsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserCCureEntityMappingOptionsArgs = {
  input?: InputMaybe<UserCCureEnvironmentsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserCCureEnvironmentsArgs = {
  input?: InputMaybe<UserCCureEnvironmentsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserContractorMembersArgs = {
  input?: InputMaybe<UserContractorMembersInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserContractorsArgs = {
  input?: InputMaybe<UserContractorsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserDevelopersArgs = {
  input?: InputMaybe<UserDevelopersInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserFormsArgs = {
  input?: InputMaybe<UserFormsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserJobsiteAccessEventsArgs = {
  input?: InputMaybe<JobsiteAccessEventsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserJobsiteAccessSessionsArgs = {
  input?: InputMaybe<JobsiteAccessSessionsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserJobsiteFormSubmissionsArgs = {
  input: JobsiteFormSubmissionsInput;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserJobsiteFormsArgs = {
  input?: InputMaybe<UserJobsiteFormsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserJobsiteMembersArgs = {
  input?: InputMaybe<UserJobsiteMembersInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserJobsitesArgs = {
  input?: InputMaybe<UserJobsitesInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserOrganizationsArgs = {
  input?: InputMaybe<GetAllOrganizationsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserRolesArgs = {
  input?: InputMaybe<UserRolesInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserSchedulesArgs = {
  input: SchedulesInput;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserUsersArgs = {
  input?: InputMaybe<UserUsersInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserWorkerCardFormatsArgs = {
  input?: InputMaybe<UserWorkerCardFormatsInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserWorkerDocumentTypesArgs = {
  input?: InputMaybe<UserWorkerDocumentTypesInput>;
};

/**
 * Represents a user and all of its underlying properties. A user can be in one of three states:
 * 1. Anonymous - The user has no identity or auth. The user can still interact with endpoints as if it were a normal
 * user, but they will not be able to fetch that data once the session has expired.
 * 2. Identified - The user has an identity but no auth. This is usually the state of an invited user.
 * 3. Web Account - The user has both an identity and an authentication mechanism. The can use the endpoints fully and
 * can always login with their credentials.
 */
export type UserWorkersArgs = {
  input?: InputMaybe<UserWorkersInput>;
};

export type UserAssignInput = {
  memberUserAccountId: Scalars['ID']['input'];
  userAssignmentInput: UserAssignmentInput;
};

export type UserAssignmentInput = {
  /** Title of the member at the jobsite. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the jobsites or contractors to assign the member to, based on 'userAssignmentType'. */
  userAssignmentObjectIds: Array<Scalars['ID']['input']>;
  /** Specifies if a user is assigned to a jobsite or a contractor */
  userAssignmentType: UserAssignmentType;
  /** The user role to assign the user to */
  userRoleKey: UserRoleKey;
};

export enum UserAssignmentType {
  Contractor = 'Contractor',
  Developer = 'Developer',
  Jobsite = 'Jobsite',
}

export type UserAvailableRoleObjectsConnection = {
  __typename?: 'UserAvailableRoleObjectsConnection';
  contractors: Array<Contractor>;
  jobsites: Array<Jobsite>;
};

export type UserAvailableRoleObjectsInput = {
  /** If true, includes the jobsites or contractors for which the user already has a role assigned. */
  includeAssignedObjects?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserBadgeTemplatesConnection = {
  __typename?: 'UserBadgeTemplatesConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<UserBadgeTemplatesEdge>>;
};

export type UserBadgeTemplatesEdge = {
  __typename?: 'UserBadgeTemplatesEdge';
  node: BadgeTemplate;
};

export type UserCCureEntityMappingOptionsConnection = {
  __typename?: 'UserCCureEntityMappingOptionsConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<UserCCureEntityMappingOptionsEdge>>;
};

export type UserCCureEntityMappingOptionsEdge = {
  __typename?: 'UserCCureEntityMappingOptionsEdge';
  node: CCureEntityMapping;
};

export type UserCCureEntityMappingOptionsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserCCureEnvironmentsConnection = {
  __typename?: 'UserCCureEnvironmentsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserCCureEnvironmentsEdge>;
};

export type UserCCureEnvironmentsEdge = {
  __typename?: 'UserCCureEnvironmentsEdge';
  node: CCureEnvironment;
};

export type UserCCureEnvironmentsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserCancelPendingChangeInput = {
  changeType: UserPendingChangeType;
  workerId: Scalars['ID']['input'];
};

export type UserConfirmPendingChangeInput = {
  changeType: UserPendingChangeType;
  workerId: Scalars['ID']['input'];
};

export type UserContractorMembersConnection = {
  __typename?: 'UserContractorMembersConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserContractorMembersEdge>;
};

export type UserContractorMembersEdge = {
  __typename?: 'UserContractorMembersEdge';
  node: ContractorMember;
};

export type UserContractorMembersInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserContractorsConnection = {
  __typename?: 'UserContractorsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserContractorsEdge>;
};

export type UserContractorsEdge = {
  __typename?: 'UserContractorsEdge';
  node: Contractor;
};

export type UserContractorsInput = {
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for Jobsite Mutations */
export type UserCreateInput = {
  /** If an email invite should be sent */
  sendInviteEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Input fields for assigning a user to jobsites or contractors */
  userAssignmentInput: UserAssignmentInput;
  /** Input fields for creating a new user account */
  userInviteInput: UserInviteInput;
};

export type UserDevelopersConnection = {
  __typename?: 'UserDevelopersConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserDevelopersEdge>;
};

export type UserDevelopersEdge = {
  __typename?: 'UserDevelopersEdge';
  node: Developer;
};

export type UserDevelopersInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum UserErrorCode {
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  FailedLogin = 'FAILED_LOGIN',
  IncorrectBirthdate = 'INCORRECT_BIRTHDATE',
  InvalidAuthentication = 'INVALID_AUTHENTICATION',
  InvalidEmail = 'INVALID_EMAIL',
  NotAuthenticated = 'NOT_AUTHENTICATED',
  NotAuthorized = 'NOT_AUTHORIZED',
  NoEmailOrPhone = 'NO_EMAIL_OR_PHONE',
  PhoneAlreadyExists = 'PHONE_ALREADY_EXISTS',
  SessionExpired = 'SESSION_EXPIRED',
  UserRoleNotFound = 'USER_ROLE_NOT_FOUND',
}

export type UserFormsConnection = {
  __typename?: 'UserFormsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserFormsEdge>;
};

export type UserFormsEdge = {
  __typename?: 'UserFormsEdge';
  node: Form;
};

export type UserFormsInput = {
  formKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAllForms?: InputMaybe<Scalars['Boolean']['input']>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserHidEntityOptionsConnection = {
  __typename?: 'UserHidEntityOptionsConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<UserHidEntityOptionsEdge>>;
};

export type UserHidEntityOptionsEdge = {
  __typename?: 'UserHidEntityOptionsEdge';
  node: HidEntityOption;
};

/** The identity of a user */
export type UserIdentity = {
  __typename?: 'UserIdentity';
  /** When the identity was created */
  createdAt: Scalars['Date']['output'];
  /** Email address of the user. This is unique to the user. */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the user */
  firstName?: Maybe<Scalars['String']['output']>;
  /** FusionAuth id of the user */
  fusionAuthId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Last name of the user */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone or email pending changes */
  pendingChanges?: Maybe<UserIdentityPendingChanges>;
  /** Phone number of the user */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * When the user affirmed the SMS opt-in disclosure, or null if they never
   * have. Drives the re-capture gate's SMS checkbox: it's shown only while this
   * is null (an already-consented user is never re-prompted).
   */
  smsConsentReceivedAt?: Maybe<Scalars['Date']['output']>;
  /** When the identity was updated */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserIdentityInput = {
  /** Email of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the user */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the user */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone or email pending changes */
  pendingChanges?: InputMaybe<UserIdentityPendingChangesInput>;
  /** User's phone */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserIdentityPendingChange = {
  __typename?: 'UserIdentityPendingChange';
  expiresAt: Scalars['Date']['output'];
  newValue: Scalars['String']['output'];
  submittedBy: User;
};

export type UserIdentityPendingChanges = {
  __typename?: 'UserIdentityPendingChanges';
  email?: Maybe<UserIdentityPendingChange>;
  phoneNumber?: Maybe<UserIdentityPendingChange>;
};

export type UserIdentityPendingChangesInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserInviteInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserJobsiteFormsConnection = {
  __typename?: 'UserJobsiteFormsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserJobsiteFormsEdge>;
};

export type UserJobsiteFormsEdge = {
  __typename?: 'UserJobsiteFormsEdge';
  node: JobsiteForm;
};

export type UserJobsiteFormsInput = {
  formId?: InputMaybe<Scalars['ID']['input']>;
  formKey?: InputMaybe<Scalars['String']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserJobsiteMembersConnection = {
  __typename?: 'UserJobsiteMembersConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserJobsiteMembersEdge>;
};

export type UserJobsiteMembersEdge = {
  __typename?: 'UserJobsiteMembersEdge';
  node: JobsiteMember;
};

export type UserJobsiteMembersInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserJobsitesConnection = {
  __typename?: 'UserJobsitesConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserJobsitesEdge>;
  filtersOptions?: Maybe<UserJobsitesFilters>;
  templatesCount: Scalars['Int']['output'];
};

export type UserJobsitesEdge = {
  __typename?: 'UserJobsitesEdge';
  node: Jobsite;
};

export type UserJobsitesFilters = {
  __typename?: 'UserJobsitesFilters';
  cities: Array<FilterOption>;
  developers: Array<FilterOption>;
  states: Array<FilterOption>;
};

export type UserJobsitesInput = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  developerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If true and the user is admin, return all jobsites that the user has a access to
   * as opposed to the sites they are assigned to
   */
  includeAllJobsites?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * GPS coordinate used to resolve the distance orderBy field. When orderBy includes
   * distance, jobsites are sorted by great-circle distance from this point (closest first);
   * jobsites without coordinates sort last. Has no effect unless distance is included in orderBy.
   */
  location?: InputMaybe<GpsCoordinateInput>;
  orderBy?: InputMaybe<Array<GetJobsitesOrderBy>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<StateAbbreviation>>;
};

export type UserOrganizationsConnection = {
  __typename?: 'UserOrganizationsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserOrganizationsEdge>;
};

export type UserOrganizationsEdge = {
  __typename?: 'UserOrganizationsEdge';
  node: Organization;
};

export type UserPayload = {
  __typename?: 'UserPayload';
  user: User;
};

export type UserPendingChange = {
  __typename?: 'UserPendingChange';
  currentValue: Scalars['String']['output'];
  expiresAt: Scalars['Date']['output'];
  newValue: Scalars['String']['output'];
  submittedBy: User;
};

export type UserPendingChangePayload = {
  __typename?: 'UserPendingChangePayload';
  change?: Maybe<UserPendingChange>;
};

export enum UserPendingChangeType {
  Email = 'email',
  Phone = 'phone',
}

/** PIN credential metadata for a user. The hash is never exposed. */
export type UserPin = {
  __typename?: 'UserPin';
  /** Number of consecutive failed PIN entries since the last successful login. */
  failedAttempts: Scalars['Int']['output'];
  /** If non-null, the credential is locked until this time due to repeated failures. */
  lockedUntil?: Maybe<Scalars['Date']['output']>;
  /** When the current PIN was set or last rotated. */
  pinSetAt: Scalars['Date']['output'];
};

/**
 * A current policy document paired with the current user's consent history for
 * its `key`. Drives the re-capture gate rows: the client derives the display
 * state from `lastAcceptedVersion` vs `document.version` — accepted when equal,
 * updated when an older version was accepted, new when never accepted.
 */
export type UserPolicyConsentStatus = {
  __typename?: 'UserPolicyConsentStatus';
  /** The current, effective version of the policy. */
  document: PolicyDocument;
  /** When the user consented to `lastAcceptedVersion`; null if never accepted. */
  lastAcceptedAt?: Maybe<Scalars['Date']['output']>;
  /**
   * The greatest version of this policy's `key` the user has ever consented to,
   * or null if they never have.
   */
  lastAcceptedVersion?: Maybe<Scalars['Int']['output']>;
};

export type UserRemoveAssignmentInput = {
  /** ID of the jobsiteMember or contractorMember, based on 'userAssignmentType'. */
  userAssignmentId: Scalars['ID']['input'];
  /** Specifies if a user is assigned to a jobsite or a contractor */
  userAssignmentType: UserAssignmentType;
};

/** A role for a user. A user can be associated with multiple roles. */
export type UserRole = {
  __typename?: 'UserRole';
  /** Display name of the role */
  displayName: Scalars['String']['output'];
  /** Indicates whether the role is a super-user role */
  isSuper: Scalars['Boolean']['output'];
  /** Human-readable, all lower-case, snake-case identifier for this role. This is unique to this role. */
  key: UserRoleKey;
  mappingCreatedAt: Scalars['Date']['output'];
  /** When the mapping of the user to the role was created */
  mappingId?: Maybe<Scalars['ID']['output']>;
  /** When the mapping of the user to the role was updated */
  mappingUpdatedAt: Scalars['Date']['output'];
  object?: Maybe<UserRoleObject>;
  /** When the role itself was created */
  roleCreatedAt: Scalars['Date']['output'];
  /** When the role itself was updated */
  roleUpdatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserRoleAssignInput = {
  key: UserRoleKey;
  object?: InputMaybe<UserRoleObjectInput>;
};

export enum UserRoleKey {
  Admin = 'admin',
  ClientAdmin = 'client_admin',
  ContractorAdmin = 'contractor_admin',
  ContractorEditor = 'contractor_editor',
  ContractorForeman = 'contractor_foreman',
  ContractorReader = 'contractor_reader',
  JobsiteAdmin = 'jobsite_admin',
  JobsiteDirectoryReader = 'jobsite_directory_reader',
  JobsiteEditor = 'jobsite_editor',
  JobsiteMedicSupervisor = 'jobsite_medic_supervisor',
  JobsiteOdinAmbassador = 'jobsite_odin_ambassador',
  JobsiteOdinAmbassadorAdmin = 'jobsite_odin_ambassador_admin',
  JobsiteReader = 'jobsite_reader',
  JobsiteSecurity = 'jobsite_security',
  JobsiteSecuritySupervisor = 'jobsite_security_supervisor',
  JobsiteSiteSafetyManager = 'jobsite_site_safety_manager',
  JobsiteSiteSafetyManagerFitout = 'jobsite_site_safety_manager_fitout',
  OnboardingOnly = 'onboarding_only',
  OnboardingOnlyAnnouncements = 'onboarding_only_announcements',
  Super = 'super',
  Worker = 'worker',
}

export type UserRoleObject = {
  __typename?: 'UserRoleObject';
  /** Details of the object the role is attached to */
  objectDetails?: Maybe<UserRoleObjectDetails>;
  /** Public ID of the object the role is attached to */
  objectId?: Maybe<Scalars['ID']['output']>;
  /** Type of the object the role is attached to */
  objectName?: Maybe<Scalars['String']['output']>;
};

export type UserRoleObjectDetails = {
  __typename?: 'UserRoleObjectDetails';
  /** Public ID of the object the role is attached to */
  id?: Maybe<Scalars['ID']['output']>;
  /** Name of the object the role is attached to */
  name?: Maybe<Scalars['String']['output']>;
  /** 'jobsiteMemberId' or 'contractorMemberId' based on type */
  objectMemberId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Type of the object the role is attached to */
  type?: Maybe<Scalars['String']['output']>;
};

export type UserRoleObjectInput = {
  objectId: Scalars['ID']['input'];
  objectName: Scalars['String']['input'];
};

export type UserRolesInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<GetUserRolesOrderBy>>>;
};

export type UserSearchQuery = {
  __typename?: 'UserSearchQuery';
  createdAt: Scalars['Date']['output'];
  searchQuery: Scalars['String']['output'];
  searchQueryType: SearchQueryType;
  userAccountId: Scalars['ID']['output'];
};

/** Input for saving a user search query */
export type UserSearchQueryInput = {
  /** Text of the user search query */
  searchQuery: Scalars['String']['input'];
  /** Type of search query */
  searchQueryType: SearchQueryType;
};

export type UserSearchQueryResponse = {
  __typename?: 'UserSearchQueryResponse';
  results: Array<UserSearchQuery>;
};

/** Information about a user's session */
export type UserSession = {
  __typename?: 'UserSession';
  /** The user's current app version */
  appVersion?: Maybe<Scalars['String']['output']>;
  /** The authentication mechanism, whether bearer or cookie */
  authType: AuthType;
  /** When the session was created */
  createdAt: Scalars['Date']['output'];
  /** Last time this token was active. This helps determine when to expire the token. */
  lastActiveAt: Scalars['Date']['output'];
  /** Optional refresh token for migrated FusionAuth users */
  refreshToken?: Maybe<Scalars['String']['output']>;
  /** Token to use for all authenticated requests */
  sessionToken?: Maybe<Scalars['String']['output']>;
  /**
   * The type of session
   * @deprecated No longer using sessionType for anything
   */
  sessionType?: Maybe<SessionType>;
  /** When the session was updated */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** URL this session is locked to */
  urlLock?: Maybe<Scalars['String']['output']>;
};

export type UserUpdateAssignmentInput = {
  /** Title of the member at the jobsite. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** ID of the jobsiteMember or contractorMember, based on 'userAssignmentType'. */
  userAssignmentId: Scalars['ID']['input'];
  /** Specifies if a user is assigned to a jobsite or a contractor */
  userAssignmentType: UserAssignmentType;
  /** The user role to assign the user to */
  userRoleKey?: InputMaybe<UserRoleKey>;
};

export type UserUpdateIdentityInput = {
  userAccountId: Scalars['ID']['input'];
  userIdentityInput: UserIdentityInput;
};

export type UserUsersConnection = {
  __typename?: 'UserUsersConnection';
  contractorUsersCount: Scalars['Int']['output'];
  developerUsersCount: Scalars['Int']['output'];
  edges: Array<UserUsersEdge>;
  jobsiteUsersCount: Scalars['Int']['output'];
};

export type UserUsersEdge = {
  __typename?: 'UserUsersEdge';
  node: User;
};

export type UserUsersInput = {
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  developerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<Array<InputMaybe<GetUsersOrderBy>>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Specifies if a user is assigned to a jobsite or a contractor */
  userAssignmentType: UserAssignmentType;
  userRoleKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserWorkerCardFormatsConnection = {
  __typename?: 'UserWorkerCardFormatsConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserWorkerCardFormatsEdge>;
};

export type UserWorkerCardFormatsEdge = {
  __typename?: 'UserWorkerCardFormatsEdge';
  node: WorkerCardFormat;
};

export type UserWorkerCardFormatsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserWorkerDocumentTypesConnection = {
  __typename?: 'UserWorkerDocumentTypesConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserWorkerDocumentTypesEdge>;
};

export type UserWorkerDocumentTypesEdge = {
  __typename?: 'UserWorkerDocumentTypesEdge';
  node: WorkerDocumentType;
};

export type UserWorkerDocumentTypesInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type UserWorkerProfileAccess = {
  __typename?: 'UserWorkerProfileAccess';
  id: Scalars['ID']['output'];
  isUnlocked: Scalars['Boolean']['output'];
  /** History of the object */
  objectHistory: ObjectHistory;
  unlockedWith: WorkerUnlockProfileType;
  /** The full user object of the user who unlocked the worker profile */
  user: User;
  /** The full worker object */
  worker: Worker;
};

export type UserWorkersConnection = {
  __typename?: 'UserWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<UserWorkersEdge>;
  filtersOptions?: Maybe<UserWorkersFilters>;
};

export type UserWorkersEdge = {
  __typename?: 'UserWorkersEdge';
  node: Worker;
};

export type UserWorkersFilters = {
  __typename?: 'UserWorkersFilters';
  jobTitles: Array<FilterOption>;
  trades: Array<FilterOption>;
};

export type UserWorkersInput = {
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  trades?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ValidModule =
  | JobsiteAppCheckInModule
  | JobsiteFeaturesModule
  | JobsiteOnboardingModule
  | JobsitePreOnboardingModule;

export type Vehicle = {
  __typename?: 'Vehicle';
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<File>;
  visitorLog: VisitorLog;
};

export type VehicleInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<FileChangeInput>;
};

export type Visitor = {
  __typename?: 'Visitor';
  /** This id points to jobsiteFormSubmissionWorker.id */
  id: Scalars['ID']['output'];
  jobsiteWorker: JobsiteWorker;
  visitorLog: VisitorLog;
};

export type VisitorLog = {
  __typename?: 'VisitorLog';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  jobsite: Jobsite;
  objectHistory: ObjectHistory;
  timeZone: Scalars['String']['output'];
  vehicle?: Maybe<Vehicle>;
  visitors?: Maybe<Array<Visitor>>;
};

export type VisitorLogPayload = {
  __typename?: 'VisitorLogPayload';
  tempBadgeAssignmentError?: Maybe<TempBadgeAssignmentError>;
  visitorLog: VisitorLog;
};

export type VisitorWorkerCreateInput = {
  /** Middle Initial of the worker */
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  /** Profile picture of the worker */
  photo?: InputMaybe<FileInput>;
  /** Primary language of the worker */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Suffix of the worker */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** Base info for the worker */
  workerBaseInfoInput?: InputMaybe<WorkerBaseInfoInput>;
};

export type WeatherConditions = {
  __typename?: 'WeatherConditions';
  description?: Maybe<Scalars['String']['output']>;
  humidity?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  temp?: Maybe<Scalars['Float']['output']>;
  tempHigh?: Maybe<Scalars['Float']['output']>;
  tempLow?: Maybe<Scalars['Float']['output']>;
  timestamp?: Maybe<Scalars['Date']['output']>;
  visibility?: Maybe<Scalars['Int']['output']>;
  windDirectionCardinal?: Maybe<Scalars['String']['output']>;
  windDirectionDegrees?: Maybe<Scalars['Float']['output']>;
  windSpeed?: Maybe<Scalars['Float']['output']>;
};

export type WebhookSetupResult = {
  __typename?: 'WebhookSetupResult';
  message?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type WebhookVerifyResult = {
  __typename?: 'WebhookVerifyResult';
  isActive?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type Worker = {
  __typename?: 'Worker';
  /** Worker access history across jobsites */
  accessHistory?: Maybe<Array<WorkerAccessHistory>>;
  /** City of the worker */
  addressCity?: Maybe<Scalars['String']['output']>;
  /** Address of the worker */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Address of the worker */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** State of the worker */
  addressState?: Maybe<StateAbbreviation>;
  /** Zip code of the worker */
  addressZipCode?: Maybe<Scalars['String']['output']>;
  assignedJobsiteFormSubmissions: JobsiteFormSubmissionsConnection;
  /** Birth date of the worker */
  birthDate?: Maybe<Scalars['Date']['output']>;
  /** Mobile check-in suggestions for the worker */
  checkInSuggestions?: Maybe<WorkerCheckInSuggestionsConnection>;
  citizenshipStatus?: Maybe<WorkerCitizenshipStatus>;
  connections: Array<Connection>;
  contractorWorkers: WorkerContractorWorkersConnection;
  createdMethod?: Maybe<WorkerCreatedMethod>;
  documents: WorkerDocumentsConnection;
  editableFields: EditableFields;
  /** Email of worker's emergency contact */
  emergencyContactEmail?: Maybe<Scalars['String']['output']>;
  /** Name of worker's emergency contact */
  emergencyContactName?: Maybe<Scalars['String']['output']>;
  /** Optional Note regarding worker's emergency contact */
  emergencyContactNote?: Maybe<Scalars['String']['output']>;
  /** Phone number of worker's emergency contact */
  emergencyContactPhone?: Maybe<Scalars['String']['output']>;
  /** Relation of emergency contact to worker */
  emergencyContactRelationship?: Maybe<Scalars['String']['output']>;
  formSubmissionJobsiteWorker?: Maybe<JobsiteWorker>;
  /** Gender of the worker */
  gender?: Maybe<Scalars['String']['output']>;
  /** Tells whether this worker has been archived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAssignedToMultipleJobsites?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the worker is a skilled worker */
  isSkilled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the worker is a veteran */
  isVeteran?: Maybe<Scalars['Boolean']['output']>;
  /** Jobsite access events for the worker */
  jobsiteAccessEvents?: Maybe<JobsiteAccessEventsConnection>;
  /** Jobsite access sessions for the worker */
  jobsiteAccessSessions?: Maybe<JobsiteAccessSessionsConnection>;
  jobsiteWorkers: WorkerJobsiteWorkersConnection;
  /** Middle Initial of the worker */
  middleInitial?: Maybe<Scalars['String']['output']>;
  /** History of the object */
  objectHistory: ObjectHistory;
  /** Primary language of the worker */
  primaryLanguage?: Maybe<Scalars['String']['output']>;
  profileAccess?: Maybe<UserWorkerProfileAccess>;
  /** Worker profile picture */
  profilePicture?: Maybe<File>;
  /** Worker cropped profile picture */
  profilePictureCropped?: Maybe<File>;
  quickCode?: Maybe<Scalars['String']['output']>;
  /** Race of the worker */
  race?: Maybe<Scalars['String']['output']>;
  selfOnboardingCurrentStep?: Maybe<Scalars['String']['output']>;
  /** SSN of the worker */
  ssn?: Maybe<Scalars['String']['output']>;
  /** Last four digits SSN of the worker */
  ssnLastFour?: Maybe<Scalars['String']['output']>;
  /** Suffix of the worker */
  suffix?: Maybe<Scalars['String']['output']>;
  /** Full user object of the worker */
  user: User;
  workAuthorizationStatus?: Maybe<WorkerWorkAuthorizationStatus>;
  workerCards: WorkerWorkerCardsConnection;
  /** Comments for worker */
  workerComments: WorkerWorkerCommentsConnection;
  /** Unique ID for the worker */
  workerId: Scalars['ID']['output'];
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerAssignedJobsiteFormSubmissionsArgs = {
  input?: InputMaybe<WorkerAssignedJobsiteFormSubmissionsInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerCheckInSuggestionsArgs = {
  input?: InputMaybe<WorkerCheckInSuggestionsInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerContractorWorkersArgs = {
  input?: InputMaybe<WorkerContractorWorkersInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerDocumentsArgs = {
  input?: InputMaybe<WorkerDocumentsInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerFormSubmissionJobsiteWorkerArgs = {
  input?: InputMaybe<FormSubmissionJobsiteWorkerInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerJobsiteAccessEventsArgs = {
  input?: InputMaybe<JobsiteAccessEventsInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerJobsiteAccessSessionsArgs = {
  input?: InputMaybe<JobsiteAccessSessionsInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerJobsiteWorkersArgs = {
  input?: InputMaybe<WorkerJobsiteWorkersInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerWorkerCardsArgs = {
  input?: InputMaybe<WorkerWorkerCardsInput>;
};

/**
 * Worker return type. A worker represents a Construction Manager company, as opposed to an
 * individual working either for or at the worker.
 */
export type WorkerWorkerCommentsArgs = {
  input?: InputMaybe<WorkerWorkerCommentsInput>;
};

export type WorkerAccessHistory = {
  __typename?: 'WorkerAccessHistory';
  banEndDate?: Maybe<Scalars['Date']['output']>;
  changeApprovedBy: Scalars['String']['output'];
  changeCategory?: Maybe<Scalars['String']['output']>;
  changeDate: Scalars['Date']['output'];
  changeReason: Scalars['String']['output'];
  changeToAccess: Scalars['String']['output'];
  jobsiteName: Scalars['String']['output'];
  updatedByName: Scalars['String']['output'];
  workerAccessHistoryId: Scalars['ID']['output'];
};

export type WorkerAccessRestoreGroup = {
  __typename?: 'WorkerAccessRestoreGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WorkerAccessRestorePreview = {
  __typename?: 'WorkerAccessRestorePreview';
  groups: Array<WorkerAccessRestoreGroup>;
  status: WorkerAccessRestorePreviewStatus;
  totalCount: Scalars['Int']['output'];
};

export enum WorkerAccessRestorePreviewStatus {
  NotApplicable = 'NOT_APPLICABLE',
  NoSnapshot = 'NO_SNAPSHOT',
  Preparing = 'PREPARING',
  Ready = 'READY',
}

export type WorkerAccount = {
  __typename?: 'WorkerAccount';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fusionAuthId?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  userAccountId: Scalars['String']['output'];
  userIdentityId: Scalars['String']['output'];
  workerId: Scalars['ID']['output'];
};

export type WorkerAssignedJobsiteFormSubmissionsInput = {
  filter?: InputMaybe<WorkerAssignedSubmissionsFilter>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export enum WorkerAssignedSubmissionsFilter {
  Active = 'active',
  All = 'all',
  Complete = 'complete',
}

export type WorkerAuth = {
  __typename?: 'WorkerAuth';
  session: UserSession;
  worker: Worker;
};

export type WorkerBaseInfoInput = {
  /** Birth date for worker */
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  /** last four of SSN for worker */
  ssnLastFour?: InputMaybe<Scalars['String']['input']>;
};

export type WorkerCCureData = {
  __typename?: 'WorkerCCureData';
  data?: Maybe<Scalars['JSONObject']['output']>;
};

export type WorkerCard = {
  __typename?: 'WorkerCard';
  cardIssueReason?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardStatus?: Maybe<CardStatus>;
  connections: Array<Connection>;
  deactivatedAt?: Maybe<Scalars['Date']['output']>;
  deactivatedReason?: Maybe<Scalars['String']['output']>;
  expiredAt?: Maybe<Scalars['Date']['output']>;
  isReplacement?: Maybe<Scalars['Boolean']['output']>;
  isTemporary?: Maybe<Scalars['Boolean']['output']>;
  issuedAt?: Maybe<Scalars['Date']['output']>;
  lastPrintJob?: Maybe<CardPrintJob>;
  matchingWorkerCardId?: Maybe<Scalars['ID']['output']>;
  tempBadge?: Maybe<TempBadge>;
  temporaryAssignReason?: Maybe<Scalars['String']['output']>;
  /** @deprecated type is now on workerCardFormat */
  type?: Maybe<WorkerCardType>;
  worker: Worker;
  workerCardFormat: WorkerCardFormat;
  workerCardId?: Maybe<Scalars['ID']['output']>;
  workerCardStatus?: Maybe<WorkerCardStatus>;
};

export type WorkerCardFormat = {
  __typename?: 'WorkerCardFormat';
  cardType: WorkerCardType;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * How the format encodes its card numbers, e.g. wiegand-48-bit for
   * Corporate 1000. The encoding fixes the largest card number the format can
   * carry.
   */
  encoding?: Maybe<Scalars['String']['output']>;
  facilityCode?: Maybe<Scalars['Int']['output']>;
  isHexEncoded?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  validationMessage?: Maybe<Scalars['String']['output']>;
  validationRegex?: Maybe<Scalars['String']['output']>;
  workerCardFormatId?: Maybe<Scalars['ID']['output']>;
};

export type WorkerCardFormatInput = {
  cardType: WorkerCardType;
  description?: InputMaybe<Scalars['String']['input']>;
  facilityCode?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  validationMessage?: InputMaybe<Scalars['String']['input']>;
  validationRegex?: InputMaybe<Scalars['String']['input']>;
};

export type WorkerCardInput = {
  cardIssueReason?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  deactivatedReason?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  isTemporary?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tempBadgeId?: InputMaybe<Scalars['ID']['input']>;
  temporaryAssignReason?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated type is now on workerCardFormat */
  type?: InputMaybe<WorkerCardType>;
  workerCardFormatId?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkerCardPayload = {
  __typename?: 'WorkerCardPayload';
  workerCard: WorkerCard;
};

export enum WorkerCardStatus {
  Created = 'created',
  Deactivated = 'deactivated',
  PrintFailed = 'printFailed',
  Printed = 'printed',
  Printing = 'printing',
}

export enum WorkerCardType {
  Bluetooth = 'Bluetooth',
  FacialRecognition = 'FacialRecognition',
  MobileBadge = 'MobileBadge',
  Pvc = 'PVC',
  Proximity = 'Proximity',
  QrCode = 'QrCode',
}

export enum WorkerCheckInDataType {
  QrCode = 'QRCode',
  TempBadgeId = 'TempBadgeId',
  WorkerId = 'WorkerId',
}

export type WorkerCheckInError = {
  __typename?: 'WorkerCheckInError';
  code: Scalars['String']['output'];
  contractor?: Maybe<Contractor>;
  currentAccess?: Maybe<JobsiteWorkerCurrentAccess>;
  message?: Maybe<Scalars['String']['output']>;
  worker?: Maybe<Worker>;
};

export type WorkerCheckInInfo = {
  __typename?: 'WorkerCheckInInfo';
  contractor?: Maybe<Contractor>;
  currentAccess?: Maybe<JobsiteWorkerCurrentAccess>;
  jobsite?: Maybe<Jobsite>;
  jobsiteWorker?: Maybe<JobsiteWorker>;
  key: Scalars['String']['output'];
  rejectionReason?: Maybe<JobsiteAccessEventRejectionReason>;
  worker?: Maybe<Worker>;
};

/** Input for getting a worker checking in info based on scanned code */
export type WorkerCheckInInfoInput = {
  areaId: Scalars['ID']['input'];
  direction?: InputMaybe<JobsiteWorkerCheckInDirection>;
  jobsiteId: Scalars['ID']['input'];
  key: Scalars['String']['input'];
  location?: InputMaybe<GpsCoordinateInput>;
  source?: InputMaybe<JobsiteWorkerCheckInSource>;
  workerData: Scalars['String']['input'];
  workerDataType: WorkerCheckInDataType;
};

export type WorkerCheckInInput = {
  checkedInAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  /**
   * ID of the jobsiteWorkerCheckIn that marks the beginning of the session block.
   * This applies only during the creation of outbound check-ins.
   */
  sessionStartCheckInId?: InputMaybe<Scalars['ID']['input']>;
  workerData: Scalars['String']['input'];
  workerDataType: WorkerCheckInDataType;
};

export type WorkerCheckInResult = {
  __typename?: 'WorkerCheckInResult';
  checkIn?: Maybe<JobsiteWorkerCheckIn>;
  error?: Maybe<WorkerCheckInError>;
  key: Scalars['String']['output'];
};

export type WorkerCheckInSuggestionsConnection = {
  __typename?: 'WorkerCheckInSuggestionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkerCheckInSuggestionsEdge>;
};

export type WorkerCheckInSuggestionsEdge = {
  __typename?: 'WorkerCheckInSuggestionsEdge';
  node: JobsiteWorkerCheckInSuggestion;
};

export type WorkerCheckInSuggestionsInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export enum WorkerCitizenshipStatus {
  Citizen = 'Citizen',
  NonCitizen = 'NonCitizen',
}

export type WorkerComment = {
  __typename?: 'WorkerComment';
  comment: Scalars['String']['output'];
  jobsite?: Maybe<Jobsite>;
  objectHistory?: Maybe<ObjectHistory>;
  worker?: Maybe<Worker>;
  workerCommentId: Scalars['ID']['output'];
};

export type WorkerCommentConnection = {
  __typename?: 'WorkerCommentConnection';
  edges: Array<Maybe<WorkerComment>>;
  totalCount: Scalars['Int']['output'];
};

export type WorkerCommentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  jobsiteId?: InputMaybe<Scalars['ID']['input']>;
  workerId: Scalars['ID']['input'];
};

export type WorkerContractorWorkersConnection = {
  __typename?: 'WorkerContractorWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkerContractorWorkersEdge>;
};

export type WorkerContractorWorkersEdge = {
  __typename?: 'WorkerContractorWorkersEdge';
  node: ContractorWorker;
};

export type WorkerContractorWorkersInput = {
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export enum WorkerCreatedMethod {
  ContractorApi = 'ContractorApi',
  Import = 'Import',
  MobileApp = 'MobileApp',
  SelfOnboarding = 'SelfOnboarding',
  VisitorLog = 'VisitorLog',
  WebApp = 'WebApp',
}

export type WorkerDocumentAdditionalField = {
  __typename?: 'WorkerDocumentAdditionalField';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum WorkerDocumentLevel {
  Jobsite = 'Jobsite',
  Organization = 'Organization',
  Worker = 'Worker',
}

export type WorkerDocumentType = {
  __typename?: 'WorkerDocumentType';
  documentLevel?: Maybe<WorkerDocumentLevel>;
  expirationDate?: Maybe<Scalars['Date']['output']>;
  isGlobal: Scalars['Boolean']['output'];
  isPhi: Scalars['Boolean']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  workerDocumentTypeId: Scalars['ID']['output'];
};

export type WorkerDocumentsConnection = {
  __typename?: 'WorkerDocumentsConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkerDocumentsEdge>;
};

export type WorkerDocumentsEdge = {
  __typename?: 'WorkerDocumentsEdge';
  node: JobsiteWorkerDocument;
};

export type WorkerDocumentsInput = {
  includePhi?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type WorkerErrorInfo = {
  __typename?: 'WorkerErrorInfo';
  birthDate?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  jobsiteWorkerInfo: Array<JobsiteWorkerInfo>;
  lastName: Scalars['String']['output'];
  middleInitial?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<File>;
  profilePictureCropped?: Maybe<File>;
  quickCode?: Maybe<Scalars['String']['output']>;
  selfOnboardingInfo?: Maybe<SelfOnboardingWorkerInfo>;
  ssnLastFour?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  workerId: Scalars['ID']['output'];
};

export enum WorkerFileField {
  ProfilePicture = 'profilePicture',
  ProfilePictureCropped = 'profilePictureCropped',
}

/** Input for Worker Mutations */
export type WorkerInput = {
  /** City of the worker */
  addressCity?: InputMaybe<Scalars['String']['input']>;
  /** Address of the worker */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  /** Address of the worker */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** State of the worker */
  addressState?: InputMaybe<StateAbbreviation>;
  /** Zip code of the worker */
  addressZipCode?: InputMaybe<Scalars['String']['input']>;
  citizenshipStatus?: InputMaybe<WorkerCitizenshipStatus>;
  /** Email of worker's emergency contact */
  emergencyContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Name of worker's emergency contact */
  emergencyContactName?: InputMaybe<Scalars['String']['input']>;
  /** Optional Note regarding worker's emergency contact */
  emergencyContactNote?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of worker's emergency contact */
  emergencyContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Relation of emergency contact to worker */
  emergencyContactRelationship?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the worker */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Whether the worker is a skilled worker */
  isSkilled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the worker is a supervisor */
  isSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the worker is a veteran */
  isVeteran?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteInvitationId?: InputMaybe<Scalars['ID']['input']>;
  /** Middle Initial of the worker */
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  /** Job title of the worker */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  /** ID of the uploaded profile picture */
  profilePictureFileId?: InputMaybe<Scalars['ID']['input']>;
  quickCode?: InputMaybe<Scalars['String']['input']>;
  /** Race of the worker */
  race?: InputMaybe<Scalars['String']['input']>;
  selfOnboardingCurrentStep?: InputMaybe<Scalars['String']['input']>;
  /** SSN of the worker */
  ssn?: InputMaybe<Scalars['String']['input']>;
  /** Suffix of the worker */
  suffix?: InputMaybe<Scalars['String']['input']>;
  workAuthorizationStatus?: InputMaybe<WorkerWorkAuthorizationStatus>;
  /** Base info for the worker */
  workerBaseInfoInput?: InputMaybe<WorkerBaseInfoInput>;
};

export type WorkerJobsiteBan = {
  __typename?: 'WorkerJobsiteBan';
  /** When the worker is allowed back to the site */
  accessReadmissionDate?: Maybe<Scalars['Date']['output']>;
  /** When the worker's access was disabled */
  disabledAccessDate?: Maybe<Scalars['Date']['output']>;
  /** Indicates whether the worker has access temporarily disabled. */
  isDisabledAccess?: Maybe<Scalars['Boolean']['output']>;
  jobsite: Jobsite;
};

export type WorkerJobsiteWorkersConnection = {
  __typename?: 'WorkerJobsiteWorkersConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkerJobsiteWorkersEdge>;
};

export type WorkerJobsiteWorkersEdge = {
  __typename?: 'WorkerJobsiteWorkersEdge';
  node: JobsiteWorker;
};

export type WorkerJobsiteWorkersInput = {
  contractorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export enum WorkerResponseFilter {
  No = 'no',
  Pending = 'pending',
  Yes = 'yes',
}

export type WorkerSearchResponse = {
  __typename?: 'WorkerSearchResponse';
  count: Scalars['Int']['output'];
  results: Array<WorkerSearchResult>;
};

export type WorkerSearchResult = {
  __typename?: 'WorkerSearchResult';
  worker: Worker;
};

export type WorkerUnlockProfileInput = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssnLastFour?: InputMaybe<Scalars['String']['input']>;
  unlockType: WorkerUnlockProfileType;
  workerId: Scalars['ID']['input'];
};

export type WorkerUnlockProfilePayload = {
  __typename?: 'WorkerUnlockProfilePayload';
  userWorkerProfileAccess: UserWorkerProfileAccess;
};

export enum WorkerUnlockProfileType {
  BirthDate = 'birthDate',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  SsnLastFour = 'ssnLastFour',
}

export enum WorkerWorkAuthorizationStatus {
  AuthorizedToWorkInTheUs = 'AuthorizedToWorkInTheUs',
  NotAuthorizedToWorkInTheUs = 'NotAuthorizedToWorkInTheUs',
}

export type WorkerWorkerCardsConnection = {
  __typename?: 'WorkerWorkerCardsConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkerWorkerCardsEdge>;
};

export type WorkerWorkerCardsEdge = {
  __typename?: 'WorkerWorkerCardsEdge';
  node: WorkerCard;
};

export type WorkerWorkerCardsInput = {
  cardType?: InputMaybe<WorkerCardType>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
  syncPrintJob?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WorkerWorkerCommentsConnection = {
  __typename?: 'WorkerWorkerCommentsConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkerWorkerCommentsEdge>;
};

export type WorkerWorkerCommentsEdge = {
  __typename?: 'WorkerWorkerCommentsEdge';
  node: WorkerComment;
};

export type WorkerWorkerCommentsInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  paginationInput?: InputMaybe<LimitOffsetPaginationInput>;
};

export type WorkersCheckInConnection = {
  __typename?: 'WorkersCheckInConnection';
  count: Scalars['Int']['output'];
  edges: Array<WorkersCheckInEdge>;
};

export type WorkersCheckInEdge = {
  __typename?: 'WorkersCheckInEdge';
  node: WorkerCheckInResult;
};

/** Input for checking in multiple workers based on scanned codes */
export type WorkersCheckInInput = {
  areaId: Scalars['ID']['input'];
  checkInType?: InputMaybe<JobsiteWorkerCheckInType>;
  checkIns: Array<WorkerCheckInInput>;
  direction: JobsiteWorkerCheckInDirection;
  jobsiteGatewayId?: InputMaybe<Scalars['ID']['input']>;
  jobsiteId: Scalars['ID']['input'];
  location?: InputMaybe<GpsCoordinateInput>;
  source?: InputMaybe<JobsiteWorkerCheckInSource>;
};

export type Zone = {
  __typename?: 'Zone';
  /**
   * The zone's connection to its Avigilon zone; null while it has none;
   * layout delivery creates or binds it. An error when the zone has more
   * than one Avigilon zone connection; layout delivery refuses the site's
   * layout the same way.
   */
  connection?: Maybe<Connection>;
  connections: Array<Connection>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum ZonesMode {
  Enforce = 'ENFORCE',
  Off = 'OFF',
  Shadow = 'SHADOW',
}

export type ZonesModeChange = {
  __typename?: 'ZonesModeChange';
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  fromMode: ZonesMode;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  parityResult?: Maybe<ZonesParityResult>;
  startedAt: Scalars['DateTime']['output'];
  startedBy: User;
  status: ZonesModeChangeStatus;
  step?: Maybe<ZonesModeChangeStep>;
  toMode: ZonesMode;
  workersEnrolled?: Maybe<Scalars['Int']['output']>;
  workersTotal?: Maybe<Scalars['Int']['output']>;
};

export enum ZonesModeChangeStatus {
  Failed = 'FAILED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
}

export enum ZonesModeChangeStep {
  AdoptAndPush = 'ADOPT_AND_PUSH',
  DefaultGroup = 'DEFAULT_GROUP',
  Enrolling = 'ENROLLING',
  Parity = 'PARITY',
  Readiness = 'READINESS',
}

export enum ZonesParityCheck {
  Avigilon = 'AVIGILON',
  Odin = 'ODIN',
}

export type ZonesParityDifference = {
  __typename?: 'ZonesParityDifference';
  check: ZonesParityCheck;
  identity: ZonesParityIdentity;
};

export type ZonesParityExternalUser = {
  __typename?: 'ZonesParityExternalUser';
  externalUserId: Scalars['ID']['output'];
};

export type ZonesParityIdentity = ZonesParityExternalUser | ZonesParityWorker;

export type ZonesParityResult = {
  __typename?: 'ZonesParityResult';
  blockers: Array<Scalars['String']['output']>;
  gained: Array<ZonesParityDifference>;
  lost: Array<ZonesParityDifference>;
  revokedDefaults: Array<ZonesParityWorker>;
};

export type ZonesParityWorker = {
  __typename?: 'ZonesParityWorker';
  /** Null when the recorded worker no longer exists or the viewer may not read it. */
  worker?: Maybe<Worker>;
  workerId: Scalars['ID']['output'];
};

export type ZonesReadiness = {
  __typename?: 'ZonesReadiness';
  items: Array<ZonesReadinessItem>;
  ready: Scalars['Boolean']['output'];
};

export enum ZonesReadinessCode {
  AccessGroupSync = 'ACCESS_GROUP_SYNC',
  Connector = 'CONNECTOR',
  DefaultGroup = 'DEFAULT_GROUP',
  LinkedReader = 'LINKED_READER',
  PublishedZone = 'PUBLISHED_ZONE',
}

export type ZonesReadinessItem = {
  __typename?: 'ZonesReadinessItem';
  code: ZonesReadinessCode;
  message: Scalars['String']['output'];
  ready: Scalars['Boolean']['output'];
};

export type AccessGroupActorFragment = { __typename?: 'User' } & Pick<
  User,
  'userAccountId'
> & {
    identity?: Maybe<
      { __typename?: 'UserIdentity' } & Pick<
        UserIdentity,
        'firstName' | 'lastName'
      >
    >;
  };

export type AccessGroupSummaryFragment = { __typename?: 'AccessGroup' } & Pick<
  AccessGroup,
  'id' | 'siteId' | 'name' | 'isDefault' | 'archivedAt' | 'memberCount'
> & {
    zones: Array<
      { __typename?: 'AccessGroupZoneGrant' } & Pick<
        AccessGroupZoneGrant,
        'id' | 'name' | 'state' | 'grantedAt'
      > & {
          zone: { __typename?: 'Zone' } & Pick<Zone, 'id'>;
          grantedBy: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            };
        }
    >;
    avigilon: { __typename?: 'AccessGroupAvigilonSync' } & Pick<
      AccessGroupAvigilonSync,
      'name' | 'origin' | 'state' | 'syncedAt' | 'error'
    >;
  };

export type GetSiteAccessGroupsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
}>;

export type GetSiteAccessGroupsQuery = { __typename?: 'Query' } & {
  siteConfigurationZones: Array<
    { __typename?: 'ConfigurationZone' } & Pick<
      ConfigurationZone,
      'id' | 'name' | 'state'
    >
  >;
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'timeZone' | 'zonesMode'
  > & {
      accessGroups: Array<
        { __typename?: 'AccessGroup' } & Pick<
          AccessGroup,
          'id' | 'siteId' | 'name' | 'isDefault' | 'archivedAt' | 'memberCount'
        > & {
            zones: Array<
              { __typename?: 'AccessGroupZoneGrant' } & Pick<
                AccessGroupZoneGrant,
                'id' | 'name' | 'state' | 'grantedAt'
              > & {
                  zone: { __typename?: 'Zone' } & Pick<Zone, 'id'>;
                  grantedBy: { __typename?: 'User' } & Pick<
                    User,
                    'userAccountId'
                  > & {
                      identity?: Maybe<
                        { __typename?: 'UserIdentity' } & Pick<
                          UserIdentity,
                          'firstName' | 'lastName'
                        >
                      >;
                    };
                }
            >;
            avigilon: { __typename?: 'AccessGroupAvigilonSync' } & Pick<
              AccessGroupAvigilonSync,
              'name' | 'origin' | 'state' | 'syncedAt' | 'error'
            >;
          }
      >;
    };
};

export type GetAccessGroupDetailsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;

export type GetAccessGroupDetailsQuery = { __typename?: 'Query' } & {
  accessGroup?: Maybe<
    { __typename?: 'AccessGroup' } & Pick<
      AccessGroup,
      'id' | 'siteId' | 'name' | 'isDefault' | 'archivedAt' | 'memberCount'
    > & {
        archivedBy?: Maybe<
          { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
        >;
        history: Array<
          { __typename?: 'AccessGroupHistoryEntry' } & Pick<
            AccessGroupHistoryEntry,
            'id' | 'type' | 'occurredAt' | 'payload'
          > & {
              actor: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                  identity?: Maybe<
                    { __typename?: 'UserIdentity' } & Pick<
                      UserIdentity,
                      'firstName' | 'lastName'
                    >
                  >;
                };
            }
        >;
        zones: Array<
          { __typename?: 'AccessGroupZoneGrant' } & Pick<
            AccessGroupZoneGrant,
            'id' | 'name' | 'state' | 'grantedAt'
          > & {
              zone: { __typename?: 'Zone' } & Pick<Zone, 'id'>;
              grantedBy: { __typename?: 'User' } & Pick<
                User,
                'userAccountId'
              > & {
                  identity?: Maybe<
                    { __typename?: 'UserIdentity' } & Pick<
                      UserIdentity,
                      'firstName' | 'lastName'
                    >
                  >;
                };
            }
        >;
        avigilon: { __typename?: 'AccessGroupAvigilonSync' } & Pick<
          AccessGroupAvigilonSync,
          'name' | 'origin' | 'state' | 'syncedAt' | 'error'
        >;
      }
  >;
};

export type GetWorkerAccessGroupsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
}>;

export type GetWorkerAccessGroupsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'timeZone' | 'zonesMode'
  > & {
      accessGroups: Array<
        { __typename?: 'AccessGroup' } & Pick<
          AccessGroup,
          'id' | 'siteId' | 'name' | 'isDefault' | 'archivedAt' | 'memberCount'
        > & {
            zones: Array<
              { __typename?: 'AccessGroupZoneGrant' } & Pick<
                AccessGroupZoneGrant,
                'id' | 'name' | 'state' | 'grantedAt'
              > & {
                  zone: { __typename?: 'Zone' } & Pick<Zone, 'id'>;
                  grantedBy: { __typename?: 'User' } & Pick<
                    User,
                    'userAccountId'
                  > & {
                      identity?: Maybe<
                        { __typename?: 'UserIdentity' } & Pick<
                          UserIdentity,
                          'firstName' | 'lastName'
                        >
                      >;
                    };
                }
            >;
            avigilon: { __typename?: 'AccessGroupAvigilonSync' } & Pick<
              AccessGroupAvigilonSync,
              'name' | 'origin' | 'state' | 'syncedAt' | 'error'
            >;
          }
      >;
    };
  workerAccessGroupMemberships: Array<
    { __typename?: 'AccessGroupMembership' } & Pick<
      AccessGroupMembership,
      'id' | 'grantedAt' | 'grantSource' | 'revokedAt' | 'revokeSource'
    > & {
        group: { __typename?: 'AccessGroup' } & Pick<
          AccessGroup,
          'id' | 'siteId' | 'name' | 'isDefault' | 'archivedAt' | 'memberCount'
        > & {
            zones: Array<
              { __typename?: 'AccessGroupZoneGrant' } & Pick<
                AccessGroupZoneGrant,
                'id' | 'name' | 'state' | 'grantedAt'
              > & {
                  zone: { __typename?: 'Zone' } & Pick<Zone, 'id'>;
                  grantedBy: { __typename?: 'User' } & Pick<
                    User,
                    'userAccountId'
                  > & {
                      identity?: Maybe<
                        { __typename?: 'UserIdentity' } & Pick<
                          UserIdentity,
                          'firstName' | 'lastName'
                        >
                      >;
                    };
                }
            >;
            avigilon: { __typename?: 'AccessGroupAvigilonSync' } & Pick<
              AccessGroupAvigilonSync,
              'name' | 'origin' | 'state' | 'syncedAt' | 'error'
            >;
          };
        grantedBy: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
            identity?: Maybe<
              { __typename?: 'UserIdentity' } & Pick<
                UserIdentity,
                'firstName' | 'lastName'
              >
            >;
          };
        revokedBy?: Maybe<
          { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
        >;
      }
  >;
};

export type GetSiteZonesModeQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetSiteZonesModeQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'timeZone' | 'zonesMode'
  > & {
      zonesReadiness: { __typename?: 'ZonesReadiness' } & Pick<
        ZonesReadiness,
        'ready'
      > & {
          items: Array<
            { __typename?: 'ZonesReadinessItem' } & Pick<
              ZonesReadinessItem,
              'code' | 'ready' | 'message'
            >
          >;
        };
      latestZonesModeChange?: Maybe<
        { __typename?: 'ZonesModeChange' } & Pick<
          ZonesModeChange,
          | 'id'
          | 'fromMode'
          | 'toMode'
          | 'status'
          | 'step'
          | 'workersEnrolled'
          | 'workersTotal'
          | 'message'
          | 'startedAt'
          | 'finishedAt'
        > & {
            startedBy: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName'
                  >
                >;
              };
            parityResult?: Maybe<
              { __typename?: 'ZonesParityResult' } & Pick<
                ZonesParityResult,
                'blockers'
              > & {
                  gained: Array<
                    { __typename?: 'ZonesParityDifference' } & Pick<
                      ZonesParityDifference,
                      'check'
                    > & {
                        identity:
                          | ({ __typename: 'ZonesParityExternalUser' } & Pick<
                              ZonesParityExternalUser,
                              'externalUserId'
                            >)
                          | ({ __typename: 'ZonesParityWorker' } & Pick<
                              ZonesParityWorker,
                              'workerId'
                            > & {
                                worker?: Maybe<
                                  { __typename?: 'Worker' } & Pick<
                                    Worker,
                                    'workerId'
                                  > & {
                                      user: { __typename?: 'User' } & Pick<
                                        User,
                                        'userAccountId'
                                      > & {
                                          identity?: Maybe<
                                            {
                                              __typename?: 'UserIdentity';
                                            } & Pick<
                                              UserIdentity,
                                              'firstName' | 'lastName'
                                            >
                                          >;
                                        };
                                    }
                                >;
                              });
                      }
                  >;
                  lost: Array<
                    { __typename?: 'ZonesParityDifference' } & Pick<
                      ZonesParityDifference,
                      'check'
                    > & {
                        identity:
                          | ({ __typename: 'ZonesParityExternalUser' } & Pick<
                              ZonesParityExternalUser,
                              'externalUserId'
                            >)
                          | ({ __typename: 'ZonesParityWorker' } & Pick<
                              ZonesParityWorker,
                              'workerId'
                            > & {
                                worker?: Maybe<
                                  { __typename?: 'Worker' } & Pick<
                                    Worker,
                                    'workerId'
                                  > & {
                                      user: { __typename?: 'User' } & Pick<
                                        User,
                                        'userAccountId'
                                      > & {
                                          identity?: Maybe<
                                            {
                                              __typename?: 'UserIdentity';
                                            } & Pick<
                                              UserIdentity,
                                              'firstName' | 'lastName'
                                            >
                                          >;
                                        };
                                    }
                                >;
                              });
                      }
                  >;
                  revokedDefaults: Array<
                    { __typename?: 'ZonesParityWorker' } & Pick<
                      ZonesParityWorker,
                      'workerId'
                    > & {
                        worker?: Maybe<
                          { __typename?: 'Worker' } & Pick<
                            Worker,
                            'workerId'
                          > & {
                              user: { __typename?: 'User' } & Pick<
                                User,
                                'userAccountId'
                              > & {
                                  identity?: Maybe<
                                    { __typename?: 'UserIdentity' } & Pick<
                                      UserIdentity,
                                      'firstName' | 'lastName'
                                    >
                                  >;
                                };
                            }
                        >;
                      }
                  >;
                }
            >;
          }
      >;
    };
};

export type ZonesParityDifferenceFragment = {
  __typename?: 'ZonesParityDifference';
} & Pick<ZonesParityDifference, 'check'> & {
    identity:
      | ({ __typename: 'ZonesParityExternalUser' } & Pick<
          ZonesParityExternalUser,
          'externalUserId'
        >)
      | ({ __typename: 'ZonesParityWorker' } & Pick<
          ZonesParityWorker,
          'workerId'
        > & {
            worker?: Maybe<
              { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                  user: { __typename?: 'User' } & Pick<
                    User,
                    'userAccountId'
                  > & {
                      identity?: Maybe<
                        { __typename?: 'UserIdentity' } & Pick<
                          UserIdentity,
                          'firstName' | 'lastName'
                        >
                      >;
                    };
                }
            >;
          });
  };

export type ZonesParityWorkerFragment = {
  __typename?: 'ZonesParityWorker';
} & Pick<ZonesParityWorker, 'workerId'> & {
    worker?: Maybe<
      { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
          user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            };
        }
    >;
  };

export type ChangeZonesModeMutationVariables = Exact<{
  input: ChangeZonesModeInput;
}>;

export type ChangeZonesModeMutation = { __typename?: 'Mutation' } & {
  changeZonesMode: { __typename?: 'ChangeZonesModePayload' } & Pick<
    ChangeZonesModePayload,
    'id'
  >;
};

export type CreateAccessGroupMutationVariables = Exact<{
  input: CreateAccessGroupInput;
}>;

export type CreateAccessGroupMutation = { __typename?: 'Mutation' } & {
  createAccessGroup: { __typename?: 'AccessGroup' } & Pick<AccessGroup, 'id'>;
};

export type RenameAccessGroupMutationVariables = Exact<{
  input: RenameAccessGroupInput;
}>;

export type RenameAccessGroupMutation = { __typename?: 'Mutation' } & {
  renameAccessGroup: { __typename?: 'AccessGroup' } & Pick<AccessGroup, 'id'>;
};

export type SetDefaultAccessGroupMutationVariables = Exact<{
  input: AccessGroupInput;
}>;

export type SetDefaultAccessGroupMutation = { __typename?: 'Mutation' } & {
  setDefaultAccessGroup: { __typename?: 'AccessGroup' } & Pick<
    AccessGroup,
    'id'
  >;
};

export type ArchiveAccessGroupMutationVariables = Exact<{
  input: AccessGroupInput;
}>;

export type ArchiveAccessGroupMutation = { __typename?: 'Mutation' } & {
  archiveAccessGroup: { __typename?: 'AccessGroup' } & Pick<AccessGroup, 'id'>;
};

export type AddZoneToAccessGroupMutationVariables = Exact<{
  input: AccessGroupZoneInput;
}>;

export type AddZoneToAccessGroupMutation = { __typename?: 'Mutation' } & {
  addZoneToAccessGroup: { __typename?: 'AccessGroup' } & Pick<
    AccessGroup,
    'id'
  >;
};

export type RemoveZoneFromAccessGroupMutationVariables = Exact<{
  input: AccessGroupZoneInput;
}>;

export type RemoveZoneFromAccessGroupMutation = { __typename?: 'Mutation' } & {
  removeZoneFromAccessGroup: { __typename?: 'AccessGroup' } & Pick<
    AccessGroup,
    'id'
  >;
};

export type GrantAccessGroupMembershipMutationVariables = Exact<{
  input: AccessGroupMembershipInput;
}>;

export type GrantAccessGroupMembershipMutation = { __typename?: 'Mutation' } & {
  grantAccessGroupMembership: { __typename?: 'AccessGroup' } & Pick<
    AccessGroup,
    'id'
  >;
};

export type RevokeAccessGroupMembershipMutationVariables = Exact<{
  input: RevokeAccessGroupMembershipInput;
}>;

export type RevokeAccessGroupMembershipMutation = {
  __typename?: 'Mutation';
} & {
  revokeAccessGroupMembership: { __typename?: 'AccessGroup' } & Pick<
    AccessGroup,
    'id'
  >;
};

export type GetWorkerAccessGroupSitesQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type GetWorkerAccessGroupSitesQuery = { __typename?: 'Query' } & {
  workerAccessGroupSites: Array<
    { __typename?: 'AccessGroupMembershipSite' } & Pick<
      AccessGroupMembershipSite,
      'siteId' | 'name'
    >
  >;
};

export type RetryAccessGroupPushMutationVariables = Exact<{
  input: AccessGroupInput;
}>;

export type RetryAccessGroupPushMutation = { __typename?: 'Mutation' } & {
  retryAccessGroupPush: { __typename?: 'AccessGroup' } & Pick<
    AccessGroup,
    'id'
  >;
};

export type GetAccessGroupMembersQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetAccessGroupMembersQuery = { __typename?: 'Query' } & {
  accessGroup?: Maybe<
    { __typename?: 'AccessGroup' } & Pick<AccessGroup, 'id'> & {
        members: Array<
          { __typename?: 'AccessGroupMembership' } & Pick<
            AccessGroupMembership,
            'id' | 'cursor' | 'grantedAt' | 'grantSource'
          > & {
              worker?: Maybe<
                { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                    user: { __typename?: 'User' } & Pick<
                      User,
                      'userAccountId'
                    > & {
                        identity?: Maybe<
                          { __typename?: 'UserIdentity' } & Pick<
                            UserIdentity,
                            'firstName' | 'lastName'
                          >
                        >;
                      };
                  }
              >;
              grantedBy: { __typename?: 'User' } & Pick<
                User,
                'userAccountId'
              > & {
                  identity?: Maybe<
                    { __typename?: 'UserIdentity' } & Pick<
                      UserIdentity,
                      'firstName' | 'lastName'
                    >
                  >;
                };
            }
        >;
      }
  >;
};

export type DisconnectProcoreMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DisconnectProcoreMutation = { __typename?: 'Mutation' } & {
  disconnectProcore: { __typename?: 'Success' } & Pick<Success, 'success'>;
};

export type ProcoreOAuthExchangeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;

export type ProcoreOAuthExchangeMutation = { __typename?: 'Mutation' } & {
  procoreOAuthExchange: { __typename?: 'ProcoreOAuthExchangeResponse' } & Pick<
    ProcoreOAuthExchangeResponse,
    'connected' | 'procoreUserId'
  >;
};

export type ProcoreOAuthStartMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ProcoreOAuthStartMutation = { __typename?: 'Mutation' } & {
  procoreOAuthStart: { __typename?: 'ProcoreOAuthStartResponse' } & Pick<
    ProcoreOAuthStartResponse,
    'authorizeUrl'
  >;
};

export type RecordPolicyConsentMutationVariables = Exact<{
  input: RecordPolicyConsentInput;
}>;

export type RecordPolicyConsentMutation = { __typename?: 'Mutation' } & {
  recordPolicyConsent: { __typename?: 'Success' } & Pick<Success, 'success'>;
};

export type TrackIntegrationHandoffMutationVariables = Exact<{
  integrationType: ExternalIntegrationType;
}>;

export type TrackIntegrationHandoffMutation = { __typename?: 'Mutation' } & {
  trackIntegrationHandoff: { __typename?: 'IntegrationDetails' } & Pick<
    IntegrationDetails,
    'integrationType' | 'url'
  >;
};

export type TrackSessionMutationVariables = Exact<{
  sessionType: SessionType;
}>;

export type TrackSessionMutation = { __typename?: 'Mutation' } & {
  trackSession: { __typename?: 'Success' } & Pick<Success, 'success'>;
};

export type GetCurrentSessionQueryVariables = Exact<{
  includeComputedRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetCurrentSessionQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<
        User,
        | 'userAccountId'
        | 'createdAt'
        | 'hasUrlLockCode'
        | 'hasPaidAccess'
        | 'hasAnnouncementsEnabled'
        | 'hasFormsEnabled'
        | 'hasSchedulingEnabled'
        | 'hasCamerasEnabled'
      > & {
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              | 'email'
              | 'firstName'
              | 'lastName'
              | 'createdAt'
              | 'updatedAt'
              | 'smsConsentReceivedAt'
            >
          >;
          roles: Array<
            { __typename?: 'UserRole' } & Pick<UserRole, 'key'> & {
                object?: Maybe<
                  { __typename?: 'UserRoleObject' } & Pick<
                    UserRoleObject,
                    'objectName' | 'objectId'
                  >
                >;
              }
          >;
          profilePictureCropped?: Maybe<
            { __typename?: 'File' } & Pick<
              File,
              'downloadUrl' | 'fileId' | 'fileType'
            >
          >;
          worker?: Maybe<{ __typename?: 'Worker' } & Pick<Worker, 'workerId'>>;
        };
      session: { __typename?: 'UserSession' } & Pick<
        UserSession,
        | 'sessionToken'
        | 'authType'
        | 'createdAt'
        | 'updatedAt'
        | 'lastActiveAt'
        | 'urlLock'
        | 'appVersion'
      >;
      policyConsentStatuses: Array<
        { __typename?: 'UserPolicyConsentStatus' } & Pick<
          UserPolicyConsentStatus,
          'lastAcceptedVersion' | 'lastAcceptedAt'
        > & {
            document: { __typename?: 'PolicyDocument' } & Pick<
              PolicyDocument,
              'id' | 'key' | 'version' | 'effectiveAt'
            >;
          }
      >;
    }
  >;
};

export type GetProcoreConnectionStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetProcoreConnectionStatusQuery = { __typename?: 'Query' } & {
  getProcoreConnectionStatus: { __typename?: 'ProcoreConnectionStatus' } & Pick<
    ProcoreConnectionStatus,
    'connected' | 'procoreUserId'
  >;
};

export type SearchWorkersFromSearchBoxQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchWorkersFromSearchBoxQuery = { __typename?: 'Query' } & {
  searchWorkers: { __typename?: 'WorkerSearchResponse' } & Pick<
    WorkerSearchResponse,
    'count'
  > & {
      results: Array<
        { __typename?: 'WorkerSearchResult' } & {
          worker: { __typename?: 'Worker' } & Pick<
            Worker,
            'workerId' | 'birthDate' | 'quickCode'
          > & {
              user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                  identity?: Maybe<
                    { __typename?: 'UserIdentity' } & Pick<
                      UserIdentity,
                      'firstName' | 'lastName' | 'email' | 'phoneNumber'
                    >
                  >;
                };
              profilePicture?: Maybe<
                { __typename?: 'File' } & Pick<File, 'downloadUrl'>
              >;
              profilePictureCropped?: Maybe<
                { __typename?: 'File' } & Pick<File, 'downloadUrl'>
              >;
              contractorWorkers: {
                __typename?: 'WorkerContractorWorkersConnection';
              } & {
                edges: Array<
                  { __typename?: 'WorkerContractorWorkersEdge' } & {
                    node: { __typename?: 'ContractorWorker' } & {
                      contractor: { __typename?: 'Contractor' } & Pick<
                        Contractor,
                        'contractorId'
                      > & {
                          organization: { __typename?: 'Organization' } & Pick<
                            Organization,
                            'name' | 'slug'
                          >;
                        };
                      jobsiteWorkers: {
                        __typename?: 'ContractorWorkerJobsiteWorkersConnection';
                      } & {
                        edges: Array<
                          {
                            __typename?: 'ContractorWorkerJobsiteWorkersEdge';
                          } & {
                            node: { __typename?: 'JobsiteWorker' } & Pick<
                              JobsiteWorker,
                              | 'jobsiteWorkerId'
                              | 'trade'
                              | 'jobTitle'
                              | 'stickerNumber'
                            > & {
                                currentAccess: {
                                  __typename?: 'JobsiteWorkerCurrentAccess';
                                } & Pick<
                                  JobsiteWorkerCurrentAccess,
                                  'isAllowed'
                                >;
                                jobsiteContractor: {
                                  __typename?: 'JobsiteContractor';
                                } & {
                                  jobsite: { __typename?: 'Jobsite' } & Pick<
                                    Jobsite,
                                    'name' | 'jobsiteId'
                                  >;
                                };
                              };
                          }
                        >;
                      };
                    };
                  }
                >;
              };
            };
        }
      >;
    };
};

export type GetJobsiteAnnouncementQueryVariables = Exact<{
  announcementId: Scalars['ID']['input'];
}>;

export type GetJobsiteAnnouncementQuery = { __typename?: 'Query' } & {
  getJobsiteAnnouncement: { __typename?: 'JobsiteAnnouncement' } & Pick<
    JobsiteAnnouncement,
    | 'announcementType'
    | 'jobsiteAnnouncementId'
    | 'subject'
    | 'status'
    | 'message'
    | 'sentAt'
    | 'startAt'
    | 'endAt'
    | 'timeZone'
    | 'jobsiteAccessStatus'
    | 'accessWithinDayRange'
    | 'trades'
    | 'titles'
    | 'languages'
    | 'publishedCount'
    | 'deliveredCount'
  > & {
      jobsites: { __typename?: 'JobsiteAnnouncementJobsitesConnection' } & Pick<
        JobsiteAnnouncementJobsitesConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'JobsiteAnnouncementJobsitesEdge' } & {
              node: { __typename?: 'Jobsite' } & Pick<
                Jobsite,
                'jobsiteId' | 'name'
              >;
            }
          >;
        };
      contractors: {
        __typename?: 'JobsiteAnnouncementContractorsConnection';
      } & Pick<JobsiteAnnouncementContractorsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteAnnouncementContractorsEdge' } & {
              node: { __typename?: 'Contractor' } & Pick<
                Contractor,
                'contractorId'
              > & {
                  organization: { __typename?: 'Organization' } & Pick<
                    Organization,
                    'name'
                  >;
                };
            }
          >;
        };
      sentBy?: Maybe<
        { __typename?: 'User' } & {
          profilePictureCropped?: Maybe<
            { __typename?: 'File' } & Pick<File, 'downloadUrl'>
          >;
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              'firstName' | 'lastName'
            >
          >;
        }
      >;
      files: Array<
        { __typename?: 'File' } & Pick<
          File,
          'fileId' | 'fileType' | 'downloadUrl' | 'originalFileName'
        >
      >;
    };
};

export type CreateJobsiteAnnouncementMutationVariables = Exact<{
  jobsiteAnnouncementInput: JobsiteAnnouncementInput;
}>;

export type CreateJobsiteAnnouncementMutation = { __typename?: 'Mutation' } & {
  createJobsiteAnnouncement: { __typename?: 'JobsiteAnnouncement' } & Pick<
    JobsiteAnnouncement,
    | 'announcementType'
    | 'jobsiteAnnouncementId'
    | 'subject'
    | 'status'
    | 'message'
    | 'sentAt'
    | 'startAt'
    | 'endAt'
    | 'timeZone'
    | 'jobsiteAccessStatus'
    | 'accessWithinDayRange'
    | 'trades'
    | 'titles'
    | 'languages'
  > & {
      jobsites: { __typename?: 'JobsiteAnnouncementJobsitesConnection' } & Pick<
        JobsiteAnnouncementJobsitesConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'JobsiteAnnouncementJobsitesEdge' } & {
              node: { __typename?: 'Jobsite' } & Pick<
                Jobsite,
                'jobsiteId' | 'name'
              >;
            }
          >;
        };
    };
};

export type DeleteJobsiteAnnouncementMutationVariables = Exact<{
  jobsiteAnnouncementId: Scalars['ID']['input'];
}>;

export type DeleteJobsiteAnnouncementMutation = { __typename?: 'Mutation' } & {
  deleteJobsiteAnnouncement: { __typename: 'Success' } & Pick<
    Success,
    'success'
  >;
};

export type GetJobsiteAnnouncementCandidateCountsQueryVariables = Exact<{
  input: JobsiteAnnouncementFilterSpecification;
}>;

export type GetJobsiteAnnouncementCandidateCountsQuery = {
  __typename?: 'Query';
} & {
  getJobsiteAnnouncementCandidateRecipients: {
    __typename?: 'JobsiteAnnouncementCandidateRecipientsConnection';
  } & Pick<
    JobsiteAnnouncementCandidateRecipientsConnection,
    'totalCount' | 'totalReachableCount'
  >;
};

export type GetJobsiteAnnouncementsQueryVariables = Exact<{
  getJobsiteAnnouncementsInput?: InputMaybe<GetJobsiteAnnouncementsInput>;
}>;

export type GetJobsiteAnnouncementsQuery = { __typename?: 'Query' } & {
  getJobsiteAnnouncements: {
    __typename?: 'JobsiteAnnouncementConnection';
  } & Pick<JobsiteAnnouncementConnection, 'count'> & {
      edges: Array<
        { __typename?: 'JobsiteAnnouncementEdge' } & {
          node: { __typename?: 'JobsiteAnnouncement' } & Pick<
            JobsiteAnnouncement,
            | 'announcementType'
            | 'jobsiteAnnouncementId'
            | 'subject'
            | 'status'
            | 'message'
            | 'sentAt'
            | 'startAt'
            | 'endAt'
            | 'timeZone'
            | 'jobsiteAccessStatus'
            | 'accessWithinDayRange'
            | 'trades'
            | 'titles'
          > & {
              jobsites: {
                __typename?: 'JobsiteAnnouncementJobsitesConnection';
              } & Pick<JobsiteAnnouncementJobsitesConnection, 'count'> & {
                  edges: Array<
                    { __typename?: 'JobsiteAnnouncementJobsitesEdge' } & {
                      node: { __typename?: 'Jobsite' } & Pick<
                        Jobsite,
                        'jobsiteId' | 'name'
                      >;
                    }
                  >;
                };
            };
        }
      >;
    };
};

export type GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables =
  Exact<{
    userContractorsInput?: InputMaybe<UserContractorsInput>;
  }>;

export type GetJobsiteAnnouncementsContainerContractorsSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          contractors: { __typename?: 'UserContractorsConnection' } & Pick<
            UserContractorsConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserContractorsEdge' } & {
                  node: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name'
                      >;
                    };
                }
              >;
            };
        };
    }
  >;
};

export type ContractorAddJobsitesMutationVariables = Exact<{
  input: ContractorAddJobsitesInput;
}>;

export type ContractorAddJobsitesMutation = { __typename?: 'Mutation' } & {
  contractorAddJobsites: { __typename?: 'ContractorAddJobsitesPayload' } & {
    jobsiteContractors: Array<
      { __typename?: 'JobsiteContractor' } & Pick<JobsiteContractor, 'id'>
    >;
  };
};

export type ContractorRemoveWorkerMutationVariables = Exact<{
  input: ContractorRemoveWorkerInput;
}>;

export type ContractorRemoveWorkerMutation = { __typename?: 'Mutation' } & {
  contractorRemoveWorker: { __typename?: 'ContractorRemoveWorkerPayload' } & {
    success: { __typename?: 'Success' } & Pick<Success, 'success'>;
  };
};

export type CreateContractorStripeInvoiceMutationVariables = Exact<{
  input: CreateContractorStripeInvoiceInput;
}>;

export type CreateContractorStripeInvoiceMutation = {
  __typename?: 'Mutation';
} & {
  createContractorStripeInvoice: {
    __typename?: 'CreateContractorStripeInvoicePayload';
  } & Pick<
    CreateContractorStripeInvoicePayload,
    'invoiceId' | 'customerId' | 'url' | 'status'
  >;
};

export type InitiateStripePaymentSetupSessionMutationVariables = Exact<{
  input: InitiateStripePaymentSetupSessionInput;
}>;

export type InitiateStripePaymentSetupSessionMutation = {
  __typename?: 'Mutation';
} & {
  initiateStripePaymentSetupSession: {
    __typename?: 'InitiateStripePaymentSetupSessionPayload';
  } & Pick<
    InitiateStripePaymentSetupSessionPayload,
    'clientSecret' | 'customerId' | 'publicKey' | 'sessionId'
  >;
};

export type JobsiteContractorUpdateStripePaymentMethodMutationVariables =
  Exact<{
    input: JobsiteContractorUpdateStripePaymentMethodInput;
  }>;

export type JobsiteContractorUpdateStripePaymentMethodMutation = {
  __typename?: 'Mutation';
} & {
  jobsiteContractorUpdateStripePaymentMethod: {
    __typename?: 'JobsiteContractorUpdateStripePaymentMethodPayload';
  } & { success: { __typename?: 'Success' } & Pick<Success, 'success'> };
};

export type RemoveStripePaymentMethodMutationVariables = Exact<{
  input: ManageContractorStripePaymentMethodInput;
}>;

export type RemoveStripePaymentMethodMutation = { __typename?: 'Mutation' } & {
  removeStripePaymentMethod?: Maybe<
    Array<
      { __typename?: 'StripePaymentMethod' } & Pick<
        StripePaymentMethod,
        'id' | 'brand' | 'last4' | 'expMonth' | 'expYear' | 'isDefault'
      >
    >
  >;
};

export type SetDefaultStripePaymentMethodMutationVariables = Exact<{
  input: ManageContractorStripePaymentMethodInput;
}>;

export type SetDefaultStripePaymentMethodMutation = {
  __typename?: 'Mutation';
} & {
  setDefaultStripePaymentMethod?: Maybe<
    Array<
      { __typename?: 'StripePaymentMethod' } & Pick<
        StripePaymentMethod,
        'id' | 'brand' | 'last4' | 'expMonth' | 'expYear' | 'isDefault'
      >
    >
  >;
};

export type GetContractorStripePaymentMethodsDetailsQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
}>;

export type GetContractorStripePaymentMethodsDetailsQuery = {
  __typename?: 'Query';
} & {
  getContractor: { __typename?: 'Contractor' } & Pick<
    Contractor,
    'contractorId' | 'isArchived' | 'websiteUrl' | 'description'
  > & {
      stripeMappingDetails?: Maybe<
        { __typename?: 'StripeMappingData' } & Pick<
          StripeMappingData,
          'customerId' | 'publicKey' | 'clientSecret'
        >
      >;
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        | 'organizationId'
        | 'name'
        | 'legalName'
        | 'email'
        | 'addressLine1'
        | 'addressLine2'
        | 'addressCity'
        | 'addressState'
        | 'addressZipCode'
      >;
      billingContact?: Maybe<
        { __typename?: 'ContactPerson' } & Pick<
          ContactPerson,
          'firstName' | 'lastName' | 'email' | 'phoneNumber'
        >
      >;
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
          >;
        };
    };
};

export type GetJobsitesAndContractorsQueryVariables = Exact<{
  userJobsitesInput: UserJobsitesInput;
}>;

export type GetJobsitesAndContractorsQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          jobsites: { __typename?: 'UserJobsitesConnection' } & Pick<
            UserJobsitesConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserJobsitesEdge' } & {
                  node: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'jobsiteId'
                  > & {
                      jobsiteContractors: {
                        __typename?: 'JobsiteJobsiteContractorsConnection';
                      } & Pick<JobsiteJobsiteContractorsConnection, 'count'> & {
                          edges: Array<
                            { __typename?: 'JobsiteJobsiteContractorsEdge' } & {
                              node: { __typename?: 'JobsiteContractor' } & Pick<
                                JobsiteContractor,
                                'id' | 'startDate'
                              > & {
                                  contractor: {
                                    __typename?: 'Contractor';
                                  } & Pick<
                                    Contractor,
                                    'contractorId' | 'isDefaultContractor'
                                  > & {
                                      organization: {
                                        __typename?: 'Organization';
                                      } & Pick<
                                        Organization,
                                        'name' | 'slug' | 'legalName'
                                      >;
                                    };
                                };
                            }
                          >;
                        };
                    };
                }
              >;
            };
        };
    }
  >;
};

export type GetContractorContainerContractorInfoQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
}>;

export type GetContractorContainerContractorInfoQuery = {
  __typename?: 'Query';
} & {
  getContractor: { __typename?: 'Contractor' } & Pick<
    Contractor,
    'contractorId' | 'isArchived' | 'websiteUrl' | 'description'
  > & {
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        | 'organizationId'
        | 'slug'
        | 'name'
        | 'legalName'
        | 'email'
        | 'addressLine1'
        | 'addressLine2'
        | 'addressCity'
        | 'addressState'
        | 'addressZipCode'
      >;
      billingContact?: Maybe<
        { __typename?: 'ContactPerson' } & Pick<
          ContactPerson,
          'firstName' | 'lastName' | 'email' | 'phoneNumber'
        >
      >;
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
          >;
        };
    };
};

export type GetContractorContainerContractorJobsitesQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
  contractorJobsiteContractorsInput?: InputMaybe<ContractorJobsiteContractorsInput>;
}>;

export type GetContractorContainerContractorJobsitesQuery = {
  __typename?: 'Query';
} & {
  getContractor: { __typename?: 'Contractor' } & Pick<
    Contractor,
    'contractorId' | 'isArchived'
  > & {
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        'organizationId' | 'name'
      >;
      jobsiteContractors: {
        __typename?: 'ContractorJobsiteContractorsConnection';
      } & Pick<ContractorJobsiteContractorsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'ContractorJobsiteContractorsEdge' } & {
              node: { __typename?: 'JobsiteContractor' } & Pick<
                JobsiteContractor,
                'id' | 'stripePaymentMethodId' | 'startDate' | 'endDate'
              > & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'name' | 'jobsiteId' | 'addressCity' | 'addressState'
                  >;
                  parentJobsiteContractor?: Maybe<
                    { __typename?: 'JobsiteContractor' } & {
                      contractor: { __typename?: 'Contractor' } & Pick<
                        Contractor,
                        'contractorId'
                      > & {
                          organization: { __typename?: 'Organization' } & Pick<
                            Organization,
                            'name'
                          >;
                        };
                    }
                  >;
                  contact?: Maybe<
                    { __typename?: 'ContactPerson' } & Pick<
                      ContactPerson,
                      | 'firstName'
                      | 'lastName'
                      | 'phoneNumber'
                      | 'email'
                      | 'title'
                    >
                  >;
                  jobsiteWorkers: {
                    __typename?: 'JobsiteContractorJobsiteWorkersConnection';
                  } & Pick<
                    JobsiteContractorJobsiteWorkersConnection,
                    'count'
                  > & {
                      edges: Array<
                        {
                          __typename?: 'JobsiteContractorJobsiteWorkersEdge';
                        } & {
                          node: { __typename?: 'JobsiteWorker' } & Pick<
                            JobsiteWorker,
                            'jobsiteWorkerId'
                          >;
                        }
                      >;
                    };
                  subcontractedJobsiteContractors: {
                    __typename?: 'SubcontractedJobsiteContractorsConnection';
                  } & Pick<SubcontractedJobsiteContractorsConnection, 'count'>;
                  jobsiteInvitation?: Maybe<
                    { __typename?: 'JobsiteInvitation' } & Pick<
                      JobsiteInvitation,
                      'jobsiteInvitationId'
                    >
                  >;
                };
            }
          >;
        };
    };
};

export type GetContractorContainerContractorSubcontractorsQueryVariables =
  Exact<{
    contractorId: Scalars['ID']['input'];
    includeArchived: Scalars['Boolean']['input'];
    contractorContractorWorkersInput?: InputMaybe<ContractorContractorWorkersInput>;
  }>;

export type GetContractorContainerContractorSubcontractorsQuery = {
  __typename?: 'Query';
} & {
  getContractor: { __typename?: 'Contractor' } & Pick<
    Contractor,
    'contractorId' | 'isArchived'
  > & {
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        'name' | 'addressCity' | 'addressState'
      >;
      jobsiteContractors: {
        __typename?: 'ContractorJobsiteContractorsConnection';
      } & Pick<ContractorJobsiteContractorsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'ContractorJobsiteContractorsEdge' } & {
              node: { __typename?: 'JobsiteContractor' } & {
                jobsite: { __typename?: 'Jobsite' } & Pick<
                  Jobsite,
                  'jobsiteId' | 'name'
                >;
                subcontractedJobsiteContractors: {
                  __typename?: 'SubcontractedJobsiteContractorsConnection';
                } & Pick<SubcontractedJobsiteContractorsConnection, 'count'> & {
                    edges: Array<
                      { __typename?: 'SubcontractedJobsiteContractorEdge' } & {
                        node: { __typename?: 'JobsiteContractor' } & Pick<
                          JobsiteContractor,
                          'endDate'
                        > & {
                            contractor: { __typename?: 'Contractor' } & Pick<
                              Contractor,
                              'contractorId'
                            > & {
                                organization: {
                                  __typename?: 'Organization';
                                } & Pick<Organization, 'name'>;
                              };
                            jobsite: { __typename?: 'Jobsite' } & Pick<
                              Jobsite,
                              'jobsiteId' | 'name'
                            >;
                            jobsiteWorkers: {
                              __typename?: 'JobsiteContractorJobsiteWorkersConnection';
                            } & Pick<
                              JobsiteContractorJobsiteWorkersConnection,
                              'count'
                            >;
                          };
                      }
                    >;
                  };
              };
            }
          >;
        };
      contractorWorkers: {
        __typename?: 'ContractorContractorWorkersConnection';
      } & Pick<ContractorContractorWorkersConnection, 'count'>;
      contractorMembers: {
        __typename?: 'ContractorContractorMembersConnection';
      } & Pick<ContractorContractorMembersConnection, 'count'>;
    };
};

export type GetContractorContainerContractorUsersQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
  contractorContractorMemberInput?: InputMaybe<ContractorContractorMembersInput>;
  userRolesInput?: InputMaybe<UserRolesInput>;
}>;

export type GetContractorContainerContractorUsersQuery = {
  __typename?: 'Query';
} & {
  getContractor: { __typename?: 'Contractor' } & Pick<
    Contractor,
    'contractorId' | 'isArchived'
  > & {
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        'organizationId' | 'name'
      >;
      contractorMembers: {
        __typename?: 'ContractorContractorMembersConnection';
      } & Pick<ContractorContractorMembersConnection, 'count'> & {
          edges: Array<
            { __typename?: 'ContractorContractorMembersEdge' } & {
              node: { __typename?: 'ContractorMember' } & Pick<
                ContractorMember,
                'id'
              > & {
                  user: { __typename?: 'User' } & Pick<
                    User,
                    'userAccountId'
                  > & {
                      roles: Array<
                        { __typename?: 'UserRole' } & Pick<
                          UserRole,
                          'key' | 'displayName'
                        > & {
                            object?: Maybe<
                              { __typename?: 'UserRoleObject' } & Pick<
                                UserRoleObject,
                                'objectId'
                              > & {
                                  objectDetails?: Maybe<
                                    {
                                      __typename?: 'UserRoleObjectDetails';
                                    } & Pick<UserRoleObjectDetails, 'name'>
                                  >;
                                }
                            >;
                          }
                      >;
                      identity?: Maybe<
                        { __typename?: 'UserIdentity' } & Pick<
                          UserIdentity,
                          'firstName' | 'lastName' | 'email' | 'phoneNumber'
                        >
                      >;
                      worker?: Maybe<
                        { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                            profilePictureCropped?: Maybe<
                              { __typename?: 'File' } & Pick<
                                File,
                                'downloadUrl'
                              >
                            >;
                          }
                      >;
                      lastSession?: Maybe<
                        { __typename?: 'UserSession' } & Pick<
                          UserSession,
                          'createdAt' | 'appVersion'
                        >
                      >;
                    };
                };
            }
          >;
        };
    };
};

export type GetContractorContainerContractorWorkersQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
  contractorContractorWorkersInput?: InputMaybe<ContractorContractorWorkersInput>;
}>;

export type GetContractorContainerContractorWorkersQuery = {
  __typename?: 'Query';
} & {
  getContractor: { __typename?: 'Contractor' } & Pick<
    Contractor,
    'contractorId' | 'isArchived'
  > & {
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        'organizationId' | 'name'
      >;
      jobsiteContractors: {
        __typename?: 'ContractorJobsiteContractorsConnection';
      } & {
        edges: Array<
          { __typename?: 'ContractorJobsiteContractorsEdge' } & {
            node: { __typename?: 'JobsiteContractor' } & {
              jobsite: { __typename?: 'Jobsite' } & Pick<
                Jobsite,
                'jobsiteId' | 'name'
              >;
            };
          }
        >;
      };
      contractorWorkers: {
        __typename?: 'ContractorContractorWorkersConnection';
      } & Pick<ContractorContractorWorkersConnection, 'count'> & {
          edges: Array<
            { __typename?: 'ContractorContractorWorkersEdge' } & {
              node: { __typename?: 'ContractorWorker' } & Pick<
                ContractorWorker,
                'id'
              > & {
                  worker: { __typename?: 'Worker' } & Pick<
                    Worker,
                    'workerId' | 'birthDate' | 'quickCode'
                  > & {
                      user: { __typename?: 'User' } & Pick<
                        User,
                        'userAccountId'
                      > & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName' | 'email'
                            >
                          >;
                        };
                      profilePicture?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId'
                        >
                      >;
                      profilePictureCropped?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                        >
                      >;
                      workerCards: {
                        __typename?: 'WorkerWorkerCardsConnection';
                      } & {
                        edges: Array<
                          { __typename?: 'WorkerWorkerCardsEdge' } & {
                            node: { __typename?: 'WorkerCard' } & Pick<
                              WorkerCard,
                              'workerCardId' | 'cardNumber' | 'cardStatus'
                            >;
                          }
                        >;
                      };
                    };
                  jobsiteWorkers: {
                    __typename?: 'ContractorWorkerJobsiteWorkersConnection';
                  } & Pick<
                    ContractorWorkerJobsiteWorkersConnection,
                    'count'
                  > & {
                      edges: Array<
                        {
                          __typename?: 'ContractorWorkerJobsiteWorkersEdge';
                        } & {
                          node: { __typename?: 'JobsiteWorker' } & Pick<
                            JobsiteWorker,
                            'jobsiteWorkerId' | 'trade'
                          > & {
                              jobsiteContractor: {
                                __typename?: 'JobsiteContractor';
                              } & {
                                jobsite: { __typename?: 'Jobsite' } & Pick<
                                  Jobsite,
                                  'jobsiteId' | 'name'
                                >;
                                contractor: {
                                  __typename?: 'Contractor';
                                } & Pick<Contractor, 'contractorId'> & {
                                    organization: {
                                      __typename?: 'Organization';
                                    } & Pick<Organization, 'name'>;
                                  };
                              };
                              currentAccess: {
                                __typename?: 'JobsiteWorkerCurrentAccess';
                              } & Pick<
                                JobsiteWorkerCurrentAccess,
                                | 'isAllowed'
                                | 'notAllowedReason'
                                | 'startDate'
                                | 'endDate'
                              >;
                            };
                        }
                      >;
                    };
                };
            }
          >;
        };
    };
};

export type GetContractorContainerPaymentMethodsQueryVariables = Exact<{
  contractorId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
}>;

export type GetContractorContainerPaymentMethodsQuery = {
  __typename?: 'Query';
} & {
  getContractor: { __typename?: 'Contractor' } & Pick<
    Contractor,
    'contractorId' | 'isArchived' | 'websiteUrl' | 'description'
  > & {
      stripeMappingDetails?: Maybe<
        { __typename?: 'StripeMappingData' } & Pick<
          StripeMappingData,
          'customerId' | 'publicKey'
        >
      >;
      stripePaymentMethods?: Maybe<
        Array<
          { __typename?: 'StripePaymentMethod' } & Pick<
            StripePaymentMethod,
            'id' | 'brand' | 'last4' | 'expMonth' | 'expYear' | 'isDefault'
          >
        >
      >;
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        | 'organizationId'
        | 'name'
        | 'legalName'
        | 'email'
        | 'addressLine1'
        | 'addressLine2'
        | 'addressCity'
        | 'addressState'
        | 'addressZipCode'
      >;
      billingContact?: Maybe<
        { __typename?: 'ContactPerson' } & Pick<
          ContactPerson,
          'firstName' | 'lastName' | 'email' | 'phoneNumber'
        >
      >;
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
          >;
        };
      jobsiteContractors: {
        __typename?: 'ContractorJobsiteContractorsConnection';
      } & Pick<ContractorJobsiteContractorsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'ContractorJobsiteContractorsEdge' } & {
              node: { __typename?: 'JobsiteContractor' } & Pick<
                JobsiteContractor,
                'id' | 'stripePaymentMethodId'
              > & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    | 'name'
                    | 'jobsiteId'
                    | 'addressCity'
                    | 'addressState'
                    | 'startDate'
                    | 'endDate'
                  >;
                };
            }
          >;
        };
    };
};

export type GetJobsiteContractorsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteContractorsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteContractors: {
        __typename?: 'JobsiteJobsiteContractorsConnection';
      } & Pick<JobsiteJobsiteContractorsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteJobsiteContractorsEdge' } & {
              node: { __typename?: 'JobsiteContractor' } & Pick<
                JobsiteContractor,
                'id' | 'startDate' | 'stripePaymentMethodId'
              > & {
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId' | 'isDefaultContractor'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'organizationId' | 'name' | 'slug' | 'legalName'
                      >;
                    };
                };
            }
          >;
        };
    };
};

export type ContractorCreateMutationVariables = Exact<{
  input: ContractorCreateInput;
}>;

export type ContractorCreateMutation = { __typename?: 'Mutation' } & {
  contractorCreate: { __typename?: 'ContractorCreatePayload' } & {
    contractor: { __typename?: 'Contractor' } & Pick<
      Contractor,
      'contractorId'
    >;
  };
};

export type ContractorUpdateMutationVariables = Exact<{
  input: ContractorUpdateInput;
}>;

export type ContractorUpdateMutation = { __typename?: 'Mutation' } & {
  contractorUpdate: { __typename?: 'ContractorUpdatePayload' } & {
    contractor: { __typename?: 'Contractor' } & Pick<
      Contractor,
      'contractorId'
    >;
  };
};

export type GetContractorsContainerCurrentSessionQueryVariables = Exact<{
  userContractorsInput?: InputMaybe<UserContractorsInput>;
}>;

export type GetContractorsContainerCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          contractors: { __typename?: 'UserContractorsConnection' } & Pick<
            UserContractorsConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserContractorsEdge' } & {
                  node: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name' | 'addressCity' | 'addressState'
                      >;
                      jobsiteContractors: {
                        __typename?: 'ContractorJobsiteContractorsConnection';
                      } & {
                        edges: Array<
                          {
                            __typename?: 'ContractorJobsiteContractorsEdge';
                          } & {
                            node: { __typename?: 'JobsiteContractor' } & Pick<
                              JobsiteContractor,
                              'startDate' | 'endDate'
                            > & {
                                jobsite: { __typename?: 'Jobsite' } & Pick<
                                  Jobsite,
                                  'name' | 'jobsiteId'
                                >;
                                jobsiteWorkers: {
                                  __typename?: 'JobsiteContractorJobsiteWorkersConnection';
                                } & Pick<
                                  JobsiteContractorJobsiteWorkersConnection,
                                  'count'
                                >;
                              };
                          }
                        >;
                      };
                    };
                }
              >;
            };
        };
    }
  >;
};

export type GetDashboardJobsitesWithStatsCurrentSessionQueryVariables = Exact<{
  userJobsitesInput?: InputMaybe<UserJobsitesInput>;
}>;

export type GetDashboardJobsitesWithStatsCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          jobsites: { __typename?: 'UserJobsitesConnection' } & Pick<
            UserJobsitesConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserJobsitesEdge' } & {
                  node: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    | 'jobsiteId'
                    | 'name'
                    | 'addressLine1'
                    | 'addressLine2'
                    | 'addressCity'
                    | 'addressState'
                    | 'addressZipCode'
                    | 'latitude'
                    | 'longitude'
                    | 'startDate'
                    | 'endDate'
                  > & {
                      developer?: Maybe<
                        { __typename?: 'Developer' } & Pick<Developer, 'name'>
                      >;
                      profilePicture?: Maybe<
                        { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                      >;
                      jobsiteStats?: Maybe<
                        { __typename?: 'JobsiteStats' } & Pick<
                          JobsiteStats,
                          | 'numberOfActiveWorkers'
                          | 'numberOfOrientationWorkersInProgress'
                          | 'numberOfOnSiteWorkers'
                        >
                      >;
                    };
                }
              >;
              filtersOptions?: Maybe<
                { __typename?: 'UserJobsitesFilters' } & {
                  developers: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                  cities: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                  states: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                }
              >;
            };
        };
    }
  >;
};

export type GetDeveloperContainerDeveloperInfoQueryVariables = Exact<{
  developerId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
}>;

export type GetDeveloperContainerDeveloperInfoQuery = {
  __typename?: 'Query';
} & {
  getDeveloper: { __typename?: 'Developer' } & Pick<
    Developer,
    'developerId'
  > & {
      organization: { __typename?: 'Organization' } & Pick<
        Organization,
        | 'organizationId'
        | 'name'
        | 'slug'
        | 'legalName'
        | 'email'
        | 'phoneNumber'
        | 'addressLine1'
        | 'addressLine2'
        | 'addressCity'
        | 'addressState'
        | 'addressZipCode'
      > & {
          objectHistory: { __typename?: 'ObjectHistory' } & Pick<
            ObjectHistory,
            'createdAt' | 'updatedAt'
          > & {
              createdBy?: Maybe<
                { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName'
                      >
                    >;
                  }
              >;
              updatedBy?: Maybe<
                { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName'
                      >
                    >;
                  }
              >;
            };
        };
      jobsites: { __typename?: 'DeveloperJobsitesConnection' } & Pick<
        DeveloperJobsitesConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'DeveloperJobsitesEdge' } & {
              node: { __typename?: 'Jobsite' } & Pick<
                Jobsite,
                | 'name'
                | 'parentId'
                | 'jobsiteId'
                | 'addressLine1'
                | 'addressLine2'
                | 'addressCity'
                | 'addressState'
                | 'addressZipCode'
                | 'startDate'
                | 'endDate'
                | 'workerAccessEnabled'
                | 'avigilonEnabled'
              > & {
                  jobsiteWorkers: {
                    __typename?: 'JobsiteJobsiteWorkersConnection';
                  } & Pick<JobsiteJobsiteWorkersConnection, 'count'>;
                  featuresModule?: Maybe<
                    { __typename?: 'JobsiteFeaturesModule' } & Pick<
                      JobsiteFeaturesModule,
                      'announcementsEnabled' | 'archivingAccessEventsEnabled'
                    >
                  >;
                  developer?: Maybe<
                    { __typename?: 'Developer' } & Pick<
                      Developer,
                      'developerId' | 'name'
                    >
                  >;
                  jobsiteCardFormats: {
                    __typename: 'JobsiteCardFormatsConnection';
                  } & Pick<JobsiteCardFormatsConnection, 'count'> & {
                      edges: Array<
                        { __typename?: 'JobsiteCardFormatsEdge' } & {
                          node: { __typename?: 'JobsiteCardFormat' } & Pick<
                            JobsiteCardFormat,
                            'jobsiteCardFormatId' | 'isDefaultForCardType'
                          > & {
                              workerCardFormat: {
                                __typename?: 'WorkerCardFormat';
                              } & Pick<
                                WorkerCardFormat,
                                | 'workerCardFormatId'
                                | 'name'
                                | 'description'
                                | 'cardType'
                                | 'facilityCode'
                              >;
                            };
                        }
                      >;
                    };
                  jobsiteMembers: {
                    __typename?: 'JobsiteJobsiteMembersConnection';
                  } & Pick<JobsiteJobsiteMembersConnection, 'count'>;
                };
            }
          >;
        };
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
          >;
        };
    };
};

export type GetDeveloperWorkersContainerCurrentSessionQueryVariables = Exact<{
  userWorkersInput?: InputMaybe<UserWorkersInput>;
}>;

export type GetDeveloperWorkersContainerCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          workers: { __typename?: 'UserWorkersConnection' } & Pick<
            UserWorkersConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserWorkersEdge' } & {
                  node: { __typename?: 'Worker' } & Pick<
                    Worker,
                    'workerId' | 'birthDate' | 'quickCode'
                  > & {
                      user: { __typename?: 'User' } & Pick<
                        User,
                        'userAccountId'
                      > & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName' | 'email'
                            >
                          >;
                        };
                      profilePictureCropped?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                        >
                      >;
                      workerCards: {
                        __typename?: 'WorkerWorkerCardsConnection';
                      } & Pick<WorkerWorkerCardsConnection, 'count'> & {
                          edges: Array<
                            { __typename?: 'WorkerWorkerCardsEdge' } & {
                              node: { __typename?: 'WorkerCard' } & Pick<
                                WorkerCard,
                                'cardNumber' | 'cardStatus' | 'workerCardId'
                              >;
                            }
                          >;
                        };
                      jobsiteWorkers: {
                        __typename?: 'WorkerJobsiteWorkersConnection';
                      } & {
                        edges: Array<
                          { __typename?: 'WorkerJobsiteWorkersEdge' } & {
                            node: { __typename?: 'JobsiteWorker' } & Pick<
                              JobsiteWorker,
                              'jobsiteWorkerId' | 'trade'
                            > & {
                                jobsiteContractor: {
                                  __typename?: 'JobsiteContractor';
                                } & {
                                  jobsite: { __typename?: 'Jobsite' } & Pick<
                                    Jobsite,
                                    'jobsiteId' | 'name'
                                  >;
                                  contractor: {
                                    __typename?: 'Contractor';
                                  } & Pick<Contractor, 'contractorId'> & {
                                      organization: {
                                        __typename?: 'Organization';
                                      } & Pick<Organization, 'name'>;
                                    };
                                };
                                currentAccess: {
                                  __typename?: 'JobsiteWorkerCurrentAccess';
                                } & Pick<
                                  JobsiteWorkerCurrentAccess,
                                  'isAllowed'
                                >;
                              };
                          }
                        >;
                      };
                    };
                }
              >;
            };
        };
    }
  >;
};

export type DeveloperCreateMutationVariables = Exact<{
  input: DeveloperCreateInput;
}>;

export type DeveloperCreateMutation = { __typename?: 'Mutation' } & {
  developerCreate: { __typename?: 'DeveloperCreatePayload' } & {
    developer: { __typename?: 'Developer' } & Pick<
      Developer,
      'name' | 'developerId'
    > & {
        organization: { __typename?: 'Organization' } & Pick<
          Organization,
          'name' | 'slug' | 'organizationId'
        >;
      };
  };
};

export type DeveloperUpdateMutationVariables = Exact<{
  input: DeveloperUpdateInput;
}>;

export type DeveloperUpdateMutation = { __typename?: 'Mutation' } & {
  developerUpdate: { __typename?: 'DeveloperUpdatePayload' } & {
    developer: { __typename?: 'Developer' } & Pick<
      Developer,
      'name' | 'developerId'
    > & {
        organization: { __typename?: 'Organization' } & Pick<
          Organization,
          'name' | 'slug' | 'organizationId'
        >;
      };
  };
};

export type GetDevelopersContainerCurrentSessionQueryVariables = Exact<{
  userDevelopersInput?: InputMaybe<UserDevelopersInput>;
}>;

export type GetDevelopersContainerCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          developers: { __typename?: 'UserDevelopersConnection' } & Pick<
            UserDevelopersConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserDevelopersEdge' } & {
                  node: { __typename?: 'Developer' } & Pick<
                    Developer,
                    'developerId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        | 'organizationId'
                        | 'name'
                        | 'addressState'
                        | 'addressCity'
                      >;
                      jobsites: {
                        __typename?: 'DeveloperJobsitesConnection';
                      } & Pick<DeveloperJobsitesConnection, 'count'> & {
                          edges: Array<
                            { __typename?: 'DeveloperJobsitesEdge' } & {
                              node: { __typename?: 'Jobsite' } & Pick<
                                Jobsite,
                                'jobsiteId' | 'name' | 'startDate' | 'endDate'
                              > & {
                                  jobsiteWorkers: {
                                    __typename?: 'JobsiteJobsiteWorkersConnection';
                                  } & Pick<
                                    JobsiteJobsiteWorkersConnection,
                                    'count'
                                  >;
                                };
                            }
                          >;
                        };
                    };
                }
              >;
            };
        };
    }
  >;
};

export type GetChangeWorkerQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type GetChangeWorkerQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & Pick<
    Worker,
    'workerId' | 'quickCode' | 'createdMethod' | 'isArchived'
  > & {
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt' | 'updatedAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName' | 'email'
                  >
                >;
              }
          >;
          updatedBy?: Maybe<
            { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName' | 'email'
                  >
                >;
              }
          >;
        };
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              'id' | 'firstName' | 'lastName' | 'email'
            >
          >;
          jobsiteMembers: { __typename?: 'UserJobsiteMembersConnection' } & {
            edges: Array<
              { __typename?: 'UserJobsiteMembersEdge' } & {
                node: { __typename?: 'JobsiteMember' } & Pick<
                  JobsiteMember,
                  'id' | 'title'
                > & {
                    jobsite: { __typename?: 'Jobsite' } & Pick<
                      Jobsite,
                      'jobsiteId' | 'name' | 'timeZone'
                    >;
                  };
              }
            >;
          };
          roles: Array<
            { __typename?: 'UserRole' } & Pick<
              UserRole,
              'key' | 'mappingId' | 'displayName'
            > & {
                object?: Maybe<
                  { __typename?: 'UserRoleObject' } & Pick<
                    UserRoleObject,
                    'objectId' | 'objectName'
                  > & {
                      objectDetails?: Maybe<
                        { __typename?: 'UserRoleObjectDetails' } & Pick<
                          UserRoleObjectDetails,
                          'objectMemberId' | 'type' | 'name' | 'title'
                        >
                      >;
                    }
                >;
              }
          >;
        };
      jobsiteWorkers: { __typename?: 'WorkerJobsiteWorkersConnection' } & {
        edges: Array<
          { __typename?: 'WorkerJobsiteWorkersEdge' } & {
            node: { __typename?: 'JobsiteWorker' } & Pick<
              JobsiteWorker,
              'jobsiteWorkerId'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'jobsiteId' | 'name' | 'timeZone'
                  >;
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'organizationId' | 'name'
                      >;
                    };
                };
                currentAccess: {
                  __typename?: 'JobsiteWorkerCurrentAccess';
                } & Pick<
                  JobsiteWorkerCurrentAccess,
                  'id' | 'isAllowed' | 'notAllowedReason' | 'endDate'
                >;
              };
          }
        >;
      };
      documents: { __typename?: 'WorkerDocumentsConnection' } & {
        edges: Array<
          { __typename?: 'WorkerDocumentsEdge' } & {
            node: { __typename?: 'JobsiteWorkerDocument' } & Pick<
              JobsiteWorkerDocument,
              'jobsiteWorkerDocumentId'
            > & {
                jobsiteWorkerDocumentType: {
                  __typename?: 'JobsiteWorkerDocumentType';
                } & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'name' | 'jobsiteId'
                  > & {
                      developer?: Maybe<
                        { __typename?: 'Developer' } & Pick<
                          Developer,
                          'name' | 'developerId'
                        >
                      >;
                    };
                  workerDocumentType: {
                    __typename?: 'WorkerDocumentType';
                  } & Pick<
                    WorkerDocumentType,
                    | 'name'
                    | 'key'
                    | 'expirationDate'
                    | 'documentLevel'
                    | 'isGlobal'
                    | 'isPhi'
                  >;
                };
                latestVersion: {
                  __typename?: 'JobsiteWorkerDocumentVersion';
                } & Pick<
                  JobsiteWorkerDocumentVersion,
                  'jobsiteWorkerDocumentVersionId'
                > & {
                    files: Array<
                      { __typename?: 'File' } & Pick<
                        File,
                        'fileId' | 'fileType' | 'downloadUrl'
                      >
                    >;
                    additionalFieldValues?: Maybe<
                      Array<
                        { __typename?: 'AdditionalFieldValue' } & Pick<
                          AdditionalFieldValue,
                          'key' | 'value'
                        >
                      >
                    >;
                  };
              };
          }
        >;
      };
      workerCards: { __typename?: 'WorkerWorkerCardsConnection' } & {
        edges: Array<
          { __typename?: 'WorkerWorkerCardsEdge' } & {
            node: { __typename?: 'WorkerCard' } & Pick<
              WorkerCard,
              'workerCardId' | 'cardNumber'
            >;
          }
        >;
      };
    };
};

export type GetEntityChangesQueryVariables = Exact<{
  input?: InputMaybe<GetEntityChangesInput>;
}>;

export type GetEntityChangesQuery = { __typename?: 'Query' } & {
  getEntityChanges: { __typename?: 'GetEntityChangesResult' } & Pick<
    GetEntityChangesResult,
    'count'
  > & {
      edges: Array<
        { __typename?: 'EntityChangesEdge' } & {
          node: { __typename?: 'EntityChange' } & Pick<
            EntityChange,
            | 'id'
            | 'tableName'
            | 'entityId'
            | 'entityDbId'
            | 'apiDbHandler'
            | 'values'
          > & {
              objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                ObjectHistory,
                'createdAt'
              > & {
                  createdBy?: Maybe<
                    { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                        identity?: Maybe<
                          { __typename?: 'UserIdentity' } & Pick<
                            UserIdentity,
                            'firstName' | 'lastName' | 'email'
                          >
                        >;
                      }
                  >;
                };
            };
        }
      >;
    };
};

export type RegisterWorkerForFacialRecognitionBadgeMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  workerCardId: Scalars['ID']['input'];
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type RegisterWorkerForFacialRecognitionBadgeMutation = {
  __typename?: 'Mutation';
} & {
  registerWorkerForFacialRecognitionBadge: { __typename?: 'WorkerCard' } & Pick<
    WorkerCard,
    'workerCardId' | 'cardStatus' | 'cardNumber'
  > & {
      workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
        WorkerCardFormat,
        'name' | 'cardType' | 'facilityCode'
      >;
    };
};

export type GenerateFormSubmissionsReportMutationVariables = Exact<{
  input: FormSubmissionsReportInput;
}>;

export type GenerateFormSubmissionsReportMutation = {
  __typename?: 'Mutation';
} & {
  generateFormSubmissionsReport: { __typename?: 'File' } & Pick<
    File,
    'fileId' | 'fileType' | 'uploadedAt' | 'downloadUrl' | 'originalFileName'
  >;
};

export type JobsiteArchiveFormSubmissionMutationVariables = Exact<{
  input: JobsiteArchiveFormSubmissionInput;
}>;

export type JobsiteArchiveFormSubmissionMutation = {
  __typename?: 'Mutation';
} & {
  jobsiteArchiveFormSubmission: {
    __typename?: 'JobsiteArchiveFormSubmissionPayload';
  } & { success: { __typename?: 'Success' } & Pick<Success, 'success'> };
};

export type JobsiteCreateFormSubmissionMutationVariables = Exact<{
  input: JobsiteCreateFormSubmissionInput;
}>;

export type JobsiteCreateFormSubmissionMutation = {
  __typename?: 'Mutation';
} & {
  jobsiteCreateFormSubmission: {
    __typename?: 'JobsiteCreateFormSubmissionPayload';
  } & {
    jobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
      JobsiteFormSubmission,
      'id'
    >;
  };
};

export type GetFormsQueryVariables = Exact<{
  formsInput?: InputMaybe<UserFormsInput>;
}>;

export type GetFormsQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & {
        forms: { __typename?: 'UserFormsConnection' } & {
          edges: Array<
            { __typename?: 'UserFormsEdge' } & {
              node: { __typename?: 'Form' } & Pick<
                Form,
                | 'id'
                | 'key'
                | 'name'
                | 'content'
                | 'allowAdd'
                | 'allowEdit'
                | 'allowDelete'
              >;
            }
          >;
        };
      };
    }
  >;
};

export type GetJobsiteFormSubmissionsQueryVariables = Exact<{
  jobsiteFormSubmissionsInput: JobsiteFormSubmissionsInput;
}>;

export type GetJobsiteFormSubmissionsQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & {
        jobsiteFormSubmissions: {
          __typename?: 'JobsiteFormSubmissionsConnection';
        } & Pick<JobsiteFormSubmissionsConnection, 'count'> & {
            edges: Array<
              { __typename?: 'JobsiteFormSubmissionsEdge' } & {
                node: { __typename?: 'JobsiteFormSubmission' } & Pick<
                  JobsiteFormSubmission,
                  | 'id'
                  | 'startAt'
                  | 'isStartTimeSpecified'
                  | 'endAt'
                  | 'timeZone'
                  | 'extraData'
                > & {
                    objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                      ObjectHistory,
                      'createdAt'
                    > & {
                        createdBy?: Maybe<
                          { __typename?: 'User' } & Pick<
                            User,
                            'userAccountId'
                          > & {
                              identity?: Maybe<
                                { __typename?: 'UserIdentity' } & Pick<
                                  UserIdentity,
                                  'firstName' | 'lastName'
                                >
                              >;
                              worker?: Maybe<
                                { __typename?: 'Worker' } & Pick<
                                  Worker,
                                  'workerId'
                                > & {
                                    profilePictureCropped?: Maybe<
                                      { __typename?: 'File' } & Pick<
                                        File,
                                        'downloadUrl'
                                      >
                                    >;
                                  }
                              >;
                            }
                        >;
                      };
                    jobsiteForm: { __typename?: 'JobsiteForm' } & Pick<
                      JobsiteForm,
                      'id'
                    > & {
                        jobsite: { __typename?: 'Jobsite' } & Pick<
                          Jobsite,
                          'jobsiteId' | 'name'
                        >;
                        form: { __typename?: 'Form' } & Pick<
                          Form,
                          | 'id'
                          | 'key'
                          | 'name'
                          | 'allowEdit'
                          | 'allowDelete'
                          | 'allowPrintView'
                        >;
                      };
                    jobsiteContractors: {
                      __typename?: 'JobsiteFormSubmissionContractorsConnection';
                    } & {
                      edges: Array<
                        {
                          __typename?: 'JobsiteFormSubmissionContractorsEdge';
                        } & {
                          node: {
                            __typename?: 'JobsiteFormSubmissionContractor';
                          } & Pick<
                            JobsiteFormSubmissionContractor,
                            'id' | 'associationType'
                          > & {
                              jobsiteContractor: {
                                __typename?: 'JobsiteContractor';
                              } & Pick<JobsiteContractor, 'id'> & {
                                  contractor: {
                                    __typename?: 'Contractor';
                                  } & Pick<Contractor, 'contractorId'> & {
                                      organization: {
                                        __typename?: 'Organization';
                                      } & Pick<
                                        Organization,
                                        'organizationId' | 'name'
                                      >;
                                    };
                                };
                            };
                        }
                      >;
                    };
                    jobsiteWorkers: {
                      __typename?: 'JobsiteFormSubmissionWorkersConnection';
                    } & Pick<
                      JobsiteFormSubmissionWorkersConnection,
                      'count'
                    > & {
                        edges: Array<
                          {
                            __typename?: 'JobsiteFormSubmissionWorkersEdge';
                          } & {
                            node: {
                              __typename?: 'JobsiteFormSubmissionWorker';
                            } & Pick<
                              JobsiteFormSubmissionWorker,
                              'id' | 'extraData' | 'associationType'
                            > & {
                                jobsiteWorker: {
                                  __typename?: 'JobsiteWorker';
                                } & Pick<JobsiteWorker, 'jobsiteWorkerId'> & {
                                    activeTempWorkerCard?: Maybe<
                                      { __typename?: 'WorkerCard' } & Pick<
                                        WorkerCard,
                                        | 'workerCardId'
                                        | 'expiredAt'
                                        | 'cardNumber'
                                      > & {
                                          tempBadge?: Maybe<
                                            { __typename?: 'TempBadge' } & Pick<
                                              TempBadge,
                                              'id' | 'name' | 'cardNumber'
                                            >
                                          >;
                                        }
                                    >;
                                    contractorWorker: {
                                      __typename?: 'ContractorWorker';
                                    } & {
                                      worker: { __typename?: 'Worker' } & Pick<
                                        Worker,
                                        'workerId'
                                      > & {
                                          user: { __typename?: 'User' } & Pick<
                                            User,
                                            'userAccountId'
                                          > & {
                                              identity?: Maybe<
                                                {
                                                  __typename?: 'UserIdentity';
                                                } & Pick<
                                                  UserIdentity,
                                                  | 'firstName'
                                                  | 'lastName'
                                                  | 'phoneNumber'
                                                >
                                              >;
                                            };
                                          profilePictureCropped?: Maybe<
                                            { __typename?: 'File' } & Pick<
                                              File,
                                              'downloadUrl'
                                            >
                                          >;
                                        };
                                    };
                                  };
                              };
                          }
                        >;
                      };
                  };
              }
            >;
            filtersOptions?: Maybe<
              { __typename?: 'JobsiteFormSubmissionsFilters' } & {
                forms: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label'
                  >
                >;
                contractors: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label'
                  >
                >;
                createdByUsers: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label'
                  >
                >;
                workers: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label'
                  >
                >;
              }
            >;
          };
      };
    }
  >;
};

export type GetJobsiteFormsQueryVariables = Exact<{
  jobsiteFormsInput?: InputMaybe<UserJobsiteFormsInput>;
}>;

export type GetJobsiteFormsQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & {
        jobsiteForms: { __typename?: 'UserJobsiteFormsConnection' } & {
          edges: Array<
            { __typename?: 'UserJobsiteFormsEdge' } & {
              node: { __typename?: 'JobsiteForm' } & Pick<JobsiteForm, 'id'> & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'jobsiteId' | 'name' | 'timeZone'
                  >;
                };
            }
          >;
        };
      };
    }
  >;
};

export type GetCurrentSessionHomeContainerQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCurrentSessionHomeContainerQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          jobsiteMembers: {
            __typename?: 'UserJobsiteMembersConnection';
          } & Pick<UserJobsiteMembersConnection, 'count'>;
          contractorMembers: {
            __typename?: 'UserContractorMembersConnection';
          } & Pick<UserContractorMembersConnection, 'count'>;
        };
    }
  >;
};

export type JobsiteAddContractorsMutationVariables = Exact<{
  input: JobsiteAddContractorsInput;
}>;

export type JobsiteAddContractorsMutation = { __typename?: 'Mutation' } & {
  jobsiteAddContractors: { __typename?: 'JobsiteAddContractorsPayload' } & {
    jobsiteContractors: Array<
      { __typename?: 'JobsiteContractor' } & Pick<JobsiteContractor, 'id'>
    >;
  };
};

export type JobsiteOffboardContractorMutationVariables = Exact<{
  input: JobsiteOffboardContractorInput;
}>;

export type JobsiteOffboardContractorMutation = { __typename?: 'Mutation' } & {
  jobsiteOffboardContractor: {
    __typename?: 'JobsiteOffboardContractorPayload';
  } & { success: { __typename?: 'Success' } & Pick<Success, 'success'> };
};

export type JobsiteReinstateContractorMutationVariables = Exact<{
  input: JobsiteReinstateContractorInput;
}>;

export type JobsiteReinstateContractorMutation = { __typename?: 'Mutation' } & {
  jobsiteReinstateContractor: {
    __typename?: 'JobsiteReinstateContractorPayload';
  } & { success: { __typename?: 'Success' } & Pick<Success, 'success'> };
};

export type JobsiteRemoveContractorMutationVariables = Exact<{
  input: JobsiteRemoveContractorInput;
}>;

export type JobsiteRemoveContractorMutation = { __typename?: 'Mutation' } & {
  jobsiteRemoveContractor: { __typename?: 'JobsiteRemoveContractorPayload' } & {
    success: { __typename?: 'Success' } & Pick<Success, 'success'>;
  };
};

export type JobsiteUpdateContractorMutationVariables = Exact<{
  input: JobsiteUpdateContractorInput;
}>;

export type JobsiteUpdateContractorMutation = { __typename?: 'Mutation' } & {
  jobsiteUpdateContractor: { __typename?: 'JobsiteUpdateContractorPayload' } & {
    jobsiteContractor: { __typename?: 'JobsiteContractor' } & Pick<
      JobsiteContractor,
      'id'
    >;
  };
};

export type GetContractorsAndJobsitesQueryVariables = Exact<{
  userContractorsInput: UserContractorsInput;
}>;

export type GetContractorsAndJobsitesQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          contractors: { __typename?: 'UserContractorsConnection' } & Pick<
            UserContractorsConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserContractorsEdge' } & {
                  node: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      jobsiteContractors: {
                        __typename?: 'ContractorJobsiteContractorsConnection';
                      } & Pick<
                        ContractorJobsiteContractorsConnection,
                        'count'
                      > & {
                          edges: Array<
                            {
                              __typename?: 'ContractorJobsiteContractorsEdge';
                            } & {
                              node: { __typename?: 'JobsiteContractor' } & Pick<
                                JobsiteContractor,
                                'id' | 'startDate'
                              > & {
                                  contractor: {
                                    __typename?: 'Contractor';
                                  } & Pick<
                                    Contractor,
                                    'contractorId' | 'isDefaultContractor'
                                  > & {
                                      organization: {
                                        __typename?: 'Organization';
                                      } & Pick<
                                        Organization,
                                        'name' | 'slug' | 'legalName'
                                      >;
                                    };
                                };
                            }
                          >;
                        };
                    };
                }
              >;
            };
        };
    }
  >;
};

export type GetJobsiteContainerQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteContainerQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    | 'name'
    | 'jobsiteId'
    | 'jobsiteNumber'
    | 'addressCity'
    | 'addressState'
    | 'addressLine1'
    | 'addressLine2'
    | 'addressZipCode'
    | 'startDate'
    | 'endDate'
    | 'timeZone'
    | 'procoreCompanyId'
    | 'procoreProjectId'
  > & {
      profilePicture?: Maybe<
        { __typename?: 'File' } & Pick<File, 'downloadUrl'>
      >;
      procoreProjectVendors?: Maybe<
        { __typename?: 'ProcoreProjectVendorConnection' } & {
          edges: Array<
            { __typename?: 'ProcoreProjectVendorEdge' } & {
              node: { __typename?: 'ProcoreProjectVendor' } & Pick<
                ProcoreProjectVendor,
                'id' | 'name'
              >;
            }
          >;
        }
      >;
      jobsiteWorkers: { __typename?: 'JobsiteJobsiteWorkersConnection' } & Pick<
        JobsiteJobsiteWorkersConnection,
        'count'
      >;
      jobsiteMembers: { __typename?: 'JobsiteJobsiteMembersConnection' } & Pick<
        JobsiteJobsiteMembersConnection,
        'count'
      >;
      developer?: Maybe<
        { __typename?: 'Developer' } & {
          organization: { __typename?: 'Organization' } & Pick<
            Organization,
            'name'
          >;
        }
      >;
      jobsiteContractors: {
        __typename?: 'JobsiteJobsiteContractorsConnection';
      } & Pick<JobsiteJobsiteContractorsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteJobsiteContractorsEdge' } & {
              node: { __typename?: 'JobsiteContractor' } & Pick<
                JobsiteContractor,
                'id'
              > & {
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name'
                      >;
                    };
                };
            }
          >;
        };
      tempBadges: { __typename?: 'TempBadgesConnection' } & Pick<
        TempBadgesConnection,
        'count'
      >;
      featuresModule?: Maybe<
        { __typename?: 'JobsiteFeaturesModule' } & Pick<
          JobsiteFeaturesModule,
          'schedulingEnabled'
        >
      >;
    };
};

export type GetJobsiteDetailsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteDetailsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'clearanceAssignmentEnabled'
  > & {
      cCureClearances: { __typename?: 'JobsiteCCureClearancesConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteCCureClearancesEdge' } & {
            node: { __typename?: 'CCureClearance' } & Pick<
              CCureClearance,
              | 'cCureClearanceId'
              | 'name'
              | 'cCureClearanceObjectId'
              | 'isDefault'
              | 'isSelectable'
            > & {
                cCureEnvironment: { __typename: 'CCureEnvironment' } & Pick<
                  CCureEnvironment,
                  | 'cCureEnvironmentId'
                  | 'namespace'
                  | 'partitionId'
                  | 'instanceSlug'
                >;
              };
          }
        >;
      };
    };
};

export type GetSiteConnectionsTabQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetSiteConnectionsTabQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      connections: Array<
        { __typename?: 'Connection' } & Pick<Connection, 'id'> & {
            externalEntity: { __typename?: 'ExternalEntity' } & Pick<
              ExternalEntity,
              'type' | 'typeDisplayName' | 'id' | 'name'
            >;
          }
      >;
    };
};

export type GetJobsiteContainerContractorsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteJobsiteContractorsInput?: InputMaybe<JobsiteJobsiteContractorsInput>;
}>;

export type GetJobsiteContainerContractorsQuery = { __typename?: 'Query' } & {
  getProcoreConnectionStatus: { __typename?: 'ProcoreConnectionStatus' } & Pick<
    ProcoreConnectionStatus,
    'connected' | 'procoreUserId'
  >;
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'startDate'
  > & {
      jobsiteContractors: {
        __typename?: 'JobsiteJobsiteContractorsConnection';
      } & Pick<JobsiteJobsiteContractorsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteJobsiteContractorsEdge' } & {
              node: { __typename?: 'JobsiteContractor' } & Pick<
                JobsiteContractor,
                'id' | 'procoreProjectVendorId' | 'startDate' | 'endDate'
              > & {
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name'
                      >;
                    };
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    | 'name'
                    | 'jobsiteId'
                    | 'addressCity'
                    | 'addressState'
                    | 'startDate'
                  > & {
                      developer?: Maybe<
                        { __typename?: 'Developer' } & {
                          organization: { __typename?: 'Organization' } & Pick<
                            Organization,
                            'name'
                          >;
                        }
                      >;
                    };
                  parentJobsiteContractor?: Maybe<
                    { __typename?: 'JobsiteContractor' } & {
                      contractor: { __typename?: 'Contractor' } & Pick<
                        Contractor,
                        'contractorId'
                      > & {
                          organization: { __typename?: 'Organization' } & Pick<
                            Organization,
                            'name'
                          >;
                        };
                    }
                  >;
                  subcontractedJobsiteContractors: {
                    __typename?: 'SubcontractedJobsiteContractorsConnection';
                  } & Pick<
                    SubcontractedJobsiteContractorsConnection,
                    'count'
                  > & {
                      edges: Array<
                        {
                          __typename?: 'SubcontractedJobsiteContractorEdge';
                        } & {
                          node: { __typename?: 'JobsiteContractor' } & {
                            contractor: { __typename?: 'Contractor' } & Pick<
                              Contractor,
                              'contractorId'
                            > & {
                                organization: {
                                  __typename?: 'Organization';
                                } & Pick<Organization, 'name'>;
                              };
                            jobsiteWorkers: {
                              __typename?: 'JobsiteContractorJobsiteWorkersConnection';
                            } & Pick<
                              JobsiteContractorJobsiteWorkersConnection,
                              'count'
                            >;
                          };
                        }
                      >;
                    };
                  contact?: Maybe<
                    { __typename?: 'ContactPerson' } & Pick<
                      ContactPerson,
                      | 'firstName'
                      | 'lastName'
                      | 'phoneNumber'
                      | 'email'
                      | 'title'
                    >
                  >;
                  jobsiteWorkers: {
                    __typename?: 'JobsiteContractorJobsiteWorkersConnection';
                  } & Pick<
                    JobsiteContractorJobsiteWorkersConnection,
                    'count'
                  > & {
                      edges: Array<
                        {
                          __typename?: 'JobsiteContractorJobsiteWorkersEdge';
                        } & {
                          node: { __typename?: 'JobsiteWorker' } & Pick<
                            JobsiteWorker,
                            'jobsiteWorkerId'
                          >;
                        }
                      >;
                    };
                };
            }
          >;
        };
    };
};

export type GetJobsiteContainerEquipmentTabQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  status?: InputMaybe<JobsiteEquipmentStatusType>;
}>;

export type GetJobsiteContainerEquipmentTabQuery = { __typename?: 'Query' } & {
  getJobsiteEquipmentData: {
    __typename?: 'GetJobsiteEquipmentDataResponse';
  } & Pick<GetJobsiteEquipmentDataResponse, 'count'> & {
      results: Array<
        { __typename?: 'JobsiteEquipmentData' } & Pick<
          JobsiteEquipmentData,
          | 'instanceSlug'
          | 'status'
          | 'name'
          | 'description'
          | 'guid'
          | 'type'
          | 'lastOnlineDate'
          | 'lastOfflineDate'
        > & {
            jobsite: { __typename?: 'Jobsite' } & Pick<
              Jobsite,
              'jobsiteId' | 'name'
            >;
          }
      >;
    };
};

export type GetJobsiteContainerEquipmentHistoryTabQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  status?: InputMaybe<JobsiteEquipmentStatusType>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  sortDir?: InputMaybe<OrderByDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetJobsiteContainerEquipmentHistoryTabQuery = {
  __typename?: 'Query';
} & {
  getJobsiteEquipmentHistory: {
    __typename?: 'GetJobsiteEquipmentHistoryResponse';
  } & Pick<GetJobsiteEquipmentHistoryResponse, 'count'> & {
      results: Array<
        { __typename?: 'JobsiteEquipmentEvent' } & Pick<
          JobsiteEquipmentEvent,
          | 'instanceSlug'
          | 'deviceGuid'
          | 'deviceType'
          | 'deviceStatus'
          | 'deviceName'
          | 'deviceDescription'
          | 'jobsiteId'
          | 'eventDate'
        >
      >;
    };
};

export type GetJobsiteContainerJobsiteInfoQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteContainerJobsiteInfoQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    | 'name'
    | 'jobsiteId'
    | 'jobsiteNumber'
    | 'addressCity'
    | 'addressState'
    | 'addressLine1'
    | 'addressLine2'
    | 'addressZipCode'
    | 'startDate'
    | 'endDate'
    | 'latitude'
    | 'longitude'
  > & {
      profilePicture?: Maybe<
        { __typename?: 'File' } & Pick<File, 'downloadUrl'>
      >;
      developer?: Maybe<
        { __typename?: 'Developer' } & {
          organization: { __typename?: 'Organization' } & Pick<
            Organization,
            | 'organizationId'
            | 'name'
            | 'legalName'
            | 'email'
            | 'addressLine1'
            | 'addressLine2'
            | 'addressCity'
            | 'addressState'
            | 'addressZipCode'
          >;
        }
      >;
      defaultJobsiteContractor?: Maybe<
        { __typename?: 'JobsiteContractor' } & Pick<JobsiteContractor, 'id'> & {
            contractor: { __typename?: 'Contractor' } & Pick<
              Contractor,
              'contractorId'
            > & {
                organization: { __typename?: 'Organization' } & Pick<
                  Organization,
                  'organizationId' | 'name'
                >;
              };
            jobsiteInvitation?: Maybe<
              { __typename?: 'JobsiteInvitation' } & Pick<
                JobsiteInvitation,
                'jobsiteInvitationId'
              >
            >;
          }
      >;
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt' | 'updatedAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
          >;
        };
    };
};

export type GetJobsiteOverviewDataQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteFormSubmissionsInput: JobsiteFormSubmissionsInput;
  timeSeriesInput: JobsiteTimeSeriesInput;
  weatherInput: JobsiteWeatherInput;
}>;

export type GetJobsiteOverviewDataQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'timeZone'
  > & {
      jobsiteForms: { __typename?: 'JobsiteFormsConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteFormsEdge' } & {
            node: { __typename?: 'JobsiteForm' } & {
              form: { __typename?: 'Form' } & Pick<Form, 'key'>;
            };
          }
        >;
      };
      jobsiteFormSubmissions: {
        __typename?: 'JobsiteFormSubmissionsConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteFormSubmissionsEdge' } & {
            node: { __typename?: 'JobsiteFormSubmission' } & {
              jobsiteForm: { __typename?: 'JobsiteForm' } & {
                form: { __typename?: 'Form' } & Pick<
                  Form,
                  'id' | 'key' | 'name'
                >;
              };
            };
          }
        >;
      };
      jobsiteStats?: Maybe<
        { __typename?: 'JobsiteStats' } & Pick<
          JobsiteStats,
          | 'numberOfActiveWorkers'
          | 'numberOfActiveContractors'
          | 'numberOfOrientationWorkersInProgress'
          | 'numberOfOrientationWorkersNeedingBadging'
          | 'numberOfOrientationWorkersNeedingMedical'
          | 'numberOfOrientationWorkersCompleted'
          | 'numberOfOnSiteWorkers'
          | 'numberOfOnSiteContractors'
        >
      >;
      timeSeries: { __typename?: 'JobsiteTimeSeries' } & {
        nowBoundedContractorSessions?: Maybe<
          Array<
            { __typename?: 'TimeSeries' } & Pick<
              TimeSeries,
              'dateTime' | 'timeZone' | 'value'
            >
          >
        >;
        nowBoundedSessions?: Maybe<
          Array<
            { __typename?: 'TimeSeries' } & Pick<
              TimeSeries,
              'dateTime' | 'timeZone' | 'value'
            >
          >
        >;
      };
      weather: { __typename?: 'JobsiteWeatherConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteWeatherEntryEdge' } & {
            node: { __typename?: 'JobsiteWeatherEntry' } & Pick<
              JobsiteWeatherEntry,
              'date'
            > & {
                weatherConditions?: Maybe<
                  Array<
                    { __typename?: 'WeatherConditions' } & Pick<
                      WeatherConditions,
                      | 'description'
                      | 'humidity'
                      | 'icon'
                      | 'temp'
                      | 'timestamp'
                      | 'visibility'
                      | 'windDirectionCardinal'
                      | 'windDirectionDegrees'
                      | 'windSpeed'
                    >
                  >
                >;
              };
          }
        >;
      };
    };
};

export type GetJobsitePulseDataQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteAccessEventsInput?: InputMaybe<JobsiteAccessEventsInput>;
  jobsiteFormSubmissionsInput: JobsiteFormSubmissionsInput;
}>;

export type GetJobsitePulseDataQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'timeZone'
  > & {
      jobsiteAccessEvents?: Maybe<
        { __typename?: 'JobsiteAccessEventsConnection' } & {
          edges: Array<
            { __typename?: 'JobsiteAccessEventsEdge' } & {
              node: { __typename?: 'JobsiteAccessEvent' } & Pick<
                JobsiteAccessEvent,
                | 'id'
                | 'type'
                | 'status'
                | 'credentialId'
                | 'eventOccurredAt'
                | 'localizedDate'
                | 'localizedTime'
                | 'timeZone'
                | 'rejectionReason'
                | 'message'
                | 'gateway'
                | 'overnightSession'
                | 'direction'
                | 'externalId'
                | 'eventType'
              > & {
                  zoneCrossing?: Maybe<
                    { __typename?: 'AccessEventCrossing' } & Pick<
                      AccessEventCrossing,
                      | 'kind'
                      | 'revisionId'
                      | 'entryId'
                      | 'entrySideId'
                      | 'reason'
                    > & {
                        from?: Maybe<
                          { __typename?: 'AccessEventEndpoint' } & Pick<
                            AccessEventEndpoint,
                            'kind' | 'zoneId' | 'name'
                          >
                        >;
                        to?: Maybe<
                          { __typename?: 'AccessEventEndpoint' } & Pick<
                            AccessEventEndpoint,
                            'kind' | 'zoneId' | 'name'
                          >
                        >;
                      }
                  >;
                  jobsite?: Maybe<
                    { __typename?: 'Jobsite' } & Pick<
                      Jobsite,
                      'jobsiteId' | 'name'
                    >
                  >;
                  jobsiteWorker?: Maybe<
                    { __typename?: 'JobsiteWorker' } & Pick<
                      JobsiteWorker,
                      'jobsiteWorkerId'
                    > & {
                        jobsiteContractor: {
                          __typename?: 'JobsiteContractor';
                        } & Pick<JobsiteContractor, 'id'> & {
                            contractor: { __typename?: 'Contractor' } & Pick<
                              Contractor,
                              'contractorId'
                            > & {
                                organization: {
                                  __typename?: 'Organization';
                                } & Pick<
                                  Organization,
                                  'organizationId' | 'name'
                                >;
                              };
                          };
                        currentAccess: {
                          __typename?: 'JobsiteWorkerCurrentAccess';
                        } & Pick<JobsiteWorkerCurrentAccess, 'isAllowed'>;
                      }
                  >;
                  worker?: Maybe<
                    { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                        user: { __typename?: 'User' } & Pick<
                          User,
                          'userAccountId'
                        > & {
                            identity?: Maybe<
                              { __typename?: 'UserIdentity' } & Pick<
                                UserIdentity,
                                'firstName' | 'lastName'
                              >
                            >;
                          };
                        profilePictureCropped?: Maybe<
                          { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                        >;
                      }
                  >;
                };
            }
          >;
        }
      >;
      jobsiteFormSubmissions: {
        __typename?: 'JobsiteFormSubmissionsConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteFormSubmissionsEdge' } & {
            node: { __typename?: 'JobsiteFormSubmission' } & Pick<
              JobsiteFormSubmission,
              'id' | 'extraData' | 'startAt'
            > & {
                jobsiteForm: { __typename?: 'JobsiteForm' } & Pick<
                  JobsiteForm,
                  'id'
                > & {
                    form: { __typename?: 'Form' } & Pick<
                      Form,
                      'id' | 'key' | 'name'
                    >;
                  };
              };
          }
        >;
      };
    };
};

export type GetJobsitePulseTimeSeriesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteAccessSessionsInput?: InputMaybe<JobsiteAccessSessionsInput>;
  timeSeriesInput?: InputMaybe<JobsiteTimeSeriesInput>;
  weatherInput?: InputMaybe<JobsiteWeatherInput>;
}>;

export type GetJobsitePulseTimeSeriesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteAccessSessions?: Maybe<
        { __typename?: 'JobsiteAccessSessionsConnection' } & Pick<
          JobsiteAccessSessionsConnection,
          'count'
        >
      >;
      timeSeries: { __typename?: 'JobsiteTimeSeries' } & {
        sessions?: Maybe<
          Array<
            { __typename?: 'TimeSeries' } & Pick<
              TimeSeries,
              'dateTime' | 'timeZone' | 'value'
            >
          >
        >;
      };
      weather: { __typename?: 'JobsiteWeatherConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteWeatherEntryEdge' } & {
            node: { __typename?: 'JobsiteWeatherEntry' } & Pick<
              JobsiteWeatherEntry,
              'date'
            > & {
                weatherConditions?: Maybe<
                  Array<
                    { __typename?: 'WeatherConditions' } & Pick<
                      WeatherConditions,
                      | 'timestamp'
                      | 'description'
                      | 'icon'
                      | 'temp'
                      | 'windSpeed'
                      | 'windDirectionCardinal'
                    >
                  >
                >;
              };
          }
        >;
      };
    };
};

export type GetJobsitePulseVideoFilesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsitePulseVideoFilesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      pulseVideoFiles: Array<
        { __typename?: 'PulseVideoFile' } & {
          videoFile: { __typename?: 'File' } & Pick<File, 'downloadUrl'>;
          thumbnailFiles?: Maybe<
            Array<
              { __typename?: 'CloudFile' } & Pick<
                CloudFile,
                'downloadUrl' | 'fileName'
              >
            >
          >;
        }
      >;
    };
};

export type GetJobsitePulseVideosQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['Date']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
}>;

export type GetJobsitePulseVideosQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      pulseVideos?: Maybe<
        { __typename?: 'PulseVideos' } & Pick<
          PulseVideos,
          'avigilonUrl' | 'sessionToken' | 'hlsBasicAuth'
        > & {
            cameras: Array<
              { __typename?: 'PulseVideoCamera' } & Pick<
                PulseVideoCamera,
                | 'deviceId'
                | 'name'
                | 'oldestRecording'
                | 'setupStatus'
                | 'sources'
              >
            >;
          }
      >;
    };
};

export type ChangeScheduleStatusMutationVariables = Exact<{
  input: ChangeScheduleStatusInput;
}>;

export type ChangeScheduleStatusMutation = { __typename?: 'Mutation' } & {
  changeScheduleStatus: { __typename?: 'ChangeScheduleStatusPayload' } & {
    schedule: { __typename?: 'Schedule' } & Pick<Schedule, 'id' | 'status'>;
  };
};

export type CreateScheduleShiftMutationVariables = Exact<{
  input: CreateScheduleShiftInput;
}>;

export type CreateScheduleShiftMutation = { __typename?: 'Mutation' } & {
  createScheduleShift: { __typename?: 'CreateScheduleShiftPayload' } & {
    scheduleShift: { __typename?: 'ScheduleShift' } & Pick<
      ScheduleShift,
      'id' | 'duration' | 'startTime'
    >;
  };
};

export type CreateScheduleWorkerMutationVariables = Exact<{
  input: CreateScheduleWorkerInput;
}>;

export type CreateScheduleWorkerMutation = { __typename?: 'Mutation' } & {
  createScheduleWorker: { __typename?: 'CreateScheduleWorkerPayload' } & {
    scheduleWorker: { __typename?: 'ScheduleWorker' } & Pick<
      ScheduleWorker,
      'id'
    >;
  };
};

export type DeleteScheduleShiftMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteScheduleShiftMutation = { __typename?: 'Mutation' } & {
  deleteScheduleShift: { __typename?: 'DeleteScheduleShiftPayload' } & {
    success: { __typename?: 'Success' } & Pick<Success, 'success'>;
  };
};

export type DeleteScheduleWorkerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteScheduleWorkerMutation = { __typename?: 'Mutation' } & {
  deleteScheduleWorker: { __typename?: 'DeleteScheduleWorkerPayload' } & {
    success: { __typename?: 'Success' } & Pick<Success, 'success'>;
  };
};

export type SendScheduleNotificationsMutationVariables = Exact<{
  input: SendScheduleNotificationsInput;
}>;

export type SendScheduleNotificationsMutation = { __typename?: 'Mutation' } & {
  sendScheduleNotifications: {
    __typename?: 'SendScheduleNotificationsPayload';
  } & { schedule: { __typename?: 'Schedule' } & Pick<Schedule, 'id'> };
};

export type UpdateScheduleShiftMutationVariables = Exact<{
  input: UpdateScheduleShiftInput;
}>;

export type UpdateScheduleShiftMutation = { __typename?: 'Mutation' } & {
  updateScheduleShift: { __typename?: 'UpdateScheduleShiftPayload' } & {
    scheduleShift: { __typename?: 'ScheduleShift' } & Pick<ScheduleShift, 'id'>;
  };
};

export type UpdateScheduleWorkerMutationVariables = Exact<{
  input: UpdateScheduleWorkerInput;
}>;

export type UpdateScheduleWorkerMutation = { __typename?: 'Mutation' } & {
  updateScheduleWorker: { __typename?: 'UpdateScheduleWorkerPayload' } & {
    scheduleWorker: { __typename?: 'ScheduleWorker' } & Pick<
      ScheduleWorker,
      'id'
    >;
  };
};

export type GetScheduleDetailsQueryVariables = Exact<{
  scheduleInput: ScheduleInput;
  attendanceInput?: InputMaybe<ScheduleAttendanceFilterInput>;
}>;

export type GetScheduleDetailsQuery = { __typename?: 'Query' } & {
  getSchedule?: Maybe<
    { __typename?: 'Schedule' } & Pick<
      Schedule,
      'id' | 'date' | 'status' | 'notifiedAt'
    > & {
        jobsite: { __typename?: 'Jobsite' } & Pick<
          Jobsite,
          'jobsiteId' | 'name' | 'tradeOptions' | 'activityCodeOptions'
        > & {
            developer?: Maybe<
              { __typename?: 'Developer' } & Pick<Developer, 'developerId'> & {
                  organization: { __typename?: 'Organization' } & Pick<
                    Organization,
                    'organizationId' | 'name'
                  >;
                }
            >;
          };
        shifts: Array<
          { __typename?: 'ScheduleShift' } & Pick<
            ScheduleShift,
            'id' | 'startTime' | 'duration'
          > & {
              workers: { __typename?: 'ScheduleWorkersConnection' } & Pick<
                ScheduleWorkersConnection,
                'count'
              > & {
                  edges: Array<
                    { __typename?: 'ScheduleWorkerEdge' } & {
                      node?: Maybe<
                        { __typename?: 'ScheduleWorker' } & Pick<
                          ScheduleWorker,
                          | 'id'
                          | 'quantity'
                          | 'type'
                          | 'trade'
                          | 'activity'
                          | 'notes'
                        > & {
                            jobsiteContractor: {
                              __typename?: 'JobsiteContractor';
                            } & Pick<JobsiteContractor, 'id'> & {
                                contractor: {
                                  __typename?: 'Contractor';
                                } & Pick<Contractor, 'contractorId'> & {
                                    organization: {
                                      __typename?: 'Organization';
                                    } & Pick<
                                      Organization,
                                      'organizationId' | 'legalName' | 'name'
                                    >;
                                  };
                              };
                            jobsiteWorker?: Maybe<
                              { __typename?: 'JobsiteWorker' } & Pick<
                                JobsiteWorker,
                                'jobsiteWorkerId' | 'trade'
                              > & {
                                  contractorWorker: {
                                    __typename?: 'ContractorWorker';
                                  } & Pick<ContractorWorker, 'id'> & {
                                      worker: { __typename?: 'Worker' } & Pick<
                                        Worker,
                                        'workerId'
                                      > & {
                                          profilePictureCropped?: Maybe<
                                            { __typename?: 'File' } & Pick<
                                              File,
                                              'downloadUrl'
                                            >
                                          >;
                                          user: { __typename?: 'User' } & Pick<
                                            User,
                                            'userAccountId'
                                          > & {
                                              identity?: Maybe<
                                                {
                                                  __typename?: 'UserIdentity';
                                                } & Pick<
                                                  UserIdentity,
                                                  'firstName' | 'lastName'
                                                >
                                              >;
                                            };
                                        };
                                    };
                                }
                            >;
                          }
                      >;
                    }
                  >;
                };
              attendance: {
                __typename?: 'ScheduleAttendanceConnection';
              } & Pick<ScheduleAttendanceConnection, 'count'> & {
                  edges: Array<
                    { __typename?: 'ScheduleAttendanceEntryEdge' } & {
                      node?: Maybe<
                        { __typename?: 'ScheduleAttendanceEntry' } & Pick<
                          ScheduleAttendanceEntry,
                          'id' | 'status'
                        > & {
                            jobsiteContractor: {
                              __typename?: 'JobsiteContractor';
                            } & Pick<JobsiteContractor, 'id'> & {
                                contractor: {
                                  __typename?: 'Contractor';
                                } & Pick<Contractor, 'contractorId'> & {
                                    organization: {
                                      __typename?: 'Organization';
                                    } & Pick<
                                      Organization,
                                      'organizationId' | 'legalName' | 'name'
                                    >;
                                  };
                              };
                            jobsiteWorker?: Maybe<
                              { __typename?: 'JobsiteWorker' } & Pick<
                                JobsiteWorker,
                                'jobsiteWorkerId' | 'trade'
                              > & {
                                  contractorWorker: {
                                    __typename?: 'ContractorWorker';
                                  } & Pick<ContractorWorker, 'id'> & {
                                      worker: { __typename?: 'Worker' } & Pick<
                                        Worker,
                                        'workerId'
                                      > & {
                                          profilePictureCropped?: Maybe<
                                            { __typename?: 'File' } & Pick<
                                              File,
                                              'downloadUrl'
                                            >
                                          >;
                                          user: { __typename?: 'User' } & Pick<
                                            User,
                                            'userAccountId'
                                          > & {
                                              identity?: Maybe<
                                                {
                                                  __typename?: 'UserIdentity';
                                                } & Pick<
                                                  UserIdentity,
                                                  'firstName' | 'lastName'
                                                >
                                              >;
                                            };
                                        };
                                    };
                                }
                            >;
                            scheduleWorker?: Maybe<
                              { __typename?: 'ScheduleWorker' } & Pick<
                                ScheduleWorker,
                                'id' | 'trade' | 'activity' | 'notes'
                              > & {
                                  jobsiteContractor: {
                                    __typename?: 'JobsiteContractor';
                                  } & Pick<JobsiteContractor, 'id'> & {
                                      contractor: {
                                        __typename?: 'Contractor';
                                      } & Pick<Contractor, 'contractorId'> & {
                                          organization: {
                                            __typename?: 'Organization';
                                          } & Pick<
                                            Organization,
                                            | 'organizationId'
                                            | 'legalName'
                                            | 'name'
                                          >;
                                        };
                                    };
                                  jobsiteWorker?: Maybe<
                                    { __typename?: 'JobsiteWorker' } & Pick<
                                      JobsiteWorker,
                                      'jobsiteWorkerId' | 'trade'
                                    > & {
                                        contractorWorker: {
                                          __typename?: 'ContractorWorker';
                                        } & Pick<ContractorWorker, 'id'> & {
                                            worker: {
                                              __typename?: 'Worker';
                                            } & Pick<Worker, 'workerId'> & {
                                                profilePictureCropped?: Maybe<
                                                  {
                                                    __typename?: 'File';
                                                  } & Pick<File, 'downloadUrl'>
                                                >;
                                                user: {
                                                  __typename?: 'User';
                                                } & Pick<
                                                  User,
                                                  'userAccountId'
                                                > & {
                                                    identity?: Maybe<
                                                      {
                                                        __typename?: 'UserIdentity';
                                                      } & Pick<
                                                        UserIdentity,
                                                        'firstName' | 'lastName'
                                                      >
                                                    >;
                                                  };
                                              };
                                          };
                                      }
                                  >;
                                }
                            >;
                            session?: Maybe<
                              { __typename?: 'JobsiteAccessSession' } & Pick<
                                JobsiteAccessSession,
                                'sessionId'
                              > & {
                                  proximitySession: {
                                    __typename?: 'ProximitySessionResult';
                                  } & Pick<
                                    ProximitySessionResult,
                                    'id' | 'active' | 'compliant' | 'closed'
                                  > & {
                                      locale?: Maybe<
                                        {
                                          __typename?: 'ProximitySessionLocaleData';
                                        } & {
                                          time?: Maybe<
                                            {
                                              __typename?: 'ProximitySessionLocaleTimeData';
                                            } & Pick<
                                              ProximitySessionLocaleTimeData,
                                              'start' | 'end'
                                            >
                                          >;
                                        }
                                      >;
                                      span?: Maybe<
                                        {
                                          __typename?: 'ProximitySessionSpanData';
                                        } & Pick<
                                          ProximitySessionSpanData,
                                          'hours'
                                        >
                                      >;
                                    };
                                }
                            >;
                          }
                      >;
                    }
                  >;
                };
            }
        >;
      }
  >;
};

export type ScheduleJobsiteContractorFieldFragment = {
  __typename?: 'JobsiteContractor';
} & Pick<JobsiteContractor, 'id'> & {
    contractor: { __typename?: 'Contractor' } & Pick<
      Contractor,
      'contractorId'
    > & {
        organization: { __typename?: 'Organization' } & Pick<
          Organization,
          'organizationId' | 'legalName' | 'name'
        >;
      };
  };

export type ScheduleJobsiteWorkerFieldFragment = {
  __typename?: 'JobsiteWorker';
} & Pick<JobsiteWorker, 'jobsiteWorkerId' | 'trade'> & {
    contractorWorker: { __typename?: 'ContractorWorker' } & Pick<
      ContractorWorker,
      'id'
    > & {
        worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
            profilePictureCropped?: Maybe<
              { __typename?: 'File' } & Pick<File, 'downloadUrl'>
            >;
            user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName'
                  >
                >;
              };
          };
      };
  };

export type GetScheduleNotificationPreviewQueryVariables = Exact<{
  scheduleId: Scalars['ID']['input'];
}>;

export type GetScheduleNotificationPreviewQuery = { __typename?: 'Query' } & {
  getScheduleNotificationPreview: Array<
    { __typename?: 'ScheduleNotificationPreview' } & Pick<
      ScheduleNotificationPreview,
      'body' | 'subject' | 'recipient' | 'to'
    >
  >;
};

export type GetJobsiteContainerTempBadgesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteTempBadgesInput?: InputMaybe<TempBadgesInput>;
}>;

export type GetJobsiteContainerTempBadgesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      tempBadges: { __typename?: 'TempBadgesConnection' } & Pick<
        TempBadgesConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'TempBadgeEdge' } & {
              node?: Maybe<
                { __typename?: 'TempBadge' } & Pick<
                  TempBadge,
                  'id' | 'name' | 'cardNumber' | 'status'
                > & {
                    badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
                      BadgeTemplate,
                      'templateName'
                    >;
                    jobsiteCardFormat?: Maybe<
                      { __typename?: 'JobsiteCardFormat' } & Pick<
                        JobsiteCardFormat,
                        'jobsiteCardFormatId'
                      > & {
                          workerCardFormat: {
                            __typename?: 'WorkerCardFormat';
                          } & Pick<
                            WorkerCardFormat,
                            | 'workerCardFormatId'
                            | 'name'
                            | 'description'
                            | 'cardType'
                            | 'facilityCode'
                          >;
                        }
                    >;
                    activeWorkerCard?: Maybe<
                      { __typename?: 'WorkerCard' } & Pick<
                        WorkerCard,
                        'workerCardId' | 'expiredAt'
                      > & {
                          worker: { __typename?: 'Worker' } & Pick<
                            Worker,
                            'workerId' | 'quickCode'
                          > & {
                              user: { __typename?: 'User' } & Pick<
                                User,
                                'userAccountId'
                              > & {
                                  identity?: Maybe<
                                    { __typename?: 'UserIdentity' } & Pick<
                                      UserIdentity,
                                      'firstName' | 'lastName'
                                    >
                                  >;
                                };
                              profilePictureCropped?: Maybe<
                                { __typename?: 'File' } & Pick<
                                  File,
                                  | 'downloadUrl'
                                  | 'uploadedAt'
                                  | 'fileId'
                                  | 'fileType'
                                >
                              >;
                            };
                        }
                    >;
                    lastPrintJob?: Maybe<
                      { __typename?: 'CardPrintJob' } & Pick<
                        CardPrintJob,
                        | 'cardPrintJobId'
                        | 'startedAt'
                        | 'status'
                        | 'statusMessage'
                      > & {
                          completion?: Maybe<
                            { __typename?: 'CardPrintJobCompletion' } & Pick<
                              CardPrintJobCompletion,
                              'cardNumber' | 'facilityCode' | 'completedAt'
                            >
                          >;
                          error?: Maybe<
                            { __typename?: 'CardPrintJobError' } & Pick<
                              CardPrintJobError,
                              'code' | 'erroredAt' | 'message'
                            >
                          >;
                        }
                    >;
                  }
              >;
            }
          >;
        };
    };
};

export type DeactivateTempBadgeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeactivateTempBadgeMutation = { __typename?: 'Mutation' } & {
  deactivateTempBadge: { __typename?: 'TempBadgePayload' } & {
    tempBadge: { __typename?: 'TempBadge' } & Pick<
      TempBadge,
      'id' | 'name' | 'cardNumber' | 'status'
    > & {
        jobsiteCardFormat?: Maybe<
          { __typename?: 'JobsiteCardFormat' } & Pick<
            JobsiteCardFormat,
            'jobsiteCardFormatId'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                | 'workerCardFormatId'
                | 'name'
                | 'description'
                | 'cardType'
                | 'facilityCode'
              >;
            }
        >;
      };
  };
};

export type ReturnTempBadgeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ReturnTempBadgeMutation = { __typename?: 'Mutation' } & {
  returnTempBadge: { __typename?: 'TempBadgePayload' } & {
    tempBadge: { __typename?: 'TempBadge' } & Pick<
      TempBadge,
      'id' | 'name' | 'cardNumber' | 'status'
    > & {
        jobsiteCardFormat?: Maybe<
          { __typename?: 'JobsiteCardFormat' } & Pick<
            JobsiteCardFormat,
            'jobsiteCardFormatId'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                | 'workerCardFormatId'
                | 'name'
                | 'description'
                | 'cardType'
                | 'facilityCode'
              >;
            }
        >;
      };
  };
};

export type AssignTempBadgeMutationVariables = Exact<{
  input: AssignTempBadgeInput;
}>;

export type AssignTempBadgeMutation = { __typename?: 'Mutation' } & {
  assignTempBadge: { __typename?: 'TempBadgePayload' } & {
    tempBadge: { __typename?: 'TempBadge' } & Pick<
      TempBadge,
      'id' | 'name' | 'cardNumber' | 'status'
    > & {
        badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
          BadgeTemplate,
          'templateName'
        >;
        jobsiteCardFormat?: Maybe<
          { __typename?: 'JobsiteCardFormat' } & Pick<
            JobsiteCardFormat,
            'jobsiteCardFormatId'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                | 'workerCardFormatId'
                | 'name'
                | 'description'
                | 'cardType'
                | 'facilityCode'
              >;
            }
        >;
      };
  };
};

export type CreateAndPrintTempBadgeMutationVariables = Exact<{
  input: CreateTempBadgeInput;
}>;

export type CreateAndPrintTempBadgeMutation = { __typename?: 'Mutation' } & {
  createAndPrintTempBadge: { __typename?: 'TempBadgePayload' } & {
    tempBadge: { __typename?: 'TempBadge' } & Pick<
      TempBadge,
      'id' | 'name' | 'cardNumber' | 'status'
    > & {
        badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
          BadgeTemplate,
          'templateName'
        >;
        jobsiteCardFormat?: Maybe<
          { __typename?: 'JobsiteCardFormat' } & Pick<
            JobsiteCardFormat,
            'jobsiteCardFormatId'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                | 'workerCardFormatId'
                | 'name'
                | 'description'
                | 'cardType'
                | 'facilityCode'
              >;
            }
        >;
        lastPrintJob?: Maybe<
          { __typename?: 'CardPrintJob' } & Pick<
            CardPrintJob,
            'cardPrintJobId' | 'startedAt' | 'status' | 'statusMessage'
          > & {
              completion?: Maybe<
                { __typename?: 'CardPrintJobCompletion' } & Pick<
                  CardPrintJobCompletion,
                  'cardNumber' | 'facilityCode' | 'completedAt'
                >
              >;
              error?: Maybe<
                { __typename?: 'CardPrintJobError' } & Pick<
                  CardPrintJobError,
                  'code' | 'erroredAt' | 'message'
                >
              >;
            }
        >;
      };
  };
};

export type GetPrintingTempBadgeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPrintingTempBadgeQuery = { __typename?: 'Query' } & {
  getTempBadge: { __typename?: 'TempBadge' } & Pick<
    TempBadge,
    'id' | 'name' | 'cardNumber' | 'status'
  > & {
      badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
        BadgeTemplate,
        'templateName'
      >;
      jobsiteCardFormat?: Maybe<
        { __typename?: 'JobsiteCardFormat' } & Pick<
          JobsiteCardFormat,
          'jobsiteCardFormatId'
        > & {
            workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
              WorkerCardFormat,
              | 'workerCardFormatId'
              | 'name'
              | 'description'
              | 'cardType'
              | 'facilityCode'
            >;
          }
      >;
      activeWorkerCard?: Maybe<
        { __typename?: 'WorkerCard' } & Pick<
          WorkerCard,
          'workerCardId' | 'expiredAt'
        > & {
            worker: { __typename?: 'Worker' } & Pick<
              Worker,
              'workerId' | 'quickCode'
            > & {
                user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName'
                      >
                    >;
                  };
                profilePictureCropped?: Maybe<
                  { __typename?: 'File' } & Pick<
                    File,
                    'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                  >
                >;
              };
          }
      >;
      lastPrintJob?: Maybe<
        { __typename?: 'CardPrintJob' } & Pick<
          CardPrintJob,
          'cardPrintJobId' | 'startedAt' | 'status' | 'statusMessage'
        > & {
            completion?: Maybe<
              { __typename?: 'CardPrintJobCompletion' } & Pick<
                CardPrintJobCompletion,
                'cardNumber' | 'facilityCode' | 'completedAt'
              >
            >;
            error?: Maybe<
              { __typename?: 'CardPrintJobError' } & Pick<
                CardPrintJobError,
                'code' | 'erroredAt' | 'message'
              >
            >;
          }
      >;
    };
};

export type ReprintTempBadgeMutationVariables = Exact<{
  input: ReprintTempBadgeInput;
}>;

export type ReprintTempBadgeMutation = { __typename?: 'Mutation' } & {
  reprintTempBadge: { __typename?: 'TempBadgePayload' } & {
    tempBadge: { __typename?: 'TempBadge' } & Pick<
      TempBadge,
      'id' | 'name' | 'cardNumber' | 'status'
    > & {
        badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
          BadgeTemplate,
          'templateName'
        >;
        jobsiteCardFormat?: Maybe<
          { __typename?: 'JobsiteCardFormat' } & Pick<
            JobsiteCardFormat,
            'jobsiteCardFormatId'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                | 'workerCardFormatId'
                | 'name'
                | 'description'
                | 'cardType'
                | 'facilityCode'
              >;
            }
        >;
        lastPrintJob?: Maybe<
          { __typename?: 'CardPrintJob' } & Pick<
            CardPrintJob,
            'cardPrintJobId' | 'startedAt' | 'status' | 'statusMessage'
          > & {
              completion?: Maybe<
                { __typename?: 'CardPrintJobCompletion' } & Pick<
                  CardPrintJobCompletion,
                  'cardNumber' | 'facilityCode' | 'completedAt'
                >
              >;
              error?: Maybe<
                { __typename?: 'CardPrintJobError' } & Pick<
                  CardPrintJobError,
                  'code' | 'erroredAt' | 'message'
                >
              >;
            }
        >;
      };
  };
};

export type ReactivateTempBadgeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ReactivateTempBadgeMutation = { __typename?: 'Mutation' } & {
  reactivateTempBadge: { __typename?: 'TempBadgePayload' } & {
    tempBadge: { __typename?: 'TempBadge' } & Pick<
      TempBadge,
      'id' | 'name' | 'cardNumber' | 'status'
    > & {
        badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
          BadgeTemplate,
          'templateName'
        >;
        jobsiteCardFormat?: Maybe<
          { __typename?: 'JobsiteCardFormat' } & Pick<
            JobsiteCardFormat,
            'jobsiteCardFormatId'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                | 'workerCardFormatId'
                | 'name'
                | 'description'
                | 'cardType'
                | 'facilityCode'
              >;
            }
        >;
      };
  };
};

export type RegisterTempBadgeMutationVariables = Exact<{
  input: RegisterTempBadgeInput;
}>;

export type RegisterTempBadgeMutation = { __typename?: 'Mutation' } & {
  registerTempBadge: { __typename?: 'TempBadgePayload' } & {
    tempBadge: { __typename?: 'TempBadge' } & Pick<
      TempBadge,
      'id' | 'name' | 'cardNumber' | 'status'
    > & {
        badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
          BadgeTemplate,
          'templateName'
        >;
        jobsiteCardFormat?: Maybe<
          { __typename?: 'JobsiteCardFormat' } & Pick<
            JobsiteCardFormat,
            'jobsiteCardFormatId'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                | 'workerCardFormatId'
                | 'name'
                | 'description'
                | 'cardType'
                | 'facilityCode'
              >;
            }
        >;
      };
  };
};

export type GetJobsiteContainerMembersQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteJobsiteMembersInput?: InputMaybe<JobsiteJobsiteMembersInput>;
  userRolesInput?: InputMaybe<UserRolesInput>;
}>;

export type GetJobsiteContainerMembersQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteMembers: { __typename?: 'JobsiteJobsiteMembersConnection' } & Pick<
        JobsiteJobsiteMembersConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'JobsiteJobsiteMembersEdge' } & {
              node: { __typename?: 'JobsiteMember' } & Pick<
                JobsiteMember,
                'id'
              > & {
                  user: { __typename?: 'User' } & Pick<
                    User,
                    'userAccountId'
                  > & {
                      roles: Array<
                        { __typename?: 'UserRole' } & Pick<
                          UserRole,
                          'key' | 'displayName'
                        > & {
                            object?: Maybe<
                              { __typename?: 'UserRoleObject' } & Pick<
                                UserRoleObject,
                                'objectId'
                              > & {
                                  objectDetails?: Maybe<
                                    {
                                      __typename?: 'UserRoleObjectDetails';
                                    } & Pick<UserRoleObjectDetails, 'name'>
                                  >;
                                }
                            >;
                          }
                      >;
                      identity?: Maybe<
                        { __typename?: 'UserIdentity' } & Pick<
                          UserIdentity,
                          'firstName' | 'lastName' | 'email' | 'phoneNumber'
                        >
                      >;
                      worker?: Maybe<
                        { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                            profilePictureCropped?: Maybe<
                              { __typename?: 'File' } & Pick<
                                File,
                                'downloadUrl'
                              >
                            >;
                          }
                      >;
                      lastSession?: Maybe<
                        { __typename?: 'UserSession' } & Pick<
                          UserSession,
                          'createdAt' | 'appVersion'
                        >
                      >;
                    };
                };
            }
          >;
        };
    };
};

export type GetJobsiteContainerWorkersQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteJobsiteWorkersInput?: InputMaybe<JobsiteJobsiteWorkersInput>;
}>;

export type GetJobsiteContainerWorkersQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteWorkers: { __typename?: 'JobsiteJobsiteWorkersConnection' } & Pick<
        JobsiteJobsiteWorkersConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'JobsiteJobsiteWorkersEdge' } & {
              node: { __typename?: 'JobsiteWorker' } & Pick<
                JobsiteWorker,
                'jobsiteWorkerId'
              > & {
                  currentAccess: {
                    __typename?: 'JobsiteWorkerCurrentAccess';
                  } & Pick<
                    JobsiteWorkerCurrentAccess,
                    'isAllowed' | 'notAllowedReason' | 'startDate' | 'endDate'
                  >;
                  contractorWorker: { __typename?: 'ContractorWorker' } & {
                    worker: { __typename?: 'Worker' } & Pick<
                      Worker,
                      'workerId' | 'birthDate' | 'quickCode'
                    > & {
                        user: { __typename?: 'User' } & Pick<
                          User,
                          'userAccountId'
                        > & {
                            identity?: Maybe<
                              { __typename?: 'UserIdentity' } & Pick<
                                UserIdentity,
                                'firstName' | 'lastName' | 'email'
                              >
                            >;
                          };
                        profilePicture?: Maybe<
                          { __typename?: 'File' } & Pick<
                            File,
                            'downloadUrl' | 'uploadedAt' | 'fileId'
                          >
                        >;
                        profilePictureCropped?: Maybe<
                          { __typename?: 'File' } & Pick<
                            File,
                            'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                          >
                        >;
                        workerCards: {
                          __typename?: 'WorkerWorkerCardsConnection';
                        } & {
                          edges: Array<
                            { __typename?: 'WorkerWorkerCardsEdge' } & {
                              node: { __typename?: 'WorkerCard' } & Pick<
                                WorkerCard,
                                'workerCardId' | 'cardNumber' | 'cardStatus'
                              >;
                            }
                          >;
                        };
                        jobsiteWorkers: {
                          __typename?: 'WorkerJobsiteWorkersConnection';
                        } & Pick<WorkerJobsiteWorkersConnection, 'count'> & {
                            edges: Array<
                              { __typename?: 'WorkerJobsiteWorkersEdge' } & {
                                node: { __typename?: 'JobsiteWorker' } & Pick<
                                  JobsiteWorker,
                                  'jobsiteWorkerId' | 'trade'
                                > & {
                                    jobsiteContractor: {
                                      __typename?: 'JobsiteContractor';
                                    } & {
                                      jobsite: {
                                        __typename?: 'Jobsite';
                                      } & Pick<Jobsite, 'jobsiteId' | 'name'>;
                                      contractor: {
                                        __typename?: 'Contractor';
                                      } & Pick<Contractor, 'contractorId'> & {
                                          organization: {
                                            __typename?: 'Organization';
                                          } & Pick<Organization, 'name'>;
                                        };
                                    };
                                    currentAccess: {
                                      __typename?: 'JobsiteWorkerCurrentAccess';
                                    } & Pick<
                                      JobsiteWorkerCurrentAccess,
                                      | 'isAllowed'
                                      | 'notAllowedReason'
                                      | 'startDate'
                                      | 'endDate'
                                    >;
                                  };
                              }
                            >;
                          };
                      };
                  };
                };
            }
          >;
        };
    };
};

export type GetJobsiteAccessActivityCurrentSessionQueryVariables = Exact<{
  jobsiteAccessEventsInput?: InputMaybe<JobsiteAccessEventsInput>;
}>;

export type GetJobsiteAccessActivityCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          jobsiteAccessEvents?: Maybe<
            { __typename?: 'JobsiteAccessEventsConnection' } & Pick<
              JobsiteAccessEventsConnection,
              'count'
            > & {
                edges: Array<
                  { __typename?: 'JobsiteAccessEventsEdge' } & {
                    node: { __typename?: 'JobsiteAccessEvent' } & Pick<
                      JobsiteAccessEvent,
                      | 'id'
                      | 'type'
                      | 'status'
                      | 'credentialId'
                      | 'eventOccurredAt'
                      | 'localizedDate'
                      | 'localizedTime'
                      | 'timeZone'
                      | 'rejectionReason'
                      | 'message'
                      | 'gateway'
                      | 'overnightSession'
                      | 'direction'
                      | 'externalId'
                      | 'eventType'
                    > & {
                        zoneCrossing?: Maybe<
                          { __typename?: 'AccessEventCrossing' } & Pick<
                            AccessEventCrossing,
                            | 'kind'
                            | 'revisionId'
                            | 'entryId'
                            | 'entrySideId'
                            | 'reason'
                          > & {
                              from?: Maybe<
                                { __typename?: 'AccessEventEndpoint' } & Pick<
                                  AccessEventEndpoint,
                                  'kind' | 'zoneId' | 'name'
                                >
                              >;
                              to?: Maybe<
                                { __typename?: 'AccessEventEndpoint' } & Pick<
                                  AccessEventEndpoint,
                                  'kind' | 'zoneId' | 'name'
                                >
                              >;
                            }
                        >;
                        jobsite?: Maybe<
                          { __typename?: 'Jobsite' } & Pick<
                            Jobsite,
                            'jobsiteId' | 'name'
                          >
                        >;
                        jobsiteWorker?: Maybe<
                          { __typename?: 'JobsiteWorker' } & Pick<
                            JobsiteWorker,
                            'jobsiteWorkerId'
                          > & {
                              jobsiteContractor: {
                                __typename?: 'JobsiteContractor';
                              } & Pick<JobsiteContractor, 'id'> & {
                                  contractor: {
                                    __typename?: 'Contractor';
                                  } & Pick<Contractor, 'contractorId'> & {
                                      organization: {
                                        __typename?: 'Organization';
                                      } & Pick<
                                        Organization,
                                        'organizationId' | 'name'
                                      >;
                                    };
                                };
                              currentAccess: {
                                __typename?: 'JobsiteWorkerCurrentAccess';
                              } & Pick<JobsiteWorkerCurrentAccess, 'isAllowed'>;
                            }
                        >;
                        worker?: Maybe<
                          { __typename?: 'Worker' } & Pick<
                            Worker,
                            'workerId'
                          > & {
                              user: { __typename?: 'User' } & Pick<
                                User,
                                'userAccountId'
                              > & {
                                  identity?: Maybe<
                                    { __typename?: 'UserIdentity' } & Pick<
                                      UserIdentity,
                                      'firstName' | 'lastName'
                                    >
                                  >;
                                };
                              profilePictureCropped?: Maybe<
                                { __typename?: 'File' } & Pick<
                                  File,
                                  'downloadUrl'
                                >
                              >;
                            }
                        >;
                      };
                  }
                >;
                filtersOptions?: Maybe<
                  { __typename?: 'JobsiteAccessEventsFilters' } & {
                    jobsites: Array<
                      { __typename?: 'FilterOption' } & Pick<
                        FilterOption,
                        'value' | 'label' | 'count'
                      >
                    >;
                    contractors: Array<
                      { __typename?: 'FilterOption' } & Pick<
                        FilterOption,
                        'value' | 'label' | 'count'
                      >
                    >;
                    zones: Array<
                      { __typename?: 'FilterOption' } & Pick<
                        FilterOption,
                        'value' | 'label'
                      >
                    >;
                    gateways: Array<
                      { __typename?: 'FilterOption' } & Pick<
                        FilterOption,
                        'value' | 'label' | 'count'
                      >
                    >;
                    rejectionReasons: Array<
                      Maybe<
                        { __typename?: 'FilterOption' } & Pick<
                          FilterOption,
                          'value' | 'label' | 'count'
                        >
                      >
                    >;
                    locationStatuses: Array<
                      Maybe<
                        { __typename?: 'FilterOption' } & Pick<
                          FilterOption,
                          'value' | 'label' | 'count'
                        >
                      >
                    >;
                  }
                >;
              }
          >;
        };
    }
  >;
};

export type ArchiveJobsiteMutationVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type ArchiveJobsiteMutation = { __typename?: 'Mutation' } & {
  archiveJobsite: { __typename?: 'Success' } & Pick<Success, 'success'>;
};

export type JobsiteUpdateMutationVariables = Exact<{
  input: JobsiteUpdateInput;
}>;

export type JobsiteUpdateMutation = { __typename?: 'Mutation' } & {
  jobsiteUpdate: { __typename?: 'JobsiteUpdatePayload' } & {
    jobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'>;
  };
};

export type GetJobsiteConfigAvigilonQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigAvigilonQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'avigilonEnabled' | 'avigilonCameraEnabled'
  > & {
      connectors: Array<
        | ({ __typename?: 'AvigilonAccessConnector' } & Pick<
            AvigilonAccessConnector,
            'type' | 'connectedAt'
          >)
        | ({ __typename?: 'AvigilonVideoConnector' } & Pick<
            AvigilonVideoConnector,
            'type' | 'connectedAt'
          >)
      >;
    };
};

export type GetJobsiteConfigCCureQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigCCureQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name'
  > & {
      cCureClearances: { __typename?: 'JobsiteCCureClearancesConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteCCureClearancesEdge' } & {
            node: { __typename?: 'CCureClearance' } & Pick<
              CCureClearance,
              | 'cCureClearanceId'
              | 'name'
              | 'cCureClearanceObjectId'
              | 'isDefault'
              | 'isSelectable'
            > & {
                cCureEnvironment: { __typename?: 'CCureEnvironment' } & Pick<
                  CCureEnvironment,
                  'cCureEnvironmentId' | 'namespace'
                >;
              };
          }
        >;
      };
      cCureEntityMappings: {
        __typename?: 'JobsiteCCureEntityMappingsConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteCCureEntityMappingsEdge' } & {
            node: { __typename?: 'CCureEntityMapping' } & Pick<
              CCureEntityMapping,
              'objectId' | 'entityType'
            > & {
                cCureEnvironment: { __typename?: 'CCureEnvironment' } & Pick<
                  CCureEnvironment,
                  'cCureEnvironmentId' | 'namespace'
                >;
              };
          }
        >;
      };
      jobsiteCardFormats: { __typename?: 'JobsiteCardFormatsConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteCardFormatsEdge' } & {
            node: { __typename?: 'JobsiteCardFormat' } & Pick<
              JobsiteCardFormat,
              'jobsiteCardFormatId' | 'isDefaultForCardType'
            > & {
                workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                  WorkerCardFormat,
                  'workerCardFormatId'
                >;
              };
          }
        >;
      };
    };
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          workerCardFormats: {
            __typename?: 'UserWorkerCardFormatsConnection';
          } & {
            edges: Array<
              { __typename?: 'UserWorkerCardFormatsEdge' } & {
                node: { __typename?: 'WorkerCardFormat' } & Pick<
                  WorkerCardFormat,
                  'workerCardFormatId' | 'name' | 'facilityCode' | 'cardType'
                >;
              }
            >;
          };
          cCureEnvironments: {
            __typename?: 'UserCCureEnvironmentsConnection';
          } & {
            edges: Array<
              { __typename?: 'UserCCureEnvironmentsEdge' } & {
                node: { __typename?: 'CCureEnvironment' } & Pick<
                  CCureEnvironment,
                  'cCureEnvironmentId' | 'namespace'
                >;
              }
            >;
          };
          cCureEntityMappingOptions: {
            __typename?: 'UserCCureEntityMappingOptionsConnection';
          } & {
            edges?: Maybe<
              Array<
                { __typename?: 'UserCCureEntityMappingOptionsEdge' } & {
                  node: { __typename?: 'CCureEntityMapping' } & Pick<
                    CCureEntityMapping,
                    'entityType' | 'objectId' | 'name'
                  > & {
                      cCureEnvironment: {
                        __typename?: 'CCureEnvironment';
                      } & Pick<
                        CCureEnvironment,
                        'namespace' | 'cCureEnvironmentId' | 'instanceSlug'
                      >;
                    };
                }
              >
            >;
          };
        };
    }
  >;
};

type ConnectorListItemFields_AvigilonAccessConnector_Fragment = {
  __typename?: 'AvigilonAccessConnector';
} & Pick<AvigilonAccessConnector, 'id' | 'type' | 'status'> & {
    definition: { __typename?: 'AvigilonAccessConnectorDefinition' } & Pick<
      AvigilonAccessConnectorDefinition,
      'type' | 'displayName' | 'connectedDescription' | 'settingsLabel'
    >;
  };

type ConnectorListItemFields_AvigilonVideoConnector_Fragment = {
  __typename?: 'AvigilonVideoConnector';
} & Pick<AvigilonVideoConnector, 'id' | 'type' | 'status'> & {
    definition: { __typename?: 'AvigilonVideoConnectorDefinition' } & Pick<
      AvigilonVideoConnectorDefinition,
      'type' | 'displayName' | 'connectedDescription' | 'settingsLabel'
    >;
  };

export type ConnectorListItemFieldsFragment =
  | ConnectorListItemFields_AvigilonAccessConnector_Fragment
  | ConnectorListItemFields_AvigilonVideoConnector_Fragment;

export type GetSiteConnectorsQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetSiteConnectorsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      connectors: Array<
        | ({ __typename?: 'AvigilonAccessConnector' } & Pick<
            AvigilonAccessConnector,
            'id' | 'type' | 'status'
          > & {
              definition: {
                __typename?: 'AvigilonAccessConnectorDefinition';
              } & Pick<
                AvigilonAccessConnectorDefinition,
                | 'type'
                | 'displayName'
                | 'connectedDescription'
                | 'settingsLabel'
              >;
            })
        | ({ __typename?: 'AvigilonVideoConnector' } & Pick<
            AvigilonVideoConnector,
            'id' | 'type' | 'status'
          > & {
              definition: {
                __typename?: 'AvigilonVideoConnectorDefinition';
              } & Pick<
                AvigilonVideoConnectorDefinition,
                | 'type'
                | 'displayName'
                | 'connectedDescription'
                | 'settingsLabel'
              >;
            })
      >;
    };
};

export type GetConnectorRunsQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  filter?: InputMaybe<ConnectorRunFilterInput>;
}>;

export type GetConnectorRunsQuery = { __typename?: 'Query' } & {
  connector?: Maybe<
    | ({ __typename?: 'AvigilonAccessConnector' } & Pick<
        AvigilonAccessConnector,
        'id'
      > & {
          runs: { __typename?: 'ConnectorRunPage' } & Pick<
            ConnectorRunPage,
            'total'
          > & {
              runs: Array<
                { __typename?: 'ConnectorRun' } & Pick<
                  ConnectorRun,
                  'id' | 'status' | 'startedAt' | 'finishedAt' | 'message'
                >
              >;
            };
        })
    | ({ __typename?: 'AvigilonVideoConnector' } & Pick<
        AvigilonVideoConnector,
        'id'
      > & {
          runs: { __typename?: 'ConnectorRunPage' } & Pick<
            ConnectorRunPage,
            'total'
          > & {
              runs: Array<
                { __typename?: 'ConnectorRun' } & Pick<
                  ConnectorRun,
                  'id' | 'status' | 'startedAt' | 'finishedAt' | 'message'
                >
              >;
            };
        })
  >;
};

export type SetConnectorEnabledMutationVariables = Exact<{
  connectorId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;

export type SetConnectorEnabledMutation = { __typename?: 'Mutation' } & {
  setConnectorEnabled:
    | ({ __typename?: 'AvigilonAccessConnector' } & Pick<
        AvigilonAccessConnector,
        'id' | 'status'
      >)
    | ({ __typename?: 'AvigilonVideoConnector' } & Pick<
        AvigilonVideoConnector,
        'id' | 'status'
      >);
};

export type GetAvigilonAccessConnectorDetailsQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;

export type GetAvigilonAccessConnectorDetailsQuery = {
  __typename?: 'Query';
} & {
  avigilonAccessConnector?: Maybe<
    { __typename?: 'AvigilonAccessConnector' } & Pick<
      AvigilonAccessConnector,
      'id' | 'siteId' | 'type' | 'status' | 'createdAt' | 'updatedAt'
    > & {
        definition: { __typename?: 'AvigilonAccessConnectorDefinition' } & Pick<
          AvigilonAccessConnectorDefinition,
          'organizationId'
        >;
        avigilonSite?: Maybe<
          { __typename?: 'AvigilonAccessSite' } & Pick<
            AvigilonAccessSite,
            'id' | 'name'
          >
        >;
        createdBy: { __typename?: 'ConnectorActor' } & Pick<
          ConnectorActor,
          'id' | 'name'
        >;
        updatedBy: { __typename?: 'ConnectorActor' } & Pick<
          ConnectorActor,
          'id' | 'name'
        >;
      }
  >;
};

export type GetAvigilonAccessConnectorSetupMetadataQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetAvigilonAccessConnectorSetupMetadataQuery = {
  __typename?: 'Query';
} & {
  connectorCatalog: { __typename?: 'ConnectorCatalog' } & {
    definition:
      | ({ __typename?: 'AvigilonAccessConnectorDefinition' } & Pick<
          AvigilonAccessConnectorDefinition,
          'organizationId'
        > & { kind: 'AvigilonAccessConnectorDefinition' })
      | ({ __typename?: 'AvigilonVideoConnectorDefinition' } & {
          kind: 'AvigilonVideoConnectorDefinition';
        });
  };
};

export type SetupAvigilonAccessConnectorMutationVariables = Exact<{
  input: SetupAvigilonAccessConnectorInput;
}>;

export type SetupAvigilonAccessConnectorMutation = {
  __typename?: 'Mutation';
} & {
  setupAvigilonAccessConnector:
    | ({ __typename?: 'AvigilonAccessConnector' } & Pick<
        AvigilonAccessConnector,
        'id'
      >)
    | ({ __typename?: 'AvigilonVideoConnector' } & Pick<
        AvigilonVideoConnector,
        'id'
      >);
};

export type GetAvigilonVideoConnectorDetailsQueryVariables = Exact<{
  connectorId: Scalars['ID']['input'];
}>;

export type GetAvigilonVideoConnectorDetailsQuery = { __typename?: 'Query' } & {
  avigilonVideoConnector?: Maybe<
    { __typename?: 'AvigilonVideoConnector' } & Pick<
      AvigilonVideoConnector,
      'id' | 'siteId' | 'type' | 'status' | 'createdAt' | 'updatedAt'
    > & {
        createdBy: { __typename?: 'ConnectorActor' } & Pick<
          ConnectorActor,
          'id' | 'name'
        >;
        updatedBy: { __typename?: 'ConnectorActor' } & Pick<
          ConnectorActor,
          'id' | 'name'
        >;
      }
  >;
};

export type SetupAvigilonVideoConnectorMutationVariables = Exact<{
  input: SetupAvigilonVideoConnectorInput;
}>;

export type SetupAvigilonVideoConnectorMutation = {
  __typename?: 'Mutation';
} & {
  setupAvigilonVideoConnector:
    | ({ __typename?: 'AvigilonAccessConnector' } & Pick<
        AvigilonAccessConnector,
        'id'
      >)
    | ({ __typename?: 'AvigilonVideoConnector' } & Pick<
        AvigilonVideoConnector,
        'id'
      >);
};

export type ConnectorCatalogItemFieldsFragment = {
  __typename?: 'ConnectorCatalogItem';
} & Pick<
  ConnectorCatalogItem,
  | 'type'
  | 'displayName'
  | 'available'
  | 'setupDescription'
  | 'connectedDescription'
  | 'settingsLabel'
> & {
    instance?: Maybe<
      { __typename?: 'ConnectorCatalogInstance' } & Pick<
        ConnectorCatalogInstance,
        'connectorId' | 'status'
      >
    >;
  };

export type GetConnectorCatalogQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetConnectorCatalogQuery = { __typename?: 'Query' } & {
  connectorCatalog: { __typename?: 'ConnectorCatalog' } & {
    items: Array<
      { __typename?: 'ConnectorCatalogItem' } & Pick<
        ConnectorCatalogItem,
        | 'type'
        | 'displayName'
        | 'available'
        | 'setupDescription'
        | 'connectedDescription'
        | 'settingsLabel'
      > & {
          instance?: Maybe<
            { __typename?: 'ConnectorCatalogInstance' } & Pick<
              ConnectorCatalogInstance,
              'connectorId' | 'status'
            >
          >;
        }
    >;
  };
};

type ConnectorDetailsFields_AvigilonAccessConnector_Fragment = {
  __typename?: 'AvigilonAccessConnector';
} & Pick<
  AvigilonAccessConnector,
  'id' | 'siteId' | 'type' | 'status' | 'createdAt' | 'updatedAt'
> & {
    createdBy: { __typename?: 'ConnectorActor' } & Pick<
      ConnectorActor,
      'id' | 'name'
    >;
    updatedBy: { __typename?: 'ConnectorActor' } & Pick<
      ConnectorActor,
      'id' | 'name'
    >;
  };

type ConnectorDetailsFields_AvigilonVideoConnector_Fragment = {
  __typename?: 'AvigilonVideoConnector';
} & Pick<
  AvigilonVideoConnector,
  'id' | 'siteId' | 'type' | 'status' | 'createdAt' | 'updatedAt'
> & {
    createdBy: { __typename?: 'ConnectorActor' } & Pick<
      ConnectorActor,
      'id' | 'name'
    >;
    updatedBy: { __typename?: 'ConnectorActor' } & Pick<
      ConnectorActor,
      'id' | 'name'
    >;
  };

export type ConnectorDetailsFieldsFragment =
  | ConnectorDetailsFields_AvigilonAccessConnector_Fragment
  | ConnectorDetailsFields_AvigilonVideoConnector_Fragment;

export type GetJobsiteConfigCustomFieldsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigCustomFieldsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    | 'jobsiteId'
    | 'name'
    | 'activityCodeOptions'
    | 'classificationGroupOptions'
    | 'titleOptions'
    | 'tradeOptions'
    | 'unionAffiliationOptions'
  >;
};

export type CreateDeveloperJobsiteAccessGrantMutationVariables = Exact<{
  input: CreateDeveloperJobsiteAccessGrantInput;
}>;

export type CreateDeveloperJobsiteAccessGrantMutation = {
  __typename?: 'Mutation';
} & {
  createDeveloperJobsiteAccessGrant: {
    __typename?: 'DeveloperJobsiteAccessGrantPayload';
  } & {
    grant: { __typename?: 'DeveloperJobsiteAccessGrant' } & Pick<
      DeveloperJobsiteAccessGrant,
      'id'
    >;
  };
};

export type GetJobsiteDataSharingGrantsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteDataSharingGrantsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId' | 'name'>;
  jobsiteDataSharingGrants: Array<
    { __typename?: 'DeveloperJobsiteAccessGrant' } & Pick<
      DeveloperJobsiteAccessGrant,
      'id' | 'capability' | 'agreementReference' | 'status'
    > & {
        granteeDeveloper: { __typename?: 'Developer' } & Pick<
          Developer,
          'developerId' | 'name'
        >;
      }
  >;
};

export type RevokeDeveloperJobsiteAccessGrantMutationVariables = Exact<{
  input: RevokeDeveloperJobsiteAccessGrantInput;
}>;

export type RevokeDeveloperJobsiteAccessGrantMutation = {
  __typename?: 'Mutation';
} & {
  revokeDeveloperJobsiteAccessGrant: {
    __typename?: 'DeveloperJobsiteAccessGrantPayload';
  } & {
    grant: { __typename?: 'DeveloperJobsiteAccessGrant' } & Pick<
      DeveloperJobsiteAccessGrant,
      'id' | 'status'
    >;
  };
};

export type SiteReaderAttachmentsFieldsFragment = {
  __typename?: 'SiteReaderAttachments';
} & Pick<SiteReaderAttachments, 'readerName' | 'fingerprint'> & {
    attachments: Array<
      { __typename?: 'SiteReaderAttachment' } & Pick<
        SiteReaderAttachment,
        | 'entryId'
        | 'entryName'
        | 'zoneId'
        | 'zoneName'
        | 'siteId'
        | 'siteName'
        | 'currentSite'
        | 'removable'
        | 'removalBlockedReason'
      >
    >;
  };

export type GetSiteReaderAttachmentsQueryVariables = Exact<{
  input: SiteReaderAttachmentsInput;
}>;

export type GetSiteReaderAttachmentsQuery = { __typename?: 'Query' } & {
  siteReaderAttachments: { __typename?: 'SiteReaderAttachments' } & Pick<
    SiteReaderAttachments,
    'readerName' | 'fingerprint'
  > & {
      attachments: Array<
        { __typename?: 'SiteReaderAttachment' } & Pick<
          SiteReaderAttachment,
          | 'entryId'
          | 'entryName'
          | 'zoneId'
          | 'zoneName'
          | 'siteId'
          | 'siteName'
          | 'currentSite'
          | 'removable'
          | 'removalBlockedReason'
        >
      >;
    };
};

export type RemoveSiteReaderAttachmentMutationVariables = Exact<{
  input: RemoveSiteReaderAttachmentInput;
}>;

export type RemoveSiteReaderAttachmentMutation = { __typename?: 'Mutation' } & {
  removeSiteReaderAttachment: { __typename?: 'SiteReaderAttachments' } & Pick<
    SiteReaderAttachments,
    'readerName' | 'fingerprint'
  > & {
      attachments: Array<
        { __typename?: 'SiteReaderAttachment' } & Pick<
          SiteReaderAttachment,
          | 'entryId'
          | 'entryName'
          | 'zoneId'
          | 'zoneName'
          | 'siteId'
          | 'siteName'
          | 'currentSite'
          | 'removable'
          | 'removalBlockedReason'
        >
      >;
    };
};

export type SiteControllerReaderFieldsFragment = {
  __typename?: 'SiteControllerReader';
} & Pick<
  SiteControllerReader,
  | 'kind'
  | 'readerId'
  | 'registeredAt'
  | 'registeredBy'
  | 'readerDeviceId'
  | 'name'
  | 'serialNumber'
  | 'missing'
  | 'ownership'
  | 'createdAt'
  | 'lastSeenAt'
> & {
    entry?: Maybe<
      { __typename?: 'SiteReaderEntry' } & Pick<
        SiteReaderEntry,
        'externalEntryId' | 'name'
      >
    >;
    health: { __typename?: 'SiteReaderHealth' } & Pick<
      SiteReaderHealth,
      'kind' | 'isMissing' | 'bound' | 'lastReadAt'
    >;
    port?: Maybe<
      { __typename?: 'SiteControllerReaderPort' } & Pick<
        SiteControllerReaderPort,
        'id' | 'label' | 'position'
      >
    >;
    connection?: Maybe<
      { __typename?: 'SiteDeviceConnection' } & Pick<
        SiteDeviceConnection,
        'externalId' | 'externalName'
      >
    >;
    placement: { __typename?: 'SiteReaderPlacements' } & {
      published?: Maybe<
        { __typename?: 'SiteDevicePlacement' } & Pick<
          SiteDevicePlacement,
          'placementId' | 'entryId' | 'entryName'
        >
      >;
      draft?: Maybe<
        { __typename?: 'SiteDevicePlacement' } & Pick<
          SiteDevicePlacement,
          'placementId' | 'entryId' | 'entryName'
        >
      >;
    };
  };

export type SiteControllerFieldsFragment = {
  __typename?: 'SiteController';
} & Pick<
  SiteController,
  | 'assignmentId'
  | 'deviceId'
  | 'name'
  | 'modelKey'
  | 'serialNumber'
  | 'health'
  | 'healthObservedAt'
  | 'lastSuccessfulSyncAt'
  | 'lastFailureCode'
  | 'assignedAt'
  | 'assignedBy'
  | 'createdAt'
  | 'lastSeenAt'
> & {
    connection?: Maybe<
      { __typename?: 'SiteDeviceConnection' } & Pick<
        SiteDeviceConnection,
        'externalId' | 'externalName'
      >
    >;
    ports: Array<
      { __typename?: 'SiteControllerPort' } & Pick<
        SiteControllerPort,
        'id' | 'externalPortId' | 'label' | 'portType' | 'position' | 'readerId'
      >
    >;
    readers: Array<
      { __typename?: 'SiteControllerReader' } & Pick<
        SiteControllerReader,
        | 'kind'
        | 'readerId'
        | 'registeredAt'
        | 'registeredBy'
        | 'readerDeviceId'
        | 'name'
        | 'serialNumber'
        | 'missing'
        | 'ownership'
        | 'createdAt'
        | 'lastSeenAt'
      > & {
          entry?: Maybe<
            { __typename?: 'SiteReaderEntry' } & Pick<
              SiteReaderEntry,
              'externalEntryId' | 'name'
            >
          >;
          health: { __typename?: 'SiteReaderHealth' } & Pick<
            SiteReaderHealth,
            'kind' | 'isMissing' | 'bound' | 'lastReadAt'
          >;
          port?: Maybe<
            { __typename?: 'SiteControllerReaderPort' } & Pick<
              SiteControllerReaderPort,
              'id' | 'label' | 'position'
            >
          >;
          connection?: Maybe<
            { __typename?: 'SiteDeviceConnection' } & Pick<
              SiteDeviceConnection,
              'externalId' | 'externalName'
            >
          >;
          placement: { __typename?: 'SiteReaderPlacements' } & {
            published?: Maybe<
              { __typename?: 'SiteDevicePlacement' } & Pick<
                SiteDevicePlacement,
                'placementId' | 'entryId' | 'entryName'
              >
            >;
            draft?: Maybe<
              { __typename?: 'SiteDevicePlacement' } & Pick<
                SiteDevicePlacement,
                'placementId' | 'entryId' | 'entryName'
              >
            >;
          };
        }
    >;
  };

export type GetSiteDevicesQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetSiteDevicesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId' | 'name'>;
  siteIndependentReaders: Array<
    { __typename?: 'SiteIndependentReader' } & Pick<
      SiteIndependentReader,
      | 'kind'
      | 'readerId'
      | 'readerDeviceId'
      | 'name'
      | 'serialNumber'
      | 'missing'
    > & {
        entry?: Maybe<
          { __typename?: 'SiteReaderEntry' } & Pick<
            SiteReaderEntry,
            'externalEntryId' | 'name'
          >
        >;
        health: { __typename?: 'SiteReaderHealth' } & Pick<
          SiteReaderHealth,
          'kind' | 'isMissing' | 'bound' | 'lastReadAt'
        >;
        placement: { __typename?: 'SiteReaderPlacements' } & {
          published?: Maybe<
            { __typename?: 'SiteDevicePlacement' } & Pick<
              SiteDevicePlacement,
              'placementId' | 'entryId' | 'entryName'
            >
          >;
          draft?: Maybe<
            { __typename?: 'SiteDevicePlacement' } & Pick<
              SiteDevicePlacement,
              'placementId' | 'entryId' | 'entryName'
            >
          >;
        };
      }
  >;
  siteDevices: Array<
    { __typename?: 'SiteController' } & Pick<
      SiteController,
      | 'assignmentId'
      | 'deviceId'
      | 'name'
      | 'modelKey'
      | 'serialNumber'
      | 'health'
      | 'healthObservedAt'
      | 'lastSuccessfulSyncAt'
      | 'lastFailureCode'
      | 'assignedAt'
      | 'assignedBy'
      | 'createdAt'
      | 'lastSeenAt'
    > & {
        connection?: Maybe<
          { __typename?: 'SiteDeviceConnection' } & Pick<
            SiteDeviceConnection,
            'externalId' | 'externalName'
          >
        >;
        ports: Array<
          { __typename?: 'SiteControllerPort' } & Pick<
            SiteControllerPort,
            | 'id'
            | 'externalPortId'
            | 'label'
            | 'portType'
            | 'position'
            | 'readerId'
          >
        >;
        readers: Array<
          { __typename?: 'SiteControllerReader' } & Pick<
            SiteControllerReader,
            | 'kind'
            | 'readerId'
            | 'registeredAt'
            | 'registeredBy'
            | 'readerDeviceId'
            | 'name'
            | 'serialNumber'
            | 'missing'
            | 'ownership'
            | 'createdAt'
            | 'lastSeenAt'
          > & {
              entry?: Maybe<
                { __typename?: 'SiteReaderEntry' } & Pick<
                  SiteReaderEntry,
                  'externalEntryId' | 'name'
                >
              >;
              health: { __typename?: 'SiteReaderHealth' } & Pick<
                SiteReaderHealth,
                'kind' | 'isMissing' | 'bound' | 'lastReadAt'
              >;
              port?: Maybe<
                { __typename?: 'SiteControllerReaderPort' } & Pick<
                  SiteControllerReaderPort,
                  'id' | 'label' | 'position'
                >
              >;
              connection?: Maybe<
                { __typename?: 'SiteDeviceConnection' } & Pick<
                  SiteDeviceConnection,
                  'externalId' | 'externalName'
                >
              >;
              placement: { __typename?: 'SiteReaderPlacements' } & {
                published?: Maybe<
                  { __typename?: 'SiteDevicePlacement' } & Pick<
                    SiteDevicePlacement,
                    'placementId' | 'entryId' | 'entryName'
                  >
                >;
                draft?: Maybe<
                  { __typename?: 'SiteDevicePlacement' } & Pick<
                    SiteDevicePlacement,
                    'placementId' | 'entryId' | 'entryName'
                  >
                >;
              };
            }
        >;
      }
  >;
};

export type GetSiteUnresolvedReadersQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetSiteUnresolvedReadersQuery = { __typename?: 'Query' } & {
  siteUnresolvedReaders: Array<
    { __typename?: 'SiteUnresolvedReader' } & Pick<
      SiteUnresolvedReader,
      'readerId' | 'name'
    > & {
        controller?: Maybe<
          { __typename?: 'SiteUnresolvedReaderController' } & Pick<
            SiteUnresolvedReaderController,
            'assignmentId' | 'name' | 'portLabel'
          >
        >;
      }
  >;
};

export type AddSiteControllerMutationVariables = Exact<{
  input: AddSiteControllerInput;
}>;

export type AddSiteControllerMutation = { __typename?: 'Mutation' } & {
  addSiteController: { __typename?: 'AddSiteControllerPayload' } & Pick<
    AddSiteControllerPayload,
    | 'kind'
    | 'refusal'
    | 'failure'
    | 'runId'
    | 'assignmentId'
    | 'deviceId'
    | 'readerIds'
  >;
};

export type SyncSiteControllerMutationVariables = Exact<{
  input: SyncSiteControllerInput;
}>;

export type SyncSiteControllerMutation = { __typename?: 'Mutation' } & {
  syncSiteController: { __typename?: 'SyncSiteControllerPayload' } & Pick<
    SyncSiteControllerPayload,
    'kind' | 'refusal' | 'failure' | 'runId' | 'status' | 'observedAt'
  >;
};

export type RemoveSiteControllerMutationVariables = Exact<{
  input: RemoveSiteControllerInput;
}>;

export type RemoveSiteControllerMutation = { __typename?: 'Mutation' } & {
  removeSiteController: { __typename?: 'RemoveSiteControllerPayload' } & Pick<
    RemoveSiteControllerPayload,
    | 'kind'
    | 'refusal'
    | 'failure'
    | 'runId'
    | 'closedReaderIds'
    | 'removedDraftPlacementIds'
  >;
};

export type GetAvailableSiteControllersQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAvailableSiteControllersQuery = { __typename?: 'Query' } & {
  availableSiteControllers: {
    __typename?: 'AvailableSiteControllerConnection';
  } & {
    nodes: Array<
      { __typename?: 'AvailableSiteController' } & Pick<
        AvailableSiteController,
        'id' | 'name' | 'serialNumber'
      >
    >;
    pageInfo: { __typename?: 'AvailableSiteControllerPageInfo' } & Pick<
      AvailableSiteControllerPageInfo,
      'endCursor' | 'hasNextPage'
    >;
  };
};

export type GetJobsiteConfigDocumentsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  documentTypesInput?: InputMaybe<JobsiteWorkerDocumentTypesInput>;
}>;

export type GetJobsiteConfigDocumentsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name'
  > & {
      documentTypes: { __typename?: 'JobsiteWorkerDocumentTypesConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteWorkerDocumentTypesEdge' } & {
            node: { __typename?: 'JobsiteWorkerDocumentType' } & Pick<
              JobsiteWorkerDocumentType,
              'id' | 'key' | 'name' | 'position'
            > & {
                workerDocumentType: {
                  __typename?: 'WorkerDocumentType';
                } & Pick<
                  WorkerDocumentType,
                  'workerDocumentTypeId' | 'key' | 'name'
                >;
                files: Array<
                  { __typename?: 'File' } & Pick<
                    File,
                    'fileId' | 'fileType' | 'downloadUrl' | 'language' | 'title'
                  >
                >;
              };
          }
        >;
      };
      onboardingModule?: Maybe<
        { __typename?: 'JobsiteOnboardingModule' } & Pick<
          JobsiteOnboardingModule,
          'name' | 'badgePrintingAllowed' | 'badgeAssignmentAllowed'
        > & {
            steps?: Maybe<
              Array<
                { __typename?: 'JobsiteOnboardingStep' } & Pick<
                  JobsiteOnboardingStep,
                  'key' | 'index' | 'isRequired' | 'isVisible'
                > & {
                    fields?: Maybe<
                      Array<
                        { __typename?: 'JobsiteOnboardingField' } & Pick<
                          JobsiteOnboardingField,
                          | 'key'
                          | 'name'
                          | 'index'
                          | 'isRequired'
                          | 'isHidden'
                          | 'isEnforced'
                        >
                      >
                    >;
                  }
              >
            >;
            documents?: Maybe<
              Array<
                { __typename?: 'JobsiteOnboardingDocument' } & Pick<
                  JobsiteOnboardingDocument,
                  | 'key'
                  | 'workerDocTypeKey'
                  | 'name'
                  | 'index'
                  | 'isRequired'
                  | 'isVisible'
                  | 'expiration'
                  | 'gracePeriod'
                > & {
                    fields?: Maybe<
                      Array<
                        { __typename?: 'JobsiteOnboardingField' } & Pick<
                          JobsiteOnboardingField,
                          'key' | 'name' | 'index' | 'isRequired' | 'isHidden'
                        >
                      >
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type GetJobsiteConfigFeaturesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  userUsersInput?: InputMaybe<UserUsersInput>;
}>;

export type GetJobsiteConfigFeaturesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'isTemplate'
  > & {
      schedulerAccount?: Maybe<
        { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
            identity?: Maybe<
              { __typename?: 'UserIdentity' } & Pick<
                UserIdentity,
                'firstName' | 'lastName'
              >
            >;
          }
      >;
      featuresModule?: Maybe<
        { __typename?: 'JobsiteFeaturesModule' } & Pick<
          JobsiteFeaturesModule,
          | 'addWorkersToDailyLog'
          | 'announcementsEnabled'
          | 'archivingAccessEventsEnabled'
          | 'doNotAllowToSkipSelfOnboardingSteps'
          | 'enforceValidContractorInSelfOnboarding'
          | 'formsEnabled'
          | 'schedulingEnabled'
          | 'selfOnboardingAutoCompleteEnabled'
          | 'workerAppAdminCheckInEnabled'
          | 'workerAppBadgeScanningEnabled'
          | 'workerAppEnabled'
          | 'workerAppKioskCheckInEnabled'
          | 'workerAppKioskFrontCameraEnabled'
          | 'workerAppSelfCheckInEnabled'
          | 'isEnabled'
          | 'name'
          | 'slug'
        >
      >;
      appCheckInModule?: Maybe<
        { __typename?: 'JobsiteAppCheckInModule' } & Pick<
          JobsiteAppCheckInModule,
          | 'geofencingEnforcementType'
          | 'crewGeofencingEnforcementType'
          | 'isEnabled'
          | 'name'
          | 'slug'
        > & {
            areas: Array<
              { __typename?: 'JobsiteAppCheckInModuleArea' } & Pick<
                JobsiteAppCheckInModuleArea,
                'id' | 'name' | 'checkInRadius'
              > & {
                  checkInCoordinate: { __typename?: 'GPSCoordinate' } & Pick<
                    GpsCoordinate,
                    'lat' | 'lng'
                  >;
                }
            >;
          }
      >;
    };
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          users: { __typename?: 'UserUsersConnection' } & {
            edges: Array<
              { __typename?: 'UserUsersEdge' } & {
                node: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName'
                      >
                    >;
                  };
              }
            >;
          };
        };
    }
  >;
};

export type GetJobsiteConfigFormsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  userFormsInput?: InputMaybe<UserFormsInput>;
}>;

export type GetJobsiteConfigFormsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name'
  > & {
      jobsiteForms: { __typename?: 'JobsiteFormsConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteFormsEdge' } & {
            node: { __typename?: 'JobsiteForm' } & Pick<
              JobsiteForm,
              'id' | 'sessionAssignment' | 'autoCreateTrigger'
            > & {
                form: { __typename?: 'Form' } & Pick<
                  Form,
                  | 'id'
                  | 'key'
                  | 'name'
                  | 'description'
                  | 'allowSessionAssignment'
                  | 'allowAutoCreateOnCheckout'
                >;
              };
          }
        >;
      };
    };
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          forms: { __typename?: 'UserFormsConnection' } & {
            edges: Array<
              { __typename?: 'UserFormsEdge' } & {
                node: { __typename?: 'Form' } & Pick<
                  Form,
                  | 'id'
                  | 'key'
                  | 'name'
                  | 'description'
                  | 'allowSessionAssignment'
                  | 'allowAutoCreateOnCheckout'
                >;
              }
            >;
          };
        };
    }
  >;
};

export type GetJobsiteConfigGeofencingQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigGeofencingQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'isTemplate' | 'gatewayAddsClosed'
  > & {
      appCheckInModule?: Maybe<
        { __typename?: 'JobsiteAppCheckInModule' } & Pick<
          JobsiteAppCheckInModule,
          | 'geofencingEnforcementType'
          | 'crewGeofencingEnforcementType'
          | 'isEnabled'
          | 'name'
          | 'slug'
        > & {
            areas: Array<
              { __typename?: 'JobsiteAppCheckInModuleArea' } & Pick<
                JobsiteAppCheckInModuleArea,
                | 'id'
                | 'name'
                | 'checkInRadius'
                | 'isInboundEnabled'
                | 'isOutboundEnabled'
              > & {
                  checkInCoordinate: { __typename?: 'GPSCoordinate' } & Pick<
                    GpsCoordinate,
                    'lat' | 'lng'
                  >;
                }
            >;
          }
      >;
      featuresModule?: Maybe<
        { __typename?: 'JobsiteFeaturesModule' } & Pick<
          JobsiteFeaturesModule,
          | 'workerAppSelfCheckInEnabled'
          | 'workerAppAdminCheckInEnabled'
          | 'workerAppBadgeScanningEnabled'
          | 'workerAppKioskCheckInEnabled'
          | 'isEnabled'
          | 'name'
          | 'slug'
        >
      >;
      jobsiteGateways: { __typename?: 'JobsiteGatewaysConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteGatewaysEdge' } & {
            node: { __typename?: 'JobsiteGateway' } & Pick<
              JobsiteGateway,
              'id' | 'name'
            >;
          }
        >;
      };
    };
};

export type GetJobsiteConfigHidFargoConnectQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigHidFargoConnectQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    | 'jobsiteId'
    | 'name'
    | 'defaultJobsitePrinterId'
    | 'hidCardMappingUnion'
    | 'hidCardMappingNonUnion'
    | 'hidCardMappingTest'
  > & {
      jobsiteBadgeTemplates: {
        __typename?: 'JobsiteBadgeTemplatesConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteBadgeTemplatesEdge' } & {
            node: { __typename?: 'JobsiteBadgeTemplate' } & Pick<
              JobsiteBadgeTemplate,
              'id' | 'jobsiteId' | 'isDefault'
            > & {
                badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
                  BadgeTemplate,
                  'id' | 'templateName' | 'displayName' | 'isForTempBadge'
                >;
              };
          }
        >;
      };
      jobsitePrinters: { __typename?: 'JobsitePrintersConnection' } & {
        edges: Array<
          { __typename?: 'JobsitePrintersEdge' } & {
            node: { __typename?: 'JobsitePrinter' } & Pick<
              JobsitePrinter,
              | 'id'
              | 'hidPrinterId'
              | 'hidProxyInstance'
              | 'fargoLocationId'
              | 'fargoOrganizationId'
            >;
          }
        >;
      };
    };
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          hidEntityOptions: {
            __typename?: 'UserHidEntityOptionsConnection';
          } & {
            edges?: Maybe<
              Array<
                { __typename?: 'UserHidEntityOptionsEdge' } & {
                  node: { __typename?: 'HidEntityOption' } & Pick<
                    HidEntityOption,
                    | 'id'
                    | 'name'
                    | 'organizationId'
                    | 'organizationName'
                    | 'locationId'
                    | 'locationName'
                    | 'entityType'
                    | 'proxyInstance'
                  >;
                }
              >
            >;
          };
          badgeTemplates: { __typename?: 'UserBadgeTemplatesConnection' } & {
            edges?: Maybe<
              Array<
                { __typename?: 'UserBadgeTemplatesEdge' } & {
                  node: { __typename?: 'BadgeTemplate' } & Pick<
                    BadgeTemplate,
                    'id' | 'templateName' | 'displayName' | 'isForTempBadge'
                  >;
                }
              >
            >;
          };
        };
    }
  >;
};

export type GetJobsiteConfigInfoQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigInfoQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    | 'jobsiteId'
    | 'name'
    | 'jobsiteNumber'
    | 'parentId'
    | 'isTemplate'
    | 'addressLine1'
    | 'addressLine2'
    | 'addressCity'
    | 'addressState'
    | 'addressZipCode'
    | 'timeZone'
    | 'latitude'
    | 'longitude'
    | 'startDate'
    | 'endDate'
  > & {
      profilePicture?: Maybe<
        { __typename?: 'File' } & Pick<
          File,
          'fileId' | 'fileType' | 'downloadUrl'
        >
      >;
      developer?: Maybe<
        { __typename?: 'Developer' } & Pick<Developer, 'developerId'>
      >;
    };
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          developers: { __typename?: 'UserDevelopersConnection' } & {
            edges: Array<
              { __typename?: 'UserDevelopersEdge' } & {
                node: { __typename?: 'Developer' } & Pick<
                  Developer,
                  'developerId'
                > & {
                    organization: { __typename?: 'Organization' } & Pick<
                      Organization,
                      'organizationId' | 'name'
                    >;
                  };
              }
            >;
          };
          jobsites: { __typename?: 'UserJobsitesConnection' } & {
            edges: Array<
              { __typename?: 'UserJobsitesEdge' } & {
                node: { __typename?: 'Jobsite' } & Pick<
                  Jobsite,
                  'jobsiteId' | 'name' | 'parentId'
                >;
              }
            >;
          };
        };
    }
  >;
};

export type GetJobsiteConfigNotificationsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigNotificationsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    | 'jobsiteId'
    | 'name'
    | 'deviceStatusChangeEmails'
    | 'accessChangeEmails'
    | 'escortChangeEmails'
    | 'assignmentChangeEmails'
    | 'rejectedSwipeEmails'
    | 'dailyAccessReportEmails'
    | 'weeklyAccessReportEmails'
    | 'siteSafetyLogEmails'
    | 'safetyObservationLogEmails'
    | 'reportingTimeSlot'
  >;
};

export type GetJobsiteConfigOnboardingQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigOnboardingQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name'
  > & {
      onboardingModule?: Maybe<
        { __typename?: 'JobsiteOnboardingModule' } & Pick<
          JobsiteOnboardingModule,
          'name' | 'badgePrintingAllowed' | 'badgeAssignmentAllowed'
        > & {
            steps?: Maybe<
              Array<
                { __typename?: 'JobsiteOnboardingStep' } & Pick<
                  JobsiteOnboardingStep,
                  'key' | 'index' | 'isRequired' | 'isVisible'
                > & {
                    fields?: Maybe<
                      Array<
                        { __typename?: 'JobsiteOnboardingField' } & Pick<
                          JobsiteOnboardingField,
                          | 'key'
                          | 'name'
                          | 'index'
                          | 'isRequired'
                          | 'isHidden'
                          | 'isEnforced'
                        >
                      >
                    >;
                  }
              >
            >;
            documents?: Maybe<
              Array<
                { __typename?: 'JobsiteOnboardingDocument' } & Pick<
                  JobsiteOnboardingDocument,
                  | 'key'
                  | 'workerDocTypeKey'
                  | 'name'
                  | 'index'
                  | 'isRequired'
                  | 'isVisible'
                  | 'expiration'
                  | 'gracePeriod'
                > & {
                    fields?: Maybe<
                      Array<
                        { __typename?: 'JobsiteOnboardingField' } & Pick<
                          JobsiteOnboardingField,
                          'key' | 'name' | 'index' | 'isRequired' | 'isHidden'
                        >
                      >
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type GetJobsiteConfigProcoreQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigProcoreQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name' | 'procoreCompanyId' | 'procoreProjectId'
  >;
};

export type GetJobsiteConfigSiteAccessRulesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigSiteAccessRulesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    | 'jobsiteId'
    | 'name'
    | 'onboardingGracePeriod'
    | 'swipeInactivityThreshold'
    | 'maximumSessionLength'
    | 'allowOvernightSessions'
    | 'sessionDisplayColumn'
  >;
};

export type GetJobsiteConfigSiteLayoutQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigSiteLayoutQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId' | 'name'>;
};

export type GetJobsiteConfigZonesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigZonesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      zones: Array<{ __typename?: 'Zone' } & Pick<Zone, 'id' | 'name'>>;
    };
};

export type GetZoneDetailsQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;

export type GetZoneDetailsQuery = { __typename?: 'Query' } & {
  zone?: Maybe<
    { __typename?: 'Zone' } & Pick<Zone, 'id' | 'name'> & {
        connections: Array<
          { __typename?: 'Connection' } & Pick<Connection, 'id'> & {
              externalEntity: { __typename?: 'ExternalEntity' } & Pick<
                ExternalEntity,
                'type' | 'typeDisplayName' | 'id' | 'name'
              >;
            }
        >;
      }
  >;
};

export type GetJobsiteConfigWorkerInfoQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteConfigWorkerInfoQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name'
  > & {
      jobsiteCustomWorkerDataFields: {
        __typename?: 'JobsiteCustomWorkerDataFieldsConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteCustomWorkerDataFieldsEdge' } & {
            node: { __typename?: 'JobsiteCustomWorkerDataField' } & Pick<
              JobsiteCustomWorkerDataField,
              | 'id'
              | 'fieldDataType'
              | 'fieldLabel'
              | 'validationRegex'
              | 'validationMessage'
              | 'isRequired'
            >;
          }
        >;
      };
      onboardingModule?: Maybe<
        { __typename?: 'JobsiteOnboardingModule' } & Pick<
          JobsiteOnboardingModule,
          'name' | 'badgePrintingAllowed' | 'badgeAssignmentAllowed'
        > & {
            steps?: Maybe<
              Array<
                { __typename?: 'JobsiteOnboardingStep' } & Pick<
                  JobsiteOnboardingStep,
                  'key' | 'index' | 'isRequired' | 'isVisible'
                > & {
                    fields?: Maybe<
                      Array<
                        { __typename?: 'JobsiteOnboardingField' } & Pick<
                          JobsiteOnboardingField,
                          | 'key'
                          | 'name'
                          | 'index'
                          | 'isRequired'
                          | 'isHidden'
                          | 'isEnforced'
                        >
                      >
                    >;
                  }
              >
            >;
            documents?: Maybe<
              Array<
                { __typename?: 'JobsiteOnboardingDocument' } & Pick<
                  JobsiteOnboardingDocument,
                  | 'key'
                  | 'workerDocTypeKey'
                  | 'name'
                  | 'index'
                  | 'isRequired'
                  | 'isVisible'
                  | 'expiration'
                  | 'gracePeriod'
                > & {
                    fields?: Maybe<
                      Array<
                        { __typename?: 'JobsiteOnboardingField' } & Pick<
                          JobsiteOnboardingField,
                          'key' | 'name' | 'index' | 'isRequired' | 'isHidden'
                        >
                      >
                    >;
                  }
              >
            >;
          }
      >;
    };
};

export type GetAddJobsiteContractorWorkerJobsiteQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetAddJobsiteContractorWorkerJobsiteQuery = {
  __typename?: 'Query';
} & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'name'
  > & {
      modules?: Maybe<
        Array<
          | { __typename?: 'JobsiteAppCheckInModule' }
          | { __typename?: 'JobsiteFeaturesModule' }
          | ({ __typename?: 'JobsiteOnboardingModule' } & Pick<
              JobsiteOnboardingModule,
              'name'
            > & {
                steps?: Maybe<
                  Array<
                    { __typename?: 'JobsiteOnboardingStep' } & Pick<
                      JobsiteOnboardingStep,
                      'key' | 'index' | 'isRequired' | 'isVisible'
                    > & {
                        fields?: Maybe<
                          Array<
                            { __typename?: 'JobsiteOnboardingField' } & Pick<
                              JobsiteOnboardingField,
                              | 'key'
                              | 'name'
                              | 'index'
                              | 'isRequired'
                              | 'isHidden'
                            >
                          >
                        >;
                      }
                  >
                >;
              })
          | { __typename?: 'JobsitePreOnboardingModule' }
        >
      >;
    };
};

export type GetAvailableJobsiteWorkersQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteJobsiteWorkersInput?: InputMaybe<JobsiteJobsiteWorkersInput>;
}>;

export type GetAvailableJobsiteWorkersQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteWorkers: { __typename?: 'JobsiteJobsiteWorkersConnection' } & Pick<
        JobsiteJobsiteWorkersConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'JobsiteJobsiteWorkersEdge' } & {
              node: { __typename?: 'JobsiteWorker' } & Pick<
                JobsiteWorker,
                | 'jobsiteWorkerId'
                | 'stickerNumber'
                | 'isOnSite'
                | 'trade'
                | 'jobTitle'
                | 'isBanned'
                | 'banExpiresAt'
              > & {
                  currentAccess: {
                    __typename?: 'JobsiteWorkerCurrentAccess';
                  } & Pick<
                    JobsiteWorkerCurrentAccess,
                    'isAllowed' | 'notAllowedReason' | 'startDate' | 'endDate'
                  >;
                  contractorWorker: { __typename?: 'ContractorWorker' } & Pick<
                    ContractorWorker,
                    'id'
                  > & {
                      contractor: { __typename?: 'Contractor' } & Pick<
                        Contractor,
                        'contractorId'
                      > & {
                          organization: { __typename?: 'Organization' } & Pick<
                            Organization,
                            'organizationId' | 'name'
                          >;
                        };
                      worker: { __typename?: 'Worker' } & Pick<
                        Worker,
                        'workerId' | 'birthDate' | 'quickCode'
                      > & {
                          user: { __typename?: 'User' } & Pick<
                            User,
                            'userAccountId'
                          > & {
                              identity?: Maybe<
                                { __typename?: 'UserIdentity' } & Pick<
                                  UserIdentity,
                                  'firstName' | 'lastName' | 'email'
                                >
                              >;
                              roles: Array<
                                { __typename?: 'UserRole' } & Pick<
                                  UserRole,
                                  'mappingId' | 'key' | 'displayName'
                                >
                              >;
                            };
                          profilePicture?: Maybe<
                            { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                          >;
                        };
                    };
                };
            }
          >;
        };
    };
};

export type GetFormSubmissionAvailableWorkersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  availableWorkersInput: JobsiteFormSubmissionAvailableWorkersInput;
}>;

export type GetFormSubmissionAvailableWorkersQuery = {
  __typename?: 'Query';
} & {
  getJobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
    JobsiteFormSubmission,
    'id'
  > & {
      jobsiteForm: { __typename?: 'JobsiteForm' } & Pick<JobsiteForm, 'id'> & {
          jobsite: { __typename?: 'Jobsite' } & Pick<
            Jobsite,
            'jobsiteId' | 'name'
          >;
        };
      availableWorkers: {
        __typename?: 'JobsiteFormSubmissionAvailableWorkersConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteFormSubmissionAvailableWorkerEdge' } & {
            node: { __typename?: 'Worker' } & Pick<
              Worker,
              'workerId' | 'birthDate' | 'quickCode'
            > & {
                user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName' | 'email' | 'phoneNumber'
                      >
                    >;
                  };
                profilePicture?: Maybe<
                  { __typename?: 'File' } & Pick<
                    File,
                    'downloadUrl' | 'uploadedAt' | 'fileId'
                  >
                >;
                profilePictureCropped?: Maybe<
                  { __typename?: 'File' } & Pick<
                    File,
                    'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                  >
                >;
                jobsiteWorkers: {
                  __typename?: 'WorkerJobsiteWorkersConnection';
                } & {
                  edges: Array<
                    { __typename?: 'WorkerJobsiteWorkersEdge' } & {
                      node: { __typename?: 'JobsiteWorker' } & Pick<
                        JobsiteWorker,
                        | 'jobsiteWorkerId'
                        | 'stickerNumber'
                        | 'trade'
                        | 'jobTitle'
                        | 'unionAffiliation'
                      > & {
                          currentAccess: {
                            __typename?: 'JobsiteWorkerCurrentAccess';
                          } & Pick<
                            JobsiteWorkerCurrentAccess,
                            | 'isAllowed'
                            | 'notAllowedReason'
                            | 'startDate'
                            | 'endDate'
                          >;
                          jobsiteContractor: {
                            __typename?: 'JobsiteContractor';
                          } & Pick<JobsiteContractor, 'id'> & {
                              jobsite: { __typename?: 'Jobsite' } & Pick<
                                Jobsite,
                                'jobsiteId' | 'name'
                              >;
                              contractor: { __typename?: 'Contractor' } & Pick<
                                Contractor,
                                'contractorId'
                              > & {
                                  organization: {
                                    __typename?: 'Organization';
                                  } & Pick<
                                    Organization,
                                    'organizationId' | 'name'
                                  >;
                                };
                            };
                        };
                    }
                  >;
                };
              };
          }
        >;
      };
    };
};

export type GetFormSubmissionJobsiteContractorsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetFormSubmissionJobsiteContractorsQuery = {
  __typename?: 'Query';
} & {
  getJobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
    JobsiteFormSubmission,
    'id'
  > & {
      jobsiteContractors: {
        __typename?: 'JobsiteFormSubmissionContractorsConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteFormSubmissionContractorsEdge' } & {
            node: { __typename?: 'JobsiteFormSubmissionContractor' } & Pick<
              JobsiteFormSubmissionContractor,
              'id' | 'extraData' | 'associationType'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & Pick<
                  JobsiteContractor,
                  'id'
                > & {
                    contractor: { __typename?: 'Contractor' } & Pick<
                      Contractor,
                      'contractorId'
                    > & {
                        organization: { __typename?: 'Organization' } & Pick<
                          Organization,
                          'organizationId' | 'name'
                        >;
                      };
                  };
              };
          }
        >;
      };
    };
};

export type GetFormSubmissionJobsiteWorkersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  jfsInput?: InputMaybe<JobsiteFormSubmissionWorkersInput>;
}>;

export type GetFormSubmissionJobsiteWorkersQuery = { __typename?: 'Query' } & {
  getJobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
    JobsiteFormSubmission,
    'id'
  > & {
      jobsiteForm: { __typename?: 'JobsiteForm' } & Pick<JobsiteForm, 'id'> & {
          jobsite: { __typename?: 'Jobsite' } & Pick<
            Jobsite,
            'jobsiteId' | 'name'
          >;
        };
      jobsiteWorkers: {
        __typename?: 'JobsiteFormSubmissionWorkersConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteFormSubmissionWorkersEdge' } & {
            node: { __typename?: 'JobsiteFormSubmissionWorker' } & Pick<
              JobsiteFormSubmissionWorker,
              'id' | 'extraData' | 'associationType'
            > & {
                historicalData: {
                  __typename?: 'JobsiteFormSubmissionWorkerHistoricalData';
                } & {
                  jobsiteWorkerAccess?: Maybe<
                    { __typename?: 'JobsiteWorkerAccess' } & Pick<
                      JobsiteWorkerAccess,
                      'isAllowedNow'
                    >
                  >;
                };
                jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
                  JobsiteWorker,
                  | 'jobsiteWorkerId'
                  | 'stickerNumber'
                  | 'isOnSite'
                  | 'trade'
                  | 'jobTitle'
                  | 'unionAffiliation'
                > & {
                    currentAccess: {
                      __typename?: 'JobsiteWorkerCurrentAccess';
                    } & Pick<
                      JobsiteWorkerCurrentAccess,
                      'isAllowed' | 'notAllowedReason' | 'startDate' | 'endDate'
                    >;
                    jobsiteContractor: {
                      __typename?: 'JobsiteContractor';
                    } & Pick<JobsiteContractor, 'id'> & {
                        jobsite: { __typename?: 'Jobsite' } & Pick<
                          Jobsite,
                          'jobsiteId' | 'name'
                        >;
                        contractor: { __typename?: 'Contractor' } & Pick<
                          Contractor,
                          'contractorId'
                        > & {
                            organization: {
                              __typename?: 'Organization';
                            } & Pick<Organization, 'organizationId' | 'name'>;
                          };
                      };
                    contractorWorker: {
                      __typename?: 'ContractorWorker';
                    } & Pick<ContractorWorker, 'id'> & {
                        worker: { __typename?: 'Worker' } & Pick<
                          Worker,
                          'workerId' | 'birthDate' | 'quickCode'
                        > & {
                            user: { __typename?: 'User' } & Pick<
                              User,
                              'userAccountId'
                            > & {
                                identity?: Maybe<
                                  { __typename?: 'UserIdentity' } & Pick<
                                    UserIdentity,
                                    | 'firstName'
                                    | 'lastName'
                                    | 'email'
                                    | 'phoneNumber'
                                  >
                                >;
                              };
                            profilePicture?: Maybe<
                              { __typename?: 'File' } & Pick<
                                File,
                                'downloadUrl'
                              >
                            >;
                          };
                      };
                    activeTempWorkerCard?: Maybe<
                      { __typename?: 'WorkerCard' } & Pick<
                        WorkerCard,
                        'workerCardId' | 'expiredAt' | 'cardNumber'
                      > & {
                          tempBadge?: Maybe<
                            { __typename?: 'TempBadge' } & Pick<
                              TempBadge,
                              'id' | 'name' | 'cardNumber'
                            >
                          >;
                        }
                    >;
                  };
              };
          }
        >;
      };
    };
};

export type GetJobsiteTimeSeriesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  timeSeriesInput?: InputMaybe<JobsiteTimeSeriesInput>;
}>;

export type GetJobsiteTimeSeriesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      timeSeries: { __typename?: 'JobsiteTimeSeries' } & {
        sessions?: Maybe<
          Array<
            { __typename?: 'TimeSeries' } & Pick<
              TimeSeries,
              'dateTime' | 'timeZone' | 'value'
            >
          >
        >;
      };
    };
};

export type GetJobsiteWorkerDashboardReportQueryVariables = Exact<{
  jobsiteIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  timeBreakdown?: InputMaybe<GetJobsiteWorkerReportsTimeBreakdown>;
  realtime?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  export?: InputMaybe<Scalars['Boolean']['input']>;
  trade?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  contractor?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  fitoutTenant?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  compliant?: InputMaybe<Scalars['Boolean']['input']>;
  workerIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type GetJobsiteWorkerDashboardReportQuery = { __typename?: 'Query' } & {
  getJobsiteWorkerDashboard?: Maybe<
    { __typename?: 'GetJobsiteWorkerDashboardResponse' } & {
      jobsites: Array<
        { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId' | 'name'>
      >;
      overviewBreakdowns?: Maybe<
        Array<
          { __typename?: 'ElasticFacetEntry' } & Pick<
            ElasticFacetEntry,
            'name' | 'count' | 'compliantCount' | 'percentage'
          >
        >
      >;
    }
  >;
};

export type GetJobsiteFormSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetJobsiteFormSubmissionQuery = { __typename?: 'Query' } & {
  getJobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
    JobsiteFormSubmission,
    | 'id'
    | 'startAt'
    | 'isStartTimeSpecified'
    | 'endAt'
    | 'timeZone'
    | 'extraData'
  > & {
      objectHistory: { __typename?: 'ObjectHistory' } & {
        createdBy?: Maybe<
          { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            }
        >;
      };
      weatherConditions?: Maybe<
        Array<
          { __typename?: 'WeatherConditions' } & Pick<
            WeatherConditions,
            | 'timestamp'
            | 'description'
            | 'icon'
            | 'temp'
            | 'windSpeed'
            | 'windDirectionCardinal'
          >
        >
      >;
      jobsiteForm: { __typename?: 'JobsiteForm' } & Pick<JobsiteForm, 'id'> & {
          form: { __typename?: 'Form' } & Pick<Form, 'id' | 'key' | 'content'>;
          jobsite: { __typename?: 'Jobsite' } & Pick<
            Jobsite,
            'jobsiteId' | 'jobsiteNumber' | 'name'
          > & {
              modules?: Maybe<
                Array<
                  | { __typename?: 'JobsiteAppCheckInModule' }
                  | ({ __typename?: 'JobsiteFeaturesModule' } & Pick<
                      JobsiteFeaturesModule,
                      | 'formsEnabled'
                      | 'addWorkersToDailyLog'
                      | 'isEnabled'
                      | 'name'
                      | 'slug'
                    >)
                  | { __typename?: 'JobsiteOnboardingModule' }
                  | { __typename?: 'JobsitePreOnboardingModule' }
                >
              >;
            };
        };
      jobsiteContractors: {
        __typename?: 'JobsiteFormSubmissionContractorsConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteFormSubmissionContractorsEdge' } & {
            node: { __typename?: 'JobsiteFormSubmissionContractor' } & Pick<
              JobsiteFormSubmissionContractor,
              'id' | 'extraData' | 'associationType'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & Pick<
                  JobsiteContractor,
                  'id'
                > & {
                    contractor: { __typename?: 'Contractor' } & Pick<
                      Contractor,
                      'contractorId'
                    > & {
                        organization: { __typename?: 'Organization' } & Pick<
                          Organization,
                          'organizationId' | 'name'
                        >;
                      };
                  };
              };
          }
        >;
      };
      jobsiteWorkers: {
        __typename?: 'JobsiteFormSubmissionWorkersConnection';
      } & Pick<JobsiteFormSubmissionWorkersConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteFormSubmissionWorkersEdge' } & {
              node: { __typename?: 'JobsiteFormSubmissionWorker' } & Pick<
                JobsiteFormSubmissionWorker,
                'id' | 'extraData' | 'associationType'
              > & {
                  jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
                    JobsiteWorker,
                    'jobsiteWorkerId'
                  >;
                };
            }
          >;
        };
      documents: {
        __typename?: 'JobsiteFormSubmissionDocumentsConnection';
      } & Pick<JobsiteFormSubmissionDocumentsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteFormSubmissionDocumentsEdge' } & {
              node: { __typename?: 'JobsiteFormSubmissionDocument' } & Pick<
                JobsiteFormSubmissionDocument,
                'id' | 'description' | 'associationType'
              > & {
                  files: Array<
                    { __typename?: 'File' } & Pick<
                      File,
                      'fileId' | 'fileType' | 'downloadUrl' | 'originalFileName'
                    >
                  >;
                  objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                    ObjectHistory,
                    'createdAt'
                  > & {
                      createdBy?: Maybe<
                        { __typename?: 'User' } & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName'
                            >
                          >;
                        }
                      >;
                    };
                };
            }
          >;
        };
    };
};

export type GetJobsiteFormSubmissionHistoricalDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetJobsiteFormSubmissionHistoricalDataQuery = {
  __typename?: 'Query';
} & {
  getJobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
    JobsiteFormSubmission,
    'id'
  > & {
      jobsiteWorkers: {
        __typename?: 'JobsiteFormSubmissionWorkersConnection';
      } & Pick<JobsiteFormSubmissionWorkersConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteFormSubmissionWorkersEdge' } & {
              node: { __typename?: 'JobsiteFormSubmissionWorker' } & Pick<
                JobsiteFormSubmissionWorker,
                'id' | 'extraData'
              > & {
                  objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                    ObjectHistory,
                    'createdAt'
                  >;
                  historicalData: {
                    __typename?: 'JobsiteFormSubmissionWorkerHistoricalData';
                  } & {
                    jobsiteWorkerAccess?: Maybe<
                      { __typename?: 'JobsiteWorkerAccess' } & Pick<
                        JobsiteWorkerAccess,
                        | 'isAllowedNow'
                        | 'notAllowedReason'
                        | 'jobsiteIsDisabledAccess'
                        | 'jobsiteAccessReadmissionDate'
                        | 'endDate'
                        | 'isAntipassbackExempt'
                        | 'siteSpecificTrainingCompletedAt'
                        | 'siteSpecificTrainingExpiredAt'
                        | 'siteSpecificTrainingSkipReason'
                        | 'safetyDocumentsCompletedAt'
                        | 'safetyDocumentsExpiredAt'
                        | 'safetyDocumentsSkipReason'
                        | 'orientationMedicalCompletedAt'
                        | 'orientationMedicalExpiredAt'
                        | 'orientationMedicalSkipReason'
                        | 'nycSstExemptionReason'
                        | 'safetyDocumentStatus'
                      > & {
                          jobsiteWorker: {
                            __typename?: 'JobsiteWorker';
                          } & Pick<
                            JobsiteWorker,
                            | 'jobsiteWorkerId'
                            | 'trade'
                            | 'jobTitle'
                            | 'unionAffiliation'
                            | 'isBanned'
                            | 'bannedReason'
                            | 'bannedAt'
                            | 'banRemovedReason'
                            | 'startDate'
                            | 'endDate'
                            | 'payrollId'
                            | 'siteSpecificTrainingCompletedAt'
                            | 'stickerNumber'
                            | 'orientationDate'
                            | 'orientationStatus'
                            | 'documentsCompletedSkipExpiresAt'
                            | 'urineTestConditionalPassExpiresAt'
                            | 'banExpiresAt'
                            | 'isSuspended'
                            | 'badgingCompletedAt'
                            | 'medicalNotes'
                            | 'nycSstExemptionReason'
                            | 'siteAccessChangeApprovedBy'
                            | 'isExemptFromSwipeInactivity'
                            | 'isExemptFromSiteSpecificRefresher'
                            | 'customWorkerData'
                          > & {
                              jobsiteContractor: {
                                __typename?: 'JobsiteContractor';
                              } & {
                                jobsite: { __typename?: 'Jobsite' } & Pick<
                                  Jobsite,
                                  'name' | 'jobsiteId' | 'parentId'
                                > & {
                                    developer?: Maybe<
                                      { __typename?: 'Developer' } & Pick<
                                        Developer,
                                        'developerId' | 'name'
                                      >
                                    >;
                                    jobsiteCustomWorkerDataFields: {
                                      __typename?: 'JobsiteCustomWorkerDataFieldsConnection';
                                    } & {
                                      edges: Array<
                                        {
                                          __typename?: 'JobsiteCustomWorkerDataFieldsEdge';
                                        } & {
                                          node: {
                                            __typename?: 'JobsiteCustomWorkerDataField';
                                          } & Pick<
                                            JobsiteCustomWorkerDataField,
                                            | 'fieldLabel'
                                            | 'fieldDataType'
                                            | 'isRequired'
                                            | 'validationMessage'
                                            | 'validationRegex'
                                          >;
                                        }
                                      >;
                                    };
                                  };
                              };
                              contractorWorker: {
                                __typename?: 'ContractorWorker';
                              } & {
                                worker: { __typename?: 'Worker' } & Pick<
                                  Worker,
                                  'workerId'
                                > & {
                                    documents: {
                                      __typename?: 'WorkerDocumentsConnection';
                                    } & {
                                      edges: Array<
                                        {
                                          __typename?: 'WorkerDocumentsEdge';
                                        } & {
                                          node: {
                                            __typename?: 'JobsiteWorkerDocument';
                                          } & Pick<
                                            JobsiteWorkerDocument,
                                            'jobsiteWorkerDocumentId'
                                          > & {
                                              jobsiteWorkerDocumentType: {
                                                __typename?: 'JobsiteWorkerDocumentType';
                                              } & Pick<
                                                JobsiteWorkerDocumentType,
                                                'expiration'
                                              > & {
                                                  jobsite: {
                                                    __typename?: 'Jobsite';
                                                  } & Pick<
                                                    Jobsite,
                                                    'name' | 'jobsiteId'
                                                  > & {
                                                      developer?: Maybe<
                                                        {
                                                          __typename?: 'Developer';
                                                        } & Pick<
                                                          Developer,
                                                          'name' | 'developerId'
                                                        >
                                                      >;
                                                    };
                                                  workerDocumentType: {
                                                    __typename?: 'WorkerDocumentType';
                                                  } & Pick<
                                                    WorkerDocumentType,
                                                    | 'name'
                                                    | 'key'
                                                    | 'expirationDate'
                                                    | 'isGlobal'
                                                    | 'documentLevel'
                                                  >;
                                                };
                                              jobsiteWorker?: Maybe<
                                                {
                                                  __typename?: 'JobsiteWorker';
                                                } & Pick<
                                                  JobsiteWorker,
                                                  'jobsiteWorkerId'
                                                > & {
                                                    jobsiteContractor: {
                                                      __typename?: 'JobsiteContractor';
                                                    } & {
                                                      jobsite: {
                                                        __typename?: 'Jobsite';
                                                      } & Pick<
                                                        Jobsite,
                                                        'jobsiteId'
                                                      >;
                                                    };
                                                  }
                                              >;
                                              latestVersion: {
                                                __typename?: 'JobsiteWorkerDocumentVersion';
                                              } & Pick<
                                                JobsiteWorkerDocumentVersion,
                                                'jobsiteWorkerDocumentVersionId'
                                              > & {
                                                  files: Array<
                                                    {
                                                      __typename?: 'File';
                                                    } & Pick<
                                                      File,
                                                      | 'fileId'
                                                      | 'fileType'
                                                      | 'downloadUrl'
                                                    >
                                                  >;
                                                  additionalFieldValues?: Maybe<
                                                    Array<
                                                      {
                                                        __typename?: 'AdditionalFieldValue';
                                                      } & Pick<
                                                        AdditionalFieldValue,
                                                        'key' | 'value'
                                                      >
                                                    >
                                                  >;
                                                  objectHistory: {
                                                    __typename?: 'ObjectHistory';
                                                  } & Pick<
                                                    ObjectHistory,
                                                    'createdAt' | 'updatedAt'
                                                  > & {
                                                      createdBy?: Maybe<
                                                        {
                                                          __typename?: 'User';
                                                        } & Pick<
                                                          User,
                                                          'userAccountId'
                                                        > & {
                                                            identity?: Maybe<
                                                              {
                                                                __typename?: 'UserIdentity';
                                                              } & Pick<
                                                                UserIdentity,
                                                                | 'firstName'
                                                                | 'lastName'
                                                                | 'email'
                                                              >
                                                            >;
                                                          }
                                                      >;
                                                      updatedBy?: Maybe<
                                                        {
                                                          __typename?: 'User';
                                                        } & Pick<
                                                          User,
                                                          'userAccountId'
                                                        > & {
                                                            identity?: Maybe<
                                                              {
                                                                __typename?: 'UserIdentity';
                                                              } & Pick<
                                                                UserIdentity,
                                                                | 'firstName'
                                                                | 'lastName'
                                                                | 'email'
                                                              >
                                                            >;
                                                          }
                                                      >;
                                                    };
                                                };
                                            };
                                        }
                                      >;
                                    };
                                    jobsiteAccessEvents?: Maybe<
                                      {
                                        __typename?: 'JobsiteAccessEventsConnection';
                                      } & {
                                        edges: Array<
                                          {
                                            __typename?: 'JobsiteAccessEventsEdge';
                                          } & {
                                            node: {
                                              __typename?: 'JobsiteAccessEvent';
                                            } & Pick<
                                              JobsiteAccessEvent,
                                              | 'id'
                                              | 'status'
                                              | 'timeStamp'
                                              | 'eventOccurredAt'
                                              | 'timeZone'
                                              | 'overnightSession'
                                              | 'gateway'
                                              | 'direction'
                                              | 'eventType'
                                              | 'credentialId'
                                            >;
                                          }
                                        >;
                                      }
                                    >;
                                    objectHistory: {
                                      __typename?: 'ObjectHistory';
                                    } & Pick<
                                      ObjectHistory,
                                      'createdAt' | 'updatedAt'
                                    > & {
                                        createdBy?: Maybe<
                                          { __typename?: 'User' } & Pick<
                                            User,
                                            'userAccountId'
                                          > & {
                                              identity?: Maybe<
                                                {
                                                  __typename?: 'UserIdentity';
                                                } & Pick<
                                                  UserIdentity,
                                                  | 'firstName'
                                                  | 'lastName'
                                                  | 'email'
                                                >
                                              >;
                                            }
                                        >;
                                        updatedBy?: Maybe<
                                          { __typename?: 'User' } & Pick<
                                            User,
                                            'userAccountId'
                                          > & {
                                              identity?: Maybe<
                                                {
                                                  __typename?: 'UserIdentity';
                                                } & Pick<
                                                  UserIdentity,
                                                  | 'firstName'
                                                  | 'lastName'
                                                  | 'email'
                                                >
                                              >;
                                            }
                                        >;
                                      };
                                  };
                                contractor: {
                                  __typename?: 'Contractor';
                                } & Pick<Contractor, 'contractorId'> & {
                                    organization: {
                                      __typename?: 'Organization';
                                    } & Pick<
                                      Organization,
                                      'organizationId' | 'name'
                                    >;
                                  };
                              };
                              objectHistory: {
                                __typename?: 'ObjectHistory';
                              } & Pick<
                                ObjectHistory,
                                'createdAt' | 'updatedAt'
                              > & {
                                  createdBy?: Maybe<
                                    { __typename?: 'User' } & Pick<
                                      User,
                                      'userAccountId'
                                    > & {
                                        identity?: Maybe<
                                          {
                                            __typename?: 'UserIdentity';
                                          } & Pick<
                                            UserIdentity,
                                            'firstName' | 'lastName' | 'email'
                                          >
                                        >;
                                      }
                                  >;
                                  updatedBy?: Maybe<
                                    { __typename?: 'User' } & Pick<
                                      User,
                                      'userAccountId'
                                    > & {
                                        identity?: Maybe<
                                          {
                                            __typename?: 'UserIdentity';
                                          } & Pick<
                                            UserIdentity,
                                            'firstName' | 'lastName' | 'email'
                                          >
                                        >;
                                      }
                                  >;
                                };
                            };
                        }
                    >;
                  };
                };
            }
          >;
        };
    };
};

export type GetJobsiteFormSubmissionReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetJobsiteFormSubmissionReportQuery = { __typename?: 'Query' } & {
  getJobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
    JobsiteFormSubmission,
    | 'id'
    | 'startAt'
    | 'isStartTimeSpecified'
    | 'endAt'
    | 'timeZone'
    | 'extraData'
  > & {
      weatherConditions?: Maybe<
        Array<
          { __typename?: 'WeatherConditions' } & Pick<
            WeatherConditions,
            | 'timestamp'
            | 'description'
            | 'icon'
            | 'temp'
            | 'windSpeed'
            | 'windDirectionCardinal'
          >
        >
      >;
      jobsiteForm: { __typename?: 'JobsiteForm' } & Pick<JobsiteForm, 'id'> & {
          form: { __typename?: 'Form' } & Pick<
            Form,
            'id' | 'key' | 'name' | 'content'
          >;
          jobsite: { __typename?: 'Jobsite' } & Pick<
            Jobsite,
            | 'jobsiteId'
            | 'jobsiteNumber'
            | 'name'
            | 'addressLine1'
            | 'addressLine2'
            | 'addressCity'
            | 'addressState'
            | 'addressZipCode'
          >;
        };
      jobsiteContractors: {
        __typename?: 'JobsiteFormSubmissionContractorsConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteFormSubmissionContractorsEdge' } & {
            node: { __typename?: 'JobsiteFormSubmissionContractor' } & Pick<
              JobsiteFormSubmissionContractor,
              'id' | 'extraData' | 'associationType'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & Pick<
                  JobsiteContractor,
                  'id'
                > & {
                    contractor: { __typename?: 'Contractor' } & Pick<
                      Contractor,
                      'contractorId'
                    > & {
                        organization: { __typename?: 'Organization' } & Pick<
                          Organization,
                          | 'organizationId'
                          | 'name'
                          | 'addressLine1'
                          | 'addressLine2'
                          | 'addressCity'
                          | 'addressState'
                          | 'addressZipCode'
                        >;
                      };
                  };
              };
          }
        >;
      };
      jobsiteWorkers: {
        __typename?: 'JobsiteFormSubmissionWorkersConnection';
      } & Pick<JobsiteFormSubmissionWorkersConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteFormSubmissionWorkersEdge' } & {
              node: { __typename?: 'JobsiteFormSubmissionWorker' } & Pick<
                JobsiteFormSubmissionWorker,
                'id' | 'extraData' | 'associationType'
              > & {
                  jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
                    JobsiteWorker,
                    | 'jobsiteWorkerId'
                    | 'trade'
                    | 'jobTitle'
                    | 'unionAffiliation'
                  > & {
                      contractorWorker: {
                        __typename?: 'ContractorWorker';
                      } & Pick<ContractorWorker, 'id'> & {
                          contractor: { __typename?: 'Contractor' } & Pick<
                            Contractor,
                            'contractorId'
                          > & {
                              organization: {
                                __typename?: 'Organization';
                              } & Pick<Organization, 'organizationId' | 'name'>;
                            };
                          worker: { __typename?: 'Worker' } & Pick<
                            Worker,
                            'workerId' | 'birthDate' | 'quickCode'
                          > & {
                              user: { __typename?: 'User' } & Pick<
                                User,
                                'userAccountId'
                              > & {
                                  identity?: Maybe<
                                    { __typename?: 'UserIdentity' } & Pick<
                                      UserIdentity,
                                      'firstName' | 'lastName'
                                    >
                                  >;
                                };
                              profilePictureCropped?: Maybe<
                                { __typename?: 'File' } & Pick<
                                  File,
                                  'downloadUrl'
                                >
                              >;
                            };
                        };
                      activeTempWorkerCard?: Maybe<
                        { __typename?: 'WorkerCard' } & Pick<
                          WorkerCard,
                          'workerCardId' | 'expiredAt' | 'cardNumber'
                        > & {
                            tempBadge?: Maybe<
                              { __typename?: 'TempBadge' } & Pick<
                                TempBadge,
                                'id' | 'name' | 'cardNumber'
                              >
                            >;
                          }
                      >;
                    };
                };
            }
          >;
        };
      documents: {
        __typename?: 'JobsiteFormSubmissionDocumentsConnection';
      } & Pick<JobsiteFormSubmissionDocumentsConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteFormSubmissionDocumentsEdge' } & {
              node: { __typename?: 'JobsiteFormSubmissionDocument' } & Pick<
                JobsiteFormSubmissionDocument,
                'id' | 'description' | 'associationType'
              > & {
                  files: Array<
                    { __typename?: 'File' } & Pick<
                      File,
                      'fileId' | 'fileType' | 'downloadUrl' | 'originalFileName'
                    >
                  >;
                  objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                    ObjectHistory,
                    'createdAt'
                  > & {
                      createdBy?: Maybe<
                        { __typename?: 'User' } & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName'
                            >
                          >;
                        }
                      >;
                    };
                };
            }
          >;
        };
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt' | 'updatedAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName' | 'phoneNumber' | 'email'
                  >
                >;
                worker?: Maybe<
                  { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                      profilePictureCropped?: Maybe<
                        { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                      >;
                      formSubmissionJobsiteWorker?: Maybe<
                        { __typename?: 'JobsiteWorker' } & Pick<
                          JobsiteWorker,
                          'trade' | 'jobTitle'
                        >
                      >;
                    }
                >;
              }
          >;
          updatedBy?: Maybe<
            { __typename?: 'User' } & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
              worker?: Maybe<
                { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                    profilePictureCropped?: Maybe<
                      { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                    >;
                  }
              >;
            }
          >;
        };
    };
};

export type FormUpdateMutationVariables = Exact<{
  input: FormUpdateInput;
}>;

export type FormUpdateMutation = { __typename?: 'Mutation' } & {
  formUpdate: { __typename?: 'FormUpdatePayload' } & {
    form: { __typename?: 'Form' } & Pick<Form, 'id'>;
  };
};

export type JobsiteUpdateFormSubmissionMutationVariables = Exact<{
  input: JobsiteUpdateFormSubmissionInput;
}>;

export type JobsiteUpdateFormSubmissionMutation = {
  __typename?: 'Mutation';
} & {
  jobsiteUpdateFormSubmission: {
    __typename?: 'JobsiteUpdateFormSubmissionPayload';
  } & {
    jobsiteFormSubmission: { __typename?: 'JobsiteFormSubmission' } & Pick<
      JobsiteFormSubmission,
      'id'
    >;
  };
};

export type JobsiteCloseOutMutationVariables = Exact<{
  input: JobsiteCloseOutInput;
}>;

export type JobsiteCloseOutMutation = { __typename?: 'Mutation' } & {
  jobsiteCloseOut: { __typename?: 'JobsiteCloseOutPayload' } & {
    jobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'>;
  };
};

export type JobsiteCreateMutationVariables = Exact<{
  input: JobsiteCreateInput;
}>;

export type JobsiteCreateMutation = { __typename?: 'Mutation' } & {
  jobsiteCreate: { __typename?: 'JobsiteCreatePayload' } & {
    jobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'>;
  };
};

export type GetJobsiteTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetJobsiteTemplatesQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          jobsites: { __typename?: 'UserJobsitesConnection' } & {
            edges: Array<
              { __typename?: 'UserJobsitesEdge' } & {
                node: { __typename?: 'Jobsite' } & Pick<
                  Jobsite,
                  'jobsiteId' | 'name'
                > & {
                    developer?: Maybe<
                      { __typename?: 'Developer' } & Pick<
                        Developer,
                        'developerId'
                      >
                    >;
                  };
              }
            >;
          };
        };
    }
  >;
};

export type GetJobsitesContainerCurrentSessionQueryVariables = Exact<{
  userJobsitesInput?: InputMaybe<UserJobsitesInput>;
}>;

export type GetJobsitesContainerCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          jobsites: { __typename?: 'UserJobsitesConnection' } & Pick<
            UserJobsitesConnection,
            'count' | 'templatesCount'
          > & {
              edges: Array<
                { __typename?: 'UserJobsitesEdge' } & {
                  node: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    | 'jobsiteId'
                    | 'name'
                    | 'addressCity'
                    | 'addressState'
                    | 'startDate'
                    | 'endDate'
                  > & {
                      developer?: Maybe<
                        { __typename?: 'Developer' } & Pick<
                          Developer,
                          'developerId'
                        > & {
                            organization: {
                              __typename?: 'Organization';
                            } & Pick<Organization, 'organizationId' | 'name'>;
                          }
                      >;
                    };
                }
              >;
              filtersOptions?: Maybe<
                { __typename?: 'UserJobsitesFilters' } & {
                  developers: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                  cities: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                  states: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                }
              >;
            };
        };
    }
  >;
};

export type AuthenticateLimitedTokenDetailsMutationVariables = Exact<{
  input: AuthenticateLimitedTokenDetailsInput;
}>;

export type AuthenticateLimitedTokenDetailsMutation = {
  __typename?: 'Mutation';
} & {
  authenticateLimitedTokenDetails: {
    __typename?: 'AuthenticateLimitedTokenDetailsResponse';
  } & Pick<AuthenticateLimitedTokenDetailsResponse, 'token'>;
};

export type GetRecentUserSearchQueriesQueryVariables = Exact<{
  searchQueryType?: InputMaybe<SearchQueryType>;
  count?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetRecentUserSearchQueriesQuery = { __typename?: 'Query' } & {
  getRecentUserSearchQueries: { __typename?: 'UserSearchQueryResponse' } & {
    results: Array<
      { __typename?: 'UserSearchQuery' } & Pick<
        UserSearchQuery,
        'searchQuery' | 'searchQueryType' | 'createdAt'
      >
    >;
  };
};

export type SaveUserSearchQueryMutationVariables = Exact<{
  input: UserSearchQueryInput;
}>;

export type SaveUserSearchQueryMutation = { __typename?: 'Mutation' } & {
  saveUserSearchQuery: { __typename?: 'Success' } & Pick<Success, 'success'>;
};

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;

export type DeleteOrganizationMutation = { __typename?: 'Mutation' } & {
  organizationDelete: { __typename?: 'OrganizationDeletePayload' } & {
    success: { __typename?: 'Success' } & Pick<Success, 'success'>;
  };
};

export type GetOrganizationContainerOrganizationInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  includeArchived: Scalars['Boolean']['input'];
}>;

export type GetOrganizationContainerOrganizationInfoQuery = {
  __typename?: 'Query';
} & {
  getOrganization: { __typename?: 'Organization' } & Pick<
    Organization,
    | 'organizationId'
    | 'name'
    | 'slug'
    | 'legalName'
    | 'email'
    | 'phoneNumber'
    | 'addressLine1'
    | 'addressLine2'
    | 'addressCity'
    | 'addressState'
    | 'addressZipCode'
  > & {
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt' | 'updatedAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName'
                  >
                >;
              }
          >;
          updatedBy?: Maybe<
            { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName'
                  >
                >;
              }
          >;
        };
      developers?: Maybe<
        { __typename: 'OrganizationDevelopersConnection' } & Pick<
          OrganizationDevelopersConnection,
          'count'
        > & {
            edges: Array<
              { __typename?: 'OrganizationDevelopersEdge' } & {
                node: { __typename: 'Developer' } & Pick<
                  Developer,
                  'developerId' | 'name'
                >;
              }
            >;
          }
      >;
      contractors?: Maybe<
        { __typename: 'OrganizationContractorsConnection' } & Pick<
          OrganizationContractorsConnection,
          'count'
        > & {
            edges: Array<
              { __typename: 'OrganizationContractorsEdge' } & {
                node: { __typename: 'Contractor' } & Pick<
                  Contractor,
                  'contractorId' | 'description' | 'websiteUrl'
                > & {
                    jobsiteContractors: {
                      __typename: 'ContractorJobsiteContractorsConnection';
                    } & Pick<ContractorJobsiteContractorsConnection, 'count'>;
                  };
              }
            >;
          }
      >;
    };
};

export type GetOrganizationsContainerCurrentSessionQueryVariables = Exact<{
  userOrganizationsInput?: InputMaybe<GetAllOrganizationsInput>;
}>;

export type GetOrganizationsContainerCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          organizations: { __typename?: 'UserOrganizationsConnection' } & Pick<
            UserOrganizationsConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserOrganizationsEdge' } & {
                  node: { __typename?: 'Organization' } & Pick<
                    Organization,
                    | 'name'
                    | 'legalName'
                    | 'organizationId'
                    | 'slug'
                    | 'addressLine1'
                    | 'addressLine2'
                    | 'addressCity'
                    | 'addressState'
                    | 'addressZipCode'
                    | 'email'
                    | 'phoneNumber'
                  > & {
                      contractors?: Maybe<
                        {
                          __typename: 'OrganizationContractorsConnection';
                        } & Pick<OrganizationContractorsConnection, 'count'> & {
                            edges: Array<
                              { __typename?: 'OrganizationContractorsEdge' } & {
                                node: { __typename: 'Contractor' } & Pick<
                                  Contractor,
                                  'contractorId'
                                >;
                              }
                            >;
                          }
                      >;
                      developers?: Maybe<
                        {
                          __typename: 'OrganizationDevelopersConnection';
                        } & Pick<OrganizationDevelopersConnection, 'count'> & {
                            edges: Array<
                              { __typename?: 'OrganizationDevelopersEdge' } & {
                                node: { __typename: 'Developer' } & Pick<
                                  Developer,
                                  'developerId'
                                >;
                              }
                            >;
                          }
                      >;
                    };
                }
              >;
            };
        };
    }
  >;
};

export type PolicyConsentStatusFieldsFragment = {
  __typename?: 'UserPolicyConsentStatus';
} & Pick<UserPolicyConsentStatus, 'lastAcceptedVersion' | 'lastAcceptedAt'> & {
    document: { __typename?: 'PolicyDocument' } & Pick<
      PolicyDocument,
      'id' | 'key' | 'version' | 'effectiveAt'
    >;
  };

export type GetPrintWorkerDataQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type GetPrintWorkerDataQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & Pick<
    Worker,
    | 'workerId'
    | 'middleInitial'
    | 'suffix'
    | 'addressLine1'
    | 'addressLine2'
    | 'addressCity'
    | 'addressState'
    | 'addressZipCode'
    | 'birthDate'
    | 'emergencyContactName'
    | 'emergencyContactPhone'
    | 'emergencyContactRelationship'
    | 'gender'
    | 'primaryLanguage'
    | 'race'
    | 'isSkilled'
    | 'ssnLastFour'
    | 'isVeteran'
    | 'quickCode'
  > & {
      profilePicture?: Maybe<
        { __typename?: 'File' } & Pick<File, 'downloadUrl' | 'uploadedAt'>
      >;
      profilePictureCropped?: Maybe<
        { __typename?: 'File' } & Pick<
          File,
          'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
        >
      >;
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              'firstName' | 'lastName' | 'email' | 'phoneNumber'
            >
          >;
        };
      contractorWorkers: {
        __typename?: 'WorkerContractorWorkersConnection';
      } & {
        edges: Array<
          { __typename?: 'WorkerContractorWorkersEdge' } & {
            node: { __typename?: 'ContractorWorker' } & Pick<
              ContractorWorker,
              'id' | 'startDate' | 'endDate' | 'payrollId'
            > & {
                contractor: { __typename?: 'Contractor' } & Pick<
                  Contractor,
                  'contractorId'
                > & {
                    organization: { __typename?: 'Organization' } & Pick<
                      Organization,
                      'organizationId' | 'name'
                    >;
                  };
              };
          }
        >;
      };
      jobsiteWorkers: { __typename?: 'WorkerJobsiteWorkersConnection' } & {
        edges: Array<
          { __typename?: 'WorkerJobsiteWorkersEdge' } & {
            node: { __typename?: 'JobsiteWorker' } & Pick<
              JobsiteWorker,
              | 'jobsiteWorkerId'
              | 'unionAffiliation'
              | 'isBanned'
              | 'bannedReason'
              | 'bannedAt'
              | 'startDate'
              | 'endDate'
              | 'payrollId'
              | 'stickerNumber'
              | 'orientationDate'
              | 'orientationStatus'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'name' | 'jobsiteId'
                  >;
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name'
                      >;
                    };
                };
                currentAccess: {
                  __typename?: 'JobsiteWorkerCurrentAccess';
                } & Pick<JobsiteWorkerCurrentAccess, 'endDate' | 'isAllowed'>;
              };
          }
        >;
      };
      workerComments: { __typename?: 'WorkerWorkerCommentsConnection' } & {
        edges: Array<
          { __typename?: 'WorkerWorkerCommentsEdge' } & {
            node: { __typename?: 'WorkerComment' } & Pick<
              WorkerComment,
              'workerCommentId' | 'comment'
            > & {
                jobsite?: Maybe<
                  { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'name' | 'jobsiteId'
                  >
                >;
                objectHistory?: Maybe<
                  { __typename?: 'ObjectHistory' } & Pick<
                    ObjectHistory,
                    'createdAt' | 'updatedAt'
                  > & {
                      createdBy?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'userAccountId'
                        > & {
                            identity?: Maybe<
                              { __typename?: 'UserIdentity' } & Pick<
                                UserIdentity,
                                'firstName' | 'lastName' | 'email'
                              >
                            >;
                          }
                      >;
                      updatedBy?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'userAccountId'
                        > & {
                            identity?: Maybe<
                              { __typename?: 'UserIdentity' } & Pick<
                                UserIdentity,
                                'firstName' | 'lastName' | 'email'
                              >
                            >;
                          }
                      >;
                    }
                >;
              };
          }
        >;
      };
    };
};

export type GenerateLookerJobsiteWorkerReportMutationVariables = Exact<{
  jobsiteIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  realtime?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  export?: InputMaybe<Scalars['Boolean']['input']>;
  trade?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  contractor?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  compliant?: InputMaybe<Scalars['Boolean']['input']>;
  overnight?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GenerateLookerJobsiteWorkerReportMutation = {
  __typename?: 'Mutation';
} & {
  generateLookerJobsiteWorkerReport: { __typename?: 'File' } & Pick<
    File,
    'fileId' | 'fileType' | 'uploadedAt' | 'downloadUrl' | 'originalFileName'
  >;
};

export type GetJobsiteWorkerDashboardQueryVariables = Exact<{
  jobsiteIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  timeBreakdown?: InputMaybe<GetJobsiteWorkerReportsTimeBreakdown>;
  realtime?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  export?: InputMaybe<Scalars['Boolean']['input']>;
  trade?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  contractor?: InputMaybe<
    Array<Scalars['String']['input']> | Scalars['String']['input']
  >;
  fitoutTenant?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  compliant?: InputMaybe<Scalars['Boolean']['input']>;
  overnight?: InputMaybe<Scalars['Boolean']['input']>;
  workerIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
}>;

export type GetJobsiteWorkerDashboardQuery = { __typename?: 'Query' } & {
  getJobsiteWorkerDashboard?: Maybe<
    { __typename?: 'GetJobsiteWorkerDashboardResponse' } & Pick<
      GetJobsiteWorkerDashboardResponse,
      'contractorOptions' | 'totalCount'
    > & {
        jobsites: Array<
          { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId' | 'name'>
        >;
        contractorBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        tradeBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        jobTitleBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        activeBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        compliantBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        jobsiteBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        overviewBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'compliantCount' | 'percentage'
            >
          >
        >;
        dailyBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count'
            >
          >
        >;
        languageBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        genderBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        raceBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        zipcodeBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        ageBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        onboardedBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        bannedBreakdowns?: Maybe<
          Array<
            { __typename?: 'ElasticFacetEntry' } & Pick<
              ElasticFacetEntry,
              'name' | 'count' | 'percentage'
            >
          >
        >;
        results: Array<
          { __typename?: 'DashboardJobsiteWorkerSession' } & Pick<
            DashboardJobsiteWorkerSession,
            | 'swipeSessionsSessionId'
            | 'swipeSessionsJobsiteWorkerId'
            | 'contractorOrganizationName'
            | 'jobsiteName'
            | 'profile'
            | 'swipeSessionsFirstInboundSwipeTimeOfDay'
            | 'swipeSessionsLastOutboundSwipeTimeOfDay'
            | 'swipeSessionsNetTotalSpanHours'
            | 'swipeSessionsDisplayValueSpanHours'
            | 'swipeSessionsOvernightSession'
            | 'swipeSessionsSessionDate'
            | 'userIdentityUserFullname'
            | 'workerWorkerId'
            | 'workerJobTitle'
            | 'workerTrade'
            | 'workerUnionAffiliation'
            | 'workerQuickCode'
            | 'croppedDownloadKey'
            | 'publicUrl'
          >
        >;
      }
  >;
};

export type ImportScheduleMutationVariables = Exact<{
  input: ImportScheduleInput;
}>;

export type ImportScheduleMutation = { __typename?: 'Mutation' } & {
  importSchedule: { __typename?: 'ImportSchedulePayload' } & {
    schedule: { __typename?: 'Schedule' } & Pick<Schedule, 'id'>;
  };
};

export type GetScheduleImportTargetQueryVariables = Exact<{
  input: ScheduleInput;
}>;

export type GetScheduleImportTargetQuery = { __typename?: 'Query' } & {
  getSchedule?: Maybe<
    { __typename?: 'Schedule' } & Pick<Schedule, 'id' | 'date' | 'status'> & {
        jobsite: { __typename?: 'Jobsite' } & Pick<
          Jobsite,
          'jobsiteId' | 'name'
        >;
        shifts: Array<
          { __typename?: 'ScheduleShift' } & Pick<ScheduleShift, 'id'> & {
              workers: { __typename?: 'ScheduleWorkersConnection' } & Pick<
                ScheduleWorkersConnection,
                'count'
              > & {
                  edges: Array<
                    { __typename?: 'ScheduleWorkerEdge' } & {
                      node?: Maybe<
                        { __typename?: 'ScheduleWorker' } & Pick<
                          ScheduleWorker,
                          'id'
                        >
                      >;
                    }
                  >;
                };
            }
        >;
      }
  >;
};

export type GetSchedulesQueryVariables = Exact<{
  schedulesInput: SchedulesInput;
}>;

export type GetSchedulesQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & {
        schedules: { __typename?: 'SchedulesConnection' } & Pick<
          SchedulesConnection,
          'count'
        > & {
            edges: Array<
              { __typename?: 'ScheduleEdge' } & {
                node?: Maybe<
                  { __typename?: 'Schedule' } & Pick<
                    Schedule,
                    'id' | 'date' | 'status' | 'notifiedAt'
                  > & {
                      scheduler: { __typename?: 'User' } & Pick<
                        User,
                        'userAccountId'
                      > & {
                          profilePictureCropped?: Maybe<
                            { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                          >;
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName'
                            >
                          >;
                        };
                      jobsite: { __typename?: 'Jobsite' } & Pick<
                        Jobsite,
                        'jobsiteId' | 'name'
                      > & {
                          developer?: Maybe<
                            { __typename?: 'Developer' } & Pick<
                              Developer,
                              'developerId' | 'name'
                            >
                          >;
                        };
                    }
                >;
              }
            >;
            filtersOptions?: Maybe<
              { __typename?: 'SchedulesFilters' } & {
                schedulerAccountIds: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label'
                  >
                >;
              }
            >;
          };
      };
    }
  >;
};

export type SearchWorkersQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type SearchWorkersQuery = { __typename?: 'Query' } & {
  searchWorkers: { __typename?: 'WorkerSearchResponse' } & Pick<
    WorkerSearchResponse,
    'count'
  > & {
      results: Array<
        { __typename?: 'WorkerSearchResult' } & {
          worker: { __typename?: 'Worker' } & Pick<
            Worker,
            'workerId' | 'quickCode'
          > & {
              user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                  identity?: Maybe<
                    { __typename?: 'UserIdentity' } & Pick<
                      UserIdentity,
                      'firstName' | 'lastName'
                    >
                  >;
                };
              profilePictureCropped?: Maybe<
                { __typename?: 'File' } & Pick<File, 'downloadUrl'>
              >;
              jobsiteWorkers: {
                __typename?: 'WorkerJobsiteWorkersConnection';
              } & {
                edges: Array<
                  { __typename?: 'WorkerJobsiteWorkersEdge' } & {
                    node: { __typename?: 'JobsiteWorker' } & Pick<
                      JobsiteWorker,
                      'trade' | 'jobTitle'
                    >;
                  }
                >;
              };
            };
        }
      >;
    };
};

export type CompleteAnonymousPhoneVerificationMutationVariables = Exact<{
  input: CompleteAnonymousPhoneVerificationInput;
}>;

export type CompleteAnonymousPhoneVerificationMutation = {
  __typename?: 'Mutation';
} & {
  completeAnonymousPhoneVerification: {
    __typename?: 'CompleteAnonymousPhoneVerificationResponse';
  } & Pick<
    CompleteAnonymousPhoneVerificationResponse,
    'success' | 'token' | 'selfOnboardingCurrentStep'
  > & {
      auth?: Maybe<
        { __typename?: 'Auth' } & {
          user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            };
          session: { __typename?: 'UserSession' } & Pick<
            UserSession,
            'sessionToken'
          >;
        }
      >;
    };
};

export type CompletePhoneNumberVerificationMutationVariables = Exact<{
  input: CompletePhoneNumberVerificationInput;
}>;

export type CompletePhoneNumberVerificationMutation = {
  __typename?: 'Mutation';
} & {
  completePhoneNumberVerification: {
    __typename?: 'CompletePhoneNumberVerificationResponse';
  } & Pick<CompletePhoneNumberVerificationResponse, 'success'> & {
      worker?: Maybe<
        { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
            editableFields: { __typename?: 'EditableFields' } & Pick<
              EditableFields,
              'phone' | 'email'
            >;
          }
      >;
    };
};

export type CompletePhoneNumberVerificationAndSignInMutationVariables = Exact<{
  input: CompletePhoneNumberVerificationAndSignInInput;
}>;

export type CompletePhoneNumberVerificationAndSignInMutation = {
  __typename?: 'Mutation';
} & {
  completePhoneNumberVerificationAndSignIn: {
    __typename?: 'CompletePhoneNumberVerificationAndSignInResponse';
  } & Pick<CompletePhoneNumberVerificationAndSignInResponse, 'success'> & {
      auth: { __typename?: 'Auth' } & {
        user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
            identity?: Maybe<
              { __typename?: 'UserIdentity' } & Pick<
                UserIdentity,
                'firstName' | 'lastName'
              >
            >;
          };
        session: { __typename?: 'UserSession' } & Pick<
          UserSession,
          'sessionToken'
        >;
      };
      selfOnboardingInfo: { __typename?: 'SelfOnboardingWorkerInfo' } & Pick<
        SelfOnboardingWorkerInfo,
        'jobsiteWorkerId' | 'continueAction' | 'abortReason'
      >;
      jobsiteWorker?: Maybe<
        { __typename?: 'JobsiteWorker' } & Pick<
          JobsiteWorker,
          'jobsiteWorkerId'
        > & {
            contractorWorker: { __typename?: 'ContractorWorker' } & {
              worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                  editableFields: { __typename?: 'EditableFields' } & Pick<
                    EditableFields,
                    'phone' | 'email'
                  >;
                };
            };
          }
      >;
    };
};

export type SelfOnboardingAssignToJobsiteMutationVariables = Exact<{
  input: SelfOnboardingAssignToJobsiteInput;
}>;

export type SelfOnboardingAssignToJobsiteMutation = {
  __typename?: 'Mutation';
} & {
  selfOnboardingAssignToJobsite: {
    __typename?: 'SelfOnboardingAssignToJobsitePayload';
  } & {
    jobsiteWorker?: Maybe<
      { __typename?: 'JobsiteWorker' } & Pick<
        JobsiteWorker,
        'jobsiteWorkerId'
      > & {
          contractorWorker: { __typename?: 'ContractorWorker' } & {
            worker: { __typename?: 'Worker' } & Pick<
              Worker,
              'workerId' | 'isAssignedToMultipleJobsites'
            >;
          };
        }
    >;
    selfOnboardingInfo: { __typename?: 'SelfOnboardingWorkerInfo' } & Pick<
      SelfOnboardingWorkerInfo,
      'jobsiteWorkerId' | 'continueAction' | 'abortReason'
    >;
  };
};

export type SelfOnboardingCreateAccountMutationVariables = Exact<{
  input: SelfOnboardingCreateAccountInput;
}>;

export type SelfOnboardingCreateAccountMutation = {
  __typename?: 'Mutation';
} & {
  selfOnboardingCreateAccount: {
    __typename?: 'SelfOnboardingCreateAccountPayload';
  } & {
    auth: { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              'firstName' | 'lastName'
            >
          >;
        };
      session: { __typename?: 'UserSession' } & Pick<
        UserSession,
        'sessionToken'
      >;
    };
    worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId' | 'quickCode'>;
  };
};

export type SelfOnboardingWorkerCreateMutationVariables = Exact<{
  input: SelfOnboardingWorkerAccountCreateInput;
}>;

export type SelfOnboardingWorkerCreateMutation = { __typename?: 'Mutation' } & {
  selfOnboardingWorkerCreate: {
    __typename?: 'SelfOnboardingWorkerCreatePayload';
  } & {
    jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
      JobsiteWorker,
      'jobsiteWorkerId'
    > & {
        contractorWorker: { __typename?: 'ContractorWorker' } & {
          worker: { __typename?: 'Worker' } & Pick<
            Worker,
            'workerId' | 'quickCode'
          >;
        };
      };
    auth: { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              'firstName' | 'lastName'
            >
          >;
        };
      session: { __typename?: 'UserSession' } & Pick<
        UserSession,
        'sessionToken'
      >;
    };
  };
};

export type SelfOnboardingWorkerUpdateMutationVariables = Exact<{
  input: SelfOnboardingWorkerAccountUpdateInput;
}>;

export type SelfOnboardingWorkerUpdateMutation = { __typename?: 'Mutation' } & {
  selfOnboardingWorkerUpdate: {
    __typename?: 'SelfOnboardingWorkerUpdatePayload';
  } & { worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> };
};

export type StartAnonymousPhoneVerificationMutationVariables = Exact<{
  input: StartAnonymousPhoneVerificationInput;
}>;

export type StartAnonymousPhoneVerificationMutation = {
  __typename?: 'Mutation';
} & {
  startAnonymousPhoneVerification: {
    __typename?: 'StartAnonymousPhoneVerificationResponse';
  } & Pick<StartAnonymousPhoneVerificationResponse, 'success'>;
};

export type StartPhoneNumberVerificationMutationVariables = Exact<{
  input: StartPhoneNumberVerificationInput;
}>;

export type StartPhoneNumberVerificationMutation = {
  __typename?: 'Mutation';
} & {
  startPhoneNumberVerification: {
    __typename?: 'StartPhoneNumberVerificationResponse';
  } & Pick<StartPhoneNumberVerificationResponse, 'success'>;
};

export type UpsertJobsiteWorkerDocumentMutationVariables = Exact<{
  input: JobsiteWorkerDocumentUpsertInput;
}>;

export type UpsertJobsiteWorkerDocumentMutation = {
  __typename?: 'Mutation';
} & {
  upsertJobsiteWorkerDocument: {
    __typename?: 'JobsiteWorkerDocumentVersion';
  } & Pick<JobsiteWorkerDocumentVersion, 'jobsiteWorkerDocumentVersionId'> & {
      files: Array<
        { __typename?: 'File' } & Pick<
          File,
          | 'fileId'
          | 'fileType'
          | 'downloadUrl'
          | 'originalFileName'
          | 'uploadedAt'
        >
      >;
      additionalFieldValues?: Maybe<
        Array<
          { __typename?: 'AdditionalFieldValue' } & Pick<
            AdditionalFieldValue,
            'key' | 'value'
          >
        >
      >;
    };
};

export type GetSelfOnboardingContainerSessionQueryVariables = Exact<{
  jobsiteWorkersInput: WorkerJobsiteWorkersInput;
  workerDocumentsInput: WorkerDocumentsInput;
}>;

export type GetSelfOnboardingContainerSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      policyConsentStatuses: Array<
        { __typename?: 'UserPolicyConsentStatus' } & Pick<
          UserPolicyConsentStatus,
          'lastAcceptedVersion' | 'lastAcceptedAt'
        > & {
            document: { __typename?: 'PolicyDocument' } & Pick<
              PolicyDocument,
              'id' | 'key' | 'version' | 'effectiveAt'
            >;
          }
      >;
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              | 'firstName'
              | 'lastName'
              | 'email'
              | 'phoneNumber'
              | 'smsConsentReceivedAt'
            >
          >;
          worker?: Maybe<
            { __typename?: 'Worker' } & Pick<
              Worker,
              | 'workerId'
              | 'quickCode'
              | 'middleInitial'
              | 'suffix'
              | 'birthDate'
              | 'ssnLastFour'
              | 'addressLine1'
              | 'addressLine2'
              | 'addressCity'
              | 'addressState'
              | 'addressZipCode'
              | 'primaryLanguage'
              | 'citizenshipStatus'
              | 'workAuthorizationStatus'
              | 'race'
              | 'gender'
              | 'isVeteran'
              | 'emergencyContactName'
              | 'emergencyContactRelationship'
              | 'emergencyContactPhone'
              | 'selfOnboardingCurrentStep'
              | 'isAssignedToMultipleJobsites'
            > & {
                profilePicture?: Maybe<
                  { __typename?: 'File' } & Pick<
                    File,
                    'fileId' | 'fileType' | 'downloadUrl' | 'uploadedAt'
                  >
                >;
                editableFields: { __typename?: 'EditableFields' } & Pick<
                  EditableFields,
                  'email' | 'phone'
                >;
                jobsiteWorkers: {
                  __typename?: 'WorkerJobsiteWorkersConnection';
                } & {
                  edges: Array<
                    { __typename?: 'WorkerJobsiteWorkersEdge' } & {
                      node: { __typename?: 'JobsiteWorker' } & Pick<
                        JobsiteWorker,
                        | 'jobsiteWorkerId'
                        | 'trade'
                        | 'jobTitle'
                        | 'tradeExperience'
                        | 'unionAffiliation'
                        | 'classificationGroup'
                        | 'customWorkerData'
                      > & {
                          jobsiteContractor: {
                            __typename?: 'JobsiteContractor';
                          } & Pick<JobsiteContractor, 'id'> & {
                              contractor: { __typename?: 'Contractor' } & Pick<
                                Contractor,
                                'contractorId' | 'isDefaultContractor'
                              > & {
                                  organization: {
                                    __typename?: 'Organization';
                                  } & Pick<
                                    Organization,
                                    'organizationId' | 'name'
                                  >;
                                };
                              jobsite: { __typename?: 'Jobsite' } & Pick<
                                Jobsite,
                                | 'jobsiteId'
                                | 'tradeOptions'
                                | 'titleOptions'
                                | 'unionAffiliationOptions'
                              >;
                            };
                        };
                    }
                  >;
                };
                documents: { __typename?: 'WorkerDocumentsConnection' } & {
                  edges: Array<
                    { __typename?: 'WorkerDocumentsEdge' } & {
                      node: { __typename?: 'JobsiteWorkerDocument' } & Pick<
                        JobsiteWorkerDocument,
                        'jobsiteWorkerDocumentId'
                      > & {
                          jobsiteWorkerDocumentType: {
                            __typename?: 'JobsiteWorkerDocumentType';
                          } & Pick<
                            JobsiteWorkerDocumentType,
                            'id' | 'key' | 'name'
                          > & {
                              workerDocumentType: {
                                __typename?: 'WorkerDocumentType';
                              } & Pick<WorkerDocumentType, 'key'>;
                            };
                          latestVersion: {
                            __typename?: 'JobsiteWorkerDocumentVersion';
                          } & Pick<
                            JobsiteWorkerDocumentVersion,
                            'jobsiteWorkerDocumentVersionId'
                          > & {
                              additionalFieldValues?: Maybe<
                                Array<
                                  {
                                    __typename?: 'AdditionalFieldValue';
                                  } & Pick<
                                    AdditionalFieldValue,
                                    'key' | 'value'
                                  >
                                >
                              >;
                              files: Array<
                                { __typename?: 'File' } & Pick<
                                  File,
                                  'fileId' | 'fileType' | 'downloadUrl'
                                >
                              >;
                            };
                        };
                    }
                  >;
                };
              }
          >;
        };
    }
  >;
};

export type GetSelfOnboardingCurrentStepQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSelfOnboardingCurrentStepQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          worker?: Maybe<
            { __typename?: 'Worker' } & Pick<
              Worker,
              'workerId' | 'selfOnboardingCurrentStep'
            >
          >;
        };
    }
  >;
};

export type SetMyPinMutationVariables = Exact<{
  input: SetMyPinInput;
}>;

export type SetMyPinMutation = { __typename?: 'Mutation' } & {
  setMyPin: { __typename?: 'Success' } & Pick<Success, 'success'>;
};

export type GetMyPinQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyPinQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          pin?: Maybe<
            { __typename?: 'UserPin' } & Pick<
              UserPin,
              'pinSetAt' | 'failedAttempts' | 'lockedUntil'
            >
          >;
        };
    }
  >;
};

export type UserCancelPendingChangeMutationVariables = Exact<{
  input: UserCancelPendingChangeInput;
}>;

export type UserCancelPendingChangeMutation = { __typename?: 'Mutation' } & {
  userCancelPendingChange: { __typename?: 'Success' } & Pick<
    Success,
    'success'
  >;
};

export type UserConfirmPendingChangeMutationVariables = Exact<{
  input: UserConfirmPendingChangeInput;
}>;

export type UserConfirmPendingChangeMutation = { __typename?: 'Mutation' } & {
  userConfirmPendingChange: { __typename?: 'UserPayload' } & {
    user: { __typename?: 'User' } & Pick<User, 'userAccountId'>;
  };
};

export type GetUserPendingChangeQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  changeType: UserPendingChangeType;
}>;

export type GetUserPendingChangeQuery = { __typename?: 'Query' } & {
  getUserPendingChange: { __typename?: 'UserPendingChangePayload' } & {
    change?: Maybe<
      { __typename?: 'UserPendingChange' } & Pick<
        UserPendingChange,
        'currentValue' | 'newValue' | 'expiresAt'
      > & {
          submittedBy: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            };
        }
    >;
  };
};

export type UserAssignMutationVariables = Exact<{
  input: UserAssignInput;
}>;

export type UserAssignMutation = { __typename?: 'Mutation' } & {
  userAssign: { __typename?: 'UserPayload' } & {
    user: { __typename?: 'User' } & Pick<User, 'userAccountId'>;
  };
};

export type UserCreateMutationVariables = Exact<{
  input: UserCreateInput;
}>;

export type UserCreateMutation = { __typename?: 'Mutation' } & {
  userCreate: { __typename?: 'UserPayload' } & {
    user: { __typename?: 'User' } & Pick<User, 'userAccountId'>;
  };
};

export type UserRemoveAssignmentMutationVariables = Exact<{
  input: UserRemoveAssignmentInput;
}>;

export type UserRemoveAssignmentMutation = { __typename?: 'Mutation' } & {
  userRemoveAssignment: { __typename?: 'UserPayload' } & {
    user: { __typename?: 'User' } & Pick<User, 'userAccountId'>;
  };
};

export type UserUpdateAssignmentMutationVariables = Exact<{
  input: UserUpdateAssignmentInput;
}>;

export type UserUpdateAssignmentMutation = { __typename?: 'Mutation' } & {
  userUpdateAssignment: { __typename?: 'UserPayload' } & {
    user: { __typename?: 'User' } & Pick<User, 'userAccountId'>;
  };
};

export type GetUserRoleModalContractorsQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  availableRoleObjectsInput?: InputMaybe<UserAvailableRoleObjectsInput>;
}>;

export type GetUserRoleModalContractorsQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & {
    user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
        availableRoleObjects: {
          __typename?: 'UserAvailableRoleObjectsConnection';
        } & {
          contractors: Array<
            { __typename?: 'Contractor' } & Pick<Contractor, 'contractorId'> & {
                organization: { __typename?: 'Organization' } & Pick<
                  Organization,
                  'organizationId' | 'name'
                >;
              }
          >;
        };
      };
  };
};

export type GetUserRoleModalJobsitesQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  availableRoleObjectsInput?: InputMaybe<UserAvailableRoleObjectsInput>;
}>;

export type GetUserRoleModalJobsitesQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & {
    user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
        availableRoleObjects: {
          __typename?: 'UserAvailableRoleObjectsConnection';
        } & {
          jobsites: Array<
            { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId' | 'name'>
          >;
        };
      };
  };
};

export type GetUsersQueryVariables = Exact<{
  usersInput?: InputMaybe<UserUsersInput>;
}>;

export type GetUsersQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & {
        users: { __typename?: 'UserUsersConnection' } & Pick<
          UserUsersConnection,
          'jobsiteUsersCount' | 'contractorUsersCount' | 'developerUsersCount'
        > & {
            edges: Array<
              { __typename?: 'UserUsersEdge' } & {
                node: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    roles: Array<
                      { __typename?: 'UserRole' } & Pick<
                        UserRole,
                        'key' | 'displayName'
                      > & {
                          object?: Maybe<
                            { __typename?: 'UserRoleObject' } & Pick<
                              UserRoleObject,
                              'objectId'
                            > & {
                                objectDetails?: Maybe<
                                  {
                                    __typename?: 'UserRoleObjectDetails';
                                  } & Pick<UserRoleObjectDetails, 'name'>
                                >;
                              }
                          >;
                        }
                    >;
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName' | 'email' | 'phoneNumber'
                      >
                    >;
                    worker?: Maybe<
                      { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                          profilePictureCropped?: Maybe<
                            { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                          >;
                        }
                    >;
                    lastSession?: Maybe<
                      { __typename?: 'UserSession' } & Pick<
                        UserSession,
                        'createdAt' | 'appVersion'
                      >
                    >;
                  };
              }
            >;
          };
      };
    }
  >;
};

export type GetWorkerAccessRestorePreviewQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  workerId: Scalars['ID']['input'];
}>;

export type GetWorkerAccessRestorePreviewQuery = { __typename?: 'Query' } & {
  workerAccessRestorePreview: {
    __typename?: 'WorkerAccessRestorePreview';
  } & Pick<WorkerAccessRestorePreview, 'status' | 'totalCount'> & {
      groups: Array<
        { __typename?: 'WorkerAccessRestoreGroup' } & Pick<
          WorkerAccessRestoreGroup,
          'id' | 'name'
        >
      >;
    };
};

export type ArchiveJobsiteWorkerAccessEventMutationVariables = Exact<{
  input: ArchiveJobsiteWorkerAccessEventInput;
}>;

export type ArchiveJobsiteWorkerAccessEventMutation = {
  __typename?: 'Mutation';
} & {
  archiveJobsiteWorkerAccessEvent?: Maybe<
    { __typename?: 'ArchiveJobsiteWorkerAccessEventResponse' } & Pick<
      ArchiveJobsiteWorkerAccessEventResponse,
      'accessEventId'
    > & { success: { __typename?: 'Success' } & Pick<Success, 'success'> }
  >;
};

export type ChangeContractorForJobsiteWorkersMutationVariables = Exact<{
  input?: InputMaybe<ChangeContractorForJobsiteWorkersInput>;
}>;

export type ChangeContractorForJobsiteWorkersMutation = {
  __typename?: 'Mutation';
} & {
  changeContractorForJobsiteWorkers: {
    __typename?: 'ChangeContractorForJobsiteWorkersResponse';
  } & {
    changeContractorForJobsiteWorkersSuccess: Array<
      Maybe<
        { __typename?: 'ChangeContractorForJobsiteWorkersSuccess' } & {
          jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
            JobsiteWorker,
            'jobsiteWorkerId' | 'startDate'
          > & {
              contractorWorker: { __typename?: 'ContractorWorker' } & {
                worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                    user: { __typename?: 'User' } & {
                      identity?: Maybe<
                        { __typename?: 'UserIdentity' } & Pick<
                          UserIdentity,
                          'firstName' | 'lastName'
                        >
                      >;
                    };
                  };
              };
              jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                jobsite: { __typename?: 'Jobsite' } & Pick<
                  Jobsite,
                  'jobsiteId' | 'name'
                >;
              };
            };
        }
      >
    >;
    changeContractorForJobsiteWorkersError: Array<
      Maybe<
        { __typename?: 'ChangeContractorForJobsiteWorkersError' } & Pick<
          ChangeContractorForJobsiteWorkersError,
          'errorMessage'
        >
      >
    >;
  };
};

export type ChangeJobsiteWorkersJobsiteAssignmentMutationVariables = Exact<{
  input: ChangeJobsiteWorkersJobsiteAssignmentInput;
}>;

export type ChangeJobsiteWorkersJobsiteAssignmentMutation = {
  __typename?: 'Mutation';
} & {
  changeJobsiteWorkersJobsiteAssignment: {
    __typename?: 'ChangeJobsiteWorkersJobsiteAssignmentResponse';
  } & Pick<ChangeJobsiteWorkersJobsiteAssignmentResponse, 'totalCount'> & {
      edges: Array<
        { __typename?: 'JobsiteWorker' } & Pick<
          JobsiteWorker,
          'jobsiteWorkerId'
        > & {
            jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
              jobsite: { __typename?: 'Jobsite' } & Pick<
                Jobsite,
                'jobsiteId' | 'name'
              >;
            };
          }
      >;
    };
};

export type CheckInJobsiteWorkersMutationVariables = Exact<{
  input: CheckInJobsiteWorkersInput;
}>;

export type CheckInJobsiteWorkersMutation = { __typename?: 'Mutation' } & {
  checkInJobsiteWorkers: {
    __typename?: 'JobsiteWorkerCheckInConnection';
  } & Pick<JobsiteWorkerCheckInConnection, 'totalCount'> & {
      edges: Array<
        { __typename?: 'JobsiteWorkerCheckIn' } & Pick<
          JobsiteWorkerCheckIn,
          'id' | 'checkInDateTime'
        > & {
            area: { __typename?: 'JobsiteAppCheckInModuleArea' } & Pick<
              JobsiteAppCheckInModuleArea,
              'id' | 'name'
            >;
            jobsiteWorker?: Maybe<
              { __typename?: 'JobsiteWorker' } & Pick<
                JobsiteWorker,
                'jobsiteWorkerId'
              > & {
                  jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                    jobsite: { __typename?: 'Jobsite' } & Pick<
                      Jobsite,
                      'name' | 'jobsiteId'
                    >;
                  };
                  contractorWorker: { __typename?: 'ContractorWorker' } & {
                    worker: { __typename?: 'Worker' } & Pick<
                      Worker,
                      'workerId'
                    >;
                  };
                }
            >;
          }
      >;
    };
};

export type CompleteSelfOnBoardingMutationVariables = Exact<{
  jobsiteWorkerId: Scalars['ID']['input'];
}>;

export type CompleteSelfOnBoardingMutation = { __typename?: 'Mutation' } & {
  completeSelfOnBoarding: { __typename?: 'JobsiteWorker' } & Pick<
    JobsiteWorker,
    'jobsiteWorkerId' | 'orientationStatus' | 'orientationDate'
  > & {
      contractorWorker: { __typename?: 'ContractorWorker' } & {
        worker: { __typename?: 'Worker' } & Pick<
          Worker,
          'workerId' | 'selfOnboardingCurrentStep'
        >;
      };
    };
};

export type EnableJobsiteWorkerSelfOnboardingMutationVariables = Exact<{
  jobsiteWorkerId: Scalars['ID']['input'];
}>;

export type EnableJobsiteWorkerSelfOnboardingMutation = {
  __typename?: 'Mutation';
} & {
  enableJobsiteWorkerSelfOnboarding: { __typename?: 'JobsiteWorker' } & Pick<
    JobsiteWorker,
    'jobsiteWorkerId' | 'orientationStatus'
  >;
};

export type ManuallyEnterCardNumberForPrintJobMutationVariables = Exact<{
  cardPrintJobId: Scalars['ID']['input'];
  cardNumber: Scalars['String']['input'];
  workerCardFormatId: Scalars['ID']['input'];
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ManuallyEnterCardNumberForPrintJobMutation = {
  __typename?: 'Mutation';
} & {
  manuallyEnterCardNumberForPrintJob: { __typename?: 'WorkerCard' } & Pick<
    WorkerCard,
    'workerCardId' | 'cardNumber'
  > & {
      workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
        WorkerCardFormat,
        'workerCardFormatId' | 'name'
      >;
    };
};

export type ReactivateWorkerCardMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;

export type ReactivateWorkerCardMutation = { __typename?: 'Mutation' } & {
  reactivateWorkerCard: { __typename?: 'Success' } & Pick<Success, 'success'>;
};

export type RemoveWorkerFromJobsiteMutationVariables = Exact<{
  input: RemoveWorkerFromJobsiteInput;
}>;

export type RemoveWorkerFromJobsiteMutation = { __typename?: 'Mutation' } & {
  removeWorkerFromJobsite: {
    __typename?: 'RemoveWorkerFromJobsiteResponse';
  } & { success: { __typename?: 'Success' } & Pick<Success, 'success'> };
};

export type UpdateJobsiteWorkerMutationVariables = Exact<{
  jobsiteWorkerId: Scalars['ID']['input'];
  jobsiteWorkerInput: JobsiteWorkerInput;
  skipACSSync?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateJobsiteWorkerMutation = { __typename?: 'Mutation' } & {
  updateJobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
    JobsiteWorker,
    'orientationDate' | 'trade' | 'jobTitle' | 'unionAffiliation'
  >;
};

export type UpdateWorkerMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  workerInput: WorkerInput;
}>;

export type UpdateWorkerMutation = { __typename?: 'Mutation' } & {
  updateWorker: { __typename?: 'Worker' } & Pick<
    Worker,
    'birthDate' | 'ssnLastFour' | 'workerId'
  > & {
      profilePictureCropped?: Maybe<
        { __typename?: 'File' } & Pick<File, 'downloadUrl'>
      >;
      user: { __typename?: 'User' } & Pick<
        User,
        'userAccountId' | 'createdAt'
      > & {
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              'firstName' | 'lastName' | 'createdAt' | 'updatedAt'
            >
          >;
          roles: Array<
            { __typename?: 'UserRole' } & Pick<
              UserRole,
              | 'key'
              | 'displayName'
              | 'roleCreatedAt'
              | 'roleUpdatedAt'
              | 'mappingCreatedAt'
            >
          >;
        };
    };
};

export type UserUpdateIdentityMutationVariables = Exact<{
  input: UserUpdateIdentityInput;
}>;

export type UserUpdateIdentityMutation = { __typename?: 'Mutation' } & {
  userUpdateIdentity: { __typename?: 'UserPayload' } & {
    user: { __typename?: 'User' } & {
      identity?: Maybe<
        { __typename?: 'UserIdentity' } & Pick<
          UserIdentity,
          'firstName' | 'lastName' | 'email'
        >
      >;
    };
  };
};

export type WorkerUnlockProfileMutationVariables = Exact<{
  input: WorkerUnlockProfileInput;
}>;

export type WorkerUnlockProfileMutation = { __typename?: 'Mutation' } & {
  workerUnlockProfile: { __typename?: 'WorkerUnlockProfilePayload' } & {
    userWorkerProfileAccess: { __typename?: 'UserWorkerProfileAccess' } & Pick<
      UserWorkerProfileAccess,
      'id' | 'isUnlocked'
    >;
  };
};

export type ArchiveWorkerMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type ArchiveWorkerMutation = { __typename?: 'Mutation' } & {
  archiveWorker: { __typename?: 'Worker' } & {
    user: { __typename?: 'User' } & {
      identity?: Maybe<
        { __typename?: 'UserIdentity' } & Pick<
          UserIdentity,
          'firstName' | 'lastName'
        >
      >;
    };
  };
};

export type ExtractIdDataFromFileMutationVariables = Exact<{
  extractionInput: DataExtractionInput;
}>;

export type ExtractIdDataFromFileMutation = { __typename?: 'Mutation' } & {
  extractIdDataFromFile: { __typename?: 'IdCardDataExtractionResult' } & {
    file?: Maybe<{ __typename?: 'File' } & Pick<File, 'fileId'>>;
    extractedData?: Maybe<
      { __typename?: 'IdCardData' } & Pick<
        IdCardData,
        | 'identifier'
        | 'idType'
        | 'issueDate'
        | 'expirationDate'
        | 'dateOfBirth'
        | 'fullName'
        | 'firstName'
        | 'lastName'
        | 'address'
        | 'title'
      >
    >;
  };
};

export type UnarchiveWorkerMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type UnarchiveWorkerMutation = { __typename?: 'Mutation' } & {
  unarchiveWorker: { __typename?: 'Worker' } & {
    user: { __typename?: 'User' } & {
      identity?: Maybe<
        { __typename?: 'UserIdentity' } & Pick<
          UserIdentity,
          'firstName' | 'lastName'
        >
      >;
    };
  };
};

export type GetJobsiteAccessSessionsQueryVariables = Exact<{
  jobsiteAccessSessionsInput?: InputMaybe<JobsiteAccessSessionsInput>;
}>;

export type GetJobsiteAccessSessionsQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          jobsiteAccessSessions?: Maybe<
            { __typename?: 'JobsiteAccessSessionsConnection' } & Pick<
              JobsiteAccessSessionsConnection,
              'count'
            > & {
                edges: Array<
                  Maybe<
                    { __typename?: 'JobsiteAccessSessionEdge' } & {
                      node?: Maybe<
                        { __typename?: 'JobsiteAccessSession' } & Pick<
                          JobsiteAccessSession,
                          'sessionId'
                        > & {
                            jobsiteWorker: { __typename?: 'JobsiteWorker' } & {
                              contractorWorker: {
                                __typename?: 'ContractorWorker';
                              } & {
                                worker: { __typename?: 'Worker' } & Pick<
                                  Worker,
                                  'workerId'
                                > & {
                                    user: { __typename?: 'User' } & Pick<
                                      User,
                                      'userAccountId'
                                    > & {
                                        identity?: Maybe<
                                          {
                                            __typename?: 'UserIdentity';
                                          } & Pick<
                                            UserIdentity,
                                            'firstName' | 'lastName'
                                          >
                                        >;
                                      };
                                    profilePictureCropped?: Maybe<
                                      { __typename?: 'File' } & Pick<
                                        File,
                                        'downloadUrl'
                                      >
                                    >;
                                  };
                              };
                              jobsiteContractor: {
                                __typename?: 'JobsiteContractor';
                              } & Pick<JobsiteContractor, 'id'> & {
                                  jobsite: { __typename?: 'Jobsite' } & Pick<
                                    Jobsite,
                                    'jobsiteId' | 'name'
                                  >;
                                };
                            };
                            proximitySession: {
                              __typename?: 'ProximitySessionResult';
                            } & Pick<
                              ProximitySessionResult,
                              | 'id'
                              | 'day'
                              | 'start'
                              | 'end'
                              | 'active'
                              | 'compliant'
                              | 'closed'
                            > & {
                                locale?: Maybe<
                                  {
                                    __typename?: 'ProximitySessionLocaleData';
                                  } & {
                                    time?: Maybe<
                                      {
                                        __typename?: 'ProximitySessionLocaleTimeData';
                                      } & Pick<
                                        ProximitySessionLocaleTimeData,
                                        'start' | 'end'
                                      >
                                    >;
                                  }
                                >;
                                span?: Maybe<
                                  {
                                    __typename?: 'ProximitySessionSpanData';
                                  } & Pick<ProximitySessionSpanData, 'hours'>
                                >;
                                reads?: Maybe<
                                  {
                                    __typename?: 'ProximitySessionReadsData';
                                  } & Pick<
                                    ProximitySessionReadsData,
                                    'count'
                                  > & {
                                      counts?: Maybe<
                                        {
                                          __typename?: 'ProximitySessionReadsCountData';
                                        } & Pick<
                                          ProximitySessionReadsCountData,
                                          'inbound' | 'outbound'
                                        >
                                      >;
                                    }
                                >;
                              };
                          }
                      >;
                    }
                  >
                >;
              }
          >;
        };
    }
  >;
};

export type GetWorkerCCureDataQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type GetWorkerCCureDataQuery = { __typename?: 'Query' } & {
  getWorkerCCureData: { __typename?: 'WorkerCCureData' } & Pick<
    WorkerCCureData,
    'data'
  >;
};

export type GetWorkerDataQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  includeArchivedWorker?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteWorkersInput?: InputMaybe<WorkerJobsiteWorkersInput>;
  jobsiteAccessSessionsInput: JobsiteAccessSessionsInput;
}>;

export type GetWorkerDataQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & Pick<
    Worker,
    | 'workerId'
    | 'middleInitial'
    | 'suffix'
    | 'addressLine1'
    | 'addressLine2'
    | 'addressCity'
    | 'addressState'
    | 'addressZipCode'
    | 'birthDate'
    | 'emergencyContactName'
    | 'emergencyContactPhone'
    | 'emergencyContactRelationship'
    | 'gender'
    | 'primaryLanguage'
    | 'race'
    | 'isSkilled'
    | 'ssnLastFour'
    | 'citizenshipStatus'
    | 'workAuthorizationStatus'
    | 'isVeteran'
    | 'quickCode'
    | 'selfOnboardingCurrentStep'
    | 'createdMethod'
    | 'isArchived'
  > & {
      objectHistory: { __typename?: 'ObjectHistory' } & Pick<
        ObjectHistory,
        'createdAt' | 'updatedAt'
      > & {
          createdBy?: Maybe<
            { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName' | 'email'
                  >
                >;
              }
          >;
          updatedBy?: Maybe<
            { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                identity?: Maybe<
                  { __typename?: 'UserIdentity' } & Pick<
                    UserIdentity,
                    'firstName' | 'lastName' | 'email'
                  >
                >;
              }
          >;
        };
      accessHistory?: Maybe<
        Array<
          { __typename?: 'WorkerAccessHistory' } & Pick<
            WorkerAccessHistory,
            | 'changeCategory'
            | 'changeReason'
            | 'changeApprovedBy'
            | 'changeDate'
            | 'changeToAccess'
            | 'updatedByName'
            | 'banEndDate'
            | 'jobsiteName'
          >
        >
      >;
      profilePicture?: Maybe<
        { __typename?: 'File' } & Pick<File, 'downloadUrl' | 'uploadedAt'>
      >;
      profilePictureCropped?: Maybe<
        { __typename?: 'File' } & Pick<
          File,
          'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
        >
      >;
      user: { __typename?: 'User' } & Pick<
        User,
        'userAccountId' | 'isMobileUser'
      > & {
          mobileDeviceInfo?: Maybe<
            { __typename?: 'MobileDeviceInfo' } & Pick<
              MobileDeviceInfo,
              'binaryVersion' | 'bundleVersion' | 'deviceModelName' | 'platform'
            >
          >;
          identity?: Maybe<
            { __typename?: 'UserIdentity' } & Pick<
              UserIdentity,
              | 'firstName'
              | 'lastName'
              | 'email'
              | 'phoneNumber'
              | 'fusionAuthId'
            > & {
                pendingChanges?: Maybe<
                  { __typename?: 'UserIdentityPendingChanges' } & {
                    phoneNumber?: Maybe<
                      { __typename?: 'UserIdentityPendingChange' } & Pick<
                        UserIdentityPendingChange,
                        'newValue' | 'expiresAt'
                      > & {
                          submittedBy: { __typename?: 'User' } & Pick<
                            User,
                            'userAccountId'
                          >;
                        }
                    >;
                    email?: Maybe<
                      { __typename?: 'UserIdentityPendingChange' } & Pick<
                        UserIdentityPendingChange,
                        'newValue' | 'expiresAt'
                      > & {
                          submittedBy: { __typename?: 'User' } & Pick<
                            User,
                            'userAccountId'
                          >;
                        }
                    >;
                  }
                >;
              }
          >;
          lastSession?: Maybe<
            { __typename?: 'UserSession' } & Pick<
              UserSession,
              'createdAt' | 'appVersion'
            >
          >;
        };
      profileAccess?: Maybe<
        { __typename?: 'UserWorkerProfileAccess' } & Pick<
          UserWorkerProfileAccess,
          'id' | 'isUnlocked'
        >
      >;
      editableFields: { __typename?: 'EditableFields' } & Pick<
        EditableFields,
        'email' | 'phone'
      >;
      workerComments: { __typename?: 'WorkerWorkerCommentsConnection' } & {
        edges: Array<
          { __typename?: 'WorkerWorkerCommentsEdge' } & {
            node: { __typename?: 'WorkerComment' } & Pick<
              WorkerComment,
              'workerCommentId' | 'comment'
            > & {
                jobsite?: Maybe<
                  { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'name' | 'jobsiteId'
                  >
                >;
                objectHistory?: Maybe<
                  { __typename?: 'ObjectHistory' } & Pick<
                    ObjectHistory,
                    'createdAt' | 'updatedAt'
                  > & {
                      createdBy?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'userAccountId'
                        > & {
                            identity?: Maybe<
                              { __typename?: 'UserIdentity' } & Pick<
                                UserIdentity,
                                'firstName' | 'lastName' | 'email'
                              >
                            >;
                          }
                      >;
                      updatedBy?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'userAccountId'
                        > & {
                            identity?: Maybe<
                              { __typename?: 'UserIdentity' } & Pick<
                                UserIdentity,
                                'firstName' | 'lastName' | 'email'
                              >
                            >;
                          }
                      >;
                    }
                >;
              };
          }
        >;
      };
      jobsiteAccessSessions?: Maybe<
        { __typename?: 'JobsiteAccessSessionsConnection' } & {
          edges: Array<
            Maybe<
              { __typename?: 'JobsiteAccessSessionEdge' } & {
                node?: Maybe<
                  { __typename?: 'JobsiteAccessSession' } & Pick<
                    JobsiteAccessSession,
                    'active'
                  > & {
                      jobsiteWorker: { __typename?: 'JobsiteWorker' } & {
                        jobsiteContractor: {
                          __typename?: 'JobsiteContractor';
                        } & {
                          jobsite: { __typename?: 'Jobsite' } & Pick<
                            Jobsite,
                            'jobsiteId' | 'name'
                          >;
                        };
                      };
                    }
                >;
              }
            >
          >;
        }
      >;
      jobsiteWorkers: { __typename?: 'WorkerJobsiteWorkersConnection' } & {
        edges: Array<
          { __typename?: 'WorkerJobsiteWorkersEdge' } & {
            node: { __typename?: 'JobsiteWorker' } & Pick<
              JobsiteWorker,
              | 'jobsiteWorkerId'
              | 'isBanned'
              | 'banCategory'
              | 'bannedReason'
              | 'bannedAt'
              | 'banRemovedReason'
              | 'orientationDate'
              | 'startDate'
              | 'endDate'
              | 'payrollId'
              | 'trade'
              | 'tradeExperience'
              | 'jobTitle'
              | 'unionAffiliation'
              | 'classificationGroup'
              | 'siteSpecificTrainingCompletedAt'
              | 'siteSpecificTrainingSkipReason'
              | 'siteSpecificTrainingSkipExpiresAt'
              | 'stickerNumber'
              | 'orientationStatus'
              | 'documentsCompletedAt'
              | 'documentsCompletedSkipExpiresAt'
              | 'documentsCompletedSkipReason'
              | 'urineTestConditionalPassExpiresAt'
              | 'banExpiresAt'
              | 'isSuspended'
              | 'badgingCompletedAt'
              | 'medicalNotes'
              | 'nycSstExemptionReason'
              | 'siteAccessChangeApprovedBy'
              | 'isExemptFromSwipeInactivity'
              | 'isExemptFromSiteSpecificRefresher'
              | 'passedMedicalExamAt'
              | 'medicalExamSkipReason'
              | 'medicalExamSkipExpiresAt'
              | 'isAntipassbackExempt'
              | 'documentExemptionReason'
              | 'customWorkerData'
            > & {
                clearanceAssignments?: Maybe<
                  {
                    __typename?: 'JobsiteWorkerClearanceAssignmentsConnection';
                  } & Pick<
                    JobsiteWorkerClearanceAssignmentsConnection,
                    'count'
                  > & {
                      edges: Array<
                        Maybe<
                          {
                            __typename?: 'JobsiteWorkerClearanceAssignmentEdge';
                          } & {
                            node?: Maybe<
                              {
                                __typename?: 'JobsiteWorkerClearanceAssignment';
                              } & Pick<
                                JobsiteWorkerClearanceAssignment,
                                'id'
                              > & {
                                  clearance: {
                                    __typename?: 'CCureClearance';
                                  } & Pick<
                                    CCureClearance,
                                    'cCureClearanceId' | 'name'
                                  > & {
                                      cCureEnvironment: {
                                        __typename?: 'CCureEnvironment';
                                      } & Pick<
                                        CCureEnvironment,
                                        | 'cCureEnvironmentId'
                                        | 'namespace'
                                        | 'instanceSlug'
                                      >;
                                    };
                                }
                            >;
                          }
                        >
                      >;
                    }
                >;
                objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                  ObjectHistory,
                  'createdAt' | 'updatedAt'
                > & {
                    createdBy?: Maybe<
                      { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName' | 'email'
                            >
                          >;
                        }
                    >;
                    updatedBy?: Maybe<
                      { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName' | 'email'
                            >
                          >;
                        }
                    >;
                  };
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    | 'name'
                    | 'jobsiteId'
                    | 'timeZone'
                    | 'parentId'
                    | 'tradeOptions'
                    | 'titleOptions'
                    | 'unionAffiliationOptions'
                    | 'classificationGroupOptions'
                    | 'clearanceAssignmentEnabled'
                    | 'defaultJobsitePrinterId'
                  > & {
                      jobsiteCustomWorkerDataFields: {
                        __typename?: 'JobsiteCustomWorkerDataFieldsConnection';
                      } & {
                        edges: Array<
                          {
                            __typename?: 'JobsiteCustomWorkerDataFieldsEdge';
                          } & {
                            node: {
                              __typename?: 'JobsiteCustomWorkerDataField';
                            } & Pick<
                              JobsiteCustomWorkerDataField,
                              | 'fieldLabel'
                              | 'fieldDataType'
                              | 'validationMessage'
                              | 'validationRegex'
                              | 'isRequired'
                            >;
                          }
                        >;
                      };
                      developer?: Maybe<
                        { __typename?: 'Developer' } & Pick<
                          Developer,
                          'developerId' | 'name'
                        >
                      >;
                      featuresModule?: Maybe<
                        { __typename?: 'JobsiteFeaturesModule' } & Pick<
                          JobsiteFeaturesModule,
                          | 'announcementsEnabled'
                          | 'archivingAccessEventsEnabled'
                          | 'isEnabled'
                          | 'name'
                          | 'slug'
                        >
                      >;
                      modules?: Maybe<
                        Array<
                          | ({ __typename?: 'JobsiteAppCheckInModule' } & Pick<
                              JobsiteAppCheckInModule,
                              'isEnabled' | 'name' | 'slug'
                            > & {
                                areas: Array<
                                  {
                                    __typename?: 'JobsiteAppCheckInModuleArea';
                                  } & Pick<
                                    JobsiteAppCheckInModuleArea,
                                    | 'checkInRadius'
                                    | 'id'
                                    | 'isInboundEnabled'
                                    | 'isOutboundEnabled'
                                  > & {
                                      checkInCoordinate: {
                                        __typename?: 'GPSCoordinate';
                                      } & Pick<GpsCoordinate, 'lat' | 'lng'>;
                                    }
                                >;
                              })
                          | { __typename?: 'JobsiteFeaturesModule' }
                          | ({ __typename?: 'JobsiteOnboardingModule' } & Pick<
                              JobsiteOnboardingModule,
                              | 'name'
                              | 'badgePrintingAllowed'
                              | 'badgeAssignmentAllowed'
                            > & {
                                steps?: Maybe<
                                  Array<
                                    {
                                      __typename?: 'JobsiteOnboardingStep';
                                    } & Pick<
                                      JobsiteOnboardingStep,
                                      | 'key'
                                      | 'index'
                                      | 'isRequired'
                                      | 'isVisible'
                                    >
                                  >
                                >;
                              })
                          | { __typename?: 'JobsitePreOnboardingModule' }
                        >
                      >;
                    };
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'organizationId' | 'name'
                      >;
                    };
                };
                currentAccess: {
                  __typename?: 'JobsiteWorkerCurrentAccess';
                } & Pick<
                  JobsiteWorkerCurrentAccess,
                  'isAllowed' | 'notAllowedReason' | 'endDate'
                >;
              };
          }
        >;
      };
    };
};

export type GetWorkerDocumentsQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  includePhi?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetWorkerDocumentsQuery = { __typename?: 'Query' } & {
  getWorkerDocuments: { __typename?: 'GetWorkerDocumentsResponse' } & {
    workerDocuments: Array<
      { __typename?: 'JobsiteWorkerDocument' } & Pick<
        JobsiteWorkerDocument,
        'jobsiteWorkerDocumentId' | 'key'
      > & {
          jobsiteWorkerDocumentType: {
            __typename?: 'JobsiteWorkerDocumentType';
          } & Pick<JobsiteWorkerDocumentType, 'expiration' | 'key' | 'name'> & {
              jobsite: { __typename?: 'Jobsite' } & Pick<
                Jobsite,
                'name' | 'jobsiteId'
              > & {
                  developer?: Maybe<
                    { __typename?: 'Developer' } & Pick<
                      Developer,
                      'name' | 'developerId'
                    >
                  >;
                };
              workerDocumentType: { __typename?: 'WorkerDocumentType' } & Pick<
                WorkerDocumentType,
                | 'key'
                | 'name'
                | 'expirationDate'
                | 'isPhi'
                | 'isGlobal'
                | 'documentLevel'
              >;
            };
          jobsiteWorker?: Maybe<
            { __typename?: 'JobsiteWorker' } & Pick<
              JobsiteWorker,
              'jobsiteWorkerId'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'jobsiteId'
                  >;
                };
              }
          >;
          jobsiteWorkerDocumentVersions: Array<
            { __typename?: 'JobsiteWorkerDocumentVersion' } & Pick<
              JobsiteWorkerDocumentVersion,
              'jobsiteWorkerDocumentVersionId'
            > & {
                files: Array<
                  { __typename?: 'File' } & Pick<
                    File,
                    'fileId' | 'fileType' | 'downloadUrl' | 'uploadedAt'
                  >
                >;
                additionalFieldValues?: Maybe<
                  Array<
                    { __typename?: 'AdditionalFieldValue' } & Pick<
                      AdditionalFieldValue,
                      'key' | 'value'
                    >
                  >
                >;
                objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                  ObjectHistory,
                  'createdAt' | 'updatedAt'
                > & {
                    createdBy?: Maybe<
                      { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName' | 'email'
                            >
                          >;
                        }
                    >;
                    updatedBy?: Maybe<
                      { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName' | 'email'
                            >
                          >;
                        }
                    >;
                  };
              }
          >;
        }
    >;
  };
};

export type GetWorkerJobsiteAccessActivityQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobsiteAccessEventsInput?: InputMaybe<JobsiteAccessEventsInput>;
}>;

export type GetWorkerJobsiteAccessActivityQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & Pick<Worker, 'quickCode'> & {
      jobsiteAccessEvents?: Maybe<
        { __typename?: 'JobsiteAccessEventsConnection' } & Pick<
          JobsiteAccessEventsConnection,
          'count'
        > & {
            edges: Array<
              { __typename?: 'JobsiteAccessEventsEdge' } & {
                node: { __typename?: 'JobsiteAccessEvent' } & Pick<
                  JobsiteAccessEvent,
                  | 'id'
                  | 'type'
                  | 'status'
                  | 'credentialId'
                  | 'eventOccurredAt'
                  | 'localizedDate'
                  | 'localizedTime'
                  | 'sessionDate'
                  | 'timeZone'
                  | 'rejectionReason'
                  | 'message'
                  | 'gateway'
                  | 'overnightSession'
                  | 'direction'
                  | 'externalId'
                  | 'eventType'
                  | 'locationStatus'
                > & {
                    zoneCrossing?: Maybe<
                      { __typename?: 'AccessEventCrossing' } & Pick<
                        AccessEventCrossing,
                        | 'kind'
                        | 'revisionId'
                        | 'entryId'
                        | 'entrySideId'
                        | 'reason'
                      > & {
                          from?: Maybe<
                            { __typename?: 'AccessEventEndpoint' } & Pick<
                              AccessEventEndpoint,
                              'kind' | 'zoneId' | 'name'
                            >
                          >;
                          to?: Maybe<
                            { __typename?: 'AccessEventEndpoint' } & Pick<
                              AccessEventEndpoint,
                              'kind' | 'zoneId' | 'name'
                            >
                          >;
                        }
                    >;
                    jobsite?: Maybe<
                      { __typename?: 'Jobsite' } & Pick<
                        Jobsite,
                        'jobsiteId' | 'name'
                      >
                    >;
                    jobsiteWorker?: Maybe<
                      { __typename?: 'JobsiteWorker' } & Pick<
                        JobsiteWorker,
                        'jobsiteWorkerId'
                      > & {
                          jobsiteContractor: {
                            __typename?: 'JobsiteContractor';
                          } & Pick<JobsiteContractor, 'id'>;
                          contractorWorker: {
                            __typename?: 'ContractorWorker';
                          } & Pick<ContractorWorker, 'id'> & {
                              contractor: { __typename?: 'Contractor' } & Pick<
                                Contractor,
                                'contractorId'
                              > & {
                                  organization: {
                                    __typename?: 'Organization';
                                  } & Pick<
                                    Organization,
                                    'organizationId' | 'name'
                                  >;
                                };
                            };
                          currentAccess: {
                            __typename?: 'JobsiteWorkerCurrentAccess';
                          } & Pick<JobsiteWorkerCurrentAccess, 'isAllowed'>;
                        }
                    >;
                  };
              }
            >;
            filtersOptions?: Maybe<
              { __typename?: 'JobsiteAccessEventsFilters' } & {
                jobsites: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label' | 'count'
                  >
                >;
                contractors: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label' | 'count'
                  >
                >;
                zones: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label'
                  >
                >;
                gateways: Array<
                  { __typename?: 'FilterOption' } & Pick<
                    FilterOption,
                    'value' | 'label' | 'count'
                  >
                >;
                rejectionReasons: Array<
                  Maybe<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >
                >;
                locationStatuses: Array<
                  Maybe<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >
                >;
              }
            >;
          }
      >;
    };
};

export type GetWorkerJobsiteAccessSessionsQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  jobsiteAccessSessionsInput?: InputMaybe<JobsiteAccessSessionsInput>;
}>;

export type GetWorkerJobsiteAccessSessionsQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & {
    jobsiteAccessSessions?: Maybe<
      { __typename?: 'JobsiteAccessSessionsConnection' } & Pick<
        JobsiteAccessSessionsConnection,
        'count'
      > & {
          edges: Array<
            Maybe<
              { __typename?: 'JobsiteAccessSessionEdge' } & {
                node?: Maybe<
                  { __typename?: 'JobsiteAccessSession' } & Pick<
                    JobsiteAccessSession,
                    'sessionId' | 'overnightSession' | 'inProgress'
                  > & {
                      jobsiteWorker: { __typename?: 'JobsiteWorker' } & {
                        contractorWorker: {
                          __typename?: 'ContractorWorker';
                        } & {
                          contractor: { __typename?: 'Contractor' } & Pick<
                            Contractor,
                            'contractorId'
                          > & {
                              organization: {
                                __typename?: 'Organization';
                              } & Pick<Organization, 'organizationId' | 'name'>;
                            };
                        };
                        jobsiteContractor: {
                          __typename?: 'JobsiteContractor';
                        } & Pick<JobsiteContractor, 'id'> & {
                            jobsite: { __typename?: 'Jobsite' } & Pick<
                              Jobsite,
                              'jobsiteId' | 'name'
                            >;
                          };
                        currentAccess: {
                          __typename?: 'JobsiteWorkerCurrentAccess';
                        } & Pick<JobsiteWorkerCurrentAccess, 'isAllowed'>;
                      };
                      proximitySession: {
                        __typename?: 'ProximitySessionResult';
                      } & Pick<
                        ProximitySessionResult,
                        | 'id'
                        | 'day'
                        | 'start'
                        | 'end'
                        | 'active'
                        | 'compliant'
                        | 'closed'
                      > & {
                          locale?: Maybe<
                            { __typename?: 'ProximitySessionLocaleData' } & {
                              time?: Maybe<
                                {
                                  __typename?: 'ProximitySessionLocaleTimeData';
                                } & Pick<
                                  ProximitySessionLocaleTimeData,
                                  'start' | 'end'
                                >
                              >;
                            }
                          >;
                          span?: Maybe<
                            { __typename?: 'ProximitySessionSpanData' } & Pick<
                              ProximitySessionSpanData,
                              'hours'
                            >
                          >;
                          reads?: Maybe<
                            { __typename?: 'ProximitySessionReadsData' } & Pick<
                              ProximitySessionReadsData,
                              'count'
                            > & {
                                counts?: Maybe<
                                  {
                                    __typename?: 'ProximitySessionReadsCountData';
                                  } & Pick<
                                    ProximitySessionReadsCountData,
                                    'inbound' | 'outbound'
                                  >
                                >;
                              }
                          >;
                        };
                    }
                >;
              }
            >
          >;
          filtersOptions?: Maybe<
            { __typename?: 'JobsiteAccessSessionsFilters' } & {
              jobsites: Array<
                { __typename?: 'FilterOption' } & Pick<
                  FilterOption,
                  'value' | 'label' | 'count'
                >
              >;
              contractors: Array<
                { __typename?: 'FilterOption' } & Pick<
                  FilterOption,
                  'value' | 'label' | 'count'
                >
              >;
            }
          >;
        }
    >;
  };
};

export type GetWorkerUserRolesQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  includeArchivedWorker?: InputMaybe<Scalars['Boolean']['input']>;
  userRolesInput?: InputMaybe<UserRolesInput>;
}>;

export type GetWorkerUserRolesQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          roles: Array<
            { __typename?: 'UserRole' } & Pick<
              UserRole,
              'key' | 'displayName' | 'mappingCreatedAt' | 'mappingUpdatedAt'
            > & {
                object?: Maybe<
                  { __typename?: 'UserRoleObject' } & Pick<
                    UserRoleObject,
                    'objectId' | 'objectName'
                  > & {
                      objectDetails?: Maybe<
                        { __typename?: 'UserRoleObjectDetails' } & Pick<
                          UserRoleObjectDetails,
                          'name' | 'title' | 'objectMemberId'
                        >
                      >;
                    }
                >;
              }
          >;
        };
    };
};

export type GetBadgeConnectionsQueryVariables = Exact<{
  badgeId: Scalars['ID']['input'];
}>;

export type GetBadgeConnectionsQuery = { __typename?: 'Query' } & {
  getWorkerCard: { __typename?: 'WorkerCard' } & Pick<
    WorkerCard,
    'workerCardId'
  > & {
      connections: Array<
        { __typename?: 'Connection' } & Pick<Connection, 'id'> & {
            externalEntity: { __typename?: 'ExternalEntity' } & Pick<
              ExternalEntity,
              'type' | 'typeDisplayName' | 'id' | 'name'
            >;
          }
      >;
    };
};

export type GetWorkerConnectionsTabQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type GetWorkerConnectionsTabQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
      connections: Array<
        { __typename?: 'Connection' } & Pick<Connection, 'id'> & {
            externalEntity: { __typename?: 'ExternalEntity' } & Pick<
              ExternalEntity,
              'type' | 'typeDisplayName' | 'id' | 'name'
            >;
          }
      >;
    };
};

export type WorkerOnboardingUpdateUserIdentityMutationVariables = Exact<{
  input: UserUpdateIdentityInput;
}>;

export type WorkerOnboardingUpdateUserIdentityMutation = {
  __typename?: 'Mutation';
} & {
  userUpdateIdentity: { __typename?: 'UserPayload' } & {
    user: { __typename?: 'User' } & {
      identity?: Maybe<
        { __typename?: 'UserIdentity' } & Pick<
          UserIdentity,
          'firstName' | 'lastName'
        >
      >;
    };
  };
};

export type WorkerOnboardingUpdateWorkerMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  workerInput: WorkerInput;
}>;

export type WorkerOnboardingUpdateWorkerMutation = {
  __typename?: 'Mutation';
} & {
  updateWorker: { __typename?: 'Worker' } & Pick<Worker, 'middleInitial'> & {
      user: { __typename?: 'User' } & {
        identity?: Maybe<
          { __typename?: 'UserIdentity' } & Pick<UserIdentity, 'firstName'>
        >;
      };
    };
};

export type GetWorkerOnboardingDocumentReportQueryVariables = Exact<{
  jobsiteWorkerDocumentId: Scalars['ID']['input'];
}>;

export type GetWorkerOnboardingDocumentReportQuery = {
  __typename?: 'Query';
} & {
  getJobsiteWorkerDocument: { __typename?: 'JobsiteWorkerDocument' } & Pick<
    JobsiteWorkerDocument,
    'jobsiteWorkerDocumentId'
  > & {
      jobsiteWorkerDocumentType: {
        __typename?: 'JobsiteWorkerDocumentType';
      } & {
        jobsite: { __typename?: 'Jobsite' } & Pick<
          Jobsite,
          'name' | 'jobsiteId'
        > & {
            developer?: Maybe<
              { __typename?: 'Developer' } & Pick<
                Developer,
                'name' | 'developerId'
              >
            >;
          };
        workerDocumentType: { __typename?: 'WorkerDocumentType' } & Pick<
          WorkerDocumentType,
          'name' | 'key' | 'expirationDate' | 'isGlobal' | 'documentLevel'
        >;
      };
      latestVersion: { __typename?: 'JobsiteWorkerDocumentVersion' } & Pick<
        JobsiteWorkerDocumentVersion,
        'jobsiteWorkerDocumentVersionId'
      > & {
          files: Array<
            { __typename?: 'File' } & Pick<
              File,
              'fileId' | 'fileType' | 'downloadUrl'
            >
          >;
          additionalFieldValues?: Maybe<
            Array<
              { __typename?: 'AdditionalFieldValue' } & Pick<
                AdditionalFieldValue,
                'key' | 'value'
              >
            >
          >;
          objectHistory: { __typename?: 'ObjectHistory' } & Pick<
            ObjectHistory,
            'createdAt' | 'updatedAt'
          > & {
              createdBy?: Maybe<
                { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName' | 'email'
                      >
                    >;
                  }
              >;
              updatedBy?: Maybe<
                { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'firstName' | 'lastName' | 'email'
                      >
                    >;
                  }
              >;
            };
        };
    };
};

export type GetAllJobsiteWorkerDocumentTypesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetAllJobsiteWorkerDocumentTypesQuery = { __typename?: 'Query' } & {
  getAllJobsiteWorkerDocumentTypes: Array<
    { __typename?: 'JobsiteWorkerDocumentType' } & Pick<
      JobsiteWorkerDocumentType,
      'id' | 'key' | 'name' | 'position'
    > & {
        workerDocumentType: { __typename?: 'WorkerDocumentType' } & Pick<
          WorkerDocumentType,
          'key'
        >;
        additionalFields: Array<
          { __typename?: 'WorkerDocumentAdditionalField' } & Pick<
            WorkerDocumentAdditionalField,
            'key' | 'name'
          >
        >;
      }
  >;
};

export type GetJobsiteWorkerQueryVariables = Exact<{
  jobsiteWorkerId: Scalars['ID']['input'];
}>;

export type GetJobsiteWorkerQuery = { __typename?: 'Query' } & {
  getJobsiteWorker?: Maybe<
    { __typename?: 'JobsiteWorker' } & Pick<
      JobsiteWorker,
      | 'jobsiteWorkerId'
      | 'trade'
      | 'tradeExperience'
      | 'jobTitle'
      | 'unionAffiliation'
      | 'classificationGroup'
      | 'isBanned'
      | 'bannedReason'
      | 'bannedAt'
      | 'startDate'
      | 'endDate'
      | 'payrollId'
      | 'stickerNumber'
      | 'orientationDate'
      | 'orientationStatus'
      | 'documentsCompletedAt'
      | 'medicalExamSkipReason'
      | 'passedMedicalExamAt'
      | 'documentsCompletedSkipReason'
      | 'badgingCompletedAt'
      | 'badgingSkipReason'
      | 'signatureCompletedAt'
      | 'signatureSkipReason'
      | 'onboardingSignedAt'
      | 'onboardingSkipReason'
      | 'profileCompletedAt'
      | 'profileCompleteSkipReason'
      | 'siteSpecificTrainingCompletedAt'
      | 'siteSpecificTrainingSkipReason'
      | 'medicalNotes'
      | 'isAntipassbackExempt'
      | 'nycSstExemptionReason'
      | 'customWorkerData'
    > & {
        currentAccess: { __typename?: 'JobsiteWorkerCurrentAccess' } & Pick<
          JobsiteWorkerCurrentAccess,
          'isAllowed' | 'notAllowedReason'
        >;
        clearanceAssignments?: Maybe<
          { __typename?: 'JobsiteWorkerClearanceAssignmentsConnection' } & Pick<
            JobsiteWorkerClearanceAssignmentsConnection,
            'count'
          > & {
              edges: Array<
                Maybe<
                  { __typename?: 'JobsiteWorkerClearanceAssignmentEdge' } & {
                    node?: Maybe<
                      {
                        __typename?: 'JobsiteWorkerClearanceAssignment';
                      } & Pick<JobsiteWorkerClearanceAssignment, 'id'> & {
                          clearance: { __typename?: 'CCureClearance' } & Pick<
                            CCureClearance,
                            'cCureClearanceId' | 'name'
                          > & {
                              cCureEnvironment: {
                                __typename?: 'CCureEnvironment';
                              } & Pick<
                                CCureEnvironment,
                                | 'cCureEnvironmentId'
                                | 'namespace'
                                | 'instanceSlug'
                              >;
                            };
                        }
                    >;
                  }
                >
              >;
            }
        >;
        jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
          contractor: { __typename?: 'Contractor' } & Pick<
            Contractor,
            'contractorId'
          > & {
              organization: { __typename?: 'Organization' } & Pick<
                Organization,
                'name'
              >;
            };
          jobsite: { __typename?: 'Jobsite' } & Pick<
            Jobsite,
            | 'jobsiteId'
            | 'name'
            | 'clearanceAssignmentEnabled'
            | 'tradeOptions'
            | 'titleOptions'
            | 'unionAffiliationOptions'
            | 'classificationGroupOptions'
          > & {
              developer?: Maybe<
                { __typename?: 'Developer' } & Pick<Developer, 'name'>
              >;
              jobsiteCustomWorkerDataFields: {
                __typename?: 'JobsiteCustomWorkerDataFieldsConnection';
              } & {
                edges: Array<
                  { __typename?: 'JobsiteCustomWorkerDataFieldsEdge' } & {
                    node: {
                      __typename?: 'JobsiteCustomWorkerDataField';
                    } & Pick<
                      JobsiteCustomWorkerDataField,
                      | 'fieldLabel'
                      | 'fieldDataType'
                      | 'validationMessage'
                      | 'validationRegex'
                      | 'isRequired'
                    >;
                  }
                >;
              };
              modules?: Maybe<
                Array<
                  | { __typename?: 'JobsiteAppCheckInModule' }
                  | { __typename?: 'JobsiteFeaturesModule' }
                  | ({ __typename?: 'JobsiteOnboardingModule' } & Pick<
                      JobsiteOnboardingModule,
                      'name'
                    > & {
                        steps?: Maybe<
                          Array<
                            { __typename?: 'JobsiteOnboardingStep' } & Pick<
                              JobsiteOnboardingStep,
                              | 'key'
                              | 'index'
                              | 'name'
                              | 'isRequired'
                              | 'isVisible'
                            > & {
                                fields?: Maybe<
                                  Array<
                                    {
                                      __typename?: 'JobsiteOnboardingField';
                                    } & Pick<
                                      JobsiteOnboardingField,
                                      | 'key'
                                      | 'name'
                                      | 'index'
                                      | 'isRequired'
                                      | 'isHidden'
                                    >
                                  >
                                >;
                              }
                          >
                        >;
                        documents?: Maybe<
                          Array<
                            { __typename?: 'JobsiteOnboardingDocument' } & Pick<
                              JobsiteOnboardingDocument,
                              | 'key'
                              | 'name'
                              | 'index'
                              | 'isRequired'
                              | 'isVisible'
                            > & {
                                fields?: Maybe<
                                  Array<
                                    {
                                      __typename?: 'JobsiteOnboardingField';
                                    } & Pick<
                                      JobsiteOnboardingField,
                                      | 'key'
                                      | 'name'
                                      | 'index'
                                      | 'isRequired'
                                      | 'isHidden'
                                    >
                                  >
                                >;
                              }
                          >
                        >;
                      })
                  | { __typename?: 'JobsitePreOnboardingModule' }
                >
              >;
            };
        };
        contractorWorker: { __typename?: 'ContractorWorker' } & {
          contractor: { __typename?: 'Contractor' } & Pick<
            Contractor,
            'contractorId'
          > & {
              organization: { __typename?: 'Organization' } & Pick<
                Organization,
                'name'
              >;
            };
          worker: { __typename?: 'Worker' } & Pick<
            Worker,
            | 'workerId'
            | 'middleInitial'
            | 'suffix'
            | 'addressLine1'
            | 'addressLine2'
            | 'addressCity'
            | 'addressState'
            | 'addressZipCode'
            | 'quickCode'
            | 'birthDate'
            | 'emergencyContactName'
            | 'emergencyContactPhone'
            | 'emergencyContactRelationship'
            | 'gender'
            | 'primaryLanguage'
            | 'race'
            | 'isSkilled'
            | 'ssnLastFour'
            | 'citizenshipStatus'
            | 'workAuthorizationStatus'
            | 'isVeteran'
          > & {
              profilePicture?: Maybe<
                { __typename?: 'File' } & Pick<
                  File,
                  'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                >
              >;
              profilePictureCropped?: Maybe<
                { __typename?: 'File' } & Pick<
                  File,
                  'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                >
              >;
              editableFields: { __typename?: 'EditableFields' } & Pick<
                EditableFields,
                'email' | 'phone'
              >;
              user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                  identity?: Maybe<
                    { __typename?: 'UserIdentity' } & Pick<
                      UserIdentity,
                      'firstName' | 'lastName' | 'email' | 'phoneNumber'
                    >
                  >;
                };
              jobsiteWorkers: {
                __typename?: 'WorkerJobsiteWorkersConnection';
              } & Pick<WorkerJobsiteWorkersConnection, 'count'>;
            };
        };
      }
  >;
};

export type GetJobsiteWorkerDocumentsQueryVariables = Exact<{
  jobsiteWorkerId: Scalars['ID']['input'];
  documentsInput?: InputMaybe<JobsiteWorkerDocumentsInput>;
}>;

export type GetJobsiteWorkerDocumentsQuery = { __typename?: 'Query' } & {
  getJobsiteWorker?: Maybe<
    { __typename?: 'JobsiteWorker' } & {
      documents: { __typename?: 'JobsiteWorkerDocumentsConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteWorkerDocumentsEdge' } & {
            node: { __typename?: 'JobsiteWorkerDocument' } & Pick<
              JobsiteWorkerDocument,
              'jobsiteWorkerDocumentId' | 'key'
            > & {
                jobsiteWorkerDocumentType: {
                  __typename?: 'JobsiteWorkerDocumentType';
                } & Pick<
                  JobsiteWorkerDocumentType,
                  'key' | 'name' | 'position' | 'expiration'
                > & {
                    jobsite: { __typename?: 'Jobsite' } & Pick<
                      Jobsite,
                      'jobsiteId' | 'name'
                    > & {
                        developer?: Maybe<
                          { __typename?: 'Developer' } & Pick<
                            Developer,
                            'developerId' | 'name'
                          >
                        >;
                      };
                    workerDocumentType: {
                      __typename?: 'WorkerDocumentType';
                    } & Pick<
                      WorkerDocumentType,
                      'key' | 'name' | 'documentLevel' | 'isPhi'
                    >;
                    additionalFields: Array<
                      { __typename?: 'WorkerDocumentAdditionalField' } & Pick<
                        WorkerDocumentAdditionalField,
                        'key' | 'name'
                      >
                    >;
                  };
                objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                  ObjectHistory,
                  'createdAt' | 'updatedAt'
                >;
                latestVersion: {
                  __typename?: 'JobsiteWorkerDocumentVersion';
                } & Pick<
                  JobsiteWorkerDocumentVersion,
                  'jobsiteWorkerDocumentVersionId'
                > & {
                    files: Array<
                      { __typename?: 'File' } & Pick<
                        File,
                        | 'fileId'
                        | 'fileType'
                        | 'uploadedAt'
                        | 'downloadUrl'
                        | 'originalFileName'
                      >
                    >;
                    objectHistory: { __typename?: 'ObjectHistory' } & Pick<
                      ObjectHistory,
                      'createdAt' | 'updatedAt'
                    >;
                    additionalFieldValues?: Maybe<
                      Array<
                        { __typename?: 'AdditionalFieldValue' } & Pick<
                          AdditionalFieldValue,
                          'key' | 'value'
                        >
                      >
                    >;
                    acknowledgedBy?: Maybe<
                      { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName'
                            >
                          >;
                        }
                    >;
                  };
              };
          }
        >;
      };
    }
  >;
};

export type GetOnboardingJobsiteWorkersQueryVariables = Exact<{
  userContractorsInput?: InputMaybe<UserContractorsInput>;
  jobsiteIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  contractorIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  orientationDate?: InputMaybe<Scalars['Date']['input']>;
  orientationStartDate?: InputMaybe<Scalars['Date']['input']>;
  orientationEndDate?: InputMaybe<Scalars['Date']['input']>;
  orientationStatuses?: InputMaybe<
    | Array<JobsiteWorkerOrientationStatusFilter>
    | JobsiteWorkerOrientationStatusFilter
  >;
  needsMedical?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<
    | Array<InputMaybe<GetJobsiteWorkersOrderBy>>
    | InputMaybe<GetJobsiteWorkersOrderBy>
  >;
}>;

export type GetOnboardingJobsiteWorkersQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          contractors: { __typename?: 'UserContractorsConnection' } & {
            edges: Array<
              { __typename?: 'UserContractorsEdge' } & {
                node: { __typename?: 'Contractor' } & Pick<
                  Contractor,
                  'contractorId'
                > & {
                    organization: { __typename?: 'Organization' } & Pick<
                      Organization,
                      'name'
                    >;
                  };
              }
            >;
          };
        };
    }
  >;
  getJobsiteWorkers: { __typename?: 'JobsiteWorkerConnection' } & Pick<
    JobsiteWorkerConnection,
    'totalCount'
  > & {
      jobsiteStats?: Maybe<
        { __typename?: 'JobsiteStats' } & Pick<
          JobsiteStats,
          | 'numberOfOrientationWorkersTotal'
          | 'numberOfOrientationWorkersSelfOnboarding'
          | 'numberOfOrientationWorkersInProgress'
          | 'numberOfOrientationWorkersCompleted'
          | 'numberOfOrientationWorkersNeedingMedical'
          | 'numberOfOrientationWorkersNeedingBadging'
        >
      >;
      edges: Array<
        { __typename?: 'JobsiteWorkerAccess' } & Pick<
          JobsiteWorkerAccess,
          'endDate' | 'isAllowedNow'
        > & {
            jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
              JobsiteWorker,
              | 'trade'
              | 'jobsiteWorkerId'
              | 'orientationStatus'
              | 'orientationDate'
              | 'medicalExamSkipReason'
              | 'passedMedicalExamAt'
              | 'documentsCompletedAt'
              | 'documentsCompletedSkipReason'
              | 'badgingCompletedAt'
              | 'badgingSkipReason'
              | 'signatureCompletedAt'
              | 'signatureSkipReason'
              | 'onboardingSignedAt'
              | 'onboardingSkipReason'
              | 'profileCompletedAt'
              | 'profileCompleteSkipReason'
              | 'banCategory'
              | 'bannedReason'
              | 'bannedAt'
              | 'siteSpecificTrainingCompletedAt'
              | 'siteSpecificTrainingSkipReason'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'jobsiteId' | 'name'
                  > & {
                      modules?: Maybe<
                        Array<
                          | { __typename?: 'JobsiteAppCheckInModule' }
                          | { __typename?: 'JobsiteFeaturesModule' }
                          | ({ __typename?: 'JobsiteOnboardingModule' } & Pick<
                              JobsiteOnboardingModule,
                              'name'
                            > & {
                                steps?: Maybe<
                                  Array<
                                    {
                                      __typename?: 'JobsiteOnboardingStep';
                                    } & Pick<
                                      JobsiteOnboardingStep,
                                      'key' | 'index' | 'isVisible'
                                    >
                                  >
                                >;
                              })
                          | { __typename?: 'JobsitePreOnboardingModule' }
                        >
                      >;
                    };
                };
                contractorWorker: { __typename?: 'ContractorWorker' } & {
                  worker: { __typename?: 'Worker' } & Pick<
                    Worker,
                    'workerId'
                  > & {
                      profilePicture?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId'
                        >
                      >;
                      profilePictureCropped?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                        >
                      >;
                      user: { __typename?: 'User' } & Pick<
                        User,
                        'userAccountId'
                      > & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName'
                            >
                          >;
                        };
                    };
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name'
                      >;
                    };
                };
              };
          }
      >;
    };
};

export type UpdateOnboardingJobsiteWorkerMutationVariables = Exact<{
  jobsiteWorkerId: Scalars['ID']['input'];
  jobsiteWorkerInput: JobsiteWorkerInput;
}>;

export type UpdateOnboardingJobsiteWorkerMutation = {
  __typename?: 'Mutation';
} & {
  updateJobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
    JobsiteWorker,
    'orientationDate'
  >;
};

export type GetSiteSafetyOrientationJobsiteWorkersQueryVariables = Exact<{
  userContractorsInput?: InputMaybe<UserContractorsInput>;
  jobsiteIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  contractorIds?: InputMaybe<
    Array<Scalars['ID']['input']> | Scalars['ID']['input']
  >;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<
    | Array<InputMaybe<GetJobsiteWorkersOrderBy>>
    | InputMaybe<GetJobsiteWorkersOrderBy>
  >;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  orientationStartDate?: InputMaybe<Scalars['Date']['input']>;
  orientationEndDate?: InputMaybe<Scalars['Date']['input']>;
  withContractorOnly?: InputMaybe<Scalars['Boolean']['input']>;
  orientationStatuses?: InputMaybe<
    | Array<JobsiteWorkerOrientationStatusFilter>
    | JobsiteWorkerOrientationStatusFilter
  >;
  needsMedical?: InputMaybe<Scalars['Boolean']['input']>;
  hideBanned?: InputMaybe<Scalars['Boolean']['input']>;
  completedSiteSpecificTraining?: InputMaybe<Scalars['Boolean']['input']>;
  completedSiteSpecificTrainingDate?: InputMaybe<Scalars['Date']['input']>;
  siteSpecificOrientationStatus?: InputMaybe<SiteSpecificOrientationStatus>;
}>;

export type GetSiteSafetyOrientationJobsiteWorkersQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          contractors: { __typename?: 'UserContractorsConnection' } & Pick<
            UserContractorsConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserContractorsEdge' } & {
                  node: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name'
                      >;
                    };
                }
              >;
            };
        };
    }
  >;
  getJobsiteWorkers: { __typename?: 'JobsiteWorkerConnection' } & Pick<
    JobsiteWorkerConnection,
    'totalCount'
  > & {
      edges: Array<
        { __typename?: 'JobsiteWorkerAccess' } & Pick<
          JobsiteWorkerAccess,
          'endDate' | 'isAllowedNow'
        > & {
            jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
              JobsiteWorker,
              | 'trade'
              | 'jobsiteWorkerId'
              | 'orientationStatus'
              | 'orientationDate'
              | 'medicalExamSkipReason'
              | 'passedMedicalExamAt'
              | 'documentsCompletedAt'
              | 'documentsCompletedSkipReason'
              | 'badgingCompletedAt'
              | 'badgingSkipReason'
              | 'signatureCompletedAt'
              | 'signatureSkipReason'
              | 'onboardingSignedAt'
              | 'onboardingSkipReason'
              | 'profileCompletedAt'
              | 'profileCompleteSkipReason'
              | 'siteSpecificTrainingCompletedAt'
              | 'isSiteSpecificTrainingExpired'
              | 'bannedReason'
            > & {
                jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
                  jobsite: { __typename?: 'Jobsite' } & Pick<
                    Jobsite,
                    'jobsiteId' | 'name'
                  >;
                };
                contractorWorker: { __typename?: 'ContractorWorker' } & {
                  worker: { __typename?: 'Worker' } & Pick<
                    Worker,
                    'workerId'
                  > & {
                      profilePicture?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId'
                        >
                      >;
                      profilePictureCropped?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                        >
                      >;
                      user: { __typename?: 'User' } & Pick<
                        User,
                        'userAccountId'
                      > & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName'
                            >
                          >;
                        };
                    };
                  contractor: { __typename?: 'Contractor' } & Pick<
                    Contractor,
                    'contractorId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'name'
                      >;
                    };
                };
              };
          }
      >;
    };
};

export type GetWorkersContainerCurrentSessionQueryVariables = Exact<{
  userWorkersInput?: InputMaybe<UserWorkersInput>;
  userContractorsInput?: InputMaybe<UserContractorsInput>;
}>;

export type GetWorkersContainerCurrentSessionQuery = {
  __typename?: 'Query';
} & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          workers: { __typename?: 'UserWorkersConnection' } & Pick<
            UserWorkersConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserWorkersEdge' } & {
                  node: { __typename?: 'Worker' } & Pick<
                    Worker,
                    'workerId' | 'birthDate' | 'quickCode'
                  > & {
                      user: { __typename?: 'User' } & Pick<
                        User,
                        'userAccountId'
                      > & {
                          identity?: Maybe<
                            { __typename?: 'UserIdentity' } & Pick<
                              UserIdentity,
                              'firstName' | 'lastName' | 'email'
                            >
                          >;
                        };
                      profilePictureCropped?: Maybe<
                        { __typename?: 'File' } & Pick<
                          File,
                          'downloadUrl' | 'uploadedAt' | 'fileId' | 'fileType'
                        >
                      >;
                      jobsiteWorkers: {
                        __typename?: 'WorkerJobsiteWorkersConnection';
                      } & {
                        edges: Array<
                          { __typename?: 'WorkerJobsiteWorkersEdge' } & {
                            node: { __typename?: 'JobsiteWorker' } & Pick<
                              JobsiteWorker,
                              'jobsiteWorkerId' | 'trade' | 'jobTitle'
                            > & {
                                jobsiteContractor: {
                                  __typename?: 'JobsiteContractor';
                                } & {
                                  jobsite: { __typename?: 'Jobsite' } & Pick<
                                    Jobsite,
                                    'jobsiteId' | 'name'
                                  >;
                                  contractor: {
                                    __typename?: 'Contractor';
                                  } & Pick<Contractor, 'contractorId'> & {
                                      organization: {
                                        __typename?: 'Organization';
                                      } & Pick<Organization, 'name'>;
                                    };
                                };
                                currentAccess: {
                                  __typename?: 'JobsiteWorkerCurrentAccess';
                                } & Pick<
                                  JobsiteWorkerCurrentAccess,
                                  'isAllowed'
                                >;
                              };
                          }
                        >;
                      };
                    };
                }
              >;
              filtersOptions?: Maybe<
                { __typename?: 'UserWorkersFilters' } & {
                  trades: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                  jobTitles: Array<
                    { __typename?: 'FilterOption' } & Pick<
                      FilterOption,
                      'value' | 'label' | 'count'
                    >
                  >;
                }
              >;
            };
          contractors: { __typename?: 'UserContractorsConnection' } & {
            edges: Array<
              { __typename?: 'UserContractorsEdge' } & {
                node: { __typename?: 'Contractor' } & Pick<
                  Contractor,
                  'contractorId'
                > & {
                    organization: { __typename?: 'Organization' } & Pick<
                      Organization,
                      'name'
                    >;
                  };
              }
            >;
          };
        };
    }
  >;
};

export type AddAndIssueFacialRecognitionBadgeMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  jobsiteId: Scalars['ID']['input'];
  workerCardInput: WorkerCardInput;
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  newEmail?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddAndIssueFacialRecognitionBadgeMutation = {
  __typename?: 'Mutation';
} & {
  addAndIssueFacialRecognitionBadge?: Maybe<
    { __typename?: 'WorkerCard' } & Pick<
      WorkerCard,
      'workerCardId' | 'cardNumber'
    >
  >;
};

export type AddAndIssueMobileBadgeMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  jobsiteId: Scalars['ID']['input'];
  workerCardInput: WorkerCardInput;
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddAndIssueMobileBadgeMutation = { __typename?: 'Mutation' } & {
  addAndIssueMobileBadge: { __typename?: 'WorkerCard' } & Pick<
    WorkerCard,
    'workerCardId' | 'cardNumber'
  >;
};

export type AddCardToWorkerMutationVariables = Exact<{
  workerId: Scalars['ID']['input'];
  jobsiteId: Scalars['ID']['input'];
  workerCardInput: WorkerCardInput;
  forceCreate?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type AddCardToWorkerMutation = { __typename?: 'Mutation' } & {
  addCardToWorker: { __typename?: 'WorkerCard' } & Pick<
    WorkerCard,
    'workerCardId' | 'cardNumber' | 'matchingWorkerCardId' | 'cardStatus'
  > & { worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> };
};

export type AssignContractorWorkerToJobsiteMutationVariables = Exact<{
  input: AssignContractorWorkerToJobsiteInput;
}>;

export type AssignContractorWorkerToJobsiteMutation = {
  __typename?: 'Mutation';
} & {
  assignContractorWorkerToJobsite: {
    __typename?: 'AssignContractorWorkerToJobsiteResponse';
  } & Pick<AssignContractorWorkerToJobsiteResponse, 'isAlreadyAssigned'> & {
      jobsiteWorker: { __typename?: 'JobsiteWorker' } & Pick<
        JobsiteWorker,
        'jobsiteWorkerId' | 'trade' | 'jobTitle' | 'orientationStatus'
      > & {
          contractorWorker: { __typename?: 'ContractorWorker' } & Pick<
            ContractorWorker,
            'id'
          > & {
              worker: { __typename?: 'Worker' } & Pick<
                Worker,
                'workerId' | 'isAssignedToMultipleJobsites'
              >;
            };
          jobsiteContractor: { __typename?: 'JobsiteContractor' } & Pick<
            JobsiteContractor,
            'id'
          > & {
              jobsite: { __typename?: 'Jobsite' } & Pick<
                Jobsite,
                | 'jobsiteId'
                | 'titleOptions'
                | 'tradeOptions'
                | 'unionAffiliationOptions'
              >;
              contractor: { __typename?: 'Contractor' } & Pick<
                Contractor,
                'contractorId' | 'isDefaultContractor'
              > & {
                  organization: { __typename?: 'Organization' } & Pick<
                    Organization,
                    'organizationId' | 'name'
                  >;
                };
            };
        };
    };
};

export type CreateAndPrintWorkerCardMutationVariables = Exact<{
  input: CreateWorkerCardInput;
}>;

export type CreateAndPrintWorkerCardMutation = { __typename?: 'Mutation' } & {
  createAndPrintWorkerCard: { __typename?: 'WorkerCardPayload' } & {
    workerCard: { __typename?: 'WorkerCard' } & Pick<
      WorkerCard,
      'workerCardId' | 'cardNumber' | 'workerCardStatus'
    > & {
        workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
          WorkerCardFormat,
          'workerCardFormatId' | 'name' | 'cardType'
        >;
        lastPrintJob?: Maybe<
          { __typename?: 'CardPrintJob' } & Pick<
            CardPrintJob,
            'cardPrintJobId' | 'startedAt' | 'status' | 'statusMessage'
          > & {
              completion?: Maybe<
                { __typename?: 'CardPrintJobCompletion' } & Pick<
                  CardPrintJobCompletion,
                  'cardNumber' | 'facilityCode' | 'completedAt'
                >
              >;
              error?: Maybe<
                { __typename?: 'CardPrintJobError' } & Pick<
                  CardPrintJobError,
                  'code' | 'erroredAt' | 'message'
                >
              >;
            }
        >;
      };
  };
};

export type CreateCardPrintJobMutationVariables = Exact<{
  input: CreateCardPrintJobInput;
}>;

export type CreateCardPrintJobMutation = { __typename?: 'Mutation' } & {
  createCardPrintJob: { __typename?: 'CardPrintJob' } & Pick<
    CardPrintJob,
    'cardPrintJobId' | 'status' | 'statusMessage' | 'startedAt'
  > & {
      completion?: Maybe<
        { __typename?: 'CardPrintJobCompletion' } & Pick<
          CardPrintJobCompletion,
          'cardNumber' | 'facilityCode' | 'completedAt'
        >
      >;
      jobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId' | 'name'>;
      worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
          user: { __typename?: 'User' } & {
            identity?: Maybe<
              { __typename?: 'UserIdentity' } & Pick<
                UserIdentity,
                'firstName' | 'lastName'
              >
            >;
          };
        };
    };
};

export type CreateContractorWorkerMutationVariables = Exact<{
  createContractorWorkerInput: CreateContractorWorkerInput;
}>;

export type CreateContractorWorkerMutation = { __typename?: 'Mutation' } & {
  createContractorWorker?: Maybe<
    { __typename?: 'ContractorWorker' } & {
      contractor: { __typename?: 'Contractor' } & Pick<
        Contractor,
        'contractorId'
      >;
      worker: { __typename?: 'Worker' } & Pick<
        Worker,
        'workerId' | 'ssnLastFour' | 'birthDate'
      > & {
          user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
              identity?: Maybe<
                { __typename?: 'UserIdentity' } & Pick<
                  UserIdentity,
                  'firstName' | 'lastName'
                >
              >;
            };
        };
    }
  >;
};

export type CreateJobsiteWorkerDocumentMutationVariables = Exact<{
  jobsiteWorkerDocumentInput: JobsiteWorkerDocumentInput;
  jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput;
}>;

export type CreateJobsiteWorkerDocumentMutation = {
  __typename?: 'Mutation';
} & {
  createJobsiteWorkerDocument: { __typename?: 'JobsiteWorkerDocument' } & {
    jobsiteWorkerDocumentType: { __typename?: 'JobsiteWorkerDocumentType' } & {
      workerDocumentType: { __typename?: 'WorkerDocumentType' } & Pick<
        WorkerDocumentType,
        'workerDocumentTypeId'
      >;
    };
  };
};

export type CreateJobsiteWorkerDocumentVersionMutationVariables = Exact<{
  jobsiteWorkerDocumentId: Scalars['ID']['input'];
  jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput;
}>;

export type CreateJobsiteWorkerDocumentVersionMutation = {
  __typename?: 'Mutation';
} & {
  createJobsiteWorkerDocumentVersion: {
    __typename?: 'JobsiteWorkerDocumentVersion';
  } & Pick<JobsiteWorkerDocumentVersion, 'jobsiteWorkerDocumentVersionId'>;
};

export type JobsiteArchiveInvitationMutationVariables = Exact<{
  input: JobsiteArchiveInvitationInput;
}>;

export type JobsiteArchiveInvitationMutation = { __typename?: 'Mutation' } & {
  jobsiteArchiveInvitation: {
    __typename?: 'JobsiteArchiveInvitationPayload';
  } & { success: { __typename?: 'Success' } & Pick<Success, 'success'> };
};

export type JobsiteCreateInvitationMutationVariables = Exact<{
  input: JobsiteCreateInvitationInput;
}>;

export type JobsiteCreateInvitationMutation = { __typename?: 'Mutation' } & {
  jobsiteCreateInvitation: { __typename?: 'JobsiteCreateInvitationPayload' } & {
    jobsiteInvitation: { __typename?: 'JobsiteInvitation' } & Pick<
      JobsiteInvitation,
      'jobsiteInvitationId' | 'expirationDate'
    >;
  };
};

export type ReissueMobileBadgeMutationVariables = Exact<{
  workerCardId: Scalars['ID']['input'];
  newPhoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;

export type ReissueMobileBadgeMutation = { __typename?: 'Mutation' } & {
  reissueMobileBadge: { __typename?: 'WorkerCard' } & Pick<
    WorkerCard,
    'workerCardId' | 'cardNumber'
  >;
};

export type ReprintWorkerCardMutationVariables = Exact<{
  input: PrintWorkerCardInput;
}>;

export type ReprintWorkerCardMutation = { __typename?: 'Mutation' } & {
  reprintWorkerCard: { __typename?: 'WorkerCardPayload' } & {
    workerCard: { __typename?: 'WorkerCard' } & Pick<
      WorkerCard,
      'workerCardId' | 'cardNumber' | 'workerCardStatus'
    > & {
        workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
          WorkerCardFormat,
          'workerCardFormatId' | 'name' | 'cardType'
        >;
        lastPrintJob?: Maybe<
          { __typename?: 'CardPrintJob' } & Pick<
            CardPrintJob,
            'cardPrintJobId' | 'startedAt' | 'status' | 'statusMessage'
          > & {
              completion?: Maybe<
                { __typename?: 'CardPrintJobCompletion' } & Pick<
                  CardPrintJobCompletion,
                  'cardNumber' | 'facilityCode' | 'completedAt'
                >
              >;
              error?: Maybe<
                { __typename?: 'CardPrintJobError' } & Pick<
                  CardPrintJobError,
                  'code' | 'erroredAt' | 'message'
                >
              >;
            }
        >;
      };
  };
};

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  sendForgotPasswordEmail?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type SendPasswordResetEmailMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'sendPasswordResetEmail'
>;

export type UpdateJobsiteWorkerDocumentVersionMutationVariables = Exact<{
  jobsiteWorkerDocumentVersionId: Scalars['ID']['input'];
  jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput;
}>;

export type UpdateJobsiteWorkerDocumentVersionMutation = {
  __typename?: 'Mutation';
} & {
  updateJobsiteWorkerDocumentVersion: {
    __typename?: 'JobsiteWorkerDocumentVersion';
  } & Pick<JobsiteWorkerDocumentVersion, 'jobsiteWorkerDocumentVersionId'>;
};

export type UploadSingleFileMutationVariables = Exact<{
  fileInput: FileInput;
}>;

export type UploadSingleFileMutation = { __typename?: 'Mutation' } & {
  uploadSingleFile: { __typename?: 'File' } & Pick<
    File,
    'fileId' | 'fileType' | 'downloadUrl'
  >;
};

export type GetAnonymousJobsiteInvitationQueryVariables = Exact<{
  jobsiteInvitationId: Scalars['ID']['input'];
}>;

export type GetAnonymousJobsiteInvitationQuery = { __typename?: 'Query' } & {
  getAnonymousJobsiteInvitation: {
    __typename?: 'AnonymousJobsiteInvitation';
  } & Pick<AnonymousJobsiteInvitation, 'jobsiteId'> & {
      contractor: { __typename?: 'AnonymousJobsiteContractor' } & Pick<
        AnonymousJobsiteContractor,
        'contractorId'
      >;
    };
  getCurrentPolicyDocuments: Array<
    { __typename?: 'PolicyDocument' } & Pick<
      PolicyDocument,
      'id' | 'key' | 'version'
    >
  >;
};

export type GetContractorsQueryVariables = Exact<{
  userContractorsInput?: InputMaybe<UserContractorsInput>;
}>;

export type GetContractorsQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          contractors: { __typename?: 'UserContractorsConnection' } & {
            edges: Array<
              { __typename?: 'UserContractorsEdge' } & {
                node: { __typename?: 'Contractor' } & Pick<
                  Contractor,
                  'contractorId'
                > & {
                    organization: { __typename?: 'Organization' } & Pick<
                      Organization,
                      'name'
                    >;
                  };
              }
            >;
          };
        };
    }
  >;
};

export type GetCurrentCardPrintJobQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
}>;

export type GetCurrentCardPrintJobQuery = { __typename?: 'Query' } & {
  getCurrentCardPrintJob?: Maybe<
    { __typename?: 'CardPrintJob' } & Pick<
      CardPrintJob,
      'cardPrintJobId' | 'startedAt' | 'status' | 'statusMessage'
    > & {
        completion?: Maybe<
          { __typename?: 'CardPrintJobCompletion' } & Pick<
            CardPrintJobCompletion,
            'cardNumber' | 'facilityCode' | 'completedAt'
          >
        >;
        jobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'>;
        workerCard?: Maybe<
          { __typename?: 'WorkerCard' } & Pick<
            WorkerCard,
            'workerCardId' | 'cardNumber' | 'workerCardStatus'
          > & {
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                'workerCardFormatId' | 'name' | 'cardType'
              >;
            }
        >;
      }
  >;
};

export type GetDevelopersQueryVariables = Exact<{ [key: string]: never }>;

export type GetDevelopersQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          developers: { __typename?: 'UserDevelopersConnection' } & Pick<
            UserDevelopersConnection,
            'count'
          > & {
              edges: Array<
                { __typename?: 'UserDevelopersEdge' } & {
                  node: { __typename?: 'Developer' } & Pick<
                    Developer,
                    'developerId'
                  > & {
                      organization: { __typename?: 'Organization' } & Pick<
                        Organization,
                        'organizationId' | 'name'
                      >;
                    };
                }
              >;
            };
        };
    }
  >;
};

export type GetJobsiteCardFormatsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteCardFormatsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteCardFormats: { __typename?: 'JobsiteCardFormatsConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteCardFormatsEdge' } & {
            node: { __typename?: 'JobsiteCardFormat' } & Pick<
              JobsiteCardFormat,
              'jobsiteCardFormatId' | 'isDefaultForCardType'
            > & {
                workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                  WorkerCardFormat,
                  | 'workerCardFormatId'
                  | 'name'
                  | 'description'
                  | 'cardType'
                  | 'facilityCode'
                  | 'encoding'
                  | 'validationRegex'
                  | 'validationMessage'
                >;
              };
          }
        >;
      };
    };
};

export type GetJobsiteContractorWorkersQueryVariables = Exact<{
  jobsiteContractorId: Scalars['ID']['input'];
  jobsiteContractorJobsiteWorkersInput?: InputMaybe<JobsiteContractorJobsiteWorkersInput>;
}>;

export type GetJobsiteContractorWorkersQuery = { __typename?: 'Query' } & {
  getJobsiteContractor: { __typename?: 'JobsiteContractor' } & Pick<
    JobsiteContractor,
    'id'
  > & {
      jobsiteWorkers: {
        __typename?: 'JobsiteContractorJobsiteWorkersConnection';
      } & Pick<JobsiteContractorJobsiteWorkersConnection, 'count'> & {
          edges: Array<
            { __typename?: 'JobsiteContractorJobsiteWorkersEdge' } & {
              node: { __typename?: 'JobsiteWorker' } & Pick<
                JobsiteWorker,
                | 'jobsiteWorkerId'
                | 'stickerNumber'
                | 'isOnSite'
                | 'trade'
                | 'jobTitle'
              > & {
                  currentAccess: {
                    __typename?: 'JobsiteWorkerCurrentAccess';
                  } & Pick<
                    JobsiteWorkerCurrentAccess,
                    'isAllowed' | 'notAllowedReason' | 'startDate' | 'endDate'
                  >;
                  contractorWorker: { __typename?: 'ContractorWorker' } & Pick<
                    ContractorWorker,
                    'id'
                  > & {
                      contractor: { __typename?: 'Contractor' } & Pick<
                        Contractor,
                        'contractorId'
                      > & {
                          organization: { __typename?: 'Organization' } & Pick<
                            Organization,
                            'organizationId' | 'name'
                          >;
                        };
                      worker: { __typename?: 'Worker' } & Pick<
                        Worker,
                        'workerId' | 'birthDate' | 'quickCode'
                      > & {
                          user: { __typename?: 'User' } & Pick<
                            User,
                            'userAccountId'
                          > & {
                              identity?: Maybe<
                                { __typename?: 'UserIdentity' } & Pick<
                                  UserIdentity,
                                  'firstName' | 'lastName' | 'email'
                                >
                              >;
                            };
                          profilePicture?: Maybe<
                            { __typename?: 'File' } & Pick<File, 'downloadUrl'>
                          >;
                        };
                    };
                };
            }
          >;
        };
    };
};

export type GetJobsiteInvitationQueryVariables = Exact<{
  jobsiteInvitationId: Scalars['ID']['input'];
}>;

export type GetJobsiteInvitationQuery = { __typename?: 'Query' } & {
  getJobsiteInvitation: { __typename?: 'JobsiteInvitation' } & Pick<
    JobsiteInvitation,
    'jobsiteInvitationId'
  > & {
      jobsiteContractor: { __typename?: 'JobsiteContractor' } & {
        jobsite: { __typename?: 'Jobsite' } & Pick<
          Jobsite,
          | 'jobsiteId'
          | 'name'
          | 'tradeOptions'
          | 'titleOptions'
          | 'unionAffiliationOptions'
          | 'classificationGroupOptions'
        > & {
            profilePicture?: Maybe<
              { __typename?: 'File' } & Pick<
                File,
                'fileId' | 'fileType' | 'downloadUrl'
              >
            >;
            jobsiteCustomWorkerDataFields: {
              __typename?: 'JobsiteCustomWorkerDataFieldsConnection';
            } & {
              edges: Array<
                { __typename?: 'JobsiteCustomWorkerDataFieldsEdge' } & {
                  node: { __typename?: 'JobsiteCustomWorkerDataField' } & Pick<
                    JobsiteCustomWorkerDataField,
                    | 'fieldLabel'
                    | 'fieldDataType'
                    | 'validationMessage'
                    | 'validationRegex'
                    | 'isRequired'
                  >;
                }
              >;
            };
            jobsiteCardFormats: {
              __typename?: 'JobsiteCardFormatsConnection';
            } & Pick<JobsiteCardFormatsConnection, 'count'> & {
                edges: Array<
                  { __typename?: 'JobsiteCardFormatsEdge' } & {
                    node: { __typename?: 'JobsiteCardFormat' } & {
                      workerCardFormat: {
                        __typename?: 'WorkerCardFormat';
                      } & Pick<
                        WorkerCardFormat,
                        | 'cardType'
                        | 'facilityCode'
                        | 'name'
                        | 'workerCardFormatId'
                      >;
                    };
                  }
                >;
              };
            modules?: Maybe<
              Array<
                | { __typename?: 'JobsiteAppCheckInModule' }
                | ({ __typename?: 'JobsiteFeaturesModule' } & Pick<
                    JobsiteFeaturesModule,
                    | 'name'
                    | 'slug'
                    | 'workerAppEnabled'
                    | 'doNotAllowToSkipSelfOnboardingSteps'
                    | 'enforceValidContractorInSelfOnboarding'
                  >)
                | ({ __typename?: 'JobsiteOnboardingModule' } & Pick<
                    JobsiteOnboardingModule,
                    'name'
                  > & {
                      steps?: Maybe<
                        Array<
                          { __typename?: 'JobsiteOnboardingStep' } & Pick<
                            JobsiteOnboardingStep,
                            'key' | 'index' | 'isRequired' | 'isVisible'
                          > & {
                              fields?: Maybe<
                                Array<
                                  {
                                    __typename?: 'JobsiteOnboardingField';
                                  } & Pick<
                                    JobsiteOnboardingField,
                                    | 'key'
                                    | 'name'
                                    | 'index'
                                    | 'isRequired'
                                    | 'isHidden'
                                  >
                                >
                              >;
                            }
                        >
                      >;
                      documents?: Maybe<
                        Array<
                          { __typename?: 'JobsiteOnboardingDocument' } & Pick<
                            JobsiteOnboardingDocument,
                            | 'key'
                            | 'workerDocTypeKey'
                            | 'name'
                            | 'index'
                            | 'isRequired'
                            | 'isVisible'
                            | 'expiration'
                            | 'gracePeriod'
                          > & {
                              fields?: Maybe<
                                Array<
                                  {
                                    __typename?: 'JobsiteOnboardingField';
                                  } & Pick<
                                    JobsiteOnboardingField,
                                    | 'key'
                                    | 'name'
                                    | 'index'
                                    | 'isRequired'
                                    | 'isHidden'
                                  >
                                >
                              >;
                            }
                        >
                      >;
                    })
                | ({ __typename?: 'JobsitePreOnboardingModule' } & Pick<
                    JobsitePreOnboardingModule,
                    'name'
                  > & {
                      steps?: Maybe<
                        Array<
                          { __typename?: 'JobsitePreOnboardingStep' } & Pick<
                            JobsitePreOnboardingStep,
                            | 'key'
                            | 'name'
                            | 'index'
                            | 'isRequired'
                            | 'isVisible'
                          > & {
                              fields?: Maybe<
                                Array<
                                  {
                                    __typename?: 'JobsitePreOnboardingField';
                                  } & Pick<
                                    JobsitePreOnboardingField,
                                    | 'key'
                                    | 'name'
                                    | 'index'
                                    | 'isRequired'
                                    | 'isHidden'
                                  >
                                >
                              >;
                            }
                        >
                      >;
                    })
              >
            >;
            documentTypes: {
              __typename?: 'JobsiteWorkerDocumentTypesConnection';
            } & {
              edges: Array<
                { __typename?: 'JobsiteWorkerDocumentTypesEdge' } & {
                  node: { __typename?: 'JobsiteWorkerDocumentType' } & Pick<
                    JobsiteWorkerDocumentType,
                    'id' | 'key' | 'name' | 'position'
                  > & {
                      workerDocumentType: {
                        __typename?: 'WorkerDocumentType';
                      } & Pick<
                        WorkerDocumentType,
                        'workerDocumentTypeId' | 'key'
                      >;
                      files: Array<
                        { __typename?: 'File' } & Pick<
                          File,
                          | 'fileId'
                          | 'fileType'
                          | 'downloadUrl'
                          | 'language'
                          | 'title'
                        >
                      >;
                    };
                }
              >;
            };
            jobsiteContractors: {
              __typename?: 'JobsiteJobsiteContractorsConnection';
            } & {
              edges: Array<
                { __typename?: 'JobsiteJobsiteContractorsEdge' } & {
                  node: { __typename?: 'JobsiteContractor' } & Pick<
                    JobsiteContractor,
                    'id' | 'startDate'
                  > & {
                      contractor: { __typename?: 'Contractor' } & Pick<
                        Contractor,
                        'contractorId' | 'isDefaultContractor'
                      > & {
                          organization: { __typename?: 'Organization' } & Pick<
                            Organization,
                            'organizationId' | 'name'
                          >;
                        };
                    };
                }
              >;
            };
          };
        contractor: { __typename?: 'Contractor' } & Pick<
          Contractor,
          'contractorId' | 'isDefaultContractor'
        > & {
            organization: { __typename?: 'Organization' } & Pick<
              Organization,
              'organizationId' | 'name'
            >;
          };
      };
    };
};

export type GetJobsiteWithBadgeTemplatesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteWithBadgeTemplatesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteBadgeTemplates: {
        __typename?: 'JobsiteBadgeTemplatesConnection';
      } & {
        edges: Array<
          { __typename?: 'JobsiteBadgeTemplatesEdge' } & {
            node: { __typename?: 'JobsiteBadgeTemplate' } & Pick<
              JobsiteBadgeTemplate,
              'id' | 'isDefault'
            > & {
                badgeTemplate: { __typename?: 'BadgeTemplate' } & Pick<
                  BadgeTemplate,
                  'id' | 'templateName' | 'displayName' | 'isForTempBadge'
                >;
              };
          }
        >;
      };
    };
};

export type GetJobsiteWithPrintersQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetJobsiteWithPrintersQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'defaultJobsitePrinterId'
  > & {
      jobsitePrinters: { __typename?: 'JobsitePrintersConnection' } & {
        edges: Array<
          { __typename?: 'JobsitePrintersEdge' } & {
            node: { __typename?: 'JobsitePrinter' } & Pick<
              JobsitePrinter,
              | 'id'
              | 'name'
              | 'locationName'
              | 'organizationName'
              | 'hidPrinterId'
              | 'hidProxyInstance'
              | 'fargoLocationId'
              | 'fargoOrganizationId'
            >;
          }
        >;
      };
    };
};

export type GetJobsitesQueryVariables = Exact<{
  userJobsitesInput: UserJobsitesInput;
}>;

export type GetJobsitesQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          roles: Array<
            { __typename?: 'UserRole' } & Pick<UserRole, 'key' | 'displayName'>
          >;
          jobsites: { __typename?: 'UserJobsitesConnection' } & {
            edges: Array<
              { __typename?: 'UserJobsitesEdge' } & {
                node: { __typename?: 'Jobsite' } & Pick<
                  Jobsite,
                  | 'jobsiteId'
                  | 'name'
                  | 'parentId'
                  | 'startDate'
                  | 'endDate'
                  | 'workerAccessEnabled'
                  | 'avigilonEnabled'
                  | 'clearanceAssignmentEnabled'
                  | 'timeZone'
                  | 'tradeOptions'
                  | 'titleOptions'
                > & {
                    featuresModule?: Maybe<
                      { __typename?: 'JobsiteFeaturesModule' } & Pick<
                        JobsiteFeaturesModule,
                        'announcementsEnabled' | 'archivingAccessEventsEnabled'
                      >
                    >;
                    developer?: Maybe<
                      { __typename?: 'Developer' } & Pick<
                        Developer,
                        'developerId' | 'name'
                      >
                    >;
                    jobsiteCardFormats: {
                      __typename?: 'JobsiteCardFormatsConnection';
                    } & {
                      edges: Array<
                        { __typename?: 'JobsiteCardFormatsEdge' } & {
                          node: { __typename?: 'JobsiteCardFormat' } & Pick<
                            JobsiteCardFormat,
                            'jobsiteCardFormatId' | 'isDefaultForCardType'
                          > & {
                              workerCardFormat: {
                                __typename?: 'WorkerCardFormat';
                              } & Pick<
                                WorkerCardFormat,
                                | 'workerCardFormatId'
                                | 'name'
                                | 'description'
                                | 'cardType'
                                | 'facilityCode'
                              >;
                            };
                        }
                      >;
                    };
                  };
              }
            >;
          };
        };
    }
  >;
};

export type GetRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRolesQuery = { __typename?: 'Query' } & {
  getRoles: Array<
    { __typename?: 'Role' } & Pick<
      Role,
      'key' | 'displayName' | 'isSuper' | 'createdAt' | 'updatedAt'
    >
  >;
};

export type GetTempBadgesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
  jobsiteTempBadgesInput?: InputMaybe<TempBadgesInput>;
}>;

export type GetTempBadgesQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      tempBadges: { __typename?: 'TempBadgesConnection' } & Pick<
        TempBadgesConnection,
        'count'
      > & {
          edges: Array<
            { __typename?: 'TempBadgeEdge' } & {
              node?: Maybe<
                { __typename?: 'TempBadge' } & Pick<
                  TempBadge,
                  'id' | 'name' | 'cardNumber' | 'status'
                > & {
                    jobsiteCardFormat?: Maybe<
                      { __typename?: 'JobsiteCardFormat' } & Pick<
                        JobsiteCardFormat,
                        'jobsiteCardFormatId'
                      > & {
                          workerCardFormat: {
                            __typename?: 'WorkerCardFormat';
                          } & Pick<
                            WorkerCardFormat,
                            | 'workerCardFormatId'
                            | 'name'
                            | 'description'
                            | 'cardType'
                            | 'facilityCode'
                          >;
                        }
                    >;
                  }
              >;
            }
          >;
        };
    };
};

export type GetWorkerCardQueryVariables = Exact<{
  workerCardId?: InputMaybe<Scalars['ID']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<WorkerCardType>;
}>;

export type GetWorkerCardQuery = { __typename?: 'Query' } & {
  getWorkerCard: { __typename?: 'WorkerCard' } & Pick<
    WorkerCard,
    'workerCardId' | 'cardNumber' | 'expiredAt' | 'isTemporary'
  > & {
      worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
          user: { __typename?: 'User' } & {
            identity?: Maybe<
              { __typename?: 'UserIdentity' } & Pick<
                UserIdentity,
                'phoneNumber'
              >
            >;
          };
        };
      workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
        WorkerCardFormat,
        'name' | 'workerCardFormatId' | 'cardType' | 'facilityCode'
      >;
    };
};

export type GetWorkerCardsQueryVariables = Exact<{
  workerId: Scalars['ID']['input'];
  workerCardsInput?: InputMaybe<WorkerWorkerCardsInput>;
}>;

export type GetWorkerCardsQuery = { __typename?: 'Query' } & {
  getWorker: { __typename?: 'Worker' } & {
    workerCards: { __typename?: 'WorkerWorkerCardsConnection' } & {
      edges: Array<
        { __typename?: 'WorkerWorkerCardsEdge' } & {
          node: { __typename?: 'WorkerCard' } & Pick<
            WorkerCard,
            | 'workerCardId'
            | 'cardNumber'
            | 'matchingWorkerCardId'
            | 'cardStatus'
            | 'workerCardStatus'
            | 'isTemporary'
            | 'expiredAt'
            | 'issuedAt'
          > & {
              worker: { __typename?: 'Worker' } & Pick<Worker, 'workerId'> & {
                  user: { __typename?: 'User' } & {
                    identity?: Maybe<
                      { __typename?: 'UserIdentity' } & Pick<
                        UserIdentity,
                        'phoneNumber'
                      >
                    >;
                  };
                };
              workerCardFormat: { __typename?: 'WorkerCardFormat' } & Pick<
                WorkerCardFormat,
                'name' | 'workerCardFormatId' | 'cardType' | 'facilityCode'
              >;
            };
        }
      >;
    };
  };
};

export type GetAppLayoutCurrentSessionQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAppLayoutCurrentSessionQuery = { __typename?: 'Query' } & {
  getCurrentSession?: Maybe<
    { __typename?: 'Auth' } & {
      user: { __typename?: 'User' } & Pick<User, 'userAccountId'> & {
          roles: Array<{ __typename?: 'UserRole' } & Pick<UserRole, 'key'>>;
        };
      session: { __typename?: 'UserSession' } & Pick<
        UserSession,
        'urlLock' | 'appVersion'
      >;
    }
  >;
};

export type UpdateSessionAppVersionMutationVariables = Exact<{
  appVersion: Scalars['String']['input'];
}>;

export type UpdateSessionAppVersionMutation = { __typename?: 'Mutation' } & {
  updateSessionAppVersion: { __typename?: 'Auth' } & {
    session: { __typename?: 'UserSession' } & Pick<
      UserSession,
      'authType' | 'createdAt' | 'updatedAt' | 'lastActiveAt' | 'appVersion'
    >;
  };
};

export type EntrySideFieldsFragment = { __typename?: 'EntrySide' } & Pick<
  EntrySide,
  'id' | 'position' | 'kind' | 'enforcement'
> & { zone?: Maybe<{ __typename?: 'Zone' } & Pick<Zone, 'id'>> };

export type EntryFieldsFragment = { __typename?: 'Entry' } & Pick<
  Entry,
  'id' | 'name'
> & {
    sideA: { __typename?: 'EntrySide' } & Pick<
      EntrySide,
      'id' | 'position' | 'kind' | 'enforcement'
    > & { zone?: Maybe<{ __typename?: 'Zone' } & Pick<Zone, 'id'>> };
    sideB: { __typename?: 'EntrySide' } & Pick<
      EntrySide,
      'id' | 'position' | 'kind' | 'enforcement'
    > & { zone?: Maybe<{ __typename?: 'Zone' } & Pick<Zone, 'id'>> };
    assignments: Array<
      { __typename?: 'ReaderAssignment' } & Pick<ReaderAssignment, 'id'> & {
          reader: { __typename?: 'Reader' } & Pick<
            Reader,
            'id' | 'readerDeviceId' | 'name'
          >;
          admitsInto: { __typename?: 'EntrySide' } & Pick<EntrySide, 'id'>;
        }
    >;
  };

export type SiteLayoutFieldsFragment = { __typename?: 'SiteLayout' } & Pick<
  SiteLayout,
  'revisionId' | 'draftToken' | 'lastRequestId'
> & {
    zones: Array<{ __typename?: 'Zone' } & Pick<Zone, 'id' | 'name'>>;
    entries: Array<
      { __typename?: 'Entry' } & Pick<Entry, 'id' | 'name'> & {
          sideA: { __typename?: 'EntrySide' } & Pick<
            EntrySide,
            'id' | 'position' | 'kind' | 'enforcement'
          > & { zone?: Maybe<{ __typename?: 'Zone' } & Pick<Zone, 'id'>> };
          sideB: { __typename?: 'EntrySide' } & Pick<
            EntrySide,
            'id' | 'position' | 'kind' | 'enforcement'
          > & { zone?: Maybe<{ __typename?: 'Zone' } & Pick<Zone, 'id'>> };
          assignments: Array<
            { __typename?: 'ReaderAssignment' } & Pick<
              ReaderAssignment,
              'id'
            > & {
                reader: { __typename?: 'Reader' } & Pick<
                  Reader,
                  'id' | 'readerDeviceId' | 'name'
                >;
                admitsInto: { __typename?: 'EntrySide' } & Pick<
                  EntrySide,
                  'id'
                >;
              }
          >;
        }
    >;
  };

export type SiteLayoutRevisionFieldsFragment = {
  __typename?: 'SiteLayoutRevision';
} & Pick<SiteLayoutRevision, 'id' | 'publishedAt' | 'effectiveTo'> & {
    layout?: Maybe<
      { __typename?: 'SiteLayout' } & Pick<
        SiteLayout,
        'revisionId' | 'draftToken' | 'lastRequestId'
      > & {
          zones: Array<{ __typename?: 'Zone' } & Pick<Zone, 'id' | 'name'>>;
          entries: Array<
            { __typename?: 'Entry' } & Pick<Entry, 'id' | 'name'> & {
                sideA: { __typename?: 'EntrySide' } & Pick<
                  EntrySide,
                  'id' | 'position' | 'kind' | 'enforcement'
                > & {
                    zone?: Maybe<{ __typename?: 'Zone' } & Pick<Zone, 'id'>>;
                  };
                sideB: { __typename?: 'EntrySide' } & Pick<
                  EntrySide,
                  'id' | 'position' | 'kind' | 'enforcement'
                > & {
                    zone?: Maybe<{ __typename?: 'Zone' } & Pick<Zone, 'id'>>;
                  };
                assignments: Array<
                  { __typename?: 'ReaderAssignment' } & Pick<
                    ReaderAssignment,
                    'id'
                  > & {
                      reader: { __typename?: 'Reader' } & Pick<
                        Reader,
                        'id' | 'readerDeviceId' | 'name'
                      >;
                      admitsInto: { __typename?: 'EntrySide' } & Pick<
                        EntrySide,
                        'id'
                      >;
                    }
                >;
              }
          >;
        }
    >;
  };

export type SiteLayoutRevisionSummaryFieldsFragment = {
  __typename?: 'SiteLayoutRevisionSummary';
} & Pick<
  SiteLayoutRevisionSummary,
  | 'revisionId'
  | 'number'
  | 'status'
  | 'publishedAt'
  | 'effectiveTo'
  | 'draftToken'
  | 'lastRequestId'
> & {
    publishedBy?: Maybe<
      { __typename?: 'SiteLayoutActor' } & Pick<SiteLayoutActor, 'id' | 'name'>
    >;
  };

export type GetSiteLayoutOverviewQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetSiteLayoutOverviewQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      siteLayoutOverview: { __typename?: 'SiteLayoutOverview' } & {
        effective?: Maybe<
          { __typename?: 'SiteLayoutRevisionSummary' } & Pick<
            SiteLayoutRevisionSummary,
            | 'revisionId'
            | 'number'
            | 'status'
            | 'publishedAt'
            | 'effectiveTo'
            | 'draftToken'
            | 'lastRequestId'
          > & {
              publishedBy?: Maybe<
                { __typename?: 'SiteLayoutActor' } & Pick<
                  SiteLayoutActor,
                  'id' | 'name'
                >
              >;
            }
        >;
        draft?: Maybe<
          { __typename?: 'SiteLayoutRevisionSummary' } & Pick<
            SiteLayoutRevisionSummary,
            | 'revisionId'
            | 'number'
            | 'status'
            | 'publishedAt'
            | 'effectiveTo'
            | 'draftToken'
            | 'lastRequestId'
          > & {
              publishedBy?: Maybe<
                { __typename?: 'SiteLayoutActor' } & Pick<
                  SiteLayoutActor,
                  'id' | 'name'
                >
              >;
            }
        >;
        history: Array<
          { __typename?: 'SiteLayoutRevisionSummary' } & Pick<
            SiteLayoutRevisionSummary,
            | 'revisionId'
            | 'number'
            | 'status'
            | 'publishedAt'
            | 'effectiveTo'
            | 'draftToken'
            | 'lastRequestId'
          > & {
              publishedBy?: Maybe<
                { __typename?: 'SiteLayoutActor' } & Pick<
                  SiteLayoutActor,
                  'id' | 'name'
                >
              >;
            }
        >;
      };
    };
};

export type GetSiteLayoutStateQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetSiteLayoutStateQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      siteLayoutRevisions: Array<
        { __typename?: 'SiteLayoutRevision' } & Pick<
          SiteLayoutRevision,
          'id' | 'publishedAt' | 'effectiveTo'
        > & {
            layout?: Maybe<
              { __typename?: 'SiteLayout' } & Pick<
                SiteLayout,
                'revisionId' | 'draftToken' | 'lastRequestId'
              > & {
                  zones: Array<
                    { __typename?: 'Zone' } & Pick<Zone, 'id' | 'name'>
                  >;
                  entries: Array<
                    { __typename?: 'Entry' } & Pick<Entry, 'id' | 'name'> & {
                        sideA: { __typename?: 'EntrySide' } & Pick<
                          EntrySide,
                          'id' | 'position' | 'kind' | 'enforcement'
                        > & {
                            zone?: Maybe<
                              { __typename?: 'Zone' } & Pick<Zone, 'id'>
                            >;
                          };
                        sideB: { __typename?: 'EntrySide' } & Pick<
                          EntrySide,
                          'id' | 'position' | 'kind' | 'enforcement'
                        > & {
                            zone?: Maybe<
                              { __typename?: 'Zone' } & Pick<Zone, 'id'>
                            >;
                          };
                        assignments: Array<
                          { __typename?: 'ReaderAssignment' } & Pick<
                            ReaderAssignment,
                            'id'
                          > & {
                              reader: { __typename?: 'Reader' } & Pick<
                                Reader,
                                'id' | 'readerDeviceId' | 'name'
                              >;
                              admitsInto: { __typename?: 'EntrySide' } & Pick<
                                EntrySide,
                                'id'
                              >;
                            }
                        >;
                      }
                  >;
                }
            >;
          }
      >;
    };
};

export type CreateSiteLayoutDraftMutationVariables = Exact<{
  input: CreateSiteLayoutDraftInput;
}>;

export type CreateSiteLayoutDraftMutation = { __typename?: 'Mutation' } & {
  createSiteLayoutDraft: { __typename?: 'SiteLayout' } & Pick<
    SiteLayout,
    'revisionId'
  >;
};

export type DiscardSiteLayoutDraftMutationVariables = Exact<{
  input: DiscardSiteLayoutDraftInput;
}>;

export type DiscardSiteLayoutDraftMutation = { __typename?: 'Mutation' } & {
  discardSiteLayoutDraft?: Maybe<
    { __typename?: 'SiteLayout' } & Pick<SiteLayout, 'revisionId'>
  >;
};

export type PublishSiteLayoutDraftMutationVariables = Exact<{
  input: PublishSiteLayoutDraftInput;
}>;

export type PublishSiteLayoutDraftMutation = { __typename?: 'Mutation' } & {
  publishSiteLayoutDraft: { __typename?: 'SiteLayout' } & Pick<
    SiteLayout,
    'revisionId'
  >;
};

export type LayoutRefusalFieldsFragment = {
  __typename?: 'LayoutRefusal';
} & Pick<
  LayoutRefusal,
  'code' | 'currentToken' | 'field' | 'message' | 'entryIds' | 'gatewayIds'
>;

export type SaveDraftZoneMutationVariables = Exact<{
  input: SaveDraftZoneInput;
}>;

export type SaveDraftZoneMutation = { __typename?: 'Mutation' } & {
  saveDraftZone: { __typename?: 'SaveDraftZonePayload' } & Pick<
    SaveDraftZonePayload,
    'kind' | 'draftToken'
  > & {
      refusals: Array<
        { __typename?: 'LayoutRefusal' } & Pick<
          LayoutRefusal,
          | 'code'
          | 'currentToken'
          | 'field'
          | 'message'
          | 'entryIds'
          | 'gatewayIds'
        >
      >;
    };
};

export type SaveDraftEntryMutationVariables = Exact<{
  input: SaveDraftEntryInput;
}>;

export type SaveDraftEntryMutation = { __typename?: 'Mutation' } & {
  saveDraftEntry: { __typename?: 'SaveDraftEntryPayload' } & Pick<
    SaveDraftEntryPayload,
    'kind' | 'draftToken'
  > & {
      refusals: Array<
        { __typename?: 'LayoutRefusal' } & Pick<
          LayoutRefusal,
          | 'code'
          | 'currentToken'
          | 'field'
          | 'message'
          | 'entryIds'
          | 'gatewayIds'
        >
      >;
      movedReaders?: Maybe<
        Array<
          { __typename?: 'MovedReader' } & Pick<
            MovedReader,
            'readerId' | 'fromEntryId'
          >
        >
      >;
    };
};

export type RemoveDraftZoneMutationVariables = Exact<{
  input: RemoveDraftZoneInput;
}>;

export type RemoveDraftZoneMutation = { __typename?: 'Mutation' } & {
  removeDraftZone: { __typename?: 'RemoveDraftZonePayload' } & Pick<
    RemoveDraftZonePayload,
    'kind' | 'draftToken'
  > & {
      refusals: Array<
        { __typename?: 'LayoutRefusal' } & Pick<
          LayoutRefusal,
          | 'code'
          | 'currentToken'
          | 'field'
          | 'message'
          | 'entryIds'
          | 'gatewayIds'
        >
      >;
    };
};

export type RemoveDraftEntryMutationVariables = Exact<{
  input: RemoveDraftEntryInput;
}>;

export type RemoveDraftEntryMutation = { __typename?: 'Mutation' } & {
  removeDraftEntry: { __typename?: 'RemoveDraftEntryPayload' } & Pick<
    RemoveDraftEntryPayload,
    'kind' | 'draftToken'
  > & {
      refusals: Array<
        { __typename?: 'LayoutRefusal' } & Pick<
          LayoutRefusal,
          | 'code'
          | 'currentToken'
          | 'field'
          | 'message'
          | 'entryIds'
          | 'gatewayIds'
        >
      >;
    };
};

export type SeedEntriesFromGatewaysMutationVariables = Exact<{
  input: SeedEntriesFromGatewaysInput;
}>;

export type SeedEntriesFromGatewaysMutation = { __typename?: 'Mutation' } & {
  seedEntriesFromGateways: {
    __typename?: 'SeedEntriesFromGatewaysPayload';
  } & Pick<
    SeedEntriesFromGatewaysPayload,
    'kind' | 'draftToken' | 'seededEntryIds'
  > & {
      refusals: Array<
        { __typename?: 'LayoutRefusal' } & Pick<
          LayoutRefusal,
          | 'code'
          | 'currentToken'
          | 'field'
          | 'message'
          | 'entryIds'
          | 'gatewayIds'
        >
      >;
    };
};

export type GetSiteGatewaysQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;

export type GetSiteGatewaysQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<Jobsite, 'jobsiteId'> & {
      jobsiteGateways: { __typename?: 'JobsiteGatewaysConnection' } & {
        edges: Array<
          { __typename?: 'JobsiteGatewaysEdge' } & {
            node: { __typename?: 'JobsiteGateway' } & Pick<
              JobsiteGateway,
              'id' | 'name'
            >;
          }
        >;
      };
    };
};

export type GetSiteReaderDevicesQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetSiteReaderDevicesQuery = { __typename?: 'Query' } & {
  siteDevices: Array<
    { __typename?: 'SiteController' } & Pick<SiteController, 'name'> & {
        readers: Array<
          { __typename?: 'SiteControllerReader' } & Pick<
            SiteControllerReader,
            'kind' | 'readerId' | 'readerDeviceId' | 'name' | 'missing'
          > & {
              entry?: Maybe<
                { __typename?: 'SiteReaderEntry' } & Pick<
                  SiteReaderEntry,
                  'externalEntryId' | 'name'
                >
              >;
              health: { __typename?: 'SiteReaderHealth' } & Pick<
                SiteReaderHealth,
                'kind' | 'isMissing' | 'bound' | 'lastReadAt'
              >;
              port?: Maybe<
                { __typename?: 'SiteControllerReaderPort' } & Pick<
                  SiteControllerReaderPort,
                  'id' | 'label' | 'position'
                >
              >;
            }
        >;
      }
  >;
  siteIndependentReaders: Array<
    { __typename?: 'SiteIndependentReader' } & Pick<
      SiteIndependentReader,
      'kind' | 'readerId' | 'readerDeviceId' | 'name' | 'missing'
    > & {
        entry?: Maybe<
          { __typename?: 'SiteReaderEntry' } & Pick<
            SiteReaderEntry,
            'externalEntryId' | 'name'
          >
        >;
        health: { __typename?: 'SiteReaderHealth' } & Pick<
          SiteReaderHealth,
          'kind' | 'isMissing' | 'bound' | 'lastReadAt'
        >;
      }
  >;
  siteUnresolvedReaders: Array<
    { __typename?: 'SiteUnresolvedReader' } & Pick<
      SiteUnresolvedReader,
      'kind' | 'readerId' | 'readerDeviceId' | 'name' | 'missing'
    > & {
        entry?: Maybe<
          { __typename?: 'SiteReaderEntry' } & Pick<
            SiteReaderEntry,
            'externalEntryId' | 'name'
          >
        >;
        health: { __typename?: 'SiteReaderHealth' } & Pick<
          SiteReaderHealth,
          'kind' | 'isMissing' | 'bound' | 'lastReadAt'
        >;
        controller?: Maybe<
          { __typename?: 'SiteUnresolvedReaderController' } & Pick<
            SiteUnresolvedReaderController,
            'assignmentId' | 'name' | 'portLabel'
          >
        >;
      }
  >;
};

export type GetSitePermissionsQueryVariables = Exact<{
  jobsiteId: Scalars['ID']['input'];
}>;

export type GetSitePermissionsQuery = { __typename?: 'Query' } & {
  getJobsite: { __typename?: 'Jobsite' } & Pick<
    Jobsite,
    'jobsiteId' | 'sitePermissions'
  >;
};

export const AccessGroupActorFragmentDoc = gql`
  fragment AccessGroupActor on User {
    userAccountId
    identity {
      firstName
      lastName
    }
  }
`;
export const AccessGroupSummaryFragmentDoc = gql`
  fragment AccessGroupSummary on AccessGroup {
    id
    siteId
    name
    isDefault
    archivedAt
    memberCount
    zones {
      id
      zone {
        id
      }
      name
      state
      grantedAt
      grantedBy {
        ...AccessGroupActor
      }
    }
    avigilon {
      name
      origin
      state
      syncedAt
      error
    }
  }
  ${AccessGroupActorFragmentDoc}
`;
export const ZonesParityWorkerFragmentDoc = gql`
  fragment ZonesParityWorker on ZonesParityWorker {
    workerId
    worker {
      workerId
      user {
        ...AccessGroupActor
      }
    }
  }
  ${AccessGroupActorFragmentDoc}
`;
export const ZonesParityDifferenceFragmentDoc = gql`
  fragment ZonesParityDifference on ZonesParityDifference {
    check
    identity {
      __typename
      ... on ZonesParityWorker {
        ...ZonesParityWorker
      }
      ... on ZonesParityExternalUser {
        externalUserId
      }
    }
  }
  ${ZonesParityWorkerFragmentDoc}
`;
export const ScheduleJobsiteContractorFieldFragmentDoc = gql`
  fragment ScheduleJobsiteContractorField on JobsiteContractor {
    id
    contractor {
      contractorId
      organization {
        organizationId
        legalName
        name
      }
    }
  }
`;
export const ScheduleJobsiteWorkerFieldFragmentDoc = gql`
  fragment ScheduleJobsiteWorkerField on JobsiteWorker {
    jobsiteWorkerId
    trade
    contractorWorker {
      id
      worker {
        workerId
        profilePictureCropped {
          downloadUrl
        }
        user {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export const ConnectorListItemFieldsFragmentDoc = gql`
  fragment ConnectorListItemFields on Connector {
    id
    type
    status
    definition {
      type
      displayName
      connectedDescription
      settingsLabel
    }
  }
`;
export const ConnectorCatalogItemFieldsFragmentDoc = gql`
  fragment ConnectorCatalogItemFields on ConnectorCatalogItem {
    type
    displayName
    available
    setupDescription
    connectedDescription
    settingsLabel
    instance {
      connectorId
      status
    }
  }
`;
export const ConnectorDetailsFieldsFragmentDoc = gql`
  fragment ConnectorDetailsFields on Connector {
    id
    siteId
    type
    status
    createdAt
    createdBy {
      id
      name
    }
    updatedAt
    updatedBy {
      id
      name
    }
  }
`;
export const SiteReaderAttachmentsFieldsFragmentDoc = gql`
  fragment SiteReaderAttachmentsFields on SiteReaderAttachments {
    readerName
    fingerprint
    attachments {
      entryId
      entryName
      zoneId
      zoneName
      siteId
      siteName
      currentSite
      removable
      removalBlockedReason
    }
  }
`;
export const SiteControllerReaderFieldsFragmentDoc = gql`
  fragment SiteControllerReaderFields on SiteControllerReader {
    kind
    entry {
      externalEntryId
      name
    }
    health {
      kind
      isMissing
      bound
      lastReadAt
    }
    readerId
    registeredAt
    registeredBy
    readerDeviceId
    name
    serialNumber
    missing
    port {
      id
      label
      position
    }
    ownership
    connection {
      externalId
      externalName
    }
    placement {
      published {
        placementId
        entryId
        entryName
      }
      draft {
        placementId
        entryId
        entryName
      }
    }
    createdAt
    lastSeenAt
  }
`;
export const SiteControllerFieldsFragmentDoc = gql`
  fragment SiteControllerFields on SiteController {
    assignmentId
    deviceId
    name
    modelKey
    serialNumber
    health
    healthObservedAt
    lastSuccessfulSyncAt
    lastFailureCode
    assignedAt
    assignedBy
    connection {
      externalId
      externalName
    }
    createdAt
    lastSeenAt
    ports {
      id
      externalPortId
      label
      portType
      position
      readerId
    }
    readers {
      ...SiteControllerReaderFields
    }
  }
  ${SiteControllerReaderFieldsFragmentDoc}
`;
export const PolicyConsentStatusFieldsFragmentDoc = gql`
  fragment PolicyConsentStatusFields on UserPolicyConsentStatus {
    document {
      id
      key
      version
      effectiveAt
    }
    lastAcceptedVersion
    lastAcceptedAt
  }
`;
export const EntrySideFieldsFragmentDoc = gql`
  fragment EntrySideFields on EntrySide {
    id
    position
    kind
    zone {
      id
    }
    enforcement
  }
`;
export const EntryFieldsFragmentDoc = gql`
  fragment EntryFields on Entry {
    id
    name
    sideA {
      ...EntrySideFields
    }
    sideB {
      ...EntrySideFields
    }
    assignments {
      id
      reader {
        id
        readerDeviceId
        name
      }
      admitsInto {
        id
      }
    }
  }
  ${EntrySideFieldsFragmentDoc}
`;
export const SiteLayoutFieldsFragmentDoc = gql`
  fragment SiteLayoutFields on SiteLayout {
    revisionId
    draftToken
    lastRequestId
    zones {
      id
      name
    }
    entries {
      ...EntryFields
    }
  }
  ${EntryFieldsFragmentDoc}
`;
export const SiteLayoutRevisionFieldsFragmentDoc = gql`
  fragment SiteLayoutRevisionFields on SiteLayoutRevision {
    id
    publishedAt
    effectiveTo
    layout {
      ...SiteLayoutFields
    }
  }
  ${SiteLayoutFieldsFragmentDoc}
`;
export const SiteLayoutRevisionSummaryFieldsFragmentDoc = gql`
  fragment SiteLayoutRevisionSummaryFields on SiteLayoutRevisionSummary {
    revisionId
    number
    status
    publishedAt
    publishedBy {
      id
      name
    }
    effectiveTo
    draftToken
    lastRequestId
  }
`;
export const LayoutRefusalFieldsFragmentDoc = gql`
  fragment LayoutRefusalFields on LayoutRefusal {
    code
    currentToken
    field
    message
    entryIds
    gatewayIds
  }
`;
export const GetSiteAccessGroupsDocument = gql`
  query GetSiteAccessGroups($siteId: ID!, $includeArchived: Boolean!) {
    siteConfigurationZones(siteId: $siteId) {
      id
      name
      state
    }
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      name
      timeZone
      zonesMode
      accessGroups(includeArchived: $includeArchived) {
        ...AccessGroupSummary
      }
    }
  }
  ${AccessGroupSummaryFragmentDoc}
`;

/**
 * __useGetSiteAccessGroupsQuery__
 *
 * To run a query within a React component, call `useGetSiteAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteAccessGroupsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetSiteAccessGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteAccessGroupsQuery,
    GetSiteAccessGroupsQueryVariables
  > &
    (
      | { variables: GetSiteAccessGroupsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteAccessGroupsQuery,
    GetSiteAccessGroupsQueryVariables
  >(GetSiteAccessGroupsDocument, options);
}
export function useGetSiteAccessGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteAccessGroupsQuery,
    GetSiteAccessGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteAccessGroupsQuery,
    GetSiteAccessGroupsQueryVariables
  >(GetSiteAccessGroupsDocument, options);
}
export function useGetSiteAccessGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteAccessGroupsQuery,
    GetSiteAccessGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteAccessGroupsQuery,
    GetSiteAccessGroupsQueryVariables
  >(GetSiteAccessGroupsDocument, options);
}
export type GetSiteAccessGroupsQueryHookResult = ReturnType<
  typeof useGetSiteAccessGroupsQuery
>;
export type GetSiteAccessGroupsLazyQueryHookResult = ReturnType<
  typeof useGetSiteAccessGroupsLazyQuery
>;
export type GetSiteAccessGroupsSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteAccessGroupsSuspenseQuery
>;
export type GetSiteAccessGroupsQueryResult = Apollo.QueryResult<
  GetSiteAccessGroupsQuery,
  GetSiteAccessGroupsQueryVariables
>;
export const GetAccessGroupDetailsDocument = gql`
  query GetAccessGroupDetails($siteId: ID!, $id: ID!) {
    accessGroup(siteId: $siteId, id: $id) {
      ...AccessGroupSummary
      archivedBy {
        ...AccessGroupActor
      }
      history(first: 50) {
        id
        type
        occurredAt
        actor {
          ...AccessGroupActor
        }
        payload
      }
    }
  }
  ${AccessGroupSummaryFragmentDoc}
  ${AccessGroupActorFragmentDoc}
`;

/**
 * __useGetAccessGroupDetailsQuery__
 *
 * To run a query within a React component, call `useGetAccessGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessGroupDetailsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccessGroupDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccessGroupDetailsQuery,
    GetAccessGroupDetailsQueryVariables
  > &
    (
      | { variables: GetAccessGroupDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccessGroupDetailsQuery,
    GetAccessGroupDetailsQueryVariables
  >(GetAccessGroupDetailsDocument, options);
}
export function useGetAccessGroupDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessGroupDetailsQuery,
    GetAccessGroupDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccessGroupDetailsQuery,
    GetAccessGroupDetailsQueryVariables
  >(GetAccessGroupDetailsDocument, options);
}
export function useGetAccessGroupDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAccessGroupDetailsQuery,
    GetAccessGroupDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccessGroupDetailsQuery,
    GetAccessGroupDetailsQueryVariables
  >(GetAccessGroupDetailsDocument, options);
}
export type GetAccessGroupDetailsQueryHookResult = ReturnType<
  typeof useGetAccessGroupDetailsQuery
>;
export type GetAccessGroupDetailsLazyQueryHookResult = ReturnType<
  typeof useGetAccessGroupDetailsLazyQuery
>;
export type GetAccessGroupDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetAccessGroupDetailsSuspenseQuery
>;
export type GetAccessGroupDetailsQueryResult = Apollo.QueryResult<
  GetAccessGroupDetailsQuery,
  GetAccessGroupDetailsQueryVariables
>;
export const GetWorkerAccessGroupsDocument = gql`
  query GetWorkerAccessGroups($siteId: ID!, $workerId: ID!) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      name
      timeZone
      zonesMode
      accessGroups {
        ...AccessGroupSummary
      }
    }
    workerAccessGroupMemberships(
      siteId: $siteId
      workerId: $workerId
      includeRevoked: true
      includeArchived: true
    ) {
      id
      group {
        ...AccessGroupSummary
      }
      grantedAt
      grantedBy {
        ...AccessGroupActor
      }
      grantSource
      revokedAt
      revokedBy {
        ...AccessGroupActor
      }
      revokeSource
    }
  }
  ${AccessGroupSummaryFragmentDoc}
  ${AccessGroupActorFragmentDoc}
`;

/**
 * __useGetWorkerAccessGroupsQuery__
 *
 * To run a query within a React component, call `useGetWorkerAccessGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerAccessGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerAccessGroupsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetWorkerAccessGroupsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerAccessGroupsQuery,
    GetWorkerAccessGroupsQueryVariables
  > &
    (
      | { variables: GetWorkerAccessGroupsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerAccessGroupsQuery,
    GetWorkerAccessGroupsQueryVariables
  >(GetWorkerAccessGroupsDocument, options);
}
export function useGetWorkerAccessGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerAccessGroupsQuery,
    GetWorkerAccessGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerAccessGroupsQuery,
    GetWorkerAccessGroupsQueryVariables
  >(GetWorkerAccessGroupsDocument, options);
}
export function useGetWorkerAccessGroupsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerAccessGroupsQuery,
    GetWorkerAccessGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerAccessGroupsQuery,
    GetWorkerAccessGroupsQueryVariables
  >(GetWorkerAccessGroupsDocument, options);
}
export type GetWorkerAccessGroupsQueryHookResult = ReturnType<
  typeof useGetWorkerAccessGroupsQuery
>;
export type GetWorkerAccessGroupsLazyQueryHookResult = ReturnType<
  typeof useGetWorkerAccessGroupsLazyQuery
>;
export type GetWorkerAccessGroupsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerAccessGroupsSuspenseQuery
>;
export type GetWorkerAccessGroupsQueryResult = Apollo.QueryResult<
  GetWorkerAccessGroupsQuery,
  GetWorkerAccessGroupsQueryVariables
>;
export const GetSiteZonesModeDocument = gql`
  query GetSiteZonesMode($siteId: ID!) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      timeZone
      zonesMode
      zonesReadiness {
        ready
        items {
          code
          ready
          message
        }
      }
      latestZonesModeChange {
        id
        fromMode
        toMode
        status
        step
        workersEnrolled
        workersTotal
        message
        startedAt
        startedBy {
          ...AccessGroupActor
        }
        finishedAt
        parityResult {
          gained {
            ...ZonesParityDifference
          }
          lost {
            ...ZonesParityDifference
          }
          revokedDefaults {
            ...ZonesParityWorker
          }
          blockers
        }
      }
    }
  }
  ${AccessGroupActorFragmentDoc}
  ${ZonesParityDifferenceFragmentDoc}
  ${ZonesParityWorkerFragmentDoc}
`;

/**
 * __useGetSiteZonesModeQuery__
 *
 * To run a query within a React component, call `useGetSiteZonesModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteZonesModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteZonesModeQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteZonesModeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteZonesModeQuery,
    GetSiteZonesModeQueryVariables
  > &
    (
      | { variables: GetSiteZonesModeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSiteZonesModeQuery, GetSiteZonesModeQueryVariables>(
    GetSiteZonesModeDocument,
    options,
  );
}
export function useGetSiteZonesModeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteZonesModeQuery,
    GetSiteZonesModeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteZonesModeQuery,
    GetSiteZonesModeQueryVariables
  >(GetSiteZonesModeDocument, options);
}
export function useGetSiteZonesModeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteZonesModeQuery,
    GetSiteZonesModeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteZonesModeQuery,
    GetSiteZonesModeQueryVariables
  >(GetSiteZonesModeDocument, options);
}
export type GetSiteZonesModeQueryHookResult = ReturnType<
  typeof useGetSiteZonesModeQuery
>;
export type GetSiteZonesModeLazyQueryHookResult = ReturnType<
  typeof useGetSiteZonesModeLazyQuery
>;
export type GetSiteZonesModeSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteZonesModeSuspenseQuery
>;
export type GetSiteZonesModeQueryResult = Apollo.QueryResult<
  GetSiteZonesModeQuery,
  GetSiteZonesModeQueryVariables
>;
export const ChangeZonesModeDocument = gql`
  mutation ChangeZonesMode($input: ChangeZonesModeInput!) {
    changeZonesMode(input: $input) {
      id
    }
  }
`;
export type ChangeZonesModeMutationFn = Apollo.MutationFunction<
  ChangeZonesModeMutation,
  ChangeZonesModeMutationVariables
>;

/**
 * __useChangeZonesModeMutation__
 *
 * To run a mutation, you first call `useChangeZonesModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeZonesModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeZonesModeMutation, { data, loading, error }] = useChangeZonesModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeZonesModeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeZonesModeMutation,
    ChangeZonesModeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeZonesModeMutation,
    ChangeZonesModeMutationVariables
  >(ChangeZonesModeDocument, options);
}
export type ChangeZonesModeMutationHookResult = ReturnType<
  typeof useChangeZonesModeMutation
>;
export type ChangeZonesModeMutationResult =
  Apollo.MutationResult<ChangeZonesModeMutation>;
export type ChangeZonesModeMutationOptions = Apollo.BaseMutationOptions<
  ChangeZonesModeMutation,
  ChangeZonesModeMutationVariables
>;
export const CreateAccessGroupDocument = gql`
  mutation CreateAccessGroup($input: CreateAccessGroupInput!) {
    createAccessGroup(input: $input) {
      id
    }
  }
`;
export type CreateAccessGroupMutationFn = Apollo.MutationFunction<
  CreateAccessGroupMutation,
  CreateAccessGroupMutationVariables
>;

/**
 * __useCreateAccessGroupMutation__
 *
 * To run a mutation, you first call `useCreateAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccessGroupMutation, { data, loading, error }] = useCreateAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccessGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAccessGroupMutation,
    CreateAccessGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAccessGroupMutation,
    CreateAccessGroupMutationVariables
  >(CreateAccessGroupDocument, options);
}
export type CreateAccessGroupMutationHookResult = ReturnType<
  typeof useCreateAccessGroupMutation
>;
export type CreateAccessGroupMutationResult =
  Apollo.MutationResult<CreateAccessGroupMutation>;
export type CreateAccessGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateAccessGroupMutation,
  CreateAccessGroupMutationVariables
>;
export const RenameAccessGroupDocument = gql`
  mutation RenameAccessGroup($input: RenameAccessGroupInput!) {
    renameAccessGroup(input: $input) {
      id
    }
  }
`;
export type RenameAccessGroupMutationFn = Apollo.MutationFunction<
  RenameAccessGroupMutation,
  RenameAccessGroupMutationVariables
>;

/**
 * __useRenameAccessGroupMutation__
 *
 * To run a mutation, you first call `useRenameAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameAccessGroupMutation, { data, loading, error }] = useRenameAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameAccessGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameAccessGroupMutation,
    RenameAccessGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RenameAccessGroupMutation,
    RenameAccessGroupMutationVariables
  >(RenameAccessGroupDocument, options);
}
export type RenameAccessGroupMutationHookResult = ReturnType<
  typeof useRenameAccessGroupMutation
>;
export type RenameAccessGroupMutationResult =
  Apollo.MutationResult<RenameAccessGroupMutation>;
export type RenameAccessGroupMutationOptions = Apollo.BaseMutationOptions<
  RenameAccessGroupMutation,
  RenameAccessGroupMutationVariables
>;
export const SetDefaultAccessGroupDocument = gql`
  mutation SetDefaultAccessGroup($input: AccessGroupInput!) {
    setDefaultAccessGroup(input: $input) {
      id
    }
  }
`;
export type SetDefaultAccessGroupMutationFn = Apollo.MutationFunction<
  SetDefaultAccessGroupMutation,
  SetDefaultAccessGroupMutationVariables
>;

/**
 * __useSetDefaultAccessGroupMutation__
 *
 * To run a mutation, you first call `useSetDefaultAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultAccessGroupMutation, { data, loading, error }] = useSetDefaultAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultAccessGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDefaultAccessGroupMutation,
    SetDefaultAccessGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDefaultAccessGroupMutation,
    SetDefaultAccessGroupMutationVariables
  >(SetDefaultAccessGroupDocument, options);
}
export type SetDefaultAccessGroupMutationHookResult = ReturnType<
  typeof useSetDefaultAccessGroupMutation
>;
export type SetDefaultAccessGroupMutationResult =
  Apollo.MutationResult<SetDefaultAccessGroupMutation>;
export type SetDefaultAccessGroupMutationOptions = Apollo.BaseMutationOptions<
  SetDefaultAccessGroupMutation,
  SetDefaultAccessGroupMutationVariables
>;
export const ArchiveAccessGroupDocument = gql`
  mutation ArchiveAccessGroup($input: AccessGroupInput!) {
    archiveAccessGroup(input: $input) {
      id
    }
  }
`;
export type ArchiveAccessGroupMutationFn = Apollo.MutationFunction<
  ArchiveAccessGroupMutation,
  ArchiveAccessGroupMutationVariables
>;

/**
 * __useArchiveAccessGroupMutation__
 *
 * To run a mutation, you first call `useArchiveAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAccessGroupMutation, { data, loading, error }] = useArchiveAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveAccessGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveAccessGroupMutation,
    ArchiveAccessGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveAccessGroupMutation,
    ArchiveAccessGroupMutationVariables
  >(ArchiveAccessGroupDocument, options);
}
export type ArchiveAccessGroupMutationHookResult = ReturnType<
  typeof useArchiveAccessGroupMutation
>;
export type ArchiveAccessGroupMutationResult =
  Apollo.MutationResult<ArchiveAccessGroupMutation>;
export type ArchiveAccessGroupMutationOptions = Apollo.BaseMutationOptions<
  ArchiveAccessGroupMutation,
  ArchiveAccessGroupMutationVariables
>;
export const AddZoneToAccessGroupDocument = gql`
  mutation AddZoneToAccessGroup($input: AccessGroupZoneInput!) {
    addZoneToAccessGroup(input: $input) {
      id
    }
  }
`;
export type AddZoneToAccessGroupMutationFn = Apollo.MutationFunction<
  AddZoneToAccessGroupMutation,
  AddZoneToAccessGroupMutationVariables
>;

/**
 * __useAddZoneToAccessGroupMutation__
 *
 * To run a mutation, you first call `useAddZoneToAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddZoneToAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addZoneToAccessGroupMutation, { data, loading, error }] = useAddZoneToAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddZoneToAccessGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddZoneToAccessGroupMutation,
    AddZoneToAccessGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddZoneToAccessGroupMutation,
    AddZoneToAccessGroupMutationVariables
  >(AddZoneToAccessGroupDocument, options);
}
export type AddZoneToAccessGroupMutationHookResult = ReturnType<
  typeof useAddZoneToAccessGroupMutation
>;
export type AddZoneToAccessGroupMutationResult =
  Apollo.MutationResult<AddZoneToAccessGroupMutation>;
export type AddZoneToAccessGroupMutationOptions = Apollo.BaseMutationOptions<
  AddZoneToAccessGroupMutation,
  AddZoneToAccessGroupMutationVariables
>;
export const RemoveZoneFromAccessGroupDocument = gql`
  mutation RemoveZoneFromAccessGroup($input: AccessGroupZoneInput!) {
    removeZoneFromAccessGroup(input: $input) {
      id
    }
  }
`;
export type RemoveZoneFromAccessGroupMutationFn = Apollo.MutationFunction<
  RemoveZoneFromAccessGroupMutation,
  RemoveZoneFromAccessGroupMutationVariables
>;

/**
 * __useRemoveZoneFromAccessGroupMutation__
 *
 * To run a mutation, you first call `useRemoveZoneFromAccessGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveZoneFromAccessGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeZoneFromAccessGroupMutation, { data, loading, error }] = useRemoveZoneFromAccessGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveZoneFromAccessGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveZoneFromAccessGroupMutation,
    RemoveZoneFromAccessGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveZoneFromAccessGroupMutation,
    RemoveZoneFromAccessGroupMutationVariables
  >(RemoveZoneFromAccessGroupDocument, options);
}
export type RemoveZoneFromAccessGroupMutationHookResult = ReturnType<
  typeof useRemoveZoneFromAccessGroupMutation
>;
export type RemoveZoneFromAccessGroupMutationResult =
  Apollo.MutationResult<RemoveZoneFromAccessGroupMutation>;
export type RemoveZoneFromAccessGroupMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveZoneFromAccessGroupMutation,
    RemoveZoneFromAccessGroupMutationVariables
  >;
export const GrantAccessGroupMembershipDocument = gql`
  mutation GrantAccessGroupMembership($input: AccessGroupMembershipInput!) {
    grantAccessGroupMembership(input: $input) {
      id
    }
  }
`;
export type GrantAccessGroupMembershipMutationFn = Apollo.MutationFunction<
  GrantAccessGroupMembershipMutation,
  GrantAccessGroupMembershipMutationVariables
>;

/**
 * __useGrantAccessGroupMembershipMutation__
 *
 * To run a mutation, you first call `useGrantAccessGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantAccessGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantAccessGroupMembershipMutation, { data, loading, error }] = useGrantAccessGroupMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantAccessGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GrantAccessGroupMembershipMutation,
    GrantAccessGroupMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GrantAccessGroupMembershipMutation,
    GrantAccessGroupMembershipMutationVariables
  >(GrantAccessGroupMembershipDocument, options);
}
export type GrantAccessGroupMembershipMutationHookResult = ReturnType<
  typeof useGrantAccessGroupMembershipMutation
>;
export type GrantAccessGroupMembershipMutationResult =
  Apollo.MutationResult<GrantAccessGroupMembershipMutation>;
export type GrantAccessGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    GrantAccessGroupMembershipMutation,
    GrantAccessGroupMembershipMutationVariables
  >;
export const RevokeAccessGroupMembershipDocument = gql`
  mutation RevokeAccessGroupMembership(
    $input: RevokeAccessGroupMembershipInput!
  ) {
    revokeAccessGroupMembership(input: $input) {
      id
    }
  }
`;
export type RevokeAccessGroupMembershipMutationFn = Apollo.MutationFunction<
  RevokeAccessGroupMembershipMutation,
  RevokeAccessGroupMembershipMutationVariables
>;

/**
 * __useRevokeAccessGroupMembershipMutation__
 *
 * To run a mutation, you first call `useRevokeAccessGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAccessGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAccessGroupMembershipMutation, { data, loading, error }] = useRevokeAccessGroupMembershipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeAccessGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeAccessGroupMembershipMutation,
    RevokeAccessGroupMembershipMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeAccessGroupMembershipMutation,
    RevokeAccessGroupMembershipMutationVariables
  >(RevokeAccessGroupMembershipDocument, options);
}
export type RevokeAccessGroupMembershipMutationHookResult = ReturnType<
  typeof useRevokeAccessGroupMembershipMutation
>;
export type RevokeAccessGroupMembershipMutationResult =
  Apollo.MutationResult<RevokeAccessGroupMembershipMutation>;
export type RevokeAccessGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    RevokeAccessGroupMembershipMutation,
    RevokeAccessGroupMembershipMutationVariables
  >;
export const GetWorkerAccessGroupSitesDocument = gql`
  query GetWorkerAccessGroupSites($workerId: ID!) {
    workerAccessGroupSites(workerId: $workerId) {
      siteId
      name
    }
  }
`;

/**
 * __useGetWorkerAccessGroupSitesQuery__
 *
 * To run a query within a React component, call `useGetWorkerAccessGroupSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerAccessGroupSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerAccessGroupSitesQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetWorkerAccessGroupSitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerAccessGroupSitesQuery,
    GetWorkerAccessGroupSitesQueryVariables
  > &
    (
      | { variables: GetWorkerAccessGroupSitesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerAccessGroupSitesQuery,
    GetWorkerAccessGroupSitesQueryVariables
  >(GetWorkerAccessGroupSitesDocument, options);
}
export function useGetWorkerAccessGroupSitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerAccessGroupSitesQuery,
    GetWorkerAccessGroupSitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerAccessGroupSitesQuery,
    GetWorkerAccessGroupSitesQueryVariables
  >(GetWorkerAccessGroupSitesDocument, options);
}
export function useGetWorkerAccessGroupSitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerAccessGroupSitesQuery,
    GetWorkerAccessGroupSitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerAccessGroupSitesQuery,
    GetWorkerAccessGroupSitesQueryVariables
  >(GetWorkerAccessGroupSitesDocument, options);
}
export type GetWorkerAccessGroupSitesQueryHookResult = ReturnType<
  typeof useGetWorkerAccessGroupSitesQuery
>;
export type GetWorkerAccessGroupSitesLazyQueryHookResult = ReturnType<
  typeof useGetWorkerAccessGroupSitesLazyQuery
>;
export type GetWorkerAccessGroupSitesSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerAccessGroupSitesSuspenseQuery
>;
export type GetWorkerAccessGroupSitesQueryResult = Apollo.QueryResult<
  GetWorkerAccessGroupSitesQuery,
  GetWorkerAccessGroupSitesQueryVariables
>;
export const RetryAccessGroupPushDocument = gql`
  mutation RetryAccessGroupPush($input: AccessGroupInput!) {
    retryAccessGroupPush(input: $input) {
      id
    }
  }
`;
export type RetryAccessGroupPushMutationFn = Apollo.MutationFunction<
  RetryAccessGroupPushMutation,
  RetryAccessGroupPushMutationVariables
>;

/**
 * __useRetryAccessGroupPushMutation__
 *
 * To run a mutation, you first call `useRetryAccessGroupPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryAccessGroupPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryAccessGroupPushMutation, { data, loading, error }] = useRetryAccessGroupPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryAccessGroupPushMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetryAccessGroupPushMutation,
    RetryAccessGroupPushMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetryAccessGroupPushMutation,
    RetryAccessGroupPushMutationVariables
  >(RetryAccessGroupPushDocument, options);
}
export type RetryAccessGroupPushMutationHookResult = ReturnType<
  typeof useRetryAccessGroupPushMutation
>;
export type RetryAccessGroupPushMutationResult =
  Apollo.MutationResult<RetryAccessGroupPushMutation>;
export type RetryAccessGroupPushMutationOptions = Apollo.BaseMutationOptions<
  RetryAccessGroupPushMutation,
  RetryAccessGroupPushMutationVariables
>;
export const GetAccessGroupMembersDocument = gql`
  query GetAccessGroupMembers($siteId: ID!, $id: ID!, $after: ID) {
    accessGroup(siteId: $siteId, id: $id) {
      id
      members(first: 50, after: $after) {
        id
        cursor
        worker {
          workerId
          user {
            ...AccessGroupActor
          }
        }
        grantedAt
        grantedBy {
          ...AccessGroupActor
        }
        grantSource
      }
    }
  }
  ${AccessGroupActorFragmentDoc}
`;

/**
 * __useGetAccessGroupMembersQuery__
 *
 * To run a query within a React component, call `useGetAccessGroupMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessGroupMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessGroupMembersQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAccessGroupMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccessGroupMembersQuery,
    GetAccessGroupMembersQueryVariables
  > &
    (
      | { variables: GetAccessGroupMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccessGroupMembersQuery,
    GetAccessGroupMembersQueryVariables
  >(GetAccessGroupMembersDocument, options);
}
export function useGetAccessGroupMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessGroupMembersQuery,
    GetAccessGroupMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccessGroupMembersQuery,
    GetAccessGroupMembersQueryVariables
  >(GetAccessGroupMembersDocument, options);
}
export function useGetAccessGroupMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAccessGroupMembersQuery,
    GetAccessGroupMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccessGroupMembersQuery,
    GetAccessGroupMembersQueryVariables
  >(GetAccessGroupMembersDocument, options);
}
export type GetAccessGroupMembersQueryHookResult = ReturnType<
  typeof useGetAccessGroupMembersQuery
>;
export type GetAccessGroupMembersLazyQueryHookResult = ReturnType<
  typeof useGetAccessGroupMembersLazyQuery
>;
export type GetAccessGroupMembersSuspenseQueryHookResult = ReturnType<
  typeof useGetAccessGroupMembersSuspenseQuery
>;
export type GetAccessGroupMembersQueryResult = Apollo.QueryResult<
  GetAccessGroupMembersQuery,
  GetAccessGroupMembersQueryVariables
>;
export const DisconnectProcoreDocument = gql`
  mutation DisconnectProcore {
    disconnectProcore {
      success
    }
  }
`;
export type DisconnectProcoreMutationFn = Apollo.MutationFunction<
  DisconnectProcoreMutation,
  DisconnectProcoreMutationVariables
>;

/**
 * __useDisconnectProcoreMutation__
 *
 * To run a mutation, you first call `useDisconnectProcoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectProcoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectProcoreMutation, { data, loading, error }] = useDisconnectProcoreMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectProcoreMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisconnectProcoreMutation,
    DisconnectProcoreMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisconnectProcoreMutation,
    DisconnectProcoreMutationVariables
  >(DisconnectProcoreDocument, options);
}
export type DisconnectProcoreMutationHookResult = ReturnType<
  typeof useDisconnectProcoreMutation
>;
export type DisconnectProcoreMutationResult =
  Apollo.MutationResult<DisconnectProcoreMutation>;
export type DisconnectProcoreMutationOptions = Apollo.BaseMutationOptions<
  DisconnectProcoreMutation,
  DisconnectProcoreMutationVariables
>;
export const ProcoreOAuthExchangeDocument = gql`
  mutation ProcoreOAuthExchange($code: String!, $state: String!) {
    procoreOAuthExchange(code: $code, state: $state) {
      connected
      procoreUserId
    }
  }
`;
export type ProcoreOAuthExchangeMutationFn = Apollo.MutationFunction<
  ProcoreOAuthExchangeMutation,
  ProcoreOAuthExchangeMutationVariables
>;

/**
 * __useProcoreOAuthExchangeMutation__
 *
 * To run a mutation, you first call `useProcoreOAuthExchangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcoreOAuthExchangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [procoreOAuthExchangeMutation, { data, loading, error }] = useProcoreOAuthExchangeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useProcoreOAuthExchangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProcoreOAuthExchangeMutation,
    ProcoreOAuthExchangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProcoreOAuthExchangeMutation,
    ProcoreOAuthExchangeMutationVariables
  >(ProcoreOAuthExchangeDocument, options);
}
export type ProcoreOAuthExchangeMutationHookResult = ReturnType<
  typeof useProcoreOAuthExchangeMutation
>;
export type ProcoreOAuthExchangeMutationResult =
  Apollo.MutationResult<ProcoreOAuthExchangeMutation>;
export type ProcoreOAuthExchangeMutationOptions = Apollo.BaseMutationOptions<
  ProcoreOAuthExchangeMutation,
  ProcoreOAuthExchangeMutationVariables
>;
export const ProcoreOAuthStartDocument = gql`
  mutation ProcoreOAuthStart {
    procoreOAuthStart {
      authorizeUrl
    }
  }
`;
export type ProcoreOAuthStartMutationFn = Apollo.MutationFunction<
  ProcoreOAuthStartMutation,
  ProcoreOAuthStartMutationVariables
>;

/**
 * __useProcoreOAuthStartMutation__
 *
 * To run a mutation, you first call `useProcoreOAuthStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcoreOAuthStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [procoreOAuthStartMutation, { data, loading, error }] = useProcoreOAuthStartMutation({
 *   variables: {
 *   },
 * });
 */
export function useProcoreOAuthStartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProcoreOAuthStartMutation,
    ProcoreOAuthStartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProcoreOAuthStartMutation,
    ProcoreOAuthStartMutationVariables
  >(ProcoreOAuthStartDocument, options);
}
export type ProcoreOAuthStartMutationHookResult = ReturnType<
  typeof useProcoreOAuthStartMutation
>;
export type ProcoreOAuthStartMutationResult =
  Apollo.MutationResult<ProcoreOAuthStartMutation>;
export type ProcoreOAuthStartMutationOptions = Apollo.BaseMutationOptions<
  ProcoreOAuthStartMutation,
  ProcoreOAuthStartMutationVariables
>;
export const RecordPolicyConsentDocument = gql`
  mutation RecordPolicyConsent($input: RecordPolicyConsentInput!) {
    recordPolicyConsent(input: $input) {
      success
    }
  }
`;
export type RecordPolicyConsentMutationFn = Apollo.MutationFunction<
  RecordPolicyConsentMutation,
  RecordPolicyConsentMutationVariables
>;

/**
 * __useRecordPolicyConsentMutation__
 *
 * To run a mutation, you first call `useRecordPolicyConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPolicyConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPolicyConsentMutation, { data, loading, error }] = useRecordPolicyConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordPolicyConsentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordPolicyConsentMutation,
    RecordPolicyConsentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordPolicyConsentMutation,
    RecordPolicyConsentMutationVariables
  >(RecordPolicyConsentDocument, options);
}
export type RecordPolicyConsentMutationHookResult = ReturnType<
  typeof useRecordPolicyConsentMutation
>;
export type RecordPolicyConsentMutationResult =
  Apollo.MutationResult<RecordPolicyConsentMutation>;
export type RecordPolicyConsentMutationOptions = Apollo.BaseMutationOptions<
  RecordPolicyConsentMutation,
  RecordPolicyConsentMutationVariables
>;
export const TrackIntegrationHandoffDocument = gql`
  mutation TrackIntegrationHandoff($integrationType: ExternalIntegrationType!) {
    trackIntegrationHandoff(integrationType: $integrationType) {
      integrationType
      url
    }
  }
`;
export type TrackIntegrationHandoffMutationFn = Apollo.MutationFunction<
  TrackIntegrationHandoffMutation,
  TrackIntegrationHandoffMutationVariables
>;

/**
 * __useTrackIntegrationHandoffMutation__
 *
 * To run a mutation, you first call `useTrackIntegrationHandoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackIntegrationHandoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackIntegrationHandoffMutation, { data, loading, error }] = useTrackIntegrationHandoffMutation({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *   },
 * });
 */
export function useTrackIntegrationHandoffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackIntegrationHandoffMutation,
    TrackIntegrationHandoffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackIntegrationHandoffMutation,
    TrackIntegrationHandoffMutationVariables
  >(TrackIntegrationHandoffDocument, options);
}
export type TrackIntegrationHandoffMutationHookResult = ReturnType<
  typeof useTrackIntegrationHandoffMutation
>;
export type TrackIntegrationHandoffMutationResult =
  Apollo.MutationResult<TrackIntegrationHandoffMutation>;
export type TrackIntegrationHandoffMutationOptions = Apollo.BaseMutationOptions<
  TrackIntegrationHandoffMutation,
  TrackIntegrationHandoffMutationVariables
>;
export const TrackSessionDocument = gql`
  mutation TrackSession($sessionType: SessionType!) {
    trackSession(sessionType: $sessionType) {
      success
    }
  }
`;
export type TrackSessionMutationFn = Apollo.MutationFunction<
  TrackSessionMutation,
  TrackSessionMutationVariables
>;

/**
 * __useTrackSessionMutation__
 *
 * To run a mutation, you first call `useTrackSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackSessionMutation, { data, loading, error }] = useTrackSessionMutation({
 *   variables: {
 *      sessionType: // value for 'sessionType'
 *   },
 * });
 */
export function useTrackSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TrackSessionMutation,
    TrackSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TrackSessionMutation,
    TrackSessionMutationVariables
  >(TrackSessionDocument, options);
}
export type TrackSessionMutationHookResult = ReturnType<
  typeof useTrackSessionMutation
>;
export type TrackSessionMutationResult =
  Apollo.MutationResult<TrackSessionMutation>;
export type TrackSessionMutationOptions = Apollo.BaseMutationOptions<
  TrackSessionMutation,
  TrackSessionMutationVariables
>;
export const GetCurrentSessionDocument = gql`
  query GetCurrentSession($includeComputedRoles: Boolean) {
    getCurrentSession(includeComputedRoles: $includeComputedRoles) {
      user {
        userAccountId
        createdAt
        hasUrlLockCode
        identity {
          email
          firstName
          lastName
          createdAt
          updatedAt
          smsConsentReceivedAt
        }
        hasPaidAccess
        hasAnnouncementsEnabled
        hasFormsEnabled
        hasSchedulingEnabled
        hasCamerasEnabled
        roles {
          key
          object {
            objectName
            objectId
          }
        }
        profilePictureCropped {
          downloadUrl
          fileId
          fileType
        }
        worker {
          workerId
        }
      }
      session {
        sessionToken
        authType
        createdAt
        updatedAt
        lastActiveAt
        urlLock
        appVersion
      }
      policyConsentStatuses {
        ...PolicyConsentStatusFields
      }
    }
  }
  ${PolicyConsentStatusFieldsFragmentDoc}
`;

/**
 * __useGetCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentSessionQuery({
 *   variables: {
 *      includeComputedRoles: // value for 'includeComputedRoles'
 *   },
 * });
 */
export function useGetCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentSessionQuery,
    GetCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentSessionQuery,
    GetCurrentSessionQueryVariables
  >(GetCurrentSessionDocument, options);
}
export function useGetCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentSessionQuery,
    GetCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentSessionQuery,
    GetCurrentSessionQueryVariables
  >(GetCurrentSessionDocument, options);
}
export function useGetCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentSessionQuery,
    GetCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentSessionQuery,
    GetCurrentSessionQueryVariables
  >(GetCurrentSessionDocument, options);
}
export type GetCurrentSessionQueryHookResult = ReturnType<
  typeof useGetCurrentSessionQuery
>;
export type GetCurrentSessionLazyQueryHookResult = ReturnType<
  typeof useGetCurrentSessionLazyQuery
>;
export type GetCurrentSessionSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentSessionSuspenseQuery
>;
export type GetCurrentSessionQueryResult = Apollo.QueryResult<
  GetCurrentSessionQuery,
  GetCurrentSessionQueryVariables
>;
export const GetProcoreConnectionStatusDocument = gql`
  query GetProcoreConnectionStatus {
    getProcoreConnectionStatus {
      connected
      procoreUserId
    }
  }
`;

/**
 * __useGetProcoreConnectionStatusQuery__
 *
 * To run a query within a React component, call `useGetProcoreConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcoreConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcoreConnectionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProcoreConnectionStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProcoreConnectionStatusQuery,
    GetProcoreConnectionStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProcoreConnectionStatusQuery,
    GetProcoreConnectionStatusQueryVariables
  >(GetProcoreConnectionStatusDocument, options);
}
export function useGetProcoreConnectionStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProcoreConnectionStatusQuery,
    GetProcoreConnectionStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProcoreConnectionStatusQuery,
    GetProcoreConnectionStatusQueryVariables
  >(GetProcoreConnectionStatusDocument, options);
}
export function useGetProcoreConnectionStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProcoreConnectionStatusQuery,
    GetProcoreConnectionStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetProcoreConnectionStatusQuery,
    GetProcoreConnectionStatusQueryVariables
  >(GetProcoreConnectionStatusDocument, options);
}
export type GetProcoreConnectionStatusQueryHookResult = ReturnType<
  typeof useGetProcoreConnectionStatusQuery
>;
export type GetProcoreConnectionStatusLazyQueryHookResult = ReturnType<
  typeof useGetProcoreConnectionStatusLazyQuery
>;
export type GetProcoreConnectionStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetProcoreConnectionStatusSuspenseQuery
>;
export type GetProcoreConnectionStatusQueryResult = Apollo.QueryResult<
  GetProcoreConnectionStatusQuery,
  GetProcoreConnectionStatusQueryVariables
>;
export const SearchWorkersFromSearchBoxDocument = gql`
  query SearchWorkersFromSearchBox(
    $searchString: String!
    $limit: Int
    $offset: Int
  ) {
    searchWorkers(searchString: $searchString, limit: $limit, offset: $offset) {
      count
      results {
        worker {
          workerId
          birthDate
          quickCode
          user {
            userAccountId
            identity {
              firstName
              lastName
              email
              phoneNumber
            }
          }
          profilePicture {
            downloadUrl
          }
          profilePictureCropped {
            downloadUrl
          }
          contractorWorkers {
            edges {
              node {
                contractor {
                  contractorId
                  organization {
                    name
                    slug
                  }
                }
                jobsiteWorkers {
                  edges {
                    node {
                      jobsiteWorkerId
                      trade
                      jobTitle
                      stickerNumber
                      currentAccess {
                        isAllowed
                      }
                      jobsiteContractor {
                        jobsite {
                          name
                          jobsiteId
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSearchWorkersFromSearchBoxQuery__
 *
 * To run a query within a React component, call `useSearchWorkersFromSearchBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWorkersFromSearchBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWorkersFromSearchBoxQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchWorkersFromSearchBoxQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchWorkersFromSearchBoxQuery,
    SearchWorkersFromSearchBoxQueryVariables
  > &
    (
      | { variables: SearchWorkersFromSearchBoxQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SearchWorkersFromSearchBoxQuery,
    SearchWorkersFromSearchBoxQueryVariables
  >(SearchWorkersFromSearchBoxDocument, options);
}
export function useSearchWorkersFromSearchBoxLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchWorkersFromSearchBoxQuery,
    SearchWorkersFromSearchBoxQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SearchWorkersFromSearchBoxQuery,
    SearchWorkersFromSearchBoxQueryVariables
  >(SearchWorkersFromSearchBoxDocument, options);
}
export function useSearchWorkersFromSearchBoxSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchWorkersFromSearchBoxQuery,
    SearchWorkersFromSearchBoxQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchWorkersFromSearchBoxQuery,
    SearchWorkersFromSearchBoxQueryVariables
  >(SearchWorkersFromSearchBoxDocument, options);
}
export type SearchWorkersFromSearchBoxQueryHookResult = ReturnType<
  typeof useSearchWorkersFromSearchBoxQuery
>;
export type SearchWorkersFromSearchBoxLazyQueryHookResult = ReturnType<
  typeof useSearchWorkersFromSearchBoxLazyQuery
>;
export type SearchWorkersFromSearchBoxSuspenseQueryHookResult = ReturnType<
  typeof useSearchWorkersFromSearchBoxSuspenseQuery
>;
export type SearchWorkersFromSearchBoxQueryResult = Apollo.QueryResult<
  SearchWorkersFromSearchBoxQuery,
  SearchWorkersFromSearchBoxQueryVariables
>;
export const GetJobsiteAnnouncementDocument = gql`
  query GetJobsiteAnnouncement($announcementId: ID!) {
    getJobsiteAnnouncement(jobsiteAnnouncementId: $announcementId) {
      announcementType
      jobsiteAnnouncementId
      subject
      status
      message
      sentAt
      startAt
      endAt
      timeZone
      jobsites {
        count
        edges {
          node {
            jobsiteId
            name
          }
        }
      }
      contractors {
        count
        edges {
          node {
            contractorId
            organization {
              name
            }
          }
        }
      }
      jobsiteAccessStatus
      accessWithinDayRange
      trades
      titles
      languages
      sentBy {
        profilePictureCropped {
          downloadUrl
        }
        identity {
          firstName
          lastName
        }
      }
      publishedCount
      deliveredCount
      files {
        fileId
        fileType
        downloadUrl
        originalFileName
      }
    }
  }
`;

/**
 * __useGetJobsiteAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetJobsiteAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteAnnouncementQuery({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *   },
 * });
 */
export function useGetJobsiteAnnouncementQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteAnnouncementQuery,
    GetJobsiteAnnouncementQueryVariables
  > &
    (
      | { variables: GetJobsiteAnnouncementQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteAnnouncementQuery,
    GetJobsiteAnnouncementQueryVariables
  >(GetJobsiteAnnouncementDocument, options);
}
export function useGetJobsiteAnnouncementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteAnnouncementQuery,
    GetJobsiteAnnouncementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteAnnouncementQuery,
    GetJobsiteAnnouncementQueryVariables
  >(GetJobsiteAnnouncementDocument, options);
}
export function useGetJobsiteAnnouncementSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteAnnouncementQuery,
    GetJobsiteAnnouncementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteAnnouncementQuery,
    GetJobsiteAnnouncementQueryVariables
  >(GetJobsiteAnnouncementDocument, options);
}
export type GetJobsiteAnnouncementQueryHookResult = ReturnType<
  typeof useGetJobsiteAnnouncementQuery
>;
export type GetJobsiteAnnouncementLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteAnnouncementLazyQuery
>;
export type GetJobsiteAnnouncementSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteAnnouncementSuspenseQuery
>;
export type GetJobsiteAnnouncementQueryResult = Apollo.QueryResult<
  GetJobsiteAnnouncementQuery,
  GetJobsiteAnnouncementQueryVariables
>;
export const CreateJobsiteAnnouncementDocument = gql`
  mutation CreateJobsiteAnnouncement(
    $jobsiteAnnouncementInput: JobsiteAnnouncementInput!
  ) {
    createJobsiteAnnouncement(
      jobsiteAnnouncementInput: $jobsiteAnnouncementInput
    ) {
      announcementType
      jobsiteAnnouncementId
      subject
      status
      message
      sentAt
      startAt
      endAt
      timeZone
      jobsites {
        count
        edges {
          node {
            jobsiteId
            name
          }
        }
      }
      jobsiteAccessStatus
      accessWithinDayRange
      trades
      titles
      languages
    }
  }
`;
export type CreateJobsiteAnnouncementMutationFn = Apollo.MutationFunction<
  CreateJobsiteAnnouncementMutation,
  CreateJobsiteAnnouncementMutationVariables
>;

/**
 * __useCreateJobsiteAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateJobsiteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobsiteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobsiteAnnouncementMutation, { data, loading, error }] = useCreateJobsiteAnnouncementMutation({
 *   variables: {
 *      jobsiteAnnouncementInput: // value for 'jobsiteAnnouncementInput'
 *   },
 * });
 */
export function useCreateJobsiteAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateJobsiteAnnouncementMutation,
    CreateJobsiteAnnouncementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateJobsiteAnnouncementMutation,
    CreateJobsiteAnnouncementMutationVariables
  >(CreateJobsiteAnnouncementDocument, options);
}
export type CreateJobsiteAnnouncementMutationHookResult = ReturnType<
  typeof useCreateJobsiteAnnouncementMutation
>;
export type CreateJobsiteAnnouncementMutationResult =
  Apollo.MutationResult<CreateJobsiteAnnouncementMutation>;
export type CreateJobsiteAnnouncementMutationOptions =
  Apollo.BaseMutationOptions<
    CreateJobsiteAnnouncementMutation,
    CreateJobsiteAnnouncementMutationVariables
  >;
export const DeleteJobsiteAnnouncementDocument = gql`
  mutation DeleteJobsiteAnnouncement($jobsiteAnnouncementId: ID!) {
    deleteJobsiteAnnouncement(jobsiteAnnouncementId: $jobsiteAnnouncementId) {
      __typename
      success
    }
  }
`;
export type DeleteJobsiteAnnouncementMutationFn = Apollo.MutationFunction<
  DeleteJobsiteAnnouncementMutation,
  DeleteJobsiteAnnouncementMutationVariables
>;

/**
 * __useDeleteJobsiteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteJobsiteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobsiteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobsiteAnnouncementMutation, { data, loading, error }] = useDeleteJobsiteAnnouncementMutation({
 *   variables: {
 *      jobsiteAnnouncementId: // value for 'jobsiteAnnouncementId'
 *   },
 * });
 */
export function useDeleteJobsiteAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteJobsiteAnnouncementMutation,
    DeleteJobsiteAnnouncementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteJobsiteAnnouncementMutation,
    DeleteJobsiteAnnouncementMutationVariables
  >(DeleteJobsiteAnnouncementDocument, options);
}
export type DeleteJobsiteAnnouncementMutationHookResult = ReturnType<
  typeof useDeleteJobsiteAnnouncementMutation
>;
export type DeleteJobsiteAnnouncementMutationResult =
  Apollo.MutationResult<DeleteJobsiteAnnouncementMutation>;
export type DeleteJobsiteAnnouncementMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteJobsiteAnnouncementMutation,
    DeleteJobsiteAnnouncementMutationVariables
  >;
export const GetJobsiteAnnouncementCandidateCountsDocument = gql`
  query GetJobsiteAnnouncementCandidateCounts(
    $input: JobsiteAnnouncementFilterSpecification!
  ) {
    getJobsiteAnnouncementCandidateRecipients(input: $input) {
      totalCount
      totalReachableCount
    }
  }
`;

/**
 * __useGetJobsiteAnnouncementCandidateCountsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteAnnouncementCandidateCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteAnnouncementCandidateCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteAnnouncementCandidateCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetJobsiteAnnouncementCandidateCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteAnnouncementCandidateCountsQuery,
    GetJobsiteAnnouncementCandidateCountsQueryVariables
  > &
    (
      | {
          variables: GetJobsiteAnnouncementCandidateCountsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteAnnouncementCandidateCountsQuery,
    GetJobsiteAnnouncementCandidateCountsQueryVariables
  >(GetJobsiteAnnouncementCandidateCountsDocument, options);
}
export function useGetJobsiteAnnouncementCandidateCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteAnnouncementCandidateCountsQuery,
    GetJobsiteAnnouncementCandidateCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteAnnouncementCandidateCountsQuery,
    GetJobsiteAnnouncementCandidateCountsQueryVariables
  >(GetJobsiteAnnouncementCandidateCountsDocument, options);
}
export function useGetJobsiteAnnouncementCandidateCountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteAnnouncementCandidateCountsQuery,
    GetJobsiteAnnouncementCandidateCountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteAnnouncementCandidateCountsQuery,
    GetJobsiteAnnouncementCandidateCountsQueryVariables
  >(GetJobsiteAnnouncementCandidateCountsDocument, options);
}
export type GetJobsiteAnnouncementCandidateCountsQueryHookResult = ReturnType<
  typeof useGetJobsiteAnnouncementCandidateCountsQuery
>;
export type GetJobsiteAnnouncementCandidateCountsLazyQueryHookResult =
  ReturnType<typeof useGetJobsiteAnnouncementCandidateCountsLazyQuery>;
export type GetJobsiteAnnouncementCandidateCountsSuspenseQueryHookResult =
  ReturnType<typeof useGetJobsiteAnnouncementCandidateCountsSuspenseQuery>;
export type GetJobsiteAnnouncementCandidateCountsQueryResult =
  Apollo.QueryResult<
    GetJobsiteAnnouncementCandidateCountsQuery,
    GetJobsiteAnnouncementCandidateCountsQueryVariables
  >;
export const GetJobsiteAnnouncementsDocument = gql`
  query GetJobsiteAnnouncements(
    $getJobsiteAnnouncementsInput: GetJobsiteAnnouncementsInput
  ) {
    getJobsiteAnnouncements(input: $getJobsiteAnnouncementsInput) {
      count
      edges {
        node {
          announcementType
          jobsiteAnnouncementId
          subject
          status
          message
          sentAt
          startAt
          endAt
          timeZone
          jobsites {
            count
            edges {
              node {
                jobsiteId
                name
              }
            }
          }
          jobsiteAccessStatus
          accessWithinDayRange
          trades
          titles
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteAnnouncementsQuery({
 *   variables: {
 *      getJobsiteAnnouncementsInput: // value for 'getJobsiteAnnouncementsInput'
 *   },
 * });
 */
export function useGetJobsiteAnnouncementsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobsiteAnnouncementsQuery,
    GetJobsiteAnnouncementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteAnnouncementsQuery,
    GetJobsiteAnnouncementsQueryVariables
  >(GetJobsiteAnnouncementsDocument, options);
}
export function useGetJobsiteAnnouncementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteAnnouncementsQuery,
    GetJobsiteAnnouncementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteAnnouncementsQuery,
    GetJobsiteAnnouncementsQueryVariables
  >(GetJobsiteAnnouncementsDocument, options);
}
export function useGetJobsiteAnnouncementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteAnnouncementsQuery,
    GetJobsiteAnnouncementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteAnnouncementsQuery,
    GetJobsiteAnnouncementsQueryVariables
  >(GetJobsiteAnnouncementsDocument, options);
}
export type GetJobsiteAnnouncementsQueryHookResult = ReturnType<
  typeof useGetJobsiteAnnouncementsQuery
>;
export type GetJobsiteAnnouncementsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteAnnouncementsLazyQuery
>;
export type GetJobsiteAnnouncementsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteAnnouncementsSuspenseQuery
>;
export type GetJobsiteAnnouncementsQueryResult = Apollo.QueryResult<
  GetJobsiteAnnouncementsQuery,
  GetJobsiteAnnouncementsQueryVariables
>;
export const GetJobsiteAnnouncementsContainerContractorsSessionDocument = gql`
  query GetJobsiteAnnouncementsContainerContractorsSession(
    $userContractorsInput: UserContractorsInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        contractors(input: $userContractorsInput) {
          count
          edges {
            node {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteAnnouncementsContainerContractorsSessionQuery__
 *
 * To run a query within a React component, call `useGetJobsiteAnnouncementsContainerContractorsSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteAnnouncementsContainerContractorsSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteAnnouncementsContainerContractorsSessionQuery({
 *   variables: {
 *      userContractorsInput: // value for 'userContractorsInput'
 *   },
 * });
 */
export function useGetJobsiteAnnouncementsContainerContractorsSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobsiteAnnouncementsContainerContractorsSessionQuery,
    GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteAnnouncementsContainerContractorsSessionQuery,
    GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables
  >(GetJobsiteAnnouncementsContainerContractorsSessionDocument, options);
}
export function useGetJobsiteAnnouncementsContainerContractorsSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteAnnouncementsContainerContractorsSessionQuery,
    GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteAnnouncementsContainerContractorsSessionQuery,
    GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables
  >(GetJobsiteAnnouncementsContainerContractorsSessionDocument, options);
}
export function useGetJobsiteAnnouncementsContainerContractorsSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteAnnouncementsContainerContractorsSessionQuery,
    GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteAnnouncementsContainerContractorsSessionQuery,
    GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables
  >(GetJobsiteAnnouncementsContainerContractorsSessionDocument, options);
}
export type GetJobsiteAnnouncementsContainerContractorsSessionQueryHookResult =
  ReturnType<typeof useGetJobsiteAnnouncementsContainerContractorsSessionQuery>;
export type GetJobsiteAnnouncementsContainerContractorsSessionLazyQueryHookResult =
  ReturnType<
    typeof useGetJobsiteAnnouncementsContainerContractorsSessionLazyQuery
  >;
export type GetJobsiteAnnouncementsContainerContractorsSessionSuspenseQueryHookResult =
  ReturnType<
    typeof useGetJobsiteAnnouncementsContainerContractorsSessionSuspenseQuery
  >;
export type GetJobsiteAnnouncementsContainerContractorsSessionQueryResult =
  Apollo.QueryResult<
    GetJobsiteAnnouncementsContainerContractorsSessionQuery,
    GetJobsiteAnnouncementsContainerContractorsSessionQueryVariables
  >;
export const ContractorAddJobsitesDocument = gql`
  mutation ContractorAddJobsites($input: ContractorAddJobsitesInput!) {
    contractorAddJobsites(input: $input) {
      jobsiteContractors {
        id
      }
    }
  }
`;
export type ContractorAddJobsitesMutationFn = Apollo.MutationFunction<
  ContractorAddJobsitesMutation,
  ContractorAddJobsitesMutationVariables
>;

/**
 * __useContractorAddJobsitesMutation__
 *
 * To run a mutation, you first call `useContractorAddJobsitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractorAddJobsitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractorAddJobsitesMutation, { data, loading, error }] = useContractorAddJobsitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractorAddJobsitesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContractorAddJobsitesMutation,
    ContractorAddJobsitesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContractorAddJobsitesMutation,
    ContractorAddJobsitesMutationVariables
  >(ContractorAddJobsitesDocument, options);
}
export type ContractorAddJobsitesMutationHookResult = ReturnType<
  typeof useContractorAddJobsitesMutation
>;
export type ContractorAddJobsitesMutationResult =
  Apollo.MutationResult<ContractorAddJobsitesMutation>;
export type ContractorAddJobsitesMutationOptions = Apollo.BaseMutationOptions<
  ContractorAddJobsitesMutation,
  ContractorAddJobsitesMutationVariables
>;
export const ContractorRemoveWorkerDocument = gql`
  mutation ContractorRemoveWorker($input: ContractorRemoveWorkerInput!) {
    contractorRemoveWorker(input: $input) {
      success {
        success
      }
    }
  }
`;
export type ContractorRemoveWorkerMutationFn = Apollo.MutationFunction<
  ContractorRemoveWorkerMutation,
  ContractorRemoveWorkerMutationVariables
>;

/**
 * __useContractorRemoveWorkerMutation__
 *
 * To run a mutation, you first call `useContractorRemoveWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractorRemoveWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractorRemoveWorkerMutation, { data, loading, error }] = useContractorRemoveWorkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractorRemoveWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContractorRemoveWorkerMutation,
    ContractorRemoveWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContractorRemoveWorkerMutation,
    ContractorRemoveWorkerMutationVariables
  >(ContractorRemoveWorkerDocument, options);
}
export type ContractorRemoveWorkerMutationHookResult = ReturnType<
  typeof useContractorRemoveWorkerMutation
>;
export type ContractorRemoveWorkerMutationResult =
  Apollo.MutationResult<ContractorRemoveWorkerMutation>;
export type ContractorRemoveWorkerMutationOptions = Apollo.BaseMutationOptions<
  ContractorRemoveWorkerMutation,
  ContractorRemoveWorkerMutationVariables
>;
export const CreateContractorStripeInvoiceDocument = gql`
  mutation CreateContractorStripeInvoice(
    $input: CreateContractorStripeInvoiceInput!
  ) {
    createContractorStripeInvoice(input: $input) {
      invoiceId
      customerId
      url
      status
    }
  }
`;
export type CreateContractorStripeInvoiceMutationFn = Apollo.MutationFunction<
  CreateContractorStripeInvoiceMutation,
  CreateContractorStripeInvoiceMutationVariables
>;

/**
 * __useCreateContractorStripeInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateContractorStripeInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractorStripeInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractorStripeInvoiceMutation, { data, loading, error }] = useCreateContractorStripeInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractorStripeInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContractorStripeInvoiceMutation,
    CreateContractorStripeInvoiceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContractorStripeInvoiceMutation,
    CreateContractorStripeInvoiceMutationVariables
  >(CreateContractorStripeInvoiceDocument, options);
}
export type CreateContractorStripeInvoiceMutationHookResult = ReturnType<
  typeof useCreateContractorStripeInvoiceMutation
>;
export type CreateContractorStripeInvoiceMutationResult =
  Apollo.MutationResult<CreateContractorStripeInvoiceMutation>;
export type CreateContractorStripeInvoiceMutationOptions =
  Apollo.BaseMutationOptions<
    CreateContractorStripeInvoiceMutation,
    CreateContractorStripeInvoiceMutationVariables
  >;
export const InitiateStripePaymentSetupSessionDocument = gql`
  mutation initiateStripePaymentSetupSession(
    $input: InitiateStripePaymentSetupSessionInput!
  ) {
    initiateStripePaymentSetupSession(input: $input) {
      clientSecret
      customerId
      publicKey
      sessionId
    }
  }
`;
export type InitiateStripePaymentSetupSessionMutationFn =
  Apollo.MutationFunction<
    InitiateStripePaymentSetupSessionMutation,
    InitiateStripePaymentSetupSessionMutationVariables
  >;

/**
 * __useInitiateStripePaymentSetupSessionMutation__
 *
 * To run a mutation, you first call `useInitiateStripePaymentSetupSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateStripePaymentSetupSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateStripePaymentSetupSessionMutation, { data, loading, error }] = useInitiateStripePaymentSetupSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateStripePaymentSetupSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitiateStripePaymentSetupSessionMutation,
    InitiateStripePaymentSetupSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitiateStripePaymentSetupSessionMutation,
    InitiateStripePaymentSetupSessionMutationVariables
  >(InitiateStripePaymentSetupSessionDocument, options);
}
export type InitiateStripePaymentSetupSessionMutationHookResult = ReturnType<
  typeof useInitiateStripePaymentSetupSessionMutation
>;
export type InitiateStripePaymentSetupSessionMutationResult =
  Apollo.MutationResult<InitiateStripePaymentSetupSessionMutation>;
export type InitiateStripePaymentSetupSessionMutationOptions =
  Apollo.BaseMutationOptions<
    InitiateStripePaymentSetupSessionMutation,
    InitiateStripePaymentSetupSessionMutationVariables
  >;
export const JobsiteContractorUpdateStripePaymentMethodDocument = gql`
  mutation JobsiteContractorUpdateStripePaymentMethod(
    $input: JobsiteContractorUpdateStripePaymentMethodInput!
  ) {
    jobsiteContractorUpdateStripePaymentMethod(input: $input) {
      success {
        success
      }
    }
  }
`;
export type JobsiteContractorUpdateStripePaymentMethodMutationFn =
  Apollo.MutationFunction<
    JobsiteContractorUpdateStripePaymentMethodMutation,
    JobsiteContractorUpdateStripePaymentMethodMutationVariables
  >;

/**
 * __useJobsiteContractorUpdateStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useJobsiteContractorUpdateStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteContractorUpdateStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteContractorUpdateStripePaymentMethodMutation, { data, loading, error }] = useJobsiteContractorUpdateStripePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteContractorUpdateStripePaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteContractorUpdateStripePaymentMethodMutation,
    JobsiteContractorUpdateStripePaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteContractorUpdateStripePaymentMethodMutation,
    JobsiteContractorUpdateStripePaymentMethodMutationVariables
  >(JobsiteContractorUpdateStripePaymentMethodDocument, options);
}
export type JobsiteContractorUpdateStripePaymentMethodMutationHookResult =
  ReturnType<typeof useJobsiteContractorUpdateStripePaymentMethodMutation>;
export type JobsiteContractorUpdateStripePaymentMethodMutationResult =
  Apollo.MutationResult<JobsiteContractorUpdateStripePaymentMethodMutation>;
export type JobsiteContractorUpdateStripePaymentMethodMutationOptions =
  Apollo.BaseMutationOptions<
    JobsiteContractorUpdateStripePaymentMethodMutation,
    JobsiteContractorUpdateStripePaymentMethodMutationVariables
  >;
export const RemoveStripePaymentMethodDocument = gql`
  mutation RemoveStripePaymentMethod(
    $input: ManageContractorStripePaymentMethodInput!
  ) {
    removeStripePaymentMethod(input: $input) {
      id
      brand
      last4
      expMonth
      expYear
      isDefault
    }
  }
`;
export type RemoveStripePaymentMethodMutationFn = Apollo.MutationFunction<
  RemoveStripePaymentMethodMutation,
  RemoveStripePaymentMethodMutationVariables
>;

/**
 * __useRemoveStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemoveStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStripePaymentMethodMutation, { data, loading, error }] = useRemoveStripePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveStripePaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveStripePaymentMethodMutation,
    RemoveStripePaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveStripePaymentMethodMutation,
    RemoveStripePaymentMethodMutationVariables
  >(RemoveStripePaymentMethodDocument, options);
}
export type RemoveStripePaymentMethodMutationHookResult = ReturnType<
  typeof useRemoveStripePaymentMethodMutation
>;
export type RemoveStripePaymentMethodMutationResult =
  Apollo.MutationResult<RemoveStripePaymentMethodMutation>;
export type RemoveStripePaymentMethodMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveStripePaymentMethodMutation,
    RemoveStripePaymentMethodMutationVariables
  >;
export const SetDefaultStripePaymentMethodDocument = gql`
  mutation SetDefaultStripePaymentMethod(
    $input: ManageContractorStripePaymentMethodInput!
  ) {
    setDefaultStripePaymentMethod(input: $input) {
      id
      brand
      last4
      expMonth
      expYear
      isDefault
    }
  }
`;
export type SetDefaultStripePaymentMethodMutationFn = Apollo.MutationFunction<
  SetDefaultStripePaymentMethodMutation,
  SetDefaultStripePaymentMethodMutationVariables
>;

/**
 * __useSetDefaultStripePaymentMethodMutation__
 *
 * To run a mutation, you first call `useSetDefaultStripePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultStripePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultStripePaymentMethodMutation, { data, loading, error }] = useSetDefaultStripePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultStripePaymentMethodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDefaultStripePaymentMethodMutation,
    SetDefaultStripePaymentMethodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDefaultStripePaymentMethodMutation,
    SetDefaultStripePaymentMethodMutationVariables
  >(SetDefaultStripePaymentMethodDocument, options);
}
export type SetDefaultStripePaymentMethodMutationHookResult = ReturnType<
  typeof useSetDefaultStripePaymentMethodMutation
>;
export type SetDefaultStripePaymentMethodMutationResult =
  Apollo.MutationResult<SetDefaultStripePaymentMethodMutation>;
export type SetDefaultStripePaymentMethodMutationOptions =
  Apollo.BaseMutationOptions<
    SetDefaultStripePaymentMethodMutation,
    SetDefaultStripePaymentMethodMutationVariables
  >;
export const GetContractorStripePaymentMethodsDetailsDocument = gql`
  query getContractorStripePaymentMethodsDetails(
    $contractorId: ID!
    $includeArchived: Boolean!
  ) {
    getContractor(
      contractorId: $contractorId
      includeArchived: $includeArchived
    ) {
      contractorId
      isArchived
      websiteUrl
      description
      stripeMappingDetails {
        customerId
        publicKey
        clientSecret
      }
      organization {
        organizationId
        name
        legalName
        email
        addressLine1
        addressLine2
        addressCity
        addressCity
        addressState
        addressZipCode
      }
      billingContact {
        firstName
        lastName
        email
        phoneNumber
      }
      objectHistory {
        createdAt
        createdBy {
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorStripePaymentMethodsDetailsQuery__
 *
 * To run a query within a React component, call `useGetContractorStripePaymentMethodsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorStripePaymentMethodsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorStripePaymentMethodsDetailsQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetContractorStripePaymentMethodsDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorStripePaymentMethodsDetailsQuery,
    GetContractorStripePaymentMethodsDetailsQueryVariables
  > &
    (
      | {
          variables: GetContractorStripePaymentMethodsDetailsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorStripePaymentMethodsDetailsQuery,
    GetContractorStripePaymentMethodsDetailsQueryVariables
  >(GetContractorStripePaymentMethodsDetailsDocument, options);
}
export function useGetContractorStripePaymentMethodsDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorStripePaymentMethodsDetailsQuery,
    GetContractorStripePaymentMethodsDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorStripePaymentMethodsDetailsQuery,
    GetContractorStripePaymentMethodsDetailsQueryVariables
  >(GetContractorStripePaymentMethodsDetailsDocument, options);
}
export function useGetContractorStripePaymentMethodsDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorStripePaymentMethodsDetailsQuery,
    GetContractorStripePaymentMethodsDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorStripePaymentMethodsDetailsQuery,
    GetContractorStripePaymentMethodsDetailsQueryVariables
  >(GetContractorStripePaymentMethodsDetailsDocument, options);
}
export type GetContractorStripePaymentMethodsDetailsQueryHookResult =
  ReturnType<typeof useGetContractorStripePaymentMethodsDetailsQuery>;
export type GetContractorStripePaymentMethodsDetailsLazyQueryHookResult =
  ReturnType<typeof useGetContractorStripePaymentMethodsDetailsLazyQuery>;
export type GetContractorStripePaymentMethodsDetailsSuspenseQueryHookResult =
  ReturnType<typeof useGetContractorStripePaymentMethodsDetailsSuspenseQuery>;
export type GetContractorStripePaymentMethodsDetailsQueryResult =
  Apollo.QueryResult<
    GetContractorStripePaymentMethodsDetailsQuery,
    GetContractorStripePaymentMethodsDetailsQueryVariables
  >;
export const GetJobsitesAndContractorsDocument = gql`
  query GetJobsitesAndContractors($userJobsitesInput: UserJobsitesInput!) {
    getCurrentSession {
      user {
        userAccountId
        jobsites(input: $userJobsitesInput) {
          count
          edges {
            node {
              jobsiteId
              jobsiteContractors {
                count
                edges {
                  node {
                    id
                    startDate
                    contractor {
                      contractorId
                      isDefaultContractor
                      organization {
                        name
                        slug
                        legalName
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsitesAndContractorsQuery__
 *
 * To run a query within a React component, call `useGetJobsitesAndContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsitesAndContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsitesAndContractorsQuery({
 *   variables: {
 *      userJobsitesInput: // value for 'userJobsitesInput'
 *   },
 * });
 */
export function useGetJobsitesAndContractorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsitesAndContractorsQuery,
    GetJobsitesAndContractorsQueryVariables
  > &
    (
      | { variables: GetJobsitesAndContractorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsitesAndContractorsQuery,
    GetJobsitesAndContractorsQueryVariables
  >(GetJobsitesAndContractorsDocument, options);
}
export function useGetJobsitesAndContractorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsitesAndContractorsQuery,
    GetJobsitesAndContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsitesAndContractorsQuery,
    GetJobsitesAndContractorsQueryVariables
  >(GetJobsitesAndContractorsDocument, options);
}
export function useGetJobsitesAndContractorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsitesAndContractorsQuery,
    GetJobsitesAndContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsitesAndContractorsQuery,
    GetJobsitesAndContractorsQueryVariables
  >(GetJobsitesAndContractorsDocument, options);
}
export type GetJobsitesAndContractorsQueryHookResult = ReturnType<
  typeof useGetJobsitesAndContractorsQuery
>;
export type GetJobsitesAndContractorsLazyQueryHookResult = ReturnType<
  typeof useGetJobsitesAndContractorsLazyQuery
>;
export type GetJobsitesAndContractorsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsitesAndContractorsSuspenseQuery
>;
export type GetJobsitesAndContractorsQueryResult = Apollo.QueryResult<
  GetJobsitesAndContractorsQuery,
  GetJobsitesAndContractorsQueryVariables
>;
export const GetContractorContainerContractorInfoDocument = gql`
  query GetContractorContainerContractorInfo(
    $contractorId: ID!
    $includeArchived: Boolean!
  ) {
    getContractor(
      contractorId: $contractorId
      includeArchived: $includeArchived
    ) {
      contractorId
      isArchived
      websiteUrl
      description
      organization {
        organizationId
        slug
        name
        legalName
        email
        addressLine1
        addressLine2
        addressCity
        addressCity
        addressState
        addressZipCode
      }
      billingContact {
        firstName
        lastName
        email
        phoneNumber
      }
      objectHistory {
        createdAt
        createdBy {
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorContainerContractorInfoQuery__
 *
 * To run a query within a React component, call `useGetContractorContainerContractorInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorContainerContractorInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorContainerContractorInfoQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetContractorContainerContractorInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorContainerContractorInfoQuery,
    GetContractorContainerContractorInfoQueryVariables
  > &
    (
      | {
          variables: GetContractorContainerContractorInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorContainerContractorInfoQuery,
    GetContractorContainerContractorInfoQueryVariables
  >(GetContractorContainerContractorInfoDocument, options);
}
export function useGetContractorContainerContractorInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorContainerContractorInfoQuery,
    GetContractorContainerContractorInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorContainerContractorInfoQuery,
    GetContractorContainerContractorInfoQueryVariables
  >(GetContractorContainerContractorInfoDocument, options);
}
export function useGetContractorContainerContractorInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorContainerContractorInfoQuery,
    GetContractorContainerContractorInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorContainerContractorInfoQuery,
    GetContractorContainerContractorInfoQueryVariables
  >(GetContractorContainerContractorInfoDocument, options);
}
export type GetContractorContainerContractorInfoQueryHookResult = ReturnType<
  typeof useGetContractorContainerContractorInfoQuery
>;
export type GetContractorContainerContractorInfoLazyQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorInfoLazyQuery>;
export type GetContractorContainerContractorInfoSuspenseQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorInfoSuspenseQuery>;
export type GetContractorContainerContractorInfoQueryResult =
  Apollo.QueryResult<
    GetContractorContainerContractorInfoQuery,
    GetContractorContainerContractorInfoQueryVariables
  >;
export const GetContractorContainerContractorJobsitesDocument = gql`
  query GetContractorContainerContractorJobsites(
    $contractorId: ID!
    $includeArchived: Boolean!
    $contractorJobsiteContractorsInput: ContractorJobsiteContractorsInput
  ) {
    getContractor(
      contractorId: $contractorId
      includeArchived: $includeArchived
    ) {
      contractorId
      isArchived
      organization {
        organizationId
        name
      }
      jobsiteContractors(input: $contractorJobsiteContractorsInput) {
        count
        edges {
          node {
            id
            stripePaymentMethodId
            jobsite {
              name
              jobsiteId
              addressCity
              addressState
            }
            parentJobsiteContractor {
              contractor {
                contractorId
                organization {
                  name
                }
              }
            }
            startDate
            endDate
            contact {
              firstName
              lastName
              phoneNumber
              email
              title
            }
            jobsiteWorkers {
              count
              edges {
                node {
                  jobsiteWorkerId
                }
              }
            }
            subcontractedJobsiteContractors {
              count
            }
            jobsiteInvitation {
              jobsiteInvitationId
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorContainerContractorJobsitesQuery__
 *
 * To run a query within a React component, call `useGetContractorContainerContractorJobsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorContainerContractorJobsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorContainerContractorJobsitesQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      includeArchived: // value for 'includeArchived'
 *      contractorJobsiteContractorsInput: // value for 'contractorJobsiteContractorsInput'
 *   },
 * });
 */
export function useGetContractorContainerContractorJobsitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorContainerContractorJobsitesQuery,
    GetContractorContainerContractorJobsitesQueryVariables
  > &
    (
      | {
          variables: GetContractorContainerContractorJobsitesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorContainerContractorJobsitesQuery,
    GetContractorContainerContractorJobsitesQueryVariables
  >(GetContractorContainerContractorJobsitesDocument, options);
}
export function useGetContractorContainerContractorJobsitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorContainerContractorJobsitesQuery,
    GetContractorContainerContractorJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorContainerContractorJobsitesQuery,
    GetContractorContainerContractorJobsitesQueryVariables
  >(GetContractorContainerContractorJobsitesDocument, options);
}
export function useGetContractorContainerContractorJobsitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorContainerContractorJobsitesQuery,
    GetContractorContainerContractorJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorContainerContractorJobsitesQuery,
    GetContractorContainerContractorJobsitesQueryVariables
  >(GetContractorContainerContractorJobsitesDocument, options);
}
export type GetContractorContainerContractorJobsitesQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorJobsitesQuery>;
export type GetContractorContainerContractorJobsitesLazyQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorJobsitesLazyQuery>;
export type GetContractorContainerContractorJobsitesSuspenseQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorJobsitesSuspenseQuery>;
export type GetContractorContainerContractorJobsitesQueryResult =
  Apollo.QueryResult<
    GetContractorContainerContractorJobsitesQuery,
    GetContractorContainerContractorJobsitesQueryVariables
  >;
export const GetContractorContainerContractorSubcontractorsDocument = gql`
  query GetContractorContainerContractorSubcontractors(
    $contractorId: ID!
    $includeArchived: Boolean!
    $contractorContractorWorkersInput: ContractorContractorWorkersInput
  ) {
    getContractor(
      contractorId: $contractorId
      includeArchived: $includeArchived
    ) {
      contractorId
      isArchived
      organization {
        name
        addressCity
        addressState
      }
      jobsiteContractors {
        count
        edges {
          node {
            jobsite {
              jobsiteId
              name
            }
            subcontractedJobsiteContractors {
              count
              edges {
                node {
                  contractor {
                    contractorId
                    organization {
                      name
                    }
                  }
                  jobsite {
                    jobsiteId
                    name
                  }
                  jobsiteWorkers {
                    count
                  }
                  endDate
                }
              }
            }
          }
        }
      }
      contractorWorkers(input: $contractorContractorWorkersInput) {
        count
      }
      contractorMembers {
        count
      }
    }
  }
`;

/**
 * __useGetContractorContainerContractorSubcontractorsQuery__
 *
 * To run a query within a React component, call `useGetContractorContainerContractorSubcontractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorContainerContractorSubcontractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorContainerContractorSubcontractorsQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      includeArchived: // value for 'includeArchived'
 *      contractorContractorWorkersInput: // value for 'contractorContractorWorkersInput'
 *   },
 * });
 */
export function useGetContractorContainerContractorSubcontractorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorContainerContractorSubcontractorsQuery,
    GetContractorContainerContractorSubcontractorsQueryVariables
  > &
    (
      | {
          variables: GetContractorContainerContractorSubcontractorsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorContainerContractorSubcontractorsQuery,
    GetContractorContainerContractorSubcontractorsQueryVariables
  >(GetContractorContainerContractorSubcontractorsDocument, options);
}
export function useGetContractorContainerContractorSubcontractorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorContainerContractorSubcontractorsQuery,
    GetContractorContainerContractorSubcontractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorContainerContractorSubcontractorsQuery,
    GetContractorContainerContractorSubcontractorsQueryVariables
  >(GetContractorContainerContractorSubcontractorsDocument, options);
}
export function useGetContractorContainerContractorSubcontractorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorContainerContractorSubcontractorsQuery,
    GetContractorContainerContractorSubcontractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorContainerContractorSubcontractorsQuery,
    GetContractorContainerContractorSubcontractorsQueryVariables
  >(GetContractorContainerContractorSubcontractorsDocument, options);
}
export type GetContractorContainerContractorSubcontractorsQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorSubcontractorsQuery>;
export type GetContractorContainerContractorSubcontractorsLazyQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorSubcontractorsLazyQuery>;
export type GetContractorContainerContractorSubcontractorsSuspenseQueryHookResult =
  ReturnType<
    typeof useGetContractorContainerContractorSubcontractorsSuspenseQuery
  >;
export type GetContractorContainerContractorSubcontractorsQueryResult =
  Apollo.QueryResult<
    GetContractorContainerContractorSubcontractorsQuery,
    GetContractorContainerContractorSubcontractorsQueryVariables
  >;
export const GetContractorContainerContractorUsersDocument = gql`
  query GetContractorContainerContractorUsers(
    $contractorId: ID!
    $includeArchived: Boolean!
    $contractorContractorMemberInput: ContractorContractorMembersInput
    $userRolesInput: UserRolesInput
  ) {
    getContractor(
      contractorId: $contractorId
      includeArchived: $includeArchived
    ) {
      contractorId
      isArchived
      organization {
        organizationId
        name
      }
      contractorMembers(input: $contractorContractorMemberInput) {
        count
        edges {
          node {
            id
            user {
              userAccountId
              roles(input: $userRolesInput) {
                key
                displayName
                object {
                  objectId
                  objectDetails {
                    name
                  }
                }
              }
              identity {
                firstName
                lastName
                email
                phoneNumber
              }
              worker {
                workerId
                profilePictureCropped {
                  downloadUrl
                }
              }
              lastSession {
                createdAt
                appVersion
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorContainerContractorUsersQuery__
 *
 * To run a query within a React component, call `useGetContractorContainerContractorUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorContainerContractorUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorContainerContractorUsersQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      includeArchived: // value for 'includeArchived'
 *      contractorContractorMemberInput: // value for 'contractorContractorMemberInput'
 *      userRolesInput: // value for 'userRolesInput'
 *   },
 * });
 */
export function useGetContractorContainerContractorUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorContainerContractorUsersQuery,
    GetContractorContainerContractorUsersQueryVariables
  > &
    (
      | {
          variables: GetContractorContainerContractorUsersQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorContainerContractorUsersQuery,
    GetContractorContainerContractorUsersQueryVariables
  >(GetContractorContainerContractorUsersDocument, options);
}
export function useGetContractorContainerContractorUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorContainerContractorUsersQuery,
    GetContractorContainerContractorUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorContainerContractorUsersQuery,
    GetContractorContainerContractorUsersQueryVariables
  >(GetContractorContainerContractorUsersDocument, options);
}
export function useGetContractorContainerContractorUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorContainerContractorUsersQuery,
    GetContractorContainerContractorUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorContainerContractorUsersQuery,
    GetContractorContainerContractorUsersQueryVariables
  >(GetContractorContainerContractorUsersDocument, options);
}
export type GetContractorContainerContractorUsersQueryHookResult = ReturnType<
  typeof useGetContractorContainerContractorUsersQuery
>;
export type GetContractorContainerContractorUsersLazyQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorUsersLazyQuery>;
export type GetContractorContainerContractorUsersSuspenseQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorUsersSuspenseQuery>;
export type GetContractorContainerContractorUsersQueryResult =
  Apollo.QueryResult<
    GetContractorContainerContractorUsersQuery,
    GetContractorContainerContractorUsersQueryVariables
  >;
export const GetContractorContainerContractorWorkersDocument = gql`
  query GetContractorContainerContractorWorkers(
    $contractorId: ID!
    $includeArchived: Boolean!
    $contractorContractorWorkersInput: ContractorContractorWorkersInput
  ) {
    getContractor(
      contractorId: $contractorId
      includeArchived: $includeArchived
    ) {
      contractorId
      isArchived
      organization {
        organizationId
        name
      }
      jobsiteContractors {
        edges {
          node {
            jobsite {
              jobsiteId
              name
            }
          }
        }
      }
      contractorWorkers(input: $contractorContractorWorkersInput) {
        count
        edges {
          node {
            id
            worker {
              workerId
              birthDate
              quickCode
              user {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
              profilePicture {
                downloadUrl
                uploadedAt
                fileId
              }
              profilePictureCropped {
                downloadUrl
                uploadedAt
                fileId
                fileType
              }
              workerCards {
                edges {
                  node {
                    workerCardId
                    cardNumber
                    cardStatus
                  }
                }
              }
            }
            jobsiteWorkers {
              count
              edges {
                node {
                  jobsiteWorkerId
                  trade
                  jobsiteContractor {
                    jobsite {
                      jobsiteId
                      name
                    }
                    contractor {
                      contractorId
                      organization {
                        name
                      }
                    }
                  }
                  currentAccess {
                    isAllowed
                    notAllowedReason
                    startDate
                    endDate
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorContainerContractorWorkersQuery__
 *
 * To run a query within a React component, call `useGetContractorContainerContractorWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorContainerContractorWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorContainerContractorWorkersQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      includeArchived: // value for 'includeArchived'
 *      contractorContractorWorkersInput: // value for 'contractorContractorWorkersInput'
 *   },
 * });
 */
export function useGetContractorContainerContractorWorkersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorContainerContractorWorkersQuery,
    GetContractorContainerContractorWorkersQueryVariables
  > &
    (
      | {
          variables: GetContractorContainerContractorWorkersQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorContainerContractorWorkersQuery,
    GetContractorContainerContractorWorkersQueryVariables
  >(GetContractorContainerContractorWorkersDocument, options);
}
export function useGetContractorContainerContractorWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorContainerContractorWorkersQuery,
    GetContractorContainerContractorWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorContainerContractorWorkersQuery,
    GetContractorContainerContractorWorkersQueryVariables
  >(GetContractorContainerContractorWorkersDocument, options);
}
export function useGetContractorContainerContractorWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorContainerContractorWorkersQuery,
    GetContractorContainerContractorWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorContainerContractorWorkersQuery,
    GetContractorContainerContractorWorkersQueryVariables
  >(GetContractorContainerContractorWorkersDocument, options);
}
export type GetContractorContainerContractorWorkersQueryHookResult = ReturnType<
  typeof useGetContractorContainerContractorWorkersQuery
>;
export type GetContractorContainerContractorWorkersLazyQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorWorkersLazyQuery>;
export type GetContractorContainerContractorWorkersSuspenseQueryHookResult =
  ReturnType<typeof useGetContractorContainerContractorWorkersSuspenseQuery>;
export type GetContractorContainerContractorWorkersQueryResult =
  Apollo.QueryResult<
    GetContractorContainerContractorWorkersQuery,
    GetContractorContainerContractorWorkersQueryVariables
  >;
export const GetContractorContainerPaymentMethodsDocument = gql`
  query GetContractorContainerPaymentMethods(
    $contractorId: ID!
    $includeArchived: Boolean!
  ) {
    getContractor(
      contractorId: $contractorId
      includeArchived: $includeArchived
    ) {
      contractorId
      isArchived
      websiteUrl
      description
      stripeMappingDetails {
        customerId
        publicKey
      }
      stripePaymentMethods {
        id
        brand
        last4
        expMonth
        expYear
        isDefault
      }
      organization {
        organizationId
        name
        legalName
        email
        addressLine1
        addressLine2
        addressCity
        addressCity
        addressState
        addressZipCode
      }
      billingContact {
        firstName
        lastName
        email
        phoneNumber
      }
      objectHistory {
        createdAt
        createdBy {
          identity {
            firstName
            lastName
          }
        }
      }
      jobsiteContractors {
        count
        edges {
          node {
            id
            stripePaymentMethodId
            jobsite {
              name
              jobsiteId
              addressCity
              addressState
              startDate
              endDate
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorContainerPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetContractorContainerPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorContainerPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorContainerPaymentMethodsQuery({
 *   variables: {
 *      contractorId: // value for 'contractorId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetContractorContainerPaymentMethodsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorContainerPaymentMethodsQuery,
    GetContractorContainerPaymentMethodsQueryVariables
  > &
    (
      | {
          variables: GetContractorContainerPaymentMethodsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorContainerPaymentMethodsQuery,
    GetContractorContainerPaymentMethodsQueryVariables
  >(GetContractorContainerPaymentMethodsDocument, options);
}
export function useGetContractorContainerPaymentMethodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorContainerPaymentMethodsQuery,
    GetContractorContainerPaymentMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorContainerPaymentMethodsQuery,
    GetContractorContainerPaymentMethodsQueryVariables
  >(GetContractorContainerPaymentMethodsDocument, options);
}
export function useGetContractorContainerPaymentMethodsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorContainerPaymentMethodsQuery,
    GetContractorContainerPaymentMethodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorContainerPaymentMethodsQuery,
    GetContractorContainerPaymentMethodsQueryVariables
  >(GetContractorContainerPaymentMethodsDocument, options);
}
export type GetContractorContainerPaymentMethodsQueryHookResult = ReturnType<
  typeof useGetContractorContainerPaymentMethodsQuery
>;
export type GetContractorContainerPaymentMethodsLazyQueryHookResult =
  ReturnType<typeof useGetContractorContainerPaymentMethodsLazyQuery>;
export type GetContractorContainerPaymentMethodsSuspenseQueryHookResult =
  ReturnType<typeof useGetContractorContainerPaymentMethodsSuspenseQuery>;
export type GetContractorContainerPaymentMethodsQueryResult =
  Apollo.QueryResult<
    GetContractorContainerPaymentMethodsQuery,
    GetContractorContainerPaymentMethodsQueryVariables
  >;
export const GetJobsiteContractorsDocument = gql`
  query GetJobsiteContractors($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      jobsiteContractors {
        count
        edges {
          node {
            id
            startDate
            stripePaymentMethodId
            contractor {
              contractorId
              isDefaultContractor
              organization {
                organizationId
                name
                slug
                legalName
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteContractorsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContractorsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteContractorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContractorsQuery,
    GetJobsiteContractorsQueryVariables
  > &
    (
      | { variables: GetJobsiteContractorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContractorsQuery,
    GetJobsiteContractorsQueryVariables
  >(GetJobsiteContractorsDocument, options);
}
export function useGetJobsiteContractorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContractorsQuery,
    GetJobsiteContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContractorsQuery,
    GetJobsiteContractorsQueryVariables
  >(GetJobsiteContractorsDocument, options);
}
export function useGetJobsiteContractorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContractorsQuery,
    GetJobsiteContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContractorsQuery,
    GetJobsiteContractorsQueryVariables
  >(GetJobsiteContractorsDocument, options);
}
export type GetJobsiteContractorsQueryHookResult = ReturnType<
  typeof useGetJobsiteContractorsQuery
>;
export type GetJobsiteContractorsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContractorsLazyQuery
>;
export type GetJobsiteContractorsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContractorsSuspenseQuery
>;
export type GetJobsiteContractorsQueryResult = Apollo.QueryResult<
  GetJobsiteContractorsQuery,
  GetJobsiteContractorsQueryVariables
>;
export const ContractorCreateDocument = gql`
  mutation ContractorCreate($input: ContractorCreateInput!) {
    contractorCreate(input: $input) {
      contractor {
        contractorId
      }
    }
  }
`;
export type ContractorCreateMutationFn = Apollo.MutationFunction<
  ContractorCreateMutation,
  ContractorCreateMutationVariables
>;

/**
 * __useContractorCreateMutation__
 *
 * To run a mutation, you first call `useContractorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractorCreateMutation, { data, loading, error }] = useContractorCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractorCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContractorCreateMutation,
    ContractorCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContractorCreateMutation,
    ContractorCreateMutationVariables
  >(ContractorCreateDocument, options);
}
export type ContractorCreateMutationHookResult = ReturnType<
  typeof useContractorCreateMutation
>;
export type ContractorCreateMutationResult =
  Apollo.MutationResult<ContractorCreateMutation>;
export type ContractorCreateMutationOptions = Apollo.BaseMutationOptions<
  ContractorCreateMutation,
  ContractorCreateMutationVariables
>;
export const ContractorUpdateDocument = gql`
  mutation ContractorUpdate($input: ContractorUpdateInput!) {
    contractorUpdate(input: $input) {
      contractor {
        contractorId
      }
    }
  }
`;
export type ContractorUpdateMutationFn = Apollo.MutationFunction<
  ContractorUpdateMutation,
  ContractorUpdateMutationVariables
>;

/**
 * __useContractorUpdateMutation__
 *
 * To run a mutation, you first call `useContractorUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractorUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractorUpdateMutation, { data, loading, error }] = useContractorUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractorUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContractorUpdateMutation,
    ContractorUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ContractorUpdateMutation,
    ContractorUpdateMutationVariables
  >(ContractorUpdateDocument, options);
}
export type ContractorUpdateMutationHookResult = ReturnType<
  typeof useContractorUpdateMutation
>;
export type ContractorUpdateMutationResult =
  Apollo.MutationResult<ContractorUpdateMutation>;
export type ContractorUpdateMutationOptions = Apollo.BaseMutationOptions<
  ContractorUpdateMutation,
  ContractorUpdateMutationVariables
>;
export const GetContractorsContainerCurrentSessionDocument = gql`
  query GetContractorsContainerCurrentSession(
    $userContractorsInput: UserContractorsInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        contractors(input: $userContractorsInput) {
          count
          edges {
            node {
              contractorId
              organization {
                name
                addressCity
                addressState
              }
              jobsiteContractors {
                edges {
                  node {
                    jobsite {
                      name
                      jobsiteId
                    }
                    jobsiteWorkers {
                      count
                    }
                    startDate
                    endDate
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorsContainerCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetContractorsContainerCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorsContainerCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorsContainerCurrentSessionQuery({
 *   variables: {
 *      userContractorsInput: // value for 'userContractorsInput'
 *   },
 * });
 */
export function useGetContractorsContainerCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContractorsContainerCurrentSessionQuery,
    GetContractorsContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorsContainerCurrentSessionQuery,
    GetContractorsContainerCurrentSessionQueryVariables
  >(GetContractorsContainerCurrentSessionDocument, options);
}
export function useGetContractorsContainerCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorsContainerCurrentSessionQuery,
    GetContractorsContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorsContainerCurrentSessionQuery,
    GetContractorsContainerCurrentSessionQueryVariables
  >(GetContractorsContainerCurrentSessionDocument, options);
}
export function useGetContractorsContainerCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorsContainerCurrentSessionQuery,
    GetContractorsContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorsContainerCurrentSessionQuery,
    GetContractorsContainerCurrentSessionQueryVariables
  >(GetContractorsContainerCurrentSessionDocument, options);
}
export type GetContractorsContainerCurrentSessionQueryHookResult = ReturnType<
  typeof useGetContractorsContainerCurrentSessionQuery
>;
export type GetContractorsContainerCurrentSessionLazyQueryHookResult =
  ReturnType<typeof useGetContractorsContainerCurrentSessionLazyQuery>;
export type GetContractorsContainerCurrentSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetContractorsContainerCurrentSessionSuspenseQuery>;
export type GetContractorsContainerCurrentSessionQueryResult =
  Apollo.QueryResult<
    GetContractorsContainerCurrentSessionQuery,
    GetContractorsContainerCurrentSessionQueryVariables
  >;
export const GetDashboardJobsitesWithStatsCurrentSessionDocument = gql`
  query GetDashboardJobsitesWithStatsCurrentSession(
    $userJobsitesInput: UserJobsitesInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        jobsites(input: $userJobsitesInput) {
          count
          edges {
            node {
              developer {
                name
              }
              profilePicture {
                downloadUrl
              }
              jobsiteId
              name
              addressLine1
              addressLine2
              addressCity
              addressState
              addressZipCode
              latitude
              longitude
              jobsiteStats {
                numberOfActiveWorkers
                numberOfOrientationWorkersInProgress
                numberOfOnSiteWorkers
              }
              startDate
              endDate
            }
          }
          filtersOptions {
            developers {
              value
              label
              count
            }
            cities {
              value
              label
              count
            }
            states {
              value
              label
              count
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetDashboardJobsitesWithStatsCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetDashboardJobsitesWithStatsCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardJobsitesWithStatsCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardJobsitesWithStatsCurrentSessionQuery({
 *   variables: {
 *      userJobsitesInput: // value for 'userJobsitesInput'
 *   },
 * });
 */
export function useGetDashboardJobsitesWithStatsCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDashboardJobsitesWithStatsCurrentSessionQuery,
    GetDashboardJobsitesWithStatsCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDashboardJobsitesWithStatsCurrentSessionQuery,
    GetDashboardJobsitesWithStatsCurrentSessionQueryVariables
  >(GetDashboardJobsitesWithStatsCurrentSessionDocument, options);
}
export function useGetDashboardJobsitesWithStatsCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDashboardJobsitesWithStatsCurrentSessionQuery,
    GetDashboardJobsitesWithStatsCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDashboardJobsitesWithStatsCurrentSessionQuery,
    GetDashboardJobsitesWithStatsCurrentSessionQueryVariables
  >(GetDashboardJobsitesWithStatsCurrentSessionDocument, options);
}
export function useGetDashboardJobsitesWithStatsCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDashboardJobsitesWithStatsCurrentSessionQuery,
    GetDashboardJobsitesWithStatsCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDashboardJobsitesWithStatsCurrentSessionQuery,
    GetDashboardJobsitesWithStatsCurrentSessionQueryVariables
  >(GetDashboardJobsitesWithStatsCurrentSessionDocument, options);
}
export type GetDashboardJobsitesWithStatsCurrentSessionQueryHookResult =
  ReturnType<typeof useGetDashboardJobsitesWithStatsCurrentSessionQuery>;
export type GetDashboardJobsitesWithStatsCurrentSessionLazyQueryHookResult =
  ReturnType<typeof useGetDashboardJobsitesWithStatsCurrentSessionLazyQuery>;
export type GetDashboardJobsitesWithStatsCurrentSessionSuspenseQueryHookResult =
  ReturnType<
    typeof useGetDashboardJobsitesWithStatsCurrentSessionSuspenseQuery
  >;
export type GetDashboardJobsitesWithStatsCurrentSessionQueryResult =
  Apollo.QueryResult<
    GetDashboardJobsitesWithStatsCurrentSessionQuery,
    GetDashboardJobsitesWithStatsCurrentSessionQueryVariables
  >;
export const GetDeveloperContainerDeveloperInfoDocument = gql`
  query GetDeveloperContainerDeveloperInfo(
    $developerId: ID!
    $includeArchived: Boolean!
  ) {
    getDeveloper(developerId: $developerId, includeArchived: $includeArchived) {
      developerId
      organization {
        organizationId
        name
        slug
        legalName
        email
        phoneNumber
        addressLine1
        addressLine2
        addressCity
        addressCity
        addressState
        addressZipCode
        objectHistory {
          createdAt
          createdBy {
            userAccountId
            identity {
              firstName
              lastName
            }
          }
          updatedAt
          updatedBy {
            userAccountId
            identity {
              firstName
              lastName
            }
          }
        }
      }
      jobsites {
        count
        edges {
          node {
            name
            parentId
            jobsiteId
            addressLine1
            addressLine2
            addressCity
            addressState
            addressZipCode
            startDate
            endDate
            workerAccessEnabled
            avigilonEnabled
            jobsiteWorkers {
              count
            }
            featuresModule {
              announcementsEnabled
              archivingAccessEventsEnabled
            }
            developer {
              developerId
              name
            }
            jobsiteCardFormats {
              __typename
              count
              edges {
                node {
                  jobsiteCardFormatId
                  isDefaultForCardType
                  workerCardFormat {
                    workerCardFormatId
                    name
                    description
                    cardType
                    facilityCode
                  }
                }
              }
            }
            jobsiteMembers {
              count
            }
          }
        }
      }
      objectHistory {
        createdAt
        createdBy {
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

/**
 * __useGetDeveloperContainerDeveloperInfoQuery__
 *
 * To run a query within a React component, call `useGetDeveloperContainerDeveloperInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeveloperContainerDeveloperInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeveloperContainerDeveloperInfoQuery({
 *   variables: {
 *      developerId: // value for 'developerId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetDeveloperContainerDeveloperInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeveloperContainerDeveloperInfoQuery,
    GetDeveloperContainerDeveloperInfoQueryVariables
  > &
    (
      | {
          variables: GetDeveloperContainerDeveloperInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeveloperContainerDeveloperInfoQuery,
    GetDeveloperContainerDeveloperInfoQueryVariables
  >(GetDeveloperContainerDeveloperInfoDocument, options);
}
export function useGetDeveloperContainerDeveloperInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeveloperContainerDeveloperInfoQuery,
    GetDeveloperContainerDeveloperInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeveloperContainerDeveloperInfoQuery,
    GetDeveloperContainerDeveloperInfoQueryVariables
  >(GetDeveloperContainerDeveloperInfoDocument, options);
}
export function useGetDeveloperContainerDeveloperInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeveloperContainerDeveloperInfoQuery,
    GetDeveloperContainerDeveloperInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeveloperContainerDeveloperInfoQuery,
    GetDeveloperContainerDeveloperInfoQueryVariables
  >(GetDeveloperContainerDeveloperInfoDocument, options);
}
export type GetDeveloperContainerDeveloperInfoQueryHookResult = ReturnType<
  typeof useGetDeveloperContainerDeveloperInfoQuery
>;
export type GetDeveloperContainerDeveloperInfoLazyQueryHookResult = ReturnType<
  typeof useGetDeveloperContainerDeveloperInfoLazyQuery
>;
export type GetDeveloperContainerDeveloperInfoSuspenseQueryHookResult =
  ReturnType<typeof useGetDeveloperContainerDeveloperInfoSuspenseQuery>;
export type GetDeveloperContainerDeveloperInfoQueryResult = Apollo.QueryResult<
  GetDeveloperContainerDeveloperInfoQuery,
  GetDeveloperContainerDeveloperInfoQueryVariables
>;
export const GetDeveloperWorkersContainerCurrentSessionDocument = gql`
  query GetDeveloperWorkersContainerCurrentSession(
    $userWorkersInput: UserWorkersInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        workers(input: $userWorkersInput) {
          count
          edges {
            node {
              workerId
              birthDate
              quickCode
              user {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
              profilePictureCropped {
                downloadUrl
                uploadedAt
                fileId
                fileType
              }
              workerCards {
                count
                edges {
                  node {
                    cardNumber
                    cardStatus
                    workerCardId
                  }
                }
              }
              jobsiteWorkers {
                edges {
                  node {
                    jobsiteWorkerId
                    trade
                    jobsiteContractor {
                      jobsite {
                        jobsiteId
                        name
                      }
                      contractor {
                        contractorId
                        organization {
                          name
                        }
                      }
                    }
                    currentAccess {
                      isAllowed
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetDeveloperWorkersContainerCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetDeveloperWorkersContainerCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeveloperWorkersContainerCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeveloperWorkersContainerCurrentSessionQuery({
 *   variables: {
 *      userWorkersInput: // value for 'userWorkersInput'
 *   },
 * });
 */
export function useGetDeveloperWorkersContainerCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDeveloperWorkersContainerCurrentSessionQuery,
    GetDeveloperWorkersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDeveloperWorkersContainerCurrentSessionQuery,
    GetDeveloperWorkersContainerCurrentSessionQueryVariables
  >(GetDeveloperWorkersContainerCurrentSessionDocument, options);
}
export function useGetDeveloperWorkersContainerCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeveloperWorkersContainerCurrentSessionQuery,
    GetDeveloperWorkersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDeveloperWorkersContainerCurrentSessionQuery,
    GetDeveloperWorkersContainerCurrentSessionQueryVariables
  >(GetDeveloperWorkersContainerCurrentSessionDocument, options);
}
export function useGetDeveloperWorkersContainerCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeveloperWorkersContainerCurrentSessionQuery,
    GetDeveloperWorkersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeveloperWorkersContainerCurrentSessionQuery,
    GetDeveloperWorkersContainerCurrentSessionQueryVariables
  >(GetDeveloperWorkersContainerCurrentSessionDocument, options);
}
export type GetDeveloperWorkersContainerCurrentSessionQueryHookResult =
  ReturnType<typeof useGetDeveloperWorkersContainerCurrentSessionQuery>;
export type GetDeveloperWorkersContainerCurrentSessionLazyQueryHookResult =
  ReturnType<typeof useGetDeveloperWorkersContainerCurrentSessionLazyQuery>;
export type GetDeveloperWorkersContainerCurrentSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetDeveloperWorkersContainerCurrentSessionSuspenseQuery>;
export type GetDeveloperWorkersContainerCurrentSessionQueryResult =
  Apollo.QueryResult<
    GetDeveloperWorkersContainerCurrentSessionQuery,
    GetDeveloperWorkersContainerCurrentSessionQueryVariables
  >;
export const DeveloperCreateDocument = gql`
  mutation DeveloperCreate($input: DeveloperCreateInput!) {
    developerCreate(input: $input) {
      developer {
        name
        developerId
        organization {
          name
          slug
          organizationId
        }
      }
    }
  }
`;
export type DeveloperCreateMutationFn = Apollo.MutationFunction<
  DeveloperCreateMutation,
  DeveloperCreateMutationVariables
>;

/**
 * __useDeveloperCreateMutation__
 *
 * To run a mutation, you first call `useDeveloperCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeveloperCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [developerCreateMutation, { data, loading, error }] = useDeveloperCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeveloperCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeveloperCreateMutation,
    DeveloperCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeveloperCreateMutation,
    DeveloperCreateMutationVariables
  >(DeveloperCreateDocument, options);
}
export type DeveloperCreateMutationHookResult = ReturnType<
  typeof useDeveloperCreateMutation
>;
export type DeveloperCreateMutationResult =
  Apollo.MutationResult<DeveloperCreateMutation>;
export type DeveloperCreateMutationOptions = Apollo.BaseMutationOptions<
  DeveloperCreateMutation,
  DeveloperCreateMutationVariables
>;
export const DeveloperUpdateDocument = gql`
  mutation DeveloperUpdate($input: DeveloperUpdateInput!) {
    developerUpdate(input: $input) {
      developer {
        name
        developerId
        organization {
          name
          slug
          organizationId
        }
      }
    }
  }
`;
export type DeveloperUpdateMutationFn = Apollo.MutationFunction<
  DeveloperUpdateMutation,
  DeveloperUpdateMutationVariables
>;

/**
 * __useDeveloperUpdateMutation__
 *
 * To run a mutation, you first call `useDeveloperUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeveloperUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [developerUpdateMutation, { data, loading, error }] = useDeveloperUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeveloperUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeveloperUpdateMutation,
    DeveloperUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeveloperUpdateMutation,
    DeveloperUpdateMutationVariables
  >(DeveloperUpdateDocument, options);
}
export type DeveloperUpdateMutationHookResult = ReturnType<
  typeof useDeveloperUpdateMutation
>;
export type DeveloperUpdateMutationResult =
  Apollo.MutationResult<DeveloperUpdateMutation>;
export type DeveloperUpdateMutationOptions = Apollo.BaseMutationOptions<
  DeveloperUpdateMutation,
  DeveloperUpdateMutationVariables
>;
export const GetDevelopersContainerCurrentSessionDocument = gql`
  query GetDevelopersContainerCurrentSession(
    $userDevelopersInput: UserDevelopersInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        developers(input: $userDevelopersInput) {
          count
          edges {
            node {
              developerId
              organization {
                organizationId
                name
                addressState
                addressCity
              }
              jobsites {
                count
                edges {
                  node {
                    jobsiteId
                    name
                    startDate
                    endDate
                    jobsiteWorkers {
                      count
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetDevelopersContainerCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetDevelopersContainerCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevelopersContainerCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevelopersContainerCurrentSessionQuery({
 *   variables: {
 *      userDevelopersInput: // value for 'userDevelopersInput'
 *   },
 * });
 */
export function useGetDevelopersContainerCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDevelopersContainerCurrentSessionQuery,
    GetDevelopersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDevelopersContainerCurrentSessionQuery,
    GetDevelopersContainerCurrentSessionQueryVariables
  >(GetDevelopersContainerCurrentSessionDocument, options);
}
export function useGetDevelopersContainerCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDevelopersContainerCurrentSessionQuery,
    GetDevelopersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDevelopersContainerCurrentSessionQuery,
    GetDevelopersContainerCurrentSessionQueryVariables
  >(GetDevelopersContainerCurrentSessionDocument, options);
}
export function useGetDevelopersContainerCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDevelopersContainerCurrentSessionQuery,
    GetDevelopersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDevelopersContainerCurrentSessionQuery,
    GetDevelopersContainerCurrentSessionQueryVariables
  >(GetDevelopersContainerCurrentSessionDocument, options);
}
export type GetDevelopersContainerCurrentSessionQueryHookResult = ReturnType<
  typeof useGetDevelopersContainerCurrentSessionQuery
>;
export type GetDevelopersContainerCurrentSessionLazyQueryHookResult =
  ReturnType<typeof useGetDevelopersContainerCurrentSessionLazyQuery>;
export type GetDevelopersContainerCurrentSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetDevelopersContainerCurrentSessionSuspenseQuery>;
export type GetDevelopersContainerCurrentSessionQueryResult =
  Apollo.QueryResult<
    GetDevelopersContainerCurrentSessionQuery,
    GetDevelopersContainerCurrentSessionQueryVariables
  >;
export const GetChangeWorkerDocument = gql`
  query GetChangeWorker($workerId: ID!) {
    getWorker(workerId: $workerId, includeArchived: true) {
      workerId
      quickCode
      createdMethod
      isArchived
      objectHistory {
        createdAt
        createdBy {
          userAccountId
          identity {
            firstName
            lastName
            email
          }
        }
        updatedAt
        updatedBy {
          userAccountId
          identity {
            firstName
            lastName
            email
          }
        }
      }
      user {
        userAccountId
        identity {
          id
          firstName
          lastName
          email
        }
        jobsiteMembers {
          edges {
            node {
              id
              title
              jobsite {
                jobsiteId
                name
                timeZone
              }
            }
          }
        }
        roles(input: { includeArchived: true }) {
          key
          mappingId
          displayName
          object {
            objectId
            objectName
            objectDetails {
              objectMemberId
              type
              name
              title
            }
          }
        }
      }
      jobsiteWorkers(input: { includeArchived: true }) {
        edges {
          node {
            jobsiteWorkerId
            jobsiteContractor {
              jobsite {
                jobsiteId
                name
                timeZone
              }
              contractor {
                contractorId
                organization {
                  organizationId
                  name
                }
              }
            }
            currentAccess {
              id
              isAllowed
              notAllowedReason
              endDate
            }
          }
        }
      }
      documents {
        edges {
          node {
            jobsiteWorkerDocumentId
            jobsiteWorkerDocumentType {
              jobsite {
                name
                jobsiteId
                developer {
                  name
                  developerId
                }
              }
              workerDocumentType {
                name
                key
                expirationDate
                documentLevel
                isGlobal
                isPhi
              }
            }
            latestVersion {
              jobsiteWorkerDocumentVersionId
              files {
                fileId
                fileType
                downloadUrl
              }
              additionalFieldValues {
                key
                value
              }
            }
          }
        }
      }
      workerCards(input: { includeArchived: true }) {
        edges {
          node {
            workerCardId
            cardNumber
          }
        }
      }
    }
  }
`;

/**
 * __useGetChangeWorkerQuery__
 *
 * To run a query within a React component, call `useGetChangeWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangeWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangeWorkerQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetChangeWorkerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetChangeWorkerQuery,
    GetChangeWorkerQueryVariables
  > &
    (
      | { variables: GetChangeWorkerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetChangeWorkerQuery, GetChangeWorkerQueryVariables>(
    GetChangeWorkerDocument,
    options,
  );
}
export function useGetChangeWorkerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetChangeWorkerQuery,
    GetChangeWorkerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetChangeWorkerQuery,
    GetChangeWorkerQueryVariables
  >(GetChangeWorkerDocument, options);
}
export function useGetChangeWorkerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetChangeWorkerQuery,
    GetChangeWorkerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetChangeWorkerQuery,
    GetChangeWorkerQueryVariables
  >(GetChangeWorkerDocument, options);
}
export type GetChangeWorkerQueryHookResult = ReturnType<
  typeof useGetChangeWorkerQuery
>;
export type GetChangeWorkerLazyQueryHookResult = ReturnType<
  typeof useGetChangeWorkerLazyQuery
>;
export type GetChangeWorkerSuspenseQueryHookResult = ReturnType<
  typeof useGetChangeWorkerSuspenseQuery
>;
export type GetChangeWorkerQueryResult = Apollo.QueryResult<
  GetChangeWorkerQuery,
  GetChangeWorkerQueryVariables
>;
export const GetEntityChangesDocument = gql`
  query GetEntityChanges($input: GetEntityChangesInput) {
    getEntityChanges(input: $input) {
      count
      edges {
        node {
          id
          tableName
          entityId
          entityDbId
          apiDbHandler
          values
          objectHistory {
            createdAt
            createdBy {
              userAccountId
              identity {
                firstName
                lastName
                email
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetEntityChangesQuery__
 *
 * To run a query within a React component, call `useGetEntityChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityChangesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEntityChangesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEntityChangesQuery,
    GetEntityChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEntityChangesQuery, GetEntityChangesQueryVariables>(
    GetEntityChangesDocument,
    options,
  );
}
export function useGetEntityChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEntityChangesQuery,
    GetEntityChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEntityChangesQuery,
    GetEntityChangesQueryVariables
  >(GetEntityChangesDocument, options);
}
export function useGetEntityChangesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetEntityChangesQuery,
    GetEntityChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetEntityChangesQuery,
    GetEntityChangesQueryVariables
  >(GetEntityChangesDocument, options);
}
export type GetEntityChangesQueryHookResult = ReturnType<
  typeof useGetEntityChangesQuery
>;
export type GetEntityChangesLazyQueryHookResult = ReturnType<
  typeof useGetEntityChangesLazyQuery
>;
export type GetEntityChangesSuspenseQueryHookResult = ReturnType<
  typeof useGetEntityChangesSuspenseQuery
>;
export type GetEntityChangesQueryResult = Apollo.QueryResult<
  GetEntityChangesQuery,
  GetEntityChangesQueryVariables
>;
export const RegisterWorkerForFacialRecognitionBadgeDocument = gql`
  mutation registerWorkerForFacialRecognitionBadge(
    $workerId: ID!
    $workerCardId: ID!
    $newPhoneNumber: String
  ) {
    registerWorkerForFacialRecognitionBadge(
      workerId: $workerId
      workerCardId: $workerCardId
      newPhoneNumber: $newPhoneNumber
    ) {
      workerCardId
      cardStatus
      cardNumber
      workerCardFormat {
        name
        cardType
        facilityCode
      }
    }
  }
`;
export type RegisterWorkerForFacialRecognitionBadgeMutationFn =
  Apollo.MutationFunction<
    RegisterWorkerForFacialRecognitionBadgeMutation,
    RegisterWorkerForFacialRecognitionBadgeMutationVariables
  >;

/**
 * __useRegisterWorkerForFacialRecognitionBadgeMutation__
 *
 * To run a mutation, you first call `useRegisterWorkerForFacialRecognitionBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterWorkerForFacialRecognitionBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerWorkerForFacialRecognitionBadgeMutation, { data, loading, error }] = useRegisterWorkerForFacialRecognitionBadgeMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      workerCardId: // value for 'workerCardId'
 *      newPhoneNumber: // value for 'newPhoneNumber'
 *   },
 * });
 */
export function useRegisterWorkerForFacialRecognitionBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterWorkerForFacialRecognitionBadgeMutation,
    RegisterWorkerForFacialRecognitionBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterWorkerForFacialRecognitionBadgeMutation,
    RegisterWorkerForFacialRecognitionBadgeMutationVariables
  >(RegisterWorkerForFacialRecognitionBadgeDocument, options);
}
export type RegisterWorkerForFacialRecognitionBadgeMutationHookResult =
  ReturnType<typeof useRegisterWorkerForFacialRecognitionBadgeMutation>;
export type RegisterWorkerForFacialRecognitionBadgeMutationResult =
  Apollo.MutationResult<RegisterWorkerForFacialRecognitionBadgeMutation>;
export type RegisterWorkerForFacialRecognitionBadgeMutationOptions =
  Apollo.BaseMutationOptions<
    RegisterWorkerForFacialRecognitionBadgeMutation,
    RegisterWorkerForFacialRecognitionBadgeMutationVariables
  >;
export const GenerateFormSubmissionsReportDocument = gql`
  mutation GenerateFormSubmissionsReport($input: FormSubmissionsReportInput!) {
    generateFormSubmissionsReport(input: $input) {
      fileId
      fileType
      uploadedAt
      downloadUrl
      originalFileName
    }
  }
`;
export type GenerateFormSubmissionsReportMutationFn = Apollo.MutationFunction<
  GenerateFormSubmissionsReportMutation,
  GenerateFormSubmissionsReportMutationVariables
>;

/**
 * __useGenerateFormSubmissionsReportMutation__
 *
 * To run a mutation, you first call `useGenerateFormSubmissionsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateFormSubmissionsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateFormSubmissionsReportMutation, { data, loading, error }] = useGenerateFormSubmissionsReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateFormSubmissionsReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateFormSubmissionsReportMutation,
    GenerateFormSubmissionsReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateFormSubmissionsReportMutation,
    GenerateFormSubmissionsReportMutationVariables
  >(GenerateFormSubmissionsReportDocument, options);
}
export type GenerateFormSubmissionsReportMutationHookResult = ReturnType<
  typeof useGenerateFormSubmissionsReportMutation
>;
export type GenerateFormSubmissionsReportMutationResult =
  Apollo.MutationResult<GenerateFormSubmissionsReportMutation>;
export type GenerateFormSubmissionsReportMutationOptions =
  Apollo.BaseMutationOptions<
    GenerateFormSubmissionsReportMutation,
    GenerateFormSubmissionsReportMutationVariables
  >;
export const JobsiteArchiveFormSubmissionDocument = gql`
  mutation JobsiteArchiveFormSubmission(
    $input: JobsiteArchiveFormSubmissionInput!
  ) {
    jobsiteArchiveFormSubmission(input: $input) {
      success {
        success
      }
    }
  }
`;
export type JobsiteArchiveFormSubmissionMutationFn = Apollo.MutationFunction<
  JobsiteArchiveFormSubmissionMutation,
  JobsiteArchiveFormSubmissionMutationVariables
>;

/**
 * __useJobsiteArchiveFormSubmissionMutation__
 *
 * To run a mutation, you first call `useJobsiteArchiveFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteArchiveFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteArchiveFormSubmissionMutation, { data, loading, error }] = useJobsiteArchiveFormSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteArchiveFormSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteArchiveFormSubmissionMutation,
    JobsiteArchiveFormSubmissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteArchiveFormSubmissionMutation,
    JobsiteArchiveFormSubmissionMutationVariables
  >(JobsiteArchiveFormSubmissionDocument, options);
}
export type JobsiteArchiveFormSubmissionMutationHookResult = ReturnType<
  typeof useJobsiteArchiveFormSubmissionMutation
>;
export type JobsiteArchiveFormSubmissionMutationResult =
  Apollo.MutationResult<JobsiteArchiveFormSubmissionMutation>;
export type JobsiteArchiveFormSubmissionMutationOptions =
  Apollo.BaseMutationOptions<
    JobsiteArchiveFormSubmissionMutation,
    JobsiteArchiveFormSubmissionMutationVariables
  >;
export const JobsiteCreateFormSubmissionDocument = gql`
  mutation JobsiteCreateFormSubmission(
    $input: JobsiteCreateFormSubmissionInput!
  ) {
    jobsiteCreateFormSubmission(input: $input) {
      jobsiteFormSubmission {
        id
      }
    }
  }
`;
export type JobsiteCreateFormSubmissionMutationFn = Apollo.MutationFunction<
  JobsiteCreateFormSubmissionMutation,
  JobsiteCreateFormSubmissionMutationVariables
>;

/**
 * __useJobsiteCreateFormSubmissionMutation__
 *
 * To run a mutation, you first call `useJobsiteCreateFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteCreateFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteCreateFormSubmissionMutation, { data, loading, error }] = useJobsiteCreateFormSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteCreateFormSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteCreateFormSubmissionMutation,
    JobsiteCreateFormSubmissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteCreateFormSubmissionMutation,
    JobsiteCreateFormSubmissionMutationVariables
  >(JobsiteCreateFormSubmissionDocument, options);
}
export type JobsiteCreateFormSubmissionMutationHookResult = ReturnType<
  typeof useJobsiteCreateFormSubmissionMutation
>;
export type JobsiteCreateFormSubmissionMutationResult =
  Apollo.MutationResult<JobsiteCreateFormSubmissionMutation>;
export type JobsiteCreateFormSubmissionMutationOptions =
  Apollo.BaseMutationOptions<
    JobsiteCreateFormSubmissionMutation,
    JobsiteCreateFormSubmissionMutationVariables
  >;
export const GetFormsDocument = gql`
  query GetForms($formsInput: UserFormsInput) {
    getCurrentSession {
      user {
        forms(input: $formsInput) {
          edges {
            node {
              id
              key
              name
              content
              allowAdd
              allowEdit
              allowDelete
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFormsQuery__
 *
 * To run a query within a React component, call `useGetFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormsQuery({
 *   variables: {
 *      formsInput: // value for 'formsInput'
 *   },
 * });
 */
export function useGetFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFormsQuery, GetFormsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFormsQuery, GetFormsQueryVariables>(
    GetFormsDocument,
    options,
  );
}
export function useGetFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormsQuery,
    GetFormsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFormsQuery, GetFormsQueryVariables>(
    GetFormsDocument,
    options,
  );
}
export function useGetFormsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormsQuery,
    GetFormsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetFormsQuery, GetFormsQueryVariables>(
    GetFormsDocument,
    options,
  );
}
export type GetFormsQueryHookResult = ReturnType<typeof useGetFormsQuery>;
export type GetFormsLazyQueryHookResult = ReturnType<
  typeof useGetFormsLazyQuery
>;
export type GetFormsSuspenseQueryHookResult = ReturnType<
  typeof useGetFormsSuspenseQuery
>;
export type GetFormsQueryResult = Apollo.QueryResult<
  GetFormsQuery,
  GetFormsQueryVariables
>;
export const GetJobsiteFormSubmissionsDocument = gql`
  query GetJobsiteFormSubmissions(
    $jobsiteFormSubmissionsInput: JobsiteFormSubmissionsInput!
  ) {
    getCurrentSession {
      user {
        jobsiteFormSubmissions(input: $jobsiteFormSubmissionsInput) {
          count
          edges {
            node {
              id
              startAt
              isStartTimeSpecified
              endAt
              timeZone
              extraData
              objectHistory {
                createdAt
                createdBy {
                  userAccountId
                  identity {
                    firstName
                    lastName
                  }
                  worker {
                    workerId
                    profilePictureCropped {
                      downloadUrl
                    }
                  }
                }
              }
              jobsiteForm {
                id
                jobsite {
                  jobsiteId
                  name
                }
                form {
                  id
                  key
                  name
                  allowEdit
                  allowDelete
                  allowPrintView
                }
              }
              jobsiteContractors {
                edges {
                  node {
                    id
                    associationType
                    jobsiteContractor {
                      id
                      contractor {
                        contractorId
                        organization {
                          organizationId
                          name
                        }
                      }
                    }
                  }
                }
              }
              jobsiteWorkers {
                count
                edges {
                  node {
                    id
                    extraData
                    associationType
                    jobsiteWorker {
                      jobsiteWorkerId
                      activeTempWorkerCard {
                        workerCardId
                        expiredAt
                        cardNumber
                        tempBadge {
                          id
                          name
                          cardNumber
                        }
                      }
                      contractorWorker {
                        worker {
                          workerId
                          user {
                            userAccountId
                            identity {
                              firstName
                              lastName
                              phoneNumber
                            }
                          }
                          profilePictureCropped {
                            downloadUrl
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          filtersOptions {
            forms {
              value
              label
            }
            contractors {
              value
              label
            }
            createdByUsers {
              value
              label
            }
            workers {
              value
              label
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteFormSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteFormSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteFormSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteFormSubmissionsQuery({
 *   variables: {
 *      jobsiteFormSubmissionsInput: // value for 'jobsiteFormSubmissionsInput'
 *   },
 * });
 */
export function useGetJobsiteFormSubmissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteFormSubmissionsQuery,
    GetJobsiteFormSubmissionsQueryVariables
  > &
    (
      | { variables: GetJobsiteFormSubmissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteFormSubmissionsQuery,
    GetJobsiteFormSubmissionsQueryVariables
  >(GetJobsiteFormSubmissionsDocument, options);
}
export function useGetJobsiteFormSubmissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteFormSubmissionsQuery,
    GetJobsiteFormSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteFormSubmissionsQuery,
    GetJobsiteFormSubmissionsQueryVariables
  >(GetJobsiteFormSubmissionsDocument, options);
}
export function useGetJobsiteFormSubmissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteFormSubmissionsQuery,
    GetJobsiteFormSubmissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteFormSubmissionsQuery,
    GetJobsiteFormSubmissionsQueryVariables
  >(GetJobsiteFormSubmissionsDocument, options);
}
export type GetJobsiteFormSubmissionsQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionsQuery
>;
export type GetJobsiteFormSubmissionsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionsLazyQuery
>;
export type GetJobsiteFormSubmissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionsSuspenseQuery
>;
export type GetJobsiteFormSubmissionsQueryResult = Apollo.QueryResult<
  GetJobsiteFormSubmissionsQuery,
  GetJobsiteFormSubmissionsQueryVariables
>;
export const GetJobsiteFormsDocument = gql`
  query GetJobsiteForms($jobsiteFormsInput: UserJobsiteFormsInput) {
    getCurrentSession {
      user {
        jobsiteForms(input: $jobsiteFormsInput) {
          edges {
            node {
              id
              jobsite {
                jobsiteId
                name
                timeZone
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteFormsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteFormsQuery({
 *   variables: {
 *      jobsiteFormsInput: // value for 'jobsiteFormsInput'
 *   },
 * });
 */
export function useGetJobsiteFormsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobsiteFormsQuery,
    GetJobsiteFormsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobsiteFormsQuery, GetJobsiteFormsQueryVariables>(
    GetJobsiteFormsDocument,
    options,
  );
}
export function useGetJobsiteFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteFormsQuery,
    GetJobsiteFormsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteFormsQuery,
    GetJobsiteFormsQueryVariables
  >(GetJobsiteFormsDocument, options);
}
export function useGetJobsiteFormsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteFormsQuery,
    GetJobsiteFormsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteFormsQuery,
    GetJobsiteFormsQueryVariables
  >(GetJobsiteFormsDocument, options);
}
export type GetJobsiteFormsQueryHookResult = ReturnType<
  typeof useGetJobsiteFormsQuery
>;
export type GetJobsiteFormsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteFormsLazyQuery
>;
export type GetJobsiteFormsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteFormsSuspenseQuery
>;
export type GetJobsiteFormsQueryResult = Apollo.QueryResult<
  GetJobsiteFormsQuery,
  GetJobsiteFormsQueryVariables
>;
export const GetCurrentSessionHomeContainerDocument = gql`
  query GetCurrentSessionHomeContainer {
    getCurrentSession {
      user {
        userAccountId
        jobsiteMembers {
          count
        }
        contractorMembers {
          count
        }
      }
    }
  }
`;

/**
 * __useGetCurrentSessionHomeContainerQuery__
 *
 * To run a query within a React component, call `useGetCurrentSessionHomeContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentSessionHomeContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentSessionHomeContainerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentSessionHomeContainerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCurrentSessionHomeContainerQuery,
    GetCurrentSessionHomeContainerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentSessionHomeContainerQuery,
    GetCurrentSessionHomeContainerQueryVariables
  >(GetCurrentSessionHomeContainerDocument, options);
}
export function useGetCurrentSessionHomeContainerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentSessionHomeContainerQuery,
    GetCurrentSessionHomeContainerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentSessionHomeContainerQuery,
    GetCurrentSessionHomeContainerQueryVariables
  >(GetCurrentSessionHomeContainerDocument, options);
}
export function useGetCurrentSessionHomeContainerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentSessionHomeContainerQuery,
    GetCurrentSessionHomeContainerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentSessionHomeContainerQuery,
    GetCurrentSessionHomeContainerQueryVariables
  >(GetCurrentSessionHomeContainerDocument, options);
}
export type GetCurrentSessionHomeContainerQueryHookResult = ReturnType<
  typeof useGetCurrentSessionHomeContainerQuery
>;
export type GetCurrentSessionHomeContainerLazyQueryHookResult = ReturnType<
  typeof useGetCurrentSessionHomeContainerLazyQuery
>;
export type GetCurrentSessionHomeContainerSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentSessionHomeContainerSuspenseQuery
>;
export type GetCurrentSessionHomeContainerQueryResult = Apollo.QueryResult<
  GetCurrentSessionHomeContainerQuery,
  GetCurrentSessionHomeContainerQueryVariables
>;
export const JobsiteAddContractorsDocument = gql`
  mutation JobsiteAddContractors($input: JobsiteAddContractorsInput!) {
    jobsiteAddContractors(input: $input) {
      jobsiteContractors {
        id
      }
    }
  }
`;
export type JobsiteAddContractorsMutationFn = Apollo.MutationFunction<
  JobsiteAddContractorsMutation,
  JobsiteAddContractorsMutationVariables
>;

/**
 * __useJobsiteAddContractorsMutation__
 *
 * To run a mutation, you first call `useJobsiteAddContractorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteAddContractorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteAddContractorsMutation, { data, loading, error }] = useJobsiteAddContractorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteAddContractorsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteAddContractorsMutation,
    JobsiteAddContractorsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteAddContractorsMutation,
    JobsiteAddContractorsMutationVariables
  >(JobsiteAddContractorsDocument, options);
}
export type JobsiteAddContractorsMutationHookResult = ReturnType<
  typeof useJobsiteAddContractorsMutation
>;
export type JobsiteAddContractorsMutationResult =
  Apollo.MutationResult<JobsiteAddContractorsMutation>;
export type JobsiteAddContractorsMutationOptions = Apollo.BaseMutationOptions<
  JobsiteAddContractorsMutation,
  JobsiteAddContractorsMutationVariables
>;
export const JobsiteOffboardContractorDocument = gql`
  mutation JobsiteOffboardContractor($input: JobsiteOffboardContractorInput!) {
    jobsiteOffboardContractor(input: $input) {
      success {
        success
      }
    }
  }
`;
export type JobsiteOffboardContractorMutationFn = Apollo.MutationFunction<
  JobsiteOffboardContractorMutation,
  JobsiteOffboardContractorMutationVariables
>;

/**
 * __useJobsiteOffboardContractorMutation__
 *
 * To run a mutation, you first call `useJobsiteOffboardContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteOffboardContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteOffboardContractorMutation, { data, loading, error }] = useJobsiteOffboardContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteOffboardContractorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteOffboardContractorMutation,
    JobsiteOffboardContractorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteOffboardContractorMutation,
    JobsiteOffboardContractorMutationVariables
  >(JobsiteOffboardContractorDocument, options);
}
export type JobsiteOffboardContractorMutationHookResult = ReturnType<
  typeof useJobsiteOffboardContractorMutation
>;
export type JobsiteOffboardContractorMutationResult =
  Apollo.MutationResult<JobsiteOffboardContractorMutation>;
export type JobsiteOffboardContractorMutationOptions =
  Apollo.BaseMutationOptions<
    JobsiteOffboardContractorMutation,
    JobsiteOffboardContractorMutationVariables
  >;
export const JobsiteReinstateContractorDocument = gql`
  mutation JobsiteReinstateContractor(
    $input: JobsiteReinstateContractorInput!
  ) {
    jobsiteReinstateContractor(input: $input) {
      success {
        success
      }
    }
  }
`;
export type JobsiteReinstateContractorMutationFn = Apollo.MutationFunction<
  JobsiteReinstateContractorMutation,
  JobsiteReinstateContractorMutationVariables
>;

/**
 * __useJobsiteReinstateContractorMutation__
 *
 * To run a mutation, you first call `useJobsiteReinstateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteReinstateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteReinstateContractorMutation, { data, loading, error }] = useJobsiteReinstateContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteReinstateContractorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteReinstateContractorMutation,
    JobsiteReinstateContractorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteReinstateContractorMutation,
    JobsiteReinstateContractorMutationVariables
  >(JobsiteReinstateContractorDocument, options);
}
export type JobsiteReinstateContractorMutationHookResult = ReturnType<
  typeof useJobsiteReinstateContractorMutation
>;
export type JobsiteReinstateContractorMutationResult =
  Apollo.MutationResult<JobsiteReinstateContractorMutation>;
export type JobsiteReinstateContractorMutationOptions =
  Apollo.BaseMutationOptions<
    JobsiteReinstateContractorMutation,
    JobsiteReinstateContractorMutationVariables
  >;
export const JobsiteRemoveContractorDocument = gql`
  mutation JobsiteRemoveContractor($input: JobsiteRemoveContractorInput!) {
    jobsiteRemoveContractor(input: $input) {
      success {
        success
      }
    }
  }
`;
export type JobsiteRemoveContractorMutationFn = Apollo.MutationFunction<
  JobsiteRemoveContractorMutation,
  JobsiteRemoveContractorMutationVariables
>;

/**
 * __useJobsiteRemoveContractorMutation__
 *
 * To run a mutation, you first call `useJobsiteRemoveContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteRemoveContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteRemoveContractorMutation, { data, loading, error }] = useJobsiteRemoveContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteRemoveContractorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteRemoveContractorMutation,
    JobsiteRemoveContractorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteRemoveContractorMutation,
    JobsiteRemoveContractorMutationVariables
  >(JobsiteRemoveContractorDocument, options);
}
export type JobsiteRemoveContractorMutationHookResult = ReturnType<
  typeof useJobsiteRemoveContractorMutation
>;
export type JobsiteRemoveContractorMutationResult =
  Apollo.MutationResult<JobsiteRemoveContractorMutation>;
export type JobsiteRemoveContractorMutationOptions = Apollo.BaseMutationOptions<
  JobsiteRemoveContractorMutation,
  JobsiteRemoveContractorMutationVariables
>;
export const JobsiteUpdateContractorDocument = gql`
  mutation JobsiteUpdateContractor($input: JobsiteUpdateContractorInput!) {
    jobsiteUpdateContractor(input: $input) {
      jobsiteContractor {
        id
      }
    }
  }
`;
export type JobsiteUpdateContractorMutationFn = Apollo.MutationFunction<
  JobsiteUpdateContractorMutation,
  JobsiteUpdateContractorMutationVariables
>;

/**
 * __useJobsiteUpdateContractorMutation__
 *
 * To run a mutation, you first call `useJobsiteUpdateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteUpdateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteUpdateContractorMutation, { data, loading, error }] = useJobsiteUpdateContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteUpdateContractorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteUpdateContractorMutation,
    JobsiteUpdateContractorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteUpdateContractorMutation,
    JobsiteUpdateContractorMutationVariables
  >(JobsiteUpdateContractorDocument, options);
}
export type JobsiteUpdateContractorMutationHookResult = ReturnType<
  typeof useJobsiteUpdateContractorMutation
>;
export type JobsiteUpdateContractorMutationResult =
  Apollo.MutationResult<JobsiteUpdateContractorMutation>;
export type JobsiteUpdateContractorMutationOptions = Apollo.BaseMutationOptions<
  JobsiteUpdateContractorMutation,
  JobsiteUpdateContractorMutationVariables
>;
export const GetContractorsAndJobsitesDocument = gql`
  query GetContractorsAndJobsites(
    $userContractorsInput: UserContractorsInput!
  ) {
    getCurrentSession {
      user {
        userAccountId
        contractors(input: $userContractorsInput) {
          count
          edges {
            node {
              contractorId
              jobsiteContractors {
                count
                edges {
                  node {
                    id
                    startDate
                    contractor {
                      contractorId
                      isDefaultContractor
                      organization {
                        name
                        slug
                        legalName
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorsAndJobsitesQuery__
 *
 * To run a query within a React component, call `useGetContractorsAndJobsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorsAndJobsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorsAndJobsitesQuery({
 *   variables: {
 *      userContractorsInput: // value for 'userContractorsInput'
 *   },
 * });
 */
export function useGetContractorsAndJobsitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractorsAndJobsitesQuery,
    GetContractorsAndJobsitesQueryVariables
  > &
    (
      | { variables: GetContractorsAndJobsitesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractorsAndJobsitesQuery,
    GetContractorsAndJobsitesQueryVariables
  >(GetContractorsAndJobsitesDocument, options);
}
export function useGetContractorsAndJobsitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorsAndJobsitesQuery,
    GetContractorsAndJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractorsAndJobsitesQuery,
    GetContractorsAndJobsitesQueryVariables
  >(GetContractorsAndJobsitesDocument, options);
}
export function useGetContractorsAndJobsitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorsAndJobsitesQuery,
    GetContractorsAndJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorsAndJobsitesQuery,
    GetContractorsAndJobsitesQueryVariables
  >(GetContractorsAndJobsitesDocument, options);
}
export type GetContractorsAndJobsitesQueryHookResult = ReturnType<
  typeof useGetContractorsAndJobsitesQuery
>;
export type GetContractorsAndJobsitesLazyQueryHookResult = ReturnType<
  typeof useGetContractorsAndJobsitesLazyQuery
>;
export type GetContractorsAndJobsitesSuspenseQueryHookResult = ReturnType<
  typeof useGetContractorsAndJobsitesSuspenseQuery
>;
export type GetContractorsAndJobsitesQueryResult = Apollo.QueryResult<
  GetContractorsAndJobsitesQuery,
  GetContractorsAndJobsitesQueryVariables
>;
export const GetJobsiteContainerDocument = gql`
  query GetJobsiteContainer($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      name
      jobsiteId
      jobsiteNumber
      addressCity
      addressState
      addressLine1
      addressLine2
      addressZipCode
      startDate
      endDate
      timeZone
      procoreCompanyId
      procoreProjectId
      profilePicture {
        downloadUrl
      }
      procoreProjectVendors {
        edges {
          node {
            id
            name
          }
        }
      }
      jobsiteWorkers {
        count
      }
      jobsiteMembers {
        count
      }
      developer {
        organization {
          name
        }
      }
      jobsiteContractors {
        count
        edges {
          node {
            id
            contractor {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
      tempBadges {
        count
      }
      featuresModule {
        schedulingEnabled
      }
    }
  }
`;

/**
 * __useGetJobsiteContainerQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteContainerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerQuery,
    GetJobsiteContainerQueryVariables
  > &
    (
      | { variables: GetJobsiteContainerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerQuery,
    GetJobsiteContainerQueryVariables
  >(GetJobsiteContainerDocument, options);
}
export function useGetJobsiteContainerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerQuery,
    GetJobsiteContainerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerQuery,
    GetJobsiteContainerQueryVariables
  >(GetJobsiteContainerDocument, options);
}
export function useGetJobsiteContainerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerQuery,
    GetJobsiteContainerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerQuery,
    GetJobsiteContainerQueryVariables
  >(GetJobsiteContainerDocument, options);
}
export type GetJobsiteContainerQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerQuery
>;
export type GetJobsiteContainerLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerLazyQuery
>;
export type GetJobsiteContainerSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerSuspenseQuery
>;
export type GetJobsiteContainerQueryResult = Apollo.QueryResult<
  GetJobsiteContainerQuery,
  GetJobsiteContainerQueryVariables
>;
export const GetJobsiteDetailsDocument = gql`
  query GetJobsiteDetails($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      clearanceAssignmentEnabled
      cCureClearances {
        edges {
          node {
            cCureClearanceId
            name
            cCureClearanceObjectId
            isDefault
            isSelectable
            cCureEnvironment {
              cCureEnvironmentId
              namespace
              partitionId
              instanceSlug
              __typename
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteDetailsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteDetailsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteDetailsQuery,
    GetJobsiteDetailsQueryVariables
  > &
    (
      | { variables: GetJobsiteDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteDetailsQuery,
    GetJobsiteDetailsQueryVariables
  >(GetJobsiteDetailsDocument, options);
}
export function useGetJobsiteDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteDetailsQuery,
    GetJobsiteDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteDetailsQuery,
    GetJobsiteDetailsQueryVariables
  >(GetJobsiteDetailsDocument, options);
}
export function useGetJobsiteDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteDetailsQuery,
    GetJobsiteDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteDetailsQuery,
    GetJobsiteDetailsQueryVariables
  >(GetJobsiteDetailsDocument, options);
}
export type GetJobsiteDetailsQueryHookResult = ReturnType<
  typeof useGetJobsiteDetailsQuery
>;
export type GetJobsiteDetailsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteDetailsLazyQuery
>;
export type GetJobsiteDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteDetailsSuspenseQuery
>;
export type GetJobsiteDetailsQueryResult = Apollo.QueryResult<
  GetJobsiteDetailsQuery,
  GetJobsiteDetailsQueryVariables
>;
export const GetSiteConnectionsTabDocument = gql`
  query GetSiteConnectionsTab($siteId: ID!) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      connections {
        id
        externalEntity {
          type
          typeDisplayName
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetSiteConnectionsTabQuery__
 *
 * To run a query within a React component, call `useGetSiteConnectionsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteConnectionsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteConnectionsTabQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteConnectionsTabQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteConnectionsTabQuery,
    GetSiteConnectionsTabQueryVariables
  > &
    (
      | { variables: GetSiteConnectionsTabQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteConnectionsTabQuery,
    GetSiteConnectionsTabQueryVariables
  >(GetSiteConnectionsTabDocument, options);
}
export function useGetSiteConnectionsTabLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteConnectionsTabQuery,
    GetSiteConnectionsTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteConnectionsTabQuery,
    GetSiteConnectionsTabQueryVariables
  >(GetSiteConnectionsTabDocument, options);
}
export function useGetSiteConnectionsTabSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteConnectionsTabQuery,
    GetSiteConnectionsTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteConnectionsTabQuery,
    GetSiteConnectionsTabQueryVariables
  >(GetSiteConnectionsTabDocument, options);
}
export type GetSiteConnectionsTabQueryHookResult = ReturnType<
  typeof useGetSiteConnectionsTabQuery
>;
export type GetSiteConnectionsTabLazyQueryHookResult = ReturnType<
  typeof useGetSiteConnectionsTabLazyQuery
>;
export type GetSiteConnectionsTabSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteConnectionsTabSuspenseQuery
>;
export type GetSiteConnectionsTabQueryResult = Apollo.QueryResult<
  GetSiteConnectionsTabQuery,
  GetSiteConnectionsTabQueryVariables
>;
export const GetJobsiteContainerContractorsDocument = gql`
  query GetJobsiteContainerContractors(
    $jobsiteId: ID!
    $jobsiteJobsiteContractorsInput: JobsiteJobsiteContractorsInput
  ) {
    getProcoreConnectionStatus {
      connected
      procoreUserId
    }
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      startDate
      jobsiteContractors(input: $jobsiteJobsiteContractorsInput) {
        count
        edges {
          node {
            id
            procoreProjectVendorId
            contractor {
              contractorId
              organization {
                name
              }
            }
            jobsite {
              name
              jobsiteId
              addressCity
              addressState
              startDate
              developer {
                organization {
                  name
                }
              }
            }
            parentJobsiteContractor {
              contractor {
                contractorId
                organization {
                  name
                }
              }
            }
            subcontractedJobsiteContractors {
              count
            }
            startDate
            endDate
            contact {
              firstName
              lastName
              phoneNumber
              email
              title
            }
            jobsiteWorkers {
              count
              edges {
                node {
                  jobsiteWorkerId
                }
              }
            }
            subcontractedJobsiteContractors {
              count
              edges {
                node {
                  contractor {
                    contractorId
                    organization {
                      name
                    }
                  }
                  jobsiteWorkers {
                    count
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteContainerContractorsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerContractorsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteJobsiteContractorsInput: // value for 'jobsiteJobsiteContractorsInput'
 *   },
 * });
 */
export function useGetJobsiteContainerContractorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerContractorsQuery,
    GetJobsiteContainerContractorsQueryVariables
  > &
    (
      | {
          variables: GetJobsiteContainerContractorsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerContractorsQuery,
    GetJobsiteContainerContractorsQueryVariables
  >(GetJobsiteContainerContractorsDocument, options);
}
export function useGetJobsiteContainerContractorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerContractorsQuery,
    GetJobsiteContainerContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerContractorsQuery,
    GetJobsiteContainerContractorsQueryVariables
  >(GetJobsiteContainerContractorsDocument, options);
}
export function useGetJobsiteContainerContractorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerContractorsQuery,
    GetJobsiteContainerContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerContractorsQuery,
    GetJobsiteContainerContractorsQueryVariables
  >(GetJobsiteContainerContractorsDocument, options);
}
export type GetJobsiteContainerContractorsQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerContractorsQuery
>;
export type GetJobsiteContainerContractorsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerContractorsLazyQuery
>;
export type GetJobsiteContainerContractorsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerContractorsSuspenseQuery
>;
export type GetJobsiteContainerContractorsQueryResult = Apollo.QueryResult<
  GetJobsiteContainerContractorsQuery,
  GetJobsiteContainerContractorsQueryVariables
>;
export const GetJobsiteContainerEquipmentTabDocument = gql`
  query GetJobsiteContainerEquipmentTab(
    $jobsiteId: ID!
    $status: JobsiteEquipmentStatusType
  ) {
    getJobsiteEquipmentData(jobsiteIds: [$jobsiteId], status: $status) {
      results {
        instanceSlug
        status
        name
        description
        guid
        type
        jobsite {
          jobsiteId
          name
        }
        lastOnlineDate
        lastOfflineDate
      }
      count
    }
  }
`;

/**
 * __useGetJobsiteContainerEquipmentTabQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerEquipmentTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerEquipmentTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerEquipmentTabQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetJobsiteContainerEquipmentTabQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerEquipmentTabQuery,
    GetJobsiteContainerEquipmentTabQueryVariables
  > &
    (
      | {
          variables: GetJobsiteContainerEquipmentTabQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerEquipmentTabQuery,
    GetJobsiteContainerEquipmentTabQueryVariables
  >(GetJobsiteContainerEquipmentTabDocument, options);
}
export function useGetJobsiteContainerEquipmentTabLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerEquipmentTabQuery,
    GetJobsiteContainerEquipmentTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerEquipmentTabQuery,
    GetJobsiteContainerEquipmentTabQueryVariables
  >(GetJobsiteContainerEquipmentTabDocument, options);
}
export function useGetJobsiteContainerEquipmentTabSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerEquipmentTabQuery,
    GetJobsiteContainerEquipmentTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerEquipmentTabQuery,
    GetJobsiteContainerEquipmentTabQueryVariables
  >(GetJobsiteContainerEquipmentTabDocument, options);
}
export type GetJobsiteContainerEquipmentTabQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerEquipmentTabQuery
>;
export type GetJobsiteContainerEquipmentTabLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerEquipmentTabLazyQuery
>;
export type GetJobsiteContainerEquipmentTabSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerEquipmentTabSuspenseQuery
>;
export type GetJobsiteContainerEquipmentTabQueryResult = Apollo.QueryResult<
  GetJobsiteContainerEquipmentTabQuery,
  GetJobsiteContainerEquipmentTabQueryVariables
>;
export const GetJobsiteContainerEquipmentHistoryTabDocument = gql`
  query GetJobsiteContainerEquipmentHistoryTab(
    $jobsiteId: ID!
    $status: JobsiteEquipmentStatusType
    $fromDate: Date
    $toDate: Date
    $sortDir: OrderByDirection
    $limit: Int
    $offset: Int
  ) {
    getJobsiteEquipmentHistory(
      jobsiteIds: [$jobsiteId]
      status: $status
      fromDate: $fromDate
      toDate: $toDate
      sortDir: $sortDir
      limit: $limit
      offset: $offset
    ) {
      results {
        instanceSlug
        deviceGuid
        deviceType
        deviceStatus
        deviceName
        deviceDescription
        jobsiteId
        eventDate
      }
      count
    }
  }
`;

/**
 * __useGetJobsiteContainerEquipmentHistoryTabQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerEquipmentHistoryTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerEquipmentHistoryTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerEquipmentHistoryTabQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      status: // value for 'status'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      sortDir: // value for 'sortDir'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetJobsiteContainerEquipmentHistoryTabQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerEquipmentHistoryTabQuery,
    GetJobsiteContainerEquipmentHistoryTabQueryVariables
  > &
    (
      | {
          variables: GetJobsiteContainerEquipmentHistoryTabQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerEquipmentHistoryTabQuery,
    GetJobsiteContainerEquipmentHistoryTabQueryVariables
  >(GetJobsiteContainerEquipmentHistoryTabDocument, options);
}
export function useGetJobsiteContainerEquipmentHistoryTabLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerEquipmentHistoryTabQuery,
    GetJobsiteContainerEquipmentHistoryTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerEquipmentHistoryTabQuery,
    GetJobsiteContainerEquipmentHistoryTabQueryVariables
  >(GetJobsiteContainerEquipmentHistoryTabDocument, options);
}
export function useGetJobsiteContainerEquipmentHistoryTabSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerEquipmentHistoryTabQuery,
    GetJobsiteContainerEquipmentHistoryTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerEquipmentHistoryTabQuery,
    GetJobsiteContainerEquipmentHistoryTabQueryVariables
  >(GetJobsiteContainerEquipmentHistoryTabDocument, options);
}
export type GetJobsiteContainerEquipmentHistoryTabQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerEquipmentHistoryTabQuery
>;
export type GetJobsiteContainerEquipmentHistoryTabLazyQueryHookResult =
  ReturnType<typeof useGetJobsiteContainerEquipmentHistoryTabLazyQuery>;
export type GetJobsiteContainerEquipmentHistoryTabSuspenseQueryHookResult =
  ReturnType<typeof useGetJobsiteContainerEquipmentHistoryTabSuspenseQuery>;
export type GetJobsiteContainerEquipmentHistoryTabQueryResult =
  Apollo.QueryResult<
    GetJobsiteContainerEquipmentHistoryTabQuery,
    GetJobsiteContainerEquipmentHistoryTabQueryVariables
  >;
export const GetJobsiteContainerJobsiteInfoDocument = gql`
  query GetJobsiteContainerJobsiteInfo($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      name
      jobsiteId
      jobsiteNumber
      addressCity
      addressState
      addressLine1
      addressLine2
      addressZipCode
      startDate
      endDate
      profilePicture {
        downloadUrl
      }
      latitude
      longitude
      developer {
        organization {
          organizationId
          name
          legalName
          email
          addressLine1
          addressLine2
          addressCity
          addressCity
          addressState
          addressZipCode
        }
      }
      defaultJobsiteContractor {
        id
        contractor {
          contractorId
          organization {
            organizationId
            name
          }
        }
        jobsiteInvitation {
          jobsiteInvitationId
        }
      }
      objectHistory {
        createdAt
        updatedAt
        createdBy {
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteContainerJobsiteInfoQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerJobsiteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerJobsiteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerJobsiteInfoQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteContainerJobsiteInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerJobsiteInfoQuery,
    GetJobsiteContainerJobsiteInfoQueryVariables
  > &
    (
      | {
          variables: GetJobsiteContainerJobsiteInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerJobsiteInfoQuery,
    GetJobsiteContainerJobsiteInfoQueryVariables
  >(GetJobsiteContainerJobsiteInfoDocument, options);
}
export function useGetJobsiteContainerJobsiteInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerJobsiteInfoQuery,
    GetJobsiteContainerJobsiteInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerJobsiteInfoQuery,
    GetJobsiteContainerJobsiteInfoQueryVariables
  >(GetJobsiteContainerJobsiteInfoDocument, options);
}
export function useGetJobsiteContainerJobsiteInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerJobsiteInfoQuery,
    GetJobsiteContainerJobsiteInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerJobsiteInfoQuery,
    GetJobsiteContainerJobsiteInfoQueryVariables
  >(GetJobsiteContainerJobsiteInfoDocument, options);
}
export type GetJobsiteContainerJobsiteInfoQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerJobsiteInfoQuery
>;
export type GetJobsiteContainerJobsiteInfoLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerJobsiteInfoLazyQuery
>;
export type GetJobsiteContainerJobsiteInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerJobsiteInfoSuspenseQuery
>;
export type GetJobsiteContainerJobsiteInfoQueryResult = Apollo.QueryResult<
  GetJobsiteContainerJobsiteInfoQuery,
  GetJobsiteContainerJobsiteInfoQueryVariables
>;
export const GetJobsiteOverviewDataDocument = gql`
  query GetJobsiteOverviewData(
    $jobsiteId: ID!
    $jobsiteFormSubmissionsInput: JobsiteFormSubmissionsInput!
    $timeSeriesInput: JobsiteTimeSeriesInput!
    $weatherInput: JobsiteWeatherInput!
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      timeZone
      jobsiteForms {
        edges {
          node {
            form {
              key
            }
          }
        }
      }
      jobsiteFormSubmissions(input: $jobsiteFormSubmissionsInput) {
        edges {
          node {
            jobsiteForm {
              form {
                id
                key
                name
              }
            }
          }
        }
      }
      jobsiteStats {
        numberOfActiveWorkers
        numberOfActiveContractors
        numberOfOrientationWorkersInProgress
        numberOfOrientationWorkersNeedingBadging
        numberOfOrientationWorkersNeedingMedical
        numberOfOrientationWorkersCompleted
        numberOfOnSiteWorkers
        numberOfOnSiteContractors
      }
      timeSeries(input: $timeSeriesInput) {
        nowBoundedContractorSessions {
          dateTime
          timeZone
          value
        }
        nowBoundedSessions {
          dateTime
          timeZone
          value
        }
      }
      weather(input: $weatherInput) {
        edges {
          node {
            date
            weatherConditions {
              description
              humidity
              icon
              temp
              timestamp
              visibility
              windDirectionCardinal
              windDirectionDegrees
              windSpeed
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteOverviewDataQuery__
 *
 * To run a query within a React component, call `useGetJobsiteOverviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteOverviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteOverviewDataQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteFormSubmissionsInput: // value for 'jobsiteFormSubmissionsInput'
 *      timeSeriesInput: // value for 'timeSeriesInput'
 *      weatherInput: // value for 'weatherInput'
 *   },
 * });
 */
export function useGetJobsiteOverviewDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteOverviewDataQuery,
    GetJobsiteOverviewDataQueryVariables
  > &
    (
      | { variables: GetJobsiteOverviewDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteOverviewDataQuery,
    GetJobsiteOverviewDataQueryVariables
  >(GetJobsiteOverviewDataDocument, options);
}
export function useGetJobsiteOverviewDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteOverviewDataQuery,
    GetJobsiteOverviewDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteOverviewDataQuery,
    GetJobsiteOverviewDataQueryVariables
  >(GetJobsiteOverviewDataDocument, options);
}
export function useGetJobsiteOverviewDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteOverviewDataQuery,
    GetJobsiteOverviewDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteOverviewDataQuery,
    GetJobsiteOverviewDataQueryVariables
  >(GetJobsiteOverviewDataDocument, options);
}
export type GetJobsiteOverviewDataQueryHookResult = ReturnType<
  typeof useGetJobsiteOverviewDataQuery
>;
export type GetJobsiteOverviewDataLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteOverviewDataLazyQuery
>;
export type GetJobsiteOverviewDataSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteOverviewDataSuspenseQuery
>;
export type GetJobsiteOverviewDataQueryResult = Apollo.QueryResult<
  GetJobsiteOverviewDataQuery,
  GetJobsiteOverviewDataQueryVariables
>;
export const GetJobsitePulseDataDocument = gql`
  query GetJobsitePulseData(
    $jobsiteId: ID!
    $jobsiteAccessEventsInput: JobsiteAccessEventsInput
    $jobsiteFormSubmissionsInput: JobsiteFormSubmissionsInput!
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      timeZone
      jobsiteAccessEvents(input: $jobsiteAccessEventsInput) {
        edges {
          node {
            id
            type
            status
            credentialId
            eventOccurredAt
            localizedDate
            localizedTime
            timeZone
            rejectionReason
            message
            gateway
            zoneCrossing {
              kind
              revisionId
              entryId
              entrySideId
              reason
              from {
                kind
                zoneId
                name
              }
              to {
                kind
                zoneId
                name
              }
            }
            overnightSession
            jobsite {
              jobsiteId
              name
            }
            jobsiteWorker {
              jobsiteWorkerId
              jobsiteContractor {
                id
                contractor {
                  contractorId
                  organization {
                    organizationId
                    name
                  }
                }
              }
              currentAccess {
                isAllowed
              }
            }
            direction
            externalId
            eventType
            worker {
              workerId
              user {
                userAccountId
                identity {
                  firstName
                  lastName
                }
              }
              profilePictureCropped {
                downloadUrl
              }
            }
          }
        }
      }
      jobsiteFormSubmissions(input: $jobsiteFormSubmissionsInput) {
        edges {
          node {
            id
            extraData
            startAt
            jobsiteForm {
              id
              form {
                id
                key
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsitePulseDataQuery__
 *
 * To run a query within a React component, call `useGetJobsitePulseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsitePulseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsitePulseDataQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteAccessEventsInput: // value for 'jobsiteAccessEventsInput'
 *      jobsiteFormSubmissionsInput: // value for 'jobsiteFormSubmissionsInput'
 *   },
 * });
 */
export function useGetJobsitePulseDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsitePulseDataQuery,
    GetJobsitePulseDataQueryVariables
  > &
    (
      | { variables: GetJobsitePulseDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsitePulseDataQuery,
    GetJobsitePulseDataQueryVariables
  >(GetJobsitePulseDataDocument, options);
}
export function useGetJobsitePulseDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsitePulseDataQuery,
    GetJobsitePulseDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsitePulseDataQuery,
    GetJobsitePulseDataQueryVariables
  >(GetJobsitePulseDataDocument, options);
}
export function useGetJobsitePulseDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsitePulseDataQuery,
    GetJobsitePulseDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsitePulseDataQuery,
    GetJobsitePulseDataQueryVariables
  >(GetJobsitePulseDataDocument, options);
}
export type GetJobsitePulseDataQueryHookResult = ReturnType<
  typeof useGetJobsitePulseDataQuery
>;
export type GetJobsitePulseDataLazyQueryHookResult = ReturnType<
  typeof useGetJobsitePulseDataLazyQuery
>;
export type GetJobsitePulseDataSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsitePulseDataSuspenseQuery
>;
export type GetJobsitePulseDataQueryResult = Apollo.QueryResult<
  GetJobsitePulseDataQuery,
  GetJobsitePulseDataQueryVariables
>;
export const GetJobsitePulseTimeSeriesDocument = gql`
  query GetJobsitePulseTimeSeries(
    $jobsiteId: ID!
    $jobsiteAccessSessionsInput: JobsiteAccessSessionsInput
    $timeSeriesInput: JobsiteTimeSeriesInput
    $weatherInput: JobsiteWeatherInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      jobsiteAccessSessions(input: $jobsiteAccessSessionsInput) {
        count
      }
      timeSeries(input: $timeSeriesInput) {
        sessions {
          dateTime
          timeZone
          value
        }
      }
      weather(input: $weatherInput) {
        edges {
          node {
            date
            weatherConditions {
              timestamp
              description
              icon
              temp
              windSpeed
              windDirectionCardinal
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsitePulseTimeSeriesQuery__
 *
 * To run a query within a React component, call `useGetJobsitePulseTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsitePulseTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsitePulseTimeSeriesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteAccessSessionsInput: // value for 'jobsiteAccessSessionsInput'
 *      timeSeriesInput: // value for 'timeSeriesInput'
 *      weatherInput: // value for 'weatherInput'
 *   },
 * });
 */
export function useGetJobsitePulseTimeSeriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsitePulseTimeSeriesQuery,
    GetJobsitePulseTimeSeriesQueryVariables
  > &
    (
      | { variables: GetJobsitePulseTimeSeriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsitePulseTimeSeriesQuery,
    GetJobsitePulseTimeSeriesQueryVariables
  >(GetJobsitePulseTimeSeriesDocument, options);
}
export function useGetJobsitePulseTimeSeriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsitePulseTimeSeriesQuery,
    GetJobsitePulseTimeSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsitePulseTimeSeriesQuery,
    GetJobsitePulseTimeSeriesQueryVariables
  >(GetJobsitePulseTimeSeriesDocument, options);
}
export function useGetJobsitePulseTimeSeriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsitePulseTimeSeriesQuery,
    GetJobsitePulseTimeSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsitePulseTimeSeriesQuery,
    GetJobsitePulseTimeSeriesQueryVariables
  >(GetJobsitePulseTimeSeriesDocument, options);
}
export type GetJobsitePulseTimeSeriesQueryHookResult = ReturnType<
  typeof useGetJobsitePulseTimeSeriesQuery
>;
export type GetJobsitePulseTimeSeriesLazyQueryHookResult = ReturnType<
  typeof useGetJobsitePulseTimeSeriesLazyQuery
>;
export type GetJobsitePulseTimeSeriesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsitePulseTimeSeriesSuspenseQuery
>;
export type GetJobsitePulseTimeSeriesQueryResult = Apollo.QueryResult<
  GetJobsitePulseTimeSeriesQuery,
  GetJobsitePulseTimeSeriesQueryVariables
>;
export const GetJobsitePulseVideoFilesDocument = gql`
  query GetJobsitePulseVideoFiles($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      pulseVideoFiles {
        videoFile {
          downloadUrl
        }
        thumbnailFiles {
          downloadUrl
          fileName
        }
      }
    }
  }
`;

/**
 * __useGetJobsitePulseVideoFilesQuery__
 *
 * To run a query within a React component, call `useGetJobsitePulseVideoFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsitePulseVideoFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsitePulseVideoFilesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsitePulseVideoFilesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsitePulseVideoFilesQuery,
    GetJobsitePulseVideoFilesQueryVariables
  > &
    (
      | { variables: GetJobsitePulseVideoFilesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsitePulseVideoFilesQuery,
    GetJobsitePulseVideoFilesQueryVariables
  >(GetJobsitePulseVideoFilesDocument, options);
}
export function useGetJobsitePulseVideoFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsitePulseVideoFilesQuery,
    GetJobsitePulseVideoFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsitePulseVideoFilesQuery,
    GetJobsitePulseVideoFilesQueryVariables
  >(GetJobsitePulseVideoFilesDocument, options);
}
export function useGetJobsitePulseVideoFilesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsitePulseVideoFilesQuery,
    GetJobsitePulseVideoFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsitePulseVideoFilesQuery,
    GetJobsitePulseVideoFilesQueryVariables
  >(GetJobsitePulseVideoFilesDocument, options);
}
export type GetJobsitePulseVideoFilesQueryHookResult = ReturnType<
  typeof useGetJobsitePulseVideoFilesQuery
>;
export type GetJobsitePulseVideoFilesLazyQueryHookResult = ReturnType<
  typeof useGetJobsitePulseVideoFilesLazyQuery
>;
export type GetJobsitePulseVideoFilesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsitePulseVideoFilesSuspenseQuery
>;
export type GetJobsitePulseVideoFilesQueryResult = Apollo.QueryResult<
  GetJobsitePulseVideoFilesQuery,
  GetJobsitePulseVideoFilesQueryVariables
>;
export const GetJobsitePulseVideosDocument = gql`
  query GetJobsitePulseVideos(
    $jobsiteId: ID!
    $startTime: Date
    $endTime: Date
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      pulseVideos(startTime: $startTime, endTime: $endTime) {
        avigilonUrl
        sessionToken
        hlsBasicAuth
        cameras {
          deviceId
          name
          oldestRecording
          setupStatus
          sources
        }
      }
    }
  }
`;

/**
 * __useGetJobsitePulseVideosQuery__
 *
 * To run a query within a React component, call `useGetJobsitePulseVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsitePulseVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsitePulseVideosQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetJobsitePulseVideosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsitePulseVideosQuery,
    GetJobsitePulseVideosQueryVariables
  > &
    (
      | { variables: GetJobsitePulseVideosQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsitePulseVideosQuery,
    GetJobsitePulseVideosQueryVariables
  >(GetJobsitePulseVideosDocument, options);
}
export function useGetJobsitePulseVideosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsitePulseVideosQuery,
    GetJobsitePulseVideosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsitePulseVideosQuery,
    GetJobsitePulseVideosQueryVariables
  >(GetJobsitePulseVideosDocument, options);
}
export function useGetJobsitePulseVideosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsitePulseVideosQuery,
    GetJobsitePulseVideosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsitePulseVideosQuery,
    GetJobsitePulseVideosQueryVariables
  >(GetJobsitePulseVideosDocument, options);
}
export type GetJobsitePulseVideosQueryHookResult = ReturnType<
  typeof useGetJobsitePulseVideosQuery
>;
export type GetJobsitePulseVideosLazyQueryHookResult = ReturnType<
  typeof useGetJobsitePulseVideosLazyQuery
>;
export type GetJobsitePulseVideosSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsitePulseVideosSuspenseQuery
>;
export type GetJobsitePulseVideosQueryResult = Apollo.QueryResult<
  GetJobsitePulseVideosQuery,
  GetJobsitePulseVideosQueryVariables
>;
export const ChangeScheduleStatusDocument = gql`
  mutation ChangeScheduleStatus($input: ChangeScheduleStatusInput!) {
    changeScheduleStatus(input: $input) {
      schedule {
        id
        status
      }
    }
  }
`;
export type ChangeScheduleStatusMutationFn = Apollo.MutationFunction<
  ChangeScheduleStatusMutation,
  ChangeScheduleStatusMutationVariables
>;

/**
 * __useChangeScheduleStatusMutation__
 *
 * To run a mutation, you first call `useChangeScheduleStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeScheduleStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeScheduleStatusMutation, { data, loading, error }] = useChangeScheduleStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeScheduleStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeScheduleStatusMutation,
    ChangeScheduleStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeScheduleStatusMutation,
    ChangeScheduleStatusMutationVariables
  >(ChangeScheduleStatusDocument, options);
}
export type ChangeScheduleStatusMutationHookResult = ReturnType<
  typeof useChangeScheduleStatusMutation
>;
export type ChangeScheduleStatusMutationResult =
  Apollo.MutationResult<ChangeScheduleStatusMutation>;
export type ChangeScheduleStatusMutationOptions = Apollo.BaseMutationOptions<
  ChangeScheduleStatusMutation,
  ChangeScheduleStatusMutationVariables
>;
export const CreateScheduleShiftDocument = gql`
  mutation CreateScheduleShift($input: CreateScheduleShiftInput!) {
    createScheduleShift(input: $input) {
      scheduleShift {
        id
        duration
        startTime
      }
    }
  }
`;
export type CreateScheduleShiftMutationFn = Apollo.MutationFunction<
  CreateScheduleShiftMutation,
  CreateScheduleShiftMutationVariables
>;

/**
 * __useCreateScheduleShiftMutation__
 *
 * To run a mutation, you first call `useCreateScheduleShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleShiftMutation, { data, loading, error }] = useCreateScheduleShiftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScheduleShiftMutation,
    CreateScheduleShiftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateScheduleShiftMutation,
    CreateScheduleShiftMutationVariables
  >(CreateScheduleShiftDocument, options);
}
export type CreateScheduleShiftMutationHookResult = ReturnType<
  typeof useCreateScheduleShiftMutation
>;
export type CreateScheduleShiftMutationResult =
  Apollo.MutationResult<CreateScheduleShiftMutation>;
export type CreateScheduleShiftMutationOptions = Apollo.BaseMutationOptions<
  CreateScheduleShiftMutation,
  CreateScheduleShiftMutationVariables
>;
export const CreateScheduleWorkerDocument = gql`
  mutation CreateScheduleWorker($input: CreateScheduleWorkerInput!) {
    createScheduleWorker(input: $input) {
      scheduleWorker {
        id
      }
    }
  }
`;
export type CreateScheduleWorkerMutationFn = Apollo.MutationFunction<
  CreateScheduleWorkerMutation,
  CreateScheduleWorkerMutationVariables
>;

/**
 * __useCreateScheduleWorkerMutation__
 *
 * To run a mutation, you first call `useCreateScheduleWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleWorkerMutation, { data, loading, error }] = useCreateScheduleWorkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateScheduleWorkerMutation,
    CreateScheduleWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateScheduleWorkerMutation,
    CreateScheduleWorkerMutationVariables
  >(CreateScheduleWorkerDocument, options);
}
export type CreateScheduleWorkerMutationHookResult = ReturnType<
  typeof useCreateScheduleWorkerMutation
>;
export type CreateScheduleWorkerMutationResult =
  Apollo.MutationResult<CreateScheduleWorkerMutation>;
export type CreateScheduleWorkerMutationOptions = Apollo.BaseMutationOptions<
  CreateScheduleWorkerMutation,
  CreateScheduleWorkerMutationVariables
>;
export const DeleteScheduleShiftDocument = gql`
  mutation DeleteScheduleShift($id: ID!) {
    deleteScheduleShift(id: $id) {
      success {
        success
      }
    }
  }
`;
export type DeleteScheduleShiftMutationFn = Apollo.MutationFunction<
  DeleteScheduleShiftMutation,
  DeleteScheduleShiftMutationVariables
>;

/**
 * __useDeleteScheduleShiftMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleShiftMutation, { data, loading, error }] = useDeleteScheduleShiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteScheduleShiftMutation,
    DeleteScheduleShiftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteScheduleShiftMutation,
    DeleteScheduleShiftMutationVariables
  >(DeleteScheduleShiftDocument, options);
}
export type DeleteScheduleShiftMutationHookResult = ReturnType<
  typeof useDeleteScheduleShiftMutation
>;
export type DeleteScheduleShiftMutationResult =
  Apollo.MutationResult<DeleteScheduleShiftMutation>;
export type DeleteScheduleShiftMutationOptions = Apollo.BaseMutationOptions<
  DeleteScheduleShiftMutation,
  DeleteScheduleShiftMutationVariables
>;
export const DeleteScheduleWorkerDocument = gql`
  mutation DeleteScheduleWorker($id: ID!) {
    deleteScheduleWorker(id: $id) {
      success {
        success
      }
    }
  }
`;
export type DeleteScheduleWorkerMutationFn = Apollo.MutationFunction<
  DeleteScheduleWorkerMutation,
  DeleteScheduleWorkerMutationVariables
>;

/**
 * __useDeleteScheduleWorkerMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleWorkerMutation, { data, loading, error }] = useDeleteScheduleWorkerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScheduleWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteScheduleWorkerMutation,
    DeleteScheduleWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteScheduleWorkerMutation,
    DeleteScheduleWorkerMutationVariables
  >(DeleteScheduleWorkerDocument, options);
}
export type DeleteScheduleWorkerMutationHookResult = ReturnType<
  typeof useDeleteScheduleWorkerMutation
>;
export type DeleteScheduleWorkerMutationResult =
  Apollo.MutationResult<DeleteScheduleWorkerMutation>;
export type DeleteScheduleWorkerMutationOptions = Apollo.BaseMutationOptions<
  DeleteScheduleWorkerMutation,
  DeleteScheduleWorkerMutationVariables
>;
export const SendScheduleNotificationsDocument = gql`
  mutation SendScheduleNotifications($input: SendScheduleNotificationsInput!) {
    sendScheduleNotifications(input: $input) {
      schedule {
        id
      }
    }
  }
`;
export type SendScheduleNotificationsMutationFn = Apollo.MutationFunction<
  SendScheduleNotificationsMutation,
  SendScheduleNotificationsMutationVariables
>;

/**
 * __useSendScheduleNotificationsMutation__
 *
 * To run a mutation, you first call `useSendScheduleNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendScheduleNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendScheduleNotificationsMutation, { data, loading, error }] = useSendScheduleNotificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendScheduleNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendScheduleNotificationsMutation,
    SendScheduleNotificationsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendScheduleNotificationsMutation,
    SendScheduleNotificationsMutationVariables
  >(SendScheduleNotificationsDocument, options);
}
export type SendScheduleNotificationsMutationHookResult = ReturnType<
  typeof useSendScheduleNotificationsMutation
>;
export type SendScheduleNotificationsMutationResult =
  Apollo.MutationResult<SendScheduleNotificationsMutation>;
export type SendScheduleNotificationsMutationOptions =
  Apollo.BaseMutationOptions<
    SendScheduleNotificationsMutation,
    SendScheduleNotificationsMutationVariables
  >;
export const UpdateScheduleShiftDocument = gql`
  mutation UpdateScheduleShift($input: UpdateScheduleShiftInput!) {
    updateScheduleShift(input: $input) {
      scheduleShift {
        id
      }
    }
  }
`;
export type UpdateScheduleShiftMutationFn = Apollo.MutationFunction<
  UpdateScheduleShiftMutation,
  UpdateScheduleShiftMutationVariables
>;

/**
 * __useUpdateScheduleShiftMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleShiftMutation, { data, loading, error }] = useUpdateScheduleShiftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleShiftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScheduleShiftMutation,
    UpdateScheduleShiftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateScheduleShiftMutation,
    UpdateScheduleShiftMutationVariables
  >(UpdateScheduleShiftDocument, options);
}
export type UpdateScheduleShiftMutationHookResult = ReturnType<
  typeof useUpdateScheduleShiftMutation
>;
export type UpdateScheduleShiftMutationResult =
  Apollo.MutationResult<UpdateScheduleShiftMutation>;
export type UpdateScheduleShiftMutationOptions = Apollo.BaseMutationOptions<
  UpdateScheduleShiftMutation,
  UpdateScheduleShiftMutationVariables
>;
export const UpdateScheduleWorkerDocument = gql`
  mutation UpdateScheduleWorker($input: UpdateScheduleWorkerInput!) {
    updateScheduleWorker(input: $input) {
      scheduleWorker {
        id
      }
    }
  }
`;
export type UpdateScheduleWorkerMutationFn = Apollo.MutationFunction<
  UpdateScheduleWorkerMutation,
  UpdateScheduleWorkerMutationVariables
>;

/**
 * __useUpdateScheduleWorkerMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleWorkerMutation, { data, loading, error }] = useUpdateScheduleWorkerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateScheduleWorkerMutation,
    UpdateScheduleWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateScheduleWorkerMutation,
    UpdateScheduleWorkerMutationVariables
  >(UpdateScheduleWorkerDocument, options);
}
export type UpdateScheduleWorkerMutationHookResult = ReturnType<
  typeof useUpdateScheduleWorkerMutation
>;
export type UpdateScheduleWorkerMutationResult =
  Apollo.MutationResult<UpdateScheduleWorkerMutation>;
export type UpdateScheduleWorkerMutationOptions = Apollo.BaseMutationOptions<
  UpdateScheduleWorkerMutation,
  UpdateScheduleWorkerMutationVariables
>;
export const GetScheduleDetailsDocument = gql`
  query GetScheduleDetails(
    $scheduleInput: ScheduleInput!
    $attendanceInput: ScheduleAttendanceFilterInput
  ) {
    getSchedule(input: $scheduleInput) {
      id
      date
      status
      notifiedAt
      jobsite {
        jobsiteId
        name
        tradeOptions
        activityCodeOptions
        developer {
          developerId
          organization {
            organizationId
            name
          }
        }
      }
      shifts {
        id
        startTime
        duration
        workers {
          count
          edges {
            node {
              id
              quantity
              type
              trade
              activity
              notes
              jobsiteContractor {
                ...ScheduleJobsiteContractorField
              }
              jobsiteWorker {
                ...ScheduleJobsiteWorkerField
              }
            }
          }
        }
        attendance(input: $attendanceInput) {
          count
          edges {
            node {
              id
              status
              jobsiteContractor {
                ...ScheduleJobsiteContractorField
              }
              jobsiteWorker {
                ...ScheduleJobsiteWorkerField
              }
              scheduleWorker {
                id
                trade
                activity
                notes
                jobsiteContractor {
                  ...ScheduleJobsiteContractorField
                }
                jobsiteWorker {
                  ...ScheduleJobsiteWorkerField
                }
              }
              session {
                sessionId
                proximitySession {
                  id
                  active
                  compliant
                  closed
                  locale {
                    time {
                      start
                      end
                    }
                  }
                  span {
                    hours
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${ScheduleJobsiteContractorFieldFragmentDoc}
  ${ScheduleJobsiteWorkerFieldFragmentDoc}
`;

/**
 * __useGetScheduleDetailsQuery__
 *
 * To run a query within a React component, call `useGetScheduleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleDetailsQuery({
 *   variables: {
 *      scheduleInput: // value for 'scheduleInput'
 *      attendanceInput: // value for 'attendanceInput'
 *   },
 * });
 */
export function useGetScheduleDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScheduleDetailsQuery,
    GetScheduleDetailsQueryVariables
  > &
    (
      | { variables: GetScheduleDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduleDetailsQuery,
    GetScheduleDetailsQueryVariables
  >(GetScheduleDetailsDocument, options);
}
export function useGetScheduleDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduleDetailsQuery,
    GetScheduleDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduleDetailsQuery,
    GetScheduleDetailsQueryVariables
  >(GetScheduleDetailsDocument, options);
}
export function useGetScheduleDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetScheduleDetailsQuery,
    GetScheduleDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScheduleDetailsQuery,
    GetScheduleDetailsQueryVariables
  >(GetScheduleDetailsDocument, options);
}
export type GetScheduleDetailsQueryHookResult = ReturnType<
  typeof useGetScheduleDetailsQuery
>;
export type GetScheduleDetailsLazyQueryHookResult = ReturnType<
  typeof useGetScheduleDetailsLazyQuery
>;
export type GetScheduleDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetScheduleDetailsSuspenseQuery
>;
export type GetScheduleDetailsQueryResult = Apollo.QueryResult<
  GetScheduleDetailsQuery,
  GetScheduleDetailsQueryVariables
>;
export const GetScheduleNotificationPreviewDocument = gql`
  query GetScheduleNotificationPreview($scheduleId: ID!) {
    getScheduleNotificationPreview(id: $scheduleId) {
      body
      subject
      recipient
      to
    }
  }
`;

/**
 * __useGetScheduleNotificationPreviewQuery__
 *
 * To run a query within a React component, call `useGetScheduleNotificationPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleNotificationPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleNotificationPreviewQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useGetScheduleNotificationPreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScheduleNotificationPreviewQuery,
    GetScheduleNotificationPreviewQueryVariables
  > &
    (
      | {
          variables: GetScheduleNotificationPreviewQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduleNotificationPreviewQuery,
    GetScheduleNotificationPreviewQueryVariables
  >(GetScheduleNotificationPreviewDocument, options);
}
export function useGetScheduleNotificationPreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduleNotificationPreviewQuery,
    GetScheduleNotificationPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduleNotificationPreviewQuery,
    GetScheduleNotificationPreviewQueryVariables
  >(GetScheduleNotificationPreviewDocument, options);
}
export function useGetScheduleNotificationPreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetScheduleNotificationPreviewQuery,
    GetScheduleNotificationPreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScheduleNotificationPreviewQuery,
    GetScheduleNotificationPreviewQueryVariables
  >(GetScheduleNotificationPreviewDocument, options);
}
export type GetScheduleNotificationPreviewQueryHookResult = ReturnType<
  typeof useGetScheduleNotificationPreviewQuery
>;
export type GetScheduleNotificationPreviewLazyQueryHookResult = ReturnType<
  typeof useGetScheduleNotificationPreviewLazyQuery
>;
export type GetScheduleNotificationPreviewSuspenseQueryHookResult = ReturnType<
  typeof useGetScheduleNotificationPreviewSuspenseQuery
>;
export type GetScheduleNotificationPreviewQueryResult = Apollo.QueryResult<
  GetScheduleNotificationPreviewQuery,
  GetScheduleNotificationPreviewQueryVariables
>;
export const GetJobsiteContainerTempBadgesDocument = gql`
  query GetJobsiteContainerTempBadges(
    $jobsiteId: ID!
    $jobsiteTempBadgesInput: TempBadgesInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      tempBadges(input: $jobsiteTempBadgesInput) {
        count
        edges {
          node {
            id
            name
            cardNumber
            status
            badgeTemplate {
              templateName
            }
            jobsiteCardFormat {
              jobsiteCardFormatId
              workerCardFormat {
                workerCardFormatId
                name
                description
                cardType
                facilityCode
              }
            }
            activeWorkerCard {
              workerCardId
              expiredAt
              worker {
                workerId
                quickCode
                user {
                  userAccountId
                  identity {
                    firstName
                    lastName
                  }
                }
                profilePictureCropped {
                  downloadUrl
                  uploadedAt
                  fileId
                  fileType
                }
              }
            }
            lastPrintJob {
              cardPrintJobId
              startedAt
              status
              statusMessage
              completion {
                cardNumber
                facilityCode
                completedAt
              }
              error {
                code
                erroredAt
                message
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteContainerTempBadgesQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerTempBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerTempBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerTempBadgesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteTempBadgesInput: // value for 'jobsiteTempBadgesInput'
 *   },
 * });
 */
export function useGetJobsiteContainerTempBadgesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerTempBadgesQuery,
    GetJobsiteContainerTempBadgesQueryVariables
  > &
    (
      | {
          variables: GetJobsiteContainerTempBadgesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerTempBadgesQuery,
    GetJobsiteContainerTempBadgesQueryVariables
  >(GetJobsiteContainerTempBadgesDocument, options);
}
export function useGetJobsiteContainerTempBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerTempBadgesQuery,
    GetJobsiteContainerTempBadgesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerTempBadgesQuery,
    GetJobsiteContainerTempBadgesQueryVariables
  >(GetJobsiteContainerTempBadgesDocument, options);
}
export function useGetJobsiteContainerTempBadgesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerTempBadgesQuery,
    GetJobsiteContainerTempBadgesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerTempBadgesQuery,
    GetJobsiteContainerTempBadgesQueryVariables
  >(GetJobsiteContainerTempBadgesDocument, options);
}
export type GetJobsiteContainerTempBadgesQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerTempBadgesQuery
>;
export type GetJobsiteContainerTempBadgesLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerTempBadgesLazyQuery
>;
export type GetJobsiteContainerTempBadgesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerTempBadgesSuspenseQuery
>;
export type GetJobsiteContainerTempBadgesQueryResult = Apollo.QueryResult<
  GetJobsiteContainerTempBadgesQuery,
  GetJobsiteContainerTempBadgesQueryVariables
>;
export const DeactivateTempBadgeDocument = gql`
  mutation DeactivateTempBadge($id: ID!) {
    deactivateTempBadge(id: $id) {
      tempBadge {
        id
        name
        cardNumber
        status
        jobsiteCardFormat {
          jobsiteCardFormatId
          workerCardFormat {
            workerCardFormatId
            name
            description
            cardType
            facilityCode
          }
        }
      }
    }
  }
`;
export type DeactivateTempBadgeMutationFn = Apollo.MutationFunction<
  DeactivateTempBadgeMutation,
  DeactivateTempBadgeMutationVariables
>;

/**
 * __useDeactivateTempBadgeMutation__
 *
 * To run a mutation, you first call `useDeactivateTempBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTempBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTempBadgeMutation, { data, loading, error }] = useDeactivateTempBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateTempBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateTempBadgeMutation,
    DeactivateTempBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeactivateTempBadgeMutation,
    DeactivateTempBadgeMutationVariables
  >(DeactivateTempBadgeDocument, options);
}
export type DeactivateTempBadgeMutationHookResult = ReturnType<
  typeof useDeactivateTempBadgeMutation
>;
export type DeactivateTempBadgeMutationResult =
  Apollo.MutationResult<DeactivateTempBadgeMutation>;
export type DeactivateTempBadgeMutationOptions = Apollo.BaseMutationOptions<
  DeactivateTempBadgeMutation,
  DeactivateTempBadgeMutationVariables
>;
export const ReturnTempBadgeDocument = gql`
  mutation ReturnTempBadge($id: ID!) {
    returnTempBadge(id: $id) {
      tempBadge {
        id
        name
        cardNumber
        status
        jobsiteCardFormat {
          jobsiteCardFormatId
          workerCardFormat {
            workerCardFormatId
            name
            description
            cardType
            facilityCode
          }
        }
      }
    }
  }
`;
export type ReturnTempBadgeMutationFn = Apollo.MutationFunction<
  ReturnTempBadgeMutation,
  ReturnTempBadgeMutationVariables
>;

/**
 * __useReturnTempBadgeMutation__
 *
 * To run a mutation, you first call `useReturnTempBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnTempBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnTempBadgeMutation, { data, loading, error }] = useReturnTempBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReturnTempBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReturnTempBadgeMutation,
    ReturnTempBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReturnTempBadgeMutation,
    ReturnTempBadgeMutationVariables
  >(ReturnTempBadgeDocument, options);
}
export type ReturnTempBadgeMutationHookResult = ReturnType<
  typeof useReturnTempBadgeMutation
>;
export type ReturnTempBadgeMutationResult =
  Apollo.MutationResult<ReturnTempBadgeMutation>;
export type ReturnTempBadgeMutationOptions = Apollo.BaseMutationOptions<
  ReturnTempBadgeMutation,
  ReturnTempBadgeMutationVariables
>;
export const AssignTempBadgeDocument = gql`
  mutation AssignTempBadge($input: AssignTempBadgeInput!) {
    assignTempBadge(input: $input) {
      tempBadge {
        id
        name
        cardNumber
        status
        badgeTemplate {
          templateName
        }
        jobsiteCardFormat {
          jobsiteCardFormatId
          workerCardFormat {
            workerCardFormatId
            name
            description
            cardType
            facilityCode
          }
        }
      }
    }
  }
`;
export type AssignTempBadgeMutationFn = Apollo.MutationFunction<
  AssignTempBadgeMutation,
  AssignTempBadgeMutationVariables
>;

/**
 * __useAssignTempBadgeMutation__
 *
 * To run a mutation, you first call `useAssignTempBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTempBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTempBadgeMutation, { data, loading, error }] = useAssignTempBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTempBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignTempBadgeMutation,
    AssignTempBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignTempBadgeMutation,
    AssignTempBadgeMutationVariables
  >(AssignTempBadgeDocument, options);
}
export type AssignTempBadgeMutationHookResult = ReturnType<
  typeof useAssignTempBadgeMutation
>;
export type AssignTempBadgeMutationResult =
  Apollo.MutationResult<AssignTempBadgeMutation>;
export type AssignTempBadgeMutationOptions = Apollo.BaseMutationOptions<
  AssignTempBadgeMutation,
  AssignTempBadgeMutationVariables
>;
export const CreateAndPrintTempBadgeDocument = gql`
  mutation CreateAndPrintTempBadge($input: CreateTempBadgeInput!) {
    createAndPrintTempBadge(input: $input) {
      tempBadge {
        id
        name
        cardNumber
        status
        badgeTemplate {
          templateName
        }
        jobsiteCardFormat {
          jobsiteCardFormatId
          workerCardFormat {
            workerCardFormatId
            name
            description
            cardType
            facilityCode
          }
        }
        lastPrintJob {
          cardPrintJobId
          startedAt
          status
          statusMessage
          completion {
            cardNumber
            facilityCode
            completedAt
          }
          error {
            code
            erroredAt
            message
          }
        }
      }
    }
  }
`;
export type CreateAndPrintTempBadgeMutationFn = Apollo.MutationFunction<
  CreateAndPrintTempBadgeMutation,
  CreateAndPrintTempBadgeMutationVariables
>;

/**
 * __useCreateAndPrintTempBadgeMutation__
 *
 * To run a mutation, you first call `useCreateAndPrintTempBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndPrintTempBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndPrintTempBadgeMutation, { data, loading, error }] = useCreateAndPrintTempBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAndPrintTempBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAndPrintTempBadgeMutation,
    CreateAndPrintTempBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAndPrintTempBadgeMutation,
    CreateAndPrintTempBadgeMutationVariables
  >(CreateAndPrintTempBadgeDocument, options);
}
export type CreateAndPrintTempBadgeMutationHookResult = ReturnType<
  typeof useCreateAndPrintTempBadgeMutation
>;
export type CreateAndPrintTempBadgeMutationResult =
  Apollo.MutationResult<CreateAndPrintTempBadgeMutation>;
export type CreateAndPrintTempBadgeMutationOptions = Apollo.BaseMutationOptions<
  CreateAndPrintTempBadgeMutation,
  CreateAndPrintTempBadgeMutationVariables
>;
export const GetPrintingTempBadgeDocument = gql`
  query GetPrintingTempBadge($id: ID!) {
    getTempBadge(id: $id) {
      id
      name
      cardNumber
      status
      badgeTemplate {
        templateName
      }
      jobsiteCardFormat {
        jobsiteCardFormatId
        workerCardFormat {
          workerCardFormatId
          name
          description
          cardType
          facilityCode
        }
      }
      activeWorkerCard {
        workerCardId
        expiredAt
        worker {
          workerId
          quickCode
          user {
            userAccountId
            identity {
              firstName
              lastName
            }
          }
          profilePictureCropped {
            downloadUrl
            uploadedAt
            fileId
            fileType
          }
        }
      }
      lastPrintJob {
        cardPrintJobId
        startedAt
        status
        statusMessage
        completion {
          cardNumber
          facilityCode
          completedAt
        }
        error {
          code
          erroredAt
          message
        }
      }
    }
  }
`;

/**
 * __useGetPrintingTempBadgeQuery__
 *
 * To run a query within a React component, call `useGetPrintingTempBadgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintingTempBadgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintingTempBadgeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPrintingTempBadgeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPrintingTempBadgeQuery,
    GetPrintingTempBadgeQueryVariables
  > &
    (
      | { variables: GetPrintingTempBadgeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPrintingTempBadgeQuery,
    GetPrintingTempBadgeQueryVariables
  >(GetPrintingTempBadgeDocument, options);
}
export function useGetPrintingTempBadgeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPrintingTempBadgeQuery,
    GetPrintingTempBadgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPrintingTempBadgeQuery,
    GetPrintingTempBadgeQueryVariables
  >(GetPrintingTempBadgeDocument, options);
}
export function useGetPrintingTempBadgeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPrintingTempBadgeQuery,
    GetPrintingTempBadgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPrintingTempBadgeQuery,
    GetPrintingTempBadgeQueryVariables
  >(GetPrintingTempBadgeDocument, options);
}
export type GetPrintingTempBadgeQueryHookResult = ReturnType<
  typeof useGetPrintingTempBadgeQuery
>;
export type GetPrintingTempBadgeLazyQueryHookResult = ReturnType<
  typeof useGetPrintingTempBadgeLazyQuery
>;
export type GetPrintingTempBadgeSuspenseQueryHookResult = ReturnType<
  typeof useGetPrintingTempBadgeSuspenseQuery
>;
export type GetPrintingTempBadgeQueryResult = Apollo.QueryResult<
  GetPrintingTempBadgeQuery,
  GetPrintingTempBadgeQueryVariables
>;
export const ReprintTempBadgeDocument = gql`
  mutation ReprintTempBadge($input: ReprintTempBadgeInput!) {
    reprintTempBadge(input: $input) {
      tempBadge {
        id
        name
        cardNumber
        status
        badgeTemplate {
          templateName
        }
        jobsiteCardFormat {
          jobsiteCardFormatId
          workerCardFormat {
            workerCardFormatId
            name
            description
            cardType
            facilityCode
          }
        }
        lastPrintJob {
          cardPrintJobId
          startedAt
          status
          statusMessage
          completion {
            cardNumber
            facilityCode
            completedAt
          }
          error {
            code
            erroredAt
            message
          }
        }
      }
    }
  }
`;
export type ReprintTempBadgeMutationFn = Apollo.MutationFunction<
  ReprintTempBadgeMutation,
  ReprintTempBadgeMutationVariables
>;

/**
 * __useReprintTempBadgeMutation__
 *
 * To run a mutation, you first call `useReprintTempBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprintTempBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprintTempBadgeMutation, { data, loading, error }] = useReprintTempBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReprintTempBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReprintTempBadgeMutation,
    ReprintTempBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReprintTempBadgeMutation,
    ReprintTempBadgeMutationVariables
  >(ReprintTempBadgeDocument, options);
}
export type ReprintTempBadgeMutationHookResult = ReturnType<
  typeof useReprintTempBadgeMutation
>;
export type ReprintTempBadgeMutationResult =
  Apollo.MutationResult<ReprintTempBadgeMutation>;
export type ReprintTempBadgeMutationOptions = Apollo.BaseMutationOptions<
  ReprintTempBadgeMutation,
  ReprintTempBadgeMutationVariables
>;
export const ReactivateTempBadgeDocument = gql`
  mutation ReactivateTempBadge($id: ID!) {
    reactivateTempBadge(id: $id) {
      tempBadge {
        id
        name
        cardNumber
        status
        badgeTemplate {
          templateName
        }
        jobsiteCardFormat {
          jobsiteCardFormatId
          workerCardFormat {
            workerCardFormatId
            name
            description
            cardType
            facilityCode
          }
        }
      }
    }
  }
`;
export type ReactivateTempBadgeMutationFn = Apollo.MutationFunction<
  ReactivateTempBadgeMutation,
  ReactivateTempBadgeMutationVariables
>;

/**
 * __useReactivateTempBadgeMutation__
 *
 * To run a mutation, you first call `useReactivateTempBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateTempBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateTempBadgeMutation, { data, loading, error }] = useReactivateTempBadgeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateTempBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReactivateTempBadgeMutation,
    ReactivateTempBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReactivateTempBadgeMutation,
    ReactivateTempBadgeMutationVariables
  >(ReactivateTempBadgeDocument, options);
}
export type ReactivateTempBadgeMutationHookResult = ReturnType<
  typeof useReactivateTempBadgeMutation
>;
export type ReactivateTempBadgeMutationResult =
  Apollo.MutationResult<ReactivateTempBadgeMutation>;
export type ReactivateTempBadgeMutationOptions = Apollo.BaseMutationOptions<
  ReactivateTempBadgeMutation,
  ReactivateTempBadgeMutationVariables
>;
export const RegisterTempBadgeDocument = gql`
  mutation RegisterTempBadge($input: RegisterTempBadgeInput!) {
    registerTempBadge(input: $input) {
      tempBadge {
        id
        name
        cardNumber
        status
        badgeTemplate {
          templateName
        }
        jobsiteCardFormat {
          jobsiteCardFormatId
          workerCardFormat {
            workerCardFormatId
            name
            description
            cardType
            facilityCode
          }
        }
      }
    }
  }
`;
export type RegisterTempBadgeMutationFn = Apollo.MutationFunction<
  RegisterTempBadgeMutation,
  RegisterTempBadgeMutationVariables
>;

/**
 * __useRegisterTempBadgeMutation__
 *
 * To run a mutation, you first call `useRegisterTempBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterTempBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerTempBadgeMutation, { data, loading, error }] = useRegisterTempBadgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterTempBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterTempBadgeMutation,
    RegisterTempBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RegisterTempBadgeMutation,
    RegisterTempBadgeMutationVariables
  >(RegisterTempBadgeDocument, options);
}
export type RegisterTempBadgeMutationHookResult = ReturnType<
  typeof useRegisterTempBadgeMutation
>;
export type RegisterTempBadgeMutationResult =
  Apollo.MutationResult<RegisterTempBadgeMutation>;
export type RegisterTempBadgeMutationOptions = Apollo.BaseMutationOptions<
  RegisterTempBadgeMutation,
  RegisterTempBadgeMutationVariables
>;
export const GetJobsiteContainerMembersDocument = gql`
  query GetJobsiteContainerMembers(
    $jobsiteId: ID!
    $jobsiteJobsiteMembersInput: JobsiteJobsiteMembersInput
    $userRolesInput: UserRolesInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      jobsiteMembers(input: $jobsiteJobsiteMembersInput) {
        count
        edges {
          node {
            id
            user {
              userAccountId
              roles(input: $userRolesInput) {
                key
                displayName
                object {
                  objectId
                  objectDetails {
                    name
                  }
                }
              }
              identity {
                firstName
                lastName
                email
                phoneNumber
              }
              worker {
                workerId
                profilePictureCropped {
                  downloadUrl
                }
              }
              lastSession {
                createdAt
                appVersion
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteContainerMembersQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerMembersQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteJobsiteMembersInput: // value for 'jobsiteJobsiteMembersInput'
 *      userRolesInput: // value for 'userRolesInput'
 *   },
 * });
 */
export function useGetJobsiteContainerMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerMembersQuery,
    GetJobsiteContainerMembersQueryVariables
  > &
    (
      | { variables: GetJobsiteContainerMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerMembersQuery,
    GetJobsiteContainerMembersQueryVariables
  >(GetJobsiteContainerMembersDocument, options);
}
export function useGetJobsiteContainerMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerMembersQuery,
    GetJobsiteContainerMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerMembersQuery,
    GetJobsiteContainerMembersQueryVariables
  >(GetJobsiteContainerMembersDocument, options);
}
export function useGetJobsiteContainerMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerMembersQuery,
    GetJobsiteContainerMembersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerMembersQuery,
    GetJobsiteContainerMembersQueryVariables
  >(GetJobsiteContainerMembersDocument, options);
}
export type GetJobsiteContainerMembersQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerMembersQuery
>;
export type GetJobsiteContainerMembersLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerMembersLazyQuery
>;
export type GetJobsiteContainerMembersSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerMembersSuspenseQuery
>;
export type GetJobsiteContainerMembersQueryResult = Apollo.QueryResult<
  GetJobsiteContainerMembersQuery,
  GetJobsiteContainerMembersQueryVariables
>;
export const GetJobsiteContainerWorkersDocument = gql`
  query GetJobsiteContainerWorkers(
    $jobsiteId: ID!
    $jobsiteJobsiteWorkersInput: JobsiteJobsiteWorkersInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      jobsiteWorkers(input: $jobsiteJobsiteWorkersInput) {
        count
        edges {
          node {
            jobsiteWorkerId
            currentAccess {
              isAllowed
              notAllowedReason
              startDate
              endDate
            }
            contractorWorker {
              worker {
                workerId
                birthDate
                quickCode
                user {
                  userAccountId
                  identity {
                    firstName
                    lastName
                    email
                  }
                }
                profilePicture {
                  downloadUrl
                  uploadedAt
                  fileId
                }
                profilePictureCropped {
                  downloadUrl
                  uploadedAt
                  fileId
                  fileType
                }
                workerCards {
                  edges {
                    node {
                      workerCardId
                      cardNumber
                      cardStatus
                    }
                  }
                }
                jobsiteWorkers {
                  count
                  edges {
                    node {
                      jobsiteWorkerId
                      trade
                      jobsiteContractor {
                        jobsite {
                          jobsiteId
                          name
                        }
                        contractor {
                          contractorId
                          organization {
                            name
                          }
                        }
                      }
                      currentAccess {
                        isAllowed
                        notAllowedReason
                        startDate
                        endDate
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteContainerWorkersQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContainerWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContainerWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContainerWorkersQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteJobsiteWorkersInput: // value for 'jobsiteJobsiteWorkersInput'
 *   },
 * });
 */
export function useGetJobsiteContainerWorkersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContainerWorkersQuery,
    GetJobsiteContainerWorkersQueryVariables
  > &
    (
      | { variables: GetJobsiteContainerWorkersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContainerWorkersQuery,
    GetJobsiteContainerWorkersQueryVariables
  >(GetJobsiteContainerWorkersDocument, options);
}
export function useGetJobsiteContainerWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContainerWorkersQuery,
    GetJobsiteContainerWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContainerWorkersQuery,
    GetJobsiteContainerWorkersQueryVariables
  >(GetJobsiteContainerWorkersDocument, options);
}
export function useGetJobsiteContainerWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContainerWorkersQuery,
    GetJobsiteContainerWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContainerWorkersQuery,
    GetJobsiteContainerWorkersQueryVariables
  >(GetJobsiteContainerWorkersDocument, options);
}
export type GetJobsiteContainerWorkersQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerWorkersQuery
>;
export type GetJobsiteContainerWorkersLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerWorkersLazyQuery
>;
export type GetJobsiteContainerWorkersSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContainerWorkersSuspenseQuery
>;
export type GetJobsiteContainerWorkersQueryResult = Apollo.QueryResult<
  GetJobsiteContainerWorkersQuery,
  GetJobsiteContainerWorkersQueryVariables
>;
export const GetJobsiteAccessActivityCurrentSessionDocument = gql`
  query GetJobsiteAccessActivityCurrentSession(
    $jobsiteAccessEventsInput: JobsiteAccessEventsInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        jobsiteAccessEvents(input: $jobsiteAccessEventsInput) {
          count
          edges {
            node {
              id
              type
              status
              credentialId
              eventOccurredAt
              localizedDate
              localizedTime
              timeZone
              rejectionReason
              message
              gateway
              zoneCrossing {
                kind
                revisionId
                entryId
                entrySideId
                reason
                from {
                  kind
                  zoneId
                  name
                }
                to {
                  kind
                  zoneId
                  name
                }
              }
              overnightSession
              jobsite {
                jobsiteId
                name
              }
              jobsiteWorker {
                jobsiteWorkerId
                jobsiteContractor {
                  id
                  contractor {
                    contractorId
                    organization {
                      organizationId
                      name
                    }
                  }
                }
                currentAccess {
                  isAllowed
                }
              }
              direction
              externalId
              eventType
              worker {
                workerId
                user {
                  userAccountId
                  identity {
                    firstName
                    lastName
                  }
                }
                profilePictureCropped {
                  downloadUrl
                }
              }
            }
          }
          filtersOptions {
            jobsites {
              value
              label
              count
            }
            contractors {
              value
              label
              count
            }
            zones {
              value
              label
            }
            gateways {
              value
              label
              count
            }
            rejectionReasons {
              value
              label
              count
            }
            locationStatuses {
              value
              label
              count
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteAccessActivityCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetJobsiteAccessActivityCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteAccessActivityCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteAccessActivityCurrentSessionQuery({
 *   variables: {
 *      jobsiteAccessEventsInput: // value for 'jobsiteAccessEventsInput'
 *   },
 * });
 */
export function useGetJobsiteAccessActivityCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobsiteAccessActivityCurrentSessionQuery,
    GetJobsiteAccessActivityCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteAccessActivityCurrentSessionQuery,
    GetJobsiteAccessActivityCurrentSessionQueryVariables
  >(GetJobsiteAccessActivityCurrentSessionDocument, options);
}
export function useGetJobsiteAccessActivityCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteAccessActivityCurrentSessionQuery,
    GetJobsiteAccessActivityCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteAccessActivityCurrentSessionQuery,
    GetJobsiteAccessActivityCurrentSessionQueryVariables
  >(GetJobsiteAccessActivityCurrentSessionDocument, options);
}
export function useGetJobsiteAccessActivityCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteAccessActivityCurrentSessionQuery,
    GetJobsiteAccessActivityCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteAccessActivityCurrentSessionQuery,
    GetJobsiteAccessActivityCurrentSessionQueryVariables
  >(GetJobsiteAccessActivityCurrentSessionDocument, options);
}
export type GetJobsiteAccessActivityCurrentSessionQueryHookResult = ReturnType<
  typeof useGetJobsiteAccessActivityCurrentSessionQuery
>;
export type GetJobsiteAccessActivityCurrentSessionLazyQueryHookResult =
  ReturnType<typeof useGetJobsiteAccessActivityCurrentSessionLazyQuery>;
export type GetJobsiteAccessActivityCurrentSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetJobsiteAccessActivityCurrentSessionSuspenseQuery>;
export type GetJobsiteAccessActivityCurrentSessionQueryResult =
  Apollo.QueryResult<
    GetJobsiteAccessActivityCurrentSessionQuery,
    GetJobsiteAccessActivityCurrentSessionQueryVariables
  >;
export const ArchiveJobsiteDocument = gql`
  mutation ArchiveJobsite($jobsiteId: ID!) {
    archiveJobsite(jobsiteId: $jobsiteId) {
      success
    }
  }
`;
export type ArchiveJobsiteMutationFn = Apollo.MutationFunction<
  ArchiveJobsiteMutation,
  ArchiveJobsiteMutationVariables
>;

/**
 * __useArchiveJobsiteMutation__
 *
 * To run a mutation, you first call `useArchiveJobsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJobsiteMutation, { data, loading, error }] = useArchiveJobsiteMutation({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useArchiveJobsiteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveJobsiteMutation,
    ArchiveJobsiteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveJobsiteMutation,
    ArchiveJobsiteMutationVariables
  >(ArchiveJobsiteDocument, options);
}
export type ArchiveJobsiteMutationHookResult = ReturnType<
  typeof useArchiveJobsiteMutation
>;
export type ArchiveJobsiteMutationResult =
  Apollo.MutationResult<ArchiveJobsiteMutation>;
export type ArchiveJobsiteMutationOptions = Apollo.BaseMutationOptions<
  ArchiveJobsiteMutation,
  ArchiveJobsiteMutationVariables
>;
export const JobsiteUpdateDocument = gql`
  mutation JobsiteUpdate($input: JobsiteUpdateInput!) {
    jobsiteUpdate(input: $input) {
      jobsite {
        jobsiteId
      }
    }
  }
`;
export type JobsiteUpdateMutationFn = Apollo.MutationFunction<
  JobsiteUpdateMutation,
  JobsiteUpdateMutationVariables
>;

/**
 * __useJobsiteUpdateMutation__
 *
 * To run a mutation, you first call `useJobsiteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteUpdateMutation, { data, loading, error }] = useJobsiteUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteUpdateMutation,
    JobsiteUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteUpdateMutation,
    JobsiteUpdateMutationVariables
  >(JobsiteUpdateDocument, options);
}
export type JobsiteUpdateMutationHookResult = ReturnType<
  typeof useJobsiteUpdateMutation
>;
export type JobsiteUpdateMutationResult =
  Apollo.MutationResult<JobsiteUpdateMutation>;
export type JobsiteUpdateMutationOptions = Apollo.BaseMutationOptions<
  JobsiteUpdateMutation,
  JobsiteUpdateMutationVariables
>;
export const GetJobsiteConfigAvigilonDocument = gql`
  query GetJobsiteConfigAvigilon($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      avigilonEnabled
      avigilonCameraEnabled
      connectors {
        type
        connectedAt
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigAvigilonQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigAvigilonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigAvigilonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigAvigilonQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigAvigilonQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigAvigilonQuery,
    GetJobsiteConfigAvigilonQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigAvigilonQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigAvigilonQuery,
    GetJobsiteConfigAvigilonQueryVariables
  >(GetJobsiteConfigAvigilonDocument, options);
}
export function useGetJobsiteConfigAvigilonLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigAvigilonQuery,
    GetJobsiteConfigAvigilonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigAvigilonQuery,
    GetJobsiteConfigAvigilonQueryVariables
  >(GetJobsiteConfigAvigilonDocument, options);
}
export function useGetJobsiteConfigAvigilonSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigAvigilonQuery,
    GetJobsiteConfigAvigilonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigAvigilonQuery,
    GetJobsiteConfigAvigilonQueryVariables
  >(GetJobsiteConfigAvigilonDocument, options);
}
export type GetJobsiteConfigAvigilonQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigAvigilonQuery
>;
export type GetJobsiteConfigAvigilonLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigAvigilonLazyQuery
>;
export type GetJobsiteConfigAvigilonSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigAvigilonSuspenseQuery
>;
export type GetJobsiteConfigAvigilonQueryResult = Apollo.QueryResult<
  GetJobsiteConfigAvigilonQuery,
  GetJobsiteConfigAvigilonQueryVariables
>;
export const GetJobsiteConfigCCureDocument = gql`
  query GetJobsiteConfigCCure($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      cCureClearances {
        edges {
          node {
            cCureClearanceId
            name
            cCureClearanceObjectId
            isDefault
            isSelectable
            cCureEnvironment {
              cCureEnvironmentId
              namespace
            }
          }
        }
      }
      cCureEntityMappings {
        edges {
          node {
            objectId
            entityType
            cCureEnvironment {
              cCureEnvironmentId
              namespace
            }
          }
        }
      }
      jobsiteCardFormats {
        edges {
          node {
            jobsiteCardFormatId
            isDefaultForCardType
            workerCardFormat {
              workerCardFormatId
            }
          }
        }
      }
    }
    getCurrentSession {
      user {
        userAccountId
        workerCardFormats {
          edges {
            node {
              workerCardFormatId
              name
              facilityCode
              cardType
            }
          }
        }
        cCureEnvironments {
          edges {
            node {
              cCureEnvironmentId
              namespace
            }
          }
        }
        cCureEntityMappingOptions {
          edges {
            node {
              cCureEnvironment {
                namespace
                cCureEnvironmentId
                instanceSlug
              }
              entityType
              objectId
              name
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigCCureQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigCCureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigCCureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigCCureQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigCCureQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigCCureQuery,
    GetJobsiteConfigCCureQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigCCureQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigCCureQuery,
    GetJobsiteConfigCCureQueryVariables
  >(GetJobsiteConfigCCureDocument, options);
}
export function useGetJobsiteConfigCCureLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigCCureQuery,
    GetJobsiteConfigCCureQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigCCureQuery,
    GetJobsiteConfigCCureQueryVariables
  >(GetJobsiteConfigCCureDocument, options);
}
export function useGetJobsiteConfigCCureSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigCCureQuery,
    GetJobsiteConfigCCureQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigCCureQuery,
    GetJobsiteConfigCCureQueryVariables
  >(GetJobsiteConfigCCureDocument, options);
}
export type GetJobsiteConfigCCureQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigCCureQuery
>;
export type GetJobsiteConfigCCureLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigCCureLazyQuery
>;
export type GetJobsiteConfigCCureSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigCCureSuspenseQuery
>;
export type GetJobsiteConfigCCureQueryResult = Apollo.QueryResult<
  GetJobsiteConfigCCureQuery,
  GetJobsiteConfigCCureQueryVariables
>;
export const GetSiteConnectorsDocument = gql`
  query GetSiteConnectors($siteId: ID!) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      connectors {
        ...ConnectorListItemFields
      }
    }
  }
  ${ConnectorListItemFieldsFragmentDoc}
`;

/**
 * __useGetSiteConnectorsQuery__
 *
 * To run a query within a React component, call `useGetSiteConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteConnectorsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteConnectorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteConnectorsQuery,
    GetSiteConnectorsQueryVariables
  > &
    (
      | { variables: GetSiteConnectorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteConnectorsQuery,
    GetSiteConnectorsQueryVariables
  >(GetSiteConnectorsDocument, options);
}
export function useGetSiteConnectorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteConnectorsQuery,
    GetSiteConnectorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteConnectorsQuery,
    GetSiteConnectorsQueryVariables
  >(GetSiteConnectorsDocument, options);
}
export function useGetSiteConnectorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteConnectorsQuery,
    GetSiteConnectorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteConnectorsQuery,
    GetSiteConnectorsQueryVariables
  >(GetSiteConnectorsDocument, options);
}
export type GetSiteConnectorsQueryHookResult = ReturnType<
  typeof useGetSiteConnectorsQuery
>;
export type GetSiteConnectorsLazyQueryHookResult = ReturnType<
  typeof useGetSiteConnectorsLazyQuery
>;
export type GetSiteConnectorsSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteConnectorsSuspenseQuery
>;
export type GetSiteConnectorsQueryResult = Apollo.QueryResult<
  GetSiteConnectorsQuery,
  GetSiteConnectorsQueryVariables
>;
export const GetConnectorRunsDocument = gql`
  query GetConnectorRuns(
    $connectorId: ID!
    $limit: Int!
    $offset: Int!
    $filter: ConnectorRunFilterInput
  ) {
    connector(id: $connectorId) {
      id
      runs(limit: $limit, offset: $offset, filter: $filter) {
        total
        runs {
          id
          status
          startedAt
          finishedAt
          message
        }
      }
    }
  }
`;

/**
 * __useGetConnectorRunsQuery__
 *
 * To run a query within a React component, call `useGetConnectorRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectorRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectorRunsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetConnectorRunsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConnectorRunsQuery,
    GetConnectorRunsQueryVariables
  > &
    (
      | { variables: GetConnectorRunsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetConnectorRunsQuery, GetConnectorRunsQueryVariables>(
    GetConnectorRunsDocument,
    options,
  );
}
export function useGetConnectorRunsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConnectorRunsQuery,
    GetConnectorRunsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConnectorRunsQuery,
    GetConnectorRunsQueryVariables
  >(GetConnectorRunsDocument, options);
}
export function useGetConnectorRunsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConnectorRunsQuery,
    GetConnectorRunsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetConnectorRunsQuery,
    GetConnectorRunsQueryVariables
  >(GetConnectorRunsDocument, options);
}
export type GetConnectorRunsQueryHookResult = ReturnType<
  typeof useGetConnectorRunsQuery
>;
export type GetConnectorRunsLazyQueryHookResult = ReturnType<
  typeof useGetConnectorRunsLazyQuery
>;
export type GetConnectorRunsSuspenseQueryHookResult = ReturnType<
  typeof useGetConnectorRunsSuspenseQuery
>;
export type GetConnectorRunsQueryResult = Apollo.QueryResult<
  GetConnectorRunsQuery,
  GetConnectorRunsQueryVariables
>;
export const SetConnectorEnabledDocument = gql`
  mutation SetConnectorEnabled($connectorId: ID!, $enabled: Boolean!) {
    setConnectorEnabled(connectorId: $connectorId, enabled: $enabled) {
      id
      status
    }
  }
`;
export type SetConnectorEnabledMutationFn = Apollo.MutationFunction<
  SetConnectorEnabledMutation,
  SetConnectorEnabledMutationVariables
>;

/**
 * __useSetConnectorEnabledMutation__
 *
 * To run a mutation, you first call `useSetConnectorEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConnectorEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConnectorEnabledMutation, { data, loading, error }] = useSetConnectorEnabledMutation({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetConnectorEnabledMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetConnectorEnabledMutation,
    SetConnectorEnabledMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetConnectorEnabledMutation,
    SetConnectorEnabledMutationVariables
  >(SetConnectorEnabledDocument, options);
}
export type SetConnectorEnabledMutationHookResult = ReturnType<
  typeof useSetConnectorEnabledMutation
>;
export type SetConnectorEnabledMutationResult =
  Apollo.MutationResult<SetConnectorEnabledMutation>;
export type SetConnectorEnabledMutationOptions = Apollo.BaseMutationOptions<
  SetConnectorEnabledMutation,
  SetConnectorEnabledMutationVariables
>;
export const GetAvigilonAccessConnectorDetailsDocument = gql`
  query GetAvigilonAccessConnectorDetails($connectorId: ID!) {
    avigilonAccessConnector(id: $connectorId) {
      ...ConnectorDetailsFields
      definition {
        ... on AvigilonAccessConnectorDefinition {
          organizationId
        }
      }
      avigilonSite {
        id
        name
      }
    }
  }
  ${ConnectorDetailsFieldsFragmentDoc}
`;

/**
 * __useGetAvigilonAccessConnectorDetailsQuery__
 *
 * To run a query within a React component, call `useGetAvigilonAccessConnectorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvigilonAccessConnectorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvigilonAccessConnectorDetailsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetAvigilonAccessConnectorDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvigilonAccessConnectorDetailsQuery,
    GetAvigilonAccessConnectorDetailsQueryVariables
  > &
    (
      | {
          variables: GetAvigilonAccessConnectorDetailsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvigilonAccessConnectorDetailsQuery,
    GetAvigilonAccessConnectorDetailsQueryVariables
  >(GetAvigilonAccessConnectorDetailsDocument, options);
}
export function useGetAvigilonAccessConnectorDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvigilonAccessConnectorDetailsQuery,
    GetAvigilonAccessConnectorDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvigilonAccessConnectorDetailsQuery,
    GetAvigilonAccessConnectorDetailsQueryVariables
  >(GetAvigilonAccessConnectorDetailsDocument, options);
}
export function useGetAvigilonAccessConnectorDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvigilonAccessConnectorDetailsQuery,
    GetAvigilonAccessConnectorDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvigilonAccessConnectorDetailsQuery,
    GetAvigilonAccessConnectorDetailsQueryVariables
  >(GetAvigilonAccessConnectorDetailsDocument, options);
}
export type GetAvigilonAccessConnectorDetailsQueryHookResult = ReturnType<
  typeof useGetAvigilonAccessConnectorDetailsQuery
>;
export type GetAvigilonAccessConnectorDetailsLazyQueryHookResult = ReturnType<
  typeof useGetAvigilonAccessConnectorDetailsLazyQuery
>;
export type GetAvigilonAccessConnectorDetailsSuspenseQueryHookResult =
  ReturnType<typeof useGetAvigilonAccessConnectorDetailsSuspenseQuery>;
export type GetAvigilonAccessConnectorDetailsQueryResult = Apollo.QueryResult<
  GetAvigilonAccessConnectorDetailsQuery,
  GetAvigilonAccessConnectorDetailsQueryVariables
>;
export const GetAvigilonAccessConnectorSetupMetadataDocument = gql`
  query GetAvigilonAccessConnectorSetupMetadata($siteId: ID!) {
    connectorCatalog(siteId: $siteId) {
      definition(type: AVIGILON_ACCESS) {
        kind: __typename
        ... on AvigilonAccessConnectorDefinition {
          organizationId
        }
      }
    }
  }
`;

/**
 * __useGetAvigilonAccessConnectorSetupMetadataQuery__
 *
 * To run a query within a React component, call `useGetAvigilonAccessConnectorSetupMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvigilonAccessConnectorSetupMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvigilonAccessConnectorSetupMetadataQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetAvigilonAccessConnectorSetupMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvigilonAccessConnectorSetupMetadataQuery,
    GetAvigilonAccessConnectorSetupMetadataQueryVariables
  > &
    (
      | {
          variables: GetAvigilonAccessConnectorSetupMetadataQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvigilonAccessConnectorSetupMetadataQuery,
    GetAvigilonAccessConnectorSetupMetadataQueryVariables
  >(GetAvigilonAccessConnectorSetupMetadataDocument, options);
}
export function useGetAvigilonAccessConnectorSetupMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvigilonAccessConnectorSetupMetadataQuery,
    GetAvigilonAccessConnectorSetupMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvigilonAccessConnectorSetupMetadataQuery,
    GetAvigilonAccessConnectorSetupMetadataQueryVariables
  >(GetAvigilonAccessConnectorSetupMetadataDocument, options);
}
export function useGetAvigilonAccessConnectorSetupMetadataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvigilonAccessConnectorSetupMetadataQuery,
    GetAvigilonAccessConnectorSetupMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvigilonAccessConnectorSetupMetadataQuery,
    GetAvigilonAccessConnectorSetupMetadataQueryVariables
  >(GetAvigilonAccessConnectorSetupMetadataDocument, options);
}
export type GetAvigilonAccessConnectorSetupMetadataQueryHookResult = ReturnType<
  typeof useGetAvigilonAccessConnectorSetupMetadataQuery
>;
export type GetAvigilonAccessConnectorSetupMetadataLazyQueryHookResult =
  ReturnType<typeof useGetAvigilonAccessConnectorSetupMetadataLazyQuery>;
export type GetAvigilonAccessConnectorSetupMetadataSuspenseQueryHookResult =
  ReturnType<typeof useGetAvigilonAccessConnectorSetupMetadataSuspenseQuery>;
export type GetAvigilonAccessConnectorSetupMetadataQueryResult =
  Apollo.QueryResult<
    GetAvigilonAccessConnectorSetupMetadataQuery,
    GetAvigilonAccessConnectorSetupMetadataQueryVariables
  >;
export const SetupAvigilonAccessConnectorDocument = gql`
  mutation SetupAvigilonAccessConnector(
    $input: SetupAvigilonAccessConnectorInput!
  ) {
    setupAvigilonAccessConnector(input: $input) {
      id
    }
  }
`;
export type SetupAvigilonAccessConnectorMutationFn = Apollo.MutationFunction<
  SetupAvigilonAccessConnectorMutation,
  SetupAvigilonAccessConnectorMutationVariables
>;

/**
 * __useSetupAvigilonAccessConnectorMutation__
 *
 * To run a mutation, you first call `useSetupAvigilonAccessConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupAvigilonAccessConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupAvigilonAccessConnectorMutation, { data, loading, error }] = useSetupAvigilonAccessConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupAvigilonAccessConnectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetupAvigilonAccessConnectorMutation,
    SetupAvigilonAccessConnectorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetupAvigilonAccessConnectorMutation,
    SetupAvigilonAccessConnectorMutationVariables
  >(SetupAvigilonAccessConnectorDocument, options);
}
export type SetupAvigilonAccessConnectorMutationHookResult = ReturnType<
  typeof useSetupAvigilonAccessConnectorMutation
>;
export type SetupAvigilonAccessConnectorMutationResult =
  Apollo.MutationResult<SetupAvigilonAccessConnectorMutation>;
export type SetupAvigilonAccessConnectorMutationOptions =
  Apollo.BaseMutationOptions<
    SetupAvigilonAccessConnectorMutation,
    SetupAvigilonAccessConnectorMutationVariables
  >;
export const GetAvigilonVideoConnectorDetailsDocument = gql`
  query GetAvigilonVideoConnectorDetails($connectorId: ID!) {
    avigilonVideoConnector(id: $connectorId) {
      ...ConnectorDetailsFields
    }
  }
  ${ConnectorDetailsFieldsFragmentDoc}
`;

/**
 * __useGetAvigilonVideoConnectorDetailsQuery__
 *
 * To run a query within a React component, call `useGetAvigilonVideoConnectorDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvigilonVideoConnectorDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvigilonVideoConnectorDetailsQuery({
 *   variables: {
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useGetAvigilonVideoConnectorDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvigilonVideoConnectorDetailsQuery,
    GetAvigilonVideoConnectorDetailsQueryVariables
  > &
    (
      | {
          variables: GetAvigilonVideoConnectorDetailsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvigilonVideoConnectorDetailsQuery,
    GetAvigilonVideoConnectorDetailsQueryVariables
  >(GetAvigilonVideoConnectorDetailsDocument, options);
}
export function useGetAvigilonVideoConnectorDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvigilonVideoConnectorDetailsQuery,
    GetAvigilonVideoConnectorDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvigilonVideoConnectorDetailsQuery,
    GetAvigilonVideoConnectorDetailsQueryVariables
  >(GetAvigilonVideoConnectorDetailsDocument, options);
}
export function useGetAvigilonVideoConnectorDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvigilonVideoConnectorDetailsQuery,
    GetAvigilonVideoConnectorDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvigilonVideoConnectorDetailsQuery,
    GetAvigilonVideoConnectorDetailsQueryVariables
  >(GetAvigilonVideoConnectorDetailsDocument, options);
}
export type GetAvigilonVideoConnectorDetailsQueryHookResult = ReturnType<
  typeof useGetAvigilonVideoConnectorDetailsQuery
>;
export type GetAvigilonVideoConnectorDetailsLazyQueryHookResult = ReturnType<
  typeof useGetAvigilonVideoConnectorDetailsLazyQuery
>;
export type GetAvigilonVideoConnectorDetailsSuspenseQueryHookResult =
  ReturnType<typeof useGetAvigilonVideoConnectorDetailsSuspenseQuery>;
export type GetAvigilonVideoConnectorDetailsQueryResult = Apollo.QueryResult<
  GetAvigilonVideoConnectorDetailsQuery,
  GetAvigilonVideoConnectorDetailsQueryVariables
>;
export const SetupAvigilonVideoConnectorDocument = gql`
  mutation SetupAvigilonVideoConnector(
    $input: SetupAvigilonVideoConnectorInput!
  ) {
    setupAvigilonVideoConnector(input: $input) {
      id
    }
  }
`;
export type SetupAvigilonVideoConnectorMutationFn = Apollo.MutationFunction<
  SetupAvigilonVideoConnectorMutation,
  SetupAvigilonVideoConnectorMutationVariables
>;

/**
 * __useSetupAvigilonVideoConnectorMutation__
 *
 * To run a mutation, you first call `useSetupAvigilonVideoConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupAvigilonVideoConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupAvigilonVideoConnectorMutation, { data, loading, error }] = useSetupAvigilonVideoConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupAvigilonVideoConnectorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetupAvigilonVideoConnectorMutation,
    SetupAvigilonVideoConnectorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetupAvigilonVideoConnectorMutation,
    SetupAvigilonVideoConnectorMutationVariables
  >(SetupAvigilonVideoConnectorDocument, options);
}
export type SetupAvigilonVideoConnectorMutationHookResult = ReturnType<
  typeof useSetupAvigilonVideoConnectorMutation
>;
export type SetupAvigilonVideoConnectorMutationResult =
  Apollo.MutationResult<SetupAvigilonVideoConnectorMutation>;
export type SetupAvigilonVideoConnectorMutationOptions =
  Apollo.BaseMutationOptions<
    SetupAvigilonVideoConnectorMutation,
    SetupAvigilonVideoConnectorMutationVariables
  >;
export const GetConnectorCatalogDocument = gql`
  query GetConnectorCatalog($siteId: ID!) {
    connectorCatalog(siteId: $siteId) {
      items {
        ...ConnectorCatalogItemFields
      }
    }
  }
  ${ConnectorCatalogItemFieldsFragmentDoc}
`;

/**
 * __useGetConnectorCatalogQuery__
 *
 * To run a query within a React component, call `useGetConnectorCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectorCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectorCatalogQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetConnectorCatalogQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetConnectorCatalogQuery,
    GetConnectorCatalogQueryVariables
  > &
    (
      | { variables: GetConnectorCatalogQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConnectorCatalogQuery,
    GetConnectorCatalogQueryVariables
  >(GetConnectorCatalogDocument, options);
}
export function useGetConnectorCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConnectorCatalogQuery,
    GetConnectorCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConnectorCatalogQuery,
    GetConnectorCatalogQueryVariables
  >(GetConnectorCatalogDocument, options);
}
export function useGetConnectorCatalogSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetConnectorCatalogQuery,
    GetConnectorCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetConnectorCatalogQuery,
    GetConnectorCatalogQueryVariables
  >(GetConnectorCatalogDocument, options);
}
export type GetConnectorCatalogQueryHookResult = ReturnType<
  typeof useGetConnectorCatalogQuery
>;
export type GetConnectorCatalogLazyQueryHookResult = ReturnType<
  typeof useGetConnectorCatalogLazyQuery
>;
export type GetConnectorCatalogSuspenseQueryHookResult = ReturnType<
  typeof useGetConnectorCatalogSuspenseQuery
>;
export type GetConnectorCatalogQueryResult = Apollo.QueryResult<
  GetConnectorCatalogQuery,
  GetConnectorCatalogQueryVariables
>;
export const GetJobsiteConfigCustomFieldsDocument = gql`
  query GetJobsiteConfigCustomFields($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      activityCodeOptions
      classificationGroupOptions
      titleOptions
      tradeOptions
      unionAffiliationOptions
    }
  }
`;

/**
 * __useGetJobsiteConfigCustomFieldsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigCustomFieldsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigCustomFieldsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigCustomFieldsQuery,
    GetJobsiteConfigCustomFieldsQueryVariables
  > &
    (
      | {
          variables: GetJobsiteConfigCustomFieldsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigCustomFieldsQuery,
    GetJobsiteConfigCustomFieldsQueryVariables
  >(GetJobsiteConfigCustomFieldsDocument, options);
}
export function useGetJobsiteConfigCustomFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigCustomFieldsQuery,
    GetJobsiteConfigCustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigCustomFieldsQuery,
    GetJobsiteConfigCustomFieldsQueryVariables
  >(GetJobsiteConfigCustomFieldsDocument, options);
}
export function useGetJobsiteConfigCustomFieldsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigCustomFieldsQuery,
    GetJobsiteConfigCustomFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigCustomFieldsQuery,
    GetJobsiteConfigCustomFieldsQueryVariables
  >(GetJobsiteConfigCustomFieldsDocument, options);
}
export type GetJobsiteConfigCustomFieldsQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigCustomFieldsQuery
>;
export type GetJobsiteConfigCustomFieldsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigCustomFieldsLazyQuery
>;
export type GetJobsiteConfigCustomFieldsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigCustomFieldsSuspenseQuery
>;
export type GetJobsiteConfigCustomFieldsQueryResult = Apollo.QueryResult<
  GetJobsiteConfigCustomFieldsQuery,
  GetJobsiteConfigCustomFieldsQueryVariables
>;
export const CreateDeveloperJobsiteAccessGrantDocument = gql`
  mutation CreateDeveloperJobsiteAccessGrant(
    $input: CreateDeveloperJobsiteAccessGrantInput!
  ) {
    createDeveloperJobsiteAccessGrant(input: $input) {
      grant {
        id
      }
    }
  }
`;
export type CreateDeveloperJobsiteAccessGrantMutationFn =
  Apollo.MutationFunction<
    CreateDeveloperJobsiteAccessGrantMutation,
    CreateDeveloperJobsiteAccessGrantMutationVariables
  >;

/**
 * __useCreateDeveloperJobsiteAccessGrantMutation__
 *
 * To run a mutation, you first call `useCreateDeveloperJobsiteAccessGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeveloperJobsiteAccessGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeveloperJobsiteAccessGrantMutation, { data, loading, error }] = useCreateDeveloperJobsiteAccessGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeveloperJobsiteAccessGrantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeveloperJobsiteAccessGrantMutation,
    CreateDeveloperJobsiteAccessGrantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDeveloperJobsiteAccessGrantMutation,
    CreateDeveloperJobsiteAccessGrantMutationVariables
  >(CreateDeveloperJobsiteAccessGrantDocument, options);
}
export type CreateDeveloperJobsiteAccessGrantMutationHookResult = ReturnType<
  typeof useCreateDeveloperJobsiteAccessGrantMutation
>;
export type CreateDeveloperJobsiteAccessGrantMutationResult =
  Apollo.MutationResult<CreateDeveloperJobsiteAccessGrantMutation>;
export type CreateDeveloperJobsiteAccessGrantMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDeveloperJobsiteAccessGrantMutation,
    CreateDeveloperJobsiteAccessGrantMutationVariables
  >;
export const GetJobsiteDataSharingGrantsDocument = gql`
  query GetJobsiteDataSharingGrants($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
    }
    jobsiteDataSharingGrants(jobsiteId: $jobsiteId) {
      id
      capability
      agreementReference
      status
      granteeDeveloper {
        developerId
        name
      }
    }
  }
`;

/**
 * __useGetJobsiteDataSharingGrantsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteDataSharingGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteDataSharingGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteDataSharingGrantsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteDataSharingGrantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteDataSharingGrantsQuery,
    GetJobsiteDataSharingGrantsQueryVariables
  > &
    (
      | { variables: GetJobsiteDataSharingGrantsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteDataSharingGrantsQuery,
    GetJobsiteDataSharingGrantsQueryVariables
  >(GetJobsiteDataSharingGrantsDocument, options);
}
export function useGetJobsiteDataSharingGrantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteDataSharingGrantsQuery,
    GetJobsiteDataSharingGrantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteDataSharingGrantsQuery,
    GetJobsiteDataSharingGrantsQueryVariables
  >(GetJobsiteDataSharingGrantsDocument, options);
}
export function useGetJobsiteDataSharingGrantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteDataSharingGrantsQuery,
    GetJobsiteDataSharingGrantsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteDataSharingGrantsQuery,
    GetJobsiteDataSharingGrantsQueryVariables
  >(GetJobsiteDataSharingGrantsDocument, options);
}
export type GetJobsiteDataSharingGrantsQueryHookResult = ReturnType<
  typeof useGetJobsiteDataSharingGrantsQuery
>;
export type GetJobsiteDataSharingGrantsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteDataSharingGrantsLazyQuery
>;
export type GetJobsiteDataSharingGrantsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteDataSharingGrantsSuspenseQuery
>;
export type GetJobsiteDataSharingGrantsQueryResult = Apollo.QueryResult<
  GetJobsiteDataSharingGrantsQuery,
  GetJobsiteDataSharingGrantsQueryVariables
>;
export const RevokeDeveloperJobsiteAccessGrantDocument = gql`
  mutation RevokeDeveloperJobsiteAccessGrant(
    $input: RevokeDeveloperJobsiteAccessGrantInput!
  ) {
    revokeDeveloperJobsiteAccessGrant(input: $input) {
      grant {
        id
        status
      }
    }
  }
`;
export type RevokeDeveloperJobsiteAccessGrantMutationFn =
  Apollo.MutationFunction<
    RevokeDeveloperJobsiteAccessGrantMutation,
    RevokeDeveloperJobsiteAccessGrantMutationVariables
  >;

/**
 * __useRevokeDeveloperJobsiteAccessGrantMutation__
 *
 * To run a mutation, you first call `useRevokeDeveloperJobsiteAccessGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeDeveloperJobsiteAccessGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeDeveloperJobsiteAccessGrantMutation, { data, loading, error }] = useRevokeDeveloperJobsiteAccessGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeDeveloperJobsiteAccessGrantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeDeveloperJobsiteAccessGrantMutation,
    RevokeDeveloperJobsiteAccessGrantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeDeveloperJobsiteAccessGrantMutation,
    RevokeDeveloperJobsiteAccessGrantMutationVariables
  >(RevokeDeveloperJobsiteAccessGrantDocument, options);
}
export type RevokeDeveloperJobsiteAccessGrantMutationHookResult = ReturnType<
  typeof useRevokeDeveloperJobsiteAccessGrantMutation
>;
export type RevokeDeveloperJobsiteAccessGrantMutationResult =
  Apollo.MutationResult<RevokeDeveloperJobsiteAccessGrantMutation>;
export type RevokeDeveloperJobsiteAccessGrantMutationOptions =
  Apollo.BaseMutationOptions<
    RevokeDeveloperJobsiteAccessGrantMutation,
    RevokeDeveloperJobsiteAccessGrantMutationVariables
  >;
export const GetSiteReaderAttachmentsDocument = gql`
  query GetSiteReaderAttachments($input: SiteReaderAttachmentsInput!) {
    siteReaderAttachments(input: $input) {
      ...SiteReaderAttachmentsFields
    }
  }
  ${SiteReaderAttachmentsFieldsFragmentDoc}
`;

/**
 * __useGetSiteReaderAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetSiteReaderAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteReaderAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteReaderAttachmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSiteReaderAttachmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteReaderAttachmentsQuery,
    GetSiteReaderAttachmentsQueryVariables
  > &
    (
      | { variables: GetSiteReaderAttachmentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteReaderAttachmentsQuery,
    GetSiteReaderAttachmentsQueryVariables
  >(GetSiteReaderAttachmentsDocument, options);
}
export function useGetSiteReaderAttachmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteReaderAttachmentsQuery,
    GetSiteReaderAttachmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteReaderAttachmentsQuery,
    GetSiteReaderAttachmentsQueryVariables
  >(GetSiteReaderAttachmentsDocument, options);
}
export function useGetSiteReaderAttachmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteReaderAttachmentsQuery,
    GetSiteReaderAttachmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteReaderAttachmentsQuery,
    GetSiteReaderAttachmentsQueryVariables
  >(GetSiteReaderAttachmentsDocument, options);
}
export type GetSiteReaderAttachmentsQueryHookResult = ReturnType<
  typeof useGetSiteReaderAttachmentsQuery
>;
export type GetSiteReaderAttachmentsLazyQueryHookResult = ReturnType<
  typeof useGetSiteReaderAttachmentsLazyQuery
>;
export type GetSiteReaderAttachmentsSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteReaderAttachmentsSuspenseQuery
>;
export type GetSiteReaderAttachmentsQueryResult = Apollo.QueryResult<
  GetSiteReaderAttachmentsQuery,
  GetSiteReaderAttachmentsQueryVariables
>;
export const RemoveSiteReaderAttachmentDocument = gql`
  mutation RemoveSiteReaderAttachment(
    $input: RemoveSiteReaderAttachmentInput!
  ) {
    removeSiteReaderAttachment(input: $input) {
      ...SiteReaderAttachmentsFields
    }
  }
  ${SiteReaderAttachmentsFieldsFragmentDoc}
`;
export type RemoveSiteReaderAttachmentMutationFn = Apollo.MutationFunction<
  RemoveSiteReaderAttachmentMutation,
  RemoveSiteReaderAttachmentMutationVariables
>;

/**
 * __useRemoveSiteReaderAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveSiteReaderAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSiteReaderAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSiteReaderAttachmentMutation, { data, loading, error }] = useRemoveSiteReaderAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSiteReaderAttachmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSiteReaderAttachmentMutation,
    RemoveSiteReaderAttachmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSiteReaderAttachmentMutation,
    RemoveSiteReaderAttachmentMutationVariables
  >(RemoveSiteReaderAttachmentDocument, options);
}
export type RemoveSiteReaderAttachmentMutationHookResult = ReturnType<
  typeof useRemoveSiteReaderAttachmentMutation
>;
export type RemoveSiteReaderAttachmentMutationResult =
  Apollo.MutationResult<RemoveSiteReaderAttachmentMutation>;
export type RemoveSiteReaderAttachmentMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveSiteReaderAttachmentMutation,
    RemoveSiteReaderAttachmentMutationVariables
  >;
export const GetSiteDevicesDocument = gql`
  query GetSiteDevices($siteId: ID!, $first: Int) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      name
    }
    siteIndependentReaders(siteId: $siteId) {
      kind
      entry {
        externalEntryId
        name
      }
      health {
        kind
        isMissing
        bound
        lastReadAt
      }
      readerId
      readerDeviceId
      name
      serialNumber
      missing
      placement {
        published {
          placementId
          entryId
          entryName
        }
        draft {
          placementId
          entryId
          entryName
        }
      }
    }
    siteDevices(siteId: $siteId, first: $first) {
      ...SiteControllerFields
    }
  }
  ${SiteControllerFieldsFragmentDoc}
`;

/**
 * __useGetSiteDevicesQuery__
 *
 * To run a query within a React component, call `useGetSiteDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDevicesQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetSiteDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteDevicesQuery,
    GetSiteDevicesQueryVariables
  > &
    (
      | { variables: GetSiteDevicesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSiteDevicesQuery, GetSiteDevicesQueryVariables>(
    GetSiteDevicesDocument,
    options,
  );
}
export function useGetSiteDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteDevicesQuery,
    GetSiteDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSiteDevicesQuery, GetSiteDevicesQueryVariables>(
    GetSiteDevicesDocument,
    options,
  );
}
export function useGetSiteDevicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteDevicesQuery,
    GetSiteDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteDevicesQuery,
    GetSiteDevicesQueryVariables
  >(GetSiteDevicesDocument, options);
}
export type GetSiteDevicesQueryHookResult = ReturnType<
  typeof useGetSiteDevicesQuery
>;
export type GetSiteDevicesLazyQueryHookResult = ReturnType<
  typeof useGetSiteDevicesLazyQuery
>;
export type GetSiteDevicesSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteDevicesSuspenseQuery
>;
export type GetSiteDevicesQueryResult = Apollo.QueryResult<
  GetSiteDevicesQuery,
  GetSiteDevicesQueryVariables
>;
export const GetSiteUnresolvedReadersDocument = gql`
  query GetSiteUnresolvedReaders($siteId: ID!) {
    siteUnresolvedReaders(siteId: $siteId) {
      readerId
      name
      controller {
        assignmentId
        name
        portLabel
      }
    }
  }
`;

/**
 * __useGetSiteUnresolvedReadersQuery__
 *
 * To run a query within a React component, call `useGetSiteUnresolvedReadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteUnresolvedReadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteUnresolvedReadersQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteUnresolvedReadersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteUnresolvedReadersQuery,
    GetSiteUnresolvedReadersQueryVariables
  > &
    (
      | { variables: GetSiteUnresolvedReadersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteUnresolvedReadersQuery,
    GetSiteUnresolvedReadersQueryVariables
  >(GetSiteUnresolvedReadersDocument, options);
}
export function useGetSiteUnresolvedReadersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteUnresolvedReadersQuery,
    GetSiteUnresolvedReadersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteUnresolvedReadersQuery,
    GetSiteUnresolvedReadersQueryVariables
  >(GetSiteUnresolvedReadersDocument, options);
}
export function useGetSiteUnresolvedReadersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteUnresolvedReadersQuery,
    GetSiteUnresolvedReadersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteUnresolvedReadersQuery,
    GetSiteUnresolvedReadersQueryVariables
  >(GetSiteUnresolvedReadersDocument, options);
}
export type GetSiteUnresolvedReadersQueryHookResult = ReturnType<
  typeof useGetSiteUnresolvedReadersQuery
>;
export type GetSiteUnresolvedReadersLazyQueryHookResult = ReturnType<
  typeof useGetSiteUnresolvedReadersLazyQuery
>;
export type GetSiteUnresolvedReadersSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteUnresolvedReadersSuspenseQuery
>;
export type GetSiteUnresolvedReadersQueryResult = Apollo.QueryResult<
  GetSiteUnresolvedReadersQuery,
  GetSiteUnresolvedReadersQueryVariables
>;
export const AddSiteControllerDocument = gql`
  mutation AddSiteController($input: AddSiteControllerInput!) {
    addSiteController(input: $input) {
      kind
      refusal
      failure
      runId
      assignmentId
      deviceId
      readerIds
    }
  }
`;
export type AddSiteControllerMutationFn = Apollo.MutationFunction<
  AddSiteControllerMutation,
  AddSiteControllerMutationVariables
>;

/**
 * __useAddSiteControllerMutation__
 *
 * To run a mutation, you first call `useAddSiteControllerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSiteControllerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSiteControllerMutation, { data, loading, error }] = useAddSiteControllerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSiteControllerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddSiteControllerMutation,
    AddSiteControllerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddSiteControllerMutation,
    AddSiteControllerMutationVariables
  >(AddSiteControllerDocument, options);
}
export type AddSiteControllerMutationHookResult = ReturnType<
  typeof useAddSiteControllerMutation
>;
export type AddSiteControllerMutationResult =
  Apollo.MutationResult<AddSiteControllerMutation>;
export type AddSiteControllerMutationOptions = Apollo.BaseMutationOptions<
  AddSiteControllerMutation,
  AddSiteControllerMutationVariables
>;
export const SyncSiteControllerDocument = gql`
  mutation SyncSiteController($input: SyncSiteControllerInput!) {
    syncSiteController(input: $input) {
      kind
      refusal
      failure
      runId
      status
      observedAt
    }
  }
`;
export type SyncSiteControllerMutationFn = Apollo.MutationFunction<
  SyncSiteControllerMutation,
  SyncSiteControllerMutationVariables
>;

/**
 * __useSyncSiteControllerMutation__
 *
 * To run a mutation, you first call `useSyncSiteControllerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncSiteControllerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncSiteControllerMutation, { data, loading, error }] = useSyncSiteControllerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncSiteControllerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncSiteControllerMutation,
    SyncSiteControllerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SyncSiteControllerMutation,
    SyncSiteControllerMutationVariables
  >(SyncSiteControllerDocument, options);
}
export type SyncSiteControllerMutationHookResult = ReturnType<
  typeof useSyncSiteControllerMutation
>;
export type SyncSiteControllerMutationResult =
  Apollo.MutationResult<SyncSiteControllerMutation>;
export type SyncSiteControllerMutationOptions = Apollo.BaseMutationOptions<
  SyncSiteControllerMutation,
  SyncSiteControllerMutationVariables
>;
export const RemoveSiteControllerDocument = gql`
  mutation RemoveSiteController($input: RemoveSiteControllerInput!) {
    removeSiteController(input: $input) {
      kind
      refusal
      failure
      runId
      closedReaderIds
      removedDraftPlacementIds
    }
  }
`;
export type RemoveSiteControllerMutationFn = Apollo.MutationFunction<
  RemoveSiteControllerMutation,
  RemoveSiteControllerMutationVariables
>;

/**
 * __useRemoveSiteControllerMutation__
 *
 * To run a mutation, you first call `useRemoveSiteControllerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSiteControllerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSiteControllerMutation, { data, loading, error }] = useRemoveSiteControllerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSiteControllerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSiteControllerMutation,
    RemoveSiteControllerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSiteControllerMutation,
    RemoveSiteControllerMutationVariables
  >(RemoveSiteControllerDocument, options);
}
export type RemoveSiteControllerMutationHookResult = ReturnType<
  typeof useRemoveSiteControllerMutation
>;
export type RemoveSiteControllerMutationResult =
  Apollo.MutationResult<RemoveSiteControllerMutation>;
export type RemoveSiteControllerMutationOptions = Apollo.BaseMutationOptions<
  RemoveSiteControllerMutation,
  RemoveSiteControllerMutationVariables
>;
export const GetAvailableSiteControllersDocument = gql`
  query GetAvailableSiteControllers($siteId: ID!, $first: Int, $after: String) {
    availableSiteControllers(siteId: $siteId, first: $first, after: $after) {
      nodes {
        id
        name
        serialNumber
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

/**
 * __useGetAvailableSiteControllersQuery__
 *
 * To run a query within a React component, call `useGetAvailableSiteControllersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableSiteControllersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableSiteControllersQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAvailableSiteControllersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableSiteControllersQuery,
    GetAvailableSiteControllersQueryVariables
  > &
    (
      | { variables: GetAvailableSiteControllersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableSiteControllersQuery,
    GetAvailableSiteControllersQueryVariables
  >(GetAvailableSiteControllersDocument, options);
}
export function useGetAvailableSiteControllersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableSiteControllersQuery,
    GetAvailableSiteControllersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableSiteControllersQuery,
    GetAvailableSiteControllersQueryVariables
  >(GetAvailableSiteControllersDocument, options);
}
export function useGetAvailableSiteControllersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableSiteControllersQuery,
    GetAvailableSiteControllersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailableSiteControllersQuery,
    GetAvailableSiteControllersQueryVariables
  >(GetAvailableSiteControllersDocument, options);
}
export type GetAvailableSiteControllersQueryHookResult = ReturnType<
  typeof useGetAvailableSiteControllersQuery
>;
export type GetAvailableSiteControllersLazyQueryHookResult = ReturnType<
  typeof useGetAvailableSiteControllersLazyQuery
>;
export type GetAvailableSiteControllersSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableSiteControllersSuspenseQuery
>;
export type GetAvailableSiteControllersQueryResult = Apollo.QueryResult<
  GetAvailableSiteControllersQuery,
  GetAvailableSiteControllersQueryVariables
>;
export const GetJobsiteConfigDocumentsDocument = gql`
  query GetJobsiteConfigDocuments(
    $jobsiteId: ID!
    $documentTypesInput: JobsiteWorkerDocumentTypesInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      documentTypes(input: $documentTypesInput) {
        edges {
          node {
            id
            key
            name
            position
            workerDocumentType {
              workerDocumentTypeId
              key
              name
            }
            files {
              fileId
              fileType
              downloadUrl
              language
              title
            }
          }
        }
      }
      onboardingModule {
        name
        badgePrintingAllowed
        badgeAssignmentAllowed
        steps {
          key
          index
          isRequired
          isVisible
          fields {
            key
            name
            index
            isRequired
            isHidden
            isEnforced
          }
        }
        documents {
          key
          workerDocTypeKey
          name
          index
          isRequired
          isVisible
          expiration
          gracePeriod
          fields {
            key
            name
            index
            isRequired
            isHidden
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigDocumentsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigDocumentsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      documentTypesInput: // value for 'documentTypesInput'
 *   },
 * });
 */
export function useGetJobsiteConfigDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigDocumentsQuery,
    GetJobsiteConfigDocumentsQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigDocumentsQuery,
    GetJobsiteConfigDocumentsQueryVariables
  >(GetJobsiteConfigDocumentsDocument, options);
}
export function useGetJobsiteConfigDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigDocumentsQuery,
    GetJobsiteConfigDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigDocumentsQuery,
    GetJobsiteConfigDocumentsQueryVariables
  >(GetJobsiteConfigDocumentsDocument, options);
}
export function useGetJobsiteConfigDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigDocumentsQuery,
    GetJobsiteConfigDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigDocumentsQuery,
    GetJobsiteConfigDocumentsQueryVariables
  >(GetJobsiteConfigDocumentsDocument, options);
}
export type GetJobsiteConfigDocumentsQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigDocumentsQuery
>;
export type GetJobsiteConfigDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigDocumentsLazyQuery
>;
export type GetJobsiteConfigDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigDocumentsSuspenseQuery
>;
export type GetJobsiteConfigDocumentsQueryResult = Apollo.QueryResult<
  GetJobsiteConfigDocumentsQuery,
  GetJobsiteConfigDocumentsQueryVariables
>;
export const GetJobsiteConfigFeaturesDocument = gql`
  query GetJobsiteConfigFeatures(
    $jobsiteId: ID!
    $userUsersInput: UserUsersInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      isTemplate
      schedulerAccount {
        userAccountId
        identity {
          firstName
          lastName
        }
      }
      featuresModule {
        addWorkersToDailyLog
        announcementsEnabled
        archivingAccessEventsEnabled
        doNotAllowToSkipSelfOnboardingSteps
        enforceValidContractorInSelfOnboarding
        formsEnabled
        schedulingEnabled
        selfOnboardingAutoCompleteEnabled
        workerAppAdminCheckInEnabled
        workerAppBadgeScanningEnabled
        workerAppEnabled
        workerAppKioskCheckInEnabled
        workerAppKioskFrontCameraEnabled
        workerAppSelfCheckInEnabled
        isEnabled
        name
        slug
      }
      appCheckInModule {
        areas {
          id
          name
          checkInCoordinate {
            lat
            lng
          }
          checkInRadius
        }
        geofencingEnforcementType
        crewGeofencingEnforcementType
        isEnabled
        name
        slug
      }
    }
    getCurrentSession {
      user {
        userAccountId
        users(input: $userUsersInput) {
          edges {
            node {
              userAccountId
              identity {
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigFeaturesQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigFeaturesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      userUsersInput: // value for 'userUsersInput'
 *   },
 * });
 */
export function useGetJobsiteConfigFeaturesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigFeaturesQuery,
    GetJobsiteConfigFeaturesQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigFeaturesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigFeaturesQuery,
    GetJobsiteConfigFeaturesQueryVariables
  >(GetJobsiteConfigFeaturesDocument, options);
}
export function useGetJobsiteConfigFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigFeaturesQuery,
    GetJobsiteConfigFeaturesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigFeaturesQuery,
    GetJobsiteConfigFeaturesQueryVariables
  >(GetJobsiteConfigFeaturesDocument, options);
}
export function useGetJobsiteConfigFeaturesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigFeaturesQuery,
    GetJobsiteConfigFeaturesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigFeaturesQuery,
    GetJobsiteConfigFeaturesQueryVariables
  >(GetJobsiteConfigFeaturesDocument, options);
}
export type GetJobsiteConfigFeaturesQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigFeaturesQuery
>;
export type GetJobsiteConfigFeaturesLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigFeaturesLazyQuery
>;
export type GetJobsiteConfigFeaturesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigFeaturesSuspenseQuery
>;
export type GetJobsiteConfigFeaturesQueryResult = Apollo.QueryResult<
  GetJobsiteConfigFeaturesQuery,
  GetJobsiteConfigFeaturesQueryVariables
>;
export const GetJobsiteConfigFormsDocument = gql`
  query getJobsiteConfigForms(
    $jobsiteId: ID!
    $userFormsInput: UserFormsInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      jobsiteForms {
        edges {
          node {
            id
            form {
              id
              key
              name
              description
              allowSessionAssignment
              allowAutoCreateOnCheckout
            }
            sessionAssignment
            autoCreateTrigger
          }
        }
      }
    }
    getCurrentSession {
      user {
        userAccountId
        forms(input: $userFormsInput) {
          edges {
            node {
              id
              key
              name
              description
              allowSessionAssignment
              allowAutoCreateOnCheckout
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigFormsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigFormsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      userFormsInput: // value for 'userFormsInput'
 *   },
 * });
 */
export function useGetJobsiteConfigFormsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigFormsQuery,
    GetJobsiteConfigFormsQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigFormsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigFormsQuery,
    GetJobsiteConfigFormsQueryVariables
  >(GetJobsiteConfigFormsDocument, options);
}
export function useGetJobsiteConfigFormsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigFormsQuery,
    GetJobsiteConfigFormsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigFormsQuery,
    GetJobsiteConfigFormsQueryVariables
  >(GetJobsiteConfigFormsDocument, options);
}
export function useGetJobsiteConfigFormsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigFormsQuery,
    GetJobsiteConfigFormsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigFormsQuery,
    GetJobsiteConfigFormsQueryVariables
  >(GetJobsiteConfigFormsDocument, options);
}
export type GetJobsiteConfigFormsQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigFormsQuery
>;
export type GetJobsiteConfigFormsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigFormsLazyQuery
>;
export type GetJobsiteConfigFormsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigFormsSuspenseQuery
>;
export type GetJobsiteConfigFormsQueryResult = Apollo.QueryResult<
  GetJobsiteConfigFormsQuery,
  GetJobsiteConfigFormsQueryVariables
>;
export const GetJobsiteConfigGeofencingDocument = gql`
  query GetJobsiteConfigGeofencing($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      isTemplate
      appCheckInModule {
        areas {
          id
          name
          checkInCoordinate {
            lat
            lng
          }
          checkInRadius
          isInboundEnabled
          isOutboundEnabled
        }
        geofencingEnforcementType
        crewGeofencingEnforcementType
        isEnabled
        name
        slug
      }
      featuresModule {
        workerAppSelfCheckInEnabled
        workerAppAdminCheckInEnabled
        workerAppBadgeScanningEnabled
        workerAppKioskCheckInEnabled
        isEnabled
        name
        slug
      }
      jobsiteGateways {
        edges {
          node {
            id
            name
          }
        }
      }
      gatewayAddsClosed
    }
  }
`;

/**
 * __useGetJobsiteConfigGeofencingQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigGeofencingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigGeofencingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigGeofencingQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigGeofencingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigGeofencingQuery,
    GetJobsiteConfigGeofencingQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigGeofencingQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigGeofencingQuery,
    GetJobsiteConfigGeofencingQueryVariables
  >(GetJobsiteConfigGeofencingDocument, options);
}
export function useGetJobsiteConfigGeofencingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigGeofencingQuery,
    GetJobsiteConfigGeofencingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigGeofencingQuery,
    GetJobsiteConfigGeofencingQueryVariables
  >(GetJobsiteConfigGeofencingDocument, options);
}
export function useGetJobsiteConfigGeofencingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigGeofencingQuery,
    GetJobsiteConfigGeofencingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigGeofencingQuery,
    GetJobsiteConfigGeofencingQueryVariables
  >(GetJobsiteConfigGeofencingDocument, options);
}
export type GetJobsiteConfigGeofencingQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigGeofencingQuery
>;
export type GetJobsiteConfigGeofencingLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigGeofencingLazyQuery
>;
export type GetJobsiteConfigGeofencingSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigGeofencingSuspenseQuery
>;
export type GetJobsiteConfigGeofencingQueryResult = Apollo.QueryResult<
  GetJobsiteConfigGeofencingQuery,
  GetJobsiteConfigGeofencingQueryVariables
>;
export const GetJobsiteConfigHidFargoConnectDocument = gql`
  query GetJobsiteConfigHidFargoConnect($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      defaultJobsitePrinterId
      hidCardMappingUnion
      hidCardMappingNonUnion
      hidCardMappingTest
      jobsiteBadgeTemplates {
        edges {
          node {
            id
            jobsiteId
            isDefault
            badgeTemplate {
              id
              templateName
              displayName
              isForTempBadge
            }
          }
        }
      }
      jobsitePrinters {
        edges {
          node {
            id
            hidPrinterId
            hidProxyInstance
            fargoLocationId
            fargoOrganizationId
          }
        }
      }
    }
    getCurrentSession {
      user {
        userAccountId
        hidEntityOptions {
          edges {
            node {
              id
              name
              organizationId
              organizationName
              locationId
              locationName
              entityType
              proxyInstance
            }
          }
        }
        badgeTemplates {
          edges {
            node {
              id
              templateName
              displayName
              isForTempBadge
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigHidFargoConnectQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigHidFargoConnectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigHidFargoConnectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigHidFargoConnectQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigHidFargoConnectQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigHidFargoConnectQuery,
    GetJobsiteConfigHidFargoConnectQueryVariables
  > &
    (
      | {
          variables: GetJobsiteConfigHidFargoConnectQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigHidFargoConnectQuery,
    GetJobsiteConfigHidFargoConnectQueryVariables
  >(GetJobsiteConfigHidFargoConnectDocument, options);
}
export function useGetJobsiteConfigHidFargoConnectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigHidFargoConnectQuery,
    GetJobsiteConfigHidFargoConnectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigHidFargoConnectQuery,
    GetJobsiteConfigHidFargoConnectQueryVariables
  >(GetJobsiteConfigHidFargoConnectDocument, options);
}
export function useGetJobsiteConfigHidFargoConnectSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigHidFargoConnectQuery,
    GetJobsiteConfigHidFargoConnectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigHidFargoConnectQuery,
    GetJobsiteConfigHidFargoConnectQueryVariables
  >(GetJobsiteConfigHidFargoConnectDocument, options);
}
export type GetJobsiteConfigHidFargoConnectQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigHidFargoConnectQuery
>;
export type GetJobsiteConfigHidFargoConnectLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigHidFargoConnectLazyQuery
>;
export type GetJobsiteConfigHidFargoConnectSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigHidFargoConnectSuspenseQuery
>;
export type GetJobsiteConfigHidFargoConnectQueryResult = Apollo.QueryResult<
  GetJobsiteConfigHidFargoConnectQuery,
  GetJobsiteConfigHidFargoConnectQueryVariables
>;
export const GetJobsiteConfigInfoDocument = gql`
  query GetJobsiteConfigInfo($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      jobsiteNumber
      profilePicture {
        fileId
        fileType
        downloadUrl
      }
      developer {
        developerId
      }
      parentId
      isTemplate
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZipCode
      timeZone
      latitude
      longitude
      startDate
      endDate
    }
    getCurrentSession {
      user {
        userAccountId
        developers {
          edges {
            node {
              developerId
              organization {
                organizationId
                name
              }
            }
          }
        }
        jobsites {
          edges {
            node {
              jobsiteId
              name
              parentId
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigInfoQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigInfoQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigInfoQuery,
    GetJobsiteConfigInfoQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigInfoQuery,
    GetJobsiteConfigInfoQueryVariables
  >(GetJobsiteConfigInfoDocument, options);
}
export function useGetJobsiteConfigInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigInfoQuery,
    GetJobsiteConfigInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigInfoQuery,
    GetJobsiteConfigInfoQueryVariables
  >(GetJobsiteConfigInfoDocument, options);
}
export function useGetJobsiteConfigInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigInfoQuery,
    GetJobsiteConfigInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigInfoQuery,
    GetJobsiteConfigInfoQueryVariables
  >(GetJobsiteConfigInfoDocument, options);
}
export type GetJobsiteConfigInfoQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigInfoQuery
>;
export type GetJobsiteConfigInfoLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigInfoLazyQuery
>;
export type GetJobsiteConfigInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigInfoSuspenseQuery
>;
export type GetJobsiteConfigInfoQueryResult = Apollo.QueryResult<
  GetJobsiteConfigInfoQuery,
  GetJobsiteConfigInfoQueryVariables
>;
export const GetJobsiteConfigNotificationsDocument = gql`
  query GetJobsiteConfigNotifications($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      deviceStatusChangeEmails
      accessChangeEmails
      escortChangeEmails
      assignmentChangeEmails
      rejectedSwipeEmails
      dailyAccessReportEmails
      weeklyAccessReportEmails
      siteSafetyLogEmails
      safetyObservationLogEmails
      reportingTimeSlot
    }
  }
`;

/**
 * __useGetJobsiteConfigNotificationsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigNotificationsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigNotificationsQuery,
    GetJobsiteConfigNotificationsQueryVariables
  > &
    (
      | {
          variables: GetJobsiteConfigNotificationsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigNotificationsQuery,
    GetJobsiteConfigNotificationsQueryVariables
  >(GetJobsiteConfigNotificationsDocument, options);
}
export function useGetJobsiteConfigNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigNotificationsQuery,
    GetJobsiteConfigNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigNotificationsQuery,
    GetJobsiteConfigNotificationsQueryVariables
  >(GetJobsiteConfigNotificationsDocument, options);
}
export function useGetJobsiteConfigNotificationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigNotificationsQuery,
    GetJobsiteConfigNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigNotificationsQuery,
    GetJobsiteConfigNotificationsQueryVariables
  >(GetJobsiteConfigNotificationsDocument, options);
}
export type GetJobsiteConfigNotificationsQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigNotificationsQuery
>;
export type GetJobsiteConfigNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigNotificationsLazyQuery
>;
export type GetJobsiteConfigNotificationsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigNotificationsSuspenseQuery
>;
export type GetJobsiteConfigNotificationsQueryResult = Apollo.QueryResult<
  GetJobsiteConfigNotificationsQuery,
  GetJobsiteConfigNotificationsQueryVariables
>;
export const GetJobsiteConfigOnboardingDocument = gql`
  query GetJobsiteConfigOnboarding($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      onboardingModule {
        name
        badgePrintingAllowed
        badgeAssignmentAllowed
        steps {
          key
          index
          isRequired
          isVisible
          fields {
            key
            name
            index
            isRequired
            isHidden
            isEnforced
          }
        }
        documents {
          key
          workerDocTypeKey
          name
          index
          isRequired
          isVisible
          expiration
          gracePeriod
          fields {
            key
            name
            index
            isRequired
            isHidden
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigOnboardingQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigOnboardingQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigOnboardingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigOnboardingQuery,
    GetJobsiteConfigOnboardingQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigOnboardingQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigOnboardingQuery,
    GetJobsiteConfigOnboardingQueryVariables
  >(GetJobsiteConfigOnboardingDocument, options);
}
export function useGetJobsiteConfigOnboardingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigOnboardingQuery,
    GetJobsiteConfigOnboardingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigOnboardingQuery,
    GetJobsiteConfigOnboardingQueryVariables
  >(GetJobsiteConfigOnboardingDocument, options);
}
export function useGetJobsiteConfigOnboardingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigOnboardingQuery,
    GetJobsiteConfigOnboardingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigOnboardingQuery,
    GetJobsiteConfigOnboardingQueryVariables
  >(GetJobsiteConfigOnboardingDocument, options);
}
export type GetJobsiteConfigOnboardingQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigOnboardingQuery
>;
export type GetJobsiteConfigOnboardingLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigOnboardingLazyQuery
>;
export type GetJobsiteConfigOnboardingSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigOnboardingSuspenseQuery
>;
export type GetJobsiteConfigOnboardingQueryResult = Apollo.QueryResult<
  GetJobsiteConfigOnboardingQuery,
  GetJobsiteConfigOnboardingQueryVariables
>;
export const GetJobsiteConfigProcoreDocument = gql`
  query GetJobsiteConfigProcore($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      procoreCompanyId
      procoreProjectId
    }
  }
`;

/**
 * __useGetJobsiteConfigProcoreQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigProcoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigProcoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigProcoreQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigProcoreQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigProcoreQuery,
    GetJobsiteConfigProcoreQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigProcoreQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigProcoreQuery,
    GetJobsiteConfigProcoreQueryVariables
  >(GetJobsiteConfigProcoreDocument, options);
}
export function useGetJobsiteConfigProcoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigProcoreQuery,
    GetJobsiteConfigProcoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigProcoreQuery,
    GetJobsiteConfigProcoreQueryVariables
  >(GetJobsiteConfigProcoreDocument, options);
}
export function useGetJobsiteConfigProcoreSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigProcoreQuery,
    GetJobsiteConfigProcoreQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigProcoreQuery,
    GetJobsiteConfigProcoreQueryVariables
  >(GetJobsiteConfigProcoreDocument, options);
}
export type GetJobsiteConfigProcoreQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigProcoreQuery
>;
export type GetJobsiteConfigProcoreLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigProcoreLazyQuery
>;
export type GetJobsiteConfigProcoreSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigProcoreSuspenseQuery
>;
export type GetJobsiteConfigProcoreQueryResult = Apollo.QueryResult<
  GetJobsiteConfigProcoreQuery,
  GetJobsiteConfigProcoreQueryVariables
>;
export const GetJobsiteConfigSiteAccessRulesDocument = gql`
  query GetJobsiteConfigSiteAccessRules($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      onboardingGracePeriod
      swipeInactivityThreshold
      maximumSessionLength
      allowOvernightSessions
      sessionDisplayColumn
    }
  }
`;

/**
 * __useGetJobsiteConfigSiteAccessRulesQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigSiteAccessRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigSiteAccessRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigSiteAccessRulesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigSiteAccessRulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigSiteAccessRulesQuery,
    GetJobsiteConfigSiteAccessRulesQueryVariables
  > &
    (
      | {
          variables: GetJobsiteConfigSiteAccessRulesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigSiteAccessRulesQuery,
    GetJobsiteConfigSiteAccessRulesQueryVariables
  >(GetJobsiteConfigSiteAccessRulesDocument, options);
}
export function useGetJobsiteConfigSiteAccessRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigSiteAccessRulesQuery,
    GetJobsiteConfigSiteAccessRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigSiteAccessRulesQuery,
    GetJobsiteConfigSiteAccessRulesQueryVariables
  >(GetJobsiteConfigSiteAccessRulesDocument, options);
}
export function useGetJobsiteConfigSiteAccessRulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigSiteAccessRulesQuery,
    GetJobsiteConfigSiteAccessRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigSiteAccessRulesQuery,
    GetJobsiteConfigSiteAccessRulesQueryVariables
  >(GetJobsiteConfigSiteAccessRulesDocument, options);
}
export type GetJobsiteConfigSiteAccessRulesQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigSiteAccessRulesQuery
>;
export type GetJobsiteConfigSiteAccessRulesLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigSiteAccessRulesLazyQuery
>;
export type GetJobsiteConfigSiteAccessRulesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigSiteAccessRulesSuspenseQuery
>;
export type GetJobsiteConfigSiteAccessRulesQueryResult = Apollo.QueryResult<
  GetJobsiteConfigSiteAccessRulesQuery,
  GetJobsiteConfigSiteAccessRulesQueryVariables
>;
export const GetJobsiteConfigSiteLayoutDocument = gql`
  query GetJobsiteConfigSiteLayout($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
    }
  }
`;

/**
 * __useGetJobsiteConfigSiteLayoutQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigSiteLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigSiteLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigSiteLayoutQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigSiteLayoutQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigSiteLayoutQuery,
    GetJobsiteConfigSiteLayoutQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigSiteLayoutQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigSiteLayoutQuery,
    GetJobsiteConfigSiteLayoutQueryVariables
  >(GetJobsiteConfigSiteLayoutDocument, options);
}
export function useGetJobsiteConfigSiteLayoutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigSiteLayoutQuery,
    GetJobsiteConfigSiteLayoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigSiteLayoutQuery,
    GetJobsiteConfigSiteLayoutQueryVariables
  >(GetJobsiteConfigSiteLayoutDocument, options);
}
export function useGetJobsiteConfigSiteLayoutSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigSiteLayoutQuery,
    GetJobsiteConfigSiteLayoutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigSiteLayoutQuery,
    GetJobsiteConfigSiteLayoutQueryVariables
  >(GetJobsiteConfigSiteLayoutDocument, options);
}
export type GetJobsiteConfigSiteLayoutQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigSiteLayoutQuery
>;
export type GetJobsiteConfigSiteLayoutLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigSiteLayoutLazyQuery
>;
export type GetJobsiteConfigSiteLayoutSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigSiteLayoutSuspenseQuery
>;
export type GetJobsiteConfigSiteLayoutQueryResult = Apollo.QueryResult<
  GetJobsiteConfigSiteLayoutQuery,
  GetJobsiteConfigSiteLayoutQueryVariables
>;
export const GetJobsiteConfigZonesDocument = gql`
  query GetJobsiteConfigZones($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      zones {
        id
        name
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigZonesQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigZonesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigZonesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigZonesQuery,
    GetJobsiteConfigZonesQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigZonesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigZonesQuery,
    GetJobsiteConfigZonesQueryVariables
  >(GetJobsiteConfigZonesDocument, options);
}
export function useGetJobsiteConfigZonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigZonesQuery,
    GetJobsiteConfigZonesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigZonesQuery,
    GetJobsiteConfigZonesQueryVariables
  >(GetJobsiteConfigZonesDocument, options);
}
export function useGetJobsiteConfigZonesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigZonesQuery,
    GetJobsiteConfigZonesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigZonesQuery,
    GetJobsiteConfigZonesQueryVariables
  >(GetJobsiteConfigZonesDocument, options);
}
export type GetJobsiteConfigZonesQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigZonesQuery
>;
export type GetJobsiteConfigZonesLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigZonesLazyQuery
>;
export type GetJobsiteConfigZonesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigZonesSuspenseQuery
>;
export type GetJobsiteConfigZonesQueryResult = Apollo.QueryResult<
  GetJobsiteConfigZonesQuery,
  GetJobsiteConfigZonesQueryVariables
>;
export const GetZoneDetailsDocument = gql`
  query GetZoneDetails($zoneId: ID!) {
    zone(id: $zoneId) {
      id
      name
      connections {
        id
        externalEntity {
          type
          typeDisplayName
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetZoneDetailsQuery__
 *
 * To run a query within a React component, call `useGetZoneDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneDetailsQuery({
 *   variables: {
 *      zoneId: // value for 'zoneId'
 *   },
 * });
 */
export function useGetZoneDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetZoneDetailsQuery,
    GetZoneDetailsQueryVariables
  > &
    (
      | { variables: GetZoneDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetZoneDetailsQuery, GetZoneDetailsQueryVariables>(
    GetZoneDetailsDocument,
    options,
  );
}
export function useGetZoneDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetZoneDetailsQuery,
    GetZoneDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetZoneDetailsQuery, GetZoneDetailsQueryVariables>(
    GetZoneDetailsDocument,
    options,
  );
}
export function useGetZoneDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetZoneDetailsQuery,
    GetZoneDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetZoneDetailsQuery,
    GetZoneDetailsQueryVariables
  >(GetZoneDetailsDocument, options);
}
export type GetZoneDetailsQueryHookResult = ReturnType<
  typeof useGetZoneDetailsQuery
>;
export type GetZoneDetailsLazyQueryHookResult = ReturnType<
  typeof useGetZoneDetailsLazyQuery
>;
export type GetZoneDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetZoneDetailsSuspenseQuery
>;
export type GetZoneDetailsQueryResult = Apollo.QueryResult<
  GetZoneDetailsQuery,
  GetZoneDetailsQueryVariables
>;
export const GetJobsiteConfigWorkerInfoDocument = gql`
  query GetJobsiteConfigWorkerInfo($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      jobsiteCustomWorkerDataFields {
        edges {
          node {
            id
            fieldDataType
            fieldLabel
            validationRegex
            validationMessage
            isRequired
          }
        }
      }
      onboardingModule {
        name
        badgePrintingAllowed
        badgeAssignmentAllowed
        steps {
          key
          index
          isRequired
          isVisible
          fields {
            key
            name
            index
            isRequired
            isHidden
            isEnforced
          }
        }
        documents {
          key
          workerDocTypeKey
          name
          index
          isRequired
          isVisible
          expiration
          gracePeriod
          fields {
            key
            name
            index
            isRequired
            isHidden
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteConfigWorkerInfoQuery__
 *
 * To run a query within a React component, call `useGetJobsiteConfigWorkerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteConfigWorkerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteConfigWorkerInfoQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteConfigWorkerInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteConfigWorkerInfoQuery,
    GetJobsiteConfigWorkerInfoQueryVariables
  > &
    (
      | { variables: GetJobsiteConfigWorkerInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteConfigWorkerInfoQuery,
    GetJobsiteConfigWorkerInfoQueryVariables
  >(GetJobsiteConfigWorkerInfoDocument, options);
}
export function useGetJobsiteConfigWorkerInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteConfigWorkerInfoQuery,
    GetJobsiteConfigWorkerInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteConfigWorkerInfoQuery,
    GetJobsiteConfigWorkerInfoQueryVariables
  >(GetJobsiteConfigWorkerInfoDocument, options);
}
export function useGetJobsiteConfigWorkerInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteConfigWorkerInfoQuery,
    GetJobsiteConfigWorkerInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteConfigWorkerInfoQuery,
    GetJobsiteConfigWorkerInfoQueryVariables
  >(GetJobsiteConfigWorkerInfoDocument, options);
}
export type GetJobsiteConfigWorkerInfoQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigWorkerInfoQuery
>;
export type GetJobsiteConfigWorkerInfoLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigWorkerInfoLazyQuery
>;
export type GetJobsiteConfigWorkerInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteConfigWorkerInfoSuspenseQuery
>;
export type GetJobsiteConfigWorkerInfoQueryResult = Apollo.QueryResult<
  GetJobsiteConfigWorkerInfoQuery,
  GetJobsiteConfigWorkerInfoQueryVariables
>;
export const GetAddJobsiteContractorWorkerJobsiteDocument = gql`
  query GetAddJobsiteContractorWorkerJobsite($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      name
      modules {
        ... on JobsiteOnboardingModule {
          name
          steps {
            key
            index
            isRequired
            isVisible
            fields {
              key
              name
              index
              isRequired
              isHidden
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetAddJobsiteContractorWorkerJobsiteQuery__
 *
 * To run a query within a React component, call `useGetAddJobsiteContractorWorkerJobsiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddJobsiteContractorWorkerJobsiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddJobsiteContractorWorkerJobsiteQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetAddJobsiteContractorWorkerJobsiteQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAddJobsiteContractorWorkerJobsiteQuery,
    GetAddJobsiteContractorWorkerJobsiteQueryVariables
  > &
    (
      | {
          variables: GetAddJobsiteContractorWorkerJobsiteQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAddJobsiteContractorWorkerJobsiteQuery,
    GetAddJobsiteContractorWorkerJobsiteQueryVariables
  >(GetAddJobsiteContractorWorkerJobsiteDocument, options);
}
export function useGetAddJobsiteContractorWorkerJobsiteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAddJobsiteContractorWorkerJobsiteQuery,
    GetAddJobsiteContractorWorkerJobsiteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAddJobsiteContractorWorkerJobsiteQuery,
    GetAddJobsiteContractorWorkerJobsiteQueryVariables
  >(GetAddJobsiteContractorWorkerJobsiteDocument, options);
}
export function useGetAddJobsiteContractorWorkerJobsiteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAddJobsiteContractorWorkerJobsiteQuery,
    GetAddJobsiteContractorWorkerJobsiteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAddJobsiteContractorWorkerJobsiteQuery,
    GetAddJobsiteContractorWorkerJobsiteQueryVariables
  >(GetAddJobsiteContractorWorkerJobsiteDocument, options);
}
export type GetAddJobsiteContractorWorkerJobsiteQueryHookResult = ReturnType<
  typeof useGetAddJobsiteContractorWorkerJobsiteQuery
>;
export type GetAddJobsiteContractorWorkerJobsiteLazyQueryHookResult =
  ReturnType<typeof useGetAddJobsiteContractorWorkerJobsiteLazyQuery>;
export type GetAddJobsiteContractorWorkerJobsiteSuspenseQueryHookResult =
  ReturnType<typeof useGetAddJobsiteContractorWorkerJobsiteSuspenseQuery>;
export type GetAddJobsiteContractorWorkerJobsiteQueryResult =
  Apollo.QueryResult<
    GetAddJobsiteContractorWorkerJobsiteQuery,
    GetAddJobsiteContractorWorkerJobsiteQueryVariables
  >;
export const GetAvailableJobsiteWorkersDocument = gql`
  query GetAvailableJobsiteWorkers(
    $jobsiteId: ID!
    $jobsiteJobsiteWorkersInput: JobsiteJobsiteWorkersInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      jobsiteWorkers(input: $jobsiteJobsiteWorkersInput) {
        count
        edges {
          node {
            jobsiteWorkerId
            stickerNumber
            isOnSite
            trade
            jobTitle
            isBanned
            banExpiresAt
            currentAccess {
              isAllowed
              notAllowedReason
              startDate
              endDate
            }
            contractorWorker {
              id
              contractor {
                contractorId
                organization {
                  organizationId
                  name
                }
              }
              worker {
                workerId
                birthDate
                quickCode
                user {
                  userAccountId
                  identity {
                    firstName
                    lastName
                    email
                  }
                  roles {
                    mappingId
                    key
                    displayName
                  }
                }
                profilePicture {
                  downloadUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetAvailableJobsiteWorkersQuery__
 *
 * To run a query within a React component, call `useGetAvailableJobsiteWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableJobsiteWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableJobsiteWorkersQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteJobsiteWorkersInput: // value for 'jobsiteJobsiteWorkersInput'
 *   },
 * });
 */
export function useGetAvailableJobsiteWorkersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAvailableJobsiteWorkersQuery,
    GetAvailableJobsiteWorkersQueryVariables
  > &
    (
      | { variables: GetAvailableJobsiteWorkersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAvailableJobsiteWorkersQuery,
    GetAvailableJobsiteWorkersQueryVariables
  >(GetAvailableJobsiteWorkersDocument, options);
}
export function useGetAvailableJobsiteWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAvailableJobsiteWorkersQuery,
    GetAvailableJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAvailableJobsiteWorkersQuery,
    GetAvailableJobsiteWorkersQueryVariables
  >(GetAvailableJobsiteWorkersDocument, options);
}
export function useGetAvailableJobsiteWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAvailableJobsiteWorkersQuery,
    GetAvailableJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAvailableJobsiteWorkersQuery,
    GetAvailableJobsiteWorkersQueryVariables
  >(GetAvailableJobsiteWorkersDocument, options);
}
export type GetAvailableJobsiteWorkersQueryHookResult = ReturnType<
  typeof useGetAvailableJobsiteWorkersQuery
>;
export type GetAvailableJobsiteWorkersLazyQueryHookResult = ReturnType<
  typeof useGetAvailableJobsiteWorkersLazyQuery
>;
export type GetAvailableJobsiteWorkersSuspenseQueryHookResult = ReturnType<
  typeof useGetAvailableJobsiteWorkersSuspenseQuery
>;
export type GetAvailableJobsiteWorkersQueryResult = Apollo.QueryResult<
  GetAvailableJobsiteWorkersQuery,
  GetAvailableJobsiteWorkersQueryVariables
>;
export const GetFormSubmissionAvailableWorkersDocument = gql`
  query GetFormSubmissionAvailableWorkers(
    $id: ID!
    $availableWorkersInput: JobsiteFormSubmissionAvailableWorkersInput!
  ) {
    getJobsiteFormSubmission(id: $id) {
      id
      jobsiteForm {
        id
        jobsite {
          jobsiteId
          name
        }
      }
      availableWorkers(input: $availableWorkersInput) {
        edges {
          node {
            workerId
            birthDate
            quickCode
            user {
              userAccountId
              identity {
                firstName
                lastName
                email
                phoneNumber
              }
            }
            profilePicture {
              downloadUrl
              uploadedAt
              fileId
            }
            profilePictureCropped {
              downloadUrl
              uploadedAt
              fileId
              fileType
            }
            jobsiteWorkers {
              edges {
                node {
                  jobsiteWorkerId
                  stickerNumber
                  trade
                  jobTitle
                  unionAffiliation
                  currentAccess {
                    isAllowed
                    notAllowedReason
                    startDate
                    endDate
                  }
                  jobsiteContractor {
                    id
                    jobsite {
                      jobsiteId
                      name
                    }
                    contractor {
                      contractorId
                      organization {
                        organizationId
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFormSubmissionAvailableWorkersQuery__
 *
 * To run a query within a React component, call `useGetFormSubmissionAvailableWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSubmissionAvailableWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSubmissionAvailableWorkersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      availableWorkersInput: // value for 'availableWorkersInput'
 *   },
 * });
 */
export function useGetFormSubmissionAvailableWorkersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormSubmissionAvailableWorkersQuery,
    GetFormSubmissionAvailableWorkersQueryVariables
  > &
    (
      | {
          variables: GetFormSubmissionAvailableWorkersQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFormSubmissionAvailableWorkersQuery,
    GetFormSubmissionAvailableWorkersQueryVariables
  >(GetFormSubmissionAvailableWorkersDocument, options);
}
export function useGetFormSubmissionAvailableWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormSubmissionAvailableWorkersQuery,
    GetFormSubmissionAvailableWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFormSubmissionAvailableWorkersQuery,
    GetFormSubmissionAvailableWorkersQueryVariables
  >(GetFormSubmissionAvailableWorkersDocument, options);
}
export function useGetFormSubmissionAvailableWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormSubmissionAvailableWorkersQuery,
    GetFormSubmissionAvailableWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFormSubmissionAvailableWorkersQuery,
    GetFormSubmissionAvailableWorkersQueryVariables
  >(GetFormSubmissionAvailableWorkersDocument, options);
}
export type GetFormSubmissionAvailableWorkersQueryHookResult = ReturnType<
  typeof useGetFormSubmissionAvailableWorkersQuery
>;
export type GetFormSubmissionAvailableWorkersLazyQueryHookResult = ReturnType<
  typeof useGetFormSubmissionAvailableWorkersLazyQuery
>;
export type GetFormSubmissionAvailableWorkersSuspenseQueryHookResult =
  ReturnType<typeof useGetFormSubmissionAvailableWorkersSuspenseQuery>;
export type GetFormSubmissionAvailableWorkersQueryResult = Apollo.QueryResult<
  GetFormSubmissionAvailableWorkersQuery,
  GetFormSubmissionAvailableWorkersQueryVariables
>;
export const GetFormSubmissionJobsiteContractorsDocument = gql`
  query GetFormSubmissionJobsiteContractors($id: ID!) {
    getJobsiteFormSubmission(id: $id) {
      id
      jobsiteContractors {
        edges {
          node {
            id
            extraData
            associationType
            jobsiteContractor {
              id
              contractor {
                contractorId
                organization {
                  organizationId
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFormSubmissionJobsiteContractorsQuery__
 *
 * To run a query within a React component, call `useGetFormSubmissionJobsiteContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSubmissionJobsiteContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSubmissionJobsiteContractorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFormSubmissionJobsiteContractorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormSubmissionJobsiteContractorsQuery,
    GetFormSubmissionJobsiteContractorsQueryVariables
  > &
    (
      | {
          variables: GetFormSubmissionJobsiteContractorsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFormSubmissionJobsiteContractorsQuery,
    GetFormSubmissionJobsiteContractorsQueryVariables
  >(GetFormSubmissionJobsiteContractorsDocument, options);
}
export function useGetFormSubmissionJobsiteContractorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormSubmissionJobsiteContractorsQuery,
    GetFormSubmissionJobsiteContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFormSubmissionJobsiteContractorsQuery,
    GetFormSubmissionJobsiteContractorsQueryVariables
  >(GetFormSubmissionJobsiteContractorsDocument, options);
}
export function useGetFormSubmissionJobsiteContractorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormSubmissionJobsiteContractorsQuery,
    GetFormSubmissionJobsiteContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFormSubmissionJobsiteContractorsQuery,
    GetFormSubmissionJobsiteContractorsQueryVariables
  >(GetFormSubmissionJobsiteContractorsDocument, options);
}
export type GetFormSubmissionJobsiteContractorsQueryHookResult = ReturnType<
  typeof useGetFormSubmissionJobsiteContractorsQuery
>;
export type GetFormSubmissionJobsiteContractorsLazyQueryHookResult = ReturnType<
  typeof useGetFormSubmissionJobsiteContractorsLazyQuery
>;
export type GetFormSubmissionJobsiteContractorsSuspenseQueryHookResult =
  ReturnType<typeof useGetFormSubmissionJobsiteContractorsSuspenseQuery>;
export type GetFormSubmissionJobsiteContractorsQueryResult = Apollo.QueryResult<
  GetFormSubmissionJobsiteContractorsQuery,
  GetFormSubmissionJobsiteContractorsQueryVariables
>;
export const GetFormSubmissionJobsiteWorkersDocument = gql`
  query GetFormSubmissionJobsiteWorkers(
    $id: ID!
    $jfsInput: JobsiteFormSubmissionWorkersInput
  ) {
    getJobsiteFormSubmission(id: $id) {
      id
      jobsiteForm {
        id
        jobsite {
          jobsiteId
          name
        }
      }
      jobsiteWorkers(input: $jfsInput) {
        edges {
          node {
            id
            extraData
            associationType
            historicalData {
              jobsiteWorkerAccess {
                isAllowedNow
              }
            }
            jobsiteWorker {
              jobsiteWorkerId
              stickerNumber
              isOnSite
              trade
              jobTitle
              unionAffiliation
              currentAccess {
                isAllowed
                notAllowedReason
                startDate
                endDate
              }
              jobsiteContractor {
                id
                jobsite {
                  jobsiteId
                  name
                }
                contractor {
                  contractorId
                  organization {
                    organizationId
                    name
                  }
                }
              }
              contractorWorker {
                id
                worker {
                  workerId
                  birthDate
                  quickCode
                  user {
                    userAccountId
                    identity {
                      firstName
                      lastName
                      email
                      phoneNumber
                    }
                  }
                  profilePicture {
                    downloadUrl
                  }
                }
              }
              activeTempWorkerCard {
                workerCardId
                expiredAt
                cardNumber
                tempBadge {
                  id
                  name
                  cardNumber
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetFormSubmissionJobsiteWorkersQuery__
 *
 * To run a query within a React component, call `useGetFormSubmissionJobsiteWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormSubmissionJobsiteWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormSubmissionJobsiteWorkersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      jfsInput: // value for 'jfsInput'
 *   },
 * });
 */
export function useGetFormSubmissionJobsiteWorkersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFormSubmissionJobsiteWorkersQuery,
    GetFormSubmissionJobsiteWorkersQueryVariables
  > &
    (
      | {
          variables: GetFormSubmissionJobsiteWorkersQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetFormSubmissionJobsiteWorkersQuery,
    GetFormSubmissionJobsiteWorkersQueryVariables
  >(GetFormSubmissionJobsiteWorkersDocument, options);
}
export function useGetFormSubmissionJobsiteWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFormSubmissionJobsiteWorkersQuery,
    GetFormSubmissionJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetFormSubmissionJobsiteWorkersQuery,
    GetFormSubmissionJobsiteWorkersQueryVariables
  >(GetFormSubmissionJobsiteWorkersDocument, options);
}
export function useGetFormSubmissionJobsiteWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetFormSubmissionJobsiteWorkersQuery,
    GetFormSubmissionJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetFormSubmissionJobsiteWorkersQuery,
    GetFormSubmissionJobsiteWorkersQueryVariables
  >(GetFormSubmissionJobsiteWorkersDocument, options);
}
export type GetFormSubmissionJobsiteWorkersQueryHookResult = ReturnType<
  typeof useGetFormSubmissionJobsiteWorkersQuery
>;
export type GetFormSubmissionJobsiteWorkersLazyQueryHookResult = ReturnType<
  typeof useGetFormSubmissionJobsiteWorkersLazyQuery
>;
export type GetFormSubmissionJobsiteWorkersSuspenseQueryHookResult = ReturnType<
  typeof useGetFormSubmissionJobsiteWorkersSuspenseQuery
>;
export type GetFormSubmissionJobsiteWorkersQueryResult = Apollo.QueryResult<
  GetFormSubmissionJobsiteWorkersQuery,
  GetFormSubmissionJobsiteWorkersQueryVariables
>;
export const GetJobsiteTimeSeriesDocument = gql`
  query GetJobsiteTimeSeries(
    $jobsiteId: ID!
    $timeSeriesInput: JobsiteTimeSeriesInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      timeSeries(input: $timeSeriesInput) {
        sessions {
          dateTime
          timeZone
          value
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteTimeSeriesQuery__
 *
 * To run a query within a React component, call `useGetJobsiteTimeSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteTimeSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteTimeSeriesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      timeSeriesInput: // value for 'timeSeriesInput'
 *   },
 * });
 */
export function useGetJobsiteTimeSeriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteTimeSeriesQuery,
    GetJobsiteTimeSeriesQueryVariables
  > &
    (
      | { variables: GetJobsiteTimeSeriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteTimeSeriesQuery,
    GetJobsiteTimeSeriesQueryVariables
  >(GetJobsiteTimeSeriesDocument, options);
}
export function useGetJobsiteTimeSeriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteTimeSeriesQuery,
    GetJobsiteTimeSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteTimeSeriesQuery,
    GetJobsiteTimeSeriesQueryVariables
  >(GetJobsiteTimeSeriesDocument, options);
}
export function useGetJobsiteTimeSeriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteTimeSeriesQuery,
    GetJobsiteTimeSeriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteTimeSeriesQuery,
    GetJobsiteTimeSeriesQueryVariables
  >(GetJobsiteTimeSeriesDocument, options);
}
export type GetJobsiteTimeSeriesQueryHookResult = ReturnType<
  typeof useGetJobsiteTimeSeriesQuery
>;
export type GetJobsiteTimeSeriesLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteTimeSeriesLazyQuery
>;
export type GetJobsiteTimeSeriesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteTimeSeriesSuspenseQuery
>;
export type GetJobsiteTimeSeriesQueryResult = Apollo.QueryResult<
  GetJobsiteTimeSeriesQuery,
  GetJobsiteTimeSeriesQueryVariables
>;
export const GetJobsiteWorkerDashboardReportDocument = gql`
  query GetJobsiteWorkerDashboardReport(
    $jobsiteIds: [ID!]!
    $startDate: Date!
    $endDate: Date!
    $timeBreakdown: GetJobsiteWorkerReportsTimeBreakdown
    $realtime: Boolean
    $limit: Int
    $offset: Int
    $sortField: String
    $sortDir: String
    $export: Boolean
    $trade: String
    $jobTitle: String
    $contractor: [String!]
    $fitoutTenant: String
    $active: Boolean
    $compliant: Boolean
    $workerIds: [ID!]
  ) {
    getJobsiteWorkerDashboard(
      jobsiteIds: $jobsiteIds
      startDate: $startDate
      endDate: $endDate
      timeBreakdown: $timeBreakdown
      realtime: $realtime
      limit: $limit
      offset: $offset
      sortField: $sortField
      sortDir: $sortDir
      export: $export
      trade: $trade
      jobTitle: $jobTitle
      contractor: $contractor
      fitoutTenant: $fitoutTenant
      active: $active
      compliant: $compliant
      workerIds: $workerIds
    ) {
      jobsites {
        jobsiteId
        name
      }
      overviewBreakdowns {
        name
        count
        compliantCount
        percentage
      }
    }
  }
`;

/**
 * __useGetJobsiteWorkerDashboardReportQuery__
 *
 * To run a query within a React component, call `useGetJobsiteWorkerDashboardReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteWorkerDashboardReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteWorkerDashboardReportQuery({
 *   variables: {
 *      jobsiteIds: // value for 'jobsiteIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timeBreakdown: // value for 'timeBreakdown'
 *      realtime: // value for 'realtime'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortField: // value for 'sortField'
 *      sortDir: // value for 'sortDir'
 *      export: // value for 'export'
 *      trade: // value for 'trade'
 *      jobTitle: // value for 'jobTitle'
 *      contractor: // value for 'contractor'
 *      fitoutTenant: // value for 'fitoutTenant'
 *      active: // value for 'active'
 *      compliant: // value for 'compliant'
 *      workerIds: // value for 'workerIds'
 *   },
 * });
 */
export function useGetJobsiteWorkerDashboardReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteWorkerDashboardReportQuery,
    GetJobsiteWorkerDashboardReportQueryVariables
  > &
    (
      | {
          variables: GetJobsiteWorkerDashboardReportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteWorkerDashboardReportQuery,
    GetJobsiteWorkerDashboardReportQueryVariables
  >(GetJobsiteWorkerDashboardReportDocument, options);
}
export function useGetJobsiteWorkerDashboardReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteWorkerDashboardReportQuery,
    GetJobsiteWorkerDashboardReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteWorkerDashboardReportQuery,
    GetJobsiteWorkerDashboardReportQueryVariables
  >(GetJobsiteWorkerDashboardReportDocument, options);
}
export function useGetJobsiteWorkerDashboardReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteWorkerDashboardReportQuery,
    GetJobsiteWorkerDashboardReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteWorkerDashboardReportQuery,
    GetJobsiteWorkerDashboardReportQueryVariables
  >(GetJobsiteWorkerDashboardReportDocument, options);
}
export type GetJobsiteWorkerDashboardReportQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDashboardReportQuery
>;
export type GetJobsiteWorkerDashboardReportLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDashboardReportLazyQuery
>;
export type GetJobsiteWorkerDashboardReportSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDashboardReportSuspenseQuery
>;
export type GetJobsiteWorkerDashboardReportQueryResult = Apollo.QueryResult<
  GetJobsiteWorkerDashboardReportQuery,
  GetJobsiteWorkerDashboardReportQueryVariables
>;
export const GetJobsiteFormSubmissionDocument = gql`
  query GetJobsiteFormSubmission($id: ID!) {
    getJobsiteFormSubmission(id: $id) {
      id
      startAt
      isStartTimeSpecified
      endAt
      timeZone
      extraData
      objectHistory {
        createdBy {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
      }
      weatherConditions {
        timestamp
        description
        icon
        temp
        windSpeed
        windDirectionCardinal
      }
      jobsiteForm {
        id
        form {
          id
          key
          content
        }
        jobsite {
          jobsiteId
          jobsiteNumber
          name
          modules {
            ... on JobsiteFeaturesModule {
              formsEnabled
              addWorkersToDailyLog
              isEnabled
              name
              slug
            }
          }
        }
      }
      jobsiteContractors {
        edges {
          node {
            id
            extraData
            associationType
            jobsiteContractor {
              id
              contractor {
                contractorId
                organization {
                  organizationId
                  name
                }
              }
            }
          }
        }
      }
      jobsiteWorkers {
        count
        edges {
          node {
            id
            extraData
            associationType
            jobsiteWorker {
              jobsiteWorkerId
            }
          }
        }
      }
      documents {
        count
        edges {
          node {
            id
            description
            associationType
            files {
              fileId
              fileType
              downloadUrl
              originalFileName
            }
            objectHistory {
              createdAt
              createdBy {
                identity {
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteFormSubmissionQuery__
 *
 * To run a query within a React component, call `useGetJobsiteFormSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteFormSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteFormSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobsiteFormSubmissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteFormSubmissionQuery,
    GetJobsiteFormSubmissionQueryVariables
  > &
    (
      | { variables: GetJobsiteFormSubmissionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteFormSubmissionQuery,
    GetJobsiteFormSubmissionQueryVariables
  >(GetJobsiteFormSubmissionDocument, options);
}
export function useGetJobsiteFormSubmissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteFormSubmissionQuery,
    GetJobsiteFormSubmissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteFormSubmissionQuery,
    GetJobsiteFormSubmissionQueryVariables
  >(GetJobsiteFormSubmissionDocument, options);
}
export function useGetJobsiteFormSubmissionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteFormSubmissionQuery,
    GetJobsiteFormSubmissionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteFormSubmissionQuery,
    GetJobsiteFormSubmissionQueryVariables
  >(GetJobsiteFormSubmissionDocument, options);
}
export type GetJobsiteFormSubmissionQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionQuery
>;
export type GetJobsiteFormSubmissionLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionLazyQuery
>;
export type GetJobsiteFormSubmissionSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionSuspenseQuery
>;
export type GetJobsiteFormSubmissionQueryResult = Apollo.QueryResult<
  GetJobsiteFormSubmissionQuery,
  GetJobsiteFormSubmissionQueryVariables
>;
export const GetJobsiteFormSubmissionHistoricalDataDocument = gql`
  query GetJobsiteFormSubmissionHistoricalData($id: ID!) {
    getJobsiteFormSubmission(id: $id) {
      id
      jobsiteWorkers {
        count
        edges {
          node {
            id
            extraData
            objectHistory {
              createdAt
            }
            historicalData {
              jobsiteWorkerAccess {
                isAllowedNow
                notAllowedReason
                jobsiteIsDisabledAccess
                jobsiteAccessReadmissionDate
                endDate
                isAntipassbackExempt
                siteSpecificTrainingCompletedAt
                siteSpecificTrainingExpiredAt
                siteSpecificTrainingSkipReason
                safetyDocumentsCompletedAt
                safetyDocumentsExpiredAt
                safetyDocumentsSkipReason
                orientationMedicalCompletedAt
                orientationMedicalExpiredAt
                orientationMedicalSkipReason
                nycSstExemptionReason
                safetyDocumentStatus
                jobsiteWorker {
                  jobsiteWorkerId
                  trade
                  jobTitle
                  unionAffiliation
                  isBanned
                  bannedReason
                  bannedAt
                  banRemovedReason
                  startDate
                  endDate
                  payrollId
                  siteSpecificTrainingCompletedAt
                  stickerNumber
                  orientationDate
                  orientationStatus
                  documentsCompletedSkipExpiresAt
                  urineTestConditionalPassExpiresAt
                  banExpiresAt
                  isSuspended
                  badgingCompletedAt
                  medicalNotes
                  nycSstExemptionReason
                  siteAccessChangeApprovedBy
                  isExemptFromSwipeInactivity
                  isExemptFromSiteSpecificRefresher
                  customWorkerData
                  jobsiteContractor {
                    jobsite {
                      name
                      jobsiteId
                      parentId
                      developer {
                        developerId
                        name
                      }
                      jobsiteCustomWorkerDataFields {
                        edges {
                          node {
                            fieldLabel
                            fieldDataType
                            isRequired
                            validationMessage
                            validationRegex
                          }
                        }
                      }
                    }
                  }
                  contractorWorker {
                    worker {
                      workerId
                      documents {
                        edges {
                          node {
                            jobsiteWorkerDocumentId
                            jobsiteWorkerDocumentType {
                              expiration
                              jobsite {
                                name
                                jobsiteId
                                developer {
                                  name
                                  developerId
                                }
                              }
                              workerDocumentType {
                                name
                                key
                                expirationDate
                                isGlobal
                                documentLevel
                              }
                            }
                            jobsiteWorker {
                              jobsiteContractor {
                                jobsite {
                                  jobsiteId
                                }
                              }
                              jobsiteWorkerId
                            }
                            latestVersion {
                              jobsiteWorkerDocumentVersionId
                              files {
                                fileId
                                fileType
                                downloadUrl
                              }
                              additionalFieldValues {
                                key
                                value
                              }
                              objectHistory {
                                createdAt
                                createdBy {
                                  userAccountId
                                  identity {
                                    firstName
                                    lastName
                                    email
                                  }
                                }
                                updatedAt
                                updatedBy {
                                  userAccountId
                                  identity {
                                    firstName
                                    lastName
                                    email
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                      jobsiteAccessEvents {
                        edges {
                          node {
                            id
                            status
                            timeStamp
                            eventOccurredAt
                            timeZone
                            overnightSession
                            gateway
                            direction
                            eventType
                            credentialId
                          }
                        }
                      }
                      objectHistory {
                        createdAt
                        createdBy {
                          userAccountId
                          identity {
                            firstName
                            lastName
                            email
                          }
                        }
                        updatedAt
                        updatedBy {
                          userAccountId
                          identity {
                            firstName
                            lastName
                            email
                          }
                        }
                      }
                    }
                    contractor {
                      contractorId
                      organization {
                        organizationId
                        name
                      }
                    }
                  }
                  objectHistory {
                    createdAt
                    createdBy {
                      userAccountId
                      identity {
                        firstName
                        lastName
                        email
                      }
                    }
                    updatedAt
                    updatedBy {
                      userAccountId
                      identity {
                        firstName
                        lastName
                        email
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteFormSubmissionHistoricalDataQuery__
 *
 * To run a query within a React component, call `useGetJobsiteFormSubmissionHistoricalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteFormSubmissionHistoricalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteFormSubmissionHistoricalDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobsiteFormSubmissionHistoricalDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteFormSubmissionHistoricalDataQuery,
    GetJobsiteFormSubmissionHistoricalDataQueryVariables
  > &
    (
      | {
          variables: GetJobsiteFormSubmissionHistoricalDataQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteFormSubmissionHistoricalDataQuery,
    GetJobsiteFormSubmissionHistoricalDataQueryVariables
  >(GetJobsiteFormSubmissionHistoricalDataDocument, options);
}
export function useGetJobsiteFormSubmissionHistoricalDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteFormSubmissionHistoricalDataQuery,
    GetJobsiteFormSubmissionHistoricalDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteFormSubmissionHistoricalDataQuery,
    GetJobsiteFormSubmissionHistoricalDataQueryVariables
  >(GetJobsiteFormSubmissionHistoricalDataDocument, options);
}
export function useGetJobsiteFormSubmissionHistoricalDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteFormSubmissionHistoricalDataQuery,
    GetJobsiteFormSubmissionHistoricalDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteFormSubmissionHistoricalDataQuery,
    GetJobsiteFormSubmissionHistoricalDataQueryVariables
  >(GetJobsiteFormSubmissionHistoricalDataDocument, options);
}
export type GetJobsiteFormSubmissionHistoricalDataQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionHistoricalDataQuery
>;
export type GetJobsiteFormSubmissionHistoricalDataLazyQueryHookResult =
  ReturnType<typeof useGetJobsiteFormSubmissionHistoricalDataLazyQuery>;
export type GetJobsiteFormSubmissionHistoricalDataSuspenseQueryHookResult =
  ReturnType<typeof useGetJobsiteFormSubmissionHistoricalDataSuspenseQuery>;
export type GetJobsiteFormSubmissionHistoricalDataQueryResult =
  Apollo.QueryResult<
    GetJobsiteFormSubmissionHistoricalDataQuery,
    GetJobsiteFormSubmissionHistoricalDataQueryVariables
  >;
export const GetJobsiteFormSubmissionReportDocument = gql`
  query GetJobsiteFormSubmissionReport($id: ID!) {
    getJobsiteFormSubmission(id: $id) {
      id
      startAt
      isStartTimeSpecified
      endAt
      timeZone
      extraData
      weatherConditions {
        timestamp
        description
        icon
        temp
        windSpeed
        windDirectionCardinal
      }
      jobsiteForm {
        id
        form {
          id
          key
          name
          content
        }
        jobsite {
          jobsiteId
          jobsiteNumber
          name
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZipCode
        }
      }
      jobsiteContractors {
        edges {
          node {
            id
            extraData
            associationType
            jobsiteContractor {
              id
              contractor {
                contractorId
                organization {
                  organizationId
                  name
                  addressLine1
                  addressLine2
                  addressCity
                  addressState
                  addressZipCode
                }
              }
            }
          }
        }
      }
      jobsiteWorkers {
        count
        edges {
          node {
            id
            extraData
            associationType
            jobsiteWorker {
              jobsiteWorkerId
              trade
              jobTitle
              unionAffiliation
              contractorWorker {
                id
                contractor {
                  contractorId
                  organization {
                    organizationId
                    name
                  }
                }
                worker {
                  workerId
                  birthDate
                  quickCode
                  user {
                    userAccountId
                    identity {
                      firstName
                      lastName
                    }
                  }
                  profilePictureCropped {
                    downloadUrl
                  }
                }
              }
              activeTempWorkerCard {
                workerCardId
                expiredAt
                cardNumber
                tempBadge {
                  id
                  name
                  cardNumber
                }
              }
            }
          }
        }
      }
      documents {
        count
        edges {
          node {
            id
            description
            associationType
            files {
              fileId
              fileType
              downloadUrl
              originalFileName
            }
            objectHistory {
              createdAt
              createdBy {
                identity {
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
      objectHistory {
        createdAt
        createdBy {
          userAccountId
          identity {
            firstName
            lastName
            phoneNumber
            email
          }
          worker {
            workerId
            profilePictureCropped {
              downloadUrl
            }
            formSubmissionJobsiteWorker(input: { formSubmissionId: $id }) {
              trade
              jobTitle
            }
          }
        }
        updatedAt
        updatedBy {
          identity {
            firstName
            lastName
          }
          worker {
            workerId
            profilePictureCropped {
              downloadUrl
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteFormSubmissionReportQuery__
 *
 * To run a query within a React component, call `useGetJobsiteFormSubmissionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteFormSubmissionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteFormSubmissionReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobsiteFormSubmissionReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteFormSubmissionReportQuery,
    GetJobsiteFormSubmissionReportQueryVariables
  > &
    (
      | {
          variables: GetJobsiteFormSubmissionReportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteFormSubmissionReportQuery,
    GetJobsiteFormSubmissionReportQueryVariables
  >(GetJobsiteFormSubmissionReportDocument, options);
}
export function useGetJobsiteFormSubmissionReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteFormSubmissionReportQuery,
    GetJobsiteFormSubmissionReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteFormSubmissionReportQuery,
    GetJobsiteFormSubmissionReportQueryVariables
  >(GetJobsiteFormSubmissionReportDocument, options);
}
export function useGetJobsiteFormSubmissionReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteFormSubmissionReportQuery,
    GetJobsiteFormSubmissionReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteFormSubmissionReportQuery,
    GetJobsiteFormSubmissionReportQueryVariables
  >(GetJobsiteFormSubmissionReportDocument, options);
}
export type GetJobsiteFormSubmissionReportQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionReportQuery
>;
export type GetJobsiteFormSubmissionReportLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionReportLazyQuery
>;
export type GetJobsiteFormSubmissionReportSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteFormSubmissionReportSuspenseQuery
>;
export type GetJobsiteFormSubmissionReportQueryResult = Apollo.QueryResult<
  GetJobsiteFormSubmissionReportQuery,
  GetJobsiteFormSubmissionReportQueryVariables
>;
export const FormUpdateDocument = gql`
  mutation FormUpdate($input: FormUpdateInput!) {
    formUpdate(input: $input) {
      form {
        id
      }
    }
  }
`;
export type FormUpdateMutationFn = Apollo.MutationFunction<
  FormUpdateMutation,
  FormUpdateMutationVariables
>;

/**
 * __useFormUpdateMutation__
 *
 * To run a mutation, you first call `useFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formUpdateMutation, { data, loading, error }] = useFormUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFormUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FormUpdateMutation,
    FormUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FormUpdateMutation, FormUpdateMutationVariables>(
    FormUpdateDocument,
    options,
  );
}
export type FormUpdateMutationHookResult = ReturnType<
  typeof useFormUpdateMutation
>;
export type FormUpdateMutationResult =
  Apollo.MutationResult<FormUpdateMutation>;
export type FormUpdateMutationOptions = Apollo.BaseMutationOptions<
  FormUpdateMutation,
  FormUpdateMutationVariables
>;
export const JobsiteUpdateFormSubmissionDocument = gql`
  mutation JobsiteUpdateFormSubmission(
    $input: JobsiteUpdateFormSubmissionInput!
  ) {
    jobsiteUpdateFormSubmission(input: $input) {
      jobsiteFormSubmission {
        id
      }
    }
  }
`;
export type JobsiteUpdateFormSubmissionMutationFn = Apollo.MutationFunction<
  JobsiteUpdateFormSubmissionMutation,
  JobsiteUpdateFormSubmissionMutationVariables
>;

/**
 * __useJobsiteUpdateFormSubmissionMutation__
 *
 * To run a mutation, you first call `useJobsiteUpdateFormSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteUpdateFormSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteUpdateFormSubmissionMutation, { data, loading, error }] = useJobsiteUpdateFormSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteUpdateFormSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteUpdateFormSubmissionMutation,
    JobsiteUpdateFormSubmissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteUpdateFormSubmissionMutation,
    JobsiteUpdateFormSubmissionMutationVariables
  >(JobsiteUpdateFormSubmissionDocument, options);
}
export type JobsiteUpdateFormSubmissionMutationHookResult = ReturnType<
  typeof useJobsiteUpdateFormSubmissionMutation
>;
export type JobsiteUpdateFormSubmissionMutationResult =
  Apollo.MutationResult<JobsiteUpdateFormSubmissionMutation>;
export type JobsiteUpdateFormSubmissionMutationOptions =
  Apollo.BaseMutationOptions<
    JobsiteUpdateFormSubmissionMutation,
    JobsiteUpdateFormSubmissionMutationVariables
  >;
export const JobsiteCloseOutDocument = gql`
  mutation JobsiteCloseOut($input: JobsiteCloseOutInput!) {
    jobsiteCloseOut(input: $input) {
      jobsite {
        jobsiteId
      }
    }
  }
`;
export type JobsiteCloseOutMutationFn = Apollo.MutationFunction<
  JobsiteCloseOutMutation,
  JobsiteCloseOutMutationVariables
>;

/**
 * __useJobsiteCloseOutMutation__
 *
 * To run a mutation, you first call `useJobsiteCloseOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteCloseOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteCloseOutMutation, { data, loading, error }] = useJobsiteCloseOutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteCloseOutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteCloseOutMutation,
    JobsiteCloseOutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteCloseOutMutation,
    JobsiteCloseOutMutationVariables
  >(JobsiteCloseOutDocument, options);
}
export type JobsiteCloseOutMutationHookResult = ReturnType<
  typeof useJobsiteCloseOutMutation
>;
export type JobsiteCloseOutMutationResult =
  Apollo.MutationResult<JobsiteCloseOutMutation>;
export type JobsiteCloseOutMutationOptions = Apollo.BaseMutationOptions<
  JobsiteCloseOutMutation,
  JobsiteCloseOutMutationVariables
>;
export const JobsiteCreateDocument = gql`
  mutation JobsiteCreate($input: JobsiteCreateInput!) {
    jobsiteCreate(input: $input) {
      jobsite {
        jobsiteId
      }
    }
  }
`;
export type JobsiteCreateMutationFn = Apollo.MutationFunction<
  JobsiteCreateMutation,
  JobsiteCreateMutationVariables
>;

/**
 * __useJobsiteCreateMutation__
 *
 * To run a mutation, you first call `useJobsiteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteCreateMutation, { data, loading, error }] = useJobsiteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteCreateMutation,
    JobsiteCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteCreateMutation,
    JobsiteCreateMutationVariables
  >(JobsiteCreateDocument, options);
}
export type JobsiteCreateMutationHookResult = ReturnType<
  typeof useJobsiteCreateMutation
>;
export type JobsiteCreateMutationResult =
  Apollo.MutationResult<JobsiteCreateMutation>;
export type JobsiteCreateMutationOptions = Apollo.BaseMutationOptions<
  JobsiteCreateMutation,
  JobsiteCreateMutationVariables
>;
export const GetJobsiteTemplatesDocument = gql`
  query GetJobsiteTemplates {
    getCurrentSession {
      user {
        userAccountId
        jobsites(input: { isTemplate: true }) {
          edges {
            node {
              jobsiteId
              name
              developer {
                developerId
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteTemplatesQuery__
 *
 * To run a query within a React component, call `useGetJobsiteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobsiteTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobsiteTemplatesQuery,
    GetJobsiteTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteTemplatesQuery,
    GetJobsiteTemplatesQueryVariables
  >(GetJobsiteTemplatesDocument, options);
}
export function useGetJobsiteTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteTemplatesQuery,
    GetJobsiteTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteTemplatesQuery,
    GetJobsiteTemplatesQueryVariables
  >(GetJobsiteTemplatesDocument, options);
}
export function useGetJobsiteTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteTemplatesQuery,
    GetJobsiteTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteTemplatesQuery,
    GetJobsiteTemplatesQueryVariables
  >(GetJobsiteTemplatesDocument, options);
}
export type GetJobsiteTemplatesQueryHookResult = ReturnType<
  typeof useGetJobsiteTemplatesQuery
>;
export type GetJobsiteTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteTemplatesLazyQuery
>;
export type GetJobsiteTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteTemplatesSuspenseQuery
>;
export type GetJobsiteTemplatesQueryResult = Apollo.QueryResult<
  GetJobsiteTemplatesQuery,
  GetJobsiteTemplatesQueryVariables
>;
export const GetJobsitesContainerCurrentSessionDocument = gql`
  query GetJobsitesContainerCurrentSession(
    $userJobsitesInput: UserJobsitesInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        jobsites(input: $userJobsitesInput) {
          count
          templatesCount
          edges {
            node {
              jobsiteId
              name
              addressCity
              addressState
              developer {
                developerId
                organization {
                  organizationId
                  name
                }
              }
              startDate
              endDate
            }
          }
          filtersOptions {
            developers {
              value
              label
              count
            }
            cities {
              value
              label
              count
            }
            states {
              value
              label
              count
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsitesContainerCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetJobsitesContainerCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsitesContainerCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsitesContainerCurrentSessionQuery({
 *   variables: {
 *      userJobsitesInput: // value for 'userJobsitesInput'
 *   },
 * });
 */
export function useGetJobsitesContainerCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobsitesContainerCurrentSessionQuery,
    GetJobsitesContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsitesContainerCurrentSessionQuery,
    GetJobsitesContainerCurrentSessionQueryVariables
  >(GetJobsitesContainerCurrentSessionDocument, options);
}
export function useGetJobsitesContainerCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsitesContainerCurrentSessionQuery,
    GetJobsitesContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsitesContainerCurrentSessionQuery,
    GetJobsitesContainerCurrentSessionQueryVariables
  >(GetJobsitesContainerCurrentSessionDocument, options);
}
export function useGetJobsitesContainerCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsitesContainerCurrentSessionQuery,
    GetJobsitesContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsitesContainerCurrentSessionQuery,
    GetJobsitesContainerCurrentSessionQueryVariables
  >(GetJobsitesContainerCurrentSessionDocument, options);
}
export type GetJobsitesContainerCurrentSessionQueryHookResult = ReturnType<
  typeof useGetJobsitesContainerCurrentSessionQuery
>;
export type GetJobsitesContainerCurrentSessionLazyQueryHookResult = ReturnType<
  typeof useGetJobsitesContainerCurrentSessionLazyQuery
>;
export type GetJobsitesContainerCurrentSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetJobsitesContainerCurrentSessionSuspenseQuery>;
export type GetJobsitesContainerCurrentSessionQueryResult = Apollo.QueryResult<
  GetJobsitesContainerCurrentSessionQuery,
  GetJobsitesContainerCurrentSessionQueryVariables
>;
export const AuthenticateLimitedTokenDetailsDocument = gql`
  mutation AuthenticateLimitedTokenDetails(
    $input: AuthenticateLimitedTokenDetailsInput!
  ) {
    authenticateLimitedTokenDetails(input: $input) {
      token
    }
  }
`;
export type AuthenticateLimitedTokenDetailsMutationFn = Apollo.MutationFunction<
  AuthenticateLimitedTokenDetailsMutation,
  AuthenticateLimitedTokenDetailsMutationVariables
>;

/**
 * __useAuthenticateLimitedTokenDetailsMutation__
 *
 * To run a mutation, you first call `useAuthenticateLimitedTokenDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateLimitedTokenDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateLimitedTokenDetailsMutation, { data, loading, error }] = useAuthenticateLimitedTokenDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticateLimitedTokenDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthenticateLimitedTokenDetailsMutation,
    AuthenticateLimitedTokenDetailsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AuthenticateLimitedTokenDetailsMutation,
    AuthenticateLimitedTokenDetailsMutationVariables
  >(AuthenticateLimitedTokenDetailsDocument, options);
}
export type AuthenticateLimitedTokenDetailsMutationHookResult = ReturnType<
  typeof useAuthenticateLimitedTokenDetailsMutation
>;
export type AuthenticateLimitedTokenDetailsMutationResult =
  Apollo.MutationResult<AuthenticateLimitedTokenDetailsMutation>;
export type AuthenticateLimitedTokenDetailsMutationOptions =
  Apollo.BaseMutationOptions<
    AuthenticateLimitedTokenDetailsMutation,
    AuthenticateLimitedTokenDetailsMutationVariables
  >;
export const GetRecentUserSearchQueriesDocument = gql`
  query GetRecentUserSearchQueries(
    $searchQueryType: SearchQueryType
    $count: Int
  ) {
    getRecentUserSearchQueries(
      searchQueryType: $searchQueryType
      count: $count
    ) {
      results {
        searchQuery
        searchQueryType
        createdAt
      }
    }
  }
`;

/**
 * __useGetRecentUserSearchQueriesQuery__
 *
 * To run a query within a React component, call `useGetRecentUserSearchQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentUserSearchQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentUserSearchQueriesQuery({
 *   variables: {
 *      searchQueryType: // value for 'searchQueryType'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetRecentUserSearchQueriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRecentUserSearchQueriesQuery,
    GetRecentUserSearchQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRecentUserSearchQueriesQuery,
    GetRecentUserSearchQueriesQueryVariables
  >(GetRecentUserSearchQueriesDocument, options);
}
export function useGetRecentUserSearchQueriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecentUserSearchQueriesQuery,
    GetRecentUserSearchQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRecentUserSearchQueriesQuery,
    GetRecentUserSearchQueriesQueryVariables
  >(GetRecentUserSearchQueriesDocument, options);
}
export function useGetRecentUserSearchQueriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRecentUserSearchQueriesQuery,
    GetRecentUserSearchQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRecentUserSearchQueriesQuery,
    GetRecentUserSearchQueriesQueryVariables
  >(GetRecentUserSearchQueriesDocument, options);
}
export type GetRecentUserSearchQueriesQueryHookResult = ReturnType<
  typeof useGetRecentUserSearchQueriesQuery
>;
export type GetRecentUserSearchQueriesLazyQueryHookResult = ReturnType<
  typeof useGetRecentUserSearchQueriesLazyQuery
>;
export type GetRecentUserSearchQueriesSuspenseQueryHookResult = ReturnType<
  typeof useGetRecentUserSearchQueriesSuspenseQuery
>;
export type GetRecentUserSearchQueriesQueryResult = Apollo.QueryResult<
  GetRecentUserSearchQueriesQuery,
  GetRecentUserSearchQueriesQueryVariables
>;
export const SaveUserSearchQueryDocument = gql`
  mutation SaveUserSearchQuery($input: UserSearchQueryInput!) {
    saveUserSearchQuery(input: $input) {
      success
    }
  }
`;
export type SaveUserSearchQueryMutationFn = Apollo.MutationFunction<
  SaveUserSearchQueryMutation,
  SaveUserSearchQueryMutationVariables
>;

/**
 * __useSaveUserSearchQueryMutation__
 *
 * To run a mutation, you first call `useSaveUserSearchQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserSearchQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserSearchQueryMutation, { data, loading, error }] = useSaveUserSearchQueryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserSearchQueryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveUserSearchQueryMutation,
    SaveUserSearchQueryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveUserSearchQueryMutation,
    SaveUserSearchQueryMutationVariables
  >(SaveUserSearchQueryDocument, options);
}
export type SaveUserSearchQueryMutationHookResult = ReturnType<
  typeof useSaveUserSearchQueryMutation
>;
export type SaveUserSearchQueryMutationResult =
  Apollo.MutationResult<SaveUserSearchQueryMutation>;
export type SaveUserSearchQueryMutationOptions = Apollo.BaseMutationOptions<
  SaveUserSearchQueryMutation,
  SaveUserSearchQueryMutationVariables
>;
export const DeleteOrganizationDocument = gql`
  mutation DeleteOrganization($organizationId: ID!) {
    organizationDelete(organizationId: $organizationId) {
      success {
        success
      }
    }
  }
`;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<
  DeleteOrganizationMutation,
  DeleteOrganizationMutationVariables
>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOrganizationMutation,
    DeleteOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteOrganizationMutation,
    DeleteOrganizationMutationVariables
  >(DeleteOrganizationDocument, options);
}
export type DeleteOrganizationMutationHookResult = ReturnType<
  typeof useDeleteOrganizationMutation
>;
export type DeleteOrganizationMutationResult =
  Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<
  DeleteOrganizationMutation,
  DeleteOrganizationMutationVariables
>;
export const GetOrganizationContainerOrganizationInfoDocument = gql`
  query GetOrganizationContainerOrganizationInfo(
    $organizationId: ID!
    $includeArchived: Boolean!
  ) {
    getOrganization(
      organizationId: $organizationId
      includeArchived: $includeArchived
    ) {
      organizationId
      name
      slug
      legalName
      email
      phoneNumber
      addressLine1
      addressLine2
      addressCity
      addressCity
      addressState
      addressZipCode
      objectHistory {
        createdAt
        createdBy {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
        updatedAt
        updatedBy {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
      }
      developers {
        __typename
        count
        edges {
          node {
            __typename
            developerId
            name
          }
        }
      }
      contractors {
        __typename
        count
        edges {
          __typename
          node {
            __typename
            contractorId
            description
            websiteUrl
            jobsiteContractors {
              __typename
              count
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationContainerOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizationContainerOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationContainerOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationContainerOrganizationInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetOrganizationContainerOrganizationInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrganizationContainerOrganizationInfoQuery,
    GetOrganizationContainerOrganizationInfoQueryVariables
  > &
    (
      | {
          variables: GetOrganizationContainerOrganizationInfoQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationContainerOrganizationInfoQuery,
    GetOrganizationContainerOrganizationInfoQueryVariables
  >(GetOrganizationContainerOrganizationInfoDocument, options);
}
export function useGetOrganizationContainerOrganizationInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationContainerOrganizationInfoQuery,
    GetOrganizationContainerOrganizationInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationContainerOrganizationInfoQuery,
    GetOrganizationContainerOrganizationInfoQueryVariables
  >(GetOrganizationContainerOrganizationInfoDocument, options);
}
export function useGetOrganizationContainerOrganizationInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrganizationContainerOrganizationInfoQuery,
    GetOrganizationContainerOrganizationInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrganizationContainerOrganizationInfoQuery,
    GetOrganizationContainerOrganizationInfoQueryVariables
  >(GetOrganizationContainerOrganizationInfoDocument, options);
}
export type GetOrganizationContainerOrganizationInfoQueryHookResult =
  ReturnType<typeof useGetOrganizationContainerOrganizationInfoQuery>;
export type GetOrganizationContainerOrganizationInfoLazyQueryHookResult =
  ReturnType<typeof useGetOrganizationContainerOrganizationInfoLazyQuery>;
export type GetOrganizationContainerOrganizationInfoSuspenseQueryHookResult =
  ReturnType<typeof useGetOrganizationContainerOrganizationInfoSuspenseQuery>;
export type GetOrganizationContainerOrganizationInfoQueryResult =
  Apollo.QueryResult<
    GetOrganizationContainerOrganizationInfoQuery,
    GetOrganizationContainerOrganizationInfoQueryVariables
  >;
export const GetOrganizationsContainerCurrentSessionDocument = gql`
  query GetOrganizationsContainerCurrentSession(
    $userOrganizationsInput: GetAllOrganizationsInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        organizations(input: $userOrganizationsInput) {
          count
          edges {
            node {
              name
              legalName
              organizationId
              slug
              addressLine1
              addressLine2
              addressCity
              addressState
              addressZipCode
              email
              phoneNumber
              contractors {
                __typename
                count
                edges {
                  node {
                    contractorId
                    __typename
                  }
                }
              }
              developers {
                __typename
                count
                edges {
                  node {
                    developerId
                    __typename
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOrganizationsContainerCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsContainerCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsContainerCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsContainerCurrentSessionQuery({
 *   variables: {
 *      userOrganizationsInput: // value for 'userOrganizationsInput'
 *   },
 * });
 */
export function useGetOrganizationsContainerCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOrganizationsContainerCurrentSessionQuery,
    GetOrganizationsContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrganizationsContainerCurrentSessionQuery,
    GetOrganizationsContainerCurrentSessionQueryVariables
  >(GetOrganizationsContainerCurrentSessionDocument, options);
}
export function useGetOrganizationsContainerCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrganizationsContainerCurrentSessionQuery,
    GetOrganizationsContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrganizationsContainerCurrentSessionQuery,
    GetOrganizationsContainerCurrentSessionQueryVariables
  >(GetOrganizationsContainerCurrentSessionDocument, options);
}
export function useGetOrganizationsContainerCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrganizationsContainerCurrentSessionQuery,
    GetOrganizationsContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrganizationsContainerCurrentSessionQuery,
    GetOrganizationsContainerCurrentSessionQueryVariables
  >(GetOrganizationsContainerCurrentSessionDocument, options);
}
export type GetOrganizationsContainerCurrentSessionQueryHookResult = ReturnType<
  typeof useGetOrganizationsContainerCurrentSessionQuery
>;
export type GetOrganizationsContainerCurrentSessionLazyQueryHookResult =
  ReturnType<typeof useGetOrganizationsContainerCurrentSessionLazyQuery>;
export type GetOrganizationsContainerCurrentSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetOrganizationsContainerCurrentSessionSuspenseQuery>;
export type GetOrganizationsContainerCurrentSessionQueryResult =
  Apollo.QueryResult<
    GetOrganizationsContainerCurrentSessionQuery,
    GetOrganizationsContainerCurrentSessionQueryVariables
  >;
export const GetPrintWorkerDataDocument = gql`
  query GetPrintWorkerData($workerId: ID!) {
    getWorker(workerId: $workerId) {
      workerId
      middleInitial
      suffix
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZipCode
      addressZipCode
      birthDate
      emergencyContactName
      emergencyContactPhone
      emergencyContactRelationship
      gender
      primaryLanguage
      race
      isSkilled
      ssnLastFour
      isVeteran
      quickCode
      profilePicture {
        downloadUrl
        uploadedAt
      }
      profilePictureCropped {
        downloadUrl
        uploadedAt
        fileId
        fileType
      }
      user {
        userAccountId
        identity {
          firstName
          lastName
          email
          phoneNumber
        }
      }
      contractorWorkers {
        edges {
          node {
            id
            startDate
            endDate
            payrollId
            contractor {
              contractorId
              organization {
                organizationId
                name
              }
            }
          }
        }
      }
      jobsiteWorkers {
        edges {
          node {
            jobsiteWorkerId
            unionAffiliation
            isBanned
            bannedReason
            bannedAt
            startDate
            endDate
            payrollId
            stickerNumber
            orientationDate
            orientationStatus
            jobsiteContractor {
              jobsite {
                name
                jobsiteId
              }
              contractor {
                contractorId
                organization {
                  name
                }
              }
            }
            currentAccess {
              endDate
              isAllowed
            }
          }
        }
      }
      workerComments {
        edges {
          node {
            workerCommentId
            comment
            jobsite {
              name
              jobsiteId
            }
            objectHistory {
              createdAt
              createdBy {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
              updatedAt
              updatedBy {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetPrintWorkerDataQuery__
 *
 * To run a query within a React component, call `useGetPrintWorkerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrintWorkerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrintWorkerDataQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetPrintWorkerDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPrintWorkerDataQuery,
    GetPrintWorkerDataQueryVariables
  > &
    (
      | { variables: GetPrintWorkerDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPrintWorkerDataQuery,
    GetPrintWorkerDataQueryVariables
  >(GetPrintWorkerDataDocument, options);
}
export function useGetPrintWorkerDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPrintWorkerDataQuery,
    GetPrintWorkerDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPrintWorkerDataQuery,
    GetPrintWorkerDataQueryVariables
  >(GetPrintWorkerDataDocument, options);
}
export function useGetPrintWorkerDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPrintWorkerDataQuery,
    GetPrintWorkerDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPrintWorkerDataQuery,
    GetPrintWorkerDataQueryVariables
  >(GetPrintWorkerDataDocument, options);
}
export type GetPrintWorkerDataQueryHookResult = ReturnType<
  typeof useGetPrintWorkerDataQuery
>;
export type GetPrintWorkerDataLazyQueryHookResult = ReturnType<
  typeof useGetPrintWorkerDataLazyQuery
>;
export type GetPrintWorkerDataSuspenseQueryHookResult = ReturnType<
  typeof useGetPrintWorkerDataSuspenseQuery
>;
export type GetPrintWorkerDataQueryResult = Apollo.QueryResult<
  GetPrintWorkerDataQuery,
  GetPrintWorkerDataQueryVariables
>;
export const GenerateLookerJobsiteWorkerReportDocument = gql`
  mutation GenerateLookerJobsiteWorkerReport(
    $jobsiteIds: [ID!]
    $startDate: Date!
    $endDate: Date!
    $realtime: Boolean
    $limit: Int
    $offset: Int
    $sortField: String
    $sortDir: String
    $export: Boolean
    $trade: String
    $jobTitle: String
    $contractor: [String!]
    $active: Boolean
    $compliant: Boolean
    $overnight: Boolean
  ) {
    generateLookerJobsiteWorkerReport(
      jobsiteIds: $jobsiteIds
      startDate: $startDate
      endDate: $endDate
      realtime: $realtime
      limit: $limit
      offset: $offset
      sortField: $sortField
      sortDir: $sortDir
      export: $export
      trade: $trade
      jobTitle: $jobTitle
      contractor: $contractor
      active: $active
      compliant: $compliant
      overnight: $overnight
    ) {
      fileId
      fileType
      uploadedAt
      downloadUrl
      originalFileName
    }
  }
`;
export type GenerateLookerJobsiteWorkerReportMutationFn =
  Apollo.MutationFunction<
    GenerateLookerJobsiteWorkerReportMutation,
    GenerateLookerJobsiteWorkerReportMutationVariables
  >;

/**
 * __useGenerateLookerJobsiteWorkerReportMutation__
 *
 * To run a mutation, you first call `useGenerateLookerJobsiteWorkerReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLookerJobsiteWorkerReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLookerJobsiteWorkerReportMutation, { data, loading, error }] = useGenerateLookerJobsiteWorkerReportMutation({
 *   variables: {
 *      jobsiteIds: // value for 'jobsiteIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      realtime: // value for 'realtime'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortField: // value for 'sortField'
 *      sortDir: // value for 'sortDir'
 *      export: // value for 'export'
 *      trade: // value for 'trade'
 *      jobTitle: // value for 'jobTitle'
 *      contractor: // value for 'contractor'
 *      active: // value for 'active'
 *      compliant: // value for 'compliant'
 *      overnight: // value for 'overnight'
 *   },
 * });
 */
export function useGenerateLookerJobsiteWorkerReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateLookerJobsiteWorkerReportMutation,
    GenerateLookerJobsiteWorkerReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateLookerJobsiteWorkerReportMutation,
    GenerateLookerJobsiteWorkerReportMutationVariables
  >(GenerateLookerJobsiteWorkerReportDocument, options);
}
export type GenerateLookerJobsiteWorkerReportMutationHookResult = ReturnType<
  typeof useGenerateLookerJobsiteWorkerReportMutation
>;
export type GenerateLookerJobsiteWorkerReportMutationResult =
  Apollo.MutationResult<GenerateLookerJobsiteWorkerReportMutation>;
export type GenerateLookerJobsiteWorkerReportMutationOptions =
  Apollo.BaseMutationOptions<
    GenerateLookerJobsiteWorkerReportMutation,
    GenerateLookerJobsiteWorkerReportMutationVariables
  >;
export const GetJobsiteWorkerDashboardDocument = gql`
  query GetJobsiteWorkerDashboard(
    $jobsiteIds: [ID!]
    $startDate: Date!
    $endDate: Date!
    $timeBreakdown: GetJobsiteWorkerReportsTimeBreakdown
    $realtime: Boolean
    $limit: Int
    $offset: Int
    $sortField: String
    $sortDir: String
    $export: Boolean
    $trade: String
    $jobTitle: String
    $contractor: [String!]
    $fitoutTenant: String
    $active: Boolean
    $compliant: Boolean
    $overnight: Boolean
    $workerIds: [ID!]
  ) {
    getJobsiteWorkerDashboard(
      jobsiteIds: $jobsiteIds
      startDate: $startDate
      endDate: $endDate
      timeBreakdown: $timeBreakdown
      realtime: $realtime
      limit: $limit
      offset: $offset
      sortField: $sortField
      sortDir: $sortDir
      export: $export
      trade: $trade
      jobTitle: $jobTitle
      contractor: $contractor
      fitoutTenant: $fitoutTenant
      active: $active
      compliant: $compliant
      overnight: $overnight
      workerIds: $workerIds
    ) {
      jobsites {
        jobsiteId
        name
      }
      contractorOptions
      contractorBreakdowns {
        name
        count
        percentage
      }
      tradeBreakdowns {
        name
        count
        percentage
      }
      jobTitleBreakdowns {
        name
        count
        percentage
      }
      activeBreakdowns {
        name
        count
        percentage
      }
      compliantBreakdowns {
        name
        count
        percentage
      }
      jobsiteBreakdowns {
        name
        count
        percentage
      }
      overviewBreakdowns {
        name
        count
        compliantCount
        percentage
      }
      dailyBreakdowns {
        name
        count
      }
      languageBreakdowns {
        name
        count
        percentage
      }
      genderBreakdowns {
        name
        count
        percentage
      }
      raceBreakdowns {
        name
        count
        percentage
      }
      zipcodeBreakdowns {
        name
        count
        percentage
      }
      ageBreakdowns {
        name
        count
        percentage
      }
      onboardedBreakdowns {
        name
        count
        percentage
      }
      bannedBreakdowns {
        name
        count
        percentage
      }
      totalCount
      results {
        swipeSessionsSessionId
        swipeSessionsJobsiteWorkerId
        contractorOrganizationName
        jobsiteName
        profile
        swipeSessionsFirstInboundSwipeTimeOfDay
        swipeSessionsLastOutboundSwipeTimeOfDay
        swipeSessionsNetTotalSpanHours
        swipeSessionsDisplayValueSpanHours
        swipeSessionsOvernightSession
        swipeSessionsSessionDate
        userIdentityUserFullname
        workerWorkerId
        workerJobTitle
        workerTrade
        workerUnionAffiliation
        workerQuickCode
        croppedDownloadKey
        publicUrl
      }
    }
  }
`;

/**
 * __useGetJobsiteWorkerDashboardQuery__
 *
 * To run a query within a React component, call `useGetJobsiteWorkerDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteWorkerDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteWorkerDashboardQuery({
 *   variables: {
 *      jobsiteIds: // value for 'jobsiteIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      timeBreakdown: // value for 'timeBreakdown'
 *      realtime: // value for 'realtime'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sortField: // value for 'sortField'
 *      sortDir: // value for 'sortDir'
 *      export: // value for 'export'
 *      trade: // value for 'trade'
 *      jobTitle: // value for 'jobTitle'
 *      contractor: // value for 'contractor'
 *      fitoutTenant: // value for 'fitoutTenant'
 *      active: // value for 'active'
 *      compliant: // value for 'compliant'
 *      overnight: // value for 'overnight'
 *      workerIds: // value for 'workerIds'
 *   },
 * });
 */
export function useGetJobsiteWorkerDashboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteWorkerDashboardQuery,
    GetJobsiteWorkerDashboardQueryVariables
  > &
    (
      | { variables: GetJobsiteWorkerDashboardQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteWorkerDashboardQuery,
    GetJobsiteWorkerDashboardQueryVariables
  >(GetJobsiteWorkerDashboardDocument, options);
}
export function useGetJobsiteWorkerDashboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteWorkerDashboardQuery,
    GetJobsiteWorkerDashboardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteWorkerDashboardQuery,
    GetJobsiteWorkerDashboardQueryVariables
  >(GetJobsiteWorkerDashboardDocument, options);
}
export function useGetJobsiteWorkerDashboardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteWorkerDashboardQuery,
    GetJobsiteWorkerDashboardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteWorkerDashboardQuery,
    GetJobsiteWorkerDashboardQueryVariables
  >(GetJobsiteWorkerDashboardDocument, options);
}
export type GetJobsiteWorkerDashboardQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDashboardQuery
>;
export type GetJobsiteWorkerDashboardLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDashboardLazyQuery
>;
export type GetJobsiteWorkerDashboardSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDashboardSuspenseQuery
>;
export type GetJobsiteWorkerDashboardQueryResult = Apollo.QueryResult<
  GetJobsiteWorkerDashboardQuery,
  GetJobsiteWorkerDashboardQueryVariables
>;
export const ImportScheduleDocument = gql`
  mutation ImportSchedule($input: ImportScheduleInput!) {
    importSchedule(input: $input) {
      schedule {
        id
      }
    }
  }
`;
export type ImportScheduleMutationFn = Apollo.MutationFunction<
  ImportScheduleMutation,
  ImportScheduleMutationVariables
>;

/**
 * __useImportScheduleMutation__
 *
 * To run a mutation, you first call `useImportScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importScheduleMutation, { data, loading, error }] = useImportScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportScheduleMutation,
    ImportScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ImportScheduleMutation,
    ImportScheduleMutationVariables
  >(ImportScheduleDocument, options);
}
export type ImportScheduleMutationHookResult = ReturnType<
  typeof useImportScheduleMutation
>;
export type ImportScheduleMutationResult =
  Apollo.MutationResult<ImportScheduleMutation>;
export type ImportScheduleMutationOptions = Apollo.BaseMutationOptions<
  ImportScheduleMutation,
  ImportScheduleMutationVariables
>;
export const GetScheduleImportTargetDocument = gql`
  query GetScheduleImportTarget($input: ScheduleInput!) {
    getSchedule(input: $input) {
      id
      date
      status
      jobsite {
        jobsiteId
        name
      }
      shifts {
        id
        workers {
          count
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetScheduleImportTargetQuery__
 *
 * To run a query within a React component, call `useGetScheduleImportTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduleImportTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduleImportTargetQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetScheduleImportTargetQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScheduleImportTargetQuery,
    GetScheduleImportTargetQueryVariables
  > &
    (
      | { variables: GetScheduleImportTargetQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduleImportTargetQuery,
    GetScheduleImportTargetQueryVariables
  >(GetScheduleImportTargetDocument, options);
}
export function useGetScheduleImportTargetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduleImportTargetQuery,
    GetScheduleImportTargetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduleImportTargetQuery,
    GetScheduleImportTargetQueryVariables
  >(GetScheduleImportTargetDocument, options);
}
export function useGetScheduleImportTargetSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetScheduleImportTargetQuery,
    GetScheduleImportTargetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetScheduleImportTargetQuery,
    GetScheduleImportTargetQueryVariables
  >(GetScheduleImportTargetDocument, options);
}
export type GetScheduleImportTargetQueryHookResult = ReturnType<
  typeof useGetScheduleImportTargetQuery
>;
export type GetScheduleImportTargetLazyQueryHookResult = ReturnType<
  typeof useGetScheduleImportTargetLazyQuery
>;
export type GetScheduleImportTargetSuspenseQueryHookResult = ReturnType<
  typeof useGetScheduleImportTargetSuspenseQuery
>;
export type GetScheduleImportTargetQueryResult = Apollo.QueryResult<
  GetScheduleImportTargetQuery,
  GetScheduleImportTargetQueryVariables
>;
export const GetSchedulesDocument = gql`
  query GetSchedules($schedulesInput: SchedulesInput!) {
    getCurrentSession {
      user {
        schedules(input: $schedulesInput) {
          count
          edges {
            node {
              scheduler {
                userAccountId
                profilePictureCropped {
                  downloadUrl
                }
                identity {
                  firstName
                  lastName
                }
              }
              jobsite {
                jobsiteId
                name
                developer {
                  developerId
                  name
                }
              }
              id
              date
              status
              notifiedAt
            }
          }
          filtersOptions {
            schedulerAccountIds {
              value
              label
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetSchedulesQuery__
 *
 * To run a query within a React component, call `useGetSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulesQuery({
 *   variables: {
 *      schedulesInput: // value for 'schedulesInput'
 *   },
 * });
 */
export function useGetSchedulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSchedulesQuery,
    GetSchedulesQueryVariables
  > &
    (
      | { variables: GetSchedulesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSchedulesQuery, GetSchedulesQueryVariables>(
    GetSchedulesDocument,
    options,
  );
}
export function useGetSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSchedulesQuery,
    GetSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSchedulesQuery, GetSchedulesQueryVariables>(
    GetSchedulesDocument,
    options,
  );
}
export function useGetSchedulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSchedulesQuery,
    GetSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSchedulesQuery, GetSchedulesQueryVariables>(
    GetSchedulesDocument,
    options,
  );
}
export type GetSchedulesQueryHookResult = ReturnType<
  typeof useGetSchedulesQuery
>;
export type GetSchedulesLazyQueryHookResult = ReturnType<
  typeof useGetSchedulesLazyQuery
>;
export type GetSchedulesSuspenseQueryHookResult = ReturnType<
  typeof useGetSchedulesSuspenseQuery
>;
export type GetSchedulesQueryResult = Apollo.QueryResult<
  GetSchedulesQuery,
  GetSchedulesQueryVariables
>;
export const SearchWorkersDocument = gql`
  query SearchWorkers($searchString: String!, $limit: Int, $offset: Int) {
    searchWorkers(searchString: $searchString, limit: $limit, offset: $offset) {
      count
      results {
        worker {
          workerId
          quickCode
          user {
            userAccountId
            identity {
              firstName
              lastName
            }
          }
          profilePictureCropped {
            downloadUrl
          }
          jobsiteWorkers {
            edges {
              node {
                trade
                jobTitle
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useSearchWorkersQuery__
 *
 * To run a query within a React component, call `useSearchWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWorkersQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchWorkersQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchWorkersQuery,
    SearchWorkersQueryVariables
  > &
    (
      | { variables: SearchWorkersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchWorkersQuery, SearchWorkersQueryVariables>(
    SearchWorkersDocument,
    options,
  );
}
export function useSearchWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchWorkersQuery,
    SearchWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchWorkersQuery, SearchWorkersQueryVariables>(
    SearchWorkersDocument,
    options,
  );
}
export function useSearchWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SearchWorkersQuery,
    SearchWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SearchWorkersQuery,
    SearchWorkersQueryVariables
  >(SearchWorkersDocument, options);
}
export type SearchWorkersQueryHookResult = ReturnType<
  typeof useSearchWorkersQuery
>;
export type SearchWorkersLazyQueryHookResult = ReturnType<
  typeof useSearchWorkersLazyQuery
>;
export type SearchWorkersSuspenseQueryHookResult = ReturnType<
  typeof useSearchWorkersSuspenseQuery
>;
export type SearchWorkersQueryResult = Apollo.QueryResult<
  SearchWorkersQuery,
  SearchWorkersQueryVariables
>;
export const CompleteAnonymousPhoneVerificationDocument = gql`
  mutation CompleteAnonymousPhoneVerification(
    $input: CompleteAnonymousPhoneVerificationInput!
  ) {
    completeAnonymousPhoneVerification(input: $input) {
      success
      token
      selfOnboardingCurrentStep
      auth {
        user {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
        session {
          sessionToken
        }
      }
    }
  }
`;
export type CompleteAnonymousPhoneVerificationMutationFn =
  Apollo.MutationFunction<
    CompleteAnonymousPhoneVerificationMutation,
    CompleteAnonymousPhoneVerificationMutationVariables
  >;

/**
 * __useCompleteAnonymousPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useCompleteAnonymousPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAnonymousPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAnonymousPhoneVerificationMutation, { data, loading, error }] = useCompleteAnonymousPhoneVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteAnonymousPhoneVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteAnonymousPhoneVerificationMutation,
    CompleteAnonymousPhoneVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteAnonymousPhoneVerificationMutation,
    CompleteAnonymousPhoneVerificationMutationVariables
  >(CompleteAnonymousPhoneVerificationDocument, options);
}
export type CompleteAnonymousPhoneVerificationMutationHookResult = ReturnType<
  typeof useCompleteAnonymousPhoneVerificationMutation
>;
export type CompleteAnonymousPhoneVerificationMutationResult =
  Apollo.MutationResult<CompleteAnonymousPhoneVerificationMutation>;
export type CompleteAnonymousPhoneVerificationMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteAnonymousPhoneVerificationMutation,
    CompleteAnonymousPhoneVerificationMutationVariables
  >;
export const CompletePhoneNumberVerificationDocument = gql`
  mutation CompletePhoneNumberVerification(
    $input: CompletePhoneNumberVerificationInput!
  ) {
    completePhoneNumberVerification(input: $input) {
      success
      worker {
        workerId
        editableFields {
          phone
          email
        }
      }
    }
  }
`;
export type CompletePhoneNumberVerificationMutationFn = Apollo.MutationFunction<
  CompletePhoneNumberVerificationMutation,
  CompletePhoneNumberVerificationMutationVariables
>;

/**
 * __useCompletePhoneNumberVerificationMutation__
 *
 * To run a mutation, you first call `useCompletePhoneNumberVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePhoneNumberVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePhoneNumberVerificationMutation, { data, loading, error }] = useCompletePhoneNumberVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompletePhoneNumberVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletePhoneNumberVerificationMutation,
    CompletePhoneNumberVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompletePhoneNumberVerificationMutation,
    CompletePhoneNumberVerificationMutationVariables
  >(CompletePhoneNumberVerificationDocument, options);
}
export type CompletePhoneNumberVerificationMutationHookResult = ReturnType<
  typeof useCompletePhoneNumberVerificationMutation
>;
export type CompletePhoneNumberVerificationMutationResult =
  Apollo.MutationResult<CompletePhoneNumberVerificationMutation>;
export type CompletePhoneNumberVerificationMutationOptions =
  Apollo.BaseMutationOptions<
    CompletePhoneNumberVerificationMutation,
    CompletePhoneNumberVerificationMutationVariables
  >;
export const CompletePhoneNumberVerificationAndSignInDocument = gql`
  mutation CompletePhoneNumberVerificationAndSignIn(
    $input: CompletePhoneNumberVerificationAndSignInInput!
  ) {
    completePhoneNumberVerificationAndSignIn(input: $input) {
      success
      auth {
        user {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
        session {
          sessionToken
        }
      }
      selfOnboardingInfo {
        jobsiteWorkerId
        continueAction
        abortReason
      }
      jobsiteWorker {
        jobsiteWorkerId
        contractorWorker {
          worker {
            workerId
            editableFields {
              phone
              email
            }
          }
        }
      }
    }
  }
`;
export type CompletePhoneNumberVerificationAndSignInMutationFn =
  Apollo.MutationFunction<
    CompletePhoneNumberVerificationAndSignInMutation,
    CompletePhoneNumberVerificationAndSignInMutationVariables
  >;

/**
 * __useCompletePhoneNumberVerificationAndSignInMutation__
 *
 * To run a mutation, you first call `useCompletePhoneNumberVerificationAndSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePhoneNumberVerificationAndSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePhoneNumberVerificationAndSignInMutation, { data, loading, error }] = useCompletePhoneNumberVerificationAndSignInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompletePhoneNumberVerificationAndSignInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletePhoneNumberVerificationAndSignInMutation,
    CompletePhoneNumberVerificationAndSignInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompletePhoneNumberVerificationAndSignInMutation,
    CompletePhoneNumberVerificationAndSignInMutationVariables
  >(CompletePhoneNumberVerificationAndSignInDocument, options);
}
export type CompletePhoneNumberVerificationAndSignInMutationHookResult =
  ReturnType<typeof useCompletePhoneNumberVerificationAndSignInMutation>;
export type CompletePhoneNumberVerificationAndSignInMutationResult =
  Apollo.MutationResult<CompletePhoneNumberVerificationAndSignInMutation>;
export type CompletePhoneNumberVerificationAndSignInMutationOptions =
  Apollo.BaseMutationOptions<
    CompletePhoneNumberVerificationAndSignInMutation,
    CompletePhoneNumberVerificationAndSignInMutationVariables
  >;
export const SelfOnboardingAssignToJobsiteDocument = gql`
  mutation SelfOnboardingAssignToJobsite(
    $input: SelfOnboardingAssignToJobsiteInput!
  ) {
    selfOnboardingAssignToJobsite(input: $input) {
      jobsiteWorker {
        jobsiteWorkerId
        contractorWorker {
          worker {
            workerId
            isAssignedToMultipleJobsites
          }
        }
      }
      selfOnboardingInfo {
        jobsiteWorkerId
        continueAction
        abortReason
      }
    }
  }
`;
export type SelfOnboardingAssignToJobsiteMutationFn = Apollo.MutationFunction<
  SelfOnboardingAssignToJobsiteMutation,
  SelfOnboardingAssignToJobsiteMutationVariables
>;

/**
 * __useSelfOnboardingAssignToJobsiteMutation__
 *
 * To run a mutation, you first call `useSelfOnboardingAssignToJobsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfOnboardingAssignToJobsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfOnboardingAssignToJobsiteMutation, { data, loading, error }] = useSelfOnboardingAssignToJobsiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfOnboardingAssignToJobsiteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelfOnboardingAssignToJobsiteMutation,
    SelfOnboardingAssignToJobsiteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SelfOnboardingAssignToJobsiteMutation,
    SelfOnboardingAssignToJobsiteMutationVariables
  >(SelfOnboardingAssignToJobsiteDocument, options);
}
export type SelfOnboardingAssignToJobsiteMutationHookResult = ReturnType<
  typeof useSelfOnboardingAssignToJobsiteMutation
>;
export type SelfOnboardingAssignToJobsiteMutationResult =
  Apollo.MutationResult<SelfOnboardingAssignToJobsiteMutation>;
export type SelfOnboardingAssignToJobsiteMutationOptions =
  Apollo.BaseMutationOptions<
    SelfOnboardingAssignToJobsiteMutation,
    SelfOnboardingAssignToJobsiteMutationVariables
  >;
export const SelfOnboardingCreateAccountDocument = gql`
  mutation SelfOnboardingCreateAccount(
    $input: SelfOnboardingCreateAccountInput!
  ) {
    selfOnboardingCreateAccount(input: $input) {
      auth {
        user {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
        session {
          sessionToken
        }
      }
      worker {
        workerId
        quickCode
      }
    }
  }
`;
export type SelfOnboardingCreateAccountMutationFn = Apollo.MutationFunction<
  SelfOnboardingCreateAccountMutation,
  SelfOnboardingCreateAccountMutationVariables
>;

/**
 * __useSelfOnboardingCreateAccountMutation__
 *
 * To run a mutation, you first call `useSelfOnboardingCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfOnboardingCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfOnboardingCreateAccountMutation, { data, loading, error }] = useSelfOnboardingCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfOnboardingCreateAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelfOnboardingCreateAccountMutation,
    SelfOnboardingCreateAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SelfOnboardingCreateAccountMutation,
    SelfOnboardingCreateAccountMutationVariables
  >(SelfOnboardingCreateAccountDocument, options);
}
export type SelfOnboardingCreateAccountMutationHookResult = ReturnType<
  typeof useSelfOnboardingCreateAccountMutation
>;
export type SelfOnboardingCreateAccountMutationResult =
  Apollo.MutationResult<SelfOnboardingCreateAccountMutation>;
export type SelfOnboardingCreateAccountMutationOptions =
  Apollo.BaseMutationOptions<
    SelfOnboardingCreateAccountMutation,
    SelfOnboardingCreateAccountMutationVariables
  >;
export const SelfOnboardingWorkerCreateDocument = gql`
  mutation SelfOnboardingWorkerCreate(
    $input: SelfOnboardingWorkerAccountCreateInput!
  ) {
    selfOnboardingWorkerCreate(input: $input) {
      jobsiteWorker {
        jobsiteWorkerId
        contractorWorker {
          worker {
            workerId
            quickCode
          }
        }
      }
      auth {
        user {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
        session {
          sessionToken
        }
      }
    }
  }
`;
export type SelfOnboardingWorkerCreateMutationFn = Apollo.MutationFunction<
  SelfOnboardingWorkerCreateMutation,
  SelfOnboardingWorkerCreateMutationVariables
>;

/**
 * __useSelfOnboardingWorkerCreateMutation__
 *
 * To run a mutation, you first call `useSelfOnboardingWorkerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfOnboardingWorkerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfOnboardingWorkerCreateMutation, { data, loading, error }] = useSelfOnboardingWorkerCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfOnboardingWorkerCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelfOnboardingWorkerCreateMutation,
    SelfOnboardingWorkerCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SelfOnboardingWorkerCreateMutation,
    SelfOnboardingWorkerCreateMutationVariables
  >(SelfOnboardingWorkerCreateDocument, options);
}
export type SelfOnboardingWorkerCreateMutationHookResult = ReturnType<
  typeof useSelfOnboardingWorkerCreateMutation
>;
export type SelfOnboardingWorkerCreateMutationResult =
  Apollo.MutationResult<SelfOnboardingWorkerCreateMutation>;
export type SelfOnboardingWorkerCreateMutationOptions =
  Apollo.BaseMutationOptions<
    SelfOnboardingWorkerCreateMutation,
    SelfOnboardingWorkerCreateMutationVariables
  >;
export const SelfOnboardingWorkerUpdateDocument = gql`
  mutation SelfOnboardingWorkerUpdate(
    $input: SelfOnboardingWorkerAccountUpdateInput!
  ) {
    selfOnboardingWorkerUpdate(input: $input) {
      worker {
        workerId
      }
    }
  }
`;
export type SelfOnboardingWorkerUpdateMutationFn = Apollo.MutationFunction<
  SelfOnboardingWorkerUpdateMutation,
  SelfOnboardingWorkerUpdateMutationVariables
>;

/**
 * __useSelfOnboardingWorkerUpdateMutation__
 *
 * To run a mutation, you first call `useSelfOnboardingWorkerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfOnboardingWorkerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfOnboardingWorkerUpdateMutation, { data, loading, error }] = useSelfOnboardingWorkerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfOnboardingWorkerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SelfOnboardingWorkerUpdateMutation,
    SelfOnboardingWorkerUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SelfOnboardingWorkerUpdateMutation,
    SelfOnboardingWorkerUpdateMutationVariables
  >(SelfOnboardingWorkerUpdateDocument, options);
}
export type SelfOnboardingWorkerUpdateMutationHookResult = ReturnType<
  typeof useSelfOnboardingWorkerUpdateMutation
>;
export type SelfOnboardingWorkerUpdateMutationResult =
  Apollo.MutationResult<SelfOnboardingWorkerUpdateMutation>;
export type SelfOnboardingWorkerUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    SelfOnboardingWorkerUpdateMutation,
    SelfOnboardingWorkerUpdateMutationVariables
  >;
export const StartAnonymousPhoneVerificationDocument = gql`
  mutation StartAnonymousPhoneVerification(
    $input: StartAnonymousPhoneVerificationInput!
  ) {
    startAnonymousPhoneVerification(input: $input) {
      success
    }
  }
`;
export type StartAnonymousPhoneVerificationMutationFn = Apollo.MutationFunction<
  StartAnonymousPhoneVerificationMutation,
  StartAnonymousPhoneVerificationMutationVariables
>;

/**
 * __useStartAnonymousPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useStartAnonymousPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAnonymousPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAnonymousPhoneVerificationMutation, { data, loading, error }] = useStartAnonymousPhoneVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAnonymousPhoneVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartAnonymousPhoneVerificationMutation,
    StartAnonymousPhoneVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartAnonymousPhoneVerificationMutation,
    StartAnonymousPhoneVerificationMutationVariables
  >(StartAnonymousPhoneVerificationDocument, options);
}
export type StartAnonymousPhoneVerificationMutationHookResult = ReturnType<
  typeof useStartAnonymousPhoneVerificationMutation
>;
export type StartAnonymousPhoneVerificationMutationResult =
  Apollo.MutationResult<StartAnonymousPhoneVerificationMutation>;
export type StartAnonymousPhoneVerificationMutationOptions =
  Apollo.BaseMutationOptions<
    StartAnonymousPhoneVerificationMutation,
    StartAnonymousPhoneVerificationMutationVariables
  >;
export const StartPhoneNumberVerificationDocument = gql`
  mutation StartPhoneNumberVerification(
    $input: StartPhoneNumberVerificationInput!
  ) {
    startPhoneNumberVerification(input: $input) {
      success
    }
  }
`;
export type StartPhoneNumberVerificationMutationFn = Apollo.MutationFunction<
  StartPhoneNumberVerificationMutation,
  StartPhoneNumberVerificationMutationVariables
>;

/**
 * __useStartPhoneNumberVerificationMutation__
 *
 * To run a mutation, you first call `useStartPhoneNumberVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPhoneNumberVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPhoneNumberVerificationMutation, { data, loading, error }] = useStartPhoneNumberVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartPhoneNumberVerificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartPhoneNumberVerificationMutation,
    StartPhoneNumberVerificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartPhoneNumberVerificationMutation,
    StartPhoneNumberVerificationMutationVariables
  >(StartPhoneNumberVerificationDocument, options);
}
export type StartPhoneNumberVerificationMutationHookResult = ReturnType<
  typeof useStartPhoneNumberVerificationMutation
>;
export type StartPhoneNumberVerificationMutationResult =
  Apollo.MutationResult<StartPhoneNumberVerificationMutation>;
export type StartPhoneNumberVerificationMutationOptions =
  Apollo.BaseMutationOptions<
    StartPhoneNumberVerificationMutation,
    StartPhoneNumberVerificationMutationVariables
  >;
export const UpsertJobsiteWorkerDocumentDocument = gql`
  mutation UpsertJobsiteWorkerDocument(
    $input: JobsiteWorkerDocumentUpsertInput!
  ) {
    upsertJobsiteWorkerDocument(input: $input) {
      jobsiteWorkerDocumentVersionId
      files {
        fileId
        fileType
        downloadUrl
        originalFileName
        uploadedAt
      }
      additionalFieldValues {
        key
        value
      }
    }
  }
`;
export type UpsertJobsiteWorkerDocumentMutationFn = Apollo.MutationFunction<
  UpsertJobsiteWorkerDocumentMutation,
  UpsertJobsiteWorkerDocumentMutationVariables
>;

/**
 * __useUpsertJobsiteWorkerDocumentMutation__
 *
 * To run a mutation, you first call `useUpsertJobsiteWorkerDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertJobsiteWorkerDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertJobsiteWorkerDocumentMutation, { data, loading, error }] = useUpsertJobsiteWorkerDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertJobsiteWorkerDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertJobsiteWorkerDocumentMutation,
    UpsertJobsiteWorkerDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertJobsiteWorkerDocumentMutation,
    UpsertJobsiteWorkerDocumentMutationVariables
  >(UpsertJobsiteWorkerDocumentDocument, options);
}
export type UpsertJobsiteWorkerDocumentMutationHookResult = ReturnType<
  typeof useUpsertJobsiteWorkerDocumentMutation
>;
export type UpsertJobsiteWorkerDocumentMutationResult =
  Apollo.MutationResult<UpsertJobsiteWorkerDocumentMutation>;
export type UpsertJobsiteWorkerDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertJobsiteWorkerDocumentMutation,
    UpsertJobsiteWorkerDocumentMutationVariables
  >;
export const GetSelfOnboardingContainerSessionDocument = gql`
  query GetSelfOnboardingContainerSession(
    $jobsiteWorkersInput: WorkerJobsiteWorkersInput!
    $workerDocumentsInput: WorkerDocumentsInput!
  ) {
    getCurrentSession {
      policyConsentStatuses {
        ...PolicyConsentStatusFields
      }
      user {
        userAccountId
        identity {
          firstName
          lastName
          email
          phoneNumber
          smsConsentReceivedAt
        }
        worker {
          workerId
          quickCode
          middleInitial
          suffix
          birthDate
          ssnLastFour
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZipCode
          primaryLanguage
          citizenshipStatus
          workAuthorizationStatus
          race
          gender
          isVeteran
          emergencyContactName
          emergencyContactRelationship
          emergencyContactPhone
          selfOnboardingCurrentStep
          isAssignedToMultipleJobsites
          profilePicture {
            fileId
            fileType
            downloadUrl
            uploadedAt
          }
          editableFields {
            email
            phone
          }
          jobsiteWorkers(input: $jobsiteWorkersInput) {
            edges {
              node {
                jobsiteWorkerId
                trade
                jobTitle
                tradeExperience
                unionAffiliation
                classificationGroup
                jobsiteContractor {
                  id
                  contractor {
                    contractorId
                    isDefaultContractor
                    organization {
                      organizationId
                      name
                    }
                  }
                  jobsite {
                    jobsiteId
                    tradeOptions
                    titleOptions
                    unionAffiliationOptions
                  }
                }
                customWorkerData
              }
            }
          }
          documents(input: $workerDocumentsInput) {
            edges {
              node {
                jobsiteWorkerDocumentId
                jobsiteWorkerDocumentType {
                  id
                  key
                  name
                  workerDocumentType {
                    key
                  }
                }
                latestVersion {
                  jobsiteWorkerDocumentVersionId
                  additionalFieldValues {
                    key
                    value
                  }
                  files {
                    fileId
                    fileType
                    downloadUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${PolicyConsentStatusFieldsFragmentDoc}
`;

/**
 * __useGetSelfOnboardingContainerSessionQuery__
 *
 * To run a query within a React component, call `useGetSelfOnboardingContainerSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfOnboardingContainerSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfOnboardingContainerSessionQuery({
 *   variables: {
 *      jobsiteWorkersInput: // value for 'jobsiteWorkersInput'
 *      workerDocumentsInput: // value for 'workerDocumentsInput'
 *   },
 * });
 */
export function useGetSelfOnboardingContainerSessionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSelfOnboardingContainerSessionQuery,
    GetSelfOnboardingContainerSessionQueryVariables
  > &
    (
      | {
          variables: GetSelfOnboardingContainerSessionQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSelfOnboardingContainerSessionQuery,
    GetSelfOnboardingContainerSessionQueryVariables
  >(GetSelfOnboardingContainerSessionDocument, options);
}
export function useGetSelfOnboardingContainerSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSelfOnboardingContainerSessionQuery,
    GetSelfOnboardingContainerSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSelfOnboardingContainerSessionQuery,
    GetSelfOnboardingContainerSessionQueryVariables
  >(GetSelfOnboardingContainerSessionDocument, options);
}
export function useGetSelfOnboardingContainerSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSelfOnboardingContainerSessionQuery,
    GetSelfOnboardingContainerSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSelfOnboardingContainerSessionQuery,
    GetSelfOnboardingContainerSessionQueryVariables
  >(GetSelfOnboardingContainerSessionDocument, options);
}
export type GetSelfOnboardingContainerSessionQueryHookResult = ReturnType<
  typeof useGetSelfOnboardingContainerSessionQuery
>;
export type GetSelfOnboardingContainerSessionLazyQueryHookResult = ReturnType<
  typeof useGetSelfOnboardingContainerSessionLazyQuery
>;
export type GetSelfOnboardingContainerSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetSelfOnboardingContainerSessionSuspenseQuery>;
export type GetSelfOnboardingContainerSessionQueryResult = Apollo.QueryResult<
  GetSelfOnboardingContainerSessionQuery,
  GetSelfOnboardingContainerSessionQueryVariables
>;
export const GetSelfOnboardingCurrentStepDocument = gql`
  query GetSelfOnboardingCurrentStep {
    getCurrentSession {
      user {
        userAccountId
        worker {
          workerId
          selfOnboardingCurrentStep
        }
      }
    }
  }
`;

/**
 * __useGetSelfOnboardingCurrentStepQuery__
 *
 * To run a query within a React component, call `useGetSelfOnboardingCurrentStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfOnboardingCurrentStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfOnboardingCurrentStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelfOnboardingCurrentStepQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSelfOnboardingCurrentStepQuery,
    GetSelfOnboardingCurrentStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSelfOnboardingCurrentStepQuery,
    GetSelfOnboardingCurrentStepQueryVariables
  >(GetSelfOnboardingCurrentStepDocument, options);
}
export function useGetSelfOnboardingCurrentStepLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSelfOnboardingCurrentStepQuery,
    GetSelfOnboardingCurrentStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSelfOnboardingCurrentStepQuery,
    GetSelfOnboardingCurrentStepQueryVariables
  >(GetSelfOnboardingCurrentStepDocument, options);
}
export function useGetSelfOnboardingCurrentStepSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSelfOnboardingCurrentStepQuery,
    GetSelfOnboardingCurrentStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSelfOnboardingCurrentStepQuery,
    GetSelfOnboardingCurrentStepQueryVariables
  >(GetSelfOnboardingCurrentStepDocument, options);
}
export type GetSelfOnboardingCurrentStepQueryHookResult = ReturnType<
  typeof useGetSelfOnboardingCurrentStepQuery
>;
export type GetSelfOnboardingCurrentStepLazyQueryHookResult = ReturnType<
  typeof useGetSelfOnboardingCurrentStepLazyQuery
>;
export type GetSelfOnboardingCurrentStepSuspenseQueryHookResult = ReturnType<
  typeof useGetSelfOnboardingCurrentStepSuspenseQuery
>;
export type GetSelfOnboardingCurrentStepQueryResult = Apollo.QueryResult<
  GetSelfOnboardingCurrentStepQuery,
  GetSelfOnboardingCurrentStepQueryVariables
>;
export const SetMyPinDocument = gql`
  mutation SetMyPin($input: SetMyPinInput!) {
    setMyPin(input: $input) {
      success
    }
  }
`;
export type SetMyPinMutationFn = Apollo.MutationFunction<
  SetMyPinMutation,
  SetMyPinMutationVariables
>;

/**
 * __useSetMyPinMutation__
 *
 * To run a mutation, you first call `useSetMyPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMyPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMyPinMutation, { data, loading, error }] = useSetMyPinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetMyPinMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetMyPinMutation,
    SetMyPinMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetMyPinMutation, SetMyPinMutationVariables>(
    SetMyPinDocument,
    options,
  );
}
export type SetMyPinMutationHookResult = ReturnType<typeof useSetMyPinMutation>;
export type SetMyPinMutationResult = Apollo.MutationResult<SetMyPinMutation>;
export type SetMyPinMutationOptions = Apollo.BaseMutationOptions<
  SetMyPinMutation,
  SetMyPinMutationVariables
>;
export const GetMyPinDocument = gql`
  query GetMyPin {
    getCurrentSession {
      user {
        userAccountId
        pin {
          pinSetAt
          failedAttempts
          lockedUntil
        }
      }
    }
  }
`;

/**
 * __useGetMyPinQuery__
 *
 * To run a query within a React component, call `useGetMyPinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPinQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPinQuery(
  baseOptions?: Apollo.QueryHookOptions<GetMyPinQuery, GetMyPinQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyPinQuery, GetMyPinQueryVariables>(
    GetMyPinDocument,
    options,
  );
}
export function useGetMyPinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyPinQuery,
    GetMyPinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyPinQuery, GetMyPinQueryVariables>(
    GetMyPinDocument,
    options,
  );
}
export function useGetMyPinSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMyPinQuery,
    GetMyPinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMyPinQuery, GetMyPinQueryVariables>(
    GetMyPinDocument,
    options,
  );
}
export type GetMyPinQueryHookResult = ReturnType<typeof useGetMyPinQuery>;
export type GetMyPinLazyQueryHookResult = ReturnType<
  typeof useGetMyPinLazyQuery
>;
export type GetMyPinSuspenseQueryHookResult = ReturnType<
  typeof useGetMyPinSuspenseQuery
>;
export type GetMyPinQueryResult = Apollo.QueryResult<
  GetMyPinQuery,
  GetMyPinQueryVariables
>;
export const UserCancelPendingChangeDocument = gql`
  mutation UserCancelPendingChange($input: UserCancelPendingChangeInput!) {
    userCancelPendingChange(input: $input) {
      success
    }
  }
`;
export type UserCancelPendingChangeMutationFn = Apollo.MutationFunction<
  UserCancelPendingChangeMutation,
  UserCancelPendingChangeMutationVariables
>;

/**
 * __useUserCancelPendingChangeMutation__
 *
 * To run a mutation, you first call `useUserCancelPendingChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCancelPendingChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCancelPendingChangeMutation, { data, loading, error }] = useUserCancelPendingChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCancelPendingChangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserCancelPendingChangeMutation,
    UserCancelPendingChangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserCancelPendingChangeMutation,
    UserCancelPendingChangeMutationVariables
  >(UserCancelPendingChangeDocument, options);
}
export type UserCancelPendingChangeMutationHookResult = ReturnType<
  typeof useUserCancelPendingChangeMutation
>;
export type UserCancelPendingChangeMutationResult =
  Apollo.MutationResult<UserCancelPendingChangeMutation>;
export type UserCancelPendingChangeMutationOptions = Apollo.BaseMutationOptions<
  UserCancelPendingChangeMutation,
  UserCancelPendingChangeMutationVariables
>;
export const UserConfirmPendingChangeDocument = gql`
  mutation UserConfirmPendingChange($input: UserConfirmPendingChangeInput!) {
    userConfirmPendingChange(input: $input) {
      user {
        userAccountId
      }
    }
  }
`;
export type UserConfirmPendingChangeMutationFn = Apollo.MutationFunction<
  UserConfirmPendingChangeMutation,
  UserConfirmPendingChangeMutationVariables
>;

/**
 * __useUserConfirmPendingChangeMutation__
 *
 * To run a mutation, you first call `useUserConfirmPendingChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserConfirmPendingChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userConfirmPendingChangeMutation, { data, loading, error }] = useUserConfirmPendingChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserConfirmPendingChangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserConfirmPendingChangeMutation,
    UserConfirmPendingChangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserConfirmPendingChangeMutation,
    UserConfirmPendingChangeMutationVariables
  >(UserConfirmPendingChangeDocument, options);
}
export type UserConfirmPendingChangeMutationHookResult = ReturnType<
  typeof useUserConfirmPendingChangeMutation
>;
export type UserConfirmPendingChangeMutationResult =
  Apollo.MutationResult<UserConfirmPendingChangeMutation>;
export type UserConfirmPendingChangeMutationOptions =
  Apollo.BaseMutationOptions<
    UserConfirmPendingChangeMutation,
    UserConfirmPendingChangeMutationVariables
  >;
export const GetUserPendingChangeDocument = gql`
  query GetUserPendingChange(
    $workerId: ID!
    $changeType: UserPendingChangeType!
  ) {
    getUserPendingChange(workerId: $workerId, changeType: $changeType) {
      change {
        currentValue
        newValue
        expiresAt
        submittedBy {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;

/**
 * __useGetUserPendingChangeQuery__
 *
 * To run a query within a React component, call `useGetUserPendingChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPendingChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPendingChangeQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      changeType: // value for 'changeType'
 *   },
 * });
 */
export function useGetUserPendingChangeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserPendingChangeQuery,
    GetUserPendingChangeQueryVariables
  > &
    (
      | { variables: GetUserPendingChangeQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserPendingChangeQuery,
    GetUserPendingChangeQueryVariables
  >(GetUserPendingChangeDocument, options);
}
export function useGetUserPendingChangeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserPendingChangeQuery,
    GetUserPendingChangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserPendingChangeQuery,
    GetUserPendingChangeQueryVariables
  >(GetUserPendingChangeDocument, options);
}
export function useGetUserPendingChangeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserPendingChangeQuery,
    GetUserPendingChangeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserPendingChangeQuery,
    GetUserPendingChangeQueryVariables
  >(GetUserPendingChangeDocument, options);
}
export type GetUserPendingChangeQueryHookResult = ReturnType<
  typeof useGetUserPendingChangeQuery
>;
export type GetUserPendingChangeLazyQueryHookResult = ReturnType<
  typeof useGetUserPendingChangeLazyQuery
>;
export type GetUserPendingChangeSuspenseQueryHookResult = ReturnType<
  typeof useGetUserPendingChangeSuspenseQuery
>;
export type GetUserPendingChangeQueryResult = Apollo.QueryResult<
  GetUserPendingChangeQuery,
  GetUserPendingChangeQueryVariables
>;
export const UserAssignDocument = gql`
  mutation UserAssign($input: UserAssignInput!) {
    userAssign(input: $input) {
      user {
        userAccountId
      }
    }
  }
`;
export type UserAssignMutationFn = Apollo.MutationFunction<
  UserAssignMutation,
  UserAssignMutationVariables
>;

/**
 * __useUserAssignMutation__
 *
 * To run a mutation, you first call `useUserAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAssignMutation, { data, loading, error }] = useUserAssignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAssignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserAssignMutation,
    UserAssignMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UserAssignMutation, UserAssignMutationVariables>(
    UserAssignDocument,
    options,
  );
}
export type UserAssignMutationHookResult = ReturnType<
  typeof useUserAssignMutation
>;
export type UserAssignMutationResult =
  Apollo.MutationResult<UserAssignMutation>;
export type UserAssignMutationOptions = Apollo.BaseMutationOptions<
  UserAssignMutation,
  UserAssignMutationVariables
>;
export const UserCreateDocument = gql`
  mutation UserCreate($input: UserCreateInput!) {
    userCreate(input: $input) {
      user {
        userAccountId
      }
    }
  }
`;
export type UserCreateMutationFn = Apollo.MutationFunction<
  UserCreateMutation,
  UserCreateMutationVariables
>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserCreateMutation,
    UserCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(
    UserCreateDocument,
    options,
  );
}
export type UserCreateMutationHookResult = ReturnType<
  typeof useUserCreateMutation
>;
export type UserCreateMutationResult =
  Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<
  UserCreateMutation,
  UserCreateMutationVariables
>;
export const UserRemoveAssignmentDocument = gql`
  mutation UserRemoveAssignment($input: UserRemoveAssignmentInput!) {
    userRemoveAssignment(input: $input) {
      user {
        userAccountId
      }
    }
  }
`;
export type UserRemoveAssignmentMutationFn = Apollo.MutationFunction<
  UserRemoveAssignmentMutation,
  UserRemoveAssignmentMutationVariables
>;

/**
 * __useUserRemoveAssignmentMutation__
 *
 * To run a mutation, you first call `useUserRemoveAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRemoveAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRemoveAssignmentMutation, { data, loading, error }] = useUserRemoveAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserRemoveAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserRemoveAssignmentMutation,
    UserRemoveAssignmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserRemoveAssignmentMutation,
    UserRemoveAssignmentMutationVariables
  >(UserRemoveAssignmentDocument, options);
}
export type UserRemoveAssignmentMutationHookResult = ReturnType<
  typeof useUserRemoveAssignmentMutation
>;
export type UserRemoveAssignmentMutationResult =
  Apollo.MutationResult<UserRemoveAssignmentMutation>;
export type UserRemoveAssignmentMutationOptions = Apollo.BaseMutationOptions<
  UserRemoveAssignmentMutation,
  UserRemoveAssignmentMutationVariables
>;
export const UserUpdateAssignmentDocument = gql`
  mutation UserUpdateAssignment($input: UserUpdateAssignmentInput!) {
    userUpdateAssignment(input: $input) {
      user {
        userAccountId
      }
    }
  }
`;
export type UserUpdateAssignmentMutationFn = Apollo.MutationFunction<
  UserUpdateAssignmentMutation,
  UserUpdateAssignmentMutationVariables
>;

/**
 * __useUserUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUserUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateAssignmentMutation, { data, loading, error }] = useUserUpdateAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserUpdateAssignmentMutation,
    UserUpdateAssignmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserUpdateAssignmentMutation,
    UserUpdateAssignmentMutationVariables
  >(UserUpdateAssignmentDocument, options);
}
export type UserUpdateAssignmentMutationHookResult = ReturnType<
  typeof useUserUpdateAssignmentMutation
>;
export type UserUpdateAssignmentMutationResult =
  Apollo.MutationResult<UserUpdateAssignmentMutation>;
export type UserUpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<
  UserUpdateAssignmentMutation,
  UserUpdateAssignmentMutationVariables
>;
export const GetUserRoleModalContractorsDocument = gql`
  query GetUserRoleModalContractors(
    $workerId: ID!
    $includeArchived: Boolean
    $availableRoleObjectsInput: UserAvailableRoleObjectsInput
  ) {
    getWorker(workerId: $workerId, includeArchived: $includeArchived) {
      user {
        userAccountId
        availableRoleObjects(input: $availableRoleObjectsInput) {
          contractors {
            contractorId
            organization {
              organizationId
              name
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetUserRoleModalContractorsQuery__
 *
 * To run a query within a React component, call `useGetUserRoleModalContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRoleModalContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRoleModalContractorsQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      includeArchived: // value for 'includeArchived'
 *      availableRoleObjectsInput: // value for 'availableRoleObjectsInput'
 *   },
 * });
 */
export function useGetUserRoleModalContractorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserRoleModalContractorsQuery,
    GetUserRoleModalContractorsQueryVariables
  > &
    (
      | { variables: GetUserRoleModalContractorsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserRoleModalContractorsQuery,
    GetUserRoleModalContractorsQueryVariables
  >(GetUserRoleModalContractorsDocument, options);
}
export function useGetUserRoleModalContractorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserRoleModalContractorsQuery,
    GetUserRoleModalContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserRoleModalContractorsQuery,
    GetUserRoleModalContractorsQueryVariables
  >(GetUserRoleModalContractorsDocument, options);
}
export function useGetUserRoleModalContractorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserRoleModalContractorsQuery,
    GetUserRoleModalContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserRoleModalContractorsQuery,
    GetUserRoleModalContractorsQueryVariables
  >(GetUserRoleModalContractorsDocument, options);
}
export type GetUserRoleModalContractorsQueryHookResult = ReturnType<
  typeof useGetUserRoleModalContractorsQuery
>;
export type GetUserRoleModalContractorsLazyQueryHookResult = ReturnType<
  typeof useGetUserRoleModalContractorsLazyQuery
>;
export type GetUserRoleModalContractorsSuspenseQueryHookResult = ReturnType<
  typeof useGetUserRoleModalContractorsSuspenseQuery
>;
export type GetUserRoleModalContractorsQueryResult = Apollo.QueryResult<
  GetUserRoleModalContractorsQuery,
  GetUserRoleModalContractorsQueryVariables
>;
export const GetUserRoleModalJobsitesDocument = gql`
  query GetUserRoleModalJobsites(
    $workerId: ID!
    $includeArchived: Boolean
    $availableRoleObjectsInput: UserAvailableRoleObjectsInput
  ) {
    getWorker(workerId: $workerId, includeArchived: $includeArchived) {
      user {
        userAccountId
        availableRoleObjects(input: $availableRoleObjectsInput) {
          jobsites {
            jobsiteId
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetUserRoleModalJobsitesQuery__
 *
 * To run a query within a React component, call `useGetUserRoleModalJobsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRoleModalJobsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRoleModalJobsitesQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      includeArchived: // value for 'includeArchived'
 *      availableRoleObjectsInput: // value for 'availableRoleObjectsInput'
 *   },
 * });
 */
export function useGetUserRoleModalJobsitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserRoleModalJobsitesQuery,
    GetUserRoleModalJobsitesQueryVariables
  > &
    (
      | { variables: GetUserRoleModalJobsitesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserRoleModalJobsitesQuery,
    GetUserRoleModalJobsitesQueryVariables
  >(GetUserRoleModalJobsitesDocument, options);
}
export function useGetUserRoleModalJobsitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserRoleModalJobsitesQuery,
    GetUserRoleModalJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserRoleModalJobsitesQuery,
    GetUserRoleModalJobsitesQueryVariables
  >(GetUserRoleModalJobsitesDocument, options);
}
export function useGetUserRoleModalJobsitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserRoleModalJobsitesQuery,
    GetUserRoleModalJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserRoleModalJobsitesQuery,
    GetUserRoleModalJobsitesQueryVariables
  >(GetUserRoleModalJobsitesDocument, options);
}
export type GetUserRoleModalJobsitesQueryHookResult = ReturnType<
  typeof useGetUserRoleModalJobsitesQuery
>;
export type GetUserRoleModalJobsitesLazyQueryHookResult = ReturnType<
  typeof useGetUserRoleModalJobsitesLazyQuery
>;
export type GetUserRoleModalJobsitesSuspenseQueryHookResult = ReturnType<
  typeof useGetUserRoleModalJobsitesSuspenseQuery
>;
export type GetUserRoleModalJobsitesQueryResult = Apollo.QueryResult<
  GetUserRoleModalJobsitesQuery,
  GetUserRoleModalJobsitesQueryVariables
>;
export const GetUsersDocument = gql`
  query GetUsers($usersInput: UserUsersInput) {
    getCurrentSession {
      user {
        users(input: $usersInput) {
          jobsiteUsersCount
          contractorUsersCount
          developerUsersCount
          edges {
            node {
              userAccountId
              roles {
                key
                displayName
                object {
                  objectId
                  objectDetails {
                    name
                  }
                }
              }
              identity {
                firstName
                lastName
                email
                phoneNumber
              }
              worker {
                workerId
                profilePictureCropped {
                  downloadUrl
                }
              }
              lastSession {
                createdAt
                appVersion
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      usersInput: // value for 'usersInput'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersSuspenseQueryHookResult = ReturnType<
  typeof useGetUsersSuspenseQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const GetWorkerAccessRestorePreviewDocument = gql`
  query GetWorkerAccessRestorePreview($siteId: ID!, $workerId: ID!) {
    workerAccessRestorePreview(siteId: $siteId, workerId: $workerId) {
      status
      groups {
        id
        name
      }
      totalCount
    }
  }
`;

/**
 * __useGetWorkerAccessRestorePreviewQuery__
 *
 * To run a query within a React component, call `useGetWorkerAccessRestorePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerAccessRestorePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerAccessRestorePreviewQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetWorkerAccessRestorePreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerAccessRestorePreviewQuery,
    GetWorkerAccessRestorePreviewQueryVariables
  > &
    (
      | {
          variables: GetWorkerAccessRestorePreviewQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerAccessRestorePreviewQuery,
    GetWorkerAccessRestorePreviewQueryVariables
  >(GetWorkerAccessRestorePreviewDocument, options);
}
export function useGetWorkerAccessRestorePreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerAccessRestorePreviewQuery,
    GetWorkerAccessRestorePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerAccessRestorePreviewQuery,
    GetWorkerAccessRestorePreviewQueryVariables
  >(GetWorkerAccessRestorePreviewDocument, options);
}
export function useGetWorkerAccessRestorePreviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerAccessRestorePreviewQuery,
    GetWorkerAccessRestorePreviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerAccessRestorePreviewQuery,
    GetWorkerAccessRestorePreviewQueryVariables
  >(GetWorkerAccessRestorePreviewDocument, options);
}
export type GetWorkerAccessRestorePreviewQueryHookResult = ReturnType<
  typeof useGetWorkerAccessRestorePreviewQuery
>;
export type GetWorkerAccessRestorePreviewLazyQueryHookResult = ReturnType<
  typeof useGetWorkerAccessRestorePreviewLazyQuery
>;
export type GetWorkerAccessRestorePreviewSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerAccessRestorePreviewSuspenseQuery
>;
export type GetWorkerAccessRestorePreviewQueryResult = Apollo.QueryResult<
  GetWorkerAccessRestorePreviewQuery,
  GetWorkerAccessRestorePreviewQueryVariables
>;
export const ArchiveJobsiteWorkerAccessEventDocument = gql`
  mutation ArchiveJobsiteWorkerAccessEvent(
    $input: ArchiveJobsiteWorkerAccessEventInput!
  ) {
    archiveJobsiteWorkerAccessEvent(input: $input) {
      success {
        success
      }
      accessEventId
    }
  }
`;
export type ArchiveJobsiteWorkerAccessEventMutationFn = Apollo.MutationFunction<
  ArchiveJobsiteWorkerAccessEventMutation,
  ArchiveJobsiteWorkerAccessEventMutationVariables
>;

/**
 * __useArchiveJobsiteWorkerAccessEventMutation__
 *
 * To run a mutation, you first call `useArchiveJobsiteWorkerAccessEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveJobsiteWorkerAccessEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveJobsiteWorkerAccessEventMutation, { data, loading, error }] = useArchiveJobsiteWorkerAccessEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveJobsiteWorkerAccessEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveJobsiteWorkerAccessEventMutation,
    ArchiveJobsiteWorkerAccessEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveJobsiteWorkerAccessEventMutation,
    ArchiveJobsiteWorkerAccessEventMutationVariables
  >(ArchiveJobsiteWorkerAccessEventDocument, options);
}
export type ArchiveJobsiteWorkerAccessEventMutationHookResult = ReturnType<
  typeof useArchiveJobsiteWorkerAccessEventMutation
>;
export type ArchiveJobsiteWorkerAccessEventMutationResult =
  Apollo.MutationResult<ArchiveJobsiteWorkerAccessEventMutation>;
export type ArchiveJobsiteWorkerAccessEventMutationOptions =
  Apollo.BaseMutationOptions<
    ArchiveJobsiteWorkerAccessEventMutation,
    ArchiveJobsiteWorkerAccessEventMutationVariables
  >;
export const ChangeContractorForJobsiteWorkersDocument = gql`
  mutation ChangeContractorForJobsiteWorkers(
    $input: ChangeContractorForJobsiteWorkersInput
  ) {
    changeContractorForJobsiteWorkers(input: $input) {
      changeContractorForJobsiteWorkersSuccess {
        jobsiteWorker {
          jobsiteWorkerId
          startDate
          contractorWorker {
            worker {
              workerId
              user {
                identity {
                  firstName
                  lastName
                }
              }
            }
          }
          jobsiteContractor {
            jobsite {
              jobsiteId
              name
            }
          }
        }
      }
      changeContractorForJobsiteWorkersError {
        errorMessage
      }
    }
  }
`;
export type ChangeContractorForJobsiteWorkersMutationFn =
  Apollo.MutationFunction<
    ChangeContractorForJobsiteWorkersMutation,
    ChangeContractorForJobsiteWorkersMutationVariables
  >;

/**
 * __useChangeContractorForJobsiteWorkersMutation__
 *
 * To run a mutation, you first call `useChangeContractorForJobsiteWorkersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeContractorForJobsiteWorkersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeContractorForJobsiteWorkersMutation, { data, loading, error }] = useChangeContractorForJobsiteWorkersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeContractorForJobsiteWorkersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeContractorForJobsiteWorkersMutation,
    ChangeContractorForJobsiteWorkersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeContractorForJobsiteWorkersMutation,
    ChangeContractorForJobsiteWorkersMutationVariables
  >(ChangeContractorForJobsiteWorkersDocument, options);
}
export type ChangeContractorForJobsiteWorkersMutationHookResult = ReturnType<
  typeof useChangeContractorForJobsiteWorkersMutation
>;
export type ChangeContractorForJobsiteWorkersMutationResult =
  Apollo.MutationResult<ChangeContractorForJobsiteWorkersMutation>;
export type ChangeContractorForJobsiteWorkersMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeContractorForJobsiteWorkersMutation,
    ChangeContractorForJobsiteWorkersMutationVariables
  >;
export const ChangeJobsiteWorkersJobsiteAssignmentDocument = gql`
  mutation ChangeJobsiteWorkersJobsiteAssignment(
    $input: ChangeJobsiteWorkersJobsiteAssignmentInput!
  ) {
    changeJobsiteWorkersJobsiteAssignment(input: $input) {
      totalCount
      edges {
        jobsiteWorkerId
        jobsiteContractor {
          jobsite {
            jobsiteId
            name
          }
        }
      }
    }
  }
`;
export type ChangeJobsiteWorkersJobsiteAssignmentMutationFn =
  Apollo.MutationFunction<
    ChangeJobsiteWorkersJobsiteAssignmentMutation,
    ChangeJobsiteWorkersJobsiteAssignmentMutationVariables
  >;

/**
 * __useChangeJobsiteWorkersJobsiteAssignmentMutation__
 *
 * To run a mutation, you first call `useChangeJobsiteWorkersJobsiteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeJobsiteWorkersJobsiteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeJobsiteWorkersJobsiteAssignmentMutation, { data, loading, error }] = useChangeJobsiteWorkersJobsiteAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeJobsiteWorkersJobsiteAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeJobsiteWorkersJobsiteAssignmentMutation,
    ChangeJobsiteWorkersJobsiteAssignmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeJobsiteWorkersJobsiteAssignmentMutation,
    ChangeJobsiteWorkersJobsiteAssignmentMutationVariables
  >(ChangeJobsiteWorkersJobsiteAssignmentDocument, options);
}
export type ChangeJobsiteWorkersJobsiteAssignmentMutationHookResult =
  ReturnType<typeof useChangeJobsiteWorkersJobsiteAssignmentMutation>;
export type ChangeJobsiteWorkersJobsiteAssignmentMutationResult =
  Apollo.MutationResult<ChangeJobsiteWorkersJobsiteAssignmentMutation>;
export type ChangeJobsiteWorkersJobsiteAssignmentMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeJobsiteWorkersJobsiteAssignmentMutation,
    ChangeJobsiteWorkersJobsiteAssignmentMutationVariables
  >;
export const CheckInJobsiteWorkersDocument = gql`
  mutation CheckInJobsiteWorkers($input: CheckInJobsiteWorkersInput!) {
    checkInJobsiteWorkers(input: $input) {
      totalCount
      edges {
        id
        checkInDateTime
        area {
          id
          name
        }
        jobsiteWorker {
          jobsiteWorkerId
          jobsiteContractor {
            jobsite {
              name
              jobsiteId
            }
          }
          contractorWorker {
            worker {
              workerId
            }
          }
        }
      }
    }
  }
`;
export type CheckInJobsiteWorkersMutationFn = Apollo.MutationFunction<
  CheckInJobsiteWorkersMutation,
  CheckInJobsiteWorkersMutationVariables
>;

/**
 * __useCheckInJobsiteWorkersMutation__
 *
 * To run a mutation, you first call `useCheckInJobsiteWorkersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInJobsiteWorkersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInJobsiteWorkersMutation, { data, loading, error }] = useCheckInJobsiteWorkersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckInJobsiteWorkersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckInJobsiteWorkersMutation,
    CheckInJobsiteWorkersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CheckInJobsiteWorkersMutation,
    CheckInJobsiteWorkersMutationVariables
  >(CheckInJobsiteWorkersDocument, options);
}
export type CheckInJobsiteWorkersMutationHookResult = ReturnType<
  typeof useCheckInJobsiteWorkersMutation
>;
export type CheckInJobsiteWorkersMutationResult =
  Apollo.MutationResult<CheckInJobsiteWorkersMutation>;
export type CheckInJobsiteWorkersMutationOptions = Apollo.BaseMutationOptions<
  CheckInJobsiteWorkersMutation,
  CheckInJobsiteWorkersMutationVariables
>;
export const CompleteSelfOnBoardingDocument = gql`
  mutation CompleteSelfOnBoarding($jobsiteWorkerId: ID!) {
    completeSelfOnBoarding(jobsiteWorkerId: $jobsiteWorkerId) {
      jobsiteWorkerId
      orientationStatus
      orientationDate
      contractorWorker {
        worker {
          workerId
          selfOnboardingCurrentStep
        }
      }
    }
  }
`;
export type CompleteSelfOnBoardingMutationFn = Apollo.MutationFunction<
  CompleteSelfOnBoardingMutation,
  CompleteSelfOnBoardingMutationVariables
>;

/**
 * __useCompleteSelfOnBoardingMutation__
 *
 * To run a mutation, you first call `useCompleteSelfOnBoardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSelfOnBoardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSelfOnBoardingMutation, { data, loading, error }] = useCompleteSelfOnBoardingMutation({
 *   variables: {
 *      jobsiteWorkerId: // value for 'jobsiteWorkerId'
 *   },
 * });
 */
export function useCompleteSelfOnBoardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteSelfOnBoardingMutation,
    CompleteSelfOnBoardingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteSelfOnBoardingMutation,
    CompleteSelfOnBoardingMutationVariables
  >(CompleteSelfOnBoardingDocument, options);
}
export type CompleteSelfOnBoardingMutationHookResult = ReturnType<
  typeof useCompleteSelfOnBoardingMutation
>;
export type CompleteSelfOnBoardingMutationResult =
  Apollo.MutationResult<CompleteSelfOnBoardingMutation>;
export type CompleteSelfOnBoardingMutationOptions = Apollo.BaseMutationOptions<
  CompleteSelfOnBoardingMutation,
  CompleteSelfOnBoardingMutationVariables
>;
export const EnableJobsiteWorkerSelfOnboardingDocument = gql`
  mutation EnableJobsiteWorkerSelfOnboarding($jobsiteWorkerId: ID!) {
    enableJobsiteWorkerSelfOnboarding(jobsiteWorkerId: $jobsiteWorkerId) {
      jobsiteWorkerId
      orientationStatus
    }
  }
`;
export type EnableJobsiteWorkerSelfOnboardingMutationFn =
  Apollo.MutationFunction<
    EnableJobsiteWorkerSelfOnboardingMutation,
    EnableJobsiteWorkerSelfOnboardingMutationVariables
  >;

/**
 * __useEnableJobsiteWorkerSelfOnboardingMutation__
 *
 * To run a mutation, you first call `useEnableJobsiteWorkerSelfOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableJobsiteWorkerSelfOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableJobsiteWorkerSelfOnboardingMutation, { data, loading, error }] = useEnableJobsiteWorkerSelfOnboardingMutation({
 *   variables: {
 *      jobsiteWorkerId: // value for 'jobsiteWorkerId'
 *   },
 * });
 */
export function useEnableJobsiteWorkerSelfOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableJobsiteWorkerSelfOnboardingMutation,
    EnableJobsiteWorkerSelfOnboardingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnableJobsiteWorkerSelfOnboardingMutation,
    EnableJobsiteWorkerSelfOnboardingMutationVariables
  >(EnableJobsiteWorkerSelfOnboardingDocument, options);
}
export type EnableJobsiteWorkerSelfOnboardingMutationHookResult = ReturnType<
  typeof useEnableJobsiteWorkerSelfOnboardingMutation
>;
export type EnableJobsiteWorkerSelfOnboardingMutationResult =
  Apollo.MutationResult<EnableJobsiteWorkerSelfOnboardingMutation>;
export type EnableJobsiteWorkerSelfOnboardingMutationOptions =
  Apollo.BaseMutationOptions<
    EnableJobsiteWorkerSelfOnboardingMutation,
    EnableJobsiteWorkerSelfOnboardingMutationVariables
  >;
export const ManuallyEnterCardNumberForPrintJobDocument = gql`
  mutation ManuallyEnterCardNumberForPrintJob(
    $cardPrintJobId: ID!
    $cardNumber: String!
    $workerCardFormatId: ID!
    $forceCreate: Boolean
  ) {
    manuallyEnterCardNumberForPrintJob(
      cardPrintJobId: $cardPrintJobId
      cardNumber: $cardNumber
      workerCardFormatId: $workerCardFormatId
      forceCreate: $forceCreate
    ) {
      workerCardId
      cardNumber
      workerCardFormat {
        workerCardFormatId
        name
      }
    }
  }
`;
export type ManuallyEnterCardNumberForPrintJobMutationFn =
  Apollo.MutationFunction<
    ManuallyEnterCardNumberForPrintJobMutation,
    ManuallyEnterCardNumberForPrintJobMutationVariables
  >;

/**
 * __useManuallyEnterCardNumberForPrintJobMutation__
 *
 * To run a mutation, you first call `useManuallyEnterCardNumberForPrintJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManuallyEnterCardNumberForPrintJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manuallyEnterCardNumberForPrintJobMutation, { data, loading, error }] = useManuallyEnterCardNumberForPrintJobMutation({
 *   variables: {
 *      cardPrintJobId: // value for 'cardPrintJobId'
 *      cardNumber: // value for 'cardNumber'
 *      workerCardFormatId: // value for 'workerCardFormatId'
 *      forceCreate: // value for 'forceCreate'
 *   },
 * });
 */
export function useManuallyEnterCardNumberForPrintJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ManuallyEnterCardNumberForPrintJobMutation,
    ManuallyEnterCardNumberForPrintJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ManuallyEnterCardNumberForPrintJobMutation,
    ManuallyEnterCardNumberForPrintJobMutationVariables
  >(ManuallyEnterCardNumberForPrintJobDocument, options);
}
export type ManuallyEnterCardNumberForPrintJobMutationHookResult = ReturnType<
  typeof useManuallyEnterCardNumberForPrintJobMutation
>;
export type ManuallyEnterCardNumberForPrintJobMutationResult =
  Apollo.MutationResult<ManuallyEnterCardNumberForPrintJobMutation>;
export type ManuallyEnterCardNumberForPrintJobMutationOptions =
  Apollo.BaseMutationOptions<
    ManuallyEnterCardNumberForPrintJobMutation,
    ManuallyEnterCardNumberForPrintJobMutationVariables
  >;
export const ReactivateWorkerCardDocument = gql`
  mutation ReactivateWorkerCard(
    $id: ID!
    $forceCreate: Boolean
    $endDate: Date
  ) {
    reactivateWorkerCard(
      id: $id
      forceCreate: $forceCreate
      endDate: $endDate
    ) {
      success
    }
  }
`;
export type ReactivateWorkerCardMutationFn = Apollo.MutationFunction<
  ReactivateWorkerCardMutation,
  ReactivateWorkerCardMutationVariables
>;

/**
 * __useReactivateWorkerCardMutation__
 *
 * To run a mutation, you first call `useReactivateWorkerCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateWorkerCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateWorkerCardMutation, { data, loading, error }] = useReactivateWorkerCardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      forceCreate: // value for 'forceCreate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useReactivateWorkerCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReactivateWorkerCardMutation,
    ReactivateWorkerCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReactivateWorkerCardMutation,
    ReactivateWorkerCardMutationVariables
  >(ReactivateWorkerCardDocument, options);
}
export type ReactivateWorkerCardMutationHookResult = ReturnType<
  typeof useReactivateWorkerCardMutation
>;
export type ReactivateWorkerCardMutationResult =
  Apollo.MutationResult<ReactivateWorkerCardMutation>;
export type ReactivateWorkerCardMutationOptions = Apollo.BaseMutationOptions<
  ReactivateWorkerCardMutation,
  ReactivateWorkerCardMutationVariables
>;
export const RemoveWorkerFromJobsiteDocument = gql`
  mutation RemoveWorkerFromJobsite($input: RemoveWorkerFromJobsiteInput!) {
    removeWorkerFromJobsite(input: $input) {
      success {
        success
      }
    }
  }
`;
export type RemoveWorkerFromJobsiteMutationFn = Apollo.MutationFunction<
  RemoveWorkerFromJobsiteMutation,
  RemoveWorkerFromJobsiteMutationVariables
>;

/**
 * __useRemoveWorkerFromJobsiteMutation__
 *
 * To run a mutation, you first call `useRemoveWorkerFromJobsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWorkerFromJobsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWorkerFromJobsiteMutation, { data, loading, error }] = useRemoveWorkerFromJobsiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveWorkerFromJobsiteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveWorkerFromJobsiteMutation,
    RemoveWorkerFromJobsiteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveWorkerFromJobsiteMutation,
    RemoveWorkerFromJobsiteMutationVariables
  >(RemoveWorkerFromJobsiteDocument, options);
}
export type RemoveWorkerFromJobsiteMutationHookResult = ReturnType<
  typeof useRemoveWorkerFromJobsiteMutation
>;
export type RemoveWorkerFromJobsiteMutationResult =
  Apollo.MutationResult<RemoveWorkerFromJobsiteMutation>;
export type RemoveWorkerFromJobsiteMutationOptions = Apollo.BaseMutationOptions<
  RemoveWorkerFromJobsiteMutation,
  RemoveWorkerFromJobsiteMutationVariables
>;
export const UpdateJobsiteWorkerDocument = gql`
  mutation UpdateJobsiteWorker(
    $jobsiteWorkerId: ID!
    $jobsiteWorkerInput: JobsiteWorkerInput!
    $skipACSSync: Boolean
  ) {
    updateJobsiteWorker(
      jobsiteWorkerId: $jobsiteWorkerId
      jobsiteWorkerInput: $jobsiteWorkerInput
      skipACSSync: $skipACSSync
    ) {
      orientationDate
      trade
      jobTitle
      unionAffiliation
    }
  }
`;
export type UpdateJobsiteWorkerMutationFn = Apollo.MutationFunction<
  UpdateJobsiteWorkerMutation,
  UpdateJobsiteWorkerMutationVariables
>;

/**
 * __useUpdateJobsiteWorkerMutation__
 *
 * To run a mutation, you first call `useUpdateJobsiteWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobsiteWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobsiteWorkerMutation, { data, loading, error }] = useUpdateJobsiteWorkerMutation({
 *   variables: {
 *      jobsiteWorkerId: // value for 'jobsiteWorkerId'
 *      jobsiteWorkerInput: // value for 'jobsiteWorkerInput'
 *      skipACSSync: // value for 'skipACSSync'
 *   },
 * });
 */
export function useUpdateJobsiteWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateJobsiteWorkerMutation,
    UpdateJobsiteWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateJobsiteWorkerMutation,
    UpdateJobsiteWorkerMutationVariables
  >(UpdateJobsiteWorkerDocument, options);
}
export type UpdateJobsiteWorkerMutationHookResult = ReturnType<
  typeof useUpdateJobsiteWorkerMutation
>;
export type UpdateJobsiteWorkerMutationResult =
  Apollo.MutationResult<UpdateJobsiteWorkerMutation>;
export type UpdateJobsiteWorkerMutationOptions = Apollo.BaseMutationOptions<
  UpdateJobsiteWorkerMutation,
  UpdateJobsiteWorkerMutationVariables
>;
export const UpdateWorkerDocument = gql`
  mutation UpdateWorker($workerId: ID!, $workerInput: WorkerInput!) {
    updateWorker(workerId: $workerId, workerInput: $workerInput) {
      birthDate
      ssnLastFour
      workerId
      profilePictureCropped {
        downloadUrl
      }
      user {
        userAccountId
        createdAt
        identity {
          firstName
          lastName
          createdAt
          updatedAt
        }
        roles {
          key
          displayName
          roleCreatedAt
          roleUpdatedAt
          mappingCreatedAt
        }
      }
    }
  }
`;
export type UpdateWorkerMutationFn = Apollo.MutationFunction<
  UpdateWorkerMutation,
  UpdateWorkerMutationVariables
>;

/**
 * __useUpdateWorkerMutation__
 *
 * To run a mutation, you first call `useUpdateWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkerMutation, { data, loading, error }] = useUpdateWorkerMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      workerInput: // value for 'workerInput'
 *   },
 * });
 */
export function useUpdateWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateWorkerMutation,
    UpdateWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateWorkerMutation,
    UpdateWorkerMutationVariables
  >(UpdateWorkerDocument, options);
}
export type UpdateWorkerMutationHookResult = ReturnType<
  typeof useUpdateWorkerMutation
>;
export type UpdateWorkerMutationResult =
  Apollo.MutationResult<UpdateWorkerMutation>;
export type UpdateWorkerMutationOptions = Apollo.BaseMutationOptions<
  UpdateWorkerMutation,
  UpdateWorkerMutationVariables
>;
export const UserUpdateIdentityDocument = gql`
  mutation UserUpdateIdentity($input: UserUpdateIdentityInput!) {
    userUpdateIdentity(input: $input) {
      user {
        identity {
          firstName
          lastName
          email
        }
      }
    }
  }
`;
export type UserUpdateIdentityMutationFn = Apollo.MutationFunction<
  UserUpdateIdentityMutation,
  UserUpdateIdentityMutationVariables
>;

/**
 * __useUserUpdateIdentityMutation__
 *
 * To run a mutation, you first call `useUserUpdateIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateIdentityMutation, { data, loading, error }] = useUserUpdateIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateIdentityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserUpdateIdentityMutation,
    UserUpdateIdentityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserUpdateIdentityMutation,
    UserUpdateIdentityMutationVariables
  >(UserUpdateIdentityDocument, options);
}
export type UserUpdateIdentityMutationHookResult = ReturnType<
  typeof useUserUpdateIdentityMutation
>;
export type UserUpdateIdentityMutationResult =
  Apollo.MutationResult<UserUpdateIdentityMutation>;
export type UserUpdateIdentityMutationOptions = Apollo.BaseMutationOptions<
  UserUpdateIdentityMutation,
  UserUpdateIdentityMutationVariables
>;
export const WorkerUnlockProfileDocument = gql`
  mutation WorkerUnlockProfile($input: WorkerUnlockProfileInput!) {
    workerUnlockProfile(input: $input) {
      userWorkerProfileAccess {
        id
        isUnlocked
      }
    }
  }
`;
export type WorkerUnlockProfileMutationFn = Apollo.MutationFunction<
  WorkerUnlockProfileMutation,
  WorkerUnlockProfileMutationVariables
>;

/**
 * __useWorkerUnlockProfileMutation__
 *
 * To run a mutation, you first call `useWorkerUnlockProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkerUnlockProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workerUnlockProfileMutation, { data, loading, error }] = useWorkerUnlockProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkerUnlockProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WorkerUnlockProfileMutation,
    WorkerUnlockProfileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WorkerUnlockProfileMutation,
    WorkerUnlockProfileMutationVariables
  >(WorkerUnlockProfileDocument, options);
}
export type WorkerUnlockProfileMutationHookResult = ReturnType<
  typeof useWorkerUnlockProfileMutation
>;
export type WorkerUnlockProfileMutationResult =
  Apollo.MutationResult<WorkerUnlockProfileMutation>;
export type WorkerUnlockProfileMutationOptions = Apollo.BaseMutationOptions<
  WorkerUnlockProfileMutation,
  WorkerUnlockProfileMutationVariables
>;
export const ArchiveWorkerDocument = gql`
  mutation ArchiveWorker($workerId: ID!) {
    archiveWorker(workerId: $workerId) {
      user {
        identity {
          firstName
          lastName
        }
      }
    }
  }
`;
export type ArchiveWorkerMutationFn = Apollo.MutationFunction<
  ArchiveWorkerMutation,
  ArchiveWorkerMutationVariables
>;

/**
 * __useArchiveWorkerMutation__
 *
 * To run a mutation, you first call `useArchiveWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkerMutation, { data, loading, error }] = useArchiveWorkerMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useArchiveWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveWorkerMutation,
    ArchiveWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveWorkerMutation,
    ArchiveWorkerMutationVariables
  >(ArchiveWorkerDocument, options);
}
export type ArchiveWorkerMutationHookResult = ReturnType<
  typeof useArchiveWorkerMutation
>;
export type ArchiveWorkerMutationResult =
  Apollo.MutationResult<ArchiveWorkerMutation>;
export type ArchiveWorkerMutationOptions = Apollo.BaseMutationOptions<
  ArchiveWorkerMutation,
  ArchiveWorkerMutationVariables
>;
export const ExtractIdDataFromFileDocument = gql`
  mutation ExtractIdDataFromFile($extractionInput: DataExtractionInput!) {
    extractIdDataFromFile(extractionInput: $extractionInput) {
      file {
        fileId
      }
      extractedData {
        identifier
        idType
        issueDate
        expirationDate
        dateOfBirth
        fullName
        firstName
        lastName
        address
        title
      }
    }
  }
`;
export type ExtractIdDataFromFileMutationFn = Apollo.MutationFunction<
  ExtractIdDataFromFileMutation,
  ExtractIdDataFromFileMutationVariables
>;

/**
 * __useExtractIdDataFromFileMutation__
 *
 * To run a mutation, you first call `useExtractIdDataFromFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractIdDataFromFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractIdDataFromFileMutation, { data, loading, error }] = useExtractIdDataFromFileMutation({
 *   variables: {
 *      extractionInput: // value for 'extractionInput'
 *   },
 * });
 */
export function useExtractIdDataFromFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExtractIdDataFromFileMutation,
    ExtractIdDataFromFileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExtractIdDataFromFileMutation,
    ExtractIdDataFromFileMutationVariables
  >(ExtractIdDataFromFileDocument, options);
}
export type ExtractIdDataFromFileMutationHookResult = ReturnType<
  typeof useExtractIdDataFromFileMutation
>;
export type ExtractIdDataFromFileMutationResult =
  Apollo.MutationResult<ExtractIdDataFromFileMutation>;
export type ExtractIdDataFromFileMutationOptions = Apollo.BaseMutationOptions<
  ExtractIdDataFromFileMutation,
  ExtractIdDataFromFileMutationVariables
>;
export const UnarchiveWorkerDocument = gql`
  mutation UnarchiveWorker($workerId: ID!) {
    unarchiveWorker(workerId: $workerId) {
      user {
        identity {
          firstName
          lastName
        }
      }
    }
  }
`;
export type UnarchiveWorkerMutationFn = Apollo.MutationFunction<
  UnarchiveWorkerMutation,
  UnarchiveWorkerMutationVariables
>;

/**
 * __useUnarchiveWorkerMutation__
 *
 * To run a mutation, you first call `useUnarchiveWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveWorkerMutation, { data, loading, error }] = useUnarchiveWorkerMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useUnarchiveWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveWorkerMutation,
    UnarchiveWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveWorkerMutation,
    UnarchiveWorkerMutationVariables
  >(UnarchiveWorkerDocument, options);
}
export type UnarchiveWorkerMutationHookResult = ReturnType<
  typeof useUnarchiveWorkerMutation
>;
export type UnarchiveWorkerMutationResult =
  Apollo.MutationResult<UnarchiveWorkerMutation>;
export type UnarchiveWorkerMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveWorkerMutation,
  UnarchiveWorkerMutationVariables
>;
export const GetJobsiteAccessSessionsDocument = gql`
  query GetJobsiteAccessSessions(
    $jobsiteAccessSessionsInput: JobsiteAccessSessionsInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        jobsiteAccessSessions(input: $jobsiteAccessSessionsInput) {
          count
          edges {
            node {
              sessionId
              jobsiteWorker {
                contractorWorker {
                  worker {
                    workerId
                    user {
                      userAccountId
                      identity {
                        firstName
                        lastName
                      }
                    }
                    profilePictureCropped {
                      downloadUrl
                    }
                  }
                }
                jobsiteContractor {
                  id
                  jobsite {
                    jobsiteId
                    name
                  }
                }
              }
              proximitySession {
                id
                day
                start
                end
                active
                compliant
                closed
                locale {
                  time {
                    start
                    end
                  }
                }
                span {
                  hours
                }
                reads {
                  count
                  counts {
                    inbound
                    outbound
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteAccessSessionsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteAccessSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteAccessSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteAccessSessionsQuery({
 *   variables: {
 *      jobsiteAccessSessionsInput: // value for 'jobsiteAccessSessionsInput'
 *   },
 * });
 */
export function useGetJobsiteAccessSessionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetJobsiteAccessSessionsQuery,
    GetJobsiteAccessSessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteAccessSessionsQuery,
    GetJobsiteAccessSessionsQueryVariables
  >(GetJobsiteAccessSessionsDocument, options);
}
export function useGetJobsiteAccessSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteAccessSessionsQuery,
    GetJobsiteAccessSessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteAccessSessionsQuery,
    GetJobsiteAccessSessionsQueryVariables
  >(GetJobsiteAccessSessionsDocument, options);
}
export function useGetJobsiteAccessSessionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteAccessSessionsQuery,
    GetJobsiteAccessSessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteAccessSessionsQuery,
    GetJobsiteAccessSessionsQueryVariables
  >(GetJobsiteAccessSessionsDocument, options);
}
export type GetJobsiteAccessSessionsQueryHookResult = ReturnType<
  typeof useGetJobsiteAccessSessionsQuery
>;
export type GetJobsiteAccessSessionsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteAccessSessionsLazyQuery
>;
export type GetJobsiteAccessSessionsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteAccessSessionsSuspenseQuery
>;
export type GetJobsiteAccessSessionsQueryResult = Apollo.QueryResult<
  GetJobsiteAccessSessionsQuery,
  GetJobsiteAccessSessionsQueryVariables
>;
export const GetWorkerCCureDataDocument = gql`
  query GetWorkerCCureData($workerId: ID!) {
    getWorkerCCureData(workerId: $workerId) {
      data
    }
  }
`;

/**
 * __useGetWorkerCCureDataQuery__
 *
 * To run a query within a React component, call `useGetWorkerCCureDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerCCureDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerCCureDataQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetWorkerCCureDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerCCureDataQuery,
    GetWorkerCCureDataQueryVariables
  > &
    (
      | { variables: GetWorkerCCureDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerCCureDataQuery,
    GetWorkerCCureDataQueryVariables
  >(GetWorkerCCureDataDocument, options);
}
export function useGetWorkerCCureDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerCCureDataQuery,
    GetWorkerCCureDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerCCureDataQuery,
    GetWorkerCCureDataQueryVariables
  >(GetWorkerCCureDataDocument, options);
}
export function useGetWorkerCCureDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerCCureDataQuery,
    GetWorkerCCureDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerCCureDataQuery,
    GetWorkerCCureDataQueryVariables
  >(GetWorkerCCureDataDocument, options);
}
export type GetWorkerCCureDataQueryHookResult = ReturnType<
  typeof useGetWorkerCCureDataQuery
>;
export type GetWorkerCCureDataLazyQueryHookResult = ReturnType<
  typeof useGetWorkerCCureDataLazyQuery
>;
export type GetWorkerCCureDataSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerCCureDataSuspenseQuery
>;
export type GetWorkerCCureDataQueryResult = Apollo.QueryResult<
  GetWorkerCCureDataQuery,
  GetWorkerCCureDataQueryVariables
>;
export const GetWorkerDataDocument = gql`
  query GetWorkerData(
    $workerId: ID!
    $includeArchivedWorker: Boolean
    $jobsiteWorkersInput: WorkerJobsiteWorkersInput
    $jobsiteAccessSessionsInput: JobsiteAccessSessionsInput!
  ) {
    getWorker(workerId: $workerId, includeArchived: $includeArchivedWorker) {
      workerId
      middleInitial
      suffix
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZipCode
      addressZipCode
      birthDate
      emergencyContactName
      emergencyContactPhone
      emergencyContactRelationship
      gender
      primaryLanguage
      race
      isSkilled
      ssnLastFour
      citizenshipStatus
      workAuthorizationStatus
      isVeteran
      quickCode
      selfOnboardingCurrentStep
      createdMethod
      isArchived
      objectHistory {
        createdAt
        createdBy {
          userAccountId
          identity {
            firstName
            lastName
            email
          }
        }
        updatedAt
        updatedBy {
          userAccountId
          identity {
            firstName
            lastName
            email
          }
        }
      }
      accessHistory {
        changeCategory
        changeReason
        changeApprovedBy
        changeDate
        changeToAccess
        updatedByName
        banEndDate
        jobsiteName
      }
      profilePicture {
        downloadUrl
        uploadedAt
      }
      profilePictureCropped {
        downloadUrl
        uploadedAt
        fileId
        fileType
      }
      user {
        userAccountId
        isMobileUser
        mobileDeviceInfo {
          binaryVersion
          bundleVersion
          deviceModelName
          platform
        }
        identity {
          firstName
          lastName
          email
          phoneNumber
          fusionAuthId
          pendingChanges {
            phoneNumber {
              newValue
              submittedBy {
                userAccountId
              }
              expiresAt
            }
            email {
              newValue
              submittedBy {
                userAccountId
              }
              expiresAt
            }
          }
        }
        lastSession {
          createdAt
          appVersion
        }
      }
      profileAccess {
        id
        isUnlocked
      }
      editableFields {
        email
        phone
      }
      workerComments {
        edges {
          node {
            workerCommentId
            comment
            jobsite {
              name
              jobsiteId
            }
            objectHistory {
              createdAt
              createdBy {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
              updatedAt
              updatedBy {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
            }
          }
        }
      }
      jobsiteAccessSessions(input: $jobsiteAccessSessionsInput) {
        edges {
          node {
            active
            jobsiteWorker {
              jobsiteContractor {
                jobsite {
                  jobsiteId
                  name
                }
              }
            }
          }
        }
      }
      jobsiteWorkers(input: $jobsiteWorkersInput) {
        edges {
          node {
            jobsiteWorkerId
            isBanned
            banCategory
            bannedReason
            bannedAt
            banRemovedReason
            orientationDate
            startDate
            endDate
            payrollId
            trade
            tradeExperience
            jobTitle
            unionAffiliation
            classificationGroup
            siteSpecificTrainingCompletedAt
            siteSpecificTrainingSkipReason
            siteSpecificTrainingSkipExpiresAt
            stickerNumber
            orientationDate
            orientationStatus
            documentsCompletedAt
            documentsCompletedSkipExpiresAt
            documentsCompletedSkipReason
            urineTestConditionalPassExpiresAt
            banExpiresAt
            isSuspended
            badgingCompletedAt
            medicalNotes
            nycSstExemptionReason
            siteAccessChangeApprovedBy
            isExemptFromSwipeInactivity
            isExemptFromSiteSpecificRefresher
            passedMedicalExamAt
            medicalExamSkipReason
            medicalExamSkipExpiresAt
            isAntipassbackExempt
            documentExemptionReason
            customWorkerData
            clearanceAssignments {
              count
              edges {
                node {
                  id
                  clearance {
                    cCureClearanceId
                    name
                    cCureEnvironment {
                      cCureEnvironmentId
                      namespace
                      instanceSlug
                    }
                  }
                }
              }
            }
            objectHistory {
              createdAt
              createdBy {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
              updatedAt
              updatedBy {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
            }
            jobsiteContractor {
              jobsite {
                name
                jobsiteId
                timeZone
                parentId
                tradeOptions
                titleOptions
                unionAffiliationOptions
                classificationGroupOptions
                clearanceAssignmentEnabled
                jobsiteCustomWorkerDataFields {
                  edges {
                    node {
                      fieldLabel
                      fieldDataType
                      validationMessage
                      validationRegex
                      isRequired
                    }
                  }
                }
                defaultJobsitePrinterId
                developer {
                  developerId
                  name
                }
                featuresModule {
                  announcementsEnabled
                  archivingAccessEventsEnabled
                  isEnabled
                  name
                  slug
                }
                modules {
                  ... on JobsiteAppCheckInModule {
                    areas {
                      checkInCoordinate {
                        lat
                        lng
                      }
                      checkInRadius
                      id
                      isInboundEnabled
                      isOutboundEnabled
                    }
                    isEnabled
                    name
                    slug
                  }
                  ... on JobsiteOnboardingModule {
                    name
                    badgePrintingAllowed
                    badgeAssignmentAllowed
                    steps {
                      key
                      index
                      isRequired
                      isVisible
                    }
                  }
                }
              }
              contractor {
                contractorId
                organization {
                  organizationId
                  name
                }
              }
            }
            currentAccess {
              isAllowed
              notAllowedReason
              endDate
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkerDataQuery__
 *
 * To run a query within a React component, call `useGetWorkerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerDataQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      includeArchivedWorker: // value for 'includeArchivedWorker'
 *      jobsiteWorkersInput: // value for 'jobsiteWorkersInput'
 *      jobsiteAccessSessionsInput: // value for 'jobsiteAccessSessionsInput'
 *   },
 * });
 */
export function useGetWorkerDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerDataQuery,
    GetWorkerDataQueryVariables
  > &
    (
      | { variables: GetWorkerDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkerDataQuery, GetWorkerDataQueryVariables>(
    GetWorkerDataDocument,
    options,
  );
}
export function useGetWorkerDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerDataQuery,
    GetWorkerDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkerDataQuery, GetWorkerDataQueryVariables>(
    GetWorkerDataDocument,
    options,
  );
}
export function useGetWorkerDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerDataQuery,
    GetWorkerDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerDataQuery,
    GetWorkerDataQueryVariables
  >(GetWorkerDataDocument, options);
}
export type GetWorkerDataQueryHookResult = ReturnType<
  typeof useGetWorkerDataQuery
>;
export type GetWorkerDataLazyQueryHookResult = ReturnType<
  typeof useGetWorkerDataLazyQuery
>;
export type GetWorkerDataSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerDataSuspenseQuery
>;
export type GetWorkerDataQueryResult = Apollo.QueryResult<
  GetWorkerDataQuery,
  GetWorkerDataQueryVariables
>;
export const GetWorkerDocumentsDocument = gql`
  query GetWorkerDocuments(
    $workerId: ID!
    $includePhi: Boolean
    $includeArchived: Boolean
  ) {
    getWorkerDocuments(
      workerId: $workerId
      includePhi: $includePhi
      includeArchived: $includeArchived
    ) {
      workerDocuments {
        jobsiteWorkerDocumentId
        key
        jobsiteWorkerDocumentType {
          expiration
          key
          name
          jobsite {
            name
            jobsiteId
            developer {
              name
              developerId
            }
          }
          workerDocumentType {
            key
            name
            expirationDate
            isPhi
            isGlobal
            documentLevel
          }
        }
        jobsiteWorker {
          jobsiteContractor {
            jobsite {
              jobsiteId
            }
          }
          jobsiteWorkerId
        }
        jobsiteWorkerDocumentVersions {
          jobsiteWorkerDocumentVersionId
          files {
            fileId
            fileType
            downloadUrl
            uploadedAt
          }
          additionalFieldValues {
            key
            value
          }
          objectHistory {
            createdAt
            createdBy {
              userAccountId
              identity {
                firstName
                lastName
                email
              }
            }
            updatedAt
            updatedBy {
              userAccountId
              identity {
                firstName
                lastName
                email
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetWorkerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerDocumentsQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      includePhi: // value for 'includePhi'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetWorkerDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerDocumentsQuery,
    GetWorkerDocumentsQueryVariables
  > &
    (
      | { variables: GetWorkerDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerDocumentsQuery,
    GetWorkerDocumentsQueryVariables
  >(GetWorkerDocumentsDocument, options);
}
export function useGetWorkerDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerDocumentsQuery,
    GetWorkerDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerDocumentsQuery,
    GetWorkerDocumentsQueryVariables
  >(GetWorkerDocumentsDocument, options);
}
export function useGetWorkerDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerDocumentsQuery,
    GetWorkerDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerDocumentsQuery,
    GetWorkerDocumentsQueryVariables
  >(GetWorkerDocumentsDocument, options);
}
export type GetWorkerDocumentsQueryHookResult = ReturnType<
  typeof useGetWorkerDocumentsQuery
>;
export type GetWorkerDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetWorkerDocumentsLazyQuery
>;
export type GetWorkerDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerDocumentsSuspenseQuery
>;
export type GetWorkerDocumentsQueryResult = Apollo.QueryResult<
  GetWorkerDocumentsQuery,
  GetWorkerDocumentsQueryVariables
>;
export const GetWorkerJobsiteAccessActivityDocument = gql`
  query GetWorkerJobsiteAccessActivity(
    $workerId: ID!
    $includeArchived: Boolean
    $jobsiteAccessEventsInput: JobsiteAccessEventsInput
  ) {
    getWorker(workerId: $workerId, includeArchived: $includeArchived) {
      quickCode
      jobsiteAccessEvents(input: $jobsiteAccessEventsInput) {
        count
        edges {
          node {
            id
            type
            status
            credentialId
            eventOccurredAt
            localizedDate
            localizedTime
            sessionDate
            timeZone
            rejectionReason
            message
            gateway
            zoneCrossing {
              kind
              revisionId
              entryId
              entrySideId
              reason
              from {
                kind
                zoneId
                name
              }
              to {
                kind
                zoneId
                name
              }
            }
            overnightSession
            jobsite {
              jobsiteId
              name
            }
            jobsiteWorker {
              jobsiteWorkerId
              jobsiteContractor {
                id
              }
              contractorWorker {
                id
                contractor {
                  contractorId
                  organization {
                    organizationId
                    name
                  }
                }
              }
              currentAccess {
                isAllowed
              }
            }
            direction
            externalId
            eventType
            locationStatus
            credentialId
          }
        }
        filtersOptions {
          jobsites {
            value
            label
            count
          }
          contractors {
            value
            label
            count
          }
          zones {
            value
            label
          }
          gateways {
            value
            label
            count
          }
          rejectionReasons {
            value
            label
            count
          }
          locationStatuses {
            value
            label
            count
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkerJobsiteAccessActivityQuery__
 *
 * To run a query within a React component, call `useGetWorkerJobsiteAccessActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerJobsiteAccessActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerJobsiteAccessActivityQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      includeArchived: // value for 'includeArchived'
 *      jobsiteAccessEventsInput: // value for 'jobsiteAccessEventsInput'
 *   },
 * });
 */
export function useGetWorkerJobsiteAccessActivityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerJobsiteAccessActivityQuery,
    GetWorkerJobsiteAccessActivityQueryVariables
  > &
    (
      | {
          variables: GetWorkerJobsiteAccessActivityQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerJobsiteAccessActivityQuery,
    GetWorkerJobsiteAccessActivityQueryVariables
  >(GetWorkerJobsiteAccessActivityDocument, options);
}
export function useGetWorkerJobsiteAccessActivityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerJobsiteAccessActivityQuery,
    GetWorkerJobsiteAccessActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerJobsiteAccessActivityQuery,
    GetWorkerJobsiteAccessActivityQueryVariables
  >(GetWorkerJobsiteAccessActivityDocument, options);
}
export function useGetWorkerJobsiteAccessActivitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerJobsiteAccessActivityQuery,
    GetWorkerJobsiteAccessActivityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerJobsiteAccessActivityQuery,
    GetWorkerJobsiteAccessActivityQueryVariables
  >(GetWorkerJobsiteAccessActivityDocument, options);
}
export type GetWorkerJobsiteAccessActivityQueryHookResult = ReturnType<
  typeof useGetWorkerJobsiteAccessActivityQuery
>;
export type GetWorkerJobsiteAccessActivityLazyQueryHookResult = ReturnType<
  typeof useGetWorkerJobsiteAccessActivityLazyQuery
>;
export type GetWorkerJobsiteAccessActivitySuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerJobsiteAccessActivitySuspenseQuery
>;
export type GetWorkerJobsiteAccessActivityQueryResult = Apollo.QueryResult<
  GetWorkerJobsiteAccessActivityQuery,
  GetWorkerJobsiteAccessActivityQueryVariables
>;
export const GetWorkerJobsiteAccessSessionsDocument = gql`
  query GetWorkerJobsiteAccessSessions(
    $workerId: ID!
    $jobsiteAccessSessionsInput: JobsiteAccessSessionsInput
  ) {
    getWorker(workerId: $workerId) {
      jobsiteAccessSessions(input: $jobsiteAccessSessionsInput) {
        count
        edges {
          node {
            sessionId
            overnightSession
            inProgress
            jobsiteWorker {
              contractorWorker {
                contractor {
                  contractorId
                  organization {
                    organizationId
                    name
                  }
                }
              }
              jobsiteContractor {
                id
                jobsite {
                  jobsiteId
                  name
                }
              }
              currentAccess {
                isAllowed
              }
            }
            proximitySession {
              id
              day
              start
              end
              active
              compliant
              closed
              locale {
                time {
                  start
                  end
                }
              }
              span {
                hours
              }
              reads {
                count
                counts {
                  inbound
                  outbound
                }
              }
            }
          }
        }
        filtersOptions {
          jobsites {
            value
            label
            count
          }
          contractors {
            value
            label
            count
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkerJobsiteAccessSessionsQuery__
 *
 * To run a query within a React component, call `useGetWorkerJobsiteAccessSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerJobsiteAccessSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerJobsiteAccessSessionsQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      jobsiteAccessSessionsInput: // value for 'jobsiteAccessSessionsInput'
 *   },
 * });
 */
export function useGetWorkerJobsiteAccessSessionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerJobsiteAccessSessionsQuery,
    GetWorkerJobsiteAccessSessionsQueryVariables
  > &
    (
      | {
          variables: GetWorkerJobsiteAccessSessionsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerJobsiteAccessSessionsQuery,
    GetWorkerJobsiteAccessSessionsQueryVariables
  >(GetWorkerJobsiteAccessSessionsDocument, options);
}
export function useGetWorkerJobsiteAccessSessionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerJobsiteAccessSessionsQuery,
    GetWorkerJobsiteAccessSessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerJobsiteAccessSessionsQuery,
    GetWorkerJobsiteAccessSessionsQueryVariables
  >(GetWorkerJobsiteAccessSessionsDocument, options);
}
export function useGetWorkerJobsiteAccessSessionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerJobsiteAccessSessionsQuery,
    GetWorkerJobsiteAccessSessionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerJobsiteAccessSessionsQuery,
    GetWorkerJobsiteAccessSessionsQueryVariables
  >(GetWorkerJobsiteAccessSessionsDocument, options);
}
export type GetWorkerJobsiteAccessSessionsQueryHookResult = ReturnType<
  typeof useGetWorkerJobsiteAccessSessionsQuery
>;
export type GetWorkerJobsiteAccessSessionsLazyQueryHookResult = ReturnType<
  typeof useGetWorkerJobsiteAccessSessionsLazyQuery
>;
export type GetWorkerJobsiteAccessSessionsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerJobsiteAccessSessionsSuspenseQuery
>;
export type GetWorkerJobsiteAccessSessionsQueryResult = Apollo.QueryResult<
  GetWorkerJobsiteAccessSessionsQuery,
  GetWorkerJobsiteAccessSessionsQueryVariables
>;
export const GetWorkerUserRolesDocument = gql`
  query GetWorkerUserRoles(
    $workerId: ID!
    $includeArchivedWorker: Boolean
    $userRolesInput: UserRolesInput
  ) {
    getWorker(workerId: $workerId, includeArchived: $includeArchivedWorker) {
      workerId
      user {
        userAccountId
        roles(input: $userRolesInput) {
          key
          displayName
          mappingCreatedAt
          mappingUpdatedAt
          object {
            objectId
            objectName
            objectDetails {
              name
              title
              objectMemberId
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkerUserRolesQuery__
 *
 * To run a query within a React component, call `useGetWorkerUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerUserRolesQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      includeArchivedWorker: // value for 'includeArchivedWorker'
 *      userRolesInput: // value for 'userRolesInput'
 *   },
 * });
 */
export function useGetWorkerUserRolesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerUserRolesQuery,
    GetWorkerUserRolesQueryVariables
  > &
    (
      | { variables: GetWorkerUserRolesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerUserRolesQuery,
    GetWorkerUserRolesQueryVariables
  >(GetWorkerUserRolesDocument, options);
}
export function useGetWorkerUserRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerUserRolesQuery,
    GetWorkerUserRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerUserRolesQuery,
    GetWorkerUserRolesQueryVariables
  >(GetWorkerUserRolesDocument, options);
}
export function useGetWorkerUserRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerUserRolesQuery,
    GetWorkerUserRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerUserRolesQuery,
    GetWorkerUserRolesQueryVariables
  >(GetWorkerUserRolesDocument, options);
}
export type GetWorkerUserRolesQueryHookResult = ReturnType<
  typeof useGetWorkerUserRolesQuery
>;
export type GetWorkerUserRolesLazyQueryHookResult = ReturnType<
  typeof useGetWorkerUserRolesLazyQuery
>;
export type GetWorkerUserRolesSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerUserRolesSuspenseQuery
>;
export type GetWorkerUserRolesQueryResult = Apollo.QueryResult<
  GetWorkerUserRolesQuery,
  GetWorkerUserRolesQueryVariables
>;
export const GetBadgeConnectionsDocument = gql`
  query GetBadgeConnections($badgeId: ID!) {
    getWorkerCard(workerCardId: $badgeId) {
      workerCardId
      connections {
        id
        externalEntity {
          type
          typeDisplayName
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetBadgeConnectionsQuery__
 *
 * To run a query within a React component, call `useGetBadgeConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeConnectionsQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useGetBadgeConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBadgeConnectionsQuery,
    GetBadgeConnectionsQueryVariables
  > &
    (
      | { variables: GetBadgeConnectionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBadgeConnectionsQuery,
    GetBadgeConnectionsQueryVariables
  >(GetBadgeConnectionsDocument, options);
}
export function useGetBadgeConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBadgeConnectionsQuery,
    GetBadgeConnectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBadgeConnectionsQuery,
    GetBadgeConnectionsQueryVariables
  >(GetBadgeConnectionsDocument, options);
}
export function useGetBadgeConnectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBadgeConnectionsQuery,
    GetBadgeConnectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetBadgeConnectionsQuery,
    GetBadgeConnectionsQueryVariables
  >(GetBadgeConnectionsDocument, options);
}
export type GetBadgeConnectionsQueryHookResult = ReturnType<
  typeof useGetBadgeConnectionsQuery
>;
export type GetBadgeConnectionsLazyQueryHookResult = ReturnType<
  typeof useGetBadgeConnectionsLazyQuery
>;
export type GetBadgeConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetBadgeConnectionsSuspenseQuery
>;
export type GetBadgeConnectionsQueryResult = Apollo.QueryResult<
  GetBadgeConnectionsQuery,
  GetBadgeConnectionsQueryVariables
>;
export const GetWorkerConnectionsTabDocument = gql`
  query GetWorkerConnectionsTab($workerId: ID!) {
    getWorker(workerId: $workerId) {
      workerId
      connections {
        id
        externalEntity {
          type
          typeDisplayName
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetWorkerConnectionsTabQuery__
 *
 * To run a query within a React component, call `useGetWorkerConnectionsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerConnectionsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerConnectionsTabQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetWorkerConnectionsTabQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerConnectionsTabQuery,
    GetWorkerConnectionsTabQueryVariables
  > &
    (
      | { variables: GetWorkerConnectionsTabQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerConnectionsTabQuery,
    GetWorkerConnectionsTabQueryVariables
  >(GetWorkerConnectionsTabDocument, options);
}
export function useGetWorkerConnectionsTabLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerConnectionsTabQuery,
    GetWorkerConnectionsTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerConnectionsTabQuery,
    GetWorkerConnectionsTabQueryVariables
  >(GetWorkerConnectionsTabDocument, options);
}
export function useGetWorkerConnectionsTabSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerConnectionsTabQuery,
    GetWorkerConnectionsTabQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerConnectionsTabQuery,
    GetWorkerConnectionsTabQueryVariables
  >(GetWorkerConnectionsTabDocument, options);
}
export type GetWorkerConnectionsTabQueryHookResult = ReturnType<
  typeof useGetWorkerConnectionsTabQuery
>;
export type GetWorkerConnectionsTabLazyQueryHookResult = ReturnType<
  typeof useGetWorkerConnectionsTabLazyQuery
>;
export type GetWorkerConnectionsTabSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerConnectionsTabSuspenseQuery
>;
export type GetWorkerConnectionsTabQueryResult = Apollo.QueryResult<
  GetWorkerConnectionsTabQuery,
  GetWorkerConnectionsTabQueryVariables
>;
export const WorkerOnboardingUpdateUserIdentityDocument = gql`
  mutation WorkerOnboardingUpdateUserIdentity(
    $input: UserUpdateIdentityInput!
  ) {
    userUpdateIdentity(input: $input) {
      user {
        identity {
          firstName
          lastName
        }
      }
    }
  }
`;
export type WorkerOnboardingUpdateUserIdentityMutationFn =
  Apollo.MutationFunction<
    WorkerOnboardingUpdateUserIdentityMutation,
    WorkerOnboardingUpdateUserIdentityMutationVariables
  >;

/**
 * __useWorkerOnboardingUpdateUserIdentityMutation__
 *
 * To run a mutation, you first call `useWorkerOnboardingUpdateUserIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkerOnboardingUpdateUserIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workerOnboardingUpdateUserIdentityMutation, { data, loading, error }] = useWorkerOnboardingUpdateUserIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkerOnboardingUpdateUserIdentityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WorkerOnboardingUpdateUserIdentityMutation,
    WorkerOnboardingUpdateUserIdentityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WorkerOnboardingUpdateUserIdentityMutation,
    WorkerOnboardingUpdateUserIdentityMutationVariables
  >(WorkerOnboardingUpdateUserIdentityDocument, options);
}
export type WorkerOnboardingUpdateUserIdentityMutationHookResult = ReturnType<
  typeof useWorkerOnboardingUpdateUserIdentityMutation
>;
export type WorkerOnboardingUpdateUserIdentityMutationResult =
  Apollo.MutationResult<WorkerOnboardingUpdateUserIdentityMutation>;
export type WorkerOnboardingUpdateUserIdentityMutationOptions =
  Apollo.BaseMutationOptions<
    WorkerOnboardingUpdateUserIdentityMutation,
    WorkerOnboardingUpdateUserIdentityMutationVariables
  >;
export const WorkerOnboardingUpdateWorkerDocument = gql`
  mutation WorkerOnboardingUpdateWorker(
    $workerId: ID!
    $workerInput: WorkerInput!
  ) {
    updateWorker(workerId: $workerId, workerInput: $workerInput) {
      middleInitial
      user {
        identity {
          firstName
        }
      }
    }
  }
`;
export type WorkerOnboardingUpdateWorkerMutationFn = Apollo.MutationFunction<
  WorkerOnboardingUpdateWorkerMutation,
  WorkerOnboardingUpdateWorkerMutationVariables
>;

/**
 * __useWorkerOnboardingUpdateWorkerMutation__
 *
 * To run a mutation, you first call `useWorkerOnboardingUpdateWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkerOnboardingUpdateWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workerOnboardingUpdateWorkerMutation, { data, loading, error }] = useWorkerOnboardingUpdateWorkerMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      workerInput: // value for 'workerInput'
 *   },
 * });
 */
export function useWorkerOnboardingUpdateWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WorkerOnboardingUpdateWorkerMutation,
    WorkerOnboardingUpdateWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WorkerOnboardingUpdateWorkerMutation,
    WorkerOnboardingUpdateWorkerMutationVariables
  >(WorkerOnboardingUpdateWorkerDocument, options);
}
export type WorkerOnboardingUpdateWorkerMutationHookResult = ReturnType<
  typeof useWorkerOnboardingUpdateWorkerMutation
>;
export type WorkerOnboardingUpdateWorkerMutationResult =
  Apollo.MutationResult<WorkerOnboardingUpdateWorkerMutation>;
export type WorkerOnboardingUpdateWorkerMutationOptions =
  Apollo.BaseMutationOptions<
    WorkerOnboardingUpdateWorkerMutation,
    WorkerOnboardingUpdateWorkerMutationVariables
  >;
export const GetWorkerOnboardingDocumentReportDocument = gql`
  query GetWorkerOnboardingDocumentReport($jobsiteWorkerDocumentId: ID!) {
    getJobsiteWorkerDocument(
      jobsiteWorkerDocumentId: $jobsiteWorkerDocumentId
    ) {
      jobsiteWorkerDocumentId
      jobsiteWorkerDocumentType {
        jobsite {
          name
          jobsiteId
          developer {
            name
            developerId
          }
        }
        workerDocumentType {
          name
          key
          expirationDate
          isGlobal
          documentLevel
        }
      }
      latestVersion {
        jobsiteWorkerDocumentVersionId
        files {
          fileId
          fileType
          downloadUrl
        }
        additionalFieldValues {
          key
          value
        }
        objectHistory {
          createdAt
          createdBy {
            userAccountId
            identity {
              firstName
              lastName
              email
            }
          }
          updatedAt
          updatedBy {
            userAccountId
            identity {
              firstName
              lastName
              email
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkerOnboardingDocumentReportQuery__
 *
 * To run a query within a React component, call `useGetWorkerOnboardingDocumentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerOnboardingDocumentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerOnboardingDocumentReportQuery({
 *   variables: {
 *      jobsiteWorkerDocumentId: // value for 'jobsiteWorkerDocumentId'
 *   },
 * });
 */
export function useGetWorkerOnboardingDocumentReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerOnboardingDocumentReportQuery,
    GetWorkerOnboardingDocumentReportQueryVariables
  > &
    (
      | {
          variables: GetWorkerOnboardingDocumentReportQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkerOnboardingDocumentReportQuery,
    GetWorkerOnboardingDocumentReportQueryVariables
  >(GetWorkerOnboardingDocumentReportDocument, options);
}
export function useGetWorkerOnboardingDocumentReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerOnboardingDocumentReportQuery,
    GetWorkerOnboardingDocumentReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkerOnboardingDocumentReportQuery,
    GetWorkerOnboardingDocumentReportQueryVariables
  >(GetWorkerOnboardingDocumentReportDocument, options);
}
export function useGetWorkerOnboardingDocumentReportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerOnboardingDocumentReportQuery,
    GetWorkerOnboardingDocumentReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerOnboardingDocumentReportQuery,
    GetWorkerOnboardingDocumentReportQueryVariables
  >(GetWorkerOnboardingDocumentReportDocument, options);
}
export type GetWorkerOnboardingDocumentReportQueryHookResult = ReturnType<
  typeof useGetWorkerOnboardingDocumentReportQuery
>;
export type GetWorkerOnboardingDocumentReportLazyQueryHookResult = ReturnType<
  typeof useGetWorkerOnboardingDocumentReportLazyQuery
>;
export type GetWorkerOnboardingDocumentReportSuspenseQueryHookResult =
  ReturnType<typeof useGetWorkerOnboardingDocumentReportSuspenseQuery>;
export type GetWorkerOnboardingDocumentReportQueryResult = Apollo.QueryResult<
  GetWorkerOnboardingDocumentReportQuery,
  GetWorkerOnboardingDocumentReportQueryVariables
>;
export const GetAllJobsiteWorkerDocumentTypesDocument = gql`
  query GetAllJobsiteWorkerDocumentTypes($jobsiteId: ID!) {
    getAllJobsiteWorkerDocumentTypes(jobsiteId: $jobsiteId) {
      id
      key
      name
      position
      workerDocumentType {
        key
      }
      additionalFields {
        key
        name
      }
    }
  }
`;

/**
 * __useGetAllJobsiteWorkerDocumentTypesQuery__
 *
 * To run a query within a React component, call `useGetAllJobsiteWorkerDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllJobsiteWorkerDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllJobsiteWorkerDocumentTypesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetAllJobsiteWorkerDocumentTypesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllJobsiteWorkerDocumentTypesQuery,
    GetAllJobsiteWorkerDocumentTypesQueryVariables
  > &
    (
      | {
          variables: GetAllJobsiteWorkerDocumentTypesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllJobsiteWorkerDocumentTypesQuery,
    GetAllJobsiteWorkerDocumentTypesQueryVariables
  >(GetAllJobsiteWorkerDocumentTypesDocument, options);
}
export function useGetAllJobsiteWorkerDocumentTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllJobsiteWorkerDocumentTypesQuery,
    GetAllJobsiteWorkerDocumentTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllJobsiteWorkerDocumentTypesQuery,
    GetAllJobsiteWorkerDocumentTypesQueryVariables
  >(GetAllJobsiteWorkerDocumentTypesDocument, options);
}
export function useGetAllJobsiteWorkerDocumentTypesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAllJobsiteWorkerDocumentTypesQuery,
    GetAllJobsiteWorkerDocumentTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAllJobsiteWorkerDocumentTypesQuery,
    GetAllJobsiteWorkerDocumentTypesQueryVariables
  >(GetAllJobsiteWorkerDocumentTypesDocument, options);
}
export type GetAllJobsiteWorkerDocumentTypesQueryHookResult = ReturnType<
  typeof useGetAllJobsiteWorkerDocumentTypesQuery
>;
export type GetAllJobsiteWorkerDocumentTypesLazyQueryHookResult = ReturnType<
  typeof useGetAllJobsiteWorkerDocumentTypesLazyQuery
>;
export type GetAllJobsiteWorkerDocumentTypesSuspenseQueryHookResult =
  ReturnType<typeof useGetAllJobsiteWorkerDocumentTypesSuspenseQuery>;
export type GetAllJobsiteWorkerDocumentTypesQueryResult = Apollo.QueryResult<
  GetAllJobsiteWorkerDocumentTypesQuery,
  GetAllJobsiteWorkerDocumentTypesQueryVariables
>;
export const GetJobsiteWorkerDocument = gql`
  query GetJobsiteWorker($jobsiteWorkerId: ID!) {
    getJobsiteWorker(jobsiteWorkerId: $jobsiteWorkerId) {
      jobsiteWorkerId
      trade
      tradeExperience
      jobTitle
      unionAffiliation
      classificationGroup
      isBanned
      bannedReason
      bannedAt
      startDate
      endDate
      payrollId
      stickerNumber
      orientationDate
      orientationStatus
      documentsCompletedAt
      orientationStatus
      orientationDate
      medicalExamSkipReason
      passedMedicalExamAt
      documentsCompletedAt
      documentsCompletedSkipReason
      badgingCompletedAt
      badgingSkipReason
      signatureCompletedAt
      signatureSkipReason
      onboardingSignedAt
      onboardingSkipReason
      profileCompletedAt
      profileCompleteSkipReason
      bannedReason
      siteSpecificTrainingCompletedAt
      siteSpecificTrainingSkipReason
      medicalNotes
      isAntipassbackExempt
      nycSstExemptionReason
      currentAccess {
        isAllowed
        notAllowedReason
      }
      clearanceAssignments {
        count
        edges {
          node {
            id
            clearance {
              cCureClearanceId
              name
              cCureEnvironment {
                cCureEnvironmentId
                namespace
                instanceSlug
              }
            }
          }
        }
      }
      customWorkerData
      jobsiteContractor {
        contractor {
          contractorId
          organization {
            name
          }
        }
        jobsite {
          jobsiteId
          name
          clearanceAssignmentEnabled
          tradeOptions
          titleOptions
          unionAffiliationOptions
          classificationGroupOptions
          developer {
            name
          }
          jobsiteCustomWorkerDataFields {
            edges {
              node {
                fieldLabel
                fieldDataType
                validationMessage
                validationRegex
                isRequired
              }
            }
          }
          modules {
            ... on JobsiteOnboardingModule {
              name
              steps {
                key
                index
                name
                isRequired
                isVisible
                fields {
                  key
                  name
                  index
                  isRequired
                  isHidden
                }
              }
              documents {
                key
                name
                index
                isRequired
                isVisible
                fields {
                  key
                  name
                  index
                  isRequired
                  isHidden
                }
              }
            }
          }
        }
      }
      contractorWorker {
        contractor {
          contractorId
          organization {
            name
          }
        }
        worker {
          workerId
          middleInitial
          suffix
          addressLine1
          addressLine2
          addressCity
          addressState
          addressZipCode
          addressZipCode
          quickCode
          birthDate
          emergencyContactName
          emergencyContactPhone
          emergencyContactRelationship
          gender
          primaryLanguage
          race
          isSkilled
          ssnLastFour
          citizenshipStatus
          workAuthorizationStatus
          isVeteran
          profilePicture {
            downloadUrl
            uploadedAt
            fileId
            fileType
          }
          profilePictureCropped {
            downloadUrl
            uploadedAt
            fileId
            fileType
          }
          editableFields {
            email
            phone
          }
          user {
            userAccountId
            identity {
              firstName
              lastName
              email
              phoneNumber
            }
          }
          jobsiteWorkers {
            count
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteWorkerQuery__
 *
 * To run a query within a React component, call `useGetJobsiteWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteWorkerQuery({
 *   variables: {
 *      jobsiteWorkerId: // value for 'jobsiteWorkerId'
 *   },
 * });
 */
export function useGetJobsiteWorkerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteWorkerQuery,
    GetJobsiteWorkerQueryVariables
  > &
    (
      | { variables: GetJobsiteWorkerQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobsiteWorkerQuery, GetJobsiteWorkerQueryVariables>(
    GetJobsiteWorkerDocument,
    options,
  );
}
export function useGetJobsiteWorkerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteWorkerQuery,
    GetJobsiteWorkerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteWorkerQuery,
    GetJobsiteWorkerQueryVariables
  >(GetJobsiteWorkerDocument, options);
}
export function useGetJobsiteWorkerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteWorkerQuery,
    GetJobsiteWorkerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteWorkerQuery,
    GetJobsiteWorkerQueryVariables
  >(GetJobsiteWorkerDocument, options);
}
export type GetJobsiteWorkerQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerQuery
>;
export type GetJobsiteWorkerLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerLazyQuery
>;
export type GetJobsiteWorkerSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerSuspenseQuery
>;
export type GetJobsiteWorkerQueryResult = Apollo.QueryResult<
  GetJobsiteWorkerQuery,
  GetJobsiteWorkerQueryVariables
>;
export const GetJobsiteWorkerDocumentsDocument = gql`
  query GetJobsiteWorkerDocuments(
    $jobsiteWorkerId: ID!
    $documentsInput: JobsiteWorkerDocumentsInput
  ) {
    getJobsiteWorker(jobsiteWorkerId: $jobsiteWorkerId) {
      documents(input: $documentsInput) {
        edges {
          node {
            jobsiteWorkerDocumentId
            key
            jobsiteWorkerDocumentType {
              key
              name
              position
              expiration
              jobsite {
                jobsiteId
                name
                developer {
                  developerId
                  name
                }
              }
              workerDocumentType {
                key
                name
                documentLevel
                isPhi
              }
              additionalFields {
                key
                name
              }
            }
            objectHistory {
              createdAt
              updatedAt
            }
            latestVersion {
              jobsiteWorkerDocumentVersionId
              files {
                fileId
                fileType
                uploadedAt
                downloadUrl
                originalFileName
              }
              objectHistory {
                createdAt
                updatedAt
              }
              additionalFieldValues {
                key
                value
              }
              acknowledgedBy {
                userAccountId
                identity {
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteWorkerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteWorkerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteWorkerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteWorkerDocumentsQuery({
 *   variables: {
 *      jobsiteWorkerId: // value for 'jobsiteWorkerId'
 *      documentsInput: // value for 'documentsInput'
 *   },
 * });
 */
export function useGetJobsiteWorkerDocumentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteWorkerDocumentsQuery,
    GetJobsiteWorkerDocumentsQueryVariables
  > &
    (
      | { variables: GetJobsiteWorkerDocumentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteWorkerDocumentsQuery,
    GetJobsiteWorkerDocumentsQueryVariables
  >(GetJobsiteWorkerDocumentsDocument, options);
}
export function useGetJobsiteWorkerDocumentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteWorkerDocumentsQuery,
    GetJobsiteWorkerDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteWorkerDocumentsQuery,
    GetJobsiteWorkerDocumentsQueryVariables
  >(GetJobsiteWorkerDocumentsDocument, options);
}
export function useGetJobsiteWorkerDocumentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteWorkerDocumentsQuery,
    GetJobsiteWorkerDocumentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteWorkerDocumentsQuery,
    GetJobsiteWorkerDocumentsQueryVariables
  >(GetJobsiteWorkerDocumentsDocument, options);
}
export type GetJobsiteWorkerDocumentsQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDocumentsQuery
>;
export type GetJobsiteWorkerDocumentsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDocumentsLazyQuery
>;
export type GetJobsiteWorkerDocumentsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteWorkerDocumentsSuspenseQuery
>;
export type GetJobsiteWorkerDocumentsQueryResult = Apollo.QueryResult<
  GetJobsiteWorkerDocumentsQuery,
  GetJobsiteWorkerDocumentsQueryVariables
>;
export const GetOnboardingJobsiteWorkersDocument = gql`
  query GetOnboardingJobsiteWorkers(
    $userContractorsInput: UserContractorsInput
    $jobsiteIds: [ID!]
    $contractorIds: [ID!]
    $limit: Int
    $offset: Int
    $activeOnly: Boolean
    $orientationDate: Date
    $orientationStartDate: Date
    $orientationEndDate: Date
    $orientationStatuses: [JobsiteWorkerOrientationStatusFilter!]
    $needsMedical: Boolean
    $orderBy: [GetJobsiteWorkersOrderBy]
  ) {
    getCurrentSession {
      user {
        userAccountId
        contractors(input: $userContractorsInput) {
          edges {
            node {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
    }
    getJobsiteWorkers(
      jobsiteIds: $jobsiteIds
      contractorIds: $contractorIds
      offset: $offset
      limit: $limit
      activeOnly: $activeOnly
      orientationDate: $orientationDate
      orientationStartDate: $orientationStartDate
      orientationEndDate: $orientationEndDate
      orientationStatuses: $orientationStatuses
      needsMedical: $needsMedical
      orderBy: $orderBy
    ) {
      totalCount
      jobsiteStats {
        numberOfOrientationWorkersTotal
        numberOfOrientationWorkersSelfOnboarding
        numberOfOrientationWorkersInProgress
        numberOfOrientationWorkersCompleted
        numberOfOrientationWorkersNeedingMedical
        numberOfOrientationWorkersNeedingBadging
      }
      edges {
        endDate
        isAllowedNow
        jobsiteWorker {
          trade
          jobsiteWorkerId
          orientationStatus
          orientationDate
          medicalExamSkipReason
          passedMedicalExamAt
          documentsCompletedAt
          documentsCompletedSkipReason
          badgingCompletedAt
          badgingSkipReason
          signatureCompletedAt
          signatureSkipReason
          onboardingSignedAt
          onboardingSkipReason
          profileCompletedAt
          profileCompleteSkipReason
          banCategory
          bannedReason
          bannedAt
          siteSpecificTrainingCompletedAt
          siteSpecificTrainingSkipReason
          jobsiteContractor {
            jobsite {
              jobsiteId
              name
              modules {
                ... on JobsiteOnboardingModule {
                  name
                  steps {
                    key
                    index
                    isVisible
                  }
                }
              }
            }
          }
          contractorWorker {
            worker {
              workerId
              profilePicture {
                downloadUrl
                uploadedAt
                fileId
              }
              profilePictureCropped {
                downloadUrl
                uploadedAt
                fileId
                fileType
              }
              user {
                userAccountId
                identity {
                  firstName
                  lastName
                }
              }
            }
            contractor {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetOnboardingJobsiteWorkersQuery__
 *
 * To run a query within a React component, call `useGetOnboardingJobsiteWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingJobsiteWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingJobsiteWorkersQuery({
 *   variables: {
 *      userContractorsInput: // value for 'userContractorsInput'
 *      jobsiteIds: // value for 'jobsiteIds'
 *      contractorIds: // value for 'contractorIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      activeOnly: // value for 'activeOnly'
 *      orientationDate: // value for 'orientationDate'
 *      orientationStartDate: // value for 'orientationStartDate'
 *      orientationEndDate: // value for 'orientationEndDate'
 *      orientationStatuses: // value for 'orientationStatuses'
 *      needsMedical: // value for 'needsMedical'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetOnboardingJobsiteWorkersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOnboardingJobsiteWorkersQuery,
    GetOnboardingJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOnboardingJobsiteWorkersQuery,
    GetOnboardingJobsiteWorkersQueryVariables
  >(GetOnboardingJobsiteWorkersDocument, options);
}
export function useGetOnboardingJobsiteWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOnboardingJobsiteWorkersQuery,
    GetOnboardingJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOnboardingJobsiteWorkersQuery,
    GetOnboardingJobsiteWorkersQueryVariables
  >(GetOnboardingJobsiteWorkersDocument, options);
}
export function useGetOnboardingJobsiteWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOnboardingJobsiteWorkersQuery,
    GetOnboardingJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOnboardingJobsiteWorkersQuery,
    GetOnboardingJobsiteWorkersQueryVariables
  >(GetOnboardingJobsiteWorkersDocument, options);
}
export type GetOnboardingJobsiteWorkersQueryHookResult = ReturnType<
  typeof useGetOnboardingJobsiteWorkersQuery
>;
export type GetOnboardingJobsiteWorkersLazyQueryHookResult = ReturnType<
  typeof useGetOnboardingJobsiteWorkersLazyQuery
>;
export type GetOnboardingJobsiteWorkersSuspenseQueryHookResult = ReturnType<
  typeof useGetOnboardingJobsiteWorkersSuspenseQuery
>;
export type GetOnboardingJobsiteWorkersQueryResult = Apollo.QueryResult<
  GetOnboardingJobsiteWorkersQuery,
  GetOnboardingJobsiteWorkersQueryVariables
>;
export const UpdateOnboardingJobsiteWorkerDocument = gql`
  mutation UpdateOnboardingJobsiteWorker(
    $jobsiteWorkerId: ID!
    $jobsiteWorkerInput: JobsiteWorkerInput!
  ) {
    updateJobsiteWorker(
      jobsiteWorkerId: $jobsiteWorkerId
      jobsiteWorkerInput: $jobsiteWorkerInput
    ) {
      orientationDate
    }
  }
`;
export type UpdateOnboardingJobsiteWorkerMutationFn = Apollo.MutationFunction<
  UpdateOnboardingJobsiteWorkerMutation,
  UpdateOnboardingJobsiteWorkerMutationVariables
>;

/**
 * __useUpdateOnboardingJobsiteWorkerMutation__
 *
 * To run a mutation, you first call `useUpdateOnboardingJobsiteWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOnboardingJobsiteWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOnboardingJobsiteWorkerMutation, { data, loading, error }] = useUpdateOnboardingJobsiteWorkerMutation({
 *   variables: {
 *      jobsiteWorkerId: // value for 'jobsiteWorkerId'
 *      jobsiteWorkerInput: // value for 'jobsiteWorkerInput'
 *   },
 * });
 */
export function useUpdateOnboardingJobsiteWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOnboardingJobsiteWorkerMutation,
    UpdateOnboardingJobsiteWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOnboardingJobsiteWorkerMutation,
    UpdateOnboardingJobsiteWorkerMutationVariables
  >(UpdateOnboardingJobsiteWorkerDocument, options);
}
export type UpdateOnboardingJobsiteWorkerMutationHookResult = ReturnType<
  typeof useUpdateOnboardingJobsiteWorkerMutation
>;
export type UpdateOnboardingJobsiteWorkerMutationResult =
  Apollo.MutationResult<UpdateOnboardingJobsiteWorkerMutation>;
export type UpdateOnboardingJobsiteWorkerMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOnboardingJobsiteWorkerMutation,
    UpdateOnboardingJobsiteWorkerMutationVariables
  >;
export const GetSiteSafetyOrientationJobsiteWorkersDocument = gql`
  query GetSiteSafetyOrientationJobsiteWorkers(
    $userContractorsInput: UserContractorsInput
    $jobsiteIds: [ID!]
    $contractorIds: [ID!]
    $limit: Int
    $offset: Int
    $orderBy: [GetJobsiteWorkersOrderBy]
    $activeOnly: Boolean
    $orientationStartDate: Date
    $orientationEndDate: Date
    $withContractorOnly: Boolean
    $orientationStatuses: [JobsiteWorkerOrientationStatusFilter!]
    $needsMedical: Boolean
    $hideBanned: Boolean
    $completedSiteSpecificTraining: Boolean
    $completedSiteSpecificTrainingDate: Date
    $siteSpecificOrientationStatus: SiteSpecificOrientationStatus
  ) {
    getCurrentSession {
      user {
        userAccountId
        contractors(input: $userContractorsInput) {
          count
          edges {
            node {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
    }
    getJobsiteWorkers(
      jobsiteIds: $jobsiteIds
      contractorIds: $contractorIds
      limit: $limit
      offset: $offset
      orderBy: $orderBy
      activeOnly: $activeOnly
      orientationStartDate: $orientationStartDate
      orientationEndDate: $orientationEndDate
      withContractorOnly: $withContractorOnly
      orientationStatuses: $orientationStatuses
      needsMedical: $needsMedical
      hideBanned: $hideBanned
      completedSiteSpecificTraining: $completedSiteSpecificTraining
      completedSiteSpecificTrainingDate: $completedSiteSpecificTrainingDate
      siteSpecificOrientationStatus: $siteSpecificOrientationStatus
    ) {
      totalCount
      edges {
        endDate
        isAllowedNow
        jobsiteWorker {
          trade
          jobsiteWorkerId
          orientationStatus
          orientationDate
          medicalExamSkipReason
          passedMedicalExamAt
          documentsCompletedAt
          documentsCompletedSkipReason
          badgingCompletedAt
          badgingSkipReason
          signatureCompletedAt
          signatureSkipReason
          onboardingSignedAt
          onboardingSkipReason
          profileCompletedAt
          profileCompleteSkipReason
          siteSpecificTrainingCompletedAt
          isSiteSpecificTrainingExpired
          bannedReason
          jobsiteContractor {
            jobsite {
              jobsiteId
              name
            }
          }
          contractorWorker {
            worker {
              workerId
              profilePicture {
                downloadUrl
                uploadedAt
                fileId
              }
              profilePictureCropped {
                downloadUrl
                uploadedAt
                fileId
                fileType
              }
              user {
                userAccountId
                identity {
                  firstName
                  lastName
                }
              }
            }
            contractor {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetSiteSafetyOrientationJobsiteWorkersQuery__
 *
 * To run a query within a React component, call `useGetSiteSafetyOrientationJobsiteWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteSafetyOrientationJobsiteWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteSafetyOrientationJobsiteWorkersQuery({
 *   variables: {
 *      userContractorsInput: // value for 'userContractorsInput'
 *      jobsiteIds: // value for 'jobsiteIds'
 *      contractorIds: // value for 'contractorIds'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      activeOnly: // value for 'activeOnly'
 *      orientationStartDate: // value for 'orientationStartDate'
 *      orientationEndDate: // value for 'orientationEndDate'
 *      withContractorOnly: // value for 'withContractorOnly'
 *      orientationStatuses: // value for 'orientationStatuses'
 *      needsMedical: // value for 'needsMedical'
 *      hideBanned: // value for 'hideBanned'
 *      completedSiteSpecificTraining: // value for 'completedSiteSpecificTraining'
 *      completedSiteSpecificTrainingDate: // value for 'completedSiteSpecificTrainingDate'
 *      siteSpecificOrientationStatus: // value for 'siteSpecificOrientationStatus'
 *   },
 * });
 */
export function useGetSiteSafetyOrientationJobsiteWorkersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSiteSafetyOrientationJobsiteWorkersQuery,
    GetSiteSafetyOrientationJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteSafetyOrientationJobsiteWorkersQuery,
    GetSiteSafetyOrientationJobsiteWorkersQueryVariables
  >(GetSiteSafetyOrientationJobsiteWorkersDocument, options);
}
export function useGetSiteSafetyOrientationJobsiteWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteSafetyOrientationJobsiteWorkersQuery,
    GetSiteSafetyOrientationJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteSafetyOrientationJobsiteWorkersQuery,
    GetSiteSafetyOrientationJobsiteWorkersQueryVariables
  >(GetSiteSafetyOrientationJobsiteWorkersDocument, options);
}
export function useGetSiteSafetyOrientationJobsiteWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteSafetyOrientationJobsiteWorkersQuery,
    GetSiteSafetyOrientationJobsiteWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteSafetyOrientationJobsiteWorkersQuery,
    GetSiteSafetyOrientationJobsiteWorkersQueryVariables
  >(GetSiteSafetyOrientationJobsiteWorkersDocument, options);
}
export type GetSiteSafetyOrientationJobsiteWorkersQueryHookResult = ReturnType<
  typeof useGetSiteSafetyOrientationJobsiteWorkersQuery
>;
export type GetSiteSafetyOrientationJobsiteWorkersLazyQueryHookResult =
  ReturnType<typeof useGetSiteSafetyOrientationJobsiteWorkersLazyQuery>;
export type GetSiteSafetyOrientationJobsiteWorkersSuspenseQueryHookResult =
  ReturnType<typeof useGetSiteSafetyOrientationJobsiteWorkersSuspenseQuery>;
export type GetSiteSafetyOrientationJobsiteWorkersQueryResult =
  Apollo.QueryResult<
    GetSiteSafetyOrientationJobsiteWorkersQuery,
    GetSiteSafetyOrientationJobsiteWorkersQueryVariables
  >;
export const GetWorkersContainerCurrentSessionDocument = gql`
  query GetWorkersContainerCurrentSession(
    $userWorkersInput: UserWorkersInput
    $userContractorsInput: UserContractorsInput
  ) {
    getCurrentSession {
      user {
        userAccountId
        workers(input: $userWorkersInput) {
          count
          edges {
            node {
              workerId
              birthDate
              quickCode
              user {
                userAccountId
                identity {
                  firstName
                  lastName
                  email
                }
              }
              profilePictureCropped {
                downloadUrl
                uploadedAt
                fileId
                fileType
              }
              jobsiteWorkers {
                edges {
                  node {
                    jobsiteWorkerId
                    trade
                    jobTitle
                    jobsiteContractor {
                      jobsite {
                        jobsiteId
                        name
                      }
                      contractor {
                        contractorId
                        organization {
                          name
                        }
                      }
                    }
                    currentAccess {
                      isAllowed
                    }
                  }
                }
              }
            }
          }
          filtersOptions {
            trades {
              value
              label
              count
            }
            jobTitles {
              value
              label
              count
            }
          }
        }
        contractors(input: $userContractorsInput) {
          edges {
            node {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkersContainerCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetWorkersContainerCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkersContainerCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkersContainerCurrentSessionQuery({
 *   variables: {
 *      userWorkersInput: // value for 'userWorkersInput'
 *      userContractorsInput: // value for 'userContractorsInput'
 *   },
 * });
 */
export function useGetWorkersContainerCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkersContainerCurrentSessionQuery,
    GetWorkersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkersContainerCurrentSessionQuery,
    GetWorkersContainerCurrentSessionQueryVariables
  >(GetWorkersContainerCurrentSessionDocument, options);
}
export function useGetWorkersContainerCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkersContainerCurrentSessionQuery,
    GetWorkersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkersContainerCurrentSessionQuery,
    GetWorkersContainerCurrentSessionQueryVariables
  >(GetWorkersContainerCurrentSessionDocument, options);
}
export function useGetWorkersContainerCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkersContainerCurrentSessionQuery,
    GetWorkersContainerCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkersContainerCurrentSessionQuery,
    GetWorkersContainerCurrentSessionQueryVariables
  >(GetWorkersContainerCurrentSessionDocument, options);
}
export type GetWorkersContainerCurrentSessionQueryHookResult = ReturnType<
  typeof useGetWorkersContainerCurrentSessionQuery
>;
export type GetWorkersContainerCurrentSessionLazyQueryHookResult = ReturnType<
  typeof useGetWorkersContainerCurrentSessionLazyQuery
>;
export type GetWorkersContainerCurrentSessionSuspenseQueryHookResult =
  ReturnType<typeof useGetWorkersContainerCurrentSessionSuspenseQuery>;
export type GetWorkersContainerCurrentSessionQueryResult = Apollo.QueryResult<
  GetWorkersContainerCurrentSessionQuery,
  GetWorkersContainerCurrentSessionQueryVariables
>;
export const AddAndIssueFacialRecognitionBadgeDocument = gql`
  mutation addAndIssueFacialRecognitionBadge(
    $workerId: ID!
    $jobsiteId: ID!
    $workerCardInput: WorkerCardInput!
    $newPhoneNumber: String
    $newEmail: String
  ) {
    addAndIssueFacialRecognitionBadge(
      workerId: $workerId
      jobsiteId: $jobsiteId
      workerCardInput: $workerCardInput
      newPhoneNumber: $newPhoneNumber
      newEmail: $newEmail
    ) {
      workerCardId
      cardNumber
    }
  }
`;
export type AddAndIssueFacialRecognitionBadgeMutationFn =
  Apollo.MutationFunction<
    AddAndIssueFacialRecognitionBadgeMutation,
    AddAndIssueFacialRecognitionBadgeMutationVariables
  >;

/**
 * __useAddAndIssueFacialRecognitionBadgeMutation__
 *
 * To run a mutation, you first call `useAddAndIssueFacialRecognitionBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAndIssueFacialRecognitionBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAndIssueFacialRecognitionBadgeMutation, { data, loading, error }] = useAddAndIssueFacialRecognitionBadgeMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      jobsiteId: // value for 'jobsiteId'
 *      workerCardInput: // value for 'workerCardInput'
 *      newPhoneNumber: // value for 'newPhoneNumber'
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useAddAndIssueFacialRecognitionBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAndIssueFacialRecognitionBadgeMutation,
    AddAndIssueFacialRecognitionBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddAndIssueFacialRecognitionBadgeMutation,
    AddAndIssueFacialRecognitionBadgeMutationVariables
  >(AddAndIssueFacialRecognitionBadgeDocument, options);
}
export type AddAndIssueFacialRecognitionBadgeMutationHookResult = ReturnType<
  typeof useAddAndIssueFacialRecognitionBadgeMutation
>;
export type AddAndIssueFacialRecognitionBadgeMutationResult =
  Apollo.MutationResult<AddAndIssueFacialRecognitionBadgeMutation>;
export type AddAndIssueFacialRecognitionBadgeMutationOptions =
  Apollo.BaseMutationOptions<
    AddAndIssueFacialRecognitionBadgeMutation,
    AddAndIssueFacialRecognitionBadgeMutationVariables
  >;
export const AddAndIssueMobileBadgeDocument = gql`
  mutation addAndIssueMobileBadge(
    $workerId: ID!
    $jobsiteId: ID!
    $workerCardInput: WorkerCardInput!
    $newPhoneNumber: String
  ) {
    addAndIssueMobileBadge(
      workerId: $workerId
      jobsiteId: $jobsiteId
      workerCardInput: $workerCardInput
      newPhoneNumber: $newPhoneNumber
    ) {
      workerCardId
      cardNumber
    }
  }
`;
export type AddAndIssueMobileBadgeMutationFn = Apollo.MutationFunction<
  AddAndIssueMobileBadgeMutation,
  AddAndIssueMobileBadgeMutationVariables
>;

/**
 * __useAddAndIssueMobileBadgeMutation__
 *
 * To run a mutation, you first call `useAddAndIssueMobileBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAndIssueMobileBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAndIssueMobileBadgeMutation, { data, loading, error }] = useAddAndIssueMobileBadgeMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      jobsiteId: // value for 'jobsiteId'
 *      workerCardInput: // value for 'workerCardInput'
 *      newPhoneNumber: // value for 'newPhoneNumber'
 *   },
 * });
 */
export function useAddAndIssueMobileBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddAndIssueMobileBadgeMutation,
    AddAndIssueMobileBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddAndIssueMobileBadgeMutation,
    AddAndIssueMobileBadgeMutationVariables
  >(AddAndIssueMobileBadgeDocument, options);
}
export type AddAndIssueMobileBadgeMutationHookResult = ReturnType<
  typeof useAddAndIssueMobileBadgeMutation
>;
export type AddAndIssueMobileBadgeMutationResult =
  Apollo.MutationResult<AddAndIssueMobileBadgeMutation>;
export type AddAndIssueMobileBadgeMutationOptions = Apollo.BaseMutationOptions<
  AddAndIssueMobileBadgeMutation,
  AddAndIssueMobileBadgeMutationVariables
>;
export const AddCardToWorkerDocument = gql`
  mutation AddCardToWorker(
    $workerId: ID!
    $jobsiteId: ID!
    $workerCardInput: WorkerCardInput!
    $forceCreate: Boolean
  ) {
    addCardToWorker(
      workerId: $workerId
      jobsiteId: $jobsiteId
      workerCardInput: $workerCardInput
      forceCreate: $forceCreate
    ) {
      workerCardId
      cardNumber
      matchingWorkerCardId
      cardStatus
      worker {
        workerId
      }
    }
  }
`;
export type AddCardToWorkerMutationFn = Apollo.MutationFunction<
  AddCardToWorkerMutation,
  AddCardToWorkerMutationVariables
>;

/**
 * __useAddCardToWorkerMutation__
 *
 * To run a mutation, you first call `useAddCardToWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCardToWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCardToWorkerMutation, { data, loading, error }] = useAddCardToWorkerMutation({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      jobsiteId: // value for 'jobsiteId'
 *      workerCardInput: // value for 'workerCardInput'
 *      forceCreate: // value for 'forceCreate'
 *   },
 * });
 */
export function useAddCardToWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCardToWorkerMutation,
    AddCardToWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCardToWorkerMutation,
    AddCardToWorkerMutationVariables
  >(AddCardToWorkerDocument, options);
}
export type AddCardToWorkerMutationHookResult = ReturnType<
  typeof useAddCardToWorkerMutation
>;
export type AddCardToWorkerMutationResult =
  Apollo.MutationResult<AddCardToWorkerMutation>;
export type AddCardToWorkerMutationOptions = Apollo.BaseMutationOptions<
  AddCardToWorkerMutation,
  AddCardToWorkerMutationVariables
>;
export const AssignContractorWorkerToJobsiteDocument = gql`
  mutation AssignContractorWorkerToJobsite(
    $input: AssignContractorWorkerToJobsiteInput!
  ) {
    assignContractorWorkerToJobsite(input: $input) {
      isAlreadyAssigned
      jobsiteWorker {
        jobsiteWorkerId
        trade
        jobTitle
        orientationStatus
        contractorWorker {
          id
          worker {
            workerId
            isAssignedToMultipleJobsites
          }
        }
        jobsiteContractor {
          id
          jobsite {
            jobsiteId
            titleOptions
            tradeOptions
            unionAffiliationOptions
          }
          contractor {
            contractorId
            isDefaultContractor
            organization {
              organizationId
              name
            }
          }
        }
      }
    }
  }
`;
export type AssignContractorWorkerToJobsiteMutationFn = Apollo.MutationFunction<
  AssignContractorWorkerToJobsiteMutation,
  AssignContractorWorkerToJobsiteMutationVariables
>;

/**
 * __useAssignContractorWorkerToJobsiteMutation__
 *
 * To run a mutation, you first call `useAssignContractorWorkerToJobsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignContractorWorkerToJobsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignContractorWorkerToJobsiteMutation, { data, loading, error }] = useAssignContractorWorkerToJobsiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignContractorWorkerToJobsiteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignContractorWorkerToJobsiteMutation,
    AssignContractorWorkerToJobsiteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignContractorWorkerToJobsiteMutation,
    AssignContractorWorkerToJobsiteMutationVariables
  >(AssignContractorWorkerToJobsiteDocument, options);
}
export type AssignContractorWorkerToJobsiteMutationHookResult = ReturnType<
  typeof useAssignContractorWorkerToJobsiteMutation
>;
export type AssignContractorWorkerToJobsiteMutationResult =
  Apollo.MutationResult<AssignContractorWorkerToJobsiteMutation>;
export type AssignContractorWorkerToJobsiteMutationOptions =
  Apollo.BaseMutationOptions<
    AssignContractorWorkerToJobsiteMutation,
    AssignContractorWorkerToJobsiteMutationVariables
  >;
export const CreateAndPrintWorkerCardDocument = gql`
  mutation CreateAndPrintWorkerCard($input: CreateWorkerCardInput!) {
    createAndPrintWorkerCard(input: $input) {
      workerCard {
        workerCardId
        cardNumber
        workerCardStatus
        workerCardFormat {
          workerCardFormatId
          name
          cardType
        }
        lastPrintJob {
          cardPrintJobId
          startedAt
          status
          statusMessage
          completion {
            cardNumber
            facilityCode
            completedAt
          }
          error {
            code
            erroredAt
            message
          }
        }
      }
    }
  }
`;
export type CreateAndPrintWorkerCardMutationFn = Apollo.MutationFunction<
  CreateAndPrintWorkerCardMutation,
  CreateAndPrintWorkerCardMutationVariables
>;

/**
 * __useCreateAndPrintWorkerCardMutation__
 *
 * To run a mutation, you first call `useCreateAndPrintWorkerCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndPrintWorkerCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndPrintWorkerCardMutation, { data, loading, error }] = useCreateAndPrintWorkerCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAndPrintWorkerCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAndPrintWorkerCardMutation,
    CreateAndPrintWorkerCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAndPrintWorkerCardMutation,
    CreateAndPrintWorkerCardMutationVariables
  >(CreateAndPrintWorkerCardDocument, options);
}
export type CreateAndPrintWorkerCardMutationHookResult = ReturnType<
  typeof useCreateAndPrintWorkerCardMutation
>;
export type CreateAndPrintWorkerCardMutationResult =
  Apollo.MutationResult<CreateAndPrintWorkerCardMutation>;
export type CreateAndPrintWorkerCardMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAndPrintWorkerCardMutation,
    CreateAndPrintWorkerCardMutationVariables
  >;
export const CreateCardPrintJobDocument = gql`
  mutation CreateCardPrintJob($input: CreateCardPrintJobInput!) {
    createCardPrintJob(input: $input) {
      cardPrintJobId
      status
      statusMessage
      completion {
        cardNumber
        facilityCode
        completedAt
      }
      startedAt
      jobsite {
        jobsiteId
        name
      }
      worker {
        workerId
        user {
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export type CreateCardPrintJobMutationFn = Apollo.MutationFunction<
  CreateCardPrintJobMutation,
  CreateCardPrintJobMutationVariables
>;

/**
 * __useCreateCardPrintJobMutation__
 *
 * To run a mutation, you first call `useCreateCardPrintJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCardPrintJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCardPrintJobMutation, { data, loading, error }] = useCreateCardPrintJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCardPrintJobMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCardPrintJobMutation,
    CreateCardPrintJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCardPrintJobMutation,
    CreateCardPrintJobMutationVariables
  >(CreateCardPrintJobDocument, options);
}
export type CreateCardPrintJobMutationHookResult = ReturnType<
  typeof useCreateCardPrintJobMutation
>;
export type CreateCardPrintJobMutationResult =
  Apollo.MutationResult<CreateCardPrintJobMutation>;
export type CreateCardPrintJobMutationOptions = Apollo.BaseMutationOptions<
  CreateCardPrintJobMutation,
  CreateCardPrintJobMutationVariables
>;
export const CreateContractorWorkerDocument = gql`
  mutation CreateContractorWorker(
    $createContractorWorkerInput: CreateContractorWorkerInput!
  ) {
    createContractorWorker(
      createContractorWorkerInput: $createContractorWorkerInput
    ) {
      contractor {
        contractorId
      }
      worker {
        workerId
        ssnLastFour
        birthDate
        user {
          userAccountId
          identity {
            firstName
            lastName
          }
        }
      }
    }
  }
`;
export type CreateContractorWorkerMutationFn = Apollo.MutationFunction<
  CreateContractorWorkerMutation,
  CreateContractorWorkerMutationVariables
>;

/**
 * __useCreateContractorWorkerMutation__
 *
 * To run a mutation, you first call `useCreateContractorWorkerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractorWorkerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractorWorkerMutation, { data, loading, error }] = useCreateContractorWorkerMutation({
 *   variables: {
 *      createContractorWorkerInput: // value for 'createContractorWorkerInput'
 *   },
 * });
 */
export function useCreateContractorWorkerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContractorWorkerMutation,
    CreateContractorWorkerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContractorWorkerMutation,
    CreateContractorWorkerMutationVariables
  >(CreateContractorWorkerDocument, options);
}
export type CreateContractorWorkerMutationHookResult = ReturnType<
  typeof useCreateContractorWorkerMutation
>;
export type CreateContractorWorkerMutationResult =
  Apollo.MutationResult<CreateContractorWorkerMutation>;
export type CreateContractorWorkerMutationOptions = Apollo.BaseMutationOptions<
  CreateContractorWorkerMutation,
  CreateContractorWorkerMutationVariables
>;
export const CreateJobsiteWorkerDocumentDocument = gql`
  mutation CreateJobsiteWorkerDocument(
    $jobsiteWorkerDocumentInput: JobsiteWorkerDocumentInput!
    $jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput!
  ) {
    createJobsiteWorkerDocument(
      jobsiteWorkerDocumentInput: $jobsiteWorkerDocumentInput
      jobsiteWorkerDocumentVersionInput: $jobsiteWorkerDocumentVersionInput
    ) {
      jobsiteWorkerDocumentType {
        workerDocumentType {
          workerDocumentTypeId
        }
      }
    }
  }
`;
export type CreateJobsiteWorkerDocumentMutationFn = Apollo.MutationFunction<
  CreateJobsiteWorkerDocumentMutation,
  CreateJobsiteWorkerDocumentMutationVariables
>;

/**
 * __useCreateJobsiteWorkerDocumentMutation__
 *
 * To run a mutation, you first call `useCreateJobsiteWorkerDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobsiteWorkerDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobsiteWorkerDocumentMutation, { data, loading, error }] = useCreateJobsiteWorkerDocumentMutation({
 *   variables: {
 *      jobsiteWorkerDocumentInput: // value for 'jobsiteWorkerDocumentInput'
 *      jobsiteWorkerDocumentVersionInput: // value for 'jobsiteWorkerDocumentVersionInput'
 *   },
 * });
 */
export function useCreateJobsiteWorkerDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateJobsiteWorkerDocumentMutation,
    CreateJobsiteWorkerDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateJobsiteWorkerDocumentMutation,
    CreateJobsiteWorkerDocumentMutationVariables
  >(CreateJobsiteWorkerDocumentDocument, options);
}
export type CreateJobsiteWorkerDocumentMutationHookResult = ReturnType<
  typeof useCreateJobsiteWorkerDocumentMutation
>;
export type CreateJobsiteWorkerDocumentMutationResult =
  Apollo.MutationResult<CreateJobsiteWorkerDocumentMutation>;
export type CreateJobsiteWorkerDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    CreateJobsiteWorkerDocumentMutation,
    CreateJobsiteWorkerDocumentMutationVariables
  >;
export const CreateJobsiteWorkerDocumentVersionDocument = gql`
  mutation CreateJobsiteWorkerDocumentVersion(
    $jobsiteWorkerDocumentId: ID!
    $jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput!
  ) {
    createJobsiteWorkerDocumentVersion(
      jobsiteWorkerDocumentId: $jobsiteWorkerDocumentId
      jobsiteWorkerDocumentVersionInput: $jobsiteWorkerDocumentVersionInput
    ) {
      jobsiteWorkerDocumentVersionId
    }
  }
`;
export type CreateJobsiteWorkerDocumentVersionMutationFn =
  Apollo.MutationFunction<
    CreateJobsiteWorkerDocumentVersionMutation,
    CreateJobsiteWorkerDocumentVersionMutationVariables
  >;

/**
 * __useCreateJobsiteWorkerDocumentVersionMutation__
 *
 * To run a mutation, you first call `useCreateJobsiteWorkerDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobsiteWorkerDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobsiteWorkerDocumentVersionMutation, { data, loading, error }] = useCreateJobsiteWorkerDocumentVersionMutation({
 *   variables: {
 *      jobsiteWorkerDocumentId: // value for 'jobsiteWorkerDocumentId'
 *      jobsiteWorkerDocumentVersionInput: // value for 'jobsiteWorkerDocumentVersionInput'
 *   },
 * });
 */
export function useCreateJobsiteWorkerDocumentVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateJobsiteWorkerDocumentVersionMutation,
    CreateJobsiteWorkerDocumentVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateJobsiteWorkerDocumentVersionMutation,
    CreateJobsiteWorkerDocumentVersionMutationVariables
  >(CreateJobsiteWorkerDocumentVersionDocument, options);
}
export type CreateJobsiteWorkerDocumentVersionMutationHookResult = ReturnType<
  typeof useCreateJobsiteWorkerDocumentVersionMutation
>;
export type CreateJobsiteWorkerDocumentVersionMutationResult =
  Apollo.MutationResult<CreateJobsiteWorkerDocumentVersionMutation>;
export type CreateJobsiteWorkerDocumentVersionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateJobsiteWorkerDocumentVersionMutation,
    CreateJobsiteWorkerDocumentVersionMutationVariables
  >;
export const JobsiteArchiveInvitationDocument = gql`
  mutation JobsiteArchiveInvitation($input: JobsiteArchiveInvitationInput!) {
    jobsiteArchiveInvitation(input: $input) {
      success {
        success
      }
    }
  }
`;
export type JobsiteArchiveInvitationMutationFn = Apollo.MutationFunction<
  JobsiteArchiveInvitationMutation,
  JobsiteArchiveInvitationMutationVariables
>;

/**
 * __useJobsiteArchiveInvitationMutation__
 *
 * To run a mutation, you first call `useJobsiteArchiveInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteArchiveInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteArchiveInvitationMutation, { data, loading, error }] = useJobsiteArchiveInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteArchiveInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteArchiveInvitationMutation,
    JobsiteArchiveInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteArchiveInvitationMutation,
    JobsiteArchiveInvitationMutationVariables
  >(JobsiteArchiveInvitationDocument, options);
}
export type JobsiteArchiveInvitationMutationHookResult = ReturnType<
  typeof useJobsiteArchiveInvitationMutation
>;
export type JobsiteArchiveInvitationMutationResult =
  Apollo.MutationResult<JobsiteArchiveInvitationMutation>;
export type JobsiteArchiveInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    JobsiteArchiveInvitationMutation,
    JobsiteArchiveInvitationMutationVariables
  >;
export const JobsiteCreateInvitationDocument = gql`
  mutation JobsiteCreateInvitation($input: JobsiteCreateInvitationInput!) {
    jobsiteCreateInvitation(input: $input) {
      jobsiteInvitation {
        jobsiteInvitationId
        expirationDate
      }
    }
  }
`;
export type JobsiteCreateInvitationMutationFn = Apollo.MutationFunction<
  JobsiteCreateInvitationMutation,
  JobsiteCreateInvitationMutationVariables
>;

/**
 * __useJobsiteCreateInvitationMutation__
 *
 * To run a mutation, you first call `useJobsiteCreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobsiteCreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobsiteCreateInvitationMutation, { data, loading, error }] = useJobsiteCreateInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsiteCreateInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JobsiteCreateInvitationMutation,
    JobsiteCreateInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JobsiteCreateInvitationMutation,
    JobsiteCreateInvitationMutationVariables
  >(JobsiteCreateInvitationDocument, options);
}
export type JobsiteCreateInvitationMutationHookResult = ReturnType<
  typeof useJobsiteCreateInvitationMutation
>;
export type JobsiteCreateInvitationMutationResult =
  Apollo.MutationResult<JobsiteCreateInvitationMutation>;
export type JobsiteCreateInvitationMutationOptions = Apollo.BaseMutationOptions<
  JobsiteCreateInvitationMutation,
  JobsiteCreateInvitationMutationVariables
>;
export const ReissueMobileBadgeDocument = gql`
  mutation reissueMobileBadge($workerCardId: ID!, $newPhoneNumber: String) {
    reissueMobileBadge(
      workerCardId: $workerCardId
      newPhoneNumber: $newPhoneNumber
    ) {
      workerCardId
      cardNumber
    }
  }
`;
export type ReissueMobileBadgeMutationFn = Apollo.MutationFunction<
  ReissueMobileBadgeMutation,
  ReissueMobileBadgeMutationVariables
>;

/**
 * __useReissueMobileBadgeMutation__
 *
 * To run a mutation, you first call `useReissueMobileBadgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReissueMobileBadgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reissueMobileBadgeMutation, { data, loading, error }] = useReissueMobileBadgeMutation({
 *   variables: {
 *      workerCardId: // value for 'workerCardId'
 *      newPhoneNumber: // value for 'newPhoneNumber'
 *   },
 * });
 */
export function useReissueMobileBadgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReissueMobileBadgeMutation,
    ReissueMobileBadgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReissueMobileBadgeMutation,
    ReissueMobileBadgeMutationVariables
  >(ReissueMobileBadgeDocument, options);
}
export type ReissueMobileBadgeMutationHookResult = ReturnType<
  typeof useReissueMobileBadgeMutation
>;
export type ReissueMobileBadgeMutationResult =
  Apollo.MutationResult<ReissueMobileBadgeMutation>;
export type ReissueMobileBadgeMutationOptions = Apollo.BaseMutationOptions<
  ReissueMobileBadgeMutation,
  ReissueMobileBadgeMutationVariables
>;
export const ReprintWorkerCardDocument = gql`
  mutation ReprintWorkerCard($input: PrintWorkerCardInput!) {
    reprintWorkerCard(input: $input) {
      workerCard {
        workerCardId
        cardNumber
        workerCardStatus
        workerCardFormat {
          workerCardFormatId
          name
          cardType
        }
        lastPrintJob {
          cardPrintJobId
          startedAt
          status
          statusMessage
          completion {
            cardNumber
            facilityCode
            completedAt
          }
          error {
            code
            erroredAt
            message
          }
        }
      }
    }
  }
`;
export type ReprintWorkerCardMutationFn = Apollo.MutationFunction<
  ReprintWorkerCardMutation,
  ReprintWorkerCardMutationVariables
>;

/**
 * __useReprintWorkerCardMutation__
 *
 * To run a mutation, you first call `useReprintWorkerCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprintWorkerCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprintWorkerCardMutation, { data, loading, error }] = useReprintWorkerCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReprintWorkerCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReprintWorkerCardMutation,
    ReprintWorkerCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReprintWorkerCardMutation,
    ReprintWorkerCardMutationVariables
  >(ReprintWorkerCardDocument, options);
}
export type ReprintWorkerCardMutationHookResult = ReturnType<
  typeof useReprintWorkerCardMutation
>;
export type ReprintWorkerCardMutationResult =
  Apollo.MutationResult<ReprintWorkerCardMutation>;
export type ReprintWorkerCardMutationOptions = Apollo.BaseMutationOptions<
  ReprintWorkerCardMutation,
  ReprintWorkerCardMutationVariables
>;
export const SendPasswordResetEmailDocument = gql`
  mutation SendPasswordResetEmail(
    $email: String!
    $sendForgotPasswordEmail: Boolean
  ) {
    sendPasswordResetEmail(
      email: $email
      sendForgotPasswordEmail: $sendForgotPasswordEmail
    )
  }
`;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<
  SendPasswordResetEmailMutation,
  SendPasswordResetEmailMutationVariables
>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      sendForgotPasswordEmail: // value for 'sendForgotPasswordEmail'
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendPasswordResetEmailMutation,
    SendPasswordResetEmailMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendPasswordResetEmailMutation,
    SendPasswordResetEmailMutationVariables
  >(SendPasswordResetEmailDocument, options);
}
export type SendPasswordResetEmailMutationHookResult = ReturnType<
  typeof useSendPasswordResetEmailMutation
>;
export type SendPasswordResetEmailMutationResult =
  Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<
  SendPasswordResetEmailMutation,
  SendPasswordResetEmailMutationVariables
>;
export const UpdateJobsiteWorkerDocumentVersionDocument = gql`
  mutation UpdateJobsiteWorkerDocumentVersion(
    $jobsiteWorkerDocumentVersionId: ID!
    $jobsiteWorkerDocumentVersionInput: JobsiteWorkerDocumentVersionInput!
  ) {
    updateJobsiteWorkerDocumentVersion(
      jobsiteWorkerDocumentVersionId: $jobsiteWorkerDocumentVersionId
      jobsiteWorkerDocumentVersionInput: $jobsiteWorkerDocumentVersionInput
    ) {
      jobsiteWorkerDocumentVersionId
    }
  }
`;
export type UpdateJobsiteWorkerDocumentVersionMutationFn =
  Apollo.MutationFunction<
    UpdateJobsiteWorkerDocumentVersionMutation,
    UpdateJobsiteWorkerDocumentVersionMutationVariables
  >;

/**
 * __useUpdateJobsiteWorkerDocumentVersionMutation__
 *
 * To run a mutation, you first call `useUpdateJobsiteWorkerDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobsiteWorkerDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobsiteWorkerDocumentVersionMutation, { data, loading, error }] = useUpdateJobsiteWorkerDocumentVersionMutation({
 *   variables: {
 *      jobsiteWorkerDocumentVersionId: // value for 'jobsiteWorkerDocumentVersionId'
 *      jobsiteWorkerDocumentVersionInput: // value for 'jobsiteWorkerDocumentVersionInput'
 *   },
 * });
 */
export function useUpdateJobsiteWorkerDocumentVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateJobsiteWorkerDocumentVersionMutation,
    UpdateJobsiteWorkerDocumentVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateJobsiteWorkerDocumentVersionMutation,
    UpdateJobsiteWorkerDocumentVersionMutationVariables
  >(UpdateJobsiteWorkerDocumentVersionDocument, options);
}
export type UpdateJobsiteWorkerDocumentVersionMutationHookResult = ReturnType<
  typeof useUpdateJobsiteWorkerDocumentVersionMutation
>;
export type UpdateJobsiteWorkerDocumentVersionMutationResult =
  Apollo.MutationResult<UpdateJobsiteWorkerDocumentVersionMutation>;
export type UpdateJobsiteWorkerDocumentVersionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateJobsiteWorkerDocumentVersionMutation,
    UpdateJobsiteWorkerDocumentVersionMutationVariables
  >;
export const UploadSingleFileDocument = gql`
  mutation UploadSingleFile($fileInput: FileInput!) {
    uploadSingleFile(fileInput: $fileInput) {
      fileId
      fileType
      downloadUrl
    }
  }
`;
export type UploadSingleFileMutationFn = Apollo.MutationFunction<
  UploadSingleFileMutation,
  UploadSingleFileMutationVariables
>;

/**
 * __useUploadSingleFileMutation__
 *
 * To run a mutation, you first call `useUploadSingleFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSingleFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSingleFileMutation, { data, loading, error }] = useUploadSingleFileMutation({
 *   variables: {
 *      fileInput: // value for 'fileInput'
 *   },
 * });
 */
export function useUploadSingleFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadSingleFileMutation,
    UploadSingleFileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadSingleFileMutation,
    UploadSingleFileMutationVariables
  >(UploadSingleFileDocument, options);
}
export type UploadSingleFileMutationHookResult = ReturnType<
  typeof useUploadSingleFileMutation
>;
export type UploadSingleFileMutationResult =
  Apollo.MutationResult<UploadSingleFileMutation>;
export type UploadSingleFileMutationOptions = Apollo.BaseMutationOptions<
  UploadSingleFileMutation,
  UploadSingleFileMutationVariables
>;
export const GetAnonymousJobsiteInvitationDocument = gql`
  query GetAnonymousJobsiteInvitation($jobsiteInvitationId: ID!) {
    getAnonymousJobsiteInvitation(jobsiteInvitationId: $jobsiteInvitationId) {
      jobsiteId
      contractor {
        contractorId
      }
    }
    getCurrentPolicyDocuments {
      id
      key
      version
    }
  }
`;

/**
 * __useGetAnonymousJobsiteInvitationQuery__
 *
 * To run a query within a React component, call `useGetAnonymousJobsiteInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnonymousJobsiteInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnonymousJobsiteInvitationQuery({
 *   variables: {
 *      jobsiteInvitationId: // value for 'jobsiteInvitationId'
 *   },
 * });
 */
export function useGetAnonymousJobsiteInvitationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnonymousJobsiteInvitationQuery,
    GetAnonymousJobsiteInvitationQueryVariables
  > &
    (
      | {
          variables: GetAnonymousJobsiteInvitationQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAnonymousJobsiteInvitationQuery,
    GetAnonymousJobsiteInvitationQueryVariables
  >(GetAnonymousJobsiteInvitationDocument, options);
}
export function useGetAnonymousJobsiteInvitationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnonymousJobsiteInvitationQuery,
    GetAnonymousJobsiteInvitationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnonymousJobsiteInvitationQuery,
    GetAnonymousJobsiteInvitationQueryVariables
  >(GetAnonymousJobsiteInvitationDocument, options);
}
export function useGetAnonymousJobsiteInvitationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAnonymousJobsiteInvitationQuery,
    GetAnonymousJobsiteInvitationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAnonymousJobsiteInvitationQuery,
    GetAnonymousJobsiteInvitationQueryVariables
  >(GetAnonymousJobsiteInvitationDocument, options);
}
export type GetAnonymousJobsiteInvitationQueryHookResult = ReturnType<
  typeof useGetAnonymousJobsiteInvitationQuery
>;
export type GetAnonymousJobsiteInvitationLazyQueryHookResult = ReturnType<
  typeof useGetAnonymousJobsiteInvitationLazyQuery
>;
export type GetAnonymousJobsiteInvitationSuspenseQueryHookResult = ReturnType<
  typeof useGetAnonymousJobsiteInvitationSuspenseQuery
>;
export type GetAnonymousJobsiteInvitationQueryResult = Apollo.QueryResult<
  GetAnonymousJobsiteInvitationQuery,
  GetAnonymousJobsiteInvitationQueryVariables
>;
export const GetContractorsDocument = gql`
  query GetContractors($userContractorsInput: UserContractorsInput) {
    getCurrentSession {
      user {
        userAccountId
        contractors(input: $userContractorsInput) {
          edges {
            node {
              contractorId
              organization {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContractorsQuery__
 *
 * To run a query within a React component, call `useGetContractorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractorsQuery({
 *   variables: {
 *      userContractorsInput: // value for 'userContractorsInput'
 *   },
 * });
 */
export function useGetContractorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContractorsQuery,
    GetContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContractorsQuery, GetContractorsQueryVariables>(
    GetContractorsDocument,
    options,
  );
}
export function useGetContractorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractorsQuery,
    GetContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContractorsQuery, GetContractorsQueryVariables>(
    GetContractorsDocument,
    options,
  );
}
export function useGetContractorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetContractorsQuery,
    GetContractorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetContractorsQuery,
    GetContractorsQueryVariables
  >(GetContractorsDocument, options);
}
export type GetContractorsQueryHookResult = ReturnType<
  typeof useGetContractorsQuery
>;
export type GetContractorsLazyQueryHookResult = ReturnType<
  typeof useGetContractorsLazyQuery
>;
export type GetContractorsSuspenseQueryHookResult = ReturnType<
  typeof useGetContractorsSuspenseQuery
>;
export type GetContractorsQueryResult = Apollo.QueryResult<
  GetContractorsQuery,
  GetContractorsQueryVariables
>;
export const GetCurrentCardPrintJobDocument = gql`
  query GetCurrentCardPrintJob($workerId: ID!) {
    getCurrentCardPrintJob(workerId: $workerId) {
      cardPrintJobId
      startedAt
      status
      statusMessage
      completion {
        cardNumber
        facilityCode
        completedAt
      }
      jobsite {
        jobsiteId
      }
      workerCard {
        workerCardId
        cardNumber
        workerCardStatus
        workerCardFormat {
          workerCardFormatId
          name
          cardType
        }
      }
    }
  }
`;

/**
 * __useGetCurrentCardPrintJobQuery__
 *
 * To run a query within a React component, call `useGetCurrentCardPrintJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCardPrintJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCardPrintJobQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetCurrentCardPrintJobQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrentCardPrintJobQuery,
    GetCurrentCardPrintJobQueryVariables
  > &
    (
      | { variables: GetCurrentCardPrintJobQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCurrentCardPrintJobQuery,
    GetCurrentCardPrintJobQueryVariables
  >(GetCurrentCardPrintJobDocument, options);
}
export function useGetCurrentCardPrintJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentCardPrintJobQuery,
    GetCurrentCardPrintJobQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCurrentCardPrintJobQuery,
    GetCurrentCardPrintJobQueryVariables
  >(GetCurrentCardPrintJobDocument, options);
}
export function useGetCurrentCardPrintJobSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetCurrentCardPrintJobQuery,
    GetCurrentCardPrintJobQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetCurrentCardPrintJobQuery,
    GetCurrentCardPrintJobQueryVariables
  >(GetCurrentCardPrintJobDocument, options);
}
export type GetCurrentCardPrintJobQueryHookResult = ReturnType<
  typeof useGetCurrentCardPrintJobQuery
>;
export type GetCurrentCardPrintJobLazyQueryHookResult = ReturnType<
  typeof useGetCurrentCardPrintJobLazyQuery
>;
export type GetCurrentCardPrintJobSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentCardPrintJobSuspenseQuery
>;
export type GetCurrentCardPrintJobQueryResult = Apollo.QueryResult<
  GetCurrentCardPrintJobQuery,
  GetCurrentCardPrintJobQueryVariables
>;
export const GetDevelopersDocument = gql`
  query GetDevelopers {
    getCurrentSession {
      user {
        userAccountId
        developers {
          count
          edges {
            node {
              developerId
              organization {
                organizationId
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetDevelopersQuery__
 *
 * To run a query within a React component, call `useGetDevelopersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDevelopersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDevelopersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDevelopersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDevelopersQuery,
    GetDevelopersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDevelopersQuery, GetDevelopersQueryVariables>(
    GetDevelopersDocument,
    options,
  );
}
export function useGetDevelopersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDevelopersQuery,
    GetDevelopersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDevelopersQuery, GetDevelopersQueryVariables>(
    GetDevelopersDocument,
    options,
  );
}
export function useGetDevelopersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDevelopersQuery,
    GetDevelopersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDevelopersQuery,
    GetDevelopersQueryVariables
  >(GetDevelopersDocument, options);
}
export type GetDevelopersQueryHookResult = ReturnType<
  typeof useGetDevelopersQuery
>;
export type GetDevelopersLazyQueryHookResult = ReturnType<
  typeof useGetDevelopersLazyQuery
>;
export type GetDevelopersSuspenseQueryHookResult = ReturnType<
  typeof useGetDevelopersSuspenseQuery
>;
export type GetDevelopersQueryResult = Apollo.QueryResult<
  GetDevelopersQuery,
  GetDevelopersQueryVariables
>;
export const GetJobsiteCardFormatsDocument = gql`
  query GetJobsiteCardFormats($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      jobsiteCardFormats {
        edges {
          node {
            jobsiteCardFormatId
            isDefaultForCardType
            workerCardFormat {
              workerCardFormatId
              name
              description
              cardType
              facilityCode
              encoding
              validationRegex
              validationMessage
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteCardFormatsQuery__
 *
 * To run a query within a React component, call `useGetJobsiteCardFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteCardFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteCardFormatsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteCardFormatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteCardFormatsQuery,
    GetJobsiteCardFormatsQueryVariables
  > &
    (
      | { variables: GetJobsiteCardFormatsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteCardFormatsQuery,
    GetJobsiteCardFormatsQueryVariables
  >(GetJobsiteCardFormatsDocument, options);
}
export function useGetJobsiteCardFormatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteCardFormatsQuery,
    GetJobsiteCardFormatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteCardFormatsQuery,
    GetJobsiteCardFormatsQueryVariables
  >(GetJobsiteCardFormatsDocument, options);
}
export function useGetJobsiteCardFormatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteCardFormatsQuery,
    GetJobsiteCardFormatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteCardFormatsQuery,
    GetJobsiteCardFormatsQueryVariables
  >(GetJobsiteCardFormatsDocument, options);
}
export type GetJobsiteCardFormatsQueryHookResult = ReturnType<
  typeof useGetJobsiteCardFormatsQuery
>;
export type GetJobsiteCardFormatsLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteCardFormatsLazyQuery
>;
export type GetJobsiteCardFormatsSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteCardFormatsSuspenseQuery
>;
export type GetJobsiteCardFormatsQueryResult = Apollo.QueryResult<
  GetJobsiteCardFormatsQuery,
  GetJobsiteCardFormatsQueryVariables
>;
export const GetJobsiteContractorWorkersDocument = gql`
  query GetJobsiteContractorWorkers(
    $jobsiteContractorId: ID!
    $jobsiteContractorJobsiteWorkersInput: JobsiteContractorJobsiteWorkersInput
  ) {
    getJobsiteContractor(id: $jobsiteContractorId) {
      id
      jobsiteWorkers(input: $jobsiteContractorJobsiteWorkersInput) {
        count
        edges {
          node {
            jobsiteWorkerId
            stickerNumber
            isOnSite
            trade
            jobTitle
            currentAccess {
              isAllowed
              notAllowedReason
              startDate
              endDate
            }
            contractorWorker {
              id
              contractor {
                contractorId
                organization {
                  organizationId
                  name
                }
              }
              worker {
                workerId
                birthDate
                quickCode
                user {
                  userAccountId
                  identity {
                    firstName
                    lastName
                    email
                  }
                }
                profilePicture {
                  downloadUrl
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteContractorWorkersQuery__
 *
 * To run a query within a React component, call `useGetJobsiteContractorWorkersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteContractorWorkersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteContractorWorkersQuery({
 *   variables: {
 *      jobsiteContractorId: // value for 'jobsiteContractorId'
 *      jobsiteContractorJobsiteWorkersInput: // value for 'jobsiteContractorJobsiteWorkersInput'
 *   },
 * });
 */
export function useGetJobsiteContractorWorkersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteContractorWorkersQuery,
    GetJobsiteContractorWorkersQueryVariables
  > &
    (
      | { variables: GetJobsiteContractorWorkersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteContractorWorkersQuery,
    GetJobsiteContractorWorkersQueryVariables
  >(GetJobsiteContractorWorkersDocument, options);
}
export function useGetJobsiteContractorWorkersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteContractorWorkersQuery,
    GetJobsiteContractorWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteContractorWorkersQuery,
    GetJobsiteContractorWorkersQueryVariables
  >(GetJobsiteContractorWorkersDocument, options);
}
export function useGetJobsiteContractorWorkersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteContractorWorkersQuery,
    GetJobsiteContractorWorkersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteContractorWorkersQuery,
    GetJobsiteContractorWorkersQueryVariables
  >(GetJobsiteContractorWorkersDocument, options);
}
export type GetJobsiteContractorWorkersQueryHookResult = ReturnType<
  typeof useGetJobsiteContractorWorkersQuery
>;
export type GetJobsiteContractorWorkersLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteContractorWorkersLazyQuery
>;
export type GetJobsiteContractorWorkersSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteContractorWorkersSuspenseQuery
>;
export type GetJobsiteContractorWorkersQueryResult = Apollo.QueryResult<
  GetJobsiteContractorWorkersQuery,
  GetJobsiteContractorWorkersQueryVariables
>;
export const GetJobsiteInvitationDocument = gql`
  query GetJobsiteInvitation($jobsiteInvitationId: ID!) {
    getJobsiteInvitation(jobsiteInvitationId: $jobsiteInvitationId) {
      jobsiteInvitationId
      jobsiteContractor {
        jobsite {
          jobsiteId
          name
          profilePicture {
            fileId
            fileType
            downloadUrl
          }
          tradeOptions
          titleOptions
          unionAffiliationOptions
          classificationGroupOptions
          jobsiteCustomWorkerDataFields {
            edges {
              node {
                fieldLabel
                fieldDataType
                validationMessage
                validationRegex
                isRequired
              }
            }
          }
          jobsiteCardFormats {
            count
            edges {
              node {
                workerCardFormat {
                  cardType
                  facilityCode
                  name
                  workerCardFormatId
                }
              }
            }
          }
          modules {
            ... on JobsiteOnboardingModule {
              name
              steps {
                key
                index
                isRequired
                isVisible
                fields {
                  key
                  name
                  index
                  isRequired
                  isHidden
                }
              }
              documents {
                key
                workerDocTypeKey
                name
                index
                isRequired
                isVisible
                expiration
                gracePeriod
                fields {
                  key
                  name
                  index
                  isRequired
                  isHidden
                }
              }
            }
            ... on JobsitePreOnboardingModule {
              name
              steps {
                key
                name
                index
                isRequired
                isVisible
                fields {
                  key
                  name
                  index
                  isRequired
                  isHidden
                }
              }
            }
            ... on JobsiteFeaturesModule {
              name
              slug
              workerAppEnabled
              doNotAllowToSkipSelfOnboardingSteps
              enforceValidContractorInSelfOnboarding
            }
          }
          documentTypes {
            edges {
              node {
                id
                key
                name
                position
                workerDocumentType {
                  workerDocumentTypeId
                  key
                }
                files {
                  fileId
                  fileType
                  downloadUrl
                  language
                  title
                }
              }
            }
          }
          jobsiteContractors {
            edges {
              node {
                id
                startDate
                contractor {
                  contractorId
                  isDefaultContractor
                  organization {
                    organizationId
                    name
                  }
                }
              }
            }
          }
        }
        contractor {
          contractorId
          isDefaultContractor
          organization {
            organizationId
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteInvitationQuery__
 *
 * To run a query within a React component, call `useGetJobsiteInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteInvitationQuery({
 *   variables: {
 *      jobsiteInvitationId: // value for 'jobsiteInvitationId'
 *   },
 * });
 */
export function useGetJobsiteInvitationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteInvitationQuery,
    GetJobsiteInvitationQueryVariables
  > &
    (
      | { variables: GetJobsiteInvitationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteInvitationQuery,
    GetJobsiteInvitationQueryVariables
  >(GetJobsiteInvitationDocument, options);
}
export function useGetJobsiteInvitationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteInvitationQuery,
    GetJobsiteInvitationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteInvitationQuery,
    GetJobsiteInvitationQueryVariables
  >(GetJobsiteInvitationDocument, options);
}
export function useGetJobsiteInvitationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteInvitationQuery,
    GetJobsiteInvitationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteInvitationQuery,
    GetJobsiteInvitationQueryVariables
  >(GetJobsiteInvitationDocument, options);
}
export type GetJobsiteInvitationQueryHookResult = ReturnType<
  typeof useGetJobsiteInvitationQuery
>;
export type GetJobsiteInvitationLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteInvitationLazyQuery
>;
export type GetJobsiteInvitationSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteInvitationSuspenseQuery
>;
export type GetJobsiteInvitationQueryResult = Apollo.QueryResult<
  GetJobsiteInvitationQuery,
  GetJobsiteInvitationQueryVariables
>;
export const GetJobsiteWithBadgeTemplatesDocument = gql`
  query GetJobsiteWithBadgeTemplates($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      jobsiteBadgeTemplates {
        edges {
          node {
            id
            isDefault
            badgeTemplate {
              id
              templateName
              displayName
              isForTempBadge
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteWithBadgeTemplatesQuery__
 *
 * To run a query within a React component, call `useGetJobsiteWithBadgeTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteWithBadgeTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteWithBadgeTemplatesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteWithBadgeTemplatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteWithBadgeTemplatesQuery,
    GetJobsiteWithBadgeTemplatesQueryVariables
  > &
    (
      | {
          variables: GetJobsiteWithBadgeTemplatesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteWithBadgeTemplatesQuery,
    GetJobsiteWithBadgeTemplatesQueryVariables
  >(GetJobsiteWithBadgeTemplatesDocument, options);
}
export function useGetJobsiteWithBadgeTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteWithBadgeTemplatesQuery,
    GetJobsiteWithBadgeTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteWithBadgeTemplatesQuery,
    GetJobsiteWithBadgeTemplatesQueryVariables
  >(GetJobsiteWithBadgeTemplatesDocument, options);
}
export function useGetJobsiteWithBadgeTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteWithBadgeTemplatesQuery,
    GetJobsiteWithBadgeTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteWithBadgeTemplatesQuery,
    GetJobsiteWithBadgeTemplatesQueryVariables
  >(GetJobsiteWithBadgeTemplatesDocument, options);
}
export type GetJobsiteWithBadgeTemplatesQueryHookResult = ReturnType<
  typeof useGetJobsiteWithBadgeTemplatesQuery
>;
export type GetJobsiteWithBadgeTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteWithBadgeTemplatesLazyQuery
>;
export type GetJobsiteWithBadgeTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteWithBadgeTemplatesSuspenseQuery
>;
export type GetJobsiteWithBadgeTemplatesQueryResult = Apollo.QueryResult<
  GetJobsiteWithBadgeTemplatesQuery,
  GetJobsiteWithBadgeTemplatesQueryVariables
>;
export const GetJobsiteWithPrintersDocument = gql`
  query GetJobsiteWithPrinters($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      defaultJobsitePrinterId
      jobsitePrinters {
        edges {
          node {
            id
            name
            locationName
            organizationName
            hidPrinterId
            hidProxyInstance
            fargoLocationId
            fargoOrganizationId
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsiteWithPrintersQuery__
 *
 * To run a query within a React component, call `useGetJobsiteWithPrintersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsiteWithPrintersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsiteWithPrintersQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetJobsiteWithPrintersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsiteWithPrintersQuery,
    GetJobsiteWithPrintersQueryVariables
  > &
    (
      | { variables: GetJobsiteWithPrintersQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetJobsiteWithPrintersQuery,
    GetJobsiteWithPrintersQueryVariables
  >(GetJobsiteWithPrintersDocument, options);
}
export function useGetJobsiteWithPrintersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsiteWithPrintersQuery,
    GetJobsiteWithPrintersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetJobsiteWithPrintersQuery,
    GetJobsiteWithPrintersQueryVariables
  >(GetJobsiteWithPrintersDocument, options);
}
export function useGetJobsiteWithPrintersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsiteWithPrintersQuery,
    GetJobsiteWithPrintersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetJobsiteWithPrintersQuery,
    GetJobsiteWithPrintersQueryVariables
  >(GetJobsiteWithPrintersDocument, options);
}
export type GetJobsiteWithPrintersQueryHookResult = ReturnType<
  typeof useGetJobsiteWithPrintersQuery
>;
export type GetJobsiteWithPrintersLazyQueryHookResult = ReturnType<
  typeof useGetJobsiteWithPrintersLazyQuery
>;
export type GetJobsiteWithPrintersSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsiteWithPrintersSuspenseQuery
>;
export type GetJobsiteWithPrintersQueryResult = Apollo.QueryResult<
  GetJobsiteWithPrintersQuery,
  GetJobsiteWithPrintersQueryVariables
>;
export const GetJobsitesDocument = gql`
  query GetJobsites($userJobsitesInput: UserJobsitesInput!) {
    getCurrentSession {
      user {
        userAccountId
        roles {
          key
          displayName
        }
        jobsites(input: $userJobsitesInput) {
          edges {
            node {
              jobsiteId
              name
              parentId
              startDate
              endDate
              workerAccessEnabled
              avigilonEnabled
              clearanceAssignmentEnabled
              timeZone
              tradeOptions
              titleOptions
              featuresModule {
                announcementsEnabled
                archivingAccessEventsEnabled
              }
              developer {
                developerId
                name
              }
              jobsiteCardFormats {
                edges {
                  node {
                    jobsiteCardFormatId
                    isDefaultForCardType
                    workerCardFormat {
                      workerCardFormatId
                      name
                      description
                      cardType
                      facilityCode
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetJobsitesQuery__
 *
 * To run a query within a React component, call `useGetJobsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsitesQuery({
 *   variables: {
 *      userJobsitesInput: // value for 'userJobsitesInput'
 *   },
 * });
 */
export function useGetJobsitesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetJobsitesQuery,
    GetJobsitesQueryVariables
  > &
    (
      | { variables: GetJobsitesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobsitesQuery, GetJobsitesQueryVariables>(
    GetJobsitesDocument,
    options,
  );
}
export function useGetJobsitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetJobsitesQuery,
    GetJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobsitesQuery, GetJobsitesQueryVariables>(
    GetJobsitesDocument,
    options,
  );
}
export function useGetJobsitesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetJobsitesQuery,
    GetJobsitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetJobsitesQuery, GetJobsitesQueryVariables>(
    GetJobsitesDocument,
    options,
  );
}
export type GetJobsitesQueryHookResult = ReturnType<typeof useGetJobsitesQuery>;
export type GetJobsitesLazyQueryHookResult = ReturnType<
  typeof useGetJobsitesLazyQuery
>;
export type GetJobsitesSuspenseQueryHookResult = ReturnType<
  typeof useGetJobsitesSuspenseQuery
>;
export type GetJobsitesQueryResult = Apollo.QueryResult<
  GetJobsitesQuery,
  GetJobsitesQueryVariables
>;
export const GetRolesDocument = gql`
  query GetRoles {
    getRoles {
      key
      displayName
      isSuper
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options,
  );
}
export function useGetRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRolesQuery,
    GetRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options,
  );
}
export function useGetRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRolesQuery,
    GetRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(
    GetRolesDocument,
    options,
  );
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<
  typeof useGetRolesLazyQuery
>;
export type GetRolesSuspenseQueryHookResult = ReturnType<
  typeof useGetRolesSuspenseQuery
>;
export type GetRolesQueryResult = Apollo.QueryResult<
  GetRolesQuery,
  GetRolesQueryVariables
>;
export const GetTempBadgesDocument = gql`
  query GetTempBadges(
    $jobsiteId: ID!
    $jobsiteTempBadgesInput: TempBadgesInput
  ) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      tempBadges(input: $jobsiteTempBadgesInput) {
        count
        edges {
          node {
            id
            name
            cardNumber
            status
            jobsiteCardFormat {
              jobsiteCardFormatId
              workerCardFormat {
                workerCardFormatId
                name
                description
                cardType
                facilityCode
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetTempBadgesQuery__
 *
 * To run a query within a React component, call `useGetTempBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTempBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTempBadgesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *      jobsiteTempBadgesInput: // value for 'jobsiteTempBadgesInput'
 *   },
 * });
 */
export function useGetTempBadgesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTempBadgesQuery,
    GetTempBadgesQueryVariables
  > &
    (
      | { variables: GetTempBadgesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTempBadgesQuery, GetTempBadgesQueryVariables>(
    GetTempBadgesDocument,
    options,
  );
}
export function useGetTempBadgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTempBadgesQuery,
    GetTempBadgesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTempBadgesQuery, GetTempBadgesQueryVariables>(
    GetTempBadgesDocument,
    options,
  );
}
export function useGetTempBadgesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTempBadgesQuery,
    GetTempBadgesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTempBadgesQuery,
    GetTempBadgesQueryVariables
  >(GetTempBadgesDocument, options);
}
export type GetTempBadgesQueryHookResult = ReturnType<
  typeof useGetTempBadgesQuery
>;
export type GetTempBadgesLazyQueryHookResult = ReturnType<
  typeof useGetTempBadgesLazyQuery
>;
export type GetTempBadgesSuspenseQueryHookResult = ReturnType<
  typeof useGetTempBadgesSuspenseQuery
>;
export type GetTempBadgesQueryResult = Apollo.QueryResult<
  GetTempBadgesQuery,
  GetTempBadgesQueryVariables
>;
export const GetWorkerCardDocument = gql`
  query GetWorkerCard(
    $workerCardId: ID
    $cardNumber: String
    $cardType: WorkerCardType
  ) {
    getWorkerCard(
      workerCardId: $workerCardId
      cardNumber: $cardNumber
      cardType: $cardType
    ) {
      workerCardId
      cardNumber
      expiredAt
      isTemporary
      worker {
        workerId
        user {
          identity {
            phoneNumber
          }
        }
      }
      workerCardFormat {
        name
        workerCardFormatId
        cardType
        facilityCode
      }
    }
  }
`;

/**
 * __useGetWorkerCardQuery__
 *
 * To run a query within a React component, call `useGetWorkerCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerCardQuery({
 *   variables: {
 *      workerCardId: // value for 'workerCardId'
 *      cardNumber: // value for 'cardNumber'
 *      cardType: // value for 'cardType'
 *   },
 * });
 */
export function useGetWorkerCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWorkerCardQuery,
    GetWorkerCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkerCardQuery, GetWorkerCardQueryVariables>(
    GetWorkerCardDocument,
    options,
  );
}
export function useGetWorkerCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerCardQuery,
    GetWorkerCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkerCardQuery, GetWorkerCardQueryVariables>(
    GetWorkerCardDocument,
    options,
  );
}
export function useGetWorkerCardSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerCardQuery,
    GetWorkerCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerCardQuery,
    GetWorkerCardQueryVariables
  >(GetWorkerCardDocument, options);
}
export type GetWorkerCardQueryHookResult = ReturnType<
  typeof useGetWorkerCardQuery
>;
export type GetWorkerCardLazyQueryHookResult = ReturnType<
  typeof useGetWorkerCardLazyQuery
>;
export type GetWorkerCardSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerCardSuspenseQuery
>;
export type GetWorkerCardQueryResult = Apollo.QueryResult<
  GetWorkerCardQuery,
  GetWorkerCardQueryVariables
>;
export const GetWorkerCardsDocument = gql`
  query GetWorkerCards(
    $workerId: ID!
    $workerCardsInput: WorkerWorkerCardsInput
  ) {
    getWorker(workerId: $workerId) {
      workerCards(input: $workerCardsInput) {
        edges {
          node {
            workerCardId
            cardNumber
            matchingWorkerCardId
            cardStatus
            workerCardStatus
            isTemporary
            expiredAt
            issuedAt
            worker {
              workerId
              user {
                identity {
                  phoneNumber
                }
              }
            }
            workerCardFormat {
              name
              workerCardFormatId
              cardType
              facilityCode
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetWorkerCardsQuery__
 *
 * To run a query within a React component, call `useGetWorkerCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkerCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkerCardsQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *      workerCardsInput: // value for 'workerCardsInput'
 *   },
 * });
 */
export function useGetWorkerCardsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkerCardsQuery,
    GetWorkerCardsQueryVariables
  > &
    (
      | { variables: GetWorkerCardsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkerCardsQuery, GetWorkerCardsQueryVariables>(
    GetWorkerCardsDocument,
    options,
  );
}
export function useGetWorkerCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkerCardsQuery,
    GetWorkerCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkerCardsQuery, GetWorkerCardsQueryVariables>(
    GetWorkerCardsDocument,
    options,
  );
}
export function useGetWorkerCardsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetWorkerCardsQuery,
    GetWorkerCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetWorkerCardsQuery,
    GetWorkerCardsQueryVariables
  >(GetWorkerCardsDocument, options);
}
export type GetWorkerCardsQueryHookResult = ReturnType<
  typeof useGetWorkerCardsQuery
>;
export type GetWorkerCardsLazyQueryHookResult = ReturnType<
  typeof useGetWorkerCardsLazyQuery
>;
export type GetWorkerCardsSuspenseQueryHookResult = ReturnType<
  typeof useGetWorkerCardsSuspenseQuery
>;
export type GetWorkerCardsQueryResult = Apollo.QueryResult<
  GetWorkerCardsQuery,
  GetWorkerCardsQueryVariables
>;
export const GetAppLayoutCurrentSessionDocument = gql`
  query GetAppLayoutCurrentSession {
    getCurrentSession {
      user {
        userAccountId
        roles {
          key
        }
      }
      session {
        urlLock
        appVersion
      }
    }
  }
`;

/**
 * __useGetAppLayoutCurrentSessionQuery__
 *
 * To run a query within a React component, call `useGetAppLayoutCurrentSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppLayoutCurrentSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppLayoutCurrentSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppLayoutCurrentSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAppLayoutCurrentSessionQuery,
    GetAppLayoutCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppLayoutCurrentSessionQuery,
    GetAppLayoutCurrentSessionQueryVariables
  >(GetAppLayoutCurrentSessionDocument, options);
}
export function useGetAppLayoutCurrentSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppLayoutCurrentSessionQuery,
    GetAppLayoutCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppLayoutCurrentSessionQuery,
    GetAppLayoutCurrentSessionQueryVariables
  >(GetAppLayoutCurrentSessionDocument, options);
}
export function useGetAppLayoutCurrentSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAppLayoutCurrentSessionQuery,
    GetAppLayoutCurrentSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAppLayoutCurrentSessionQuery,
    GetAppLayoutCurrentSessionQueryVariables
  >(GetAppLayoutCurrentSessionDocument, options);
}
export type GetAppLayoutCurrentSessionQueryHookResult = ReturnType<
  typeof useGetAppLayoutCurrentSessionQuery
>;
export type GetAppLayoutCurrentSessionLazyQueryHookResult = ReturnType<
  typeof useGetAppLayoutCurrentSessionLazyQuery
>;
export type GetAppLayoutCurrentSessionSuspenseQueryHookResult = ReturnType<
  typeof useGetAppLayoutCurrentSessionSuspenseQuery
>;
export type GetAppLayoutCurrentSessionQueryResult = Apollo.QueryResult<
  GetAppLayoutCurrentSessionQuery,
  GetAppLayoutCurrentSessionQueryVariables
>;
export const UpdateSessionAppVersionDocument = gql`
  mutation UpdateSessionAppVersion($appVersion: String!) {
    updateSessionAppVersion(appVersion: $appVersion) {
      session {
        authType
        createdAt
        updatedAt
        lastActiveAt
        appVersion
      }
    }
  }
`;
export type UpdateSessionAppVersionMutationFn = Apollo.MutationFunction<
  UpdateSessionAppVersionMutation,
  UpdateSessionAppVersionMutationVariables
>;

/**
 * __useUpdateSessionAppVersionMutation__
 *
 * To run a mutation, you first call `useUpdateSessionAppVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSessionAppVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSessionAppVersionMutation, { data, loading, error }] = useUpdateSessionAppVersionMutation({
 *   variables: {
 *      appVersion: // value for 'appVersion'
 *   },
 * });
 */
export function useUpdateSessionAppVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSessionAppVersionMutation,
    UpdateSessionAppVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSessionAppVersionMutation,
    UpdateSessionAppVersionMutationVariables
  >(UpdateSessionAppVersionDocument, options);
}
export type UpdateSessionAppVersionMutationHookResult = ReturnType<
  typeof useUpdateSessionAppVersionMutation
>;
export type UpdateSessionAppVersionMutationResult =
  Apollo.MutationResult<UpdateSessionAppVersionMutation>;
export type UpdateSessionAppVersionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSessionAppVersionMutation,
  UpdateSessionAppVersionMutationVariables
>;
export const GetSiteLayoutOverviewDocument = gql`
  query GetSiteLayoutOverview($siteId: ID!) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      siteLayoutOverview {
        effective {
          ...SiteLayoutRevisionSummaryFields
        }
        draft {
          ...SiteLayoutRevisionSummaryFields
        }
        history {
          ...SiteLayoutRevisionSummaryFields
        }
      }
    }
  }
  ${SiteLayoutRevisionSummaryFieldsFragmentDoc}
`;

/**
 * __useGetSiteLayoutOverviewQuery__
 *
 * To run a query within a React component, call `useGetSiteLayoutOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteLayoutOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteLayoutOverviewQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteLayoutOverviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteLayoutOverviewQuery,
    GetSiteLayoutOverviewQueryVariables
  > &
    (
      | { variables: GetSiteLayoutOverviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteLayoutOverviewQuery,
    GetSiteLayoutOverviewQueryVariables
  >(GetSiteLayoutOverviewDocument, options);
}
export function useGetSiteLayoutOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteLayoutOverviewQuery,
    GetSiteLayoutOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteLayoutOverviewQuery,
    GetSiteLayoutOverviewQueryVariables
  >(GetSiteLayoutOverviewDocument, options);
}
export function useGetSiteLayoutOverviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteLayoutOverviewQuery,
    GetSiteLayoutOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteLayoutOverviewQuery,
    GetSiteLayoutOverviewQueryVariables
  >(GetSiteLayoutOverviewDocument, options);
}
export type GetSiteLayoutOverviewQueryHookResult = ReturnType<
  typeof useGetSiteLayoutOverviewQuery
>;
export type GetSiteLayoutOverviewLazyQueryHookResult = ReturnType<
  typeof useGetSiteLayoutOverviewLazyQuery
>;
export type GetSiteLayoutOverviewSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteLayoutOverviewSuspenseQuery
>;
export type GetSiteLayoutOverviewQueryResult = Apollo.QueryResult<
  GetSiteLayoutOverviewQuery,
  GetSiteLayoutOverviewQueryVariables
>;
export const GetSiteLayoutStateDocument = gql`
  query GetSiteLayoutState($siteId: ID!) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      siteLayoutRevisions {
        ...SiteLayoutRevisionFields
      }
    }
  }
  ${SiteLayoutRevisionFieldsFragmentDoc}
`;

/**
 * __useGetSiteLayoutStateQuery__
 *
 * To run a query within a React component, call `useGetSiteLayoutStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteLayoutStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteLayoutStateQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteLayoutStateQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteLayoutStateQuery,
    GetSiteLayoutStateQueryVariables
  > &
    (
      | { variables: GetSiteLayoutStateQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteLayoutStateQuery,
    GetSiteLayoutStateQueryVariables
  >(GetSiteLayoutStateDocument, options);
}
export function useGetSiteLayoutStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteLayoutStateQuery,
    GetSiteLayoutStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteLayoutStateQuery,
    GetSiteLayoutStateQueryVariables
  >(GetSiteLayoutStateDocument, options);
}
export function useGetSiteLayoutStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteLayoutStateQuery,
    GetSiteLayoutStateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteLayoutStateQuery,
    GetSiteLayoutStateQueryVariables
  >(GetSiteLayoutStateDocument, options);
}
export type GetSiteLayoutStateQueryHookResult = ReturnType<
  typeof useGetSiteLayoutStateQuery
>;
export type GetSiteLayoutStateLazyQueryHookResult = ReturnType<
  typeof useGetSiteLayoutStateLazyQuery
>;
export type GetSiteLayoutStateSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteLayoutStateSuspenseQuery
>;
export type GetSiteLayoutStateQueryResult = Apollo.QueryResult<
  GetSiteLayoutStateQuery,
  GetSiteLayoutStateQueryVariables
>;
export const CreateSiteLayoutDraftDocument = gql`
  mutation CreateSiteLayoutDraft($input: CreateSiteLayoutDraftInput!) {
    createSiteLayoutDraft(input: $input) {
      revisionId
    }
  }
`;
export type CreateSiteLayoutDraftMutationFn = Apollo.MutationFunction<
  CreateSiteLayoutDraftMutation,
  CreateSiteLayoutDraftMutationVariables
>;

/**
 * __useCreateSiteLayoutDraftMutation__
 *
 * To run a mutation, you first call `useCreateSiteLayoutDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteLayoutDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteLayoutDraftMutation, { data, loading, error }] = useCreateSiteLayoutDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSiteLayoutDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSiteLayoutDraftMutation,
    CreateSiteLayoutDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSiteLayoutDraftMutation,
    CreateSiteLayoutDraftMutationVariables
  >(CreateSiteLayoutDraftDocument, options);
}
export type CreateSiteLayoutDraftMutationHookResult = ReturnType<
  typeof useCreateSiteLayoutDraftMutation
>;
export type CreateSiteLayoutDraftMutationResult =
  Apollo.MutationResult<CreateSiteLayoutDraftMutation>;
export type CreateSiteLayoutDraftMutationOptions = Apollo.BaseMutationOptions<
  CreateSiteLayoutDraftMutation,
  CreateSiteLayoutDraftMutationVariables
>;
export const DiscardSiteLayoutDraftDocument = gql`
  mutation DiscardSiteLayoutDraft($input: DiscardSiteLayoutDraftInput!) {
    discardSiteLayoutDraft(input: $input) {
      revisionId
    }
  }
`;
export type DiscardSiteLayoutDraftMutationFn = Apollo.MutationFunction<
  DiscardSiteLayoutDraftMutation,
  DiscardSiteLayoutDraftMutationVariables
>;

/**
 * __useDiscardSiteLayoutDraftMutation__
 *
 * To run a mutation, you first call `useDiscardSiteLayoutDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDiscardSiteLayoutDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [discardSiteLayoutDraftMutation, { data, loading, error }] = useDiscardSiteLayoutDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscardSiteLayoutDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DiscardSiteLayoutDraftMutation,
    DiscardSiteLayoutDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DiscardSiteLayoutDraftMutation,
    DiscardSiteLayoutDraftMutationVariables
  >(DiscardSiteLayoutDraftDocument, options);
}
export type DiscardSiteLayoutDraftMutationHookResult = ReturnType<
  typeof useDiscardSiteLayoutDraftMutation
>;
export type DiscardSiteLayoutDraftMutationResult =
  Apollo.MutationResult<DiscardSiteLayoutDraftMutation>;
export type DiscardSiteLayoutDraftMutationOptions = Apollo.BaseMutationOptions<
  DiscardSiteLayoutDraftMutation,
  DiscardSiteLayoutDraftMutationVariables
>;
export const PublishSiteLayoutDraftDocument = gql`
  mutation PublishSiteLayoutDraft($input: PublishSiteLayoutDraftInput!) {
    publishSiteLayoutDraft(input: $input) {
      revisionId
    }
  }
`;
export type PublishSiteLayoutDraftMutationFn = Apollo.MutationFunction<
  PublishSiteLayoutDraftMutation,
  PublishSiteLayoutDraftMutationVariables
>;

/**
 * __usePublishSiteLayoutDraftMutation__
 *
 * To run a mutation, you first call `usePublishSiteLayoutDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSiteLayoutDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSiteLayoutDraftMutation, { data, loading, error }] = usePublishSiteLayoutDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishSiteLayoutDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishSiteLayoutDraftMutation,
    PublishSiteLayoutDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishSiteLayoutDraftMutation,
    PublishSiteLayoutDraftMutationVariables
  >(PublishSiteLayoutDraftDocument, options);
}
export type PublishSiteLayoutDraftMutationHookResult = ReturnType<
  typeof usePublishSiteLayoutDraftMutation
>;
export type PublishSiteLayoutDraftMutationResult =
  Apollo.MutationResult<PublishSiteLayoutDraftMutation>;
export type PublishSiteLayoutDraftMutationOptions = Apollo.BaseMutationOptions<
  PublishSiteLayoutDraftMutation,
  PublishSiteLayoutDraftMutationVariables
>;
export const SaveDraftZoneDocument = gql`
  mutation SaveDraftZone($input: SaveDraftZoneInput!) {
    saveDraftZone(input: $input) {
      kind
      refusals {
        ...LayoutRefusalFields
      }
      draftToken
    }
  }
  ${LayoutRefusalFieldsFragmentDoc}
`;
export type SaveDraftZoneMutationFn = Apollo.MutationFunction<
  SaveDraftZoneMutation,
  SaveDraftZoneMutationVariables
>;

/**
 * __useSaveDraftZoneMutation__
 *
 * To run a mutation, you first call `useSaveDraftZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDraftZoneMutation, { data, loading, error }] = useSaveDraftZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDraftZoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveDraftZoneMutation,
    SaveDraftZoneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveDraftZoneMutation,
    SaveDraftZoneMutationVariables
  >(SaveDraftZoneDocument, options);
}
export type SaveDraftZoneMutationHookResult = ReturnType<
  typeof useSaveDraftZoneMutation
>;
export type SaveDraftZoneMutationResult =
  Apollo.MutationResult<SaveDraftZoneMutation>;
export type SaveDraftZoneMutationOptions = Apollo.BaseMutationOptions<
  SaveDraftZoneMutation,
  SaveDraftZoneMutationVariables
>;
export const SaveDraftEntryDocument = gql`
  mutation SaveDraftEntry($input: SaveDraftEntryInput!) {
    saveDraftEntry(input: $input) {
      kind
      refusals {
        ...LayoutRefusalFields
      }
      draftToken
      movedReaders {
        readerId
        fromEntryId
      }
    }
  }
  ${LayoutRefusalFieldsFragmentDoc}
`;
export type SaveDraftEntryMutationFn = Apollo.MutationFunction<
  SaveDraftEntryMutation,
  SaveDraftEntryMutationVariables
>;

/**
 * __useSaveDraftEntryMutation__
 *
 * To run a mutation, you first call `useSaveDraftEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDraftEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDraftEntryMutation, { data, loading, error }] = useSaveDraftEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDraftEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveDraftEntryMutation,
    SaveDraftEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveDraftEntryMutation,
    SaveDraftEntryMutationVariables
  >(SaveDraftEntryDocument, options);
}
export type SaveDraftEntryMutationHookResult = ReturnType<
  typeof useSaveDraftEntryMutation
>;
export type SaveDraftEntryMutationResult =
  Apollo.MutationResult<SaveDraftEntryMutation>;
export type SaveDraftEntryMutationOptions = Apollo.BaseMutationOptions<
  SaveDraftEntryMutation,
  SaveDraftEntryMutationVariables
>;
export const RemoveDraftZoneDocument = gql`
  mutation RemoveDraftZone($input: RemoveDraftZoneInput!) {
    removeDraftZone(input: $input) {
      kind
      refusals {
        ...LayoutRefusalFields
      }
      draftToken
    }
  }
  ${LayoutRefusalFieldsFragmentDoc}
`;
export type RemoveDraftZoneMutationFn = Apollo.MutationFunction<
  RemoveDraftZoneMutation,
  RemoveDraftZoneMutationVariables
>;

/**
 * __useRemoveDraftZoneMutation__
 *
 * To run a mutation, you first call `useRemoveDraftZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftZoneMutation, { data, loading, error }] = useRemoveDraftZoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDraftZoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveDraftZoneMutation,
    RemoveDraftZoneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveDraftZoneMutation,
    RemoveDraftZoneMutationVariables
  >(RemoveDraftZoneDocument, options);
}
export type RemoveDraftZoneMutationHookResult = ReturnType<
  typeof useRemoveDraftZoneMutation
>;
export type RemoveDraftZoneMutationResult =
  Apollo.MutationResult<RemoveDraftZoneMutation>;
export type RemoveDraftZoneMutationOptions = Apollo.BaseMutationOptions<
  RemoveDraftZoneMutation,
  RemoveDraftZoneMutationVariables
>;
export const RemoveDraftEntryDocument = gql`
  mutation RemoveDraftEntry($input: RemoveDraftEntryInput!) {
    removeDraftEntry(input: $input) {
      kind
      refusals {
        ...LayoutRefusalFields
      }
      draftToken
    }
  }
  ${LayoutRefusalFieldsFragmentDoc}
`;
export type RemoveDraftEntryMutationFn = Apollo.MutationFunction<
  RemoveDraftEntryMutation,
  RemoveDraftEntryMutationVariables
>;

/**
 * __useRemoveDraftEntryMutation__
 *
 * To run a mutation, you first call `useRemoveDraftEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDraftEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDraftEntryMutation, { data, loading, error }] = useRemoveDraftEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDraftEntryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveDraftEntryMutation,
    RemoveDraftEntryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveDraftEntryMutation,
    RemoveDraftEntryMutationVariables
  >(RemoveDraftEntryDocument, options);
}
export type RemoveDraftEntryMutationHookResult = ReturnType<
  typeof useRemoveDraftEntryMutation
>;
export type RemoveDraftEntryMutationResult =
  Apollo.MutationResult<RemoveDraftEntryMutation>;
export type RemoveDraftEntryMutationOptions = Apollo.BaseMutationOptions<
  RemoveDraftEntryMutation,
  RemoveDraftEntryMutationVariables
>;
export const SeedEntriesFromGatewaysDocument = gql`
  mutation SeedEntriesFromGateways($input: SeedEntriesFromGatewaysInput!) {
    seedEntriesFromGateways(input: $input) {
      kind
      refusals {
        ...LayoutRefusalFields
      }
      draftToken
      seededEntryIds
    }
  }
  ${LayoutRefusalFieldsFragmentDoc}
`;
export type SeedEntriesFromGatewaysMutationFn = Apollo.MutationFunction<
  SeedEntriesFromGatewaysMutation,
  SeedEntriesFromGatewaysMutationVariables
>;

/**
 * __useSeedEntriesFromGatewaysMutation__
 *
 * To run a mutation, you first call `useSeedEntriesFromGatewaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSeedEntriesFromGatewaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [seedEntriesFromGatewaysMutation, { data, loading, error }] = useSeedEntriesFromGatewaysMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSeedEntriesFromGatewaysMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SeedEntriesFromGatewaysMutation,
    SeedEntriesFromGatewaysMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SeedEntriesFromGatewaysMutation,
    SeedEntriesFromGatewaysMutationVariables
  >(SeedEntriesFromGatewaysDocument, options);
}
export type SeedEntriesFromGatewaysMutationHookResult = ReturnType<
  typeof useSeedEntriesFromGatewaysMutation
>;
export type SeedEntriesFromGatewaysMutationResult =
  Apollo.MutationResult<SeedEntriesFromGatewaysMutation>;
export type SeedEntriesFromGatewaysMutationOptions = Apollo.BaseMutationOptions<
  SeedEntriesFromGatewaysMutation,
  SeedEntriesFromGatewaysMutationVariables
>;
export const GetSiteGatewaysDocument = gql`
  query GetSiteGateways($siteId: ID!) {
    getJobsite(jobsiteId: $siteId) {
      jobsiteId
      jobsiteGateways {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

/**
 * __useGetSiteGatewaysQuery__
 *
 * To run a query within a React component, call `useGetSiteGatewaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteGatewaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteGatewaysQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteGatewaysQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteGatewaysQuery,
    GetSiteGatewaysQueryVariables
  > &
    (
      | { variables: GetSiteGatewaysQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSiteGatewaysQuery, GetSiteGatewaysQueryVariables>(
    GetSiteGatewaysDocument,
    options,
  );
}
export function useGetSiteGatewaysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteGatewaysQuery,
    GetSiteGatewaysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteGatewaysQuery,
    GetSiteGatewaysQueryVariables
  >(GetSiteGatewaysDocument, options);
}
export function useGetSiteGatewaysSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteGatewaysQuery,
    GetSiteGatewaysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteGatewaysQuery,
    GetSiteGatewaysQueryVariables
  >(GetSiteGatewaysDocument, options);
}
export type GetSiteGatewaysQueryHookResult = ReturnType<
  typeof useGetSiteGatewaysQuery
>;
export type GetSiteGatewaysLazyQueryHookResult = ReturnType<
  typeof useGetSiteGatewaysLazyQuery
>;
export type GetSiteGatewaysSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteGatewaysSuspenseQuery
>;
export type GetSiteGatewaysQueryResult = Apollo.QueryResult<
  GetSiteGatewaysQuery,
  GetSiteGatewaysQueryVariables
>;
export const GetSiteReaderDevicesDocument = gql`
  query GetSiteReaderDevices($jobsiteId: ID!) {
    siteDevices(siteId: $jobsiteId, first: 100) {
      name
      readers {
        kind
        entry {
          externalEntryId
          name
        }
        health {
          kind
          isMissing
          bound
          lastReadAt
        }
        readerId
        readerDeviceId
        name
        missing
        port {
          id
          label
          position
        }
      }
    }
    siteIndependentReaders(siteId: $jobsiteId) {
      kind
      entry {
        externalEntryId
        name
      }
      health {
        kind
        isMissing
        bound
        lastReadAt
      }
      readerId
      readerDeviceId
      name
      missing
    }
    siteUnresolvedReaders(siteId: $jobsiteId) {
      kind
      entry {
        externalEntryId
        name
      }
      health {
        kind
        isMissing
        bound
        lastReadAt
      }
      readerId
      readerDeviceId
      name
      missing
      controller {
        assignmentId
        name
        portLabel
      }
    }
  }
`;

/**
 * __useGetSiteReaderDevicesQuery__
 *
 * To run a query within a React component, call `useGetSiteReaderDevicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteReaderDevicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteReaderDevicesQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetSiteReaderDevicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSiteReaderDevicesQuery,
    GetSiteReaderDevicesQueryVariables
  > &
    (
      | { variables: GetSiteReaderDevicesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSiteReaderDevicesQuery,
    GetSiteReaderDevicesQueryVariables
  >(GetSiteReaderDevicesDocument, options);
}
export function useGetSiteReaderDevicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSiteReaderDevicesQuery,
    GetSiteReaderDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSiteReaderDevicesQuery,
    GetSiteReaderDevicesQueryVariables
  >(GetSiteReaderDevicesDocument, options);
}
export function useGetSiteReaderDevicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSiteReaderDevicesQuery,
    GetSiteReaderDevicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSiteReaderDevicesQuery,
    GetSiteReaderDevicesQueryVariables
  >(GetSiteReaderDevicesDocument, options);
}
export type GetSiteReaderDevicesQueryHookResult = ReturnType<
  typeof useGetSiteReaderDevicesQuery
>;
export type GetSiteReaderDevicesLazyQueryHookResult = ReturnType<
  typeof useGetSiteReaderDevicesLazyQuery
>;
export type GetSiteReaderDevicesSuspenseQueryHookResult = ReturnType<
  typeof useGetSiteReaderDevicesSuspenseQuery
>;
export type GetSiteReaderDevicesQueryResult = Apollo.QueryResult<
  GetSiteReaderDevicesQuery,
  GetSiteReaderDevicesQueryVariables
>;
export const GetSitePermissionsDocument = gql`
  query GetSitePermissions($jobsiteId: ID!) {
    getJobsite(jobsiteId: $jobsiteId) {
      jobsiteId
      sitePermissions
    }
  }
`;

/**
 * __useGetSitePermissionsQuery__
 *
 * To run a query within a React component, call `useGetSitePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitePermissionsQuery({
 *   variables: {
 *      jobsiteId: // value for 'jobsiteId'
 *   },
 * });
 */
export function useGetSitePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSitePermissionsQuery,
    GetSitePermissionsQueryVariables
  > &
    (
      | { variables: GetSitePermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSitePermissionsQuery,
    GetSitePermissionsQueryVariables
  >(GetSitePermissionsDocument, options);
}
export function useGetSitePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSitePermissionsQuery,
    GetSitePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSitePermissionsQuery,
    GetSitePermissionsQueryVariables
  >(GetSitePermissionsDocument, options);
}
export function useGetSitePermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSitePermissionsQuery,
    GetSitePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSitePermissionsQuery,
    GetSitePermissionsQueryVariables
  >(GetSitePermissionsDocument, options);
}
export type GetSitePermissionsQueryHookResult = ReturnType<
  typeof useGetSitePermissionsQuery
>;
export type GetSitePermissionsLazyQueryHookResult = ReturnType<
  typeof useGetSitePermissionsLazyQuery
>;
export type GetSitePermissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetSitePermissionsSuspenseQuery
>;
export type GetSitePermissionsQueryResult = Apollo.QueryResult<
  GetSitePermissionsQuery,
  GetSitePermissionsQueryVariables
>;
